import Y, { createGlobalStyle as Db, css as hl, useTheme as qd, keyframes as Tb } from "styled-components";
import * as Ht from "react";
import y, { useRef as St, useState as ur, useCallback as It, useMemo as at, useLayoutEffect as Kd, useEffect as Nt, forwardRef as Ye, cloneElement as Qd, Fragment as Or, isValidElement as jb, createElement as Xd, createContext as Xr, useContext as Yr, useReducer as da, createRef as io, Children as fv, Component as _b, useImperativeHandle as Ib } from "react";
import * as Mb from "react-dom";
import Ab, { flushSync as Fb, createPortal as _h, findDOMNode as Lb } from "react-dom";
function Hs(e) {
  "@babel/helpers - typeof";
  return Hs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Hs(e);
}
var Nb = /^\s+/, Bb = /\s+$/;
function dt(e, n) {
  if (e = e || "", n = n || {}, e instanceof dt)
    return e;
  if (!(this instanceof dt))
    return new dt(e, n);
  var o = Wb(e);
  this._originalInput = e, this._r = o.r, this._g = o.g, this._b = o.b, this._a = o.a, this._roundA = Math.round(100 * this._a) / 100, this._format = n.format || o.format, this._gradientType = n.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = o.ok;
}
dt.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var n = this.toRgb();
    return (n.r * 299 + n.g * 587 + n.b * 114) / 1e3;
  },
  getLuminance: function() {
    var n = this.toRgb(), o, t, r, a, i, s;
    return o = n.r / 255, t = n.g / 255, r = n.b / 255, o <= 0.03928 ? a = o / 12.92 : a = Math.pow((o + 0.055) / 1.055, 2.4), t <= 0.03928 ? i = t / 12.92 : i = Math.pow((t + 0.055) / 1.055, 2.4), r <= 0.03928 ? s = r / 12.92 : s = Math.pow((r + 0.055) / 1.055, 2.4), 0.2126 * a + 0.7152 * i + 0.0722 * s;
  },
  setAlpha: function(n) {
    return this._a = Ih(n), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var n = gv(this._r, this._g, this._b);
    return {
      h: n.h * 360,
      s: n.s,
      v: n.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var n = gv(this._r, this._g, this._b), o = Math.round(n.h * 360), t = Math.round(n.s * 100), r = Math.round(n.v * 100);
    return this._a == 1 ? "hsv(" + o + ", " + t + "%, " + r + "%)" : "hsva(" + o + ", " + t + "%, " + r + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var n = vv(this._r, this._g, this._b);
    return {
      h: n.h * 360,
      s: n.s,
      l: n.l,
      a: this._a
    };
  },
  toHslString: function() {
    var n = vv(this._r, this._g, this._b), o = Math.round(n.h * 360), t = Math.round(n.s * 100), r = Math.round(n.l * 100);
    return this._a == 1 ? "hsl(" + o + ", " + t + "%, " + r + "%)" : "hsla(" + o + ", " + t + "%, " + r + "%, " + this._roundA + ")";
  },
  toHex: function(n) {
    return hv(this._r, this._g, this._b, n);
  },
  toHexString: function(n) {
    return "#" + this.toHex(n);
  },
  toHex8: function(n) {
    return Gb(this._r, this._g, this._b, this._a, n);
  },
  toHex8String: function(n) {
    return "#" + this.toHex8(n);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(br(this._r, 255) * 100) + "%",
      g: Math.round(br(this._g, 255) * 100) + "%",
      b: Math.round(br(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(br(this._r, 255) * 100) + "%, " + Math.round(br(this._g, 255) * 100) + "%, " + Math.round(br(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(br(this._r, 255) * 100) + "%, " + Math.round(br(this._g, 255) * 100) + "%, " + Math.round(br(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : n0[hv(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(n) {
    var o = "#" + mv(this._r, this._g, this._b, this._a), t = o, r = this._gradientType ? "GradientType = 1, " : "";
    if (n) {
      var a = dt(n);
      t = "#" + mv(a._r, a._g, a._b, a._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + r + "startColorstr=" + o + ",endColorstr=" + t + ")";
  },
  toString: function(n) {
    var o = !!n;
    n = n || this._format;
    var t = !1, r = this._a < 1 && this._a >= 0, a = !o && r && (n === "hex" || n === "hex6" || n === "hex3" || n === "hex4" || n === "hex8" || n === "name");
    return a ? n === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (n === "rgb" && (t = this.toRgbString()), n === "prgb" && (t = this.toPercentageRgbString()), (n === "hex" || n === "hex6") && (t = this.toHexString()), n === "hex3" && (t = this.toHexString(!0)), n === "hex4" && (t = this.toHex8String(!0)), n === "hex8" && (t = this.toHex8String()), n === "name" && (t = this.toName()), n === "hsl" && (t = this.toHslString()), n === "hsv" && (t = this.toHsvString()), t || this.toHexString());
  },
  clone: function() {
    return dt(this.toString());
  },
  _applyModification: function(n, o) {
    var t = n.apply(null, [this].concat([].slice.call(o)));
    return this._r = t._r, this._g = t._g, this._b = t._b, this.setAlpha(t._a), this;
  },
  lighten: function() {
    return this._applyModification(Kb, arguments);
  },
  brighten: function() {
    return this._applyModification(Qb, arguments);
  },
  darken: function() {
    return this._applyModification(Xb, arguments);
  },
  desaturate: function() {
    return this._applyModification(Vb, arguments);
  },
  saturate: function() {
    return this._applyModification(Ub, arguments);
  },
  greyscale: function() {
    return this._applyModification(qb, arguments);
  },
  spin: function() {
    return this._applyModification(Jb, arguments);
  },
  _applyCombination: function(n, o) {
    return n.apply(null, [this].concat([].slice.call(o)));
  },
  analogous: function() {
    return this._applyCombination(t0, arguments);
  },
  complement: function() {
    return this._applyCombination(Zb, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(r0, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(e0, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(yv, [3]);
  },
  tetrad: function() {
    return this._applyCombination(yv, [4]);
  }
};
dt.fromRatio = function(e, n) {
  if (Hs(e) == "object") {
    var o = {};
    for (var t in e)
      e.hasOwnProperty(t) && (t === "a" ? o[t] = e[t] : o[t] = bi(e[t]));
    e = o;
  }
  return dt(e, n);
};
function Wb(e) {
  var n = {
    r: 0,
    g: 0,
    b: 0
  }, o = 1, t = null, r = null, a = null, i = !1, s = !1;
  return typeof e == "string" && (e = s0(e)), Hs(e) == "object" && (go(e.r) && go(e.g) && go(e.b) ? (n = zb(e.r, e.g, e.b), i = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : go(e.h) && go(e.s) && go(e.v) ? (t = bi(e.s), r = bi(e.v), n = Yb(e.h, t, r), i = !0, s = "hsv") : go(e.h) && go(e.s) && go(e.l) && (t = bi(e.s), a = bi(e.l), n = Hb(e.h, t, a), i = !0, s = "hsl"), e.hasOwnProperty("a") && (o = e.a)), o = Ih(o), {
    ok: i,
    format: e.format || s,
    r: Math.min(255, Math.max(n.r, 0)),
    g: Math.min(255, Math.max(n.g, 0)),
    b: Math.min(255, Math.max(n.b, 0)),
    a: o
  };
}
function zb(e, n, o) {
  return {
    r: br(e, 255) * 255,
    g: br(n, 255) * 255,
    b: br(o, 255) * 255
  };
}
function vv(e, n, o) {
  e = br(e, 255), n = br(n, 255), o = br(o, 255);
  var t = Math.max(e, n, o), r = Math.min(e, n, o), a, i, s = (t + r) / 2;
  if (t == r)
    a = i = 0;
  else {
    var l = t - r;
    switch (i = s > 0.5 ? l / (2 - t - r) : l / (t + r), t) {
      case e:
        a = (n - o) / l + (n < o ? 6 : 0);
        break;
      case n:
        a = (o - e) / l + 2;
        break;
      case o:
        a = (e - n) / l + 4;
        break;
    }
    a /= 6;
  }
  return {
    h: a,
    s: i,
    l: s
  };
}
function Hb(e, n, o) {
  var t, r, a;
  e = br(e, 360), n = br(n, 100), o = br(o, 100);
  function i(u, c, p) {
    return p < 0 && (p += 1), p > 1 && (p -= 1), p < 1 / 6 ? u + (c - u) * 6 * p : p < 1 / 2 ? c : p < 2 / 3 ? u + (c - u) * (2 / 3 - p) * 6 : u;
  }
  if (n === 0)
    t = r = a = o;
  else {
    var s = o < 0.5 ? o * (1 + n) : o + n - o * n, l = 2 * o - s;
    t = i(l, s, e + 1 / 3), r = i(l, s, e), a = i(l, s, e - 1 / 3);
  }
  return {
    r: t * 255,
    g: r * 255,
    b: a * 255
  };
}
function gv(e, n, o) {
  e = br(e, 255), n = br(n, 255), o = br(o, 255);
  var t = Math.max(e, n, o), r = Math.min(e, n, o), a, i, s = t, l = t - r;
  if (i = t === 0 ? 0 : l / t, t == r)
    a = 0;
  else {
    switch (t) {
      case e:
        a = (n - o) / l + (n < o ? 6 : 0);
        break;
      case n:
        a = (o - e) / l + 2;
        break;
      case o:
        a = (e - n) / l + 4;
        break;
    }
    a /= 6;
  }
  return {
    h: a,
    s: i,
    v: s
  };
}
function Yb(e, n, o) {
  e = br(e, 360) * 6, n = br(n, 100), o = br(o, 100);
  var t = Math.floor(e), r = e - t, a = o * (1 - n), i = o * (1 - r * n), s = o * (1 - (1 - r) * n), l = t % 6, u = [o, i, a, a, s, o][l], c = [s, o, o, i, a, a][l], p = [a, a, s, o, o, i][l];
  return {
    r: u * 255,
    g: c * 255,
    b: p * 255
  };
}
function hv(e, n, o, t) {
  var r = [Vn(Math.round(e).toString(16)), Vn(Math.round(n).toString(16)), Vn(Math.round(o).toString(16))];
  return t && r[0].charAt(0) == r[0].charAt(1) && r[1].charAt(0) == r[1].charAt(1) && r[2].charAt(0) == r[2].charAt(1) ? r[0].charAt(0) + r[1].charAt(0) + r[2].charAt(0) : r.join("");
}
function Gb(e, n, o, t, r) {
  var a = [Vn(Math.round(e).toString(16)), Vn(Math.round(n).toString(16)), Vn(Math.round(o).toString(16)), Vn(Mh(t))];
  return r && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) && a[3].charAt(0) == a[3].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
}
function mv(e, n, o, t) {
  var r = [Vn(Mh(t)), Vn(Math.round(e).toString(16)), Vn(Math.round(n).toString(16)), Vn(Math.round(o).toString(16))];
  return r.join("");
}
dt.equals = function(e, n) {
  return !e || !n ? !1 : dt(e).toRgbString() == dt(n).toRgbString();
};
dt.random = function() {
  return dt.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function Vb(e, n) {
  n = n === 0 ? 0 : n || 10;
  var o = dt(e).toHsl();
  return o.s -= n / 100, o.s = ml(o.s), dt(o);
}
function Ub(e, n) {
  n = n === 0 ? 0 : n || 10;
  var o = dt(e).toHsl();
  return o.s += n / 100, o.s = ml(o.s), dt(o);
}
function qb(e) {
  return dt(e).desaturate(100);
}
function Kb(e, n) {
  n = n === 0 ? 0 : n || 10;
  var o = dt(e).toHsl();
  return o.l += n / 100, o.l = ml(o.l), dt(o);
}
function Qb(e, n) {
  n = n === 0 ? 0 : n || 10;
  var o = dt(e).toRgb();
  return o.r = Math.max(0, Math.min(255, o.r - Math.round(255 * -(n / 100)))), o.g = Math.max(0, Math.min(255, o.g - Math.round(255 * -(n / 100)))), o.b = Math.max(0, Math.min(255, o.b - Math.round(255 * -(n / 100)))), dt(o);
}
function Xb(e, n) {
  n = n === 0 ? 0 : n || 10;
  var o = dt(e).toHsl();
  return o.l -= n / 100, o.l = ml(o.l), dt(o);
}
function Jb(e, n) {
  var o = dt(e).toHsl(), t = (o.h + n) % 360;
  return o.h = t < 0 ? 360 + t : t, dt(o);
}
function Zb(e) {
  var n = dt(e).toHsl();
  return n.h = (n.h + 180) % 360, dt(n);
}
function yv(e, n) {
  if (isNaN(n) || n <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var o = dt(e).toHsl(), t = [dt(e)], r = 360 / n, a = 1; a < n; a++)
    t.push(dt({
      h: (o.h + a * r) % 360,
      s: o.s,
      l: o.l
    }));
  return t;
}
function e0(e) {
  var n = dt(e).toHsl(), o = n.h;
  return [dt(e), dt({
    h: (o + 72) % 360,
    s: n.s,
    l: n.l
  }), dt({
    h: (o + 216) % 360,
    s: n.s,
    l: n.l
  })];
}
function t0(e, n, o) {
  n = n || 6, o = o || 30;
  var t = dt(e).toHsl(), r = 360 / o, a = [dt(e)];
  for (t.h = (t.h - (r * n >> 1) + 720) % 360; --n; )
    t.h = (t.h + r) % 360, a.push(dt(t));
  return a;
}
function r0(e, n) {
  n = n || 6;
  for (var o = dt(e).toHsv(), t = o.h, r = o.s, a = o.v, i = [], s = 1 / n; n--; )
    i.push(dt({
      h: t,
      s: r,
      v: a
    })), a = (a + s) % 1;
  return i;
}
dt.mix = function(e, n, o) {
  o = o === 0 ? 0 : o || 50;
  var t = dt(e).toRgb(), r = dt(n).toRgb(), a = o / 100, i = {
    r: (r.r - t.r) * a + t.r,
    g: (r.g - t.g) * a + t.g,
    b: (r.b - t.b) * a + t.b,
    a: (r.a - t.a) * a + t.a
  };
  return dt(i);
};
dt.readability = function(e, n) {
  var o = dt(e), t = dt(n);
  return (Math.max(o.getLuminance(), t.getLuminance()) + 0.05) / (Math.min(o.getLuminance(), t.getLuminance()) + 0.05);
};
dt.isReadable = function(e, n, o) {
  var t = dt.readability(e, n), r, a;
  switch (a = !1, r = l0(o), r.level + r.size) {
    case "AAsmall":
    case "AAAlarge":
      a = t >= 4.5;
      break;
    case "AAlarge":
      a = t >= 3;
      break;
    case "AAAsmall":
      a = t >= 7;
      break;
  }
  return a;
};
dt.mostReadable = function(e, n, o) {
  var t = null, r = 0, a, i, s, l;
  o = o || {}, i = o.includeFallbackColors, s = o.level, l = o.size;
  for (var u = 0; u < n.length; u++)
    a = dt.readability(e, n[u]), a > r && (r = a, t = dt(n[u]));
  return dt.isReadable(e, t, {
    level: s,
    size: l
  }) || !i ? t : (o.includeFallbackColors = !1, dt.mostReadable(e, ["#fff", "#000"], o));
};
var Xu = dt.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, n0 = dt.hexNames = o0(Xu);
function o0(e) {
  var n = {};
  for (var o in e)
    e.hasOwnProperty(o) && (n[e[o]] = o);
  return n;
}
function Ih(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function br(e, n) {
  a0(e) && (e = "100%");
  var o = i0(e);
  return e = Math.min(n, Math.max(0, parseFloat(e))), o && (e = parseInt(e * n, 10) / 100), Math.abs(e - n) < 1e-6 ? 1 : e % n / parseFloat(n);
}
function ml(e) {
  return Math.min(1, Math.max(0, e));
}
function bn(e) {
  return parseInt(e, 16);
}
function a0(e) {
  return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function i0(e) {
  return typeof e == "string" && e.indexOf("%") != -1;
}
function Vn(e) {
  return e.length == 1 ? "0" + e : "" + e;
}
function bi(e) {
  return e <= 1 && (e = e * 100 + "%"), e;
}
function Mh(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function bv(e) {
  return bn(e) / 255;
}
var Gn = function() {
  var e = "[-\\+]?\\d+%?", n = "[-\\+]?\\d*\\.\\d+%?", o = "(?:" + n + ")|(?:" + e + ")", t = "[\\s|\\(]+(" + o + ")[,|\\s]+(" + o + ")[,|\\s]+(" + o + ")\\s*\\)?", r = "[\\s|\\(]+(" + o + ")[,|\\s]+(" + o + ")[,|\\s]+(" + o + ")[,|\\s]+(" + o + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(o),
    rgb: new RegExp("rgb" + t),
    rgba: new RegExp("rgba" + r),
    hsl: new RegExp("hsl" + t),
    hsla: new RegExp("hsla" + r),
    hsv: new RegExp("hsv" + t),
    hsva: new RegExp("hsva" + r),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function go(e) {
  return !!Gn.CSS_UNIT.exec(e);
}
function s0(e) {
  e = e.replace(Nb, "").replace(Bb, "").toLowerCase();
  var n = !1;
  if (Xu[e])
    e = Xu[e], n = !0;
  else if (e == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var o;
  return (o = Gn.rgb.exec(e)) ? {
    r: o[1],
    g: o[2],
    b: o[3]
  } : (o = Gn.rgba.exec(e)) ? {
    r: o[1],
    g: o[2],
    b: o[3],
    a: o[4]
  } : (o = Gn.hsl.exec(e)) ? {
    h: o[1],
    s: o[2],
    l: o[3]
  } : (o = Gn.hsla.exec(e)) ? {
    h: o[1],
    s: o[2],
    l: o[3],
    a: o[4]
  } : (o = Gn.hsv.exec(e)) ? {
    h: o[1],
    s: o[2],
    v: o[3]
  } : (o = Gn.hsva.exec(e)) ? {
    h: o[1],
    s: o[2],
    v: o[3],
    a: o[4]
  } : (o = Gn.hex8.exec(e)) ? {
    r: bn(o[1]),
    g: bn(o[2]),
    b: bn(o[3]),
    a: bv(o[4]),
    format: n ? "name" : "hex8"
  } : (o = Gn.hex6.exec(e)) ? {
    r: bn(o[1]),
    g: bn(o[2]),
    b: bn(o[3]),
    format: n ? "name" : "hex"
  } : (o = Gn.hex4.exec(e)) ? {
    r: bn(o[1] + "" + o[1]),
    g: bn(o[2] + "" + o[2]),
    b: bn(o[3] + "" + o[3]),
    a: bv(o[4] + "" + o[4]),
    format: n ? "name" : "hex8"
  } : (o = Gn.hex3.exec(e)) ? {
    r: bn(o[1] + "" + o[1]),
    g: bn(o[2] + "" + o[2]),
    b: bn(o[3] + "" + o[3]),
    format: n ? "name" : "hex"
  } : !1;
}
function l0(e) {
  var n, o;
  return e = e || {
    level: "AA",
    size: "small"
  }, n = (e.level || "AA").toUpperCase(), o = (e.size || "small").toLowerCase(), n !== "AA" && n !== "AAA" && (n = "AA"), o !== "small" && o !== "large" && (o = "small"), {
    level: n,
    size: o
  };
}
const Hr = (e, n) => {
  if (n >= 1)
    return e;
  if (n <= 0)
    return "none";
  {
    const o = dt(e);
    return o.setAlpha(n), o.toRgbString();
  }
}, zr = {
  gray0: "#F9FBFD",
  gray1: "#EDF2F9",
  gray2: "#E4EBF6",
  gray3: "#D2DDEC",
  gray4: "#B1C2D9",
  gray5: "#95AAC9",
  gray6: "#6E84A3",
  gray7: "#3B516C",
  gray8: "#283E59",
  blue0: "#71AAF7",
  blue1: "#468EEE",
  blue2: "#0060DF",
  blue3: "#0250BB",
  blue4: "#054096",
  red0: "#CF4D4D",
  red1: "#C42626",
  red2: "#BA0000",
  red3: "#9E0000",
  red4: "#820000",
  green0: "#4D9858",
  green1: "#268235",
  green2: "#006C11",
  green3: "#005C0E",
  green4: "#004C0C",
  orange0: "#FFA436",
  orange1: "#BC4400",
  black: "#12263F",
  white: "#FFFFFF",
  transparent: "#00000000"
}, u0 = "#7B90B0", wv = {
  none: "0px",
  xxs: "2px",
  xs: "4px",
  s: "8px",
  m: "16px",
  l: "24px",
  xl: "32px",
  xxl: "48px"
}, c0 = {
  xxxs: "8px",
  xxs: "16px",
  xs: "24px",
  s: "32px",
  m: "40px",
  l: "48px",
  xl: "56px",
  xxl: "64px",
  xxxl: "72px"
}, d0 = {
  xxxs: "64px",
  xxs: "128px",
  xs: "192px",
  s: "256px",
  m: "320px",
  l: "384px",
  xl: "448px",
  xxl: "512px",
  xxxl: "576px"
}, p0 = {
  /** All screen widths smaller than the "mobile" breakpoint should show mobile layouts. */
  mobile: "787px",
  /**
   * All screen widths in between the "mobile" & "tablet" breakpoints should show tablet layouts,
   * and all screen widths greater than the "tablet" breakpoint should show desktop layouts.
   */
  tablet: "992px"
}, f0 = [
  "#1B68FC",
  "#EE812E",
  "#5CAB1E",
  "#2136A4",
  "#CD2843",
  "#EDB40A",
  "#9F23B4",
  "#33C5BC"
], xv = {
  pageMaxWidth: "1296px",
  color: {
    ...zr,
    /**
     * We override the type of `primary` to allow the color to be changed
     * to quickly rebrand a platform such as the Hosted Tax Center.
     */
    primary: zr.blue2,
    secondary: zr.gray7,
    success: zr.green1,
    warning: zr.orange0,
    danger: zr.red1,
    textPrimary: zr.black,
    textSecondary: zr.gray7,
    textSuccess: zr.green2,
    textDanger: zr.red2,
    /**
     * The `disabled` color alias is not accessible, and should only be
     * used to color UI where the readability of the text is not important.
     */
    disabled: zr.gray4,
    /**
     * The `border` alias should be used to color the gray borders of
     * elements with a white background and their dividing lines.
     */
    border: zr.gray3,
    /**
     * The `borderHover` alias should be used to color the hover state
     * for any border created using the `border` alias.
     */
    borderHover: zr.gray5,
    /**
     * The `focusOutline` alias should be used to color the visual focus indicator of an element
     */
    focusOutline: Hr(zr.blue2, 0.25),
    /**
     * The `activeListItemOutline` alias should be used to color the visual focus indicator of an active item in a list.
     */
    activeListItemOutline: zr.transparent
  },
  /**
   * The chartColor variables are stored as an array for ease of use as we loop through them
   * to assign appropriate colors for different types of charts. They should not be used
   * outside of data visualization.
   */
  chartColor: f0,
  spacing: {
    ...wv,
    contentPadding: wv.l
  },
  sizing: c0,
  measure: d0,
  breakpoint: p0,
  fontWeight: {
    light: "300",
    regular: "400",
    medium: "500",
    bold: "700"
  },
  fontSize: {
    xs: "12px",
    s: "14px",
    m: "16px",
    l: "20px",
    xl: "24px",
    xxl: "32px",
    xxxl: "48px",
    xxxxl: "64px"
  },
  borderRadius: {
    none: "0px",
    xs: "2px",
    s: "4px",
    m: "8px",
    l: "16px",
    /**
     * Setting the border-radius to a high number creates a "pill" shape for rectangle containers,
     * and a round shape for circle containers. See explanation [here](https://css-tricks.com/what-happens-when-border-radii-overlap/).
     */
    round: "1000px"
  },
  borderWidth: {
    none: "0px",
    s: "1px",
    m: "2px",
    l: "3px"
  },
  /**
   * An external shadow to give an item "height" off the page. Can be applied
   * to either the box-shadow property (preferred for performance reasons)
   * or drop-shadow filter.
   */
  shadow: "0px 8px 16px rgba(18, 38, 63, 0.16)",
  zIndex: {
    // Bootstrap modals are at a z-index of 1050. The transaction
    // modal (at least) links to a Help Center article. If the z-index of
    // the Help Center is lower than the modal, the Help Center will be covered
    // by the modal's backdrop. From current knowledge, nothing should ever
    // be on top of Help Center.
    helpCenter: 1e5,
    backdrop: 10099,
    modal: 10100,
    // ada chat has z-index: 10000
    toast: 150,
    sideBarNav: 100,
    stickyElement: 50,
    popover: 10
  }
}, sM = {
  ...xv,
  color: {
    ...xv.color,
    border: u0,
    borderHover: zr.gray8,
    focusOutline: zr.blue1,
    activeListItemOutline: zr.blue2
  }
}, Zn = `
  text-transform: none;
  letter-spacing: 0;
`, Ah = `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`, Jd = (e) => ({
  primary: e.color.textPrimary,
  secondary: e.color.textSecondary,
  success: e.color.textSuccess,
  danger: e.color.textDanger
}), Nn = (e) => ({
  /** Headers */
  h1: `
    ${Zn}
    color: ${e.color.textPrimary};
    font-weight: ${e.fontWeight.medium};
    font-size: ${e.fontSize.xl};
  `,
  /**
   * h1 and h2 are currently the same size, per design's direction. They
   * should still be used in the correct semantic order within a page,
   * i.e. h1 should appear first in a given layout.
   */
  h2: `
    ${Zn}
    color: ${e.color.textPrimary};
    font-weight: ${e.fontWeight.medium};
    font-size: ${e.fontSize.xl};
  `,
  h3: `
    ${Zn}
    color: ${e.color.textPrimary};
    font-weight: ${e.fontWeight.medium};
    font-size: ${e.fontSize.l};
  `,
  h4: `
    ${Zn}
    color: ${e.color.textPrimary};
    font-weight: ${e.fontWeight.medium};
    font-size: ${e.fontSize.m};
  `,
  h5: `
    ${Zn}
    color: ${e.color.textPrimary};
    font-weight: ${e.fontWeight.medium};
    font-size: ${e.fontSize.s};
  `,
  h6: `
    ${Zn}
    color: ${e.color.textPrimary};
    font-weight: ${e.fontWeight.medium};
    font-size: ${e.fontSize.xs};
  `,
  "h6-uppercase": `
    ${Zn}
    color: ${e.color.textPrimary};
    font-weight: ${e.fontWeight.bold};
    font-size: ${e.fontSize.xs};
    text-transform: uppercase;
    letter-spacing: 0.1em;
  `,
  /** Body */
  body: `
    ${Zn}
    color: ${e.color.textPrimary};
    font-weight: ${e.fontWeight.regular};
    font-size: ${e.fontSize.m};
  `,
  "body-small": `
    ${Zn}
    color: ${e.color.textPrimary};
    font-weight: ${e.fontWeight.regular};
    font-size: ${e.fontSize.s};
  `,
  "body-extra-small": `
    ${Zn}
    color: ${e.color.textPrimary};
    font-weight: ${e.fontWeight.regular};
    font-size: ${e.fontSize.xs};
  `
}), lM = Db(
  ({ theme: e }) => hl`
    /*
    The following styles are custom TaxBit global styles, and
    should not be changed without explicit direction from design.
  */
    body {
      font-family: "Roboto", sans-serif;
      ${Nn(e).body}
    }

    /*
    The following styles are borrowed from the below article on CSS resets.
    Visit the article for additional reasoning & explanation of each style.
    https://www.joshwcomeau.com/css/custom-css-reset/
  */
    /*
    Use a more-intuitive box-sizing model.
  */
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }
    /*
    Remove default margin
  */
    * {
      margin: 0;
    }
    /*
    Typographic tweaks!
    Add accessible line-height
    Improve text rendering
  */
    body {
      line-height: 1.5;
      -webkit-font-smoothing: antialiased;
    }
    /*
    Improve media defaults
  */
    img,
    picture,
    video,
    canvas,
    svg {
      display: block;
      max-width: 100%;
    }
    /*
    Remove built-in form typography styles
  */
    input,
    button,
    textarea,
    select {
      font: inherit;
    }
    /*
    Avoid text overflows
  */
    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      overflow-wrap: break-word;
    }
    /*
    Create a root stacking context
  */
    #root {
      isolation: isolate;
    }
  `
), uM = (e, n) => Number.parseInt(e.breakpoint[n], 10), Cv = (e, n) => Number.parseInt(e.measure[n], 10), v0 = (e, n) => `@media screen and (min-width: ${e.breakpoint[n]})`, Ho = (e, n) => `@media screen and (max-width: ${e.breakpoint[n]})`, g0 = {
  // Ignore capitalization differences between query/label
  isCaseSensitive: !1,
  // Sort the results in alphabetical order
  shouldSort: !0,
  // Ensure we have a relatively close match
  threshold: 0.2,
  // Show all results that might be relevant
  findAllMatches: !0
}, Pn = (e) => `${e.borderWidth.s} solid ${e.color.border}`, cn = (e) => `
  box-shadow: 0 0 0 ${e.borderWidth.s} ${e.color.white}, 0 0 0 ${e.borderWidth.l} ${e.color.focusOutline};
`, Rn = `
  opacity: 50%;
  pointer-events: none;
`, Zd = ({ theme: e }) => `
  margin: ${e.spacing.none};
  padding: ${e.spacing.s} ${e.spacing.none};
  background-color: ${e.color.white};
  border-radius: ${e.borderRadius.s};
  border: ${Pn(e)};
  box-shadow: ${e.shadow};
  outline: none;
  z-index: ${e.zIndex.popover};
  max-height: ${e.measure.m};
  overflow-x: hidden;
  overflow-y: auto;
  width: max-content;

  ul {
    padding: ${e.spacing.none};
    margin: ${e.spacing.none};
  }
`, ep = ({
  theme: e,
  isDisabled: n = !1,
  isActive: o,
  isIndented: t
}) => `
  ${n ? Rn : ""}

  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style-type: none;
  gap: ${e.spacing.m};
  padding: 12px ${e.spacing.m} 12px ${t ? e.spacing.xl : e.spacing.m};
  cursor: default;
  
  background-color: ${o ? e.color.gray1 : e.color.white};
  outline: ${o ? `1px solid ${e.color.activeListItemOutline}` : "none"};
   
  &:active {
    background-color: ${e.color.gray2};
  }
  `, Fh = "data-testid", h0 = "trackingId";
function Jr(e) {
  return Y(e).withConfig({ shouldForwardProp: (n) => n !== h0 }).attrs(
    ({ trackingId: n }) => n ? {
      /**
       * Our current tracking setup can reuse the testing attribute to identify components, so we only
       * attach the single id to avoid cluttering the DOM. In the event that a future tracking provider
       * requires a different attribute, we can just add it below.
       */
      [Fh]: n
    } : {}
  )``;
}
function pa(e) {
  return Jr(e);
}
function Ai(e) {
  return e.split("-")[0];
}
function yl(e) {
  return e.split("-")[1];
}
function tp(e) {
  return ["top", "bottom"].includes(Ai(e)) ? "x" : "y";
}
function Lh(e) {
  return e === "y" ? "height" : "width";
}
function Sv(e, n, o) {
  let { reference: t, floating: r } = e;
  const a = t.x + t.width / 2 - r.width / 2, i = t.y + t.height / 2 - r.height / 2, s = tp(n), l = Lh(s), u = t[l] / 2 - r[l] / 2, c = s === "x";
  let p;
  switch (Ai(n)) {
    case "top":
      p = { x: a, y: t.y - r.height };
      break;
    case "bottom":
      p = { x: a, y: t.y + t.height };
      break;
    case "right":
      p = { x: t.x + t.width, y: i };
      break;
    case "left":
      p = { x: t.x - r.width, y: i };
      break;
    default:
      p = { x: t.x, y: t.y };
  }
  switch (yl(n)) {
    case "start":
      p[s] -= u * (o && c ? -1 : 1);
      break;
    case "end":
      p[s] += u * (o && c ? -1 : 1);
  }
  return p;
}
const m0 = async (e, n, o) => {
  const { placement: t = "bottom", strategy: r = "absolute", middleware: a = [], platform: i } = o, s = await (i.isRTL == null ? void 0 : i.isRTL(n));
  let l = await i.getElementRects({ reference: e, floating: n, strategy: r }), { x: u, y: c } = Sv(l, t, s), p = t, h = {};
  for (let O = 0; O < a.length; O++) {
    const { name: C, fn: P } = a[O], { x: k, y: $, data: I, reset: H } = await P({ x: u, y: c, initialPlacement: t, placement: p, strategy: r, middlewareData: h, rects: l, platform: i, elements: { reference: e, floating: n } });
    u = k ?? u, c = $ ?? c, h = { ...h, [C]: { ...h[C], ...I } }, H && (typeof H == "object" && (H.placement && (p = H.placement), H.rects && (l = H.rects === !0 ? await i.getElementRects({ reference: e, floating: n, strategy: r }) : H.rects), { x: u, y: c } = Sv(l, p, s)), O = -1);
  }
  return { x: u, y: c, placement: p, strategy: r, middlewareData: h };
};
function y0(e) {
  return typeof e != "number" ? function(n) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...n };
  }(e) : { top: e, right: e, bottom: e, left: e };
}
function Ys(e) {
  return { ...e, top: e.y, left: e.x, right: e.x + e.width, bottom: e.y + e.height };
}
async function Nh(e, n) {
  var o;
  n === void 0 && (n = {});
  const { x: t, y: r, platform: a, rects: i, elements: s, strategy: l } = e, { boundary: u = "clippingAncestors", rootBoundary: c = "viewport", elementContext: p = "floating", altBoundary: h = !1, padding: O = 0 } = n, C = y0(O), P = s[h ? p === "floating" ? "reference" : "floating" : p], k = Ys(await a.getClippingRect({ element: (o = await (a.isElement == null ? void 0 : a.isElement(P))) == null || o ? P : P.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)), boundary: u, rootBoundary: c, strategy: l })), $ = Ys(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: p === "floating" ? { ...i.floating, x: t, y: r } : i.reference, offsetParent: await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), strategy: l }) : i[p]);
  return { top: k.top - $.top + C.top, bottom: $.bottom - k.bottom + C.bottom, left: k.left - $.left + C.left, right: $.right - k.right + C.right };
}
const Sa = Math.max, b0 = { left: "right", right: "left", bottom: "top", top: "bottom" };
function Gs(e) {
  return e.replace(/left|right|bottom|top/g, (n) => b0[n]);
}
function w0(e, n, o) {
  o === void 0 && (o = !1);
  const t = yl(e), r = tp(e), a = Lh(r);
  let i = r === "x" ? t === (o ? "end" : "start") ? "right" : "left" : t === "start" ? "bottom" : "top";
  return n.reference[a] > n.floating[a] && (i = Gs(i)), { main: i, cross: Gs(i) };
}
const x0 = { start: "end", end: "start" };
function Ov(e) {
  return e.replace(/start|end/g, (n) => x0[n]);
}
const C0 = ["top", "right", "bottom", "left"];
C0.reduce((e, n) => e.concat(n, n + "-start", n + "-end"), []);
const S0 = function(e) {
  return e === void 0 && (e = {}), { name: "flip", options: e, async fn(n) {
    var o;
    const { placement: t, middlewareData: r, rects: a, initialPlacement: i, platform: s, elements: l } = n, { mainAxis: u = !0, crossAxis: c = !0, fallbackPlacements: p, fallbackStrategy: h = "bestFit", flipAlignment: O = !0, ...C } = e, P = Ai(t), k = p || (P === i || !O ? [Gs(i)] : function(Q) {
      const V = Gs(Q);
      return [Ov(Q), V, Ov(V)];
    }(i)), $ = [i, ...k], I = await Nh(n, C), H = [];
    let x = ((o = r.flip) == null ? void 0 : o.overflows) || [];
    if (u && H.push(I[P]), c) {
      const { main: Q, cross: V } = w0(t, a, await (s.isRTL == null ? void 0 : s.isRTL(l.floating)));
      H.push(I[Q], I[V]);
    }
    if (x = [...x, { placement: t, overflows: H }], !H.every((Q) => Q <= 0)) {
      var _, F;
      const Q = ((_ = (F = r.flip) == null ? void 0 : F.index) != null ? _ : 0) + 1, V = $[Q];
      if (V)
        return { data: { index: Q, overflows: x }, reset: { placement: V } };
      let ie = "bottom";
      switch (h) {
        case "bestFit": {
          var G;
          const ce = (G = x.map((me) => [me, me.overflows.filter((ve) => ve > 0).reduce((ve, U) => ve + U, 0)]).sort((me, ve) => me[1] - ve[1])[0]) == null ? void 0 : G[0].placement;
          ce && (ie = ce);
          break;
        }
        case "initialPlacement":
          ie = i;
      }
      if (t !== ie)
        return { reset: { placement: ie } };
    }
    return {};
  } };
}, O0 = function(e) {
  return e === void 0 && (e = 0), { name: "offset", options: e, async fn(n) {
    const { x: o, y: t, placement: r, rects: a, platform: i, elements: s } = n, l = function(u, c, p, h) {
      h === void 0 && (h = !1);
      const O = Ai(u), C = yl(u), P = tp(u) === "x", k = ["left", "top"].includes(O) ? -1 : 1, $ = h && P ? -1 : 1, I = typeof p == "function" ? p({ ...c, placement: u }) : p;
      let { mainAxis: H, crossAxis: x, alignmentAxis: _ } = typeof I == "number" ? { mainAxis: I, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...I };
      return C && typeof _ == "number" && (x = C === "end" ? -1 * _ : _), P ? { x: x * $, y: H * k } : { x: H * k, y: x * $ };
    }(r, a, e, await (i.isRTL == null ? void 0 : i.isRTL(s.floating)));
    return { x: o + l.x, y: t + l.y, data: l };
  } };
}, P0 = function(e) {
  return e === void 0 && (e = {}), { name: "size", options: e, async fn(n) {
    const { placement: o, rects: t, platform: r, elements: a } = n, { apply: i, ...s } = e, l = await Nh(n, s), u = Ai(o), c = yl(o);
    let p, h;
    u === "top" || u === "bottom" ? (p = u, h = c === (await (r.isRTL == null ? void 0 : r.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (h = u, p = c === "end" ? "top" : "bottom");
    const O = Sa(l.left, 0), C = Sa(l.right, 0), P = Sa(l.top, 0), k = Sa(l.bottom, 0), $ = { height: t.floating.height - (["left", "right"].includes(o) ? 2 * (P !== 0 || k !== 0 ? P + k : Sa(l.top, l.bottom)) : l[p]), width: t.floating.width - (["top", "bottom"].includes(o) ? 2 * (O !== 0 || C !== 0 ? O + C : Sa(l.left, l.right)) : l[h]) }, I = await r.getDimensions(a.floating);
    i == null || i({ ...$, ...t });
    const H = await r.getDimensions(a.floating);
    return I.width !== H.width || I.height !== H.height ? { reset: { rects: !0 } } : {};
  } };
};
function Bh(e) {
  return e && e.document && e.location && e.alert && e.setInterval;
}
function Po(e) {
  if (e == null)
    return window;
  if (!Bh(e)) {
    const n = e.ownerDocument;
    return n && n.defaultView || window;
  }
  return e;
}
function Fi(e) {
  return Po(e).getComputedStyle(e);
}
function wo(e) {
  return Bh(e) ? "" : e ? (e.nodeName || "").toLowerCase() : "";
}
function uo(e) {
  return e instanceof Po(e).HTMLElement;
}
function Wo(e) {
  return e instanceof Po(e).Element;
}
function rp(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof Po(e).ShadowRoot || e instanceof ShadowRoot;
}
function bl(e) {
  const { overflow: n, overflowX: o, overflowY: t } = Fi(e);
  return /auto|scroll|overlay|hidden/.test(n + t + o);
}
function E0(e) {
  return ["table", "td", "th"].includes(wo(e));
}
function Pv(e) {
  const n = navigator.userAgent.toLowerCase().includes("firefox"), o = Fi(e);
  return o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].includes(o.willChange) || n && o.willChange === "filter" || n && !!o.filter && o.filter !== "none";
}
function Wh() {
  return !/^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
const Ev = Math.min, xi = Math.max, Vs = Math.round;
function xo(e, n, o) {
  var t, r, a, i;
  n === void 0 && (n = !1), o === void 0 && (o = !1);
  const s = e.getBoundingClientRect();
  let l = 1, u = 1;
  n && uo(e) && (l = e.offsetWidth > 0 && Vs(s.width) / e.offsetWidth || 1, u = e.offsetHeight > 0 && Vs(s.height) / e.offsetHeight || 1);
  const c = Wo(e) ? Po(e) : window, p = !Wh() && o, h = (s.left + (p && (t = (r = c.visualViewport) == null ? void 0 : r.offsetLeft) != null ? t : 0)) / l, O = (s.top + (p && (a = (i = c.visualViewport) == null ? void 0 : i.offsetTop) != null ? a : 0)) / u, C = s.width / l, P = s.height / u;
  return { width: C, height: P, top: O, right: h + C, bottom: O + P, left: h, x: h, y: O };
}
function Fo(e) {
  return (n = e, (n instanceof Po(n).Node ? e.ownerDocument : e.document) || window.document).documentElement;
  var n;
}
function wl(e) {
  return Wo(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function zh(e) {
  return xo(Fo(e)).left + wl(e).scrollLeft;
}
function k0(e, n, o) {
  const t = uo(n), r = Fo(n), a = xo(e, t && function(l) {
    const u = xo(l);
    return Vs(u.width) !== l.offsetWidth || Vs(u.height) !== l.offsetHeight;
  }(n), o === "fixed");
  let i = { scrollLeft: 0, scrollTop: 0 };
  const s = { x: 0, y: 0 };
  if (t || !t && o !== "fixed")
    if ((wo(n) !== "body" || bl(r)) && (i = wl(n)), uo(n)) {
      const l = xo(n, !0);
      s.x = l.x + n.clientLeft, s.y = l.y + n.clientTop;
    } else
      r && (s.x = zh(r));
  return { x: a.left + i.scrollLeft - s.x, y: a.top + i.scrollTop - s.y, width: a.width, height: a.height };
}
function Hh(e) {
  return wo(e) === "html" ? e : e.assignedSlot || e.parentNode || (rp(e) ? e.host : null) || Fo(e);
}
function kv(e) {
  return uo(e) && getComputedStyle(e).position !== "fixed" ? e.offsetParent : null;
}
function Ju(e) {
  const n = Po(e);
  let o = kv(e);
  for (; o && E0(o) && getComputedStyle(o).position === "static"; )
    o = kv(o);
  return o && (wo(o) === "html" || wo(o) === "body" && getComputedStyle(o).position === "static" && !Pv(o)) ? n : o || function(t) {
    let r = Hh(t);
    for (rp(r) && (r = r.host); uo(r) && !["html", "body"].includes(wo(r)); ) {
      if (Pv(r))
        return r;
      r = r.parentNode;
    }
    return null;
  }(e) || n;
}
function Rv(e) {
  if (uo(e))
    return { width: e.offsetWidth, height: e.offsetHeight };
  const n = xo(e);
  return { width: n.width, height: n.height };
}
function Yh(e) {
  const n = Hh(e);
  return ["html", "body", "#document"].includes(wo(n)) ? e.ownerDocument.body : uo(n) && bl(n) ? n : Yh(n);
}
function Us(e, n) {
  var o;
  n === void 0 && (n = []);
  const t = Yh(e), r = t === ((o = e.ownerDocument) == null ? void 0 : o.body), a = Po(t), i = r ? [a].concat(a.visualViewport || [], bl(t) ? t : []) : t, s = n.concat(i);
  return r ? s : s.concat(Us(i));
}
function $v(e, n, o) {
  return n === "viewport" ? Ys(function(t, r) {
    const a = Po(t), i = Fo(t), s = a.visualViewport;
    let l = i.clientWidth, u = i.clientHeight, c = 0, p = 0;
    if (s) {
      l = s.width, u = s.height;
      const h = Wh();
      (h || !h && r === "fixed") && (c = s.offsetLeft, p = s.offsetTop);
    }
    return { width: l, height: u, x: c, y: p };
  }(e, o)) : Wo(n) ? function(t, r) {
    const a = xo(t, !1, r === "fixed"), i = a.top + t.clientTop, s = a.left + t.clientLeft;
    return { top: i, left: s, x: s, y: i, right: s + t.clientWidth, bottom: i + t.clientHeight, width: t.clientWidth, height: t.clientHeight };
  }(n, o) : Ys(function(t) {
    var r;
    const a = Fo(t), i = wl(t), s = (r = t.ownerDocument) == null ? void 0 : r.body, l = xi(a.scrollWidth, a.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), u = xi(a.scrollHeight, a.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0);
    let c = -i.scrollLeft + zh(t);
    const p = -i.scrollTop;
    return Fi(s || a).direction === "rtl" && (c += xi(a.clientWidth, s ? s.clientWidth : 0) - l), { width: l, height: u, x: c, y: p };
  }(Fo(e)));
}
function R0(e) {
  const n = Us(e), o = ["absolute", "fixed"].includes(Fi(e).position) && uo(e) ? Ju(e) : e;
  return Wo(o) ? n.filter((t) => Wo(t) && function(r, a) {
    const i = a == null || a.getRootNode == null ? void 0 : a.getRootNode();
    if (r != null && r.contains(a))
      return !0;
    if (i && rp(i)) {
      let s = a;
      do {
        if (s && r === s)
          return !0;
        s = s.parentNode || s.host;
      } while (s);
    }
    return !1;
  }(t, o) && wo(t) !== "body") : [];
}
const $0 = { getClippingRect: function(e) {
  let { element: n, boundary: o, rootBoundary: t, strategy: r } = e;
  const a = [...o === "clippingAncestors" ? R0(n) : [].concat(o), t], i = a[0], s = a.reduce((l, u) => {
    const c = $v(n, u, r);
    return l.top = xi(c.top, l.top), l.right = Ev(c.right, l.right), l.bottom = Ev(c.bottom, l.bottom), l.left = xi(c.left, l.left), l;
  }, $v(n, i, r));
  return { width: s.right - s.left, height: s.bottom - s.top, x: s.left, y: s.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: n, offsetParent: o, strategy: t } = e;
  const r = uo(o), a = Fo(o);
  if (o === a)
    return n;
  let i = { scrollLeft: 0, scrollTop: 0 };
  const s = { x: 0, y: 0 };
  if ((r || !r && t !== "fixed") && ((wo(o) !== "body" || bl(a)) && (i = wl(o)), uo(o))) {
    const l = xo(o, !0);
    s.x = l.x + o.clientLeft, s.y = l.y + o.clientTop;
  }
  return { ...n, x: n.x - i.scrollLeft + s.x, y: n.y - i.scrollTop + s.y };
}, isElement: Wo, getDimensions: Rv, getOffsetParent: Ju, getDocumentElement: Fo, getElementRects: (e) => {
  let { reference: n, floating: o, strategy: t } = e;
  return { reference: k0(n, Ju(o), t), floating: { ...Rv(o), x: 0, y: 0 } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => Fi(e).direction === "rtl" };
function D0(e, n, o, t) {
  t === void 0 && (t = {});
  const { ancestorScroll: r = !0, ancestorResize: a = !0, elementResize: i = !0, animationFrame: s = !1 } = t;
  let l = !1;
  const u = r && !s, c = a && !s, p = i && !s, h = u || c ? [...Wo(e) ? Us(e) : [], ...Us(n)] : [];
  h.forEach((k) => {
    u && k.addEventListener("scroll", o, { passive: !0 }), c && k.addEventListener("resize", o);
  });
  let O, C = null;
  p && (C = new ResizeObserver(o), Wo(e) && C.observe(e), C.observe(n));
  let P = s ? xo(e) : null;
  return s && function k() {
    if (l)
      return;
    const $ = xo(e);
    !P || $.x === P.x && $.y === P.y && $.width === P.width && $.height === P.height || o(), P = $, O = requestAnimationFrame(k);
  }(), () => {
    var k;
    l = !0, h.forEach(($) => {
      u && $.removeEventListener("scroll", o), c && $.removeEventListener("resize", o);
    }), (k = C) == null || k.disconnect(), C = null, s && cancelAnimationFrame(O);
  };
}
const T0 = (e, n, o) => m0(e, n, { platform: $0, ...o });
var Dv = typeof document < "u" ? Kd : Nt;
function Zu(e, n) {
  if (e === n)
    return !0;
  if (typeof e != typeof n)
    return !1;
  if (typeof e == "function" && e.toString() === n.toString())
    return !0;
  let o, t, r;
  if (e && n && typeof e == "object") {
    if (Array.isArray(e)) {
      if (o = e.length, o != n.length)
        return !1;
      for (t = o; t-- !== 0; )
        if (!Zu(e[t], n[t]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), o = r.length, o !== Object.keys(n).length)
      return !1;
    for (t = o; t-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, r[t]))
        return !1;
    for (t = o; t-- !== 0; ) {
      const a = r[t];
      if (!(a === "_owner" && e.$$typeof) && !Zu(e[a], n[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
}
function j0(e) {
  let {
    middleware: n,
    placement: o = "bottom",
    strategy: t = "absolute"
  } = e === void 0 ? {} : e;
  const r = St(null), a = St(null), [i, s] = ur({
    // Setting these to `null` will allow the consumer to determine if
    // `computePosition()` has run yet
    x: null,
    y: null,
    strategy: t,
    placement: o,
    middlewareData: {}
  }), [l, u] = ur(n);
  Zu(l == null ? void 0 : l.map((P) => {
    let {
      options: k
    } = P;
    return k;
  }), n == null ? void 0 : n.map((P) => {
    let {
      options: k
    } = P;
    return k;
  })) || u(n);
  const c = St(!0);
  Dv(() => (c.current = !0, () => {
    c.current = !1;
  }), []);
  const p = It(() => {
    !r.current || !a.current || T0(r.current, a.current, {
      middleware: l,
      placement: o,
      strategy: t
    }).then((P) => {
      c.current && Fb(() => {
        s(P);
      });
    });
  }, [l, o, t]);
  Dv(p, [p]);
  const h = It((P) => {
    r.current = P, p();
  }, [p]), O = It((P) => {
    a.current = P, p();
  }, [p]), C = at(() => ({
    reference: r,
    floating: a
  }), []);
  return at(() => ({
    ...i,
    update: p,
    refs: C,
    reference: h,
    floating: O
  }), [i, p, C, h, O]);
}
const Gh = () => {
}, _0 = {
  attributes: !0,
  characterData: !0,
  childList: !0,
  subtree: !0
};
function I0(e, n, o = _0) {
  Nt(() => {
    if (e.current) {
      const t = new MutationObserver(n);
      return t.observe(e.current, o), () => {
        t.disconnect();
      };
    }
    return Gh;
  }, [n, o, e]);
}
const M0 = {
  attributes: !0,
  characterData: !0,
  childList: !0,
  subtree: !0
};
function A0(e, n = M0) {
  const [o, t] = ur(null);
  return Nt(() => {
    if (o) {
      const a = new MutationObserver(e);
      return a.observe(o, n), () => {
        a.disconnect();
      };
    }
    return Gh;
  }, [o, e, n]), [It((a) => {
    t(a);
  }, [])];
}
var Vh = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function xl(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function F0(e, n) {
  typeof e == "function" ? e(n) : e != null && (e.current = n);
}
function qs(...e) {
  return at(() => e.every((n) => n === null) ? null : (n) => {
    for (const o of e)
      F0(o, n);
  }, [e]);
}
const L0 = (e, n) => Number.parseInt(e.sizing[n], 10), N0 = (e, n, o) => Math.min(Math.max(e, n), o), Li = ({
  shouldAlignMenuToTargetWidth: e = !1,
  maxMenuWidth: n,
  minMenuWidth: o,
  onMenuToggle: t = () => {
  }
} = {}) => {
  const r = qd(), { x: a, y: i, reference: s, floating: l, refs: u, strategy: c, update: p } = j0({
    placement: "bottom-start",
    middleware: [
      O0(2),
      P0({
        apply: ({
          reference: P,
          height: k
        }) => {
          var _;
          const $ = Cv(r, "xs"), I = Cv(r, "xxxl"), H = L0(r, "xxxs"), x = N0(
            k - H,
            $,
            I
          );
          Object.assign(((_ = u.floating.current) == null ? void 0 : _.style) ?? {}, {
            minWidth: o ? r.measure[o] : `${P.width}px`,
            maxWidth: e ? `${P.width}px` : n ? r.measure[n] : "",
            maxHeight: `${x}px`
          });
        }
      }),
      S0()
    ]
  });
  Nt(() => {
    if (!(!u.reference.current || !u.floating.current))
      return D0(u.reference.current, u.floating.current, p);
  }, [p, u.reference, u.floating]);
  const h = {
    position: c,
    top: i ?? "",
    left: a ?? ""
  }, [O, C] = ur(!1);
  return I0(u.reference, () => {
    var k;
    const P = ((k = u.reference.current) == null ? void 0 : k.ariaExpanded) === "true";
    P !== O && (t(P), C(P));
  }), {
    floatingElement: u.floating.current,
    floatingPlacementStyles: h,
    floatingRef: u.floating,
    floatingRefCallback: l,
    referenceElement: u.reference.current,
    referenceRef: u.reference,
    referenceRefCallback: s
  };
}, Fr = (e) => Hr(e, 0.1), B0 = (e) => {
  const n = Ht.useRef(e);
  return Ht.useEffect(() => {
    n.current = e;
  }), n;
}, W0 = B0, z0 = (e, n = 100, o = !1) => {
  const t = W0(e), r = Ht.useRef(), a = [n, o, t];
  function i() {
    r.current && clearTimeout(r.current), r.current = void 0;
  }
  Ht.useEffect(() => i, a);
  function s() {
    r.current = void 0;
  }
  return Ht.useCallback(function() {
    const l = arguments, {
      current: u
    } = r;
    if (u === void 0 && o)
      return r.current = setTimeout(s, n), t.current.apply(null, l);
    u && clearTimeout(u), r.current = setTimeout(() => {
      r.current = void 0, t.current.apply(null, l);
    }, n);
  }, a);
}, H0 = (e, n, o) => {
  const t = Ht.useState(e);
  return [t[0], z0(t[1], n, o)];
};
function mu(e, n, o, t) {
  const r = Ht.useRef(o), a = Ht.useRef(t);
  Ht.useEffect(() => {
    r.current = o, a.current = t;
  }), Ht.useEffect(() => {
    const i = e && "current" in e ? e.current : e;
    if (!i)
      return;
    let s = 0;
    function l(...c) {
      s || r.current.apply(this, c);
    }
    i.addEventListener(n, l);
    const u = a.current;
    return () => {
      s = 1, i.removeEventListener(n, l), u && u();
    };
  }, [e, n]);
}
const Y0 = {}, Ci = typeof window > "u" ? null : window, G0 = Ci && typeof Ci.visualViewport < "u" ? Ci.visualViewport : null, Tv = () => [document.documentElement.clientWidth, document.documentElement.clientHeight], V0 = function(e) {
  e === void 0 && (e = Y0);
  const {
    wait: n,
    leading: o,
    initialWidth: t = 0,
    initialHeight: r = 0
  } = e, [a, i] = H0(
    /* istanbul ignore next */
    typeof document > "u" ? [t, r] : Tv,
    n,
    o
  ), s = () => i(Tv);
  return mu(Ci, "resize", s), mu(G0, "resize", s), mu(Ci, "orientationchange", s), a;
}, U0 = (e) => V0(e)[0], Uh = (e) => {
  const n = U0(), { breakpoint: o } = qd();
  return n <= Number.parseInt(o[e], 10);
};
var q0 = /* @__PURE__ */ ((e) => (e.Csv = "text/csv", e.Xlsx = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", e.Jsonl = "application/ld+json", e))(q0 || {});
const jv = {
  [
    "text/csv"
    /* Csv */
  ]: ".csv",
  [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    /* Xlsx */
  ]: ".xlsx",
  [
    "application/ld+json"
    /* Jsonl */
  ]: ".jsonl"
};
var ec = { exports: {} }, ci = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _v;
function K0() {
  if (_v)
    return ci;
  _v = 1;
  var e = y, n = Symbol.for("react.element"), o = Symbol.for("react.fragment"), t = Object.prototype.hasOwnProperty, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, l, u) {
    var c, p = {}, h = null, O = null;
    u !== void 0 && (h = "" + u), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (O = l.ref);
    for (c in l)
      t.call(l, c) && !a.hasOwnProperty(c) && (p[c] = l[c]);
    if (s && s.defaultProps)
      for (c in l = s.defaultProps, l)
        p[c] === void 0 && (p[c] = l[c]);
    return { $$typeof: n, type: s, key: h, ref: O, props: p, _owner: r.current };
  }
  return ci.Fragment = o, ci.jsx = i, ci.jsxs = i, ci;
}
var di = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Iv;
function Q0() {
  return Iv || (Iv = 1, process.env.NODE_ENV !== "production" && function() {
    var e = y, n = Symbol.for("react.element"), o = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), O = Symbol.for("react.offscreen"), C = Symbol.iterator, P = "@@iterator";
    function k(N) {
      if (N === null || typeof N != "object")
        return null;
      var pe = C && N[C] || N[P];
      return typeof pe == "function" ? pe : null;
    }
    var $ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function I(N) {
      {
        for (var pe = arguments.length, Ie = new Array(pe > 1 ? pe - 1 : 0), bt = 1; bt < pe; bt++)
          Ie[bt - 1] = arguments[bt];
        H("error", N, Ie);
      }
    }
    function H(N, pe, Ie) {
      {
        var bt = $.ReactDebugCurrentFrame, Bt = bt.getStackAddendum();
        Bt !== "" && (pe += "%s", Ie = Ie.concat([Bt]));
        var rr = Ie.map(function(At) {
          return String(At);
        });
        rr.unshift("Warning: " + pe), Function.prototype.apply.call(console[N], console, rr);
      }
    }
    var x = !1, _ = !1, F = !1, G = !1, Q = !1, V;
    V = Symbol.for("react.module.reference");
    function ie(N) {
      return !!(typeof N == "string" || typeof N == "function" || N === t || N === a || Q || N === r || N === u || N === c || G || N === O || x || _ || F || typeof N == "object" && N !== null && (N.$$typeof === h || N.$$typeof === p || N.$$typeof === i || N.$$typeof === s || N.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      N.$$typeof === V || N.getModuleId !== void 0));
    }
    function ce(N, pe, Ie) {
      var bt = N.displayName;
      if (bt)
        return bt;
      var Bt = pe.displayName || pe.name || "";
      return Bt !== "" ? Ie + "(" + Bt + ")" : Ie;
    }
    function me(N) {
      return N.displayName || "Context";
    }
    function ve(N) {
      if (N == null)
        return null;
      if (typeof N.tag == "number" && I("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof N == "function")
        return N.displayName || N.name || null;
      if (typeof N == "string")
        return N;
      switch (N) {
        case t:
          return "Fragment";
        case o:
          return "Portal";
        case a:
          return "Profiler";
        case r:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof N == "object")
        switch (N.$$typeof) {
          case s:
            var pe = N;
            return me(pe) + ".Consumer";
          case i:
            var Ie = N;
            return me(Ie._context) + ".Provider";
          case l:
            return ce(N, N.render, "ForwardRef");
          case p:
            var bt = N.displayName || null;
            return bt !== null ? bt : ve(N.type) || "Memo";
          case h: {
            var Bt = N, rr = Bt._payload, At = Bt._init;
            try {
              return ve(At(rr));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ee = 0, oe, ge, be, he, K, le, Pe;
    function lt() {
    }
    lt.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          oe = console.log, ge = console.info, be = console.warn, he = console.error, K = console.group, le = console.groupCollapsed, Pe = console.groupEnd;
          var N = {
            configurable: !0,
            enumerable: !0,
            value: lt,
            writable: !0
          };
          Object.defineProperties(console, {
            info: N,
            log: N,
            warn: N,
            error: N,
            group: N,
            groupCollapsed: N,
            groupEnd: N
          });
        }
        ee++;
      }
    }
    function ut() {
      {
        if (ee--, ee === 0) {
          var N = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, N, {
              value: oe
            }),
            info: U({}, N, {
              value: ge
            }),
            warn: U({}, N, {
              value: be
            }),
            error: U({}, N, {
              value: he
            }),
            group: U({}, N, {
              value: K
            }),
            groupCollapsed: U({}, N, {
              value: le
            }),
            groupEnd: U({}, N, {
              value: Pe
            })
          });
        }
        ee < 0 && I("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ze = $.ReactCurrentDispatcher, Ze;
    function _e(N, pe, Ie) {
      {
        if (Ze === void 0)
          try {
            throw Error();
          } catch (Bt) {
            var bt = Bt.stack.trim().match(/\n( *(at )?)/);
            Ze = bt && bt[1] || "";
          }
        return `
` + Ze + N;
      }
    }
    var De = !1, fe;
    {
      var ke = typeof WeakMap == "function" ? WeakMap : Map;
      fe = new ke();
    }
    function re(N, pe) {
      if (!N || De)
        return "";
      {
        var Ie = fe.get(N);
        if (Ie !== void 0)
          return Ie;
      }
      var bt;
      De = !0;
      var Bt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var rr;
      rr = ze.current, ze.current = null, Ge();
      try {
        if (pe) {
          var At = function() {
            throw Error();
          };
          if (Object.defineProperty(At.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(At, []);
            } catch (yn) {
              bt = yn;
            }
            Reflect.construct(N, [], At);
          } else {
            try {
              At.call();
            } catch (yn) {
              bt = yn;
            }
            N.call(At.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (yn) {
            bt = yn;
          }
          N();
        }
      } catch (yn) {
        if (yn && bt && typeof yn.stack == "string") {
          for (var jt = yn.stack.split(`
`), wr = bt.stack.split(`
`), gr = jt.length - 1, yr = wr.length - 1; gr >= 1 && yr >= 0 && jt[gr] !== wr[yr]; )
            yr--;
          for (; gr >= 1 && yr >= 0; gr--, yr--)
            if (jt[gr] !== wr[yr]) {
              if (gr !== 1 || yr !== 1)
                do
                  if (gr--, yr--, yr < 0 || jt[gr] !== wr[yr]) {
                    var Kr = `
` + jt[gr].replace(" at new ", " at ");
                    return N.displayName && Kr.includes("<anonymous>") && (Kr = Kr.replace("<anonymous>", N.displayName)), typeof N == "function" && fe.set(N, Kr), Kr;
                  }
                while (gr >= 1 && yr >= 0);
              break;
            }
        }
      } finally {
        De = !1, ze.current = rr, ut(), Error.prepareStackTrace = Bt;
      }
      var Xn = N ? N.displayName || N.name : "", wa = Xn ? _e(Xn) : "";
      return typeof N == "function" && fe.set(N, wa), wa;
    }
    function tt(N, pe, Ie) {
      return re(N, !1);
    }
    function et(N) {
      var pe = N.prototype;
      return !!(pe && pe.isReactComponent);
    }
    function Dt(N, pe, Ie) {
      if (N == null)
        return "";
      if (typeof N == "function")
        return re(N, et(N));
      if (typeof N == "string")
        return _e(N);
      switch (N) {
        case u:
          return _e("Suspense");
        case c:
          return _e("SuspenseList");
      }
      if (typeof N == "object")
        switch (N.$$typeof) {
          case l:
            return tt(N.render);
          case p:
            return Dt(N.type, pe, Ie);
          case h: {
            var bt = N, Bt = bt._payload, rr = bt._init;
            try {
              return Dt(rr(Bt), pe, Ie);
            } catch {
            }
          }
        }
      return "";
    }
    var Kt = Object.prototype.hasOwnProperty, fr = {}, Ir = $.ReactDebugCurrentFrame;
    function jr(N) {
      if (N) {
        var pe = N._owner, Ie = Dt(N.type, N._source, pe ? pe.type : null);
        Ir.setExtraStackFrame(Ie);
      } else
        Ir.setExtraStackFrame(null);
    }
    function Pr(N, pe, Ie, bt, Bt) {
      {
        var rr = Function.call.bind(Kt);
        for (var At in N)
          if (rr(N, At)) {
            var jt = void 0;
            try {
              if (typeof N[At] != "function") {
                var wr = Error((bt || "React class") + ": " + Ie + " type `" + At + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof N[At] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw wr.name = "Invariant Violation", wr;
              }
              jt = N[At](pe, At, bt, Ie, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (gr) {
              jt = gr;
            }
            jt && !(jt instanceof Error) && (jr(Bt), I("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", bt || "React class", Ie, At, typeof jt), jr(null)), jt instanceof Error && !(jt.message in fr) && (fr[jt.message] = !0, jr(Bt), I("Failed %s type: %s", Ie, jt.message), jr(null));
          }
      }
    }
    var Nr = Array.isArray;
    function nn(N) {
      return Nr(N);
    }
    function on(N) {
      {
        var pe = typeof Symbol == "function" && Symbol.toStringTag, Ie = pe && N[Symbol.toStringTag] || N.constructor.name || "Object";
        return Ie;
      }
    }
    function Re(N) {
      try {
        return it(N), !1;
      } catch {
        return !0;
      }
    }
    function it(N) {
      return "" + N;
    }
    function Qt(N) {
      if (Re(N))
        return I("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", on(N)), it(N);
    }
    var tr = $.ReactCurrentOwner, mr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, dn, an, hn;
    hn = {};
    function Wn(N) {
      if (Kt.call(N, "ref")) {
        var pe = Object.getOwnPropertyDescriptor(N, "ref").get;
        if (pe && pe.isReactWarning)
          return !1;
      }
      return N.ref !== void 0;
    }
    function zn(N) {
      if (Kt.call(N, "key")) {
        var pe = Object.getOwnPropertyDescriptor(N, "key").get;
        if (pe && pe.isReactWarning)
          return !1;
      }
      return N.key !== void 0;
    }
    function Z(N, pe) {
      if (typeof N.ref == "string" && tr.current && pe && tr.current.stateNode !== pe) {
        var Ie = ve(tr.current.type);
        hn[Ie] || (I('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ve(tr.current.type), N.ref), hn[Ie] = !0);
      }
    }
    function Ve(N, pe) {
      {
        var Ie = function() {
          dn || (dn = !0, I("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", pe));
        };
        Ie.isReactWarning = !0, Object.defineProperty(N, "key", {
          get: Ie,
          configurable: !0
        });
      }
    }
    function ct(N, pe) {
      {
        var Ie = function() {
          an || (an = !0, I("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", pe));
        };
        Ie.isReactWarning = !0, Object.defineProperty(N, "ref", {
          get: Ie,
          configurable: !0
        });
      }
    }
    var Mt = function(N, pe, Ie, bt, Bt, rr, At) {
      var jt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: N,
        key: pe,
        ref: Ie,
        props: At,
        // Record the component responsible for creating this element.
        _owner: rr
      };
      return jt._store = {}, Object.defineProperty(jt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(jt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: bt
      }), Object.defineProperty(jt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Bt
      }), Object.freeze && (Object.freeze(jt.props), Object.freeze(jt)), jt;
    };
    function Et(N, pe, Ie, bt, Bt) {
      {
        var rr, At = {}, jt = null, wr = null;
        Ie !== void 0 && (Qt(Ie), jt = "" + Ie), zn(pe) && (Qt(pe.key), jt = "" + pe.key), Wn(pe) && (wr = pe.ref, Z(pe, Bt));
        for (rr in pe)
          Kt.call(pe, rr) && !mr.hasOwnProperty(rr) && (At[rr] = pe[rr]);
        if (N && N.defaultProps) {
          var gr = N.defaultProps;
          for (rr in gr)
            At[rr] === void 0 && (At[rr] = gr[rr]);
        }
        if (jt || wr) {
          var yr = typeof N == "function" ? N.displayName || N.name || "Unknown" : N;
          jt && Ve(At, yr), wr && ct(At, yr);
        }
        return Mt(N, jt, wr, Bt, bt, tr.current, At);
      }
    }
    var vr = $.ReactCurrentOwner, Rr = $.ReactDebugCurrentFrame;
    function Br(N) {
      if (N) {
        var pe = N._owner, Ie = Dt(N.type, N._source, pe ? pe.type : null);
        Rr.setExtraStackFrame(Ie);
      } else
        Rr.setExtraStackFrame(null);
    }
    var Hn;
    Hn = !1;
    function Zr(N) {
      return typeof N == "object" && N !== null && N.$$typeof === n;
    }
    function pn() {
      {
        if (vr.current) {
          var N = ve(vr.current.type);
          if (N)
            return `

Check the render method of \`` + N + "`.";
        }
        return "";
      }
    }
    function Yn(N) {
      {
        if (N !== void 0) {
          var pe = N.fileName.replace(/^.*[\\\/]/, ""), Ie = N.lineNumber;
          return `

Check your code at ` + pe + ":" + Ie + ".";
        }
        return "";
      }
    }
    var mn = {};
    function Eo(N) {
      {
        var pe = pn();
        if (!pe) {
          var Ie = typeof N == "string" ? N : N.displayName || N.name;
          Ie && (pe = `

Check the top-level render call using <` + Ie + ">.");
        }
        return pe;
      }
    }
    function $n(N, pe) {
      {
        if (!N._store || N._store.validated || N.key != null)
          return;
        N._store.validated = !0;
        var Ie = Eo(pe);
        if (mn[Ie])
          return;
        mn[Ie] = !0;
        var bt = "";
        N && N._owner && N._owner !== vr.current && (bt = " It was passed a child from " + ve(N._owner.type) + "."), Br(N), I('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ie, bt), Br(null);
      }
    }
    function Dn(N, pe) {
      {
        if (typeof N != "object")
          return;
        if (nn(N))
          for (var Ie = 0; Ie < N.length; Ie++) {
            var bt = N[Ie];
            Zr(bt) && $n(bt, pe);
          }
        else if (Zr(N))
          N._store && (N._store.validated = !0);
        else if (N) {
          var Bt = k(N);
          if (typeof Bt == "function" && Bt !== N.entries)
            for (var rr = Bt.call(N), At; !(At = rr.next()).done; )
              Zr(At.value) && $n(At.value, pe);
        }
      }
    }
    function ha(N) {
      {
        var pe = N.type;
        if (pe == null || typeof pe == "string")
          return;
        var Ie;
        if (typeof pe == "function")
          Ie = pe.propTypes;
        else if (typeof pe == "object" && (pe.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        pe.$$typeof === p))
          Ie = pe.propTypes;
        else
          return;
        if (Ie) {
          var bt = ve(pe);
          Pr(Ie, N.props, "prop", bt, N);
        } else if (pe.PropTypes !== void 0 && !Hn) {
          Hn = !0;
          var Bt = ve(pe);
          I("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Bt || "Unknown");
        }
        typeof pe.getDefaultProps == "function" && !pe.getDefaultProps.isReactClassApproved && I("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ko(N) {
      {
        for (var pe = Object.keys(N.props), Ie = 0; Ie < pe.length; Ie++) {
          var bt = pe[Ie];
          if (bt !== "children" && bt !== "key") {
            Br(N), I("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", bt), Br(null);
            break;
          }
        }
        N.ref !== null && (Br(N), I("Invalid attribute `ref` supplied to `React.Fragment`."), Br(null));
      }
    }
    function ko(N, pe, Ie, bt, Bt, rr) {
      {
        var At = ie(N);
        if (!At) {
          var jt = "";
          (N === void 0 || typeof N == "object" && N !== null && Object.keys(N).length === 0) && (jt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var wr = Yn(Bt);
          wr ? jt += wr : jt += pn();
          var gr;
          N === null ? gr = "null" : nn(N) ? gr = "array" : N !== void 0 && N.$$typeof === n ? (gr = "<" + (ve(N.type) || "Unknown") + " />", jt = " Did you accidentally export a JSX literal instead of a component?") : gr = typeof N, I("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", gr, jt);
        }
        var yr = Et(N, pe, Ie, Bt, rr);
        if (yr == null)
          return yr;
        if (At) {
          var Kr = pe.children;
          if (Kr !== void 0)
            if (bt)
              if (nn(Kr)) {
                for (var Xn = 0; Xn < Kr.length; Xn++)
                  Dn(Kr[Xn], N);
                Object.freeze && Object.freeze(Kr);
              } else
                I("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Dn(Kr, N);
        }
        return N === t ? Ko(yr) : ha(yr), yr;
      }
    }
    function ma(N, pe, Ie) {
      return ko(N, pe, Ie, !0);
    }
    function ya(N, pe, Ie) {
      return ko(N, pe, Ie, !1);
    }
    var Qo = ya, ba = ma;
    di.Fragment = t, di.jsx = Qo, di.jsxs = ba;
  }()), di;
}
process.env.NODE_ENV === "production" ? ec.exports = K0() : ec.exports = Q0();
var g = ec.exports, tc = { exports: {} }, Os = { exports: {} }, ir = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mv;
function X0() {
  if (Mv)
    return ir;
  Mv = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, o = e ? Symbol.for("react.portal") : 60106, t = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, O = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, P = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
  function H(_) {
    if (typeof _ == "object" && _ !== null) {
      var F = _.$$typeof;
      switch (F) {
        case n:
          switch (_ = _.type, _) {
            case l:
            case u:
            case t:
            case a:
            case r:
            case p:
              return _;
            default:
              switch (_ = _ && _.$$typeof, _) {
                case s:
                case c:
                case C:
                case O:
                case i:
                  return _;
                default:
                  return F;
              }
          }
        case o:
          return F;
      }
    }
  }
  function x(_) {
    return H(_) === u;
  }
  return ir.AsyncMode = l, ir.ConcurrentMode = u, ir.ContextConsumer = s, ir.ContextProvider = i, ir.Element = n, ir.ForwardRef = c, ir.Fragment = t, ir.Lazy = C, ir.Memo = O, ir.Portal = o, ir.Profiler = a, ir.StrictMode = r, ir.Suspense = p, ir.isAsyncMode = function(_) {
    return x(_) || H(_) === l;
  }, ir.isConcurrentMode = x, ir.isContextConsumer = function(_) {
    return H(_) === s;
  }, ir.isContextProvider = function(_) {
    return H(_) === i;
  }, ir.isElement = function(_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === n;
  }, ir.isForwardRef = function(_) {
    return H(_) === c;
  }, ir.isFragment = function(_) {
    return H(_) === t;
  }, ir.isLazy = function(_) {
    return H(_) === C;
  }, ir.isMemo = function(_) {
    return H(_) === O;
  }, ir.isPortal = function(_) {
    return H(_) === o;
  }, ir.isProfiler = function(_) {
    return H(_) === a;
  }, ir.isStrictMode = function(_) {
    return H(_) === r;
  }, ir.isSuspense = function(_) {
    return H(_) === p;
  }, ir.isValidElementType = function(_) {
    return typeof _ == "string" || typeof _ == "function" || _ === t || _ === u || _ === a || _ === r || _ === p || _ === h || typeof _ == "object" && _ !== null && (_.$$typeof === C || _.$$typeof === O || _.$$typeof === i || _.$$typeof === s || _.$$typeof === c || _.$$typeof === k || _.$$typeof === $ || _.$$typeof === I || _.$$typeof === P);
  }, ir.typeOf = H, ir;
}
var sr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Av;
function J0() {
  return Av || (Av = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, o = e ? Symbol.for("react.portal") : 60106, t = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, O = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, P = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
    function H(re) {
      return typeof re == "string" || typeof re == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      re === t || re === u || re === a || re === r || re === p || re === h || typeof re == "object" && re !== null && (re.$$typeof === C || re.$$typeof === O || re.$$typeof === i || re.$$typeof === s || re.$$typeof === c || re.$$typeof === k || re.$$typeof === $ || re.$$typeof === I || re.$$typeof === P);
    }
    function x(re) {
      if (typeof re == "object" && re !== null) {
        var tt = re.$$typeof;
        switch (tt) {
          case n:
            var et = re.type;
            switch (et) {
              case l:
              case u:
              case t:
              case a:
              case r:
              case p:
                return et;
              default:
                var Dt = et && et.$$typeof;
                switch (Dt) {
                  case s:
                  case c:
                  case C:
                  case O:
                  case i:
                    return Dt;
                  default:
                    return tt;
                }
            }
          case o:
            return tt;
        }
      }
    }
    var _ = l, F = u, G = s, Q = i, V = n, ie = c, ce = t, me = C, ve = O, U = o, ee = a, oe = r, ge = p, be = !1;
    function he(re) {
      return be || (be = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), K(re) || x(re) === l;
    }
    function K(re) {
      return x(re) === u;
    }
    function le(re) {
      return x(re) === s;
    }
    function Pe(re) {
      return x(re) === i;
    }
    function lt(re) {
      return typeof re == "object" && re !== null && re.$$typeof === n;
    }
    function Ge(re) {
      return x(re) === c;
    }
    function ut(re) {
      return x(re) === t;
    }
    function ze(re) {
      return x(re) === C;
    }
    function Ze(re) {
      return x(re) === O;
    }
    function _e(re) {
      return x(re) === o;
    }
    function De(re) {
      return x(re) === a;
    }
    function fe(re) {
      return x(re) === r;
    }
    function ke(re) {
      return x(re) === p;
    }
    sr.AsyncMode = _, sr.ConcurrentMode = F, sr.ContextConsumer = G, sr.ContextProvider = Q, sr.Element = V, sr.ForwardRef = ie, sr.Fragment = ce, sr.Lazy = me, sr.Memo = ve, sr.Portal = U, sr.Profiler = ee, sr.StrictMode = oe, sr.Suspense = ge, sr.isAsyncMode = he, sr.isConcurrentMode = K, sr.isContextConsumer = le, sr.isContextProvider = Pe, sr.isElement = lt, sr.isForwardRef = Ge, sr.isFragment = ut, sr.isLazy = ze, sr.isMemo = Ze, sr.isPortal = _e, sr.isProfiler = De, sr.isStrictMode = fe, sr.isSuspense = ke, sr.isValidElementType = H, sr.typeOf = x;
  }()), sr;
}
var Fv;
function qh() {
  return Fv || (Fv = 1, process.env.NODE_ENV === "production" ? Os.exports = X0() : Os.exports = J0()), Os.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var yu, Lv;
function Z0() {
  if (Lv)
    return yu;
  Lv = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
  function t(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function r() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(i).map(function(c) {
        return i[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return yu = r() ? Object.assign : function(a, i) {
    for (var s, l = t(a), u, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var p in s)
        n.call(s, p) && (l[p] = s[p]);
      if (e) {
        u = e(s);
        for (var h = 0; h < u.length; h++)
          o.call(s, u[h]) && (l[u[h]] = s[u[h]]);
      }
    }
    return l;
  }, yu;
}
var bu, Nv;
function np() {
  if (Nv)
    return bu;
  Nv = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return bu = e, bu;
}
var wu, Bv;
function Kh() {
  return Bv || (Bv = 1, wu = Function.call.bind(Object.prototype.hasOwnProperty)), wu;
}
var xu, Wv;
function ew() {
  if (Wv)
    return xu;
  Wv = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = np(), o = {}, t = Kh();
    e = function(a) {
      var i = "Warning: " + a;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function r(a, i, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in a)
        if (t(a, c)) {
          var p;
          try {
            if (typeof a[c] != "function") {
              var h = Error(
                (l || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            p = a[c](i, c, l, s, null, n);
          } catch (C) {
            p = C;
          }
          if (p && !(p instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in o)) {
            o[p.message] = !0;
            var O = u ? u() : "";
            e(
              "Failed " + s + " type: " + p.message + (O ?? "")
            );
          }
        }
    }
  }
  return r.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (o = {});
  }, xu = r, xu;
}
var Cu, zv;
function tw() {
  if (zv)
    return Cu;
  zv = 1;
  var e = qh(), n = Z0(), o = np(), t = Kh(), r = ew(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return Cu = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function p(K) {
      var le = K && (u && K[u] || K[c]);
      if (typeof le == "function")
        return le;
    }
    var h = "<<anonymous>>", O = {
      array: $("array"),
      bigint: $("bigint"),
      bool: $("boolean"),
      func: $("function"),
      number: $("number"),
      object: $("object"),
      string: $("string"),
      symbol: $("symbol"),
      any: I(),
      arrayOf: H,
      element: x(),
      elementType: _(),
      instanceOf: F,
      node: ie(),
      objectOf: Q,
      oneOf: G,
      oneOfType: V,
      shape: me,
      exact: ve
    };
    function C(K, le) {
      return K === le ? K !== 0 || 1 / K === 1 / le : K !== K && le !== le;
    }
    function P(K, le) {
      this.message = K, this.data = le && typeof le == "object" ? le : {}, this.stack = "";
    }
    P.prototype = Error.prototype;
    function k(K) {
      if (process.env.NODE_ENV !== "production")
        var le = {}, Pe = 0;
      function lt(ut, ze, Ze, _e, De, fe, ke) {
        if (_e = _e || h, fe = fe || Ze, ke !== o) {
          if (l) {
            var re = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw re.name = "Invariant Violation", re;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var tt = _e + ":" + Ze;
            !le[tt] && // Avoid spamming the console because they are often not actionable except for lib authors
            Pe < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + fe + "` prop on `" + _e + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), le[tt] = !0, Pe++);
          }
        }
        return ze[Ze] == null ? ut ? ze[Ze] === null ? new P("The " + De + " `" + fe + "` is marked as required " + ("in `" + _e + "`, but its value is `null`.")) : new P("The " + De + " `" + fe + "` is marked as required in " + ("`" + _e + "`, but its value is `undefined`.")) : null : K(ze, Ze, _e, De, fe);
      }
      var Ge = lt.bind(null, !1);
      return Ge.isRequired = lt.bind(null, !0), Ge;
    }
    function $(K) {
      function le(Pe, lt, Ge, ut, ze, Ze) {
        var _e = Pe[lt], De = oe(_e);
        if (De !== K) {
          var fe = ge(_e);
          return new P(
            "Invalid " + ut + " `" + ze + "` of type " + ("`" + fe + "` supplied to `" + Ge + "`, expected ") + ("`" + K + "`."),
            { expectedType: K }
          );
        }
        return null;
      }
      return k(le);
    }
    function I() {
      return k(i);
    }
    function H(K) {
      function le(Pe, lt, Ge, ut, ze) {
        if (typeof K != "function")
          return new P("Property `" + ze + "` of component `" + Ge + "` has invalid PropType notation inside arrayOf.");
        var Ze = Pe[lt];
        if (!Array.isArray(Ze)) {
          var _e = oe(Ze);
          return new P("Invalid " + ut + " `" + ze + "` of type " + ("`" + _e + "` supplied to `" + Ge + "`, expected an array."));
        }
        for (var De = 0; De < Ze.length; De++) {
          var fe = K(Ze, De, Ge, ut, ze + "[" + De + "]", o);
          if (fe instanceof Error)
            return fe;
        }
        return null;
      }
      return k(le);
    }
    function x() {
      function K(le, Pe, lt, Ge, ut) {
        var ze = le[Pe];
        if (!s(ze)) {
          var Ze = oe(ze);
          return new P("Invalid " + Ge + " `" + ut + "` of type " + ("`" + Ze + "` supplied to `" + lt + "`, expected a single ReactElement."));
        }
        return null;
      }
      return k(K);
    }
    function _() {
      function K(le, Pe, lt, Ge, ut) {
        var ze = le[Pe];
        if (!e.isValidElementType(ze)) {
          var Ze = oe(ze);
          return new P("Invalid " + Ge + " `" + ut + "` of type " + ("`" + Ze + "` supplied to `" + lt + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return k(K);
    }
    function F(K) {
      function le(Pe, lt, Ge, ut, ze) {
        if (!(Pe[lt] instanceof K)) {
          var Ze = K.name || h, _e = he(Pe[lt]);
          return new P("Invalid " + ut + " `" + ze + "` of type " + ("`" + _e + "` supplied to `" + Ge + "`, expected ") + ("instance of `" + Ze + "`."));
        }
        return null;
      }
      return k(le);
    }
    function G(K) {
      if (!Array.isArray(K))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), i;
      function le(Pe, lt, Ge, ut, ze) {
        for (var Ze = Pe[lt], _e = 0; _e < K.length; _e++)
          if (C(Ze, K[_e]))
            return null;
        var De = JSON.stringify(K, function(ke, re) {
          var tt = ge(re);
          return tt === "symbol" ? String(re) : re;
        });
        return new P("Invalid " + ut + " `" + ze + "` of value `" + String(Ze) + "` " + ("supplied to `" + Ge + "`, expected one of " + De + "."));
      }
      return k(le);
    }
    function Q(K) {
      function le(Pe, lt, Ge, ut, ze) {
        if (typeof K != "function")
          return new P("Property `" + ze + "` of component `" + Ge + "` has invalid PropType notation inside objectOf.");
        var Ze = Pe[lt], _e = oe(Ze);
        if (_e !== "object")
          return new P("Invalid " + ut + " `" + ze + "` of type " + ("`" + _e + "` supplied to `" + Ge + "`, expected an object."));
        for (var De in Ze)
          if (t(Ze, De)) {
            var fe = K(Ze, De, Ge, ut, ze + "." + De, o);
            if (fe instanceof Error)
              return fe;
          }
        return null;
      }
      return k(le);
    }
    function V(K) {
      if (!Array.isArray(K))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var le = 0; le < K.length; le++) {
        var Pe = K[le];
        if (typeof Pe != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + be(Pe) + " at index " + le + "."
          ), i;
      }
      function lt(Ge, ut, ze, Ze, _e) {
        for (var De = [], fe = 0; fe < K.length; fe++) {
          var ke = K[fe], re = ke(Ge, ut, ze, Ze, _e, o);
          if (re == null)
            return null;
          re.data && t(re.data, "expectedType") && De.push(re.data.expectedType);
        }
        var tt = De.length > 0 ? ", expected one of type [" + De.join(", ") + "]" : "";
        return new P("Invalid " + Ze + " `" + _e + "` supplied to " + ("`" + ze + "`" + tt + "."));
      }
      return k(lt);
    }
    function ie() {
      function K(le, Pe, lt, Ge, ut) {
        return U(le[Pe]) ? null : new P("Invalid " + Ge + " `" + ut + "` supplied to " + ("`" + lt + "`, expected a ReactNode."));
      }
      return k(K);
    }
    function ce(K, le, Pe, lt, Ge) {
      return new P(
        (K || "React class") + ": " + le + " type `" + Pe + "." + lt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Ge + "`."
      );
    }
    function me(K) {
      function le(Pe, lt, Ge, ut, ze) {
        var Ze = Pe[lt], _e = oe(Ze);
        if (_e !== "object")
          return new P("Invalid " + ut + " `" + ze + "` of type `" + _e + "` " + ("supplied to `" + Ge + "`, expected `object`."));
        for (var De in K) {
          var fe = K[De];
          if (typeof fe != "function")
            return ce(Ge, ut, ze, De, ge(fe));
          var ke = fe(Ze, De, Ge, ut, ze + "." + De, o);
          if (ke)
            return ke;
        }
        return null;
      }
      return k(le);
    }
    function ve(K) {
      function le(Pe, lt, Ge, ut, ze) {
        var Ze = Pe[lt], _e = oe(Ze);
        if (_e !== "object")
          return new P("Invalid " + ut + " `" + ze + "` of type `" + _e + "` " + ("supplied to `" + Ge + "`, expected `object`."));
        var De = n({}, Pe[lt], K);
        for (var fe in De) {
          var ke = K[fe];
          if (t(K, fe) && typeof ke != "function")
            return ce(Ge, ut, ze, fe, ge(ke));
          if (!ke)
            return new P(
              "Invalid " + ut + " `" + ze + "` key `" + fe + "` supplied to `" + Ge + "`.\nBad object: " + JSON.stringify(Pe[lt], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(K), null, "  ")
            );
          var re = ke(Ze, fe, Ge, ut, ze + "." + fe, o);
          if (re)
            return re;
        }
        return null;
      }
      return k(le);
    }
    function U(K) {
      switch (typeof K) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !K;
        case "object":
          if (Array.isArray(K))
            return K.every(U);
          if (K === null || s(K))
            return !0;
          var le = p(K);
          if (le) {
            var Pe = le.call(K), lt;
            if (le !== K.entries) {
              for (; !(lt = Pe.next()).done; )
                if (!U(lt.value))
                  return !1;
            } else
              for (; !(lt = Pe.next()).done; ) {
                var Ge = lt.value;
                if (Ge && !U(Ge[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ee(K, le) {
      return K === "symbol" ? !0 : le ? le["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && le instanceof Symbol : !1;
    }
    function oe(K) {
      var le = typeof K;
      return Array.isArray(K) ? "array" : K instanceof RegExp ? "object" : ee(le, K) ? "symbol" : le;
    }
    function ge(K) {
      if (typeof K > "u" || K === null)
        return "" + K;
      var le = oe(K);
      if (le === "object") {
        if (K instanceof Date)
          return "date";
        if (K instanceof RegExp)
          return "regexp";
      }
      return le;
    }
    function be(K) {
      var le = ge(K);
      switch (le) {
        case "array":
        case "object":
          return "an " + le;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + le;
        default:
          return le;
      }
    }
    function he(K) {
      return !K.constructor || !K.constructor.name ? h : K.constructor.name;
    }
    return O.checkPropTypes = r, O.resetWarningCache = r.resetWarningCache, O.PropTypes = O, O;
  }, Cu;
}
var Su, Hv;
function rw() {
  if (Hv)
    return Su;
  Hv = 1;
  var e = np();
  function n() {
  }
  function o() {
  }
  return o.resetWarningCache = n, Su = function() {
    function t(i, s, l, u, c, p) {
      if (p !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    t.isRequired = t;
    function r() {
      return t;
    }
    var a = {
      array: t,
      bigint: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: r,
      element: t,
      elementType: t,
      instanceOf: r,
      node: t,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: o,
      resetWarningCache: n
    };
    return a.PropTypes = a, a;
  }, Su;
}
if (process.env.NODE_ENV !== "production") {
  var nw = qh(), ow = !0;
  tc.exports = tw()(nw.isElement, ow);
} else
  tc.exports = rw()();
var aw = tc.exports;
const j = /* @__PURE__ */ xl(aw);
function rc() {
  return rc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, rc.apply(this, arguments);
}
function iw(e, n) {
  if (e == null)
    return {};
  var o = sw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function sw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var op = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = iw(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", rc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("polyline", {
    points: "22 12 18 12 15 21 9 3 6 12 2 12"
  }));
});
op.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
op.displayName = "Activity";
const lw = op;
function nc() {
  return nc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, nc.apply(this, arguments);
}
function uw(e, n) {
  if (e == null)
    return {};
  var o = cw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function cw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var ap = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = uw(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", nc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "12"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "16",
    x2: "12.01",
    y2: "16"
  }));
});
ap.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
ap.displayName = "AlertCircle";
const dw = ap;
function oc() {
  return oc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, oc.apply(this, arguments);
}
function pw(e, n) {
  if (e == null)
    return {};
  var o = fw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function fw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var ip = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = pw(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", oc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "9",
    x2: "12",
    y2: "13"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "17",
    x2: "12.01",
    y2: "17"
  }));
});
ip.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
ip.displayName = "AlertTriangle";
const vw = ip;
function ac() {
  return ac = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, ac.apply(this, arguments);
}
function gw(e, n) {
  if (e == null)
    return {};
  var o = hw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function hw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var sp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = gw(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", ac({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "8 12 12 16 16 12"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "16"
  }));
});
sp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
sp.displayName = "ArrowDownCircle";
const mw = sp;
function ic() {
  return ic = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, ic.apply(this, arguments);
}
function yw(e, n) {
  if (e == null)
    return {};
  var o = bw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function bw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var lp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = yw(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", ic({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("line", {
    x1: "19",
    y1: "12",
    x2: "5",
    y2: "12"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "12 19 5 12 12 5"
  }));
});
lp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
lp.displayName = "ArrowLeft";
const ww = lp;
function sc() {
  return sc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, sc.apply(this, arguments);
}
function xw(e, n) {
  if (e == null)
    return {};
  var o = Cw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Cw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var up = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = xw(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", sc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "16 12 12 8 8 12"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "8"
  }));
});
up.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
up.displayName = "ArrowUpCircle";
const Sw = up;
function lc() {
  return lc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, lc.apply(this, arguments);
}
function Ow(e, n) {
  if (e == null)
    return {};
  var o = Pw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Pw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var cp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = Ow(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", lc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"
  }));
});
cp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
cp.displayName = "AtSign";
const Ew = cp;
function uc() {
  return uc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, uc.apply(this, arguments);
}
function kw(e, n) {
  if (e == null)
    return {};
  var o = Rw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Rw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var dp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = kw(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", uc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "20",
    x2: "12",
    y2: "10"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "18",
    y1: "20",
    x2: "18",
    y2: "4"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "6",
    y1: "20",
    x2: "6",
    y2: "16"
  }));
});
dp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
dp.displayName = "BarChart";
const $w = dp;
function cc() {
  return cc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, cc.apply(this, arguments);
}
function Dw(e, n) {
  if (e == null)
    return {};
  var o = Tw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Tw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var pp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = Dw(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", cc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M13.73 21a2 2 0 0 1-3.46 0"
  }));
});
pp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
pp.displayName = "Bell";
const jw = pp;
function dc() {
  return dc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, dc.apply(this, arguments);
}
function _w(e, n) {
  if (e == null)
    return {};
  var o = Iw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Iw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var fp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = _w(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", dc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
  }));
});
fp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
fp.displayName = "BookOpen";
const Mw = fp;
function pc() {
  return pc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, pc.apply(this, arguments);
}
function Aw(e, n) {
  if (e == null)
    return {};
  var o = Fw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Fw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var vp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = Aw(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", pc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
  }));
});
vp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
vp.displayName = "Book";
const Lw = vp;
function fc() {
  return fc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, fc.apply(this, arguments);
}
function Nw(e, n) {
  if (e == null)
    return {};
  var o = Bw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Bw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var gp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = Nw(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", fc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("rect", {
    x: "2",
    y: "7",
    width: "20",
    height: "14",
    rx: "2",
    ry: "2"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
  }));
});
gp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
gp.displayName = "Briefcase";
const Ww = gp;
function vc() {
  return vc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, vc.apply(this, arguments);
}
function zw(e, n) {
  if (e == null)
    return {};
  var o = Hw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Hw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var hp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = zw(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", vc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "16",
    y1: "2",
    x2: "16",
    y2: "6"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "8",
    y1: "2",
    x2: "8",
    y2: "6"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "3",
    y1: "10",
    x2: "21",
    y2: "10"
  }));
});
hp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
hp.displayName = "Calendar";
const Yw = hp;
function gc() {
  return gc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, gc.apply(this, arguments);
}
function Gw(e, n) {
  if (e == null)
    return {};
  var o = Vw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Vw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var mp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = Gw(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", gc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "22 4 12 14.01 9 11.01"
  }));
});
mp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
mp.displayName = "CheckCircle";
const Uw = mp;
function hc() {
  return hc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, hc.apply(this, arguments);
}
function qw(e, n) {
  if (e == null)
    return {};
  var o = Kw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Kw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var yp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = qw(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", hc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }));
});
yp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
yp.displayName = "Check";
const Qw = yp;
function mc() {
  return mc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, mc.apply(this, arguments);
}
function Xw(e, n) {
  if (e == null)
    return {};
  var o = Jw(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Jw(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var bp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = Xw(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", mc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("polyline", {
    points: "6 9 12 15 18 9"
  }));
});
bp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
bp.displayName = "ChevronDown";
const Zw = bp;
function yc() {
  return yc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, yc.apply(this, arguments);
}
function ex(e, n) {
  if (e == null)
    return {};
  var o = tx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function tx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var wp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = ex(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", yc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("polyline", {
    points: "15 18 9 12 15 6"
  }));
});
wp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
wp.displayName = "ChevronLeft";
const rx = wp;
function bc() {
  return bc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, bc.apply(this, arguments);
}
function nx(e, n) {
  if (e == null)
    return {};
  var o = ox(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function ox(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var xp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = nx(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", bc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("polyline", {
    points: "9 18 15 12 9 6"
  }));
});
xp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
xp.displayName = "ChevronRight";
const ax = xp;
function wc() {
  return wc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, wc.apply(this, arguments);
}
function ix(e, n) {
  if (e == null)
    return {};
  var o = sx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function sx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Cp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = ix(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", wc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("polyline", {
    points: "18 15 12 9 6 15"
  }));
});
Cp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Cp.displayName = "ChevronUp";
const lx = Cp;
function xc() {
  return xc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, xc.apply(this, arguments);
}
function ux(e, n) {
  if (e == null)
    return {};
  var o = cx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function cx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Sp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = ux(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", xc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("rect", {
    x: "9",
    y: "9",
    width: "13",
    height: "13",
    rx: "2",
    ry: "2"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
  }));
});
Sp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Sp.displayName = "Copy";
const dx = Sp;
function Cc() {
  return Cc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Cc.apply(this, arguments);
}
function px(e, n) {
  if (e == null)
    return {};
  var o = fx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function fx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Op = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = px(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Cc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("ellipse", {
    cx: "12",
    cy: "5",
    rx: "9",
    ry: "3"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
  }));
});
Op.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Op.displayName = "Database";
const vx = Op;
function Sc() {
  return Sc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Sc.apply(this, arguments);
}
function gx(e, n) {
  if (e == null)
    return {};
  var o = hx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function hx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Pp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = gx(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Sc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "1",
    x2: "12",
    y2: "23"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
  }));
});
Pp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Pp.displayName = "DollarSign";
const mx = Pp;
function Oc() {
  return Oc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Oc.apply(this, arguments);
}
function yx(e, n) {
  if (e == null)
    return {};
  var o = bx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function bx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Ep = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = yx(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Oc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "7 10 12 15 17 10"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "15",
    x2: "12",
    y2: "3"
  }));
});
Ep.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Ep.displayName = "Download";
const wx = Ep;
function Pc() {
  return Pc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Pc.apply(this, arguments);
}
function xx(e, n) {
  if (e == null)
    return {};
  var o = Cx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Cx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var kp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = xx(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Pc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
  }));
});
kp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
kp.displayName = "Edit";
const Sx = kp;
function Ec() {
  return Ec = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Ec.apply(this, arguments);
}
function Ox(e, n) {
  if (e == null)
    return {};
  var o = Px(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Px(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Rp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = Ox(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Ec({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "1",
    y1: "1",
    x2: "23",
    y2: "23"
  }));
});
Rp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Rp.displayName = "EyeOff";
const Ex = Rp;
function kc() {
  return kc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, kc.apply(this, arguments);
}
function kx(e, n) {
  if (e == null)
    return {};
  var o = Rx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Rx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var $p = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = kx(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", kc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
  }), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }));
});
$p.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
$p.displayName = "Eye";
const $x = $p;
function Rc() {
  return Rc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Rc.apply(this, arguments);
}
function Dx(e, n) {
  if (e == null)
    return {};
  var o = Tx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Tx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Dp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = Dx(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Rc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "14 2 14 8 20 8"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "16",
    y1: "13",
    x2: "8",
    y2: "13"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "16",
    y1: "17",
    x2: "8",
    y2: "17"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "10 9 9 9 8 9"
  }));
});
Dp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Dp.displayName = "FileText";
const jx = Dp;
function $c() {
  return $c = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, $c.apply(this, arguments);
}
function _x(e, n) {
  if (e == null)
    return {};
  var o = Ix(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Ix(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Tp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = _x(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", $c({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "13 2 13 9 20 9"
  }));
});
Tp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Tp.displayName = "File";
const Mx = Tp;
function Dc() {
  return Dc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Dc.apply(this, arguments);
}
function Ax(e, n) {
  if (e == null)
    return {};
  var o = Fx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Fx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var jp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = Ax(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Dc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "2",
    y1: "12",
    x2: "22",
    y2: "12"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
  }));
});
jp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
jp.displayName = "Globe";
const Lx = jp;
function Tc() {
  return Tc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Tc.apply(this, arguments);
}
function Nx(e, n) {
  if (e == null)
    return {};
  var o = Bx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Bx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var _p = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = Nx(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Tc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "17",
    x2: "12.01",
    y2: "17"
  }));
});
_p.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
_p.displayName = "HelpCircle";
const Wx = _p;
function jc() {
  return jc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, jc.apply(this, arguments);
}
function zx(e, n) {
  if (e == null)
    return {};
  var o = Hx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Hx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Ip = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = zx(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", jc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "9 22 9 12 15 12 15 22"
  }));
});
Ip.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Ip.displayName = "Home";
const Yx = Ip;
function _c() {
  return _c = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, _c.apply(this, arguments);
}
function Gx(e, n) {
  if (e == null)
    return {};
  var o = Vx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Vx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Mp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = Gx(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", _c({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), /* @__PURE__ */ y.createElement("circle", {
    cx: "8.5",
    cy: "8.5",
    r: "1.5"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "21 15 16 10 5 21"
  }));
});
Mp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Mp.displayName = "Image";
const Ux = Mp;
function Ic() {
  return Ic = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Ic.apply(this, arguments);
}
function qx(e, n) {
  if (e == null)
    return {};
  var o = Kx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Kx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Ap = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = qx(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Ic({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "12"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "8",
    x2: "12.01",
    y2: "8"
  }));
});
Ap.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Ap.displayName = "Info";
const Qx = Ap;
function Mc() {
  return Mc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Mc.apply(this, arguments);
}
function Xx(e, n) {
  if (e == null)
    return {};
  var o = Jx(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Jx(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Fp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = Xx(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Mc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
  }));
});
Fp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Fp.displayName = "Link";
const Zx = Fp;
function Ac() {
  return Ac = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Ac.apply(this, arguments);
}
function e1(e, n) {
  if (e == null)
    return {};
  var o = t1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function t1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Lp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = e1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Ac({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("line", {
    x1: "8",
    y1: "6",
    x2: "21",
    y2: "6"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "8",
    y1: "12",
    x2: "21",
    y2: "12"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "8",
    y1: "18",
    x2: "21",
    y2: "18"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "3",
    y1: "6",
    x2: "3.01",
    y2: "6"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "3",
    y1: "12",
    x2: "3.01",
    y2: "12"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "3",
    y1: "18",
    x2: "3.01",
    y2: "18"
  }));
});
Lp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Lp.displayName = "List";
const r1 = Lp;
function Fc() {
  return Fc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Fc.apply(this, arguments);
}
function n1(e, n) {
  if (e == null)
    return {};
  var o = o1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function o1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Np = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = n1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Fc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("rect", {
    x: "3",
    y: "11",
    width: "18",
    height: "11",
    rx: "2",
    ry: "2"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M7 11V7a5 5 0 0 1 10 0v4"
  }));
});
Np.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Np.displayName = "Lock";
const a1 = Np;
function Lc() {
  return Lc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Lc.apply(this, arguments);
}
function i1(e, n) {
  if (e == null)
    return {};
  var o = s1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function s1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Bp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = i1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Lc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "16 17 21 12 16 7"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "21",
    y1: "12",
    x2: "9",
    y2: "12"
  }));
});
Bp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Bp.displayName = "LogOut";
const l1 = Bp;
function Nc() {
  return Nc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Nc.apply(this, arguments);
}
function u1(e, n) {
  if (e == null)
    return {};
  var o = c1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function c1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Wp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = u1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Nc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("line", {
    x1: "3",
    y1: "12",
    x2: "21",
    y2: "12"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "3",
    y1: "6",
    x2: "21",
    y2: "6"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "3",
    y1: "18",
    x2: "21",
    y2: "18"
  }));
});
Wp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Wp.displayName = "Menu";
const d1 = Wp;
function Bc() {
  return Bc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Bc.apply(this, arguments);
}
function p1(e, n) {
  if (e == null)
    return {};
  var o = f1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function f1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var zp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = p1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Bc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
  }));
});
zp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
zp.displayName = "MessageCircle";
const v1 = zp;
function Wc() {
  return Wc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Wc.apply(this, arguments);
}
function g1(e, n) {
  if (e == null)
    return {};
  var o = h1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function h1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Hp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = g1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Wc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "8",
    y1: "12",
    x2: "16",
    y2: "12"
  }));
});
Hp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Hp.displayName = "MinusCircle";
const m1 = Hp;
function zc() {
  return zc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, zc.apply(this, arguments);
}
function y1(e, n) {
  if (e == null)
    return {};
  var o = b1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function b1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Yp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = y1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", zc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }));
});
Yp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Yp.displayName = "Minus";
const w1 = Yp;
function Hc() {
  return Hc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Hc.apply(this, arguments);
}
function x1(e, n) {
  if (e == null)
    return {};
  var o = C1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function C1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Gp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = x1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Hc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "5",
    r: "1"
  }), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "19",
    r: "1"
  }));
});
Gp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Gp.displayName = "MoreVertical";
const S1 = Gp;
function Yc() {
  return Yc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Yc.apply(this, arguments);
}
function O1(e, n) {
  if (e == null)
    return {};
  var o = P1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function P1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Vp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = O1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Yc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M21.21 15.89A10 10 0 1 1 8 2.83"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M22 12A10 10 0 0 0 12 2v10z"
  }));
});
Vp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Vp.displayName = "PieChart";
const E1 = Vp;
function Gc() {
  return Gc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Gc.apply(this, arguments);
}
function k1(e, n) {
  if (e == null)
    return {};
  var o = R1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function R1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Up = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = k1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Gc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "16"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "8",
    y1: "12",
    x2: "16",
    y2: "12"
  }));
});
Up.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Up.displayName = "PlusCircle";
const $1 = Up;
function Vc() {
  return Vc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Vc.apply(this, arguments);
}
function D1(e, n) {
  if (e == null)
    return {};
  var o = T1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function T1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var qp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = D1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Vc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("polyline", {
    points: "23 4 23 10 17 10"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "1 20 1 14 7 14"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
  }));
});
qp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
qp.displayName = "RefreshCw";
const j1 = qp;
function Uc() {
  return Uc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Uc.apply(this, arguments);
}
function _1(e, n) {
  if (e == null)
    return {};
  var o = I1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function I1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Kp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = _1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Uc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("polyline", {
    points: "23 4 23 10 17 10"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
  }));
});
Kp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Kp.displayName = "RotateCw";
const M1 = Kp;
function qc() {
  return qc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, qc.apply(this, arguments);
}
function A1(e, n) {
  if (e == null)
    return {};
  var o = F1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function F1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Qp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = A1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", qc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "21",
    y1: "21",
    x2: "16.65",
    y2: "16.65"
  }));
});
Qp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Qp.displayName = "Search";
const L1 = Qp;
function Kc() {
  return Kc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Kc.apply(this, arguments);
}
function N1(e, n) {
  if (e == null)
    return {};
  var o = B1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function B1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Xp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = N1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Kc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
  }));
});
Xp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Xp.displayName = "Settings";
const W1 = Xp;
function Qc() {
  return Qc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Qc.apply(this, arguments);
}
function z1(e, n) {
  if (e == null)
    return {};
  var o = H1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function H1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Jp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = z1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Qc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("circle", {
    cx: "9",
    cy: "21",
    r: "1"
  }), /* @__PURE__ */ y.createElement("circle", {
    cx: "20",
    cy: "21",
    r: "1"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
  }));
});
Jp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Jp.displayName = "ShoppingCart";
const Y1 = Jp;
function Xc() {
  return Xc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Xc.apply(this, arguments);
}
function G1(e, n) {
  if (e == null)
    return {};
  var o = V1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function V1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Zp = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = G1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Xc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("polyline", {
    points: "16 3 21 3 21 8"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "4",
    y1: "20",
    x2: "21",
    y2: "3"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "21 16 21 21 16 21"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "15",
    y1: "15",
    x2: "21",
    y2: "21"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "4",
    y1: "4",
    x2: "9",
    y2: "9"
  }));
});
Zp.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
Zp.displayName = "Shuffle";
const U1 = Zp;
function Jc() {
  return Jc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Jc.apply(this, arguments);
}
function q1(e, n) {
  if (e == null)
    return {};
  var o = K1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function K1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var ef = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = q1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Jc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("line", {
    x1: "4",
    y1: "21",
    x2: "4",
    y2: "14"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "4",
    y1: "10",
    x2: "4",
    y2: "3"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "21",
    x2: "12",
    y2: "12"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "3"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "20",
    y1: "21",
    x2: "20",
    y2: "16"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "20",
    y1: "12",
    x2: "20",
    y2: "3"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "1",
    y1: "14",
    x2: "7",
    y2: "14"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "9",
    y1: "8",
    x2: "15",
    y2: "8"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "17",
    y1: "16",
    x2: "23",
    y2: "16"
  }));
});
ef.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
ef.displayName = "Sliders";
const Q1 = ef;
function Zc() {
  return Zc = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, Zc.apply(this, arguments);
}
function X1(e, n) {
  if (e == null)
    return {};
  var o = J1(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function J1(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var tf = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = X1(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", Zc({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "7",
    y1: "7",
    x2: "7.01",
    y2: "7"
  }));
});
tf.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
tf.displayName = "Tag";
const Z1 = tf;
function ed() {
  return ed = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, ed.apply(this, arguments);
}
function eC(e, n) {
  if (e == null)
    return {};
  var o = tC(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function tC(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var rf = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = eC(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", ed({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("polyline", {
    points: "3 6 5 6 21 6"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "10",
    y1: "11",
    x2: "10",
    y2: "17"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "14",
    y1: "11",
    x2: "14",
    y2: "17"
  }));
});
rf.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
rf.displayName = "Trash2";
const rC = rf;
function td() {
  return td = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, td.apply(this, arguments);
}
function nC(e, n) {
  if (e == null)
    return {};
  var o = oC(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function oC(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var nf = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = nC(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", td({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("polyline", {
    points: "16 16 12 12 8 16"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "12",
    x2: "12",
    y2: "21"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "16 16 12 12 8 16"
  }));
});
nf.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
nf.displayName = "UploadCloud";
const aC = nf;
function rd() {
  return rd = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, rd.apply(this, arguments);
}
function iC(e, n) {
  if (e == null)
    return {};
  var o = sC(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function sC(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var of = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = iC(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", rd({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), /* @__PURE__ */ y.createElement("polyline", {
    points: "17 8 12 3 7 8"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "12",
    y1: "3",
    x2: "12",
    y2: "15"
  }));
});
of.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
of.displayName = "Upload";
const lC = of;
function nd() {
  return nd = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, nd.apply(this, arguments);
}
function uC(e, n) {
  if (e == null)
    return {};
  var o = cC(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function cC(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var af = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = uC(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", nd({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
  }), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "7",
    r: "4"
  }));
});
af.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
af.displayName = "User";
const dC = af;
function od() {
  return od = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, od.apply(this, arguments);
}
function pC(e, n) {
  if (e == null)
    return {};
  var o = fC(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function fC(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var sf = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = pC(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", od({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("path", {
    d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /* @__PURE__ */ y.createElement("circle", {
    cx: "9",
    cy: "7",
    r: "4"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M23 21v-2a4 4 0 0 0-3-3.87"
  }), /* @__PURE__ */ y.createElement("path", {
    d: "M16 3.13a4 4 0 0 1 0 7.75"
  }));
});
sf.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
sf.displayName = "Users";
const vC = sf;
function ad() {
  return ad = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, ad.apply(this, arguments);
}
function gC(e, n) {
  if (e == null)
    return {};
  var o = hC(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function hC(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var lf = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = gC(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", ad({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "15",
    y1: "9",
    x2: "9",
    y2: "15"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "9",
    y1: "9",
    x2: "15",
    y2: "15"
  }));
});
lf.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
lf.displayName = "XCircle";
const mC = lf;
function id() {
  return id = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }, id.apply(this, arguments);
}
function yC(e, n) {
  if (e == null)
    return {};
  var o = bC(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function bC(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var uf = Ye(function(e, n) {
  var o = e.color, t = o === void 0 ? "currentColor" : o, r = e.size, a = r === void 0 ? 24 : r, i = yC(e, ["color", "size"]);
  return /* @__PURE__ */ y.createElement("svg", id({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ y.createElement("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), /* @__PURE__ */ y.createElement("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  }));
});
uf.propTypes = {
  color: j.string,
  size: j.oneOfType([j.string, j.number])
};
uf.displayName = "X";
const wC = uf, xC = {
  activity: lw,
  "alert-circle": dw,
  "alert-triangle": vw,
  "arrow-down-circle": mw,
  "arrow-left": ww,
  "arrow-up-circle": Sw,
  "at-sign": Ew,
  "bar-chart": $w,
  bell: jw,
  book: Lw,
  "book-open": Mw,
  briefcase: Ww,
  calendar: Yw,
  "check-circle": Uw,
  check: Qw,
  "chevron-down": Zw,
  "chevron-left": rx,
  "chevron-right": ax,
  "chevron-up": lx,
  copy: dx,
  database: vx,
  "dollar-sign": mx,
  download: wx,
  edit: Sx,
  "eye-off": Ex,
  eye: $x,
  "file-text": jx,
  file: Mx,
  globe: Lx,
  "help-circle": Wx,
  home: Yx,
  image: Ux,
  info: Qx,
  link: Zx,
  list: r1,
  lock: a1,
  "log-out": l1,
  menu: d1,
  "message-circle": v1,
  minus: w1,
  "minus-circle": m1,
  "more-vertical": S1,
  "pie-chart": E1,
  "plus-circle": $1,
  refresh: j1,
  "rotate-cw": M1,
  search: L1,
  settings: W1,
  "shopping-cart": Y1,
  shuffle: U1,
  sliders: Q1,
  tag: Z1,
  trash: rC,
  "upload-cloud": aC,
  upload: lC,
  user: dC,
  users: vC,
  "x-circle": mC,
  x: wC
}, Lr = Ye(
  ({ name: e, className: n = "", "aria-label": o, trackingId: t, ...r }, a) => {
    const i = xC[e];
    return /* @__PURE__ */ g.jsx(
      Cl,
      {
        as: i,
        ref: a,
        className: n,
        trackingId: t,
        role: "img",
        "aria-label": o,
        "aria-hidden": !o,
        ...r
      }
    );
  }
), co = (e) => e.sizing.xxs, Cl = pa(
  Y.svg(
    ({ theme: e }) => `
  width: ${co(e)};
  height: ${co(e)};

  // Stop the svg from shrinking when its siblings need more space
  flex-shrink: 0;
`
  )
), cf = (e) => ({
  default: {
    size: e.sizing.xs,
    iconSize: e.sizing.xxs
  },
  large: {
    size: e.sizing.m,
    iconSize: e.sizing.xs
  }
}), CC = (e) => ({
  primary: {
    color: e.color.black,
    hoverBackgroundColor: Hr(e.color.black, 0.1),
    activeBackgroundColor: Hr(e.color.black, 0.2)
  },
  danger: {
    color: e.color.danger,
    hoverBackgroundColor: Hr(e.color.danger, 0.1),
    activeBackgroundColor: Hr(e.color.danger, 0.2)
  },
  white: {
    color: e.color.white,
    hoverBackgroundColor: Hr(e.color.white, 0.2),
    activeBackgroundColor: Hr(e.color.white, 0.4)
  }
}), Ga = (e) => {
  const [, n] = ur(), o = It((t) => {
    n(() => {
      throw t;
    });
  }, []);
  return It(
    (...t) => {
      try {
        e == null || e(...t);
      } catch (r) {
        o(r);
      }
    },
    [e, o]
  );
}, Yv = (e, n) => e.split(" ").map((o) => n[o]).join(" "), SC = [
  "ref",
  "id",
  "children",
  "aria-live",
  "aria-atomic",
  Fh
], OC = new Set(SC), Be = pa(
  Y.div.withConfig({
    /**
     * Prevents any props from being added to the div element as
     * attributes. Currently, without this, direction would be added as an
     * attribute on the element. The other props wouldn't technically be
     * added as attributes because they aren't valid DOM attribute names,
     * but we filter them out as well for consistency and future-proofing.
     *
     * We prevent forwarding of most props because there are currently minimal use cases
     * for passing along builtin div attributes, and to ensure consumers of `Flex`
     * don't need to account for prop forwarding themselves.
     */
    shouldForwardProp: (e) => OC.has(e)
  })(
    ({
      theme: e,
      direction: n = "row",
      gap: o = "none",
      alignItems: t = "stretch",
      justifyContent: r = "flex-start",
      padding: a = "none",
      growItems: i = !1,
      wrap: s = "nowrap",
      isInline: l = !1
    }) => `
  /**
   * Assigning a min-width assists the browser in calculating the
   * size of flex items in situations like text truncation.
   */
  min-width: 0;
  display: ${l ? "inline-flex" : "flex"};
  flex-direction: ${n};
  gap: ${Yv(o, e.spacing)};
  align-items: ${t};
  justify-content: ${r};
  padding: ${Yv(a, e.spacing)};
  flex-wrap: ${s};
  ${i ? "& > * {flex: 1}" : ""}
`
  )
), Qh = ({
  label: e,
  iconName: n,
  iconPlacement: o = "left",
  utilityElement: t,
  shouldSeparateUtilityElement: r = !1
}) => /* @__PURE__ */ g.jsxs(
  PC,
  {
    alignItems: "center",
    gap: "s",
    shouldSeparateUtilityElement: r,
    justifyContent: r ? "space-between" : "center",
    isInline: !0,
    children: [
      /* @__PURE__ */ g.jsxs(Sl, { children: [
        n && o === "left" && /* @__PURE__ */ g.jsx(Lr, { name: n }),
        e && /* @__PURE__ */ g.jsx("span", { children: e }),
        n && o === "right" && /* @__PURE__ */ g.jsx(Lr, { name: n })
      ] }),
      t
    ]
  }
), PC = Y(Be)(
  ({ shouldSeparateUtilityElement: e }) => `
  width: ${e ? "100%" : "auto"}
`
), Sl = Y(Be).attrs({
  alignItems: "center",
  gap: "s",
  isInline: !0,
  justifyContent: "center",
  wrap: "wrap"
})``, Yo = `
  height: min-content;
  color: unset;
  outline: none;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-decoration: none;
  font-size: unset;
`, Xh = (e) => ({
  small: {
    height: e.sizing.s,
    horizontalPadding: e.spacing.s,
    verticalPadding: e.spacing.xs,
    fontSize: e.fontSize.s
  },
  default: {
    height: e.sizing.m,
    horizontalPadding: e.spacing.m,
    verticalPadding: e.spacing.s,
    fontSize: e.fontSize.m
  },
  large: {
    height: e.sizing.l,
    horizontalPadding: e.spacing.l,
    verticalPadding: e.spacing.s,
    fontSize: e.fontSize.m
  }
}), EC = (e) => ({
  "button-primary": {
    enabled: {
      color: e.color.white,
      backgroundColor: e.color.primary,
      borderColor: e.color.primary
    },
    active: {
      color: e.color.white,
      backgroundColor: e.color.blue4,
      borderColor: e.color.blue4
    },
    hover: {
      color: e.color.white,
      backgroundColor: e.color.blue3,
      borderColor: e.color.blue3
    }
  },
  "button-secondary": {
    enabled: {
      color: e.color.black,
      backgroundColor: e.color.gray1,
      borderColor: e.color.gray1
    },
    active: {
      color: e.color.black,
      backgroundColor: e.color.gray3,
      borderColor: e.color.gray3
    },
    hover: {
      color: e.color.black,
      backgroundColor: e.color.gray2,
      borderColor: e.color.gray2
    }
  },
  "button-tertiary": {
    enabled: {
      color: e.color.black,
      backgroundColor: e.color.white,
      borderColor: e.color.border
    },
    active: {
      color: e.color.black,
      backgroundColor: e.color.gray1,
      borderColor: e.color.borderHover
    },
    hover: {
      color: e.color.black,
      backgroundColor: e.color.gray0,
      borderColor: e.color.borderHover
    }
  },
  "button-danger": {
    enabled: {
      color: e.color.white,
      backgroundColor: e.color.red1,
      borderColor: e.color.red1
    },
    active: {
      color: e.color.white,
      backgroundColor: e.color.red3,
      borderColor: e.color.red3
    },
    hover: {
      color: e.color.white,
      backgroundColor: e.color.red2,
      borderColor: e.color.red2
    }
  }
}), Ou = (e, n) => `
  background-color: ${e.backgroundColor};
  color: ${e.color};
  border: ${n.borderWidth.s} solid ${e.borderColor};
`, kC = (e, n, o = "default") => {
  const { enabled: t, hover: r, active: a } = EC(e)[n], { height: i, horizontalPadding: s, fontSize: l, verticalPadding: u } = Xh(e)[o];
  return `
    ${Yo}

    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${e.spacing.s};
    border-radius: ${df(n, e)};
    min-height: ${i};
    padding: ${u} ${s};
    font-size: ${l};
    // Button height at default size should be 40px when its label is not wrapping
    line-height: 1.25;

    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;

    ${Ou(t, e)}

    &:focus-visible {
      ${cn(e)};
    }

    &:hover {
      ${Ou(r, e)}
    }

    &:active {
      ${Ou(a, e)}
    }

    &[disabled] {
      ${Rn}
    }
  `;
}, RC = (e, n, o) => {
  const { color: t, hoverColor: r, activeColor: a, textDecoration: i } = $C(e)[n], { fontSize: s } = Jh(e)[o];
  return `
    ${Yo};

    transition: color .15s ease-in-out, box-shadow .15s ease-in-out;

    font-size: ${s};
    color: ${t};
    text-align: left;
    
    // Recent browser updates changed the way that text-decoration is inherited by
    // child elements. We're not sure exactly what the change is, but we need to
    // specifically target the content wrapper to underline it.
    ${Sl} {
      text-decoration: ${i};
    }

    &:hover {
      color: ${r};
    }

    &:active {
      color: ${a};
    }

    &:focus-visible {
      border-radius: ${df(n, e)};
      ${cn(e)}
    }

    &[disabled] {
      ${Rn};
    }
  `;
}, $C = (e) => ({
  "anchor-primary": {
    color: e.color.primary,
    activeColor: e.color.blue4,
    hoverColor: e.color.blue3,
    textDecoration: "none"
  },
  "anchor-primary-inline": {
    color: e.color.primary,
    activeColor: e.color.blue4,
    hoverColor: e.color.blue3,
    textDecoration: "underline"
  }
}), Jh = (e) => ({
  small: {
    fontSize: e.fontSize.s
  },
  // By default, anchor sizes should align with the text around them. This will also
  // default to our body size if not surrounded by a different text element.
  default: {
    fontSize: "inherit"
  }
}), Zh = (e) => e.startsWith("anchor"), DC = (e, n) => Object.keys(Jh(n)).includes(e), df = (e, n) => Zh(e) ? n.borderRadius.xs : n.borderRadius.s, Ol = (e, { variant: n = "button-primary", size: o = "default" }) => n === "invisible" ? `
      ${Yo}

      &:focus-visible {
        ${cn(e)}
      }
    ` : Zh(n) ? RC(
  e,
  n,
  DC(o, e) ? o : "default"
) : kC(e, n, o), TC = Ye(
  ({
    label: e,
    iconName: n,
    iconPlacement: o,
    onClick: t,
    utilityElement: r,
    shouldSeparateUtilityElement: a,
    ...i
  }, s) => {
    const l = {
      iconName: n,
      iconPlacement: o,
      label: e,
      utilityElement: r,
      shouldSeparateUtilityElement: a
    }, u = Ga(t), c = i.target ?? "_blank";
    return /* @__PURE__ */ g.jsx(
      em,
      {
        ref: s,
        target: c,
        onClick: u,
        title: c === "_blank" ? "Opens in a new tab" : void 0,
        ...i,
        children: /* @__PURE__ */ g.jsx(Qh, { ...l })
      }
    );
  }
), em = Jr(
  Y.a(
    ({ theme: e, variant: n = "anchor-primary", size: o = "default" }) => `
  ${Ol(e, { variant: n, size: o })}
`
  )
);
var fn = "top", Mn = "bottom", An = "right", vn = "left", pf = "auto", Ni = [fn, Mn, An, vn], Ia = "start", Di = "end", jC = "clippingParents", tm = "viewport", pi = "popper", _C = "reference", Gv = /* @__PURE__ */ Ni.reduce(function(e, n) {
  return e.concat([n + "-" + Ia, n + "-" + Di]);
}, []), rm = /* @__PURE__ */ [].concat(Ni, [pf]).reduce(function(e, n) {
  return e.concat([n, n + "-" + Ia, n + "-" + Di]);
}, []), IC = "beforeRead", MC = "read", AC = "afterRead", FC = "beforeMain", LC = "main", NC = "afterMain", BC = "beforeWrite", WC = "write", zC = "afterWrite", HC = [IC, MC, AC, FC, LC, NC, BC, WC, zC];
function po(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function En(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var n = e.ownerDocument;
    return n && n.defaultView || window;
  }
  return e;
}
function la(e) {
  var n = En(e).Element;
  return e instanceof n || e instanceof Element;
}
function In(e) {
  var n = En(e).HTMLElement;
  return e instanceof n || e instanceof HTMLElement;
}
function ff(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var n = En(e).ShadowRoot;
  return e instanceof n || e instanceof ShadowRoot;
}
function YC(e) {
  var n = e.state;
  Object.keys(n.elements).forEach(function(o) {
    var t = n.styles[o] || {}, r = n.attributes[o] || {}, a = n.elements[o];
    !In(a) || !po(a) || (Object.assign(a.style, t), Object.keys(r).forEach(function(i) {
      var s = r[i];
      s === !1 ? a.removeAttribute(i) : a.setAttribute(i, s === !0 ? "" : s);
    }));
  });
}
function GC(e) {
  var n = e.state, o = {
    popper: {
      position: n.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(n.elements.popper.style, o.popper), n.styles = o, n.elements.arrow && Object.assign(n.elements.arrow.style, o.arrow), function() {
    Object.keys(n.elements).forEach(function(t) {
      var r = n.elements[t], a = n.attributes[t] || {}, i = Object.keys(n.styles.hasOwnProperty(t) ? n.styles[t] : o[t]), s = i.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !In(r) || !po(r) || (Object.assign(r.style, s), Object.keys(a).forEach(function(l) {
        r.removeAttribute(l);
      }));
    });
  };
}
const nm = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: YC,
  effect: GC,
  requires: ["computeStyles"]
};
function so(e) {
  return e.split("-")[0];
}
var aa = Math.max, Ks = Math.min, Ma = Math.round;
function sd() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(n) {
    return n.brand + "/" + n.version;
  }).join(" ") : navigator.userAgent;
}
function om() {
  return !/^((?!chrome|android).)*safari/i.test(sd());
}
function Aa(e, n, o) {
  n === void 0 && (n = !1), o === void 0 && (o = !1);
  var t = e.getBoundingClientRect(), r = 1, a = 1;
  n && In(e) && (r = e.offsetWidth > 0 && Ma(t.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && Ma(t.height) / e.offsetHeight || 1);
  var i = la(e) ? En(e) : window, s = i.visualViewport, l = !om() && o, u = (t.left + (l && s ? s.offsetLeft : 0)) / r, c = (t.top + (l && s ? s.offsetTop : 0)) / a, p = t.width / r, h = t.height / a;
  return {
    width: p,
    height: h,
    top: c,
    right: u + p,
    bottom: c + h,
    left: u,
    x: u,
    y: c
  };
}
function vf(e) {
  var n = Aa(e), o = e.offsetWidth, t = e.offsetHeight;
  return Math.abs(n.width - o) <= 1 && (o = n.width), Math.abs(n.height - t) <= 1 && (t = n.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: o,
    height: t
  };
}
function am(e, n) {
  var o = n.getRootNode && n.getRootNode();
  if (e.contains(n))
    return !0;
  if (o && ff(o)) {
    var t = n;
    do {
      if (t && e.isSameNode(t))
        return !0;
      t = t.parentNode || t.host;
    } while (t);
  }
  return !1;
}
function So(e) {
  return En(e).getComputedStyle(e);
}
function VC(e) {
  return ["table", "td", "th"].indexOf(po(e)) >= 0;
}
function Go(e) {
  return ((la(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Pl(e) {
  return po(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (ff(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Go(e)
  );
}
function Vv(e) {
  return !In(e) || // https://github.com/popperjs/popper-core/issues/837
  So(e).position === "fixed" ? null : e.offsetParent;
}
function UC(e) {
  var n = /firefox/i.test(sd()), o = /Trident/i.test(sd());
  if (o && In(e)) {
    var t = So(e);
    if (t.position === "fixed")
      return null;
  }
  var r = Pl(e);
  for (ff(r) && (r = r.host); In(r) && ["html", "body"].indexOf(po(r)) < 0; ) {
    var a = So(r);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || n && a.willChange === "filter" || n && a.filter && a.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function Bi(e) {
  for (var n = En(e), o = Vv(e); o && VC(o) && So(o).position === "static"; )
    o = Vv(o);
  return o && (po(o) === "html" || po(o) === "body" && So(o).position === "static") ? n : o || UC(e) || n;
}
function gf(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Si(e, n, o) {
  return aa(e, Ks(n, o));
}
function qC(e, n, o) {
  var t = Si(e, n, o);
  return t > o ? o : t;
}
function im() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function sm(e) {
  return Object.assign({}, im(), e);
}
function lm(e, n) {
  return n.reduce(function(o, t) {
    return o[t] = e, o;
  }, {});
}
var KC = function(n, o) {
  return n = typeof n == "function" ? n(Object.assign({}, o.rects, {
    placement: o.placement
  })) : n, sm(typeof n != "number" ? n : lm(n, Ni));
};
function QC(e) {
  var n, o = e.state, t = e.name, r = e.options, a = o.elements.arrow, i = o.modifiersData.popperOffsets, s = so(o.placement), l = gf(s), u = [vn, An].indexOf(s) >= 0, c = u ? "height" : "width";
  if (!(!a || !i)) {
    var p = KC(r.padding, o), h = vf(a), O = l === "y" ? fn : vn, C = l === "y" ? Mn : An, P = o.rects.reference[c] + o.rects.reference[l] - i[l] - o.rects.popper[c], k = i[l] - o.rects.reference[l], $ = Bi(a), I = $ ? l === "y" ? $.clientHeight || 0 : $.clientWidth || 0 : 0, H = P / 2 - k / 2, x = p[O], _ = I - h[c] - p[C], F = I / 2 - h[c] / 2 + H, G = Si(x, F, _), Q = l;
    o.modifiersData[t] = (n = {}, n[Q] = G, n.centerOffset = G - F, n);
  }
}
function XC(e) {
  var n = e.state, o = e.options, t = o.element, r = t === void 0 ? "[data-popper-arrow]" : t;
  r != null && (typeof r == "string" && (r = n.elements.popper.querySelector(r), !r) || am(n.elements.popper, r) && (n.elements.arrow = r));
}
const JC = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: QC,
  effect: XC,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Fa(e) {
  return e.split("-")[1];
}
var ZC = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function eS(e, n) {
  var o = e.x, t = e.y, r = n.devicePixelRatio || 1;
  return {
    x: Ma(o * r) / r || 0,
    y: Ma(t * r) / r || 0
  };
}
function Uv(e) {
  var n, o = e.popper, t = e.popperRect, r = e.placement, a = e.variation, i = e.offsets, s = e.position, l = e.gpuAcceleration, u = e.adaptive, c = e.roundOffsets, p = e.isFixed, h = i.x, O = h === void 0 ? 0 : h, C = i.y, P = C === void 0 ? 0 : C, k = typeof c == "function" ? c({
    x: O,
    y: P
  }) : {
    x: O,
    y: P
  };
  O = k.x, P = k.y;
  var $ = i.hasOwnProperty("x"), I = i.hasOwnProperty("y"), H = vn, x = fn, _ = window;
  if (u) {
    var F = Bi(o), G = "clientHeight", Q = "clientWidth";
    if (F === En(o) && (F = Go(o), So(F).position !== "static" && s === "absolute" && (G = "scrollHeight", Q = "scrollWidth")), F = F, r === fn || (r === vn || r === An) && a === Di) {
      x = Mn;
      var V = p && F === _ && _.visualViewport ? _.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        F[G]
      );
      P -= V - t.height, P *= l ? 1 : -1;
    }
    if (r === vn || (r === fn || r === Mn) && a === Di) {
      H = An;
      var ie = p && F === _ && _.visualViewport ? _.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        F[Q]
      );
      O -= ie - t.width, O *= l ? 1 : -1;
    }
  }
  var ce = Object.assign({
    position: s
  }, u && ZC), me = c === !0 ? eS({
    x: O,
    y: P
  }, En(o)) : {
    x: O,
    y: P
  };
  if (O = me.x, P = me.y, l) {
    var ve;
    return Object.assign({}, ce, (ve = {}, ve[x] = I ? "0" : "", ve[H] = $ ? "0" : "", ve.transform = (_.devicePixelRatio || 1) <= 1 ? "translate(" + O + "px, " + P + "px)" : "translate3d(" + O + "px, " + P + "px, 0)", ve));
  }
  return Object.assign({}, ce, (n = {}, n[x] = I ? P + "px" : "", n[H] = $ ? O + "px" : "", n.transform = "", n));
}
function tS(e) {
  var n = e.state, o = e.options, t = o.gpuAcceleration, r = t === void 0 ? !0 : t, a = o.adaptive, i = a === void 0 ? !0 : a, s = o.roundOffsets, l = s === void 0 ? !0 : s, u = {
    placement: so(n.placement),
    variation: Fa(n.placement),
    popper: n.elements.popper,
    popperRect: n.rects.popper,
    gpuAcceleration: r,
    isFixed: n.options.strategy === "fixed"
  };
  n.modifiersData.popperOffsets != null && (n.styles.popper = Object.assign({}, n.styles.popper, Uv(Object.assign({}, u, {
    offsets: n.modifiersData.popperOffsets,
    position: n.options.strategy,
    adaptive: i,
    roundOffsets: l
  })))), n.modifiersData.arrow != null && (n.styles.arrow = Object.assign({}, n.styles.arrow, Uv(Object.assign({}, u, {
    offsets: n.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-placement": n.placement
  });
}
const rS = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: tS,
  data: {}
};
var Ps = {
  passive: !0
};
function nS(e) {
  var n = e.state, o = e.instance, t = e.options, r = t.scroll, a = r === void 0 ? !0 : r, i = t.resize, s = i === void 0 ? !0 : i, l = En(n.elements.popper), u = [].concat(n.scrollParents.reference, n.scrollParents.popper);
  return a && u.forEach(function(c) {
    c.addEventListener("scroll", o.update, Ps);
  }), s && l.addEventListener("resize", o.update, Ps), function() {
    a && u.forEach(function(c) {
      c.removeEventListener("scroll", o.update, Ps);
    }), s && l.removeEventListener("resize", o.update, Ps);
  };
}
const oS = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: nS,
  data: {}
};
var aS = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ls(e) {
  return e.replace(/left|right|bottom|top/g, function(n) {
    return aS[n];
  });
}
var iS = {
  start: "end",
  end: "start"
};
function qv(e) {
  return e.replace(/start|end/g, function(n) {
    return iS[n];
  });
}
function hf(e) {
  var n = En(e), o = n.pageXOffset, t = n.pageYOffset;
  return {
    scrollLeft: o,
    scrollTop: t
  };
}
function mf(e) {
  return Aa(Go(e)).left + hf(e).scrollLeft;
}
function sS(e, n) {
  var o = En(e), t = Go(e), r = o.visualViewport, a = t.clientWidth, i = t.clientHeight, s = 0, l = 0;
  if (r) {
    a = r.width, i = r.height;
    var u = om();
    (u || !u && n === "fixed") && (s = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s + mf(e),
    y: l
  };
}
function lS(e) {
  var n, o = Go(e), t = hf(e), r = (n = e.ownerDocument) == null ? void 0 : n.body, a = aa(o.scrollWidth, o.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), i = aa(o.scrollHeight, o.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), s = -t.scrollLeft + mf(e), l = -t.scrollTop;
  return So(r || o).direction === "rtl" && (s += aa(o.clientWidth, r ? r.clientWidth : 0) - a), {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
function yf(e) {
  var n = So(e), o = n.overflow, t = n.overflowX, r = n.overflowY;
  return /auto|scroll|overlay|hidden/.test(o + r + t);
}
function um(e) {
  return ["html", "body", "#document"].indexOf(po(e)) >= 0 ? e.ownerDocument.body : In(e) && yf(e) ? e : um(Pl(e));
}
function Oi(e, n) {
  var o;
  n === void 0 && (n = []);
  var t = um(e), r = t === ((o = e.ownerDocument) == null ? void 0 : o.body), a = En(t), i = r ? [a].concat(a.visualViewport || [], yf(t) ? t : []) : t, s = n.concat(i);
  return r ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Oi(Pl(i)))
  );
}
function ld(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function uS(e, n) {
  var o = Aa(e, !1, n === "fixed");
  return o.top = o.top + e.clientTop, o.left = o.left + e.clientLeft, o.bottom = o.top + e.clientHeight, o.right = o.left + e.clientWidth, o.width = e.clientWidth, o.height = e.clientHeight, o.x = o.left, o.y = o.top, o;
}
function Kv(e, n, o) {
  return n === tm ? ld(sS(e, o)) : la(n) ? uS(n, o) : ld(lS(Go(e)));
}
function cS(e) {
  var n = Oi(Pl(e)), o = ["absolute", "fixed"].indexOf(So(e).position) >= 0, t = o && In(e) ? Bi(e) : e;
  return la(t) ? n.filter(function(r) {
    return la(r) && am(r, t) && po(r) !== "body";
  }) : [];
}
function dS(e, n, o, t) {
  var r = n === "clippingParents" ? cS(e) : [].concat(n), a = [].concat(r, [o]), i = a[0], s = a.reduce(function(l, u) {
    var c = Kv(e, u, t);
    return l.top = aa(c.top, l.top), l.right = Ks(c.right, l.right), l.bottom = Ks(c.bottom, l.bottom), l.left = aa(c.left, l.left), l;
  }, Kv(e, i, t));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function cm(e) {
  var n = e.reference, o = e.element, t = e.placement, r = t ? so(t) : null, a = t ? Fa(t) : null, i = n.x + n.width / 2 - o.width / 2, s = n.y + n.height / 2 - o.height / 2, l;
  switch (r) {
    case fn:
      l = {
        x: i,
        y: n.y - o.height
      };
      break;
    case Mn:
      l = {
        x: i,
        y: n.y + n.height
      };
      break;
    case An:
      l = {
        x: n.x + n.width,
        y: s
      };
      break;
    case vn:
      l = {
        x: n.x - o.width,
        y: s
      };
      break;
    default:
      l = {
        x: n.x,
        y: n.y
      };
  }
  var u = r ? gf(r) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (a) {
      case Ia:
        l[u] = l[u] - (n[c] / 2 - o[c] / 2);
        break;
      case Di:
        l[u] = l[u] + (n[c] / 2 - o[c] / 2);
        break;
    }
  }
  return l;
}
function Ti(e, n) {
  n === void 0 && (n = {});
  var o = n, t = o.placement, r = t === void 0 ? e.placement : t, a = o.strategy, i = a === void 0 ? e.strategy : a, s = o.boundary, l = s === void 0 ? jC : s, u = o.rootBoundary, c = u === void 0 ? tm : u, p = o.elementContext, h = p === void 0 ? pi : p, O = o.altBoundary, C = O === void 0 ? !1 : O, P = o.padding, k = P === void 0 ? 0 : P, $ = sm(typeof k != "number" ? k : lm(k, Ni)), I = h === pi ? _C : pi, H = e.rects.popper, x = e.elements[C ? I : h], _ = dS(la(x) ? x : x.contextElement || Go(e.elements.popper), l, c, i), F = Aa(e.elements.reference), G = cm({
    reference: F,
    element: H,
    strategy: "absolute",
    placement: r
  }), Q = ld(Object.assign({}, H, G)), V = h === pi ? Q : F, ie = {
    top: _.top - V.top + $.top,
    bottom: V.bottom - _.bottom + $.bottom,
    left: _.left - V.left + $.left,
    right: V.right - _.right + $.right
  }, ce = e.modifiersData.offset;
  if (h === pi && ce) {
    var me = ce[r];
    Object.keys(ie).forEach(function(ve) {
      var U = [An, Mn].indexOf(ve) >= 0 ? 1 : -1, ee = [fn, Mn].indexOf(ve) >= 0 ? "y" : "x";
      ie[ve] += me[ee] * U;
    });
  }
  return ie;
}
function pS(e, n) {
  n === void 0 && (n = {});
  var o = n, t = o.placement, r = o.boundary, a = o.rootBoundary, i = o.padding, s = o.flipVariations, l = o.allowedAutoPlacements, u = l === void 0 ? rm : l, c = Fa(t), p = c ? s ? Gv : Gv.filter(function(C) {
    return Fa(C) === c;
  }) : Ni, h = p.filter(function(C) {
    return u.indexOf(C) >= 0;
  });
  h.length === 0 && (h = p);
  var O = h.reduce(function(C, P) {
    return C[P] = Ti(e, {
      placement: P,
      boundary: r,
      rootBoundary: a,
      padding: i
    })[so(P)], C;
  }, {});
  return Object.keys(O).sort(function(C, P) {
    return O[C] - O[P];
  });
}
function fS(e) {
  if (so(e) === pf)
    return [];
  var n = Ls(e);
  return [qv(e), n, qv(n)];
}
function vS(e) {
  var n = e.state, o = e.options, t = e.name;
  if (!n.modifiersData[t]._skip) {
    for (var r = o.mainAxis, a = r === void 0 ? !0 : r, i = o.altAxis, s = i === void 0 ? !0 : i, l = o.fallbackPlacements, u = o.padding, c = o.boundary, p = o.rootBoundary, h = o.altBoundary, O = o.flipVariations, C = O === void 0 ? !0 : O, P = o.allowedAutoPlacements, k = n.options.placement, $ = so(k), I = $ === k, H = l || (I || !C ? [Ls(k)] : fS(k)), x = [k].concat(H).reduce(function(Ge, ut) {
      return Ge.concat(so(ut) === pf ? pS(n, {
        placement: ut,
        boundary: c,
        rootBoundary: p,
        padding: u,
        flipVariations: C,
        allowedAutoPlacements: P
      }) : ut);
    }, []), _ = n.rects.reference, F = n.rects.popper, G = /* @__PURE__ */ new Map(), Q = !0, V = x[0], ie = 0; ie < x.length; ie++) {
      var ce = x[ie], me = so(ce), ve = Fa(ce) === Ia, U = [fn, Mn].indexOf(me) >= 0, ee = U ? "width" : "height", oe = Ti(n, {
        placement: ce,
        boundary: c,
        rootBoundary: p,
        altBoundary: h,
        padding: u
      }), ge = U ? ve ? An : vn : ve ? Mn : fn;
      _[ee] > F[ee] && (ge = Ls(ge));
      var be = Ls(ge), he = [];
      if (a && he.push(oe[me] <= 0), s && he.push(oe[ge] <= 0, oe[be] <= 0), he.every(function(Ge) {
        return Ge;
      })) {
        V = ce, Q = !1;
        break;
      }
      G.set(ce, he);
    }
    if (Q)
      for (var K = C ? 3 : 1, le = function(ut) {
        var ze = x.find(function(Ze) {
          var _e = G.get(Ze);
          if (_e)
            return _e.slice(0, ut).every(function(De) {
              return De;
            });
        });
        if (ze)
          return V = ze, "break";
      }, Pe = K; Pe > 0; Pe--) {
        var lt = le(Pe);
        if (lt === "break")
          break;
      }
    n.placement !== V && (n.modifiersData[t]._skip = !0, n.placement = V, n.reset = !0);
  }
}
const gS = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: vS,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Qv(e, n, o) {
  return o === void 0 && (o = {
    x: 0,
    y: 0
  }), {
    top: e.top - n.height - o.y,
    right: e.right - n.width + o.x,
    bottom: e.bottom - n.height + o.y,
    left: e.left - n.width - o.x
  };
}
function Xv(e) {
  return [fn, An, Mn, vn].some(function(n) {
    return e[n] >= 0;
  });
}
function hS(e) {
  var n = e.state, o = e.name, t = n.rects.reference, r = n.rects.popper, a = n.modifiersData.preventOverflow, i = Ti(n, {
    elementContext: "reference"
  }), s = Ti(n, {
    altBoundary: !0
  }), l = Qv(i, t), u = Qv(s, r, a), c = Xv(l), p = Xv(u);
  n.modifiersData[o] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: p
  }, n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": p
  });
}
const mS = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hS
};
function yS(e, n, o) {
  var t = so(e), r = [vn, fn].indexOf(t) >= 0 ? -1 : 1, a = typeof o == "function" ? o(Object.assign({}, n, {
    placement: e
  })) : o, i = a[0], s = a[1];
  return i = i || 0, s = (s || 0) * r, [vn, An].indexOf(t) >= 0 ? {
    x: s,
    y: i
  } : {
    x: i,
    y: s
  };
}
function bS(e) {
  var n = e.state, o = e.options, t = e.name, r = o.offset, a = r === void 0 ? [0, 0] : r, i = rm.reduce(function(c, p) {
    return c[p] = yS(p, n.rects, a), c;
  }, {}), s = i[n.placement], l = s.x, u = s.y;
  n.modifiersData.popperOffsets != null && (n.modifiersData.popperOffsets.x += l, n.modifiersData.popperOffsets.y += u), n.modifiersData[t] = i;
}
const wS = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: bS
};
function xS(e) {
  var n = e.state, o = e.name;
  n.modifiersData[o] = cm({
    reference: n.rects.reference,
    element: n.rects.popper,
    strategy: "absolute",
    placement: n.placement
  });
}
const CS = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: xS,
  data: {}
};
function SS(e) {
  return e === "x" ? "y" : "x";
}
function OS(e) {
  var n = e.state, o = e.options, t = e.name, r = o.mainAxis, a = r === void 0 ? !0 : r, i = o.altAxis, s = i === void 0 ? !1 : i, l = o.boundary, u = o.rootBoundary, c = o.altBoundary, p = o.padding, h = o.tether, O = h === void 0 ? !0 : h, C = o.tetherOffset, P = C === void 0 ? 0 : C, k = Ti(n, {
    boundary: l,
    rootBoundary: u,
    padding: p,
    altBoundary: c
  }), $ = so(n.placement), I = Fa(n.placement), H = !I, x = gf($), _ = SS(x), F = n.modifiersData.popperOffsets, G = n.rects.reference, Q = n.rects.popper, V = typeof P == "function" ? P(Object.assign({}, n.rects, {
    placement: n.placement
  })) : P, ie = typeof V == "number" ? {
    mainAxis: V,
    altAxis: V
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, V), ce = n.modifiersData.offset ? n.modifiersData.offset[n.placement] : null, me = {
    x: 0,
    y: 0
  };
  if (F) {
    if (a) {
      var ve, U = x === "y" ? fn : vn, ee = x === "y" ? Mn : An, oe = x === "y" ? "height" : "width", ge = F[x], be = ge + k[U], he = ge - k[ee], K = O ? -Q[oe] / 2 : 0, le = I === Ia ? G[oe] : Q[oe], Pe = I === Ia ? -Q[oe] : -G[oe], lt = n.elements.arrow, Ge = O && lt ? vf(lt) : {
        width: 0,
        height: 0
      }, ut = n.modifiersData["arrow#persistent"] ? n.modifiersData["arrow#persistent"].padding : im(), ze = ut[U], Ze = ut[ee], _e = Si(0, G[oe], Ge[oe]), De = H ? G[oe] / 2 - K - _e - ze - ie.mainAxis : le - _e - ze - ie.mainAxis, fe = H ? -G[oe] / 2 + K + _e + Ze + ie.mainAxis : Pe + _e + Ze + ie.mainAxis, ke = n.elements.arrow && Bi(n.elements.arrow), re = ke ? x === "y" ? ke.clientTop || 0 : ke.clientLeft || 0 : 0, tt = (ve = ce == null ? void 0 : ce[x]) != null ? ve : 0, et = ge + De - tt - re, Dt = ge + fe - tt, Kt = Si(O ? Ks(be, et) : be, ge, O ? aa(he, Dt) : he);
      F[x] = Kt, me[x] = Kt - ge;
    }
    if (s) {
      var fr, Ir = x === "x" ? fn : vn, jr = x === "x" ? Mn : An, Pr = F[_], Nr = _ === "y" ? "height" : "width", nn = Pr + k[Ir], on = Pr - k[jr], Re = [fn, vn].indexOf($) !== -1, it = (fr = ce == null ? void 0 : ce[_]) != null ? fr : 0, Qt = Re ? nn : Pr - G[Nr] - Q[Nr] - it + ie.altAxis, tr = Re ? Pr + G[Nr] + Q[Nr] - it - ie.altAxis : on, mr = O && Re ? qC(Qt, Pr, tr) : Si(O ? Qt : nn, Pr, O ? tr : on);
      F[_] = mr, me[_] = mr - Pr;
    }
    n.modifiersData[t] = me;
  }
}
const PS = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: OS,
  requiresIfExists: ["offset"]
};
function ES(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function kS(e) {
  return e === En(e) || !In(e) ? hf(e) : ES(e);
}
function RS(e) {
  var n = e.getBoundingClientRect(), o = Ma(n.width) / e.offsetWidth || 1, t = Ma(n.height) / e.offsetHeight || 1;
  return o !== 1 || t !== 1;
}
function $S(e, n, o) {
  o === void 0 && (o = !1);
  var t = In(n), r = In(n) && RS(n), a = Go(n), i = Aa(e, r, o), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (t || !t && !o) && ((po(n) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  yf(a)) && (s = kS(n)), In(n) ? (l = Aa(n, !0), l.x += n.clientLeft, l.y += n.clientTop) : a && (l.x = mf(a))), {
    x: i.left + s.scrollLeft - l.x,
    y: i.top + s.scrollTop - l.y,
    width: i.width,
    height: i.height
  };
}
function DS(e) {
  var n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set(), t = [];
  e.forEach(function(a) {
    n.set(a.name, a);
  });
  function r(a) {
    o.add(a.name);
    var i = [].concat(a.requires || [], a.requiresIfExists || []);
    i.forEach(function(s) {
      if (!o.has(s)) {
        var l = n.get(s);
        l && r(l);
      }
    }), t.push(a);
  }
  return e.forEach(function(a) {
    o.has(a.name) || r(a);
  }), t;
}
function TS(e) {
  var n = DS(e);
  return HC.reduce(function(o, t) {
    return o.concat(n.filter(function(r) {
      return r.phase === t;
    }));
  }, []);
}
function jS(e) {
  var n;
  return function() {
    return n || (n = new Promise(function(o) {
      Promise.resolve().then(function() {
        n = void 0, o(e());
      });
    })), n;
  };
}
function _S(e) {
  var n = e.reduce(function(o, t) {
    var r = o[t.name];
    return o[t.name] = r ? Object.assign({}, r, t, {
      options: Object.assign({}, r.options, t.options),
      data: Object.assign({}, r.data, t.data)
    }) : t, o;
  }, {});
  return Object.keys(n).map(function(o) {
    return n[o];
  });
}
var Jv = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Zv() {
  for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++)
    n[o] = arguments[o];
  return !n.some(function(t) {
    return !(t && typeof t.getBoundingClientRect == "function");
  });
}
function IS(e) {
  e === void 0 && (e = {});
  var n = e, o = n.defaultModifiers, t = o === void 0 ? [] : o, r = n.defaultOptions, a = r === void 0 ? Jv : r;
  return function(s, l, u) {
    u === void 0 && (u = a);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Jv, a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, p = [], h = !1, O = {
      state: c,
      setOptions: function($) {
        var I = typeof $ == "function" ? $(c.options) : $;
        P(), c.options = Object.assign({}, a, c.options, I), c.scrollParents = {
          reference: la(s) ? Oi(s) : s.contextElement ? Oi(s.contextElement) : [],
          popper: Oi(l)
        };
        var H = TS(_S([].concat(t, c.options.modifiers)));
        return c.orderedModifiers = H.filter(function(x) {
          return x.enabled;
        }), C(), O.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var $ = c.elements, I = $.reference, H = $.popper;
          if (Zv(I, H)) {
            c.rects = {
              reference: $S(I, Bi(H), c.options.strategy === "fixed"),
              popper: vf(H)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(ie) {
              return c.modifiersData[ie.name] = Object.assign({}, ie.data);
            });
            for (var x = 0; x < c.orderedModifiers.length; x++) {
              if (c.reset === !0) {
                c.reset = !1, x = -1;
                continue;
              }
              var _ = c.orderedModifiers[x], F = _.fn, G = _.options, Q = G === void 0 ? {} : G, V = _.name;
              typeof F == "function" && (c = F({
                state: c,
                options: Q,
                name: V,
                instance: O
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: jS(function() {
        return new Promise(function(k) {
          O.forceUpdate(), k(c);
        });
      }),
      destroy: function() {
        P(), h = !0;
      }
    };
    if (!Zv(s, l))
      return O;
    O.setOptions(u).then(function(k) {
      !h && u.onFirstUpdate && u.onFirstUpdate(k);
    });
    function C() {
      c.orderedModifiers.forEach(function(k) {
        var $ = k.name, I = k.options, H = I === void 0 ? {} : I, x = k.effect;
        if (typeof x == "function") {
          var _ = x({
            state: c,
            name: $,
            instance: O,
            options: H
          }), F = function() {
          };
          p.push(_ || F);
        }
      });
    }
    function P() {
      p.forEach(function(k) {
        return k();
      }), p = [];
    }
    return O;
  };
}
var MS = [oS, CS, rS, nm, wS, gS, PS, JC, mS], dm = /* @__PURE__ */ IS({
  defaultModifiers: MS
}), AS = "tippy-box", pm = "tippy-content", FS = "tippy-backdrop", fm = "tippy-arrow", vm = "tippy-svg-arrow", ea = {
  passive: !0,
  capture: !0
}, gm = function() {
  return document.body;
};
function LS(e, n) {
  return {}.hasOwnProperty.call(e, n);
}
function Pu(e, n, o) {
  if (Array.isArray(e)) {
    var t = e[n];
    return t ?? (Array.isArray(o) ? o[n] : o);
  }
  return e;
}
function bf(e, n) {
  var o = {}.toString.call(e);
  return o.indexOf("[object") === 0 && o.indexOf(n + "]") > -1;
}
function hm(e, n) {
  return typeof e == "function" ? e.apply(void 0, n) : e;
}
function eg(e, n) {
  if (n === 0)
    return e;
  var o;
  return function(t) {
    clearTimeout(o), o = setTimeout(function() {
      e(t);
    }, n);
  };
}
function NS(e, n) {
  var o = Object.assign({}, e);
  return n.forEach(function(t) {
    delete o[t];
  }), o;
}
function BS(e) {
  return e.split(/\s+/).filter(Boolean);
}
function Ra(e) {
  return [].concat(e);
}
function tg(e, n) {
  e.indexOf(n) === -1 && e.push(n);
}
function WS(e) {
  return e.filter(function(n, o) {
    return e.indexOf(n) === o;
  });
}
function zS(e) {
  return e.split("-")[0];
}
function Qs(e) {
  return [].slice.call(e);
}
function rg(e) {
  return Object.keys(e).reduce(function(n, o) {
    return e[o] !== void 0 && (n[o] = e[o]), n;
  }, {});
}
function Pi() {
  return document.createElement("div");
}
function ji(e) {
  return ["Element", "Fragment"].some(function(n) {
    return bf(e, n);
  });
}
function HS(e) {
  return bf(e, "NodeList");
}
function YS(e) {
  return bf(e, "MouseEvent");
}
function GS(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function VS(e) {
  return ji(e) ? [e] : HS(e) ? Qs(e) : Array.isArray(e) ? e : Qs(document.querySelectorAll(e));
}
function Eu(e, n) {
  e.forEach(function(o) {
    o && (o.style.transitionDuration = n + "ms");
  });
}
function ng(e, n) {
  e.forEach(function(o) {
    o && o.setAttribute("data-state", n);
  });
}
function US(e) {
  var n, o = Ra(e), t = o[0];
  return t != null && (n = t.ownerDocument) != null && n.body ? t.ownerDocument : document;
}
function qS(e, n) {
  var o = n.clientX, t = n.clientY;
  return e.every(function(r) {
    var a = r.popperRect, i = r.popperState, s = r.props, l = s.interactiveBorder, u = zS(i.placement), c = i.modifiersData.offset;
    if (!c)
      return !0;
    var p = u === "bottom" ? c.top.y : 0, h = u === "top" ? c.bottom.y : 0, O = u === "right" ? c.left.x : 0, C = u === "left" ? c.right.x : 0, P = a.top - t + p > l, k = t - a.bottom - h > l, $ = a.left - o + O > l, I = o - a.right - C > l;
    return P || k || $ || I;
  });
}
function ku(e, n, o) {
  var t = n + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(r) {
    e[t](r, o);
  });
}
function og(e, n) {
  for (var o = n; o; ) {
    var t;
    if (e.contains(o))
      return !0;
    o = o.getRootNode == null || (t = o.getRootNode()) == null ? void 0 : t.host;
  }
  return !1;
}
var ro = {
  isTouch: !1
}, ag = 0;
function KS() {
  ro.isTouch || (ro.isTouch = !0, window.performance && document.addEventListener("mousemove", mm));
}
function mm() {
  var e = performance.now();
  e - ag < 20 && (ro.isTouch = !1, document.removeEventListener("mousemove", mm)), ag = e;
}
function QS() {
  var e = document.activeElement;
  if (GS(e)) {
    var n = e._tippy;
    e.blur && !n.state.isVisible && e.blur();
  }
}
function XS() {
  document.addEventListener("touchstart", KS, ea), window.addEventListener("blur", QS);
}
var JS = typeof window < "u" && typeof document < "u", ZS = JS ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function Oa(e) {
  var n = e === "destroy" ? "n already-" : " ";
  return [e + "() was called on a" + n + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function ig(e) {
  var n = /[ \t]{2,}/g, o = /^[ \t]*/gm;
  return e.replace(n, " ").replace(o, "").trim();
}
function eO(e) {
  return ig(`
  %ctippy.js

  %c` + ig(e) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function ym(e) {
  return [
    eO(e),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var _i;
process.env.NODE_ENV !== "production" && tO();
function tO() {
  _i = /* @__PURE__ */ new Set();
}
function ho(e, n) {
  if (e && !_i.has(n)) {
    var o;
    _i.add(n), (o = console).warn.apply(o, ym(n));
  }
}
function ud(e, n) {
  if (e && !_i.has(n)) {
    var o;
    _i.add(n), (o = console).error.apply(o, ym(n));
  }
}
function rO(e) {
  var n = !e, o = Object.prototype.toString.call(e) === "[object Object]" && !e.addEventListener;
  ud(n, ["tippy() was passed", "`" + String(e) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), ud(o, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var bm = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, nO = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Cn = Object.assign({
  appendTo: gm,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, bm, nO), oO = Object.keys(Cn), aO = function(n) {
  process.env.NODE_ENV !== "production" && xm(n, []);
  var o = Object.keys(n);
  o.forEach(function(t) {
    Cn[t] = n[t];
  });
};
function wm(e) {
  var n = e.plugins || [], o = n.reduce(function(t, r) {
    var a = r.name, i = r.defaultValue;
    if (a) {
      var s;
      t[a] = e[a] !== void 0 ? e[a] : (s = Cn[a]) != null ? s : i;
    }
    return t;
  }, {});
  return Object.assign({}, e, o);
}
function iO(e, n) {
  var o = n ? Object.keys(wm(Object.assign({}, Cn, {
    plugins: n
  }))) : oO, t = o.reduce(function(r, a) {
    var i = (e.getAttribute("data-tippy-" + a) || "").trim();
    if (!i)
      return r;
    if (a === "content")
      r[a] = i;
    else
      try {
        r[a] = JSON.parse(i);
      } catch {
        r[a] = i;
      }
    return r;
  }, {});
  return t;
}
function sg(e, n) {
  var o = Object.assign({}, n, {
    content: hm(n.content, [e])
  }, n.ignoreAttributes ? {} : iO(e, n.plugins));
  return o.aria = Object.assign({}, Cn.aria, o.aria), o.aria = {
    expanded: o.aria.expanded === "auto" ? n.interactive : o.aria.expanded,
    content: o.aria.content === "auto" ? n.interactive ? null : "describedby" : o.aria.content
  }, o;
}
function xm(e, n) {
  e === void 0 && (e = {}), n === void 0 && (n = []);
  var o = Object.keys(e);
  o.forEach(function(t) {
    var r = NS(Cn, Object.keys(bm)), a = !LS(r, t);
    a && (a = n.filter(function(i) {
      return i.name === t;
    }).length === 0), ho(a, ["`" + t + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var sO = function() {
  return "innerHTML";
};
function cd(e, n) {
  e[sO()] = n;
}
function lg(e) {
  var n = Pi();
  return e === !0 ? n.className = fm : (n.className = vm, ji(e) ? n.appendChild(e) : cd(n, e)), n;
}
function ug(e, n) {
  ji(n.content) ? (cd(e, ""), e.appendChild(n.content)) : typeof n.content != "function" && (n.allowHTML ? cd(e, n.content) : e.textContent = n.content);
}
function dd(e) {
  var n = e.firstElementChild, o = Qs(n.children);
  return {
    box: n,
    content: o.find(function(t) {
      return t.classList.contains(pm);
    }),
    arrow: o.find(function(t) {
      return t.classList.contains(fm) || t.classList.contains(vm);
    }),
    backdrop: o.find(function(t) {
      return t.classList.contains(FS);
    })
  };
}
function Cm(e) {
  var n = Pi(), o = Pi();
  o.className = AS, o.setAttribute("data-state", "hidden"), o.setAttribute("tabindex", "-1");
  var t = Pi();
  t.className = pm, t.setAttribute("data-state", "hidden"), ug(t, e.props), n.appendChild(o), o.appendChild(t), r(e.props, e.props);
  function r(a, i) {
    var s = dd(n), l = s.box, u = s.content, c = s.arrow;
    i.theme ? l.setAttribute("data-theme", i.theme) : l.removeAttribute("data-theme"), typeof i.animation == "string" ? l.setAttribute("data-animation", i.animation) : l.removeAttribute("data-animation"), i.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof i.maxWidth == "number" ? i.maxWidth + "px" : i.maxWidth, i.role ? l.setAttribute("role", i.role) : l.removeAttribute("role"), (a.content !== i.content || a.allowHTML !== i.allowHTML) && ug(u, e.props), i.arrow ? c ? a.arrow !== i.arrow && (l.removeChild(c), l.appendChild(lg(i.arrow))) : l.appendChild(lg(i.arrow)) : c && l.removeChild(c);
  }
  return {
    popper: n,
    onUpdate: r
  };
}
Cm.$$tippy = !0;
var lO = 1, Es = [], Ru = [];
function uO(e, n) {
  var o = sg(e, Object.assign({}, Cn, wm(rg(n)))), t, r, a, i = !1, s = !1, l = !1, u = !1, c, p, h, O = [], C = eg(et, o.interactiveDebounce), P, k = lO++, $ = null, I = WS(o.plugins), H = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, x = {
    // properties
    id: k,
    reference: e,
    popper: Pi(),
    popperInstance: $,
    props: o,
    state: H,
    plugins: I,
    // methods
    clearDelayTimeouts: Qt,
    setProps: tr,
    setContent: mr,
    show: dn,
    hide: an,
    hideWithInteractivity: hn,
    enable: Re,
    disable: it,
    unmount: Wn,
    destroy: zn
  };
  if (!o.render)
    return process.env.NODE_ENV !== "production" && ud(!0, "render() function has not been supplied."), x;
  var _ = o.render(x), F = _.popper, G = _.onUpdate;
  F.setAttribute("data-tippy-root", ""), F.id = "tippy-" + x.id, x.popper = F, e._tippy = x, F._tippy = x;
  var Q = I.map(function(Z) {
    return Z.fn(x);
  }), V = e.hasAttribute("aria-expanded");
  return ke(), K(), ge(), be("onCreate", [x]), o.showOnCreate && nn(), F.addEventListener("mouseenter", function() {
    x.props.interactive && x.state.isVisible && x.clearDelayTimeouts();
  }), F.addEventListener("mouseleave", function() {
    x.props.interactive && x.props.trigger.indexOf("mouseenter") >= 0 && U().addEventListener("mousemove", C);
  }), x;
  function ie() {
    var Z = x.props.touch;
    return Array.isArray(Z) ? Z : [Z, 0];
  }
  function ce() {
    return ie()[0] === "hold";
  }
  function me() {
    var Z;
    return !!((Z = x.props.render) != null && Z.$$tippy);
  }
  function ve() {
    return P || e;
  }
  function U() {
    var Z = ve().parentNode;
    return Z ? US(Z) : document;
  }
  function ee() {
    return dd(F);
  }
  function oe(Z) {
    return x.state.isMounted && !x.state.isVisible || ro.isTouch || c && c.type === "focus" ? 0 : Pu(x.props.delay, Z ? 0 : 1, Cn.delay);
  }
  function ge(Z) {
    Z === void 0 && (Z = !1), F.style.pointerEvents = x.props.interactive && !Z ? "" : "none", F.style.zIndex = "" + x.props.zIndex;
  }
  function be(Z, Ve, ct) {
    if (ct === void 0 && (ct = !0), Q.forEach(function(Et) {
      Et[Z] && Et[Z].apply(Et, Ve);
    }), ct) {
      var Mt;
      (Mt = x.props)[Z].apply(Mt, Ve);
    }
  }
  function he() {
    var Z = x.props.aria;
    if (Z.content) {
      var Ve = "aria-" + Z.content, ct = F.id, Mt = Ra(x.props.triggerTarget || e);
      Mt.forEach(function(Et) {
        var vr = Et.getAttribute(Ve);
        if (x.state.isVisible)
          Et.setAttribute(Ve, vr ? vr + " " + ct : ct);
        else {
          var Rr = vr && vr.replace(ct, "").trim();
          Rr ? Et.setAttribute(Ve, Rr) : Et.removeAttribute(Ve);
        }
      });
    }
  }
  function K() {
    if (!(V || !x.props.aria.expanded)) {
      var Z = Ra(x.props.triggerTarget || e);
      Z.forEach(function(Ve) {
        x.props.interactive ? Ve.setAttribute("aria-expanded", x.state.isVisible && Ve === ve() ? "true" : "false") : Ve.removeAttribute("aria-expanded");
      });
    }
  }
  function le() {
    U().removeEventListener("mousemove", C), Es = Es.filter(function(Z) {
      return Z !== C;
    });
  }
  function Pe(Z) {
    if (!(ro.isTouch && (l || Z.type === "mousedown"))) {
      var Ve = Z.composedPath && Z.composedPath()[0] || Z.target;
      if (!(x.props.interactive && og(F, Ve))) {
        if (Ra(x.props.triggerTarget || e).some(function(ct) {
          return og(ct, Ve);
        })) {
          if (ro.isTouch || x.state.isVisible && x.props.trigger.indexOf("click") >= 0)
            return;
        } else
          be("onClickOutside", [x, Z]);
        x.props.hideOnClick === !0 && (x.clearDelayTimeouts(), x.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), x.state.isMounted || ze());
      }
    }
  }
  function lt() {
    l = !0;
  }
  function Ge() {
    l = !1;
  }
  function ut() {
    var Z = U();
    Z.addEventListener("mousedown", Pe, !0), Z.addEventListener("touchend", Pe, ea), Z.addEventListener("touchstart", Ge, ea), Z.addEventListener("touchmove", lt, ea);
  }
  function ze() {
    var Z = U();
    Z.removeEventListener("mousedown", Pe, !0), Z.removeEventListener("touchend", Pe, ea), Z.removeEventListener("touchstart", Ge, ea), Z.removeEventListener("touchmove", lt, ea);
  }
  function Ze(Z, Ve) {
    De(Z, function() {
      !x.state.isVisible && F.parentNode && F.parentNode.contains(F) && Ve();
    });
  }
  function _e(Z, Ve) {
    De(Z, Ve);
  }
  function De(Z, Ve) {
    var ct = ee().box;
    function Mt(Et) {
      Et.target === ct && (ku(ct, "remove", Mt), Ve());
    }
    if (Z === 0)
      return Ve();
    ku(ct, "remove", p), ku(ct, "add", Mt), p = Mt;
  }
  function fe(Z, Ve, ct) {
    ct === void 0 && (ct = !1);
    var Mt = Ra(x.props.triggerTarget || e);
    Mt.forEach(function(Et) {
      Et.addEventListener(Z, Ve, ct), O.push({
        node: Et,
        eventType: Z,
        handler: Ve,
        options: ct
      });
    });
  }
  function ke() {
    ce() && (fe("touchstart", tt, {
      passive: !0
    }), fe("touchend", Dt, {
      passive: !0
    })), BS(x.props.trigger).forEach(function(Z) {
      if (Z !== "manual")
        switch (fe(Z, tt), Z) {
          case "mouseenter":
            fe("mouseleave", Dt);
            break;
          case "focus":
            fe(ZS ? "focusout" : "blur", Kt);
            break;
          case "focusin":
            fe("focusout", Kt);
            break;
        }
    });
  }
  function re() {
    O.forEach(function(Z) {
      var Ve = Z.node, ct = Z.eventType, Mt = Z.handler, Et = Z.options;
      Ve.removeEventListener(ct, Mt, Et);
    }), O = [];
  }
  function tt(Z) {
    var Ve, ct = !1;
    if (!(!x.state.isEnabled || fr(Z) || s)) {
      var Mt = ((Ve = c) == null ? void 0 : Ve.type) === "focus";
      c = Z, P = Z.currentTarget, K(), !x.state.isVisible && YS(Z) && Es.forEach(function(Et) {
        return Et(Z);
      }), Z.type === "click" && (x.props.trigger.indexOf("mouseenter") < 0 || i) && x.props.hideOnClick !== !1 && x.state.isVisible ? ct = !0 : nn(Z), Z.type === "click" && (i = !ct), ct && !Mt && on(Z);
    }
  }
  function et(Z) {
    var Ve = Z.target, ct = ve().contains(Ve) || F.contains(Ve);
    if (!(Z.type === "mousemove" && ct)) {
      var Mt = Nr().concat(F).map(function(Et) {
        var vr, Rr = Et._tippy, Br = (vr = Rr.popperInstance) == null ? void 0 : vr.state;
        return Br ? {
          popperRect: Et.getBoundingClientRect(),
          popperState: Br,
          props: o
        } : null;
      }).filter(Boolean);
      qS(Mt, Z) && (le(), on(Z));
    }
  }
  function Dt(Z) {
    var Ve = fr(Z) || x.props.trigger.indexOf("click") >= 0 && i;
    if (!Ve) {
      if (x.props.interactive) {
        x.hideWithInteractivity(Z);
        return;
      }
      on(Z);
    }
  }
  function Kt(Z) {
    x.props.trigger.indexOf("focusin") < 0 && Z.target !== ve() || x.props.interactive && Z.relatedTarget && F.contains(Z.relatedTarget) || on(Z);
  }
  function fr(Z) {
    return ro.isTouch ? ce() !== Z.type.indexOf("touch") >= 0 : !1;
  }
  function Ir() {
    jr();
    var Z = x.props, Ve = Z.popperOptions, ct = Z.placement, Mt = Z.offset, Et = Z.getReferenceClientRect, vr = Z.moveTransition, Rr = me() ? dd(F).arrow : null, Br = Et ? {
      getBoundingClientRect: Et,
      contextElement: Et.contextElement || ve()
    } : e, Hn = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Yn) {
        var mn = Yn.state;
        if (me()) {
          var Eo = ee(), $n = Eo.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Dn) {
            Dn === "placement" ? $n.setAttribute("data-placement", mn.placement) : mn.attributes.popper["data-popper-" + Dn] ? $n.setAttribute("data-" + Dn, "") : $n.removeAttribute("data-" + Dn);
          }), mn.attributes.popper = {};
        }
      }
    }, Zr = [{
      name: "offset",
      options: {
        offset: Mt
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !vr
      }
    }, Hn];
    me() && Rr && Zr.push({
      name: "arrow",
      options: {
        element: Rr,
        padding: 3
      }
    }), Zr.push.apply(Zr, (Ve == null ? void 0 : Ve.modifiers) || []), x.popperInstance = dm(Br, F, Object.assign({}, Ve, {
      placement: ct,
      onFirstUpdate: h,
      modifiers: Zr
    }));
  }
  function jr() {
    x.popperInstance && (x.popperInstance.destroy(), x.popperInstance = null);
  }
  function Pr() {
    var Z = x.props.appendTo, Ve, ct = ve();
    x.props.interactive && Z === gm || Z === "parent" ? Ve = ct.parentNode : Ve = hm(Z, [ct]), Ve.contains(F) || Ve.appendChild(F), x.state.isMounted = !0, Ir(), process.env.NODE_ENV !== "production" && ho(x.props.interactive && Z === Cn.appendTo && ct.nextElementSibling !== F, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function Nr() {
    return Qs(F.querySelectorAll("[data-tippy-root]"));
  }
  function nn(Z) {
    x.clearDelayTimeouts(), Z && be("onTrigger", [x, Z]), ut();
    var Ve = oe(!0), ct = ie(), Mt = ct[0], Et = ct[1];
    ro.isTouch && Mt === "hold" && Et && (Ve = Et), Ve ? t = setTimeout(function() {
      x.show();
    }, Ve) : x.show();
  }
  function on(Z) {
    if (x.clearDelayTimeouts(), be("onUntrigger", [x, Z]), !x.state.isVisible) {
      ze();
      return;
    }
    if (!(x.props.trigger.indexOf("mouseenter") >= 0 && x.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(Z.type) >= 0 && i)) {
      var Ve = oe(!1);
      Ve ? r = setTimeout(function() {
        x.state.isVisible && x.hide();
      }, Ve) : a = requestAnimationFrame(function() {
        x.hide();
      });
    }
  }
  function Re() {
    x.state.isEnabled = !0;
  }
  function it() {
    x.hide(), x.state.isEnabled = !1;
  }
  function Qt() {
    clearTimeout(t), clearTimeout(r), cancelAnimationFrame(a);
  }
  function tr(Z) {
    if (process.env.NODE_ENV !== "production" && ho(x.state.isDestroyed, Oa("setProps")), !x.state.isDestroyed) {
      be("onBeforeUpdate", [x, Z]), re();
      var Ve = x.props, ct = sg(e, Object.assign({}, Ve, rg(Z), {
        ignoreAttributes: !0
      }));
      x.props = ct, ke(), Ve.interactiveDebounce !== ct.interactiveDebounce && (le(), C = eg(et, ct.interactiveDebounce)), Ve.triggerTarget && !ct.triggerTarget ? Ra(Ve.triggerTarget).forEach(function(Mt) {
        Mt.removeAttribute("aria-expanded");
      }) : ct.triggerTarget && e.removeAttribute("aria-expanded"), K(), ge(), G && G(Ve, ct), x.popperInstance && (Ir(), Nr().forEach(function(Mt) {
        requestAnimationFrame(Mt._tippy.popperInstance.forceUpdate);
      })), be("onAfterUpdate", [x, Z]);
    }
  }
  function mr(Z) {
    x.setProps({
      content: Z
    });
  }
  function dn() {
    process.env.NODE_ENV !== "production" && ho(x.state.isDestroyed, Oa("show"));
    var Z = x.state.isVisible, Ve = x.state.isDestroyed, ct = !x.state.isEnabled, Mt = ro.isTouch && !x.props.touch, Et = Pu(x.props.duration, 0, Cn.duration);
    if (!(Z || Ve || ct || Mt) && !ve().hasAttribute("disabled") && (be("onShow", [x], !1), x.props.onShow(x) !== !1)) {
      if (x.state.isVisible = !0, me() && (F.style.visibility = "visible"), ge(), ut(), x.state.isMounted || (F.style.transition = "none"), me()) {
        var vr = ee(), Rr = vr.box, Br = vr.content;
        Eu([Rr, Br], 0);
      }
      h = function() {
        var Zr;
        if (!(!x.state.isVisible || u)) {
          if (u = !0, F.offsetHeight, F.style.transition = x.props.moveTransition, me() && x.props.animation) {
            var pn = ee(), Yn = pn.box, mn = pn.content;
            Eu([Yn, mn], Et), ng([Yn, mn], "visible");
          }
          he(), K(), tg(Ru, x), (Zr = x.popperInstance) == null || Zr.forceUpdate(), be("onMount", [x]), x.props.animation && me() && _e(Et, function() {
            x.state.isShown = !0, be("onShown", [x]);
          });
        }
      }, Pr();
    }
  }
  function an() {
    process.env.NODE_ENV !== "production" && ho(x.state.isDestroyed, Oa("hide"));
    var Z = !x.state.isVisible, Ve = x.state.isDestroyed, ct = !x.state.isEnabled, Mt = Pu(x.props.duration, 1, Cn.duration);
    if (!(Z || Ve || ct) && (be("onHide", [x], !1), x.props.onHide(x) !== !1)) {
      if (x.state.isVisible = !1, x.state.isShown = !1, u = !1, i = !1, me() && (F.style.visibility = "hidden"), le(), ze(), ge(!0), me()) {
        var Et = ee(), vr = Et.box, Rr = Et.content;
        x.props.animation && (Eu([vr, Rr], Mt), ng([vr, Rr], "hidden"));
      }
      he(), K(), x.props.animation ? me() && Ze(Mt, x.unmount) : x.unmount();
    }
  }
  function hn(Z) {
    process.env.NODE_ENV !== "production" && ho(x.state.isDestroyed, Oa("hideWithInteractivity")), U().addEventListener("mousemove", C), tg(Es, C), C(Z);
  }
  function Wn() {
    process.env.NODE_ENV !== "production" && ho(x.state.isDestroyed, Oa("unmount")), x.state.isVisible && x.hide(), x.state.isMounted && (jr(), Nr().forEach(function(Z) {
      Z._tippy.unmount();
    }), F.parentNode && F.parentNode.removeChild(F), Ru = Ru.filter(function(Z) {
      return Z !== x;
    }), x.state.isMounted = !1, be("onHidden", [x]));
  }
  function zn() {
    process.env.NODE_ENV !== "production" && ho(x.state.isDestroyed, Oa("destroy")), !x.state.isDestroyed && (x.clearDelayTimeouts(), x.unmount(), re(), delete e._tippy, x.state.isDestroyed = !0, be("onDestroy", [x]));
  }
}
function Wi(e, n) {
  n === void 0 && (n = {});
  var o = Cn.plugins.concat(n.plugins || []);
  process.env.NODE_ENV !== "production" && (rO(e), xm(n, o)), XS();
  var t = Object.assign({}, n, {
    plugins: o
  }), r = VS(e);
  if (process.env.NODE_ENV !== "production") {
    var a = ji(t.content), i = r.length > 1;
    ho(a && i, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = r.reduce(function(l, u) {
    var c = u && uO(u, t);
    return c && l.push(c), l;
  }, []);
  return ji(e) ? s[0] : s;
}
Wi.defaultProps = Cn;
Wi.setDefaultProps = aO;
Wi.currentInput = ro;
Object.assign({}, nm, {
  effect: function(n) {
    var o = n.state, t = {
      popper: {
        position: o.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(o.elements.popper.style, t.popper), o.styles = t, o.elements.arrow && Object.assign(o.elements.arrow.style, t.arrow);
  }
});
Wi.setDefaultProps({
  render: Cm
});
function Sm(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var Om = typeof window < "u" && typeof document < "u";
function pd(e, n) {
  e && (typeof e == "function" && e(n), {}.hasOwnProperty.call(e, "current") && (e.current = n));
}
function cg() {
  return Om && document.createElement("div");
}
function cO(e) {
  var n = {
    "data-placement": e.placement
  };
  return e.referenceHidden && (n["data-reference-hidden"] = ""), e.escaped && (n["data-escaped"] = ""), n;
}
function Pm(e, n) {
  if (e === n)
    return !0;
  if (typeof e == "object" && e != null && typeof n == "object" && n != null) {
    if (Object.keys(e).length !== Object.keys(n).length)
      return !1;
    for (var o in e)
      if (n.hasOwnProperty(o)) {
        if (!Pm(e[o], n[o]))
          return !1;
      } else
        return !1;
    return !0;
  } else
    return !1;
}
function dO(e) {
  var n = [];
  return e.forEach(function(o) {
    n.find(function(t) {
      return Pm(o, t);
    }) || n.push(o);
  }), n;
}
function pO(e, n) {
  var o, t;
  return Object.assign({}, n, {
    popperOptions: Object.assign({}, e.popperOptions, n.popperOptions, {
      modifiers: dO([].concat(((o = e.popperOptions) == null ? void 0 : o.modifiers) || [], ((t = n.popperOptions) == null ? void 0 : t.modifiers) || []))
    })
  });
}
var $u = Om ? Kd : Nt;
function fO(e) {
  var n = St();
  return n.current || (n.current = typeof e == "function" ? e() : e), n.current;
}
function dg(e, n, o) {
  o.split(/\s+/).forEach(function(t) {
    t && e.classList[n](t);
  });
}
var vO = {
  name: "className",
  defaultValue: "",
  fn: function(n) {
    var o = n.popper.firstElementChild, t = function() {
      var s;
      return !!((s = n.props.render) != null && s.$$tippy);
    };
    function r() {
      if (n.props.className && !t()) {
        process.env.NODE_ENV !== "production" && console.warn(["@tippyjs/react: Cannot use `className` prop in conjunction with", "`render` prop. Place the className on the element you are", "rendering."].join(" "));
        return;
      }
      dg(o, "add", n.props.className);
    }
    function a() {
      t() && dg(o, "remove", n.props.className);
    }
    return {
      onCreate: r,
      onBeforeUpdate: a,
      onAfterUpdate: r
    };
  }
};
function gO(e) {
  function n(o) {
    var t = o.children, r = o.content, a = o.visible, i = o.singleton, s = o.render, l = o.reference, u = o.disabled, c = u === void 0 ? !1 : u, p = o.ignoreAttributes, h = p === void 0 ? !0 : p;
    o.__source, o.__self;
    var O = Sm(o, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]), C = a !== void 0, P = i !== void 0, k = ur(!1), $ = k[0], I = k[1], H = ur({}), x = H[0], _ = H[1], F = ur(), G = F[0], Q = F[1], V = fO(function() {
      return {
        container: cg(),
        renders: 1
      };
    }), ie = Object.assign({
      ignoreAttributes: h
    }, O, {
      content: V.container
    });
    C && (process.env.NODE_ENV !== "production" && ["trigger", "hideOnClick", "showOnCreate"].forEach(function(U) {
      ie[U] !== void 0 && console.warn(["@tippyjs/react: Cannot specify `" + U + "` prop in", "controlled mode (`visible` prop)"].join(" "));
    }), ie.trigger = "manual", ie.hideOnClick = !1), P && (c = !0);
    var ce = ie, me = ie.plugins || [];
    s && (ce = Object.assign({}, ie, {
      plugins: P && i.data != null ? [].concat(me, [{
        fn: function() {
          return {
            onTrigger: function(oe, ge) {
              var be = i.data.children.find(function(he) {
                var K = he.instance;
                return K.reference === ge.currentTarget;
              });
              oe.state.$$activeSingletonInstance = be.instance, Q(be.content);
            }
          };
        }
      }]) : me,
      render: function() {
        return {
          popper: V.container
        };
      }
    }));
    var ve = [l].concat(t ? [t.type] : []);
    return $u(function() {
      var U = l;
      l && l.hasOwnProperty("current") && (U = l.current);
      var ee = e(U || V.ref || cg(), Object.assign({}, ce, {
        plugins: [vO].concat(ie.plugins || [])
      }));
      return V.instance = ee, c && ee.disable(), a && ee.show(), P && i.hook({
        instance: ee,
        content: r,
        props: ce,
        setSingletonContent: Q
      }), I(!0), function() {
        ee.destroy(), i == null || i.cleanup(ee);
      };
    }, ve), $u(function() {
      var U;
      if (V.renders === 1) {
        V.renders++;
        return;
      }
      var ee = V.instance;
      ee.setProps(pO(ee.props, ce)), (U = ee.popperInstance) == null || U.forceUpdate(), c ? ee.disable() : ee.enable(), C && (a ? ee.show() : ee.hide()), P && i.hook({
        instance: ee,
        content: r,
        props: ce,
        setSingletonContent: Q
      });
    }), $u(function() {
      var U;
      if (s) {
        var ee = V.instance;
        ee.setProps({
          popperOptions: Object.assign({}, ee.props.popperOptions, {
            modifiers: [].concat((((U = ee.props.popperOptions) == null ? void 0 : U.modifiers) || []).filter(function(oe) {
              var ge = oe.name;
              return ge !== "$$tippyReact";
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function(ge) {
                var be, he = ge.state, K = (be = he.modifiersData) == null ? void 0 : be.hide;
                (x.placement !== he.placement || x.referenceHidden !== (K == null ? void 0 : K.isReferenceHidden) || x.escaped !== (K == null ? void 0 : K.hasPopperEscaped)) && _({
                  placement: he.placement,
                  referenceHidden: K == null ? void 0 : K.isReferenceHidden,
                  escaped: K == null ? void 0 : K.hasPopperEscaped
                }), he.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [x.placement, x.referenceHidden, x.escaped].concat(ve)), /* @__PURE__ */ y.createElement(y.Fragment, null, t ? /* @__PURE__ */ Qd(t, {
      ref: function(ee) {
        V.ref = ee, pd(t.ref, ee);
      }
    }) : null, $ && /* @__PURE__ */ _h(s ? s(cO(x), G, V.instance) : r, V.container));
  }
  return n;
}
var hO = function(e, n) {
  return /* @__PURE__ */ Ye(function(t, r) {
    var a = t.children, i = Sm(t, ["children"]);
    return (
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      /* @__PURE__ */ y.createElement(e, Object.assign({}, n, i), a ? /* @__PURE__ */ Qd(a, {
        ref: function(l) {
          pd(r, l), pd(a.ref, l);
        }
      }) : null)
    );
  });
}, mO = /* @__PURE__ */ hO(/* @__PURE__ */ gO(Wi));
const yO = mO;
const bO = {
  name: "hideOnEsc",
  defaultValue: !0,
  fn: ({ hide: e }) => {
    const n = (o) => {
      o.key === "Escape" && e();
    };
    return {
      onShow() {
        document.addEventListener("keydown", n);
      },
      onHide() {
        document.removeEventListener("keydown", n);
      }
    };
  }
}, Em = ({
  isInteractive: e = !0,
  appendTo: n = "parent",
  isDisabled: o = !1,
  target: t,
  ...r
}) => {
  const a = qd();
  return /* @__PURE__ */ g.jsx(
    wO,
    {
      animation: !1,
      maxWidth: a.measure.s,
      disabled: o,
      interactive: e,
      appendTo: n === "body" ? document.body : "parent",
      plugins: [bO],
      ...r,
      children: t
    }
  );
}, wO = Y(yO)(
  ({ theme: e }) => `
  &.tippy-box {
    ${Nn(e).body}
    background-color: ${e.color.white};
    border-radius: ${e.borderRadius.m};
    filter: drop-shadow(${e.shadow});
  }

  .tippy-content {
    padding: 0px;
    text-align: left;
  }

  .tippy-arrow {
    color: ${e.color.white};
  }
`
), El = ({ content: e, ...n }) => /* @__PURE__ */ g.jsx(
  Em,
  {
    content: /* @__PURE__ */ g.jsx(xO, { children: e }),
    ...n
  }
), xO = Y.div(
  ({ theme: e }) => `
  ${Nn(e).body}
  padding: ${e.spacing.s} ${e.spacing.m};
`
), wf = ({ className: e, size: n, trackingId: o }) => /* @__PURE__ */ g.jsx(
  OO,
  {
    role: "status",
    "aria-live": "polite",
    className: e,
    size: n,
    trackingId: o,
    children: /* @__PURE__ */ g.jsx(km, { "aria-label": "Loading" })
  }
), CO = Tb`
  to { transform: rotate(360deg) }
`, SO = hl`
  border-radius: ${({ theme: e }) => e.borderRadius.round};
  animation: 0.8s linear infinite ${CO};
  border-style: solid;
  border-color: currentColor;
  border-right-color: transparent;
`, OO = pa(
  Y.div(
    ({ theme: e, size: n = "l" }) => hl`
      color: ${e.color.primary};
      width: ${e.sizing[n]};
      height: ${e.sizing[n]};
    `
  )
), km = Y.div(
  ({ theme: e }) => hl`
    ${SO}
    border-width: ${e.borderWidth.l};
    width: 100%;
    height: 100%;
  `
), kl = Y(wf)(
  ({ theme: e }) => `
    display: inline-block;
    color: currentColor;
    width: ${co(e)};
    height: ${co(e)};

    ${km} {
      border-width: ${e.borderWidth.m};
    }
  `
), La = Ye(
  ({
    variant: e = "button-primary",
    size: n = "default",
    iconName: o,
    iconPlacement: t = "left",
    isLoading: r = !1,
    loadingText: a,
    isDisabled: i = !1,
    label: s,
    type: l = "button",
    onClick: u,
    tooltipProps: c,
    utilityElement: p,
    shouldSeparateUtilityElement: h,
    isRoundElement: O = !1,
    ...C
  }, P) => {
    const k = {
      iconName: o,
      iconPlacement: t,
      label: s,
      utilityElement: p,
      shouldSeparateUtilityElement: h
    }, $ = Ga(u), [I, H] = (() => r ? [
      !0,
      /* @__PURE__ */ g.jsxs(Sl, { children: [
        /* @__PURE__ */ g.jsx(kl, {}),
        a && /* @__PURE__ */ g.jsx("span", { children: a })
      ] })
    ] : [i, /* @__PURE__ */ g.jsx(Qh, { ...k })])(), x = /* @__PURE__ */ g.jsx(
      Na,
      {
        ...C,
        variant: e,
        size: n,
        disabled: I,
        ref: P,
        type: l,
        onClick: $,
        children: H
      }
    );
    return c ? /* @__PURE__ */ g.jsx(
      El,
      {
        ...c,
        target: (
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          i ? /* @__PURE__ */ g.jsx(
            PO,
            {
              variant: e,
              tabIndex: 0,
              isRoundElement: O,
              children: x
            }
          ) : x
        ),
        touch: i
      }
    ) : x;
  }
), PO = Y.div.withConfig({
  shouldForwardProp: (e) => !["variant", "isRoundElement"].includes(e)
})(
  ({ theme: e, variant: n, isRoundElement: o }) => `
  display: inline-flex;
  height: min-content;

  ${Na} {
    flex: 1;
  }

  &:focus-visible {
    outline: none;
    border-radius: ${o ? e.borderRadius.round : df(n, e)};
    ${cn(e)}
  }
`
), Na = Jr(
  Y.button.withConfig({
    shouldForwardProp: (e) => e !== "variant" && e !== "size"
  })(({ theme: e, variant: n, size: o }) => Ol(e, { variant: n, size: o }))
), Rm = (e) => !!e.href, EO = (e) => !Rm(e), Co = Ye((e, n) => Rm(e) ? /* @__PURE__ */ g.jsx(TC, { ref: n, ...e }) : /* @__PURE__ */ g.jsx(La, { ref: n, ...e })), kO = /* @__PURE__ */ new Set(["trash"]), RO = Ye(({ size: e = "default", label: n, variant: o = "primary", ...t }, r) => {
  const a = {
    ref: r,
    sizeVariant: e,
    colorVariant: o,
    "aria-label": n,
    variant: "invisible",
    ...EO(t) ? { isRoundElement: !0 } : {},
    ...t
  };
  return /* @__PURE__ */ g.jsx($O, { ...a });
}), $O = Y(Co).withConfig({
  shouldForwardProp: (e) => e !== "sizeVariant" && e !== "colorVariant"
})(({ theme: e, iconName: n, sizeVariant: o, colorVariant: t = "primary" }) => {
  const r = kO.has(n) ? "danger" : t, { color: a, hoverBackgroundColor: i, activeBackgroundColor: s } = CC(e)[r], { size: l, iconSize: u } = cf(e)[o];
  return `
    height: ${l};
    width: ${l};
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    border-radius: ${e.borderRadius.round};
    color: ${a};


    ${Cl} {
      width: ${u};
      height: ${u}; 
    }

    transition: background-color .15s ease-in-out, box-shadow .15s ease-in-out, color .15s ease-in-out;

    &:hover {
      background-color: ${i};
    }

    &:active {
      background-color: ${s};
    }

    &:focus-visible {
      ${cn(e)}
    }

    &[disabled] {
      ${Rn}
    }
`;
}), DO = ({
  label: e,
  target: n,
  targetVariant: o,
  visible: t
}) => /* @__PURE__ */ g.jsx(
  TO,
  {
    visible: t,
    content: e,
    target: n,
    arrow: !1,
    placement: "bottom",
    offset: [2, 2],
    appendTo: "body",
    isInteractive: !1,
    touch: !1,
    isDarkTooltip: o !== "white"
  }
), TO = Y(Em).withConfig({
  shouldForwardProp: (e) => e !== "isDarkTooltip"
})(
  ({ theme: e, isDarkTooltip: n }) => `
  &.tippy-box {
    ${Nn(e)["body-small"]};
    background-color: ${n ? e.color.black : e.color.white};
    color: ${n ? e.color.white : e.color.black};
    border-radius: ${e.borderRadius.xs};
    padding: ${e.spacing.xxs} ${e.spacing.xs};
  }
`
), Fn = Ye(({ size: e = "default", label: n, variant: o = "primary", ...t }, r) => {
  const a = /* @__PURE__ */ g.jsx(
    RO,
    {
      ref: r,
      size: e,
      variant: o,
      "aria-label": n,
      ...t
    }
  );
  return n ? /* @__PURE__ */ g.jsx(
    DO,
    {
      label: n,
      target: a,
      targetVariant: o
    }
  ) : a;
}), jO = (e) => ({
  primary: {
    color: e.color.primary,
    backgroundColor: Fr(e.color.primary)
  },
  secondary: {
    color: e.color.black,
    backgroundColor: Fr(e.color.black)
  },
  danger: {
    color: e.color.danger,
    backgroundColor: Fr(e.color.danger)
  },
  success: {
    color: e.color.success,
    backgroundColor: Fr(e.color.success)
  },
  white: {
    color: e.color.white,
    backgroundColor: Hr(e.color.white, 0.2)
  }
}), Xs = (e) => ({
  small: {
    size: e.sizing.s,
    iconSize: e.sizing.xxs
  },
  default: {
    size: e.sizing.m,
    iconSize: e.sizing.xxs
  }
}), pr = pa(
  Y.div.withConfig({
    shouldForwardProp: (e) => ![
      "variant",
      "shouldTruncate",
      "shouldBreakWord",
      "colorVariant"
    ].includes(e)
  })(
    ({
      theme: e,
      variant: n,
      shouldTruncate: o = !1,
      shouldBreakWord: t = !1,
      colorVariant: r = "primary"
    }) => `
  ${Nn(e)[n]}
  margin: 0;
  
  color: ${Jd(e)[r]};
  ${o ? Ah : ""}
  ${t ? "word-break: break-word;" : ""}
`
  )
), _O = (e) => /* @__PURE__ */ g.jsx(pr, { as: "h1", variant: "h1", ...e }), IO = (e) => /* @__PURE__ */ g.jsx(pr, { as: "h2", variant: "h2", ...e }), cM = (e) => /* @__PURE__ */ g.jsx(pr, { as: "h3", variant: "h3", ...e }), xf = (e) => /* @__PURE__ */ g.jsx(pr, { as: "h4", variant: "h4", ...e }), Cf = (e) => /* @__PURE__ */ g.jsx(pr, { as: "h5", variant: "h5", ...e }), dM = (e) => /* @__PURE__ */ g.jsx(pr, { as: "h6", variant: "h6", colorVariant: "secondary", ...e }), zi = (e) => /* @__PURE__ */ g.jsx(pr, { as: "h6", variant: "h6-uppercase", ...e }), Sf = (e) => /* @__PURE__ */ g.jsx(pr, { as: "h6", variant: "h6", ...e }), pM = (e) => /* @__PURE__ */ g.jsx(pr, { as: "h6", variant: "h6-uppercase", colorVariant: "secondary", ...e }), vo = Ye((e, n) => /* @__PURE__ */ g.jsx(
  pr,
  {
    as: "div",
    variant: "body",
    ref: n,
    ...e
  }
)), un = (e) => /* @__PURE__ */ g.jsx(pr, { as: "div", variant: "body-small", ...e }), fM = (e) => /* @__PURE__ */ g.jsx(pr, { as: "div", variant: "body-extra-small", ...e }), vM = (e) => /* @__PURE__ */ g.jsx(pr, { as: "div", variant: "body", colorVariant: "secondary", ...e }), gM = (e) => /* @__PURE__ */ g.jsx(pr, { as: "div", variant: "body-small", colorVariant: "secondary", ...e }), hM = (e) => /* @__PURE__ */ g.jsx(
  pr,
  {
    as: "div",
    variant: "body-extra-small",
    colorVariant: "secondary",
    ...e
  }
), mM = (e) => /* @__PURE__ */ g.jsx(pr, { as: "div", variant: "body", colorVariant: "success", ...e }), yM = (e) => /* @__PURE__ */ g.jsx(pr, { as: "div", variant: "body-small", colorVariant: "success", ...e }), bM = (e) => /* @__PURE__ */ g.jsx(pr, { as: "div", variant: "body", colorVariant: "danger", ...e }), wM = (e) => /* @__PURE__ */ g.jsx(pr, { as: "div", variant: "body-small", colorVariant: "danger", ...e }), Of = ({
  className: e = "",
  variant: n = "primary",
  size: o = "default",
  label: t,
  imageSrc: r,
  iconName: a
}) => {
  const i = (() => r ? /* @__PURE__ */ g.jsx(FO, { src: r }) : a || t ? /* @__PURE__ */ g.jsx(
    AO,
    {
      alignItems: "center",
      colorVariant: n,
      justifyContent: "center",
      sizeVariant: o,
      children: a ? /* @__PURE__ */ g.jsx(Lr, { name: a }) : /* @__PURE__ */ g.jsx(vo, { children: t })
    }
  ) : void 0)();
  return /* @__PURE__ */ g.jsx(MO, { sizeVariant: o, className: e, children: i });
}, MO = Y.div.withConfig(
  {
    shouldForwardProp: (e) => e !== "sizeVariant"
  }
)(({ theme: e, sizeVariant: n }) => {
  const { size: o } = Xs(e)[n];
  return `
    width: ${o};
    height: ${o};
    border-radius: ${e.borderRadius.round};
    overflow: hidden;
    flex-shrink: 0;
  `;
}), AO = Y(Be)(({ theme: e, colorVariant: n, sizeVariant: o }) => {
  const { color: t, backgroundColor: r } = jO(e)[n], { iconSize: a } = Xs(e)[o];
  return `
      background-color: ${r};
      width: 100%;
      height: 100%;

      ${Cl} {
        color: ${t};
        width: ${a};
        height: ${a};
      }
  
      ${pr} {
        color: ${t};
        font-size: ${a};
        text-transform: uppercase;
        font-weight: ${e.fontWeight.bold};
      }
  `;
}), FO = Y.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`, $m = Y.div(
  ({ theme: e }) => `
  background-color: ${Hr(e.color.black, 0.5)};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${e.zIndex.backdrop};
`
), LO = (e) => ({
  primary: {
    color: e.color.primary,
    backgroundColor: Fr(e.color.primary)
  },
  success: {
    color: e.color.textSuccess,
    backgroundColor: Fr(e.color.green0)
  },
  warning: {
    color: e.color.orange1,
    backgroundColor: Fr(e.color.warning)
  },
  danger: {
    color: e.color.textDanger,
    backgroundColor: Fr(e.color.danger)
  },
  secondary: {
    color: e.color.secondary,
    backgroundColor: Fr(e.color.secondary)
  }
}), Rl = ({
  className: e = "",
  label: n,
  variant: o = "primary",
  shouldTransformLabel: t = !0
}) => {
  const r = t ? n.toLocaleLowerCase() : n;
  return /* @__PURE__ */ g.jsx(
    NO,
    {
      className: e,
      variant: o,
      shouldTransformLabel: t,
      children: /* @__PURE__ */ g.jsx(Sf, { as: "div", shouldTruncate: !0, children: r })
    }
  );
}, NO = Y.div.withConfig({
  shouldForwardProp: (e) => e !== "variant" && e !== "shouldTransformLabel"
})(({ theme: e, variant: n, shouldTransformLabel: o }) => {
  const { color: t, backgroundColor: r } = LO(e)[n];
  return `
      background-color: ${r};
      display: inline-block;
      border-radius: ${e.borderRadius.s};
      padding: ${e.spacing.xxs} ${e.spacing.xs};
      width: min-content;

      ${pr} {
        color: ${t};
        ${o ? "text-transform: capitalize;" : ""}
      }
  `;
}), lo = (e) => e.borderRadius.m, Dm = (e) => `
  border-top-left-radius: ${lo(e)};
  border-top-right-radius: ${lo(e)};
`, Pf = ({ children: e, headElement: n, ...o }) => /* @__PURE__ */ g.jsxs(BO, { ...o, direction: "column", children: [
  n && /* @__PURE__ */ g.jsx(WO, { children: n }),
  /* @__PURE__ */ g.jsx(zO, { hasHeadElement: !!n, children: e })
] }), BO = Y(Be)(
  ({ theme: e }) => `
  border-radius: ${lo(e)};
`
), WO = Y(Be)(
  ({ theme: e }) => `
  ${Dm(e)}
  overflow: hidden;
`
), zO = Y.div.withConfig(
  {
    shouldForwardProp: (e) => e !== "hasHeadElement"
  }
)(
  ({ theme: e, hasHeadElement: n }) => `
  display: flex;
  flex-direction: column;
  background-color: ${e.color.white};
  border: ${Pn(e)};
  flex: 1;

  ${n ? `
        border-bottom-left-radius: ${lo(e)};
        border-bottom-right-radius: ${lo(e)};
        border-top: none;
      ` : `border-radius: ${lo(e)};`}
`
), HO = Y.div(({ theme: e, background: n }) => `
    width: 100%;
    background: ${e.color[n]};
    height: ${e.sizing.xxxs};
    border-top-left-radius: ${lo(e)};
    border-top-right-radius: ${lo(e)};
  `), YO = (e) => `
  border-bottom-left-radius: ${lo(e)};
  border-bottom-right-radius: ${lo(e)};
`, xM = Y.div(
  ({ theme: e, trim: n }) => `
    overflow: hidden;
    ${n === "top" || n === "all" ? Dm(e) : ""}
    ${n === "bottom" || n === "all" ? YO(e) : ""}
  `
), Bn = Y.div.withConfig({
  shouldForwardProp: (e) => e !== "direction"
})(
  ({ theme: e, direction: n = "horizontal" }) => `
  background-color: ${e.color.border};

  ${n === "horizontal" ? `
    height: 1px;
    min-height: 1px;
    max-height: 1px;
    width: 100%;
  ` : `
    width: 1px;
    min-width: 1px;
    max-width: 1px;
    height: 100%;
  `}
  
`
);
function Pa() {
}
function GO() {
  return !0;
}
function fi(e) {
  return !!(e || "").match(/\d/);
}
function pg(e) {
  return e == null;
}
function fg(e) {
  return e.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function VO(e) {
  switch (e) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function UO(e, n, o) {
  var t = VO(o), r = e.search(/[1-9]/);
  return r = r === -1 ? e.length : r, e.substring(0, r) + e.substring(r, e.length).replace(t, "$1" + n);
}
function fd(e, n) {
  n === void 0 && (n = !0);
  var o = e[0] === "-", t = o && n;
  e = e.replace("-", "");
  var r = e.split("."), a = r[0], i = r[1] || "";
  return {
    beforeDecimal: a,
    afterDecimal: i,
    hasNagation: o,
    addNegation: t
  };
}
function qO(e) {
  if (!e)
    return e;
  var n = e[0] === "-";
  n && (e = e.substring(1, e.length));
  var o = e.split("."), t = o[0].replace(/^0+/, "") || "0", r = o[1] || "";
  return (n ? "-" : "") + t + (r ? "." + r : "");
}
function Tm(e, n, o) {
  for (var t = "", r = o ? "0" : "", a = 0; a <= n - 1; a++)
    t += e[a] || r;
  return t;
}
function vg(e, n) {
  return Array(n + 1).join(e);
}
function KO(e) {
  e += "";
  var n = e[0] === "-" ? "-" : "";
  n && (e = e.substring(1));
  var o = e.split(/[eE]/g), t = o[0], r = o[1];
  if (r = Number(r), !r)
    return n + t;
  t = t.replace(".", "");
  var a = 1 + r, i = t.length;
  return a < 0 ? t = "0." + vg("0", Math.abs(a)) + t : a >= i ? t = t + vg("0", a - i) : t = (t.substring(0, a) || "0") + "." + t.substring(a), n + t;
}
function QO(e, n, o) {
  if (["", "-"].indexOf(e) !== -1)
    return e;
  var t = e.indexOf(".") !== -1 && n, r = fd(e), a = r.beforeDecimal, i = r.afterDecimal, s = r.hasNagation, l = parseFloat("0." + (i || "0")), u = i.length <= n ? "0." + i : l.toFixed(n), c = u.split("."), p = a.split("").reverse().reduce(function(P, k, $) {
    return P.length > $ ? (Number(P[0]) + Number(k)).toString() + P.substring(1, P.length) : k + P;
  }, c[0]), h = Tm(
    c[1] || "",
    Math.min(n, i.length),
    o
  ), O = s ? "-" : "", C = t ? "." : "";
  return "" + O + p + C + h;
}
function gg(e, n) {
  if (e.value = e.value, e !== null) {
    if (e.createTextRange) {
      var o = e.createTextRange();
      return o.move("character", n), o.select(), !0;
    }
    return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(n, n), !0) : (e.focus(), !1);
  }
}
function XO(e, n) {
  for (var o = 0, t = 0, r = e.length, a = n.length; e[o] === n[o] && o < r; )
    o++;
  for (; e[r - 1 - t] === n[a - 1 - t] && a - t > o && r - t > o; )
    t++;
  return { start: o, end: r - t };
}
function Du(e, n, o) {
  return Math.min(Math.max(e, n), o);
}
function hg(e) {
  return Math.max(e.selectionStart, e.selectionEnd);
}
function JO(e) {
  return e || typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function ZO(e, n) {
  var o = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) === -1 && (o[t] = e[t]);
  return o;
}
var eP = {
  displayType: "input",
  decimalSeparator: ".",
  thousandsGroupStyle: "thousand",
  fixedDecimalScale: !1,
  prefix: "",
  suffix: "",
  allowNegative: !0,
  allowEmptyFormatting: !1,
  allowLeadingZeros: !1,
  isNumericString: !1,
  type: "text",
  onValueChange: Pa,
  onChange: Pa,
  onKeyDown: Pa,
  onMouseUp: Pa,
  onFocus: Pa,
  onBlur: Pa,
  isAllowed: GO
}, jm = /* @__PURE__ */ function(e) {
  function n(o) {
    e.call(this, o);
    var t = o.defaultValue;
    this.validateProps();
    var r = this.formatValueProp(t);
    this.state = {
      value: r,
      numAsString: this.removeFormatting(r),
      mounted: !1
    }, this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0
    }, this.onChange = this.onChange.bind(this), this.onKeyDown = this.onKeyDown.bind(this), this.onMouseUp = this.onMouseUp.bind(this), this.onFocus = this.onFocus.bind(this), this.onBlur = this.onBlur.bind(this);
  }
  return e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n, n.prototype.componentDidMount = function() {
    this.setState({
      mounted: !0
    });
  }, n.prototype.componentDidUpdate = function(t) {
    this.updateValueIfRequired(t);
  }, n.prototype.componentWillUnmount = function() {
    clearTimeout(this.focusTimeout), clearTimeout(this.caretPositionTimeout);
  }, n.prototype.updateValueIfRequired = function(t) {
    var r = this, a = r.props, i = r.state, s = r.focusedElm, l = i.value, u = i.numAsString;
    if (u === void 0 && (u = ""), t !== a) {
      this.validateProps();
      var c = this.formatNumString(u), p = pg(a.value) ? c : this.formatValueProp(), h = this.removeFormatting(p), O = parseFloat(h), C = parseFloat(u);
      //while typing set state only when float value changes
      ((!isNaN(O) || !isNaN(C)) && O !== C || //can also set state when float value is same and the format props changes
      c !== l || //set state always when not in focus and formatted value is changed
      s === null && p !== l) && this.updateValue({
        formattedValue: p,
        numAsString: h,
        input: s,
        source: "prop",
        event: null
      });
    }
  }, n.prototype.getFloatString = function(t) {
    t === void 0 && (t = "");
    var r = this.props, a = r.decimalScale, i = this.getSeparators(), s = i.decimalSeparator, l = this.getNumberRegex(!0), u = t[0] === "-";
    u && (t = t.replace("-", "")), s && a === 0 && (t = t.split(s)[0]), t = (t.match(l) || []).join("").replace(s, ".");
    var c = t.indexOf(".");
    return c !== -1 && (t = t.substring(0, c) + "." + t.substring(c + 1, t.length).replace(new RegExp(fg(s), "g"), "")), u && (t = "-" + t), t;
  }, n.prototype.getNumberRegex = function(t, r) {
    var a = this.props, i = a.format, s = a.decimalScale, l = a.customNumerals, u = this.getSeparators(), c = u.decimalSeparator;
    return new RegExp(
      "[0-9" + (l ? l.join("") : "") + "]" + (c && s !== 0 && !r && !i ? "|" + fg(c) : ""),
      t ? "g" : void 0
    );
  }, n.prototype.getSeparators = function() {
    var t = this.props, r = t.decimalSeparator, a = this.props, i = a.thousandSeparator, s = a.allowedDecimalSeparators;
    return i === !0 && (i = ","), s || (s = [r, "."]), {
      decimalSeparator: r,
      thousandSeparator: i,
      allowedDecimalSeparators: s
    };
  }, n.prototype.getMaskAtIndex = function(t) {
    var r = this.props, a = r.mask;
    return a === void 0 && (a = " "), typeof a == "string" ? a : a[t] || " ";
  }, n.prototype.getValueObject = function(t, r) {
    var a = parseFloat(r);
    return {
      formattedValue: t,
      value: r,
      floatValue: isNaN(a) ? void 0 : a
    };
  }, n.prototype.validateProps = function() {
    var t = this.props, r = t.mask, a = this.getSeparators(), i = a.decimalSeparator, s = a.thousandSeparator;
    if (i === s)
      throw new Error(`
          Decimal separator can't be same as thousand separator.
          thousandSeparator: ` + s + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
          decimalSeparator: ` + i + ` (default value for decimalSeparator is .)
       `);
    if (r) {
      var l = r === "string" ? r : r.toString();
      if (l.match(/\d/g))
        throw new Error(`
          Mask ` + r + ` should not contain numeric character;
        `);
    }
  }, n.prototype.setPatchedCaretPosition = function(t, r, a) {
    gg(t, r), this.caretPositionTimeout = setTimeout(function() {
      t.value === a && gg(t, r);
    }, 0);
  }, n.prototype.correctCaretPosition = function(t, r, a) {
    var i = this.props, s = i.prefix, l = i.suffix, u = i.format;
    if (t === "")
      return 0;
    if (r = Du(r, 0, t.length), !u) {
      var c = t[0] === "-";
      return Du(r, s.length + (c ? 1 : 0), t.length - l.length);
    }
    if (typeof u == "function" || u[r] === "#" && fi(t[r]) || u[r - 1] === "#" && fi(t[r - 1]))
      return r;
    var p = u.indexOf("#"), h = u.lastIndexOf("#");
    r = Du(r, p, h + 1);
    for (var O = u.substring(r, u.length).indexOf("#"), C = r, P = r + (O === -1 ? 0 : O); C > p && (u[C] !== "#" || !fi(t[C])); )
      C -= 1;
    var k = !fi(t[P]) || a === "left" && r !== p || r - C < P - r;
    return k ? fi(t[C]) ? C + 1 : C : P;
  }, n.prototype.getCaretPosition = function(t, r, a) {
    var i = this.props, s = i.format, l = this.state.value, u = this.getNumberRegex(!0), c = (t.match(u) || []).join(""), p = (r.match(u) || []).join(""), h, O;
    for (h = 0, O = 0; O < a; O++) {
      var C = t[O] || "", P = r[h] || "";
      if (!(!C.match(u) && C !== P) && !(C === "0" && P.match(u) && P !== "0" && c.length !== p.length)) {
        for (; C !== r[h] && h < r.length; )
          h++;
        h++;
      }
    }
    return typeof s == "string" && !l && (h = r.length), h = this.correctCaretPosition(r, h), h;
  }, n.prototype.removePrefixAndSuffix = function(t) {
    var r = this.props, a = r.format, i = r.prefix, s = r.suffix;
    if (!a && t) {
      var l = t[0] === "-";
      l && (t = t.substring(1, t.length)), t = i && t.indexOf(i) === 0 ? t.substring(i.length, t.length) : t;
      var u = t.lastIndexOf(s);
      t = s && u !== -1 && u === t.length - s.length ? t.substring(0, u) : t, l && (t = "-" + t);
    }
    return t;
  }, n.prototype.removePatternFormatting = function(t) {
    for (var r = this.props, a = r.format, i = a.split("#").filter(function(O) {
      return O !== "";
    }), s = 0, l = "", u = 0, c = i.length; u <= c; u++) {
      var p = i[u] || "", h = u === c ? t.length : t.indexOf(p, s);
      if (h === -1) {
        l = t;
        break;
      } else
        l += t.substring(s, h), s = h + p.length;
    }
    return (l.match(this.getNumberRegex(!0)) || []).join("");
  }, n.prototype.removeFormatting = function(t) {
    var r = this.props, a = r.format, i = r.removeFormatting;
    return t && (a ? typeof a == "string" ? t = this.removePatternFormatting(t) : typeof i == "function" ? t = i(t) : t = (t.match(this.getNumberRegex(!0)) || []).join("") : (t = this.removePrefixAndSuffix(t), t = this.getFloatString(t)), t);
  }, n.prototype.formatWithPattern = function(t) {
    for (var r = this.props, a = r.format, i = 0, s = a.split(""), l = 0, u = a.length; l < u; l++)
      a[l] === "#" && (s[l] = t[i] || this.getMaskAtIndex(i), i += 1);
    return s.join("");
  }, n.prototype.formatAsNumber = function(t) {
    var r = this.props, a = r.decimalScale, i = r.fixedDecimalScale, s = r.prefix, l = r.suffix, u = r.allowNegative, c = r.thousandsGroupStyle, p = this.getSeparators(), h = p.thousandSeparator, O = p.decimalSeparator, C = t.indexOf(".") !== -1 || a && i, P = fd(t, u), k = P.beforeDecimal, $ = P.afterDecimal, I = P.addNegation;
    return a !== void 0 && ($ = Tm($, a, i)), h && (k = UO(k, h, c)), s && (k = s + k), l && ($ = $ + l), I && (k = "-" + k), t = k + (C && O || "") + $, t;
  }, n.prototype.formatNumString = function(t) {
    t === void 0 && (t = "");
    var r = this.props, a = r.format, i = r.allowEmptyFormatting, s = r.customNumerals, l = t;
    if (s && s.length === 10) {
      var u = new RegExp("[" + s.join("") + "]", "g");
      l = t.replace(
        u,
        function(c) {
          return s.indexOf(c).toString();
        }
      );
    }
    return t === "" && !i ? l = "" : t === "-" && !a ? l = "-" : typeof a == "string" ? l = this.formatWithPattern(l) : typeof a == "function" ? l = a(l) : l = this.formatAsNumber(l), l;
  }, n.prototype.formatValueProp = function(t) {
    var r = this.props, a = r.format, i = r.decimalScale, s = r.fixedDecimalScale, l = r.allowEmptyFormatting, u = this.props, c = u.value, p = u.isNumericString;
    c = pg(c) ? t : c;
    var h = !c && c !== 0;
    if (h && l && (c = ""), h && !l)
      return "";
    typeof c == "number" && (c = KO(c), p = !0), c === "Infinity" && p && (c = ""), p && !a && typeof i == "number" && (c = QO(c, i, s));
    var O = p ? this.formatNumString(c) : this.formatInput(c);
    return O;
  }, n.prototype.formatNegation = function(t) {
    t === void 0 && (t = "");
    var r = this.props, a = r.allowNegative, i = new RegExp("(-)"), s = new RegExp("(-)(.)*(-)"), l = i.test(t), u = s.test(t);
    return t = t.replace(/-/g, ""), l && !u && a && (t = "-" + t), t;
  }, n.prototype.formatInput = function(t) {
    t === void 0 && (t = "");
    var r = this.props, a = r.format;
    return a || (t = this.removePrefixAndSuffix(t), t = this.formatNegation(t)), t = this.removeFormatting(t), this.formatNumString(t);
  }, n.prototype.isCharacterAFormat = function(t, r) {
    var a = this.props, i = a.format, s = a.prefix, l = a.suffix, u = a.decimalScale, c = a.fixedDecimalScale, p = this.getSeparators(), h = p.decimalSeparator;
    return !!(typeof i == "string" && i[t] !== "#" || !i && (t < s.length || t >= r.length - l.length || u && c && r[t] === h));
  }, n.prototype.correctInputValue = function(t, r, a) {
    var i = this, s = this.props, l = s.format, u = s.allowNegative, c = s.prefix, p = s.suffix, h = s.decimalScale, O = this.getSeparators(), C = O.allowedDecimalSeparators, P = O.decimalSeparator, k = this.state.numAsString || "", $ = this.selectionBeforeInput, I = $.selectionStart, H = $.selectionEnd, x = XO(r, a), _ = x.start, F = x.end;
    if (!l && _ === F && C.indexOf(a[I]) !== -1) {
      var G = h === 0 ? "" : P;
      return a.substr(0, I) + G + a.substr(I + 1, a.length);
    }
    var Q = l ? 0 : c.length, V = r.length - (l ? 0 : p.length);
    if (
      // don't do anything if something got added
      a.length > r.length || // or if the new value is an empty string
      !a.length || // or if nothing has changed, in which case start will be same as end
      _ === F || // or in case if whole input is selected and new value is typed
      I === 0 && H === r.length || // or in case if the whole content is replaced by browser, example (autocomplete)
      _ === 0 && F === r.length || // or if charcters between prefix and suffix is selected.
      // For numeric inputs we apply the format so, prefix and suffix can be ignored
      I === Q && H === V
    )
      return a;
    var ie = r.substr(_, F - _), ce = !![].concat(ie).find(
      function(le, Pe) {
        return i.isCharacterAFormat(Pe + _, r);
      }
    );
    if (ce) {
      var me = r.substr(_), ve = {}, U = [];
      [].concat(me).forEach(function(le, Pe) {
        i.isCharacterAFormat(Pe + _, r) ? ve[Pe] = le : Pe > ie.length - 1 && U.push(le);
      }), Object.keys(ve).forEach(function(le) {
        U.length > le ? U.splice(le, 0, ve[le]) : U.push(ve[le]);
      }), a = r.substr(0, _) + U.join("");
    }
    if (!l) {
      var ee = this.removeFormatting(a), oe = fd(
        ee,
        u
      ), ge = oe.beforeDecimal, be = oe.afterDecimal, he = oe.addNegation, K = t < a.indexOf(P) + 1;
      if (ee.length < k.length && K && ge === "" && !parseFloat(be))
        return he ? "-" : "";
    }
    return a;
  }, n.prototype.updateValue = function(t) {
    var r = t.formattedValue, a = t.input, i = t.setCaretPosition;
    i === void 0 && (i = !0);
    var s = t.source, l = t.event, u = t.numAsString, c = t.caretPos, p = this.props, h = p.onValueChange, O = this.state, C = O.value;
    if (a) {
      if (c === void 0 && i) {
        var P = t.inputValue || a.value, k = hg(a);
        a.value = r, c = this.getCaretPosition(P, r, k);
      }
      a.value = r, i && this.setPatchedCaretPosition(a, c, r);
    }
    u === void 0 && (u = this.removeFormatting(r)), r !== C && (this.setState({ value: r, numAsString: u }), h(this.getValueObject(r, u), { event: l, source: s }));
  }, n.prototype.onChange = function(t) {
    var r = t.target, a = r.value, i = this, s = i.state, l = i.props, u = l.isAllowed, c = s.value || "", p = hg(r);
    a = this.correctInputValue(p, c, a);
    var h = this.formatInput(a) || "", O = this.removeFormatting(h), C = this.getValueObject(h, O), P = u(C);
    P || (h = c), this.updateValue({
      formattedValue: h,
      numAsString: O,
      inputValue: a,
      input: r,
      event: t,
      source: "event"
    }), P && l.onChange(t);
  }, n.prototype.onBlur = function(t) {
    var r = this, a = r.props, i = r.state, s = a.format, l = a.onBlur, u = a.allowLeadingZeros, c = i.numAsString, p = i.value;
    if (this.focusedElm = null, clearTimeout(this.focusTimeout), clearTimeout(this.caretPositionTimeout), !s) {
      isNaN(parseFloat(c)) && (c = ""), u || (c = qO(c));
      var h = this.formatNumString(c);
      if (h !== p) {
        this.updateValue({
          formattedValue: h,
          numAsString: c,
          input: t.target,
          setCaretPosition: !1,
          event: t,
          source: "event"
        }), l(t);
        return;
      }
    }
    l(t);
  }, n.prototype.onKeyDown = function(t) {
    var r = t.target, a = t.key, i = r.selectionStart, s = r.selectionEnd, l = r.value;
    l === void 0 && (l = "");
    var u, c = this.props, p = c.decimalScale, h = c.fixedDecimalScale, O = c.prefix, C = c.suffix, P = c.format, k = c.onKeyDown, $ = p !== void 0 && h, I = this.getNumberRegex(!1, $), H = new RegExp("-"), x = typeof P == "string";
    if (this.selectionBeforeInput = {
      selectionStart: i,
      selectionEnd: s
    }, a === "ArrowLeft" || a === "Backspace" ? u = i - 1 : a === "ArrowRight" ? u = i + 1 : a === "Delete" && (u = i), u === void 0 || i !== s) {
      k(t);
      return;
    }
    var _ = u, F = x ? P.indexOf("#") : O.length, G = x ? P.lastIndexOf("#") + 1 : l.length - C.length;
    if (a === "ArrowLeft" || a === "ArrowRight") {
      var Q = a === "ArrowLeft" ? "left" : "right";
      _ = this.correctCaretPosition(l, u, Q);
    } else if (a === "Delete" && !I.test(l[u]) && !H.test(l[u]))
      for (; !I.test(l[_]) && _ < G; )
        _++;
    else if (a === "Backspace" && !I.test(l[u])) {
      if (i <= F + 1 && l[0] === "-" && typeof P > "u") {
        var V = l.substring(1);
        this.updateValue({
          formattedValue: V,
          caretPos: _,
          input: r,
          event: t,
          source: "event"
        });
      } else if (!H.test(l[u])) {
        for (; !I.test(l[_ - 1]) && _ > F; )
          _--;
        _ = this.correctCaretPosition(l, _, "left");
      }
    }
    (_ !== u || u < F || u > G) && (t.preventDefault(), this.setPatchedCaretPosition(r, _, l)), t.isUnitTestRun && this.setPatchedCaretPosition(r, _, l), k(t);
  }, n.prototype.onMouseUp = function(t) {
    var r = t.target, a = r.selectionStart, i = r.selectionEnd, s = r.value;
    if (s === void 0 && (s = ""), a === i) {
      var l = this.correctCaretPosition(s, a);
      l !== a && this.setPatchedCaretPosition(r, l, s);
    }
    this.props.onMouseUp(t);
  }, n.prototype.onFocus = function(t) {
    var r = this;
    t.persist(), this.focusedElm = t.target, this.focusTimeout = setTimeout(function() {
      var a = t.target, i = a.selectionStart, s = a.selectionEnd, l = a.value;
      l === void 0 && (l = "");
      var u = r.correctCaretPosition(l, i);
      u !== i && !(i === 0 && s === l.length) && r.setPatchedCaretPosition(a, u, l), r.props.onFocus(t);
    }, 0);
  }, n.prototype.render = function() {
    var t = this.props, r = t.type, a = t.displayType, i = t.customInput, s = t.renderText, l = t.getInputRef, u = t.format;
    t.thousandSeparator, t.decimalSeparator, t.allowedDecimalSeparators, t.thousandsGroupStyle, t.decimalScale, t.fixedDecimalScale, t.prefix, t.suffix, t.removeFormatting, t.mask, t.defaultValue, t.isNumericString, t.allowNegative, t.allowEmptyFormatting, t.allowLeadingZeros, t.onValueChange, t.isAllowed, t.customNumerals, t.onChange, t.onKeyDown, t.onMouseUp, t.onFocus, t.onBlur, t.value;
    var c = ZO(t, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "thousandSeparator", "decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "decimalScale", "fixedDecimalScale", "prefix", "suffix", "removeFormatting", "mask", "defaultValue", "isNumericString", "allowNegative", "allowEmptyFormatting", "allowLeadingZeros", "onValueChange", "isAllowed", "customNumerals", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value"]), p = c, h = this.state, O = h.value, C = h.mounted, P = C && JO(u) ? "numeric" : void 0, k = Object.assign({ inputMode: P }, p, {
      type: r,
      value: O,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onMouseUp: this.onMouseUp,
      onFocus: this.onFocus,
      onBlur: this.onBlur
    });
    if (a === "text")
      return s ? s(O, p) || null : y.createElement(
        "span",
        Object.assign({}, p, { ref: l }),
        O
      );
    if (i) {
      var $ = i;
      return y.createElement($, Object.assign({}, k, { ref: l }));
    }
    return y.createElement("input", Object.assign({}, k, { ref: l }));
  }, n;
}(y.Component);
jm.defaultProps = eP;
const tP = (e) => ({
  danger: {
    enabled: e.color.red1,
    hover: e.color.red2
  },
  secondary: {
    enabled: e.color.gray7,
    hover: e.color.black
  }
}), rP = (e, n, o) => {
  const { enabled: t, hover: r } = tP(e)[o];
  return `
      color: ${t};

      ${n ? Rn : `
              &:hover {
                color: ${r};
              }

              &:focus-visible {
                ${cn(e)}
              }
            `}`;
}, Hi = ({
  tooltipProps: e,
  trackingId: n,
  variant: o = "secondary",
  isDisabled: t = !1
}) => {
  const r = /* @__PURE__ */ g.jsx(
    nP,
    {
      isDisabled: t,
      name: "help-circle",
      trackingId: n,
      colorVariant: o
    }
  );
  return t ? r : /* @__PURE__ */ g.jsx(
    El,
    {
      interactiveBorder: 4,
      target: r,
      touch: !0,
      ...e
    }
  );
}, nP = Y(Lr).withConfig({
  shouldForwardProp: (e) => e !== "isDisabled" && e !== "colorVariant"
})(
  ({ theme: e, isDisabled: n, colorVariant: o }) => `

  
  cursor: default;

  // Border radius is needed so the focus ring below aligns properly to the edge
  // of the Icon itself rather than the Icon's square viewbox.
  border-radius: ${e.borderRadius.round};

  // Safari requires height be set to auto while Chrome defaults to 
  // height: auto when in a flexbox element.
  height: auto;

  ${rP(e, n, o)}
`
), _m = `
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
`, Im = Y.div`
  ${_m}
`, oP = Jr(Y.label`
  ${_m}
`), aP = ({
  isLabelHidden: e,
  trackingId: n,
  label: o,
  helpIconProps: t,
  LabelElement: r = mg,
  htmlFor: a
}) => {
  const i = t && {
    ...t,
    tooltipProps: {
      ...t.tooltipProps,
      placement: "right"
    }
  }, s = `${n}-label`;
  return e ? /* @__PURE__ */ g.jsx(
    r,
    {
      as: oP,
      trackingId: s,
      htmlFor: a,
      children: o
    }
  ) : /* @__PURE__ */ g.jsxs(Be, { gap: "xs", alignItems: "center", children: [
    /* @__PURE__ */ g.jsx(r, { as: mg, trackingId: s, htmlFor: a, children: o }),
    i && /* @__PURE__ */ g.jsx(Hi, { ...i })
  ] });
}, mg = Jr(
  Y.label(
    ({ theme: e }) => `
  ${Nn(e).body}
`
  )
), fa = Ye(
  ({ className: e = "", children: n, ...o }, t) => /* @__PURE__ */ g.jsxs(
    iP,
    {
      className: e,
      direction: "column",
      gap: o.isLabelHidden ? "none" : "s",
      ref: t,
      children: [
        o.label && /* @__PURE__ */ g.jsx(aP, { ...o }),
        n
      ]
    }
  )
), iP = Y(Be)`
  position: relative;
`;
let yg = 0;
const Ba = (e, n = "tb-id-") => {
  const [o] = ur(() => {
    const t = e === void 0 ? `${n}${yg}` : e;
    return yg += 1, t;
  });
  return o;
}, Mm = (e) => ({
  none: {
    enabled: {
      borderColor: e.color.border,
      backgroundColor: e.color.white
    },
    hover: {
      borderColor: e.color.borderHover
    }
  },
  error: {
    enabled: {
      borderColor: e.color.danger,
      backgroundColor: Fr(e.color.danger)
    },
    hover: {
      borderColor: e.color.red3
    }
  },
  success: {
    enabled: {
      borderColor: e.color.success,
      backgroundColor: Fr(e.color.success)
    },
    hover: {
      borderColor: e.color.green3
    }
  }
}), Ef = (e) => {
  const n = Mm(e).none;
  return `
    background-color: ${n.enabled.backgroundColor};
    border-color: ${n.enabled.borderColor};

    &:hover {
      border-color: ${n.hover.borderColor};
    }
  `;
}, Yi = (e, n = "none", o = "default") => {
  const { enabled: t, hover: r } = Mm(e)[n];
  return `
    outline: none;
    height: ${o === "default" ? e.sizing.m : e.sizing.s};
    border-radius: ${e.borderRadius.s};
    background-color: ${t.backgroundColor};
    color: ${e.color.textPrimary};
    padding: ${e.spacing.s};

    border: ${e.borderWidth.s} solid ${t.borderColor};

    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;

    // On focus, show the input in the unvalidated state so it's
    // less overwhelming for a user to enter input.
    &:focus-visible {
      ${Ef(e)}
      ${cn(e)}
    }

    &:hover {
      border-color: ${r.borderColor};
    }

    &[disabled] {
      ${Rn}
    }

    &::placeholder {
      color: ${e.color.textSecondary};
    }
  `;
}, kf = Ye(
  ({
    errorMessage: e,
    id: n,
    isDisabled: o = !1,
    className: t = "",
    label: r,
    onTextChange: a,
    helpIconProps: i,
    validationState: s = "none",
    size: l = "default",
    inputRef: u,
    inputSiblingElement: c,
    trackingId: p,
    isLabelHidden: h = !1,
    ...O
  }, C) => {
    const P = Ba(n), k = Ba(), $ = Ga(
      (_) => a(_.currentTarget.value)
    ), I = s === "error", H = I && e, x = {
      label: r,
      helpIconProps: i,
      isLabelHidden: h,
      trackingId: p
    };
    return /* @__PURE__ */ g.jsxs(
      fa,
      {
        className: t,
        ref: C,
        htmlFor: P,
        ...x,
        children: [
          /* @__PURE__ */ g.jsxs(sP, { children: [
            /* @__PURE__ */ g.jsx(
              Rf,
              {
                id: P,
                validationState: s,
                size: l,
                onChange: $,
                "aria-invalid": I,
                "aria-describedby": H ? k : void 0,
                disabled: o,
                ref: u,
                trackingId: p,
                ...O
              }
            ),
            c
          ] }),
          H && /* @__PURE__ */ g.jsx(
            un,
            {
              colorVariant: "danger",
              id: k,
              trackingId: `${p}-error`,
              children: e
            }
          )
        ]
      }
    );
  }
), sP = Y.div`
  position: relative;
  width: 100%;
`, Rf = Jr(
  Y.input.withConfig({
    shouldForwardProp: (e) => !["validationState", "maxWidth", "size"].includes(e)
  })(
    ({ theme: e, validationState: n, maxWidth: o, size: t }) => `
    ${Yi(e, n, t)}

    width: 100%;
    max-width: ${o ? e.measure[o] : "initial"};
    cursor: text;
  `
  )
), CM = Ye(({ onValueChange: e, ...n }, o) => /* @__PURE__ */ g.jsx(
  jm,
  {
    customInput: kf,
    onValueChange: Ga(e),
    onTextChange: () => {
    },
    ref: o,
    autoComplete: "off",
    ...n
  }
)), ks = "1000px", lP = Y.div(
  ({ theme: e }) => `
  animation-duration: 2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: shimmer;
  animation-timing-function: linear;
  background: linear-gradient(to right, ${e.color.gray2}, ${e.color.white}, ${e.color.gray2});
  background-size: ${ks} ${ks};
  position: relative;

  @keyframes shimmer {
    0% {
      background-position: calc(-1 * calc(${ks} / 2)) 0;
    }
    100% {
      background-position: calc(${ks}/2) 0;
    }
}
`
), SM = ({ size: e = "default" }) => /* @__PURE__ */ g.jsx(uP, { size: e }), uP = Y(lP)(
  ({ theme: e, size: n }) => `
  width: ${Xs(e)[n].size};
  height: ${Xs(e)[n].size};
  border-radius: ${e.borderRadius.round};
`
), cP = (e) => ({
  secondary: {
    backgroundColor: e.color.gray6
  },
  primary: {
    backgroundColor: e.color.primary
  },
  danger: {
    backgroundColor: e.color.danger
  },
  success: {
    backgroundColor: e.color.success
  }
}), OM = ({
  className: e = "",
  value: n,
  variant: o = "primary",
  shouldShowDescription: t
}) => {
  const r = Math.min(Math.max(n, 0), 100);
  return /* @__PURE__ */ g.jsxs(Be, { gap: "s", growItems: !0, direction: "column", children: [
    /* @__PURE__ */ g.jsx(Be, { growItems: !0, children: /* @__PURE__ */ g.jsx(
      dP,
      {
        "aria-valuenow": r,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": `${r}%`,
        className: e,
        role: "progressbar",
        children: /* @__PURE__ */ g.jsx(pP, { width: r, colorVariant: o })
      }
    ) }),
    t && /* @__PURE__ */ g.jsxs(Sf, { colorVariant: "secondary", children: [
      r,
      "% Complete"
    ] })
  ] });
}, dP = Y.div(({ theme: e }) => `
    background-color: ${e.color.gray2};
    border-radius: ${e.borderRadius.round};
    height: ${e.sizing.xxxs};
    overflow: hidden;
  `), pP = Y.div.withConfig({
  shouldForwardProp: (e) => e !== "width" && e !== "colorVariant"
})(
  ({ theme: e, width: n, colorVariant: o }) => `
    height: 100%;
    width: ${n}%;
    border-radius: ${e.borderRadius.round};
    transition: width 0.5s ease-in-out;

    background-color: ${cP(e)[o].backgroundColor}  
`
), PM = (e) => /* @__PURE__ */ g.jsx(Be, { padding: "contentPadding", justifyContent: "center", children: /* @__PURE__ */ g.jsx(wf, { ...e }) }), EM = ({ value: e, formatNumber: n, ...o }) => {
  const t = (() => e ? e > 0 ? "success" : "danger" : "primary")();
  return /* @__PURE__ */ g.jsx(pr, { variant: "body", colorVariant: t, ...o, children: n(e) });
}, kM = Y(Be).attrs({
  gap: "xs"
})``, $l = typeof window > "u" || typeof document > "u";
let Xt = $l ? Nt : Kd;
function Va(e) {
  let n = St(e);
  return Xt(() => {
    n.current = e;
  }, [e]), n;
}
function Gi(e, n) {
  let [o, t] = ur(e), r = Va(e);
  return Xt(() => t(r.current), [r, t, ...n]), o;
}
function Dl(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((n) => setTimeout(() => {
    throw n;
  }));
}
function qn() {
  let e = [], n = [], o = { enqueue(t) {
    n.push(t);
  }, addEventListener(t, r, a, i) {
    return t.addEventListener(r, a, i), o.add(() => t.removeEventListener(r, a, i));
  }, requestAnimationFrame(...t) {
    let r = requestAnimationFrame(...t);
    return o.add(() => cancelAnimationFrame(r));
  }, nextFrame(...t) {
    return o.requestAnimationFrame(() => o.requestAnimationFrame(...t));
  }, setTimeout(...t) {
    let r = setTimeout(...t);
    return o.add(() => clearTimeout(r));
  }, microTask(...t) {
    let r = { current: !0 };
    return Dl(() => {
      r.current && t[0]();
    }), o.add(() => {
      r.current = !1;
    });
  }, add(t) {
    return e.push(t), () => {
      let r = e.indexOf(t);
      if (r >= 0) {
        let [a] = e.splice(r, 1);
        a();
      }
    };
  }, dispose() {
    for (let t of e.splice(0))
      t();
  }, async workQueue() {
    for (let t of n.splice(0))
      await t();
  } };
  return o;
}
function ua() {
  let [e] = ur(qn);
  return Nt(() => () => e.dispose(), [e]), e;
}
let Ne = function(e) {
  let n = Va(e);
  return y.useCallback((...o) => n.current(...o), [n]);
}, Tu = { serverHandoffComplete: !1 };
function Tl() {
  let [e, n] = ur(Tu.serverHandoffComplete);
  return Nt(() => {
    e !== !0 && n(!0);
  }, [e]), Nt(() => {
    Tu.serverHandoffComplete === !1 && (Tu.serverHandoffComplete = !0);
  }, []), e;
}
var bg;
let fP = 0;
function wg() {
  return ++fP;
}
let dr = (bg = y.useId) != null ? bg : function() {
  let e = Tl(), [n, o] = y.useState(e ? wg : null);
  return Xt(() => {
    n === null && o(wg());
  }, [n]), n != null ? "" + n : void 0;
};
function nr(e, n, ...o) {
  if (e in n) {
    let r = n[e];
    return typeof r == "function" ? r(...o) : r;
  }
  let t = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((r) => `"${r}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(t, nr), t;
}
function Vo(e) {
  return $l ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
let vd = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var tn = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(tn || {}), Js = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Js || {}), vP = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(vP || {});
function $f(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(vd));
}
var Vi = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(Vi || {});
function Ui(e, n = 0) {
  var o;
  return e === ((o = Vo(e)) == null ? void 0 : o.body) ? !1 : nr(n, { [0]() {
    return e.matches(vd);
  }, [1]() {
    let t = e;
    for (; t !== null; ) {
      if (t.matches(vd))
        return !0;
      t = t.parentElement;
    }
    return !1;
  } });
}
function Am(e) {
  let n = Vo(e);
  qn().nextFrame(() => {
    n && !Ui(n.activeElement, 0) && ia(e);
  });
}
function ia(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let gP = ["textarea", "input"].join(",");
function hP(e) {
  var n, o;
  return (o = (n = e == null ? void 0 : e.matches) == null ? void 0 : n.call(e, gP)) != null ? o : !1;
}
function qi(e, n = (o) => o) {
  return e.slice().sort((o, t) => {
    let r = n(o), a = n(t);
    if (r === null || a === null)
      return 0;
    let i = r.compareDocumentPosition(a);
    return i & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : i & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function mP(e, n) {
  return _n($f(), n, !0, e);
}
function _n(e, n, o = !0, t = null) {
  let r = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, a = Array.isArray(e) ? o ? qi(e) : e : $f(e);
  t = t ?? r.activeElement;
  let i = (() => {
    if (n & 5)
      return 1;
    if (n & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), s = (() => {
    if (n & 1)
      return 0;
    if (n & 2)
      return Math.max(0, a.indexOf(t)) - 1;
    if (n & 4)
      return Math.max(0, a.indexOf(t)) + 1;
    if (n & 8)
      return a.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), l = n & 32 ? { preventScroll: !0 } : {}, u = 0, c = a.length, p;
  do {
    if (u >= c || u + c <= 0)
      return 0;
    let h = s + u;
    if (n & 16)
      h = (h + c) % c;
    else {
      if (h < 0)
        return 3;
      if (h >= c)
        return 1;
    }
    p = a[h], p == null || p.focus(l), u += i;
  } while (p !== r.activeElement);
  return n & 6 && hP(p) && p.select(), p.hasAttribute("tabindex") || p.setAttribute("tabindex", "0"), 2;
}
function ju(e, n, o) {
  let t = Va(n);
  Nt(() => {
    function r(a) {
      t.current(a);
    }
    return document.addEventListener(e, r, o), () => document.removeEventListener(e, r, o);
  }, [e, o]);
}
function Ki(e, n, o = !0) {
  let t = St(!1);
  Nt(() => {
    requestAnimationFrame(() => {
      t.current = o;
    });
  }, [o]);
  function r(i, s) {
    if (!t.current || i.defaultPrevented)
      return;
    let l = function c(p) {
      return typeof p == "function" ? c(p()) : Array.isArray(p) || p instanceof Set ? p : [p];
    }(e), u = s(i);
    if (u !== null && u.ownerDocument.documentElement.contains(u)) {
      for (let c of l) {
        if (c === null)
          continue;
        let p = c instanceof HTMLElement ? c : c.current;
        if (p != null && p.contains(u))
          return;
      }
      return !Ui(u, Vi.Loose) && u.tabIndex !== -1 && i.preventDefault(), n(i, u);
    }
  }
  let a = St(null);
  ju("mousedown", (i) => {
    t.current && (a.current = i.target);
  }, !0), ju("click", (i) => {
    !a.current || (r(i, () => a.current), a.current = null);
  }, !0), ju("blur", (i) => r(i, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function xg(e) {
  var n;
  if (e.type)
    return e.type;
  let o = (n = e.as) != null ? n : "button";
  if (typeof o == "string" && o.toLowerCase() === "button")
    return "button";
}
function Qi(e, n) {
  let [o, t] = ur(() => xg(e));
  return Xt(() => {
    t(xg(e));
  }, [e.type, e.as]), Xt(() => {
    o || !n.current || n.current instanceof HTMLButtonElement && !n.current.hasAttribute("type") && t("button");
  }, [o, n]), o;
}
let Fm = Symbol();
function Lm(e, n = !0) {
  return Object.assign(e, { [Fm]: n });
}
function Jt(...e) {
  let n = St(e);
  Nt(() => {
    n.current = e;
  }, [e]);
  let o = Ne((t) => {
    for (let r of n.current)
      r != null && (typeof r == "function" ? r(t) : r.current = t);
  });
  return e.every((t) => t == null || (t == null ? void 0 : t[Fm])) ? void 0 : o;
}
function Df({ container: e, accept: n, walk: o, enabled: t = !0 }) {
  let r = St(n), a = St(o);
  Nt(() => {
    r.current = n, a.current = o;
  }, [n, o]), Xt(() => {
    if (!e || !t)
      return;
    let i = Vo(e);
    if (!i)
      return;
    let s = r.current, l = a.current, u = Object.assign((p) => s(p), { acceptNode: s }), c = i.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, u, !1);
    for (; c.nextNode(); )
      l(c.currentNode);
  }, [e, t, r, a]);
}
function yP(e) {
  throw new Error("Unexpected object: " + e);
}
var Yt = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(Yt || {});
function Tf(e, n) {
  let o = n.resolveItems();
  if (o.length <= 0)
    return null;
  let t = n.resolveActiveIndex(), r = t ?? -1, a = (() => {
    switch (e.focus) {
      case 0:
        return o.findIndex((i) => !n.resolveDisabled(i));
      case 1: {
        let i = o.slice().reverse().findIndex((s, l, u) => r !== -1 && u.length - l - 1 >= r ? !1 : !n.resolveDisabled(s));
        return i === -1 ? i : o.length - 1 - i;
      }
      case 2:
        return o.findIndex((i, s) => s <= r ? !1 : !n.resolveDisabled(i));
      case 3: {
        let i = o.slice().reverse().findIndex((s) => !n.resolveDisabled(s));
        return i === -1 ? i : o.length - 1 - i;
      }
      case 4:
        return o.findIndex((i) => n.resolveId(i) === e.id);
      case 5:
        return null;
      default:
        yP(e);
    }
  })();
  return a === -1 ? t : a;
}
var kn = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(kn || {}), bP = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(bP || {});
function Gt({ ourProps: e, theirProps: n, slot: o, defaultTag: t, features: r, visible: a = !0, name: i }) {
  let s = Nm(n, e);
  if (a)
    return Rs(s, o, t, i);
  let l = r ?? 0;
  if (l & 2) {
    let { static: u = !1, ...c } = s;
    if (u)
      return Rs(c, o, t, i);
  }
  if (l & 1) {
    let { unmount: u = !0, ...c } = s;
    return nr(u ? 0 : 1, { [0]() {
      return null;
    }, [1]() {
      return Rs({ ...c, hidden: !0, style: { display: "none" } }, o, t, i);
    } });
  }
  return Rs(s, o, t, i);
}
function Rs(e, n = {}, o, t) {
  let { as: r = o, children: a, refName: i = "ref", ...s } = _u(e, ["unmount", "static"]), l = e.ref !== void 0 ? { [i]: e.ref } : {}, u = typeof a == "function" ? a(n) : a;
  s.className && typeof s.className == "function" && (s.className = s.className(n));
  let c = {};
  if (n) {
    let p = !1, h = [];
    for (let [O, C] of Object.entries(n))
      typeof C == "boolean" && (p = !0), C === !0 && h.push(O);
    p && (c["data-headlessui-state"] = h.join(" "));
  }
  if (r === Or && Object.keys(Wa(s)).length > 0) {
    if (!jb(u) || Array.isArray(u) && u.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${t} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(s).map((p) => `  - ${p}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((p) => `  - ${p}`).join(`
`)].join(`
`));
    return Qd(u, Object.assign({}, Nm(u.props, Wa(_u(s, ["ref"]))), c, l, wP(u.ref, l.ref)));
  }
  return Xd(r, Object.assign({}, _u(s, ["ref"]), r !== Or && l, r !== Or && c), u);
}
function wP(...e) {
  return { ref: e.every((n) => n == null) ? void 0 : (n) => {
    for (let o of e)
      o != null && (typeof o == "function" ? o(n) : o.current = n);
  } };
}
function Nm(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let n = {}, o = {};
  for (let t of e)
    for (let r in t)
      r.startsWith("on") && typeof t[r] == "function" ? (o[r] != null || (o[r] = []), o[r].push(t[r])) : n[r] = t[r];
  if (n.disabled || n["aria-disabled"])
    return Object.assign(n, Object.fromEntries(Object.keys(o).map((t) => [t, void 0])));
  for (let t in o)
    Object.assign(n, { [t](r, ...a) {
      let i = o[t];
      for (let s of i) {
        if ((r instanceof Event || (r == null ? void 0 : r.nativeEvent) instanceof Event) && r.defaultPrevented)
          return;
        s(r, ...a);
      }
    } });
  return n;
}
function qt(e) {
  var n;
  return Object.assign(Ye(e), { displayName: (n = e.displayName) != null ? n : e.name });
}
function Wa(e) {
  let n = Object.assign({}, e);
  for (let o in n)
    n[o] === void 0 && delete n[o];
  return n;
}
function _u(e, n = []) {
  let o = Object.assign({}, e);
  for (let t of n)
    t in o && delete o[t];
  return o;
}
function va(e) {
  let n = e.parentElement, o = null;
  for (; n && !(n instanceof HTMLFieldSetElement); )
    n instanceof HTMLLegendElement && (o = n), n = n.parentElement;
  let t = (n == null ? void 0 : n.getAttribute("disabled")) === "";
  return t && xP(o) ? !1 : t;
}
function xP(e) {
  if (!e)
    return !1;
  let n = e.previousElementSibling;
  for (; n !== null; ) {
    if (n instanceof HTMLLegendElement)
      return !1;
    n = n.previousElementSibling;
  }
  return !0;
}
function jl(e = {}, n = null, o = []) {
  for (let [t, r] of Object.entries(e))
    Wm(o, Bm(n, t), r);
  return o;
}
function Bm(e, n) {
  return e ? e + "[" + n + "]" : n;
}
function Wm(e, n, o) {
  if (Array.isArray(o))
    for (let [t, r] of o.entries())
      Wm(e, Bm(n, t.toString()), r);
  else
    o instanceof Date ? e.push([n, o.toISOString()]) : typeof o == "boolean" ? e.push([n, o ? "1" : "0"]) : typeof o == "string" ? e.push([n, o]) : typeof o == "number" ? e.push([n, `${o}`]) : o == null ? e.push([n, ""]) : jl(o, n, e);
}
function zm(e) {
  var n;
  let o = (n = e == null ? void 0 : e.form) != null ? n : e.closest("form");
  if (o) {
    for (let t of o.elements)
      if (t.tagName === "INPUT" && t.type === "submit" || t.tagName === "BUTTON" && t.type === "submit" || t.nodeName === "INPUT" && t.type === "image") {
        t.click();
        return;
      }
  }
}
let CP = "div";
var Kn = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Kn || {});
let fo = qt(function(e, n) {
  let { features: o = 1, ...t } = e, r = { ref: n, "aria-hidden": (o & 2) === 2 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(o & 4) === 4 && (o & 2) !== 2 && { display: "none" } } };
  return Gt({ ourProps: r, theirProps: t, slot: {}, defaultTag: CP, name: "Hidden" });
}), jf = Xr(null);
jf.displayName = "OpenClosedContext";
var rn = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(rn || {});
function Ua() {
  return Yr(jf);
}
function _l({ value: e, children: n }) {
  return y.createElement(jf.Provider, { value: e }, n);
}
var Je = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(Je || {});
function Il(e, n, o) {
  let [t, r] = ur(o), a = e !== void 0;
  return [a ? e : t, Ne((i) => (a || r(i), n == null ? void 0 : n(i)))];
}
function _f(e, n) {
  let o = St([]), t = Ne(e);
  Nt(() => {
    let r = [...o.current];
    for (let [a, i] of n.entries())
      if (o.current[a] !== i) {
        let s = t(n, r);
        return o.current = n, s;
      }
  }, [t, ...n]);
}
var SP = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(SP || {}), OP = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(OP || {}), PP = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(PP || {}), EP = ((e) => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.RegisterOption = 3] = "RegisterOption", e[e.UnregisterOption = 4] = "UnregisterOption", e))(EP || {});
function Iu(e, n = (o) => o) {
  let o = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, t = qi(n(e.options.slice()), (a) => a.dataRef.current.domRef.current), r = o ? t.indexOf(o) : null;
  return r === -1 && (r = null), { options: t, activeOptionIndex: r };
}
let kP = { [1](e) {
  return e.dataRef.current.disabled || e.comboboxState === 1 ? e : { ...e, activeOptionIndex: null, comboboxState: 1 };
}, [0](e) {
  if (e.dataRef.current.disabled || e.comboboxState === 0)
    return e;
  let n = e.activeOptionIndex, { isSelected: o } = e.dataRef.current, t = e.options.findIndex((r) => o(r.dataRef.current.value));
  return t !== -1 && (n = t), { ...e, comboboxState: 0, activeOptionIndex: n };
}, [2](e, n) {
  var o;
  if (e.dataRef.current.disabled || e.dataRef.current.optionsRef.current && !e.dataRef.current.optionsPropsRef.current.static && e.comboboxState === 1)
    return e;
  let t = Iu(e);
  if (t.activeOptionIndex === null) {
    let a = t.options.findIndex((i) => !i.dataRef.current.disabled);
    a !== -1 && (t.activeOptionIndex = a);
  }
  let r = Tf(n, { resolveItems: () => t.options, resolveActiveIndex: () => t.activeOptionIndex, resolveId: (a) => a.id, resolveDisabled: (a) => a.dataRef.current.disabled });
  return { ...e, ...t, activeOptionIndex: r, activationTrigger: (o = n.trigger) != null ? o : 1 };
}, [3]: (e, n) => {
  let o = { id: n.id, dataRef: n.dataRef }, t = Iu(e, (a) => [...a, o]);
  e.activeOptionIndex === null && e.dataRef.current.isSelected(n.dataRef.current.value) && (t.activeOptionIndex = t.options.indexOf(o));
  let r = { ...e, ...t, activationTrigger: 1 };
  return e.dataRef.current.__demoMode && e.dataRef.current.value === void 0 && (r.activeOptionIndex = 0), r;
}, [4]: (e, n) => {
  let o = Iu(e, (t) => {
    let r = t.findIndex((a) => a.id === n.id);
    return r !== -1 && t.splice(r, 1), t;
  });
  return { ...e, ...o, activationTrigger: 1 };
} }, If = Xr(null);
If.displayName = "ComboboxActionsContext";
function Ml(e) {
  let n = Yr(If);
  if (n === null) {
    let o = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, Ml), o;
  }
  return n;
}
let Mf = Xr(null);
Mf.displayName = "ComboboxDataContext";
function qa(e) {
  let n = Yr(Mf);
  if (n === null) {
    let o = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, qa), o;
  }
  return n;
}
function RP(e, n) {
  return nr(n.type, kP, e, n);
}
let $P = Or;
function DP(e, n) {
  let { value: o, defaultValue: t, onChange: r, name: a, by: i = (he, K) => he === K, disabled: s = !1, __demoMode: l = !1, nullable: u = !1, multiple: c = !1, ...p } = e, [h, O] = Il(o, r, t), [C, P] = da(RP, { dataRef: io(), comboboxState: l ? 0 : 1, options: [], activeOptionIndex: null, activationTrigger: 1 }), k = St(!1), $ = St({ static: !1, hold: !1 }), I = St(null), H = St(null), x = St(null), _ = St(null), F = Ne(typeof i == "string" ? (he, K) => {
    let le = i;
    return (he == null ? void 0 : he[le]) === (K == null ? void 0 : K[le]);
  } : i), G = It((he) => nr(Q.mode, { [1]: () => h.some((K) => F(K, he)), [0]: () => F(h, he) }), [h]), Q = at(() => ({ ...C, optionsPropsRef: $, labelRef: I, inputRef: H, buttonRef: x, optionsRef: _, value: h, disabled: s, mode: c ? 1 : 0, get activeOptionIndex() {
    if (k.current && C.activeOptionIndex === null && C.options.length > 0) {
      let he = C.options.findIndex((K) => !K.dataRef.current.disabled);
      if (he !== -1)
        return he;
    }
    return C.activeOptionIndex;
  }, compare: F, isSelected: G, nullable: u, __demoMode: l }), [h, s, c, u, l, C]);
  Xt(() => {
    C.dataRef.current = Q;
  }, [Q]), Ki([Q.buttonRef, Q.inputRef, Q.optionsRef], () => P({ type: 1 }), Q.comboboxState === 0);
  let V = at(() => ({ open: Q.comboboxState === 0, disabled: s, activeIndex: Q.activeOptionIndex, activeOption: Q.activeOptionIndex === null ? null : Q.options[Q.activeOptionIndex].dataRef.current.value, value: h }), [Q, s, h]), ie = Ne((he) => {
    let K = Q.options.find((le) => le.id === he);
    !K || oe(K.dataRef.current.value);
  }), ce = Ne(() => {
    if (Q.activeOptionIndex !== null) {
      let { dataRef: he, id: K } = Q.options[Q.activeOptionIndex];
      oe(he.current.value), P({ type: 2, focus: Yt.Specific, id: K });
    }
  }), me = Ne(() => {
    P({ type: 0 }), k.current = !0;
  }), ve = Ne(() => {
    P({ type: 1 }), k.current = !1;
  }), U = Ne((he, K, le) => (k.current = !1, he === Yt.Specific ? P({ type: 2, focus: Yt.Specific, id: K, trigger: le }) : P({ type: 2, focus: he, trigger: le }))), ee = Ne((he, K) => (P({ type: 3, id: he, dataRef: K }), () => P({ type: 4, id: he }))), oe = Ne((he) => nr(Q.mode, { [0]() {
    return O == null ? void 0 : O(he);
  }, [1]() {
    let K = Q.value.slice(), le = K.findIndex((Pe) => F(Pe, he));
    return le === -1 ? K.push(he) : K.splice(le, 1), O == null ? void 0 : O(K);
  } })), ge = at(() => ({ onChange: oe, registerOption: ee, goToOption: U, closeCombobox: ve, openCombobox: me, selectActiveOption: ce, selectOption: ie }), []), be = n === null ? {} : { ref: n };
  return y.createElement(If.Provider, { value: ge }, y.createElement(Mf.Provider, { value: Q }, y.createElement(_l, { value: nr(Q.comboboxState, { [0]: rn.Open, [1]: rn.Closed }) }, a != null && h != null && jl({ [a]: h }).map(([he, K]) => y.createElement(fo, { features: Kn.Hidden, ...Wa({ key: he, as: "input", type: "hidden", hidden: !0, readOnly: !0, name: he, value: K }) })), Gt({ ourProps: be, theirProps: p, slot: V, defaultTag: $P, name: "Combobox" }))));
}
let TP = qt(DP), jP = "input", _P = qt(function(e, n) {
  var o, t;
  let { value: r, onChange: a, displayValue: i, type: s = "text", ...l } = e, u = qa("Combobox.Input"), c = Ml("Combobox.Input"), p = Jt(u.inputRef, n), h = `headlessui-combobox-input-${dr()}`, O = ua(), C = at(() => {
    var x;
    return typeof i == "function" ? (x = i(u.value)) != null ? x : "" : typeof u.value == "string" ? u.value : "";
  }, [u.value]);
  _f(([x, _], [F, G]) => {
    !u.inputRef.current || (G === 0 && _ === 1 || x !== F) && (u.inputRef.current.value = x);
  }, [C, u.comboboxState]);
  let P = Ne((x) => {
    switch (x.key) {
      case Je.Backspace:
      case Je.Delete:
        if (u.mode !== 0 || !u.nullable)
          return;
        let _ = x.currentTarget;
        O.requestAnimationFrame(() => {
          _.value === "" && (c.onChange(null), u.optionsRef.current && (u.optionsRef.current.scrollTop = 0), c.goToOption(Yt.Nothing));
        });
        break;
      case Je.Enter:
        if (u.comboboxState !== 0)
          return;
        if (x.preventDefault(), x.stopPropagation(), u.activeOptionIndex === null) {
          c.closeCombobox();
          return;
        }
        c.selectActiveOption(), u.mode === 0 && c.closeCombobox();
        break;
      case Je.ArrowDown:
        return x.preventDefault(), x.stopPropagation(), nr(u.comboboxState, { [0]: () => {
          c.goToOption(Yt.Next);
        }, [1]: () => {
          c.openCombobox();
        } });
      case Je.ArrowUp:
        return x.preventDefault(), x.stopPropagation(), nr(u.comboboxState, { [0]: () => {
          c.goToOption(Yt.Previous);
        }, [1]: () => {
          c.openCombobox(), O.nextFrame(() => {
            u.value || c.goToOption(Yt.Last);
          });
        } });
      case Je.Home:
      case Je.PageUp:
        return x.preventDefault(), x.stopPropagation(), c.goToOption(Yt.First);
      case Je.End:
      case Je.PageDown:
        return x.preventDefault(), x.stopPropagation(), c.goToOption(Yt.Last);
      case Je.Escape:
        return u.comboboxState !== 0 ? void 0 : (x.preventDefault(), u.optionsRef.current && !u.optionsPropsRef.current.static && x.stopPropagation(), c.closeCombobox());
      case Je.Tab:
        if (u.comboboxState !== 0)
          return;
        u.mode === 0 && c.selectActiveOption(), c.closeCombobox();
        break;
    }
  }), k = Ne((x) => {
    c.openCombobox(), a == null || a(x);
  }), $ = Gi(() => {
    if (u.labelRef.current)
      return [u.labelRef.current.id].join(" ");
  }, [u.labelRef.current]), I = at(() => ({ open: u.comboboxState === 0, disabled: u.disabled }), [u]), H = { ref: p, id: h, role: "combobox", type: s, "aria-controls": (o = u.optionsRef.current) == null ? void 0 : o.id, "aria-expanded": u.disabled ? void 0 : u.comboboxState === 0, "aria-activedescendant": u.activeOptionIndex === null || (t = u.options[u.activeOptionIndex]) == null ? void 0 : t.id, "aria-multiselectable": u.mode === 1 ? !0 : void 0, "aria-labelledby": $, disabled: u.disabled, onKeyDown: P, onChange: k };
  return Gt({ ourProps: H, theirProps: l, slot: I, defaultTag: jP, name: "Combobox.Input" });
}), IP = "button", MP = qt(function(e, n) {
  var o;
  let t = qa("Combobox.Button"), r = Ml("Combobox.Button"), a = Jt(t.buttonRef, n), i = `headlessui-combobox-button-${dr()}`, s = ua(), l = Ne((C) => {
    switch (C.key) {
      case Je.ArrowDown:
        return C.preventDefault(), C.stopPropagation(), t.comboboxState === 1 && r.openCombobox(), s.nextFrame(() => {
          var P;
          return (P = t.inputRef.current) == null ? void 0 : P.focus({ preventScroll: !0 });
        });
      case Je.ArrowUp:
        return C.preventDefault(), C.stopPropagation(), t.comboboxState === 1 && (r.openCombobox(), s.nextFrame(() => {
          t.value || r.goToOption(Yt.Last);
        })), s.nextFrame(() => {
          var P;
          return (P = t.inputRef.current) == null ? void 0 : P.focus({ preventScroll: !0 });
        });
      case Je.Escape:
        return t.comboboxState !== 0 ? void 0 : (C.preventDefault(), t.optionsRef.current && !t.optionsPropsRef.current.static && C.stopPropagation(), r.closeCombobox(), s.nextFrame(() => {
          var P;
          return (P = t.inputRef.current) == null ? void 0 : P.focus({ preventScroll: !0 });
        }));
      default:
        return;
    }
  }), u = Ne((C) => {
    if (va(C.currentTarget))
      return C.preventDefault();
    t.comboboxState === 0 ? r.closeCombobox() : (C.preventDefault(), r.openCombobox()), s.nextFrame(() => {
      var P;
      return (P = t.inputRef.current) == null ? void 0 : P.focus({ preventScroll: !0 });
    });
  }), c = Gi(() => {
    if (t.labelRef.current)
      return [t.labelRef.current.id, i].join(" ");
  }, [t.labelRef.current, i]), p = at(() => ({ open: t.comboboxState === 0, disabled: t.disabled, value: t.value }), [t]), h = e, O = { ref: a, id: i, type: Qi(e, t.buttonRef), tabIndex: -1, "aria-haspopup": !0, "aria-controls": (o = t.optionsRef.current) == null ? void 0 : o.id, "aria-expanded": t.disabled ? void 0 : t.comboboxState === 0, "aria-labelledby": c, disabled: t.disabled, onClick: u, onKeyDown: l };
  return Gt({ ourProps: O, theirProps: h, slot: p, defaultTag: IP, name: "Combobox.Button" });
}), AP = "label", FP = qt(function(e, n) {
  let o = qa("Combobox.Label"), t = `headlessui-combobox-label-${dr()}`, r = Jt(o.labelRef, n), a = Ne(() => {
    var s;
    return (s = o.inputRef.current) == null ? void 0 : s.focus({ preventScroll: !0 });
  }), i = at(() => ({ open: o.comboboxState === 0, disabled: o.disabled }), [o]);
  return Gt({ ourProps: { ref: r, id: t, onClick: a }, theirProps: e, slot: i, defaultTag: AP, name: "Combobox.Label" });
}), LP = "ul", NP = kn.RenderStrategy | kn.Static, BP = qt(function(e, n) {
  var o;
  let { hold: t = !1, ...r } = e, a = qa("Combobox.Options"), i = Jt(a.optionsRef, n), s = `headlessui-combobox-options-${dr()}`, l = Ua(), u = (() => l !== null ? l === rn.Open : a.comboboxState === 0)();
  Xt(() => {
    var O;
    a.optionsPropsRef.current.static = (O = e.static) != null ? O : !1;
  }, [a.optionsPropsRef, e.static]), Xt(() => {
    a.optionsPropsRef.current.hold = t;
  }, [a.optionsPropsRef, t]), Df({ container: a.optionsRef.current, enabled: a.comboboxState === 0, accept(O) {
    return O.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : O.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(O) {
    O.setAttribute("role", "none");
  } });
  let c = Gi(() => {
    var O, C, P;
    return (P = (O = a.labelRef.current) == null ? void 0 : O.id) != null ? P : (C = a.buttonRef.current) == null ? void 0 : C.id;
  }, [a.labelRef.current, a.buttonRef.current]), p = at(() => ({ open: a.comboboxState === 0 }), [a]), h = { "aria-activedescendant": a.activeOptionIndex === null || (o = a.options[a.activeOptionIndex]) == null ? void 0 : o.id, "aria-labelledby": c, role: "listbox", id: s, ref: i };
  return Gt({ ourProps: h, theirProps: r, slot: p, defaultTag: LP, features: NP, visible: u, name: "Combobox.Options" });
}), WP = "li", zP = qt(function(e, n) {
  var o, t;
  let { disabled: r = !1, value: a, ...i } = e, s = qa("Combobox.Option"), l = Ml("Combobox.Option"), u = `headlessui-combobox-option-${dr()}`, c = s.activeOptionIndex !== null ? s.options[s.activeOptionIndex].id === u : !1, p = s.isSelected(a), h = St(null), O = Va({ disabled: r, value: a, domRef: h, textValue: (t = (o = h.current) == null ? void 0 : o.textContent) == null ? void 0 : t.toLowerCase() }), C = Jt(n, h), P = Ne(() => l.selectOption(u));
  Xt(() => l.registerOption(u, O), [O, u]);
  let k = St(!s.__demoMode);
  Xt(() => {
    if (!s.__demoMode)
      return;
    let F = qn();
    return F.requestAnimationFrame(() => {
      k.current = !0;
    }), F.dispose;
  }, []), Xt(() => {
    if (s.comboboxState !== 0 || !c || !k.current || s.activationTrigger === 0)
      return;
    let F = qn();
    return F.requestAnimationFrame(() => {
      var G, Q;
      (Q = (G = h.current) == null ? void 0 : G.scrollIntoView) == null || Q.call(G, { block: "nearest" });
    }), F.dispose;
  }, [h, c, s.comboboxState, s.activationTrigger, s.activeOptionIndex]);
  let $ = Ne((F) => {
    if (r)
      return F.preventDefault();
    P(), s.mode === 0 && l.closeCombobox();
  }), I = Ne(() => {
    if (r)
      return l.goToOption(Yt.Nothing);
    l.goToOption(Yt.Specific, u);
  }), H = Ne(() => {
    r || c || l.goToOption(Yt.Specific, u, 0);
  }), x = Ne(() => {
    r || !c || s.optionsPropsRef.current.hold || l.goToOption(Yt.Nothing);
  }), _ = at(() => ({ active: c, selected: p, disabled: r }), [c, p, r]);
  return Gt({ ourProps: { id: u, ref: C, role: "option", tabIndex: r === !0 ? void 0 : -1, "aria-disabled": r === !0 ? !0 : void 0, "aria-selected": p, disabled: void 0, onClick: $, onFocus: I, onPointerMove: H, onMouseMove: H, onPointerLeave: x, onMouseLeave: x }, theirProps: i, slot: _, defaultTag: WP, name: "Combobox.Option" });
}), ja = Object.assign(TP, { Input: _P, Button: MP, Label: FP, Options: BP, Option: zP });
function HP(e, n, o) {
  let t = Va(n);
  Nt(() => {
    function r(a) {
      t.current(a);
    }
    return window.addEventListener(e, r, o), () => window.removeEventListener(e, r, o);
  }, [e, o]);
}
var mo = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(mo || {});
function Af() {
  let e = St(0);
  return HP("keydown", (n) => {
    n.key === "Tab" && (e.current = n.shiftKey ? 1 : 0);
  }, !0), e;
}
function Hm() {
  let e = St(!1);
  return Xt(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function Uo(...e) {
  return at(() => Vo(...e), [...e]);
}
function Al(e, n, o, t) {
  let r = Va(o);
  Nt(() => {
    e = e ?? window;
    function a(i) {
      r.current(i);
    }
    return e.addEventListener(n, a, t), () => e.removeEventListener(n, a, t);
  }, [e, n, t]);
}
let YP = "div";
var Ym = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(Ym || {});
let vi = Object.assign(qt(function(e, n) {
  let o = St(null), t = Jt(o, n), { initialFocus: r, containers: a, features: i = 30, ...s } = e;
  Tl() || (i = 1);
  let l = Uo(o);
  GP({ ownerDocument: l }, !!(i & 16));
  let u = VP({ ownerDocument: l, container: o, initialFocus: r }, !!(i & 2));
  UP({ ownerDocument: l, container: o, containers: a, previousActiveElement: u }, !!(i & 8));
  let c = Af(), p = Ne(() => {
    let O = o.current;
    !O || nr(c.current, { [mo.Forwards]: () => _n(O, tn.First), [mo.Backwards]: () => _n(O, tn.Last) });
  }), h = { ref: t };
  return y.createElement(y.Fragment, null, !!(i & 4) && y.createElement(fo, { as: "button", type: "button", onFocus: p, features: Kn.Focusable }), Gt({ ourProps: h, theirProps: s, defaultTag: YP, name: "FocusTrap" }), !!(i & 4) && y.createElement(fo, { as: "button", type: "button", onFocus: p, features: Kn.Focusable }));
}), { features: Ym });
function GP({ ownerDocument: e }, n) {
  let o = St(null);
  Al(e == null ? void 0 : e.defaultView, "focusout", (r) => {
    !n || o.current || (o.current = r.target);
  }, !0), _f(() => {
    n || ((e == null ? void 0 : e.activeElement) === (e == null ? void 0 : e.body) && ia(o.current), o.current = null);
  }, [n]);
  let t = St(!1);
  Nt(() => (t.current = !1, () => {
    t.current = !0, Dl(() => {
      !t.current || (ia(o.current), o.current = null);
    });
  }), []);
}
function VP({ ownerDocument: e, container: n, initialFocus: o }, t) {
  let r = St(null), a = Hm();
  return _f(() => {
    if (!t)
      return;
    let i = n.current;
    !i || Dl(() => {
      if (!a.current)
        return;
      let s = e == null ? void 0 : e.activeElement;
      if (o != null && o.current) {
        if ((o == null ? void 0 : o.current) === s) {
          r.current = s;
          return;
        }
      } else if (i.contains(s)) {
        r.current = s;
        return;
      }
      o != null && o.current ? ia(o.current) : _n(i, tn.First) === Js.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), r.current = e == null ? void 0 : e.activeElement;
    });
  }, [t]), r;
}
function UP({ ownerDocument: e, container: n, containers: o, previousActiveElement: t }, r) {
  let a = Hm();
  Al(e == null ? void 0 : e.defaultView, "focus", (i) => {
    if (!r || !a.current)
      return;
    let s = new Set(o == null ? void 0 : o.current);
    s.add(n);
    let l = t.current;
    if (!l)
      return;
    let u = i.target;
    u && u instanceof HTMLElement ? qP(s, u) ? (t.current = u, ia(u)) : (i.preventDefault(), i.stopPropagation(), ia(l)) : ia(t.current);
  }, !0);
}
function qP(e, n) {
  var o;
  for (let t of e)
    if ((o = t.current) != null && o.contains(n))
      return !0;
  return !1;
}
let Ea = /* @__PURE__ */ new Set(), _o = /* @__PURE__ */ new Map();
function Cg(e) {
  e.setAttribute("aria-hidden", "true"), e.inert = !0;
}
function Sg(e) {
  let n = _o.get(e);
  !n || (n["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n["aria-hidden"]), e.inert = n.inert);
}
function KP(e, n = !0) {
  Xt(() => {
    if (!n || !e.current)
      return;
    let o = e.current, t = Vo(o);
    if (t) {
      Ea.add(o);
      for (let r of _o.keys())
        r.contains(o) && (Sg(r), _o.delete(r));
      return t.querySelectorAll("body > *").forEach((r) => {
        if (r instanceof HTMLElement) {
          for (let a of Ea)
            if (r.contains(a))
              return;
          Ea.size === 1 && (_o.set(r, { "aria-hidden": r.getAttribute("aria-hidden"), inert: r.inert }), Cg(r));
        }
      }), () => {
        if (Ea.delete(o), Ea.size > 0)
          t.querySelectorAll("body > *").forEach((r) => {
            if (r instanceof HTMLElement && !_o.has(r)) {
              for (let a of Ea)
                if (r.contains(a))
                  return;
              _o.set(r, { "aria-hidden": r.getAttribute("aria-hidden"), inert: r.inert }), Cg(r);
            }
          });
        else
          for (let r of _o.keys())
            Sg(r), _o.delete(r);
      };
    }
  }, [n]);
}
let Gm = Xr(!1);
function QP() {
  return Yr(Gm);
}
function gd(e) {
  return y.createElement(Gm.Provider, { value: e.force }, e.children);
}
function XP(e) {
  let n = QP(), o = Yr(Vm), t = Uo(e), [r, a] = ur(() => {
    if (!n && o !== null || $l)
      return null;
    let i = t == null ? void 0 : t.getElementById("headlessui-portal-root");
    if (i)
      return i;
    if (t === null)
      return null;
    let s = t.createElement("div");
    return s.setAttribute("id", "headlessui-portal-root"), t.body.appendChild(s);
  });
  return Nt(() => {
    r !== null && (t != null && t.body.contains(r) || t == null || t.body.appendChild(r));
  }, [r, t]), Nt(() => {
    n || o !== null && a(o.current);
  }, [o, a, n]), r;
}
let JP = Or, ZP = qt(function(e, n) {
  let o = e, t = St(null), r = Jt(Lm((c) => {
    t.current = c;
  }), n), a = Uo(t), i = XP(t), [s] = ur(() => {
    var c;
    return $l ? null : (c = a == null ? void 0 : a.createElement("div")) != null ? c : null;
  }), l = Tl(), u = St(!1);
  return Xt(() => {
    if (u.current = !1, !(!i || !s))
      return i.contains(s) || (s.setAttribute("data-headlessui-portal", ""), i.appendChild(s)), () => {
        u.current = !0, Dl(() => {
          var c;
          !u.current || !i || !s || (i.removeChild(s), i.childNodes.length <= 0 && ((c = i.parentElement) == null || c.removeChild(i)));
        });
      };
  }, [i, s]), l ? !i || !s ? null : _h(Gt({ ourProps: { ref: r }, theirProps: o, defaultTag: JP, name: "Portal" }), s) : null;
}), eE = Or, Vm = Xr(null), tE = qt(function(e, n) {
  let { target: o, ...t } = e, r = { ref: Jt(n) };
  return y.createElement(Vm.Provider, { value: o }, Gt({ ourProps: r, theirProps: t, defaultTag: eE, name: "Popover.Group" }));
}), hd = Object.assign(ZP, { Group: tE }), Um = Xr(null);
function qm() {
  let e = Yr(Um);
  if (e === null) {
    let n = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(n, qm), n;
  }
  return e;
}
function Fl() {
  let [e, n] = ur([]);
  return [e.length > 0 ? e.join(" ") : void 0, at(() => function(o) {
    let t = Ne((a) => (n((i) => [...i, a]), () => n((i) => {
      let s = i.slice(), l = s.indexOf(a);
      return l !== -1 && s.splice(l, 1), s;
    }))), r = at(() => ({ register: t, slot: o.slot, name: o.name, props: o.props }), [t, o.slot, o.name, o.props]);
    return y.createElement(Um.Provider, { value: r }, o.children);
  }, [n])];
}
let rE = "p", Ff = qt(function(e, n) {
  let o = qm(), t = `headlessui-description-${dr()}`, r = Jt(n);
  Xt(() => o.register(t), [t, o.register]);
  let a = e, i = { ref: r, ...o.props, id: t };
  return Gt({ ourProps: i, theirProps: a, slot: o.slot || {}, defaultTag: rE, name: o.name || "Description" });
}), Lf = Xr(() => {
});
Lf.displayName = "StackContext";
var md = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(md || {});
function nE() {
  return Yr(Lf);
}
function oE({ children: e, onUpdate: n, type: o, element: t, enabled: r }) {
  let a = nE(), i = Ne((...s) => {
    n == null || n(...s), a(...s);
  });
  return Xt(() => {
    let s = r === void 0 || r === !0;
    return s && i(0, o, t), () => {
      s && i(1, o, t);
    };
  }, [i, o, t, r]), y.createElement(Lf.Provider, { value: i }, e);
}
function aE() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
var iE = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(iE || {}), sE = ((e) => (e[e.SetTitleId = 0] = "SetTitleId", e))(sE || {});
let lE = { [0](e, n) {
  return e.titleId === n.id ? e : { ...e, titleId: n.id };
} }, Zs = Xr(null);
Zs.displayName = "DialogContext";
function Xi(e) {
  let n = Yr(Zs);
  if (n === null) {
    let o = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, Xi), o;
  }
  return n;
}
function uE(e, n) {
  Nt(() => {
    var o;
    if (!n || !e)
      return;
    let t = qn();
    function r(s, l, u) {
      let c = s.style.getPropertyValue(l);
      return Object.assign(s.style, { [l]: u }), t.add(() => {
        Object.assign(s.style, { [l]: c });
      });
    }
    let a = e.documentElement, i = ((o = e.defaultView) != null ? o : window).innerWidth - a.clientWidth;
    if (r(a, "overflow", "hidden"), i > 0) {
      let s = a.clientWidth - a.offsetWidth, l = i - s;
      r(a, "paddingRight", `${l}px`);
    }
    if (aE()) {
      t.addEventListener(e, "touchmove", (l) => {
        l.preventDefault();
      }, { passive: !1 });
      let s = window.pageYOffset;
      t.add(() => window.scrollTo(0, s));
    }
    return t.dispose;
  }, [e, n]);
}
function cE(e, n) {
  return nr(n.type, lE, e, n);
}
let dE = "div", pE = kn.RenderStrategy | kn.Static, fE = qt(function(e, n) {
  let { open: o, onClose: t, initialFocus: r, __demoMode: a = !1, ...i } = e, [s, l] = ur(0), u = Ua();
  o === void 0 && u !== null && (o = nr(u, { [rn.Open]: !0, [rn.Closed]: !1 }));
  let c = St(/* @__PURE__ */ new Set()), p = St(null), h = Jt(p, n), O = St(null), C = Uo(p), P = e.hasOwnProperty("open") || u !== null, k = e.hasOwnProperty("onClose");
  if (!P && !k)
    throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!P)
    throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!k)
    throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof o != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${o}`);
  if (typeof t != "function")
    throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${t}`);
  let $ = o ? 0 : 1, [I, H] = da(cE, { titleId: null, descriptionId: null, panelRef: io() }), x = Ne(() => t(!1)), _ = Ne((oe) => H({ type: 0, id: oe })), F = Tl() ? a ? !1 : $ === 0 : !1, G = s > 1, Q = Yr(Zs) !== null, V = G ? "parent" : "leaf";
  KP(p, G ? F : !1), Ki(() => {
    var oe, ge;
    return [...Array.from((oe = C == null ? void 0 : C.querySelectorAll("body > *, [data-headlessui-portal]")) != null ? oe : []).filter((be) => !(!(be instanceof HTMLElement) || be.contains(O.current) || I.panelRef.current && be.contains(I.panelRef.current))), (ge = I.panelRef.current) != null ? ge : p.current];
  }, x, F && !G), Al(C == null ? void 0 : C.defaultView, "keydown", (oe) => {
    oe.defaultPrevented || oe.key === Je.Escape && $ === 0 && (G || (oe.preventDefault(), oe.stopPropagation(), x()));
  }), uE(C, $ === 0 && !Q), Nt(() => {
    if ($ !== 0 || !p.current)
      return;
    let oe = new IntersectionObserver((ge) => {
      for (let be of ge)
        be.boundingClientRect.x === 0 && be.boundingClientRect.y === 0 && be.boundingClientRect.width === 0 && be.boundingClientRect.height === 0 && x();
    });
    return oe.observe(p.current), () => oe.disconnect();
  }, [$, p, x]);
  let [ie, ce] = Fl(), me = `headlessui-dialog-${dr()}`, ve = at(() => [{ dialogState: $, close: x, setTitleId: _ }, I], [$, I, x, _]), U = at(() => ({ open: $ === 0 }), [$]), ee = { ref: h, id: me, role: "dialog", "aria-modal": $ === 0 ? !0 : void 0, "aria-labelledby": I.titleId, "aria-describedby": ie };
  return y.createElement(oE, { type: "Dialog", enabled: $ === 0, element: p, onUpdate: Ne((oe, ge, be) => {
    ge === "Dialog" && nr(oe, { [md.Add]() {
      c.current.add(be), l((he) => he + 1);
    }, [md.Remove]() {
      c.current.add(be), l((he) => he - 1);
    } });
  }) }, y.createElement(gd, { force: !0 }, y.createElement(hd, null, y.createElement(Zs.Provider, { value: ve }, y.createElement(hd.Group, { target: p }, y.createElement(gd, { force: !1 }, y.createElement(ce, { slot: U, name: "Dialog.Description" }, y.createElement(vi, { initialFocus: r, containers: c, features: F ? nr(V, { parent: vi.features.RestoreFocus, leaf: vi.features.All & ~vi.features.FocusLock }) : vi.features.None }, Gt({ ourProps: ee, theirProps: i, slot: U, defaultTag: dE, features: pE, visible: $ === 0, name: "Dialog" })))))))), y.createElement(fo, { features: Kn.Hidden, ref: O }));
}), vE = "div", gE = qt(function(e, n) {
  let [{ dialogState: o, close: t }] = Xi("Dialog.Overlay"), r = Jt(n), a = `headlessui-dialog-overlay-${dr()}`, i = Ne((l) => {
    if (l.target === l.currentTarget) {
      if (va(l.currentTarget))
        return l.preventDefault();
      l.preventDefault(), l.stopPropagation(), t();
    }
  }), s = at(() => ({ open: o === 0 }), [o]);
  return Gt({ ourProps: { ref: r, id: a, "aria-hidden": !0, onClick: i }, theirProps: e, slot: s, defaultTag: vE, name: "Dialog.Overlay" });
}), hE = "div", mE = qt(function(e, n) {
  let [{ dialogState: o }, t] = Xi("Dialog.Backdrop"), r = Jt(n), a = `headlessui-dialog-backdrop-${dr()}`;
  Nt(() => {
    if (t.panelRef.current === null)
      throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
  }, [t.panelRef]);
  let i = at(() => ({ open: o === 0 }), [o]);
  return y.createElement(gd, { force: !0 }, y.createElement(hd, null, Gt({ ourProps: { ref: r, id: a, "aria-hidden": !0 }, theirProps: e, slot: i, defaultTag: hE, name: "Dialog.Backdrop" })));
}), yE = "div", bE = qt(function(e, n) {
  let [{ dialogState: o }, t] = Xi("Dialog.Panel"), r = Jt(n, t.panelRef), a = `headlessui-dialog-panel-${dr()}`, i = at(() => ({ open: o === 0 }), [o]), s = Ne((l) => {
    l.stopPropagation();
  });
  return Gt({ ourProps: { ref: r, id: a, onClick: s }, theirProps: e, slot: i, defaultTag: yE, name: "Dialog.Panel" });
}), wE = "h2", xE = qt(function(e, n) {
  let [{ dialogState: o, setTitleId: t }] = Xi("Dialog.Title"), r = `headlessui-dialog-title-${dr()}`, a = Jt(n);
  Nt(() => (t(r), () => t(null)), [r, t]);
  let i = at(() => ({ open: o === 0 }), [o]);
  return Gt({ ourProps: { ref: a, id: r }, theirProps: e, slot: i, defaultTag: wE, name: "Dialog.Title" });
}), Lo = Object.assign(fE, { Backdrop: mE, Panel: bE, Overlay: gE, Title: xE, Description: Ff });
var CE = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(CE || {}), SE = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(SE || {}), OE = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(OE || {}), PE = ((e) => (e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.SetDisabled = 2] = "SetDisabled", e[e.SetOrientation = 3] = "SetOrientation", e[e.GoToOption = 4] = "GoToOption", e[e.Search = 5] = "Search", e[e.ClearSearch = 6] = "ClearSearch", e[e.RegisterOption = 7] = "RegisterOption", e[e.UnregisterOption = 8] = "UnregisterOption", e))(PE || {});
function Mu(e, n = (o) => o) {
  let o = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, t = qi(n(e.options.slice()), (a) => a.dataRef.current.domRef.current), r = o ? t.indexOf(o) : null;
  return r === -1 && (r = null), { options: t, activeOptionIndex: r };
}
let EE = { [1](e) {
  return e.disabled || e.listboxState === 1 ? e : { ...e, activeOptionIndex: null, listboxState: 1 };
}, [0](e) {
  if (e.disabled || e.listboxState === 0)
    return e;
  let n = e.activeOptionIndex, { value: o, mode: t, compare: r } = e.propsRef.current, a = e.options.findIndex((i) => {
    let s = i.dataRef.current.value;
    return nr(t, { [1]: () => o.some((l) => r(l, s)), [0]: () => r(o, s) });
  });
  return a !== -1 && (n = a), { ...e, listboxState: 0, activeOptionIndex: n };
}, [2](e, n) {
  return e.disabled === n.disabled ? e : { ...e, disabled: n.disabled };
}, [3](e, n) {
  return e.orientation === n.orientation ? e : { ...e, orientation: n.orientation };
}, [4](e, n) {
  var o;
  if (e.disabled || e.listboxState === 1)
    return e;
  let t = Mu(e), r = Tf(n, { resolveItems: () => t.options, resolveActiveIndex: () => t.activeOptionIndex, resolveId: (a) => a.id, resolveDisabled: (a) => a.dataRef.current.disabled });
  return { ...e, ...t, searchQuery: "", activeOptionIndex: r, activationTrigger: (o = n.trigger) != null ? o : 1 };
}, [5]: (e, n) => {
  if (e.disabled || e.listboxState === 1)
    return e;
  let o = e.searchQuery !== "" ? 0 : 1, t = e.searchQuery + n.value.toLowerCase(), r = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + o).concat(e.options.slice(0, e.activeOptionIndex + o)) : e.options).find((i) => {
    var s;
    return !i.dataRef.current.disabled && ((s = i.dataRef.current.textValue) == null ? void 0 : s.startsWith(t));
  }), a = r ? e.options.indexOf(r) : -1;
  return a === -1 || a === e.activeOptionIndex ? { ...e, searchQuery: t } : { ...e, searchQuery: t, activeOptionIndex: a, activationTrigger: 1 };
}, [6](e) {
  return e.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : { ...e, searchQuery: "" };
}, [7]: (e, n) => {
  let o = { id: n.id, dataRef: n.dataRef }, t = Mu(e, (r) => [...r, o]);
  if (e.activeOptionIndex === null) {
    let { value: r, mode: a, compare: i } = e.propsRef.current, s = n.dataRef.current.value;
    nr(a, { [1]: () => r.some((l) => i(l, s)), [0]: () => i(r, s) }) && (t.activeOptionIndex = t.options.indexOf(o));
  }
  return { ...e, ...t };
}, [8]: (e, n) => {
  let o = Mu(e, (t) => {
    let r = t.findIndex((a) => a.id === n.id);
    return r !== -1 && t.splice(r, 1), t;
  });
  return { ...e, ...o, activationTrigger: 1 };
} }, Nf = Xr(null);
Nf.displayName = "ListboxContext";
function Ji(e) {
  let n = Yr(Nf);
  if (n === null) {
    let o = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, Ji), o;
  }
  return n;
}
function kE(e, n) {
  return nr(n.type, EE, e, n);
}
let RE = Or, $E = qt(function(e, n) {
  let { value: o, defaultValue: t, name: r, onChange: a, by: i = (G, Q) => G === Q, disabled: s = !1, horizontal: l = !1, multiple: u = !1, ...c } = e;
  const p = l ? "horizontal" : "vertical";
  let h = Jt(n), [O, C] = Il(o, a, t), P = da(kE, { listboxState: 1, propsRef: { current: { value: O, onChange: C, mode: u ? 1 : 0, compare: Ne(typeof i == "string" ? (G, Q) => {
    let V = i;
    return (G == null ? void 0 : G[V]) === (Q == null ? void 0 : Q[V]);
  } : i) } }, labelRef: io(), buttonRef: io(), optionsRef: io(), disabled: s, orientation: p, options: [], searchQuery: "", activeOptionIndex: null, activationTrigger: 1 }), [{ listboxState: k, propsRef: $, optionsRef: I, buttonRef: H }, x] = P;
  $.current.value = O, $.current.mode = u ? 1 : 0, Xt(() => {
    $.current.onChange = (G) => nr($.current.mode, { [0]() {
      return C(G);
    }, [1]() {
      let Q = $.current.value.slice(), { compare: V } = $.current, ie = Q.findIndex((ce) => V(ce, G));
      return ie === -1 ? Q.push(G) : Q.splice(ie, 1), C(Q);
    } });
  }, [C, $]), Xt(() => x({ type: 2, disabled: s }), [s]), Xt(() => x({ type: 3, orientation: p }), [p]), Ki([H, I], (G, Q) => {
    var V;
    x({ type: 1 }), Ui(Q, Vi.Loose) || (G.preventDefault(), (V = H.current) == null || V.focus());
  }, k === 0);
  let _ = at(() => ({ open: k === 0, disabled: s, value: O }), [k, s, O]), F = { ref: h };
  return y.createElement(Nf.Provider, { value: P }, y.createElement(_l, { value: nr(k, { [0]: rn.Open, [1]: rn.Closed }) }, r != null && O != null && jl({ [r]: O }).map(([G, Q]) => y.createElement(fo, { features: Kn.Hidden, ...Wa({ key: G, as: "input", type: "hidden", hidden: !0, readOnly: !0, name: G, value: Q }) })), Gt({ ourProps: F, theirProps: c, slot: _, defaultTag: RE, name: "Listbox" })));
}), DE = "button", TE = qt(function(e, n) {
  var o;
  let [t, r] = Ji("Listbox.Button"), a = Jt(t.buttonRef, n), i = `headlessui-listbox-button-${dr()}`, s = ua(), l = Ne((P) => {
    switch (P.key) {
      case Je.Space:
      case Je.Enter:
      case Je.ArrowDown:
        P.preventDefault(), r({ type: 0 }), s.nextFrame(() => {
          t.propsRef.current.value || r({ type: 4, focus: Yt.First });
        });
        break;
      case Je.ArrowUp:
        P.preventDefault(), r({ type: 0 }), s.nextFrame(() => {
          t.propsRef.current.value || r({ type: 4, focus: Yt.Last });
        });
        break;
    }
  }), u = Ne((P) => {
    switch (P.key) {
      case Je.Space:
        P.preventDefault();
        break;
    }
  }), c = Ne((P) => {
    if (va(P.currentTarget))
      return P.preventDefault();
    t.listboxState === 0 ? (r({ type: 1 }), s.nextFrame(() => {
      var k;
      return (k = t.buttonRef.current) == null ? void 0 : k.focus({ preventScroll: !0 });
    })) : (P.preventDefault(), r({ type: 0 }));
  }), p = Gi(() => {
    if (t.labelRef.current)
      return [t.labelRef.current.id, i].join(" ");
  }, [t.labelRef.current, i]), h = at(() => ({ open: t.listboxState === 0, disabled: t.disabled, value: t.propsRef.current.value }), [t]), O = e, C = { ref: a, id: i, type: Qi(e, t.buttonRef), "aria-haspopup": !0, "aria-controls": (o = t.optionsRef.current) == null ? void 0 : o.id, "aria-expanded": t.disabled ? void 0 : t.listboxState === 0, "aria-labelledby": p, disabled: t.disabled, onKeyDown: l, onKeyUp: u, onClick: c };
  return Gt({ ourProps: C, theirProps: O, slot: h, defaultTag: DE, name: "Listbox.Button" });
}), jE = "label", _E = qt(function(e, n) {
  let [o] = Ji("Listbox.Label"), t = `headlessui-listbox-label-${dr()}`, r = Jt(o.labelRef, n), a = Ne(() => {
    var s;
    return (s = o.buttonRef.current) == null ? void 0 : s.focus({ preventScroll: !0 });
  }), i = at(() => ({ open: o.listboxState === 0, disabled: o.disabled }), [o]);
  return Gt({ ourProps: { ref: r, id: t, onClick: a }, theirProps: e, slot: i, defaultTag: jE, name: "Listbox.Label" });
}), IE = "ul", ME = kn.RenderStrategy | kn.Static, AE = qt(function(e, n) {
  var o;
  let [t, r] = Ji("Listbox.Options"), a = Jt(t.optionsRef, n), i = `headlessui-listbox-options-${dr()}`, s = ua(), l = ua(), u = Ua(), c = (() => u !== null ? u === rn.Open : t.listboxState === 0)();
  Nt(() => {
    var k;
    let $ = t.optionsRef.current;
    !$ || t.listboxState === 0 && $ !== ((k = Vo($)) == null ? void 0 : k.activeElement) && $.focus({ preventScroll: !0 });
  }, [t.listboxState, t.optionsRef]);
  let p = Ne((k) => {
    switch (l.dispose(), k.key) {
      case Je.Space:
        if (t.searchQuery !== "")
          return k.preventDefault(), k.stopPropagation(), r({ type: 5, value: k.key });
      case Je.Enter:
        if (k.preventDefault(), k.stopPropagation(), t.activeOptionIndex !== null) {
          let { dataRef: $ } = t.options[t.activeOptionIndex];
          t.propsRef.current.onChange($.current.value);
        }
        t.propsRef.current.mode === 0 && (r({ type: 1 }), qn().nextFrame(() => {
          var $;
          return ($ = t.buttonRef.current) == null ? void 0 : $.focus({ preventScroll: !0 });
        }));
        break;
      case nr(t.orientation, { vertical: Je.ArrowDown, horizontal: Je.ArrowRight }):
        return k.preventDefault(), k.stopPropagation(), r({ type: 4, focus: Yt.Next });
      case nr(t.orientation, { vertical: Je.ArrowUp, horizontal: Je.ArrowLeft }):
        return k.preventDefault(), k.stopPropagation(), r({ type: 4, focus: Yt.Previous });
      case Je.Home:
      case Je.PageUp:
        return k.preventDefault(), k.stopPropagation(), r({ type: 4, focus: Yt.First });
      case Je.End:
      case Je.PageDown:
        return k.preventDefault(), k.stopPropagation(), r({ type: 4, focus: Yt.Last });
      case Je.Escape:
        return k.preventDefault(), k.stopPropagation(), r({ type: 1 }), s.nextFrame(() => {
          var $;
          return ($ = t.buttonRef.current) == null ? void 0 : $.focus({ preventScroll: !0 });
        });
      case Je.Tab:
        k.preventDefault(), k.stopPropagation();
        break;
      default:
        k.key.length === 1 && (r({ type: 5, value: k.key }), l.setTimeout(() => r({ type: 6 }), 350));
        break;
    }
  }), h = Gi(() => {
    var k, $, I;
    return (I = (k = t.labelRef.current) == null ? void 0 : k.id) != null ? I : ($ = t.buttonRef.current) == null ? void 0 : $.id;
  }, [t.labelRef.current, t.buttonRef.current]), O = at(() => ({ open: t.listboxState === 0 }), [t]), C = e, P = { "aria-activedescendant": t.activeOptionIndex === null || (o = t.options[t.activeOptionIndex]) == null ? void 0 : o.id, "aria-multiselectable": t.propsRef.current.mode === 1 ? !0 : void 0, "aria-labelledby": h, "aria-orientation": t.orientation, id: i, onKeyDown: p, role: "listbox", tabIndex: 0, ref: a };
  return Gt({ ourProps: P, theirProps: C, slot: O, defaultTag: IE, features: ME, visible: c, name: "Listbox.Options" });
}), FE = "li", LE = qt(function(e, n) {
  let { disabled: o = !1, value: t, ...r } = e, [a, i] = Ji("Listbox.Option"), s = `headlessui-listbox-option-${dr()}`, l = a.activeOptionIndex !== null ? a.options[a.activeOptionIndex].id === s : !1, { value: u, compare: c } = a.propsRef.current, p = nr(a.propsRef.current.mode, { [1]: () => u.some((_) => c(_, t)), [0]: () => c(u, t) }), h = St(null), O = Jt(n, h);
  Xt(() => {
    if (a.listboxState !== 0 || !l || a.activationTrigger === 0)
      return;
    let _ = qn();
    return _.requestAnimationFrame(() => {
      var F, G;
      (G = (F = h.current) == null ? void 0 : F.scrollIntoView) == null || G.call(F, { block: "nearest" });
    }), _.dispose;
  }, [h, l, a.listboxState, a.activationTrigger, a.activeOptionIndex]);
  let C = St({ disabled: o, value: t, domRef: h });
  Xt(() => {
    C.current.disabled = o;
  }, [C, o]), Xt(() => {
    C.current.value = t;
  }, [C, t]), Xt(() => {
    var _, F;
    C.current.textValue = (F = (_ = h.current) == null ? void 0 : _.textContent) == null ? void 0 : F.toLowerCase();
  }, [C, h]);
  let P = Ne(() => a.propsRef.current.onChange(t));
  Xt(() => (i({ type: 7, id: s, dataRef: C }), () => i({ type: 8, id: s })), [C, s]);
  let k = Ne((_) => {
    if (o)
      return _.preventDefault();
    P(), a.propsRef.current.mode === 0 && (i({ type: 1 }), qn().nextFrame(() => {
      var F;
      return (F = a.buttonRef.current) == null ? void 0 : F.focus({ preventScroll: !0 });
    }));
  }), $ = Ne(() => {
    if (o)
      return i({ type: 4, focus: Yt.Nothing });
    i({ type: 4, focus: Yt.Specific, id: s });
  }), I = Ne(() => {
    o || l || i({ type: 4, focus: Yt.Specific, id: s, trigger: 0 });
  }), H = Ne(() => {
    o || !l || i({ type: 4, focus: Yt.Nothing });
  }), x = at(() => ({ active: l, selected: p, disabled: o }), [l, p, o]);
  return Gt({ ourProps: { id: s, ref: O, role: "option", tabIndex: o === !0 ? void 0 : -1, "aria-disabled": o === !0 ? !0 : void 0, "aria-selected": p, disabled: void 0, onClick: k, onFocus: $, onPointerMove: I, onMouseMove: I, onPointerLeave: H, onMouseLeave: H }, theirProps: r, slot: x, defaultTag: FE, name: "Listbox.Option" });
}), Tn = Object.assign($E, { Button: TE, Label: _E, Options: AE, Option: LE });
var NE = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(NE || {}), BE = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(BE || {}), WE = ((e) => (e[e.OpenMenu = 0] = "OpenMenu", e[e.CloseMenu = 1] = "CloseMenu", e[e.GoToItem = 2] = "GoToItem", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterItem = 5] = "RegisterItem", e[e.UnregisterItem = 6] = "UnregisterItem", e))(WE || {});
function Au(e, n = (o) => o) {
  let o = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, t = qi(n(e.items.slice()), (a) => a.dataRef.current.domRef.current), r = o ? t.indexOf(o) : null;
  return r === -1 && (r = null), { items: t, activeItemIndex: r };
}
let zE = { [1](e) {
  return e.menuState === 1 ? e : { ...e, activeItemIndex: null, menuState: 1 };
}, [0](e) {
  return e.menuState === 0 ? e : { ...e, menuState: 0 };
}, [2]: (e, n) => {
  var o;
  let t = Au(e), r = Tf(n, { resolveItems: () => t.items, resolveActiveIndex: () => t.activeItemIndex, resolveId: (a) => a.id, resolveDisabled: (a) => a.dataRef.current.disabled });
  return { ...e, ...t, searchQuery: "", activeItemIndex: r, activationTrigger: (o = n.trigger) != null ? o : 1 };
}, [3]: (e, n) => {
  let o = e.searchQuery !== "" ? 0 : 1, t = e.searchQuery + n.value.toLowerCase(), r = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + o).concat(e.items.slice(0, e.activeItemIndex + o)) : e.items).find((i) => {
    var s;
    return ((s = i.dataRef.current.textValue) == null ? void 0 : s.startsWith(t)) && !i.dataRef.current.disabled;
  }), a = r ? e.items.indexOf(r) : -1;
  return a === -1 || a === e.activeItemIndex ? { ...e, searchQuery: t } : { ...e, searchQuery: t, activeItemIndex: a, activationTrigger: 1 };
}, [4](e) {
  return e.searchQuery === "" ? e : { ...e, searchQuery: "", searchActiveItemIndex: null };
}, [5]: (e, n) => {
  let o = Au(e, (t) => [...t, { id: n.id, dataRef: n.dataRef }]);
  return { ...e, ...o };
}, [6]: (e, n) => {
  let o = Au(e, (t) => {
    let r = t.findIndex((a) => a.id === n.id);
    return r !== -1 && t.splice(r, 1), t;
  });
  return { ...e, ...o, activationTrigger: 1 };
} }, Bf = Xr(null);
Bf.displayName = "MenuContext";
function Ll(e) {
  let n = Yr(Bf);
  if (n === null) {
    let o = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, Ll), o;
  }
  return n;
}
function HE(e, n) {
  return nr(n.type, zE, e, n);
}
let YE = Or, GE = qt(function(e, n) {
  let o = da(HE, { menuState: 1, buttonRef: io(), itemsRef: io(), items: [], searchQuery: "", activeItemIndex: null, activationTrigger: 1 }), [{ menuState: t, itemsRef: r, buttonRef: a }, i] = o, s = Jt(n);
  Ki([a, r], (p, h) => {
    var O;
    i({ type: 1 }), Ui(h, Vi.Loose) || (p.preventDefault(), (O = a.current) == null || O.focus());
  }, t === 0);
  let l = at(() => ({ open: t === 0 }), [t]), u = e, c = { ref: s };
  return y.createElement(Bf.Provider, { value: o }, y.createElement(_l, { value: nr(t, { [0]: rn.Open, [1]: rn.Closed }) }, Gt({ ourProps: c, theirProps: u, slot: l, defaultTag: YE, name: "Menu" })));
}), VE = "button", UE = qt(function(e, n) {
  var o;
  let [t, r] = Ll("Menu.Button"), a = Jt(t.buttonRef, n), i = `headlessui-menu-button-${dr()}`, s = ua(), l = Ne((C) => {
    switch (C.key) {
      case Je.Space:
      case Je.Enter:
      case Je.ArrowDown:
        C.preventDefault(), C.stopPropagation(), r({ type: 0 }), s.nextFrame(() => r({ type: 2, focus: Yt.First }));
        break;
      case Je.ArrowUp:
        C.preventDefault(), C.stopPropagation(), r({ type: 0 }), s.nextFrame(() => r({ type: 2, focus: Yt.Last }));
        break;
    }
  }), u = Ne((C) => {
    switch (C.key) {
      case Je.Space:
        C.preventDefault();
        break;
    }
  }), c = Ne((C) => {
    if (va(C.currentTarget))
      return C.preventDefault();
    e.disabled || (t.menuState === 0 ? (r({ type: 1 }), s.nextFrame(() => {
      var P;
      return (P = t.buttonRef.current) == null ? void 0 : P.focus({ preventScroll: !0 });
    })) : (C.preventDefault(), r({ type: 0 })));
  }), p = at(() => ({ open: t.menuState === 0 }), [t]), h = e, O = { ref: a, id: i, type: Qi(e, t.buttonRef), "aria-haspopup": !0, "aria-controls": (o = t.itemsRef.current) == null ? void 0 : o.id, "aria-expanded": e.disabled ? void 0 : t.menuState === 0, onKeyDown: l, onKeyUp: u, onClick: c };
  return Gt({ ourProps: O, theirProps: h, slot: p, defaultTag: VE, name: "Menu.Button" });
}), qE = "div", KE = kn.RenderStrategy | kn.Static, QE = qt(function(e, n) {
  var o, t;
  let [r, a] = Ll("Menu.Items"), i = Jt(r.itemsRef, n), s = Uo(r.itemsRef), l = `headlessui-menu-items-${dr()}`, u = ua(), c = Ua(), p = (() => c !== null ? c === rn.Open : r.menuState === 0)();
  Nt(() => {
    let $ = r.itemsRef.current;
    !$ || r.menuState === 0 && $ !== (s == null ? void 0 : s.activeElement) && $.focus({ preventScroll: !0 });
  }, [r.menuState, r.itemsRef, s]), Df({ container: r.itemsRef.current, enabled: r.menuState === 0, accept($) {
    return $.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : $.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk($) {
    $.setAttribute("role", "none");
  } });
  let h = Ne(($) => {
    var I, H;
    switch (u.dispose(), $.key) {
      case Je.Space:
        if (r.searchQuery !== "")
          return $.preventDefault(), $.stopPropagation(), a({ type: 3, value: $.key });
      case Je.Enter:
        if ($.preventDefault(), $.stopPropagation(), a({ type: 1 }), r.activeItemIndex !== null) {
          let { dataRef: x } = r.items[r.activeItemIndex];
          (H = (I = x.current) == null ? void 0 : I.domRef.current) == null || H.click();
        }
        Am(r.buttonRef.current);
        break;
      case Je.ArrowDown:
        return $.preventDefault(), $.stopPropagation(), a({ type: 2, focus: Yt.Next });
      case Je.ArrowUp:
        return $.preventDefault(), $.stopPropagation(), a({ type: 2, focus: Yt.Previous });
      case Je.Home:
      case Je.PageUp:
        return $.preventDefault(), $.stopPropagation(), a({ type: 2, focus: Yt.First });
      case Je.End:
      case Je.PageDown:
        return $.preventDefault(), $.stopPropagation(), a({ type: 2, focus: Yt.Last });
      case Je.Escape:
        $.preventDefault(), $.stopPropagation(), a({ type: 1 }), qn().nextFrame(() => {
          var x;
          return (x = r.buttonRef.current) == null ? void 0 : x.focus({ preventScroll: !0 });
        });
        break;
      case Je.Tab:
        $.preventDefault(), $.stopPropagation(), a({ type: 1 }), qn().nextFrame(() => {
          mP(r.buttonRef.current, $.shiftKey ? tn.Previous : tn.Next);
        });
        break;
      default:
        $.key.length === 1 && (a({ type: 3, value: $.key }), u.setTimeout(() => a({ type: 4 }), 350));
        break;
    }
  }), O = Ne(($) => {
    switch ($.key) {
      case Je.Space:
        $.preventDefault();
        break;
    }
  }), C = at(() => ({ open: r.menuState === 0 }), [r]), P = e, k = { "aria-activedescendant": r.activeItemIndex === null || (o = r.items[r.activeItemIndex]) == null ? void 0 : o.id, "aria-labelledby": (t = r.buttonRef.current) == null ? void 0 : t.id, id: l, onKeyDown: h, onKeyUp: O, role: "menu", tabIndex: 0, ref: i };
  return Gt({ ourProps: k, theirProps: P, slot: C, defaultTag: qE, features: KE, visible: p, name: "Menu.Items" });
}), XE = Or, JE = qt(function(e, n) {
  let { disabled: o = !1, ...t } = e, [r, a] = Ll("Menu.Item"), i = `headlessui-menu-item-${dr()}`, s = r.activeItemIndex !== null ? r.items[r.activeItemIndex].id === i : !1, l = St(null), u = Jt(n, l);
  Xt(() => {
    if (r.menuState !== 0 || !s || r.activationTrigger === 0)
      return;
    let k = qn();
    return k.requestAnimationFrame(() => {
      var $, I;
      (I = ($ = l.current) == null ? void 0 : $.scrollIntoView) == null || I.call($, { block: "nearest" });
    }), k.dispose;
  }, [l, s, r.menuState, r.activationTrigger, r.activeItemIndex]);
  let c = St({ disabled: o, domRef: l });
  Xt(() => {
    c.current.disabled = o;
  }, [c, o]), Xt(() => {
    var k, $;
    c.current.textValue = ($ = (k = l.current) == null ? void 0 : k.textContent) == null ? void 0 : $.toLowerCase();
  }, [c, l]), Xt(() => (a({ type: 5, id: i, dataRef: c }), () => a({ type: 6, id: i })), [c, i]);
  let p = Ne((k) => {
    if (o)
      return k.preventDefault();
    a({ type: 1 }), Am(r.buttonRef.current);
  }), h = Ne(() => {
    if (o)
      return a({ type: 2, focus: Yt.Nothing });
    a({ type: 2, focus: Yt.Specific, id: i });
  }), O = Ne(() => {
    o || s || a({ type: 2, focus: Yt.Specific, id: i, trigger: 0 });
  }), C = Ne(() => {
    o || !s || a({ type: 2, focus: Yt.Nothing });
  }), P = at(() => ({ active: s, disabled: o }), [s, o]);
  return Gt({ ourProps: { id: i, ref: u, role: "menuitem", tabIndex: o === !0 ? void 0 : -1, "aria-disabled": o === !0 ? !0 : void 0, disabled: void 0, onClick: p, onFocus: h, onPointerMove: O, onMouseMove: O, onPointerLeave: C, onMouseLeave: C }, theirProps: t, slot: P, defaultTag: XE, name: "Menu.Item" });
}), $s = Object.assign(GE, { Button: UE, Items: QE, Item: JE });
var ZE = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(ZE || {}), ek = ((e) => (e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))(ek || {});
let tk = { [0]: (e) => ({ ...e, popoverState: nr(e.popoverState, { [0]: 1, [1]: 0 }) }), [1](e) {
  return e.popoverState === 1 ? e : { ...e, popoverState: 1 };
}, [2](e, n) {
  return e.button === n.button ? e : { ...e, button: n.button };
}, [3](e, n) {
  return e.buttonId === n.buttonId ? e : { ...e, buttonId: n.buttonId };
}, [4](e, n) {
  return e.panel === n.panel ? e : { ...e, panel: n.panel };
}, [5](e, n) {
  return e.panelId === n.panelId ? e : { ...e, panelId: n.panelId };
} }, Wf = Xr(null);
Wf.displayName = "PopoverContext";
function Nl(e) {
  let n = Yr(Wf);
  if (n === null) {
    let o = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, Nl), o;
  }
  return n;
}
let zf = Xr(null);
zf.displayName = "PopoverAPIContext";
function Hf(e) {
  let n = Yr(zf);
  if (n === null) {
    let o = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, Hf), o;
  }
  return n;
}
let Yf = Xr(null);
Yf.displayName = "PopoverGroupContext";
function Km() {
  return Yr(Yf);
}
let Gf = Xr(null);
Gf.displayName = "PopoverPanelContext";
function rk() {
  return Yr(Gf);
}
function nk(e, n) {
  return nr(n.type, tk, e, n);
}
let ok = "div", ak = qt(function(e, n) {
  var o;
  let t = `headlessui-popover-button-${dr()}`, r = `headlessui-popover-panel-${dr()}`, a = St(null), i = Jt(n, Lm((V) => {
    a.current = V;
  })), s = da(nk, { popoverState: 1, button: null, buttonId: t, panel: null, panelId: r, beforePanelSentinel: io(), afterPanelSentinel: io() }), [{ popoverState: l, button: u, panel: c, beforePanelSentinel: p, afterPanelSentinel: h }, O] = s, C = Uo((o = a.current) != null ? o : u);
  Nt(() => O({ type: 3, buttonId: t }), [t, O]), Nt(() => O({ type: 5, panelId: r }), [r, O]);
  let P = at(() => {
    if (!u || !c)
      return !1;
    for (let V of document.querySelectorAll("body > *"))
      if (Number(V == null ? void 0 : V.contains(u)) ^ Number(V == null ? void 0 : V.contains(c)))
        return !0;
    return !1;
  }, [u, c]), k = at(() => ({ buttonId: t, panelId: r, close: () => O({ type: 1 }) }), [t, r, O]), $ = Km(), I = $ == null ? void 0 : $.registerPopover, H = Ne(() => {
    var V;
    return (V = $ == null ? void 0 : $.isFocusWithinPopoverGroup()) != null ? V : (C == null ? void 0 : C.activeElement) && ((u == null ? void 0 : u.contains(C.activeElement)) || (c == null ? void 0 : c.contains(C.activeElement)));
  });
  Nt(() => I == null ? void 0 : I(k), [I, k]), Al(C == null ? void 0 : C.defaultView, "focus", (V) => {
    var ie, ce, me, ve;
    l === 0 && (H() || !u || !c || (ce = (ie = p.current) == null ? void 0 : ie.contains) != null && ce.call(ie, V.target) || (ve = (me = h.current) == null ? void 0 : me.contains) != null && ve.call(me, V.target) || O({ type: 1 }));
  }, !0), Ki([u, c], (V, ie) => {
    O({ type: 1 }), Ui(ie, Vi.Loose) || (V.preventDefault(), u == null || u.focus());
  }, l === 0);
  let x = Ne((V) => {
    O({ type: 1 });
    let ie = (() => V ? V instanceof HTMLElement ? V : "current" in V && V.current instanceof HTMLElement ? V.current : u : u)();
    ie == null || ie.focus();
  }), _ = at(() => ({ close: x, isPortalled: P }), [x, P]), F = at(() => ({ open: l === 0, close: x }), [l, x]), G = e, Q = { ref: i };
  return y.createElement(Wf.Provider, { value: s }, y.createElement(zf.Provider, { value: _ }, y.createElement(_l, { value: nr(l, { [0]: rn.Open, [1]: rn.Closed }) }, Gt({ ourProps: Q, theirProps: G, slot: F, defaultTag: ok, name: "Popover" }))));
}), ik = "button", sk = qt(function(e, n) {
  let [o, t] = Nl("Popover.Button"), { isPortalled: r } = Hf("Popover.Button"), a = St(null), i = `headlessui-focus-sentinel-${dr()}`, s = Km(), l = s == null ? void 0 : s.closeOthers, u = rk(), c = u === null ? !1 : u === o.panelId, p = Jt(a, n, c ? null : (V) => t({ type: 2, button: V })), h = Jt(a, n), O = Uo(a), C = Ne((V) => {
    var ie, ce, me;
    if (c) {
      if (o.popoverState === 1)
        return;
      switch (V.key) {
        case Je.Space:
        case Je.Enter:
          V.preventDefault(), (ce = (ie = V.target).click) == null || ce.call(ie), t({ type: 1 }), (me = o.button) == null || me.focus();
          break;
      }
    } else
      switch (V.key) {
        case Je.Space:
        case Je.Enter:
          V.preventDefault(), V.stopPropagation(), o.popoverState === 1 && (l == null || l(o.buttonId)), t({ type: 0 });
          break;
        case Je.Escape:
          if (o.popoverState !== 0)
            return l == null ? void 0 : l(o.buttonId);
          if (!a.current || O != null && O.activeElement && !a.current.contains(O.activeElement))
            return;
          V.preventDefault(), V.stopPropagation(), t({ type: 1 });
          break;
      }
  }), P = Ne((V) => {
    c || V.key === Je.Space && V.preventDefault();
  }), k = Ne((V) => {
    var ie, ce;
    va(V.currentTarget) || e.disabled || (c ? (t({ type: 1 }), (ie = o.button) == null || ie.focus()) : (V.preventDefault(), V.stopPropagation(), o.popoverState === 1 && (l == null || l(o.buttonId)), t({ type: 0 }), (ce = o.button) == null || ce.focus()));
  }), $ = Ne((V) => {
    V.preventDefault(), V.stopPropagation();
  }), I = o.popoverState === 0, H = at(() => ({ open: I }), [I]), x = Qi(e, a), _ = e, F = c ? { ref: h, type: x, onKeyDown: C, onClick: k } : { ref: p, id: o.buttonId, type: x, "aria-expanded": e.disabled ? void 0 : o.popoverState === 0, "aria-controls": o.panel ? o.panelId : void 0, onKeyDown: C, onKeyUp: P, onClick: k, onMouseDown: $ }, G = Af(), Q = Ne(() => {
    let V = o.panel;
    if (!V)
      return;
    function ie() {
      nr(G.current, { [mo.Forwards]: () => _n(V, tn.First), [mo.Backwards]: () => _n(V, tn.Last) });
    }
    ie();
  });
  return y.createElement(y.Fragment, null, Gt({ ourProps: F, theirProps: _, slot: H, defaultTag: ik, name: "Popover.Button" }), I && !c && r && y.createElement(fo, { id: i, features: Kn.Focusable, as: "button", type: "button", onFocus: Q }));
}), lk = "div", uk = kn.RenderStrategy | kn.Static, ck = qt(function(e, n) {
  let [{ popoverState: o }, t] = Nl("Popover.Overlay"), r = Jt(n), a = `headlessui-popover-overlay-${dr()}`, i = Ua(), s = (() => i !== null ? i === rn.Open : o === 0)(), l = Ne((c) => {
    if (va(c.currentTarget))
      return c.preventDefault();
    t({ type: 1 });
  }), u = at(() => ({ open: o === 0 }), [o]);
  return Gt({ ourProps: { ref: r, id: a, "aria-hidden": !0, onClick: l }, theirProps: e, slot: u, defaultTag: lk, features: uk, visible: s, name: "Popover.Overlay" });
}), dk = "div", pk = kn.RenderStrategy | kn.Static, fk = qt(function(e, n) {
  let { focus: o = !1, ...t } = e, [r, a] = Nl("Popover.Panel"), { close: i, isPortalled: s } = Hf("Popover.Panel"), l = `headlessui-focus-sentinel-before-${dr()}`, u = `headlessui-focus-sentinel-after-${dr()}`, c = St(null), p = Jt(c, n, (_) => {
    a({ type: 4, panel: _ });
  }), h = Uo(c), O = Ua(), C = (() => O !== null ? O === rn.Open : r.popoverState === 0)(), P = Ne((_) => {
    var F;
    switch (_.key) {
      case Je.Escape:
        if (r.popoverState !== 0 || !c.current || h != null && h.activeElement && !c.current.contains(h.activeElement))
          return;
        _.preventDefault(), _.stopPropagation(), a({ type: 1 }), (F = r.button) == null || F.focus();
        break;
    }
  });
  Nt(() => {
    var _;
    e.static || r.popoverState === 1 && ((_ = e.unmount) == null || _) && a({ type: 4, panel: null });
  }, [r.popoverState, e.unmount, e.static, a]), Nt(() => {
    if (!o || r.popoverState !== 0 || !c.current)
      return;
    let _ = h == null ? void 0 : h.activeElement;
    c.current.contains(_) || _n(c.current, tn.First);
  }, [o, c, r.popoverState]);
  let k = at(() => ({ open: r.popoverState === 0, close: i }), [r, i]), $ = { ref: p, id: r.panelId, onKeyDown: P, onBlur: o && r.popoverState === 0 ? (_) => {
    var F, G, Q, V, ie;
    let ce = _.relatedTarget;
    !ce || !c.current || (F = c.current) != null && F.contains(ce) || (a({ type: 1 }), ((Q = (G = r.beforePanelSentinel.current) == null ? void 0 : G.contains) != null && Q.call(G, ce) || (ie = (V = r.afterPanelSentinel.current) == null ? void 0 : V.contains) != null && ie.call(V, ce)) && ce.focus({ preventScroll: !0 }));
  } : void 0, tabIndex: -1 }, I = Af(), H = Ne(() => {
    let _ = c.current;
    if (!_)
      return;
    function F() {
      nr(I.current, { [mo.Forwards]: () => {
        _n(_, tn.First);
      }, [mo.Backwards]: () => {
        var G;
        (G = r.button) == null || G.focus({ preventScroll: !0 });
      } });
    }
    F();
  }), x = Ne(() => {
    let _ = c.current;
    if (!_)
      return;
    function F() {
      nr(I.current, { [mo.Forwards]: () => {
        var G, Q, V;
        if (!r.button)
          return;
        let ie = $f(), ce = ie.indexOf(r.button), me = ie.slice(0, ce + 1), ve = [...ie.slice(ce + 1), ...me];
        for (let U of ve.slice())
          if ((Q = (G = U == null ? void 0 : U.id) == null ? void 0 : G.startsWith) != null && Q.call(G, "headlessui-focus-sentinel-") || (V = r.panel) != null && V.contains(U)) {
            let ee = ve.indexOf(U);
            ee !== -1 && ve.splice(ee, 1);
          }
        _n(ve, tn.First, !1);
      }, [mo.Backwards]: () => _n(_, tn.Last) });
    }
    F();
  });
  return y.createElement(Gf.Provider, { value: r.panelId }, C && s && y.createElement(fo, { id: l, ref: r.beforePanelSentinel, features: Kn.Focusable, as: "button", type: "button", onFocus: H }), Gt({ ourProps: $, theirProps: t, slot: k, defaultTag: dk, features: pk, visible: C, name: "Popover.Panel" }), C && s && y.createElement(fo, { id: u, ref: r.afterPanelSentinel, features: Kn.Focusable, as: "button", type: "button", onFocus: x }));
}), vk = "div", gk = qt(function(e, n) {
  let o = St(null), t = Jt(o, n), [r, a] = ur([]), i = Ne((C) => {
    a((P) => {
      let k = P.indexOf(C);
      if (k !== -1) {
        let $ = P.slice();
        return $.splice(k, 1), $;
      }
      return P;
    });
  }), s = Ne((C) => (a((P) => [...P, C]), () => i(C))), l = Ne(() => {
    var C;
    let P = Vo(o);
    if (!P)
      return !1;
    let k = P.activeElement;
    return (C = o.current) != null && C.contains(k) ? !0 : r.some(($) => {
      var I, H;
      return ((I = P.getElementById($.buttonId)) == null ? void 0 : I.contains(k)) || ((H = P.getElementById($.panelId)) == null ? void 0 : H.contains(k));
    });
  }), u = Ne((C) => {
    for (let P of r)
      P.buttonId !== C && P.close();
  }), c = at(() => ({ registerPopover: s, unregisterPopover: i, isFocusWithinPopoverGroup: l, closeOthers: u }), [s, i, l, u]), p = at(() => ({}), []), h = e, O = { ref: t };
  return y.createElement(Yf.Provider, { value: c }, Gt({ ourProps: O, theirProps: h, slot: p, defaultTag: vk, name: "Popover.Group" }));
}), gi = Object.assign(ak, { Button: sk, Overlay: ck, Panel: fk, Group: gk });
function hk(e = 0) {
  let [n, o] = ur(e), t = It((s) => o((l) => l | s), [n]), r = It((s) => !!(n & s), [n]), a = It((s) => o((l) => l & ~s), [o]), i = It((s) => o((l) => l ^ s), [o]);
  return { addFlag: t, hasFlag: r, removeFlag: a, toggleFlag: i };
}
let Qm = Xr(null);
function Xm() {
  let e = Yr(Qm);
  if (e === null) {
    let n = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(n, Xm), n;
  }
  return e;
}
function Vf() {
  let [e, n] = ur([]);
  return [e.length > 0 ? e.join(" ") : void 0, at(() => function(o) {
    let t = Ne((a) => (n((i) => [...i, a]), () => n((i) => {
      let s = i.slice(), l = s.indexOf(a);
      return l !== -1 && s.splice(l, 1), s;
    }))), r = at(() => ({ register: t, slot: o.slot, name: o.name, props: o.props }), [t, o.slot, o.name, o.props]);
    return y.createElement(Qm.Provider, { value: r }, o.children);
  }, [n])];
}
let mk = "label", Jm = qt(function(e, n) {
  let { passive: o = !1, ...t } = e, r = Xm(), a = `headlessui-label-${dr()}`, i = Jt(n);
  Xt(() => r.register(a), [a, r.register]);
  let s = { ref: i, ...r.props, id: a };
  return o && ("onClick" in s && delete s.onClick, "onClick" in t && delete t.onClick), Gt({ ourProps: s, theirProps: t, slot: r.slot || {}, defaultTag: mk, name: r.name || "Label" });
});
var yk = ((e) => (e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))(yk || {});
let bk = { [0](e, n) {
  let o = [...e.options, { id: n.id, element: n.element, propsRef: n.propsRef }];
  return { ...e, options: qi(o, (t) => t.element.current) };
}, [1](e, n) {
  let o = e.options.slice(), t = e.options.findIndex((r) => r.id === n.id);
  return t === -1 ? e : (o.splice(t, 1), { ...e, options: o });
} }, Uf = Xr(null);
Uf.displayName = "RadioGroupContext";
function Zm(e) {
  let n = Yr(Uf);
  if (n === null) {
    let o = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, Zm), o;
  }
  return n;
}
function wk(e, n) {
  return nr(n.type, bk, e, n);
}
let xk = "div", Ck = qt(function(e, n) {
  let { value: o, defaultValue: t, name: r, onChange: a, by: i = (U, ee) => U === ee, disabled: s = !1, ...l } = e, u = Ne(typeof i == "string" ? (U, ee) => {
    let oe = i;
    return (U == null ? void 0 : U[oe]) === (ee == null ? void 0 : ee[oe]);
  } : i), [c, p] = da(wk, { options: [] }), h = c.options, [O, C] = Vf(), [P, k] = Fl(), $ = `headlessui-radiogroup-${dr()}`, I = St(null), H = Jt(I, n), [x, _] = Il(o, a, t), F = at(() => h.find((U) => !U.propsRef.current.disabled), [h]), G = at(() => h.some((U) => u(U.propsRef.current.value, x)), [h, x]), Q = Ne((U) => {
    var ee;
    if (s || u(U, x))
      return !1;
    let oe = (ee = h.find((ge) => u(ge.propsRef.current.value, U))) == null ? void 0 : ee.propsRef.current;
    return oe != null && oe.disabled ? !1 : (_ == null || _(U), !0);
  });
  Df({ container: I.current, accept(U) {
    return U.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : U.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(U) {
    U.setAttribute("role", "none");
  } });
  let V = Ne((U) => {
    let ee = I.current;
    if (!ee)
      return;
    let oe = Vo(ee), ge = h.filter((be) => be.propsRef.current.disabled === !1).map((be) => be.element.current);
    switch (U.key) {
      case Je.Enter:
        zm(U.currentTarget);
        break;
      case Je.ArrowLeft:
      case Je.ArrowUp:
        if (U.preventDefault(), U.stopPropagation(), _n(ge, tn.Previous | tn.WrapAround) === Js.Success) {
          let be = h.find((he) => he.element.current === (oe == null ? void 0 : oe.activeElement));
          be && Q(be.propsRef.current.value);
        }
        break;
      case Je.ArrowRight:
      case Je.ArrowDown:
        if (U.preventDefault(), U.stopPropagation(), _n(ge, tn.Next | tn.WrapAround) === Js.Success) {
          let be = h.find((he) => he.element.current === (oe == null ? void 0 : oe.activeElement));
          be && Q(be.propsRef.current.value);
        }
        break;
      case Je.Space:
        {
          U.preventDefault(), U.stopPropagation();
          let be = h.find((he) => he.element.current === (oe == null ? void 0 : oe.activeElement));
          be && Q(be.propsRef.current.value);
        }
        break;
    }
  }), ie = Ne((U) => (p({ type: 0, ...U }), () => p({ type: 1, id: U.id }))), ce = at(() => ({ registerOption: ie, firstOption: F, containsCheckedOption: G, change: Q, disabled: s, value: x, compare: u }), [ie, F, G, Q, s, x, u]), me = { ref: H, id: $, role: "radiogroup", "aria-labelledby": O, "aria-describedby": P, onKeyDown: V }, ve = at(() => ({ value: x }), [x]);
  return y.createElement(k, { name: "RadioGroup.Description" }, y.createElement(C, { name: "RadioGroup.Label" }, y.createElement(Uf.Provider, { value: ce }, r != null && x != null && jl({ [r]: x }).map(([U, ee]) => y.createElement(fo, { features: Kn.Hidden, ...Wa({ key: U, as: "input", type: "radio", checked: ee != null, hidden: !0, readOnly: !0, name: U, value: ee }) })), Gt({ ourProps: me, theirProps: l, slot: ve, defaultTag: xk, name: "RadioGroup" }))));
});
var Sk = ((e) => (e[e.Empty = 1] = "Empty", e[e.Active = 2] = "Active", e))(Sk || {});
let Ok = "div", Pk = qt(function(e, n) {
  let o = St(null), t = Jt(o, n), r = `headlessui-radiogroup-option-${dr()}`, [a, i] = Vf(), [s, l] = Fl(), { addFlag: u, removeFlag: c, hasFlag: p } = hk(1), { value: h, disabled: O = !1, ...C } = e, P = St({ value: h, disabled: O });
  Xt(() => {
    P.current.value = h;
  }, [h, P]), Xt(() => {
    P.current.disabled = O;
  }, [O, P]);
  let { registerOption: k, disabled: $, change: I, firstOption: H, containsCheckedOption: x, value: _, compare: F } = Zm("RadioGroup.Option");
  Xt(() => k({ id: r, element: o, propsRef: P }), [r, k, o, e]);
  let G = Ne(() => {
    var ee;
    !I(h) || (u(2), (ee = o.current) == null || ee.focus());
  }), Q = Ne(() => u(2)), V = Ne(() => c(2)), ie = (H == null ? void 0 : H.id) === r, ce = $ || O, me = F(_, h), ve = { ref: t, id: r, role: "radio", "aria-checked": me ? "true" : "false", "aria-labelledby": a, "aria-describedby": s, "aria-disabled": ce ? !0 : void 0, tabIndex: (() => ce ? -1 : me || !x && ie ? 0 : -1)(), onClick: ce ? void 0 : G, onFocus: ce ? void 0 : Q, onBlur: ce ? void 0 : V }, U = at(() => ({ checked: me, disabled: ce, active: p(2) }), [me, ce, p]);
  return y.createElement(l, { name: "RadioGroup.Description" }, y.createElement(i, { name: "RadioGroup.Label" }, Gt({ ourProps: ve, theirProps: C, slot: U, defaultTag: Ok, name: "RadioGroup.Option" })));
}), _a = Object.assign(Ck, { Option: Pk, Label: Jm, Description: Ff }), qf = Xr(null);
qf.displayName = "GroupContext";
let Ek = Or;
function kk(e) {
  let [n, o] = ur(null), [t, r] = Vf(), [a, i] = Fl(), s = at(() => ({ switch: n, setSwitch: o, labelledby: t, describedby: a }), [n, o, t, a]), l = {}, u = e;
  return y.createElement(i, { name: "Switch.Description" }, y.createElement(r, { name: "Switch.Label", props: { onClick() {
    !n || (n.click(), n.focus({ preventScroll: !0 }));
  } } }, y.createElement(qf.Provider, { value: s }, Gt({ ourProps: l, theirProps: u, defaultTag: Ek, name: "Switch.Group" }))));
}
let Rk = "button", $k = qt(function(e, n) {
  let { checked: o, defaultChecked: t = !1, onChange: r, name: a, value: i, ...s } = e, l = `headlessui-switch-${dr()}`, u = Yr(qf), c = St(null), p = Jt(c, n, u === null ? null : u.setSwitch), [h, O] = Il(o, r, t), C = Ne(() => O == null ? void 0 : O(!h)), P = Ne((x) => {
    if (va(x.currentTarget))
      return x.preventDefault();
    x.preventDefault(), C();
  }), k = Ne((x) => {
    x.key === Je.Space ? (x.preventDefault(), C()) : x.key === Je.Enter && zm(x.currentTarget);
  }), $ = Ne((x) => x.preventDefault()), I = at(() => ({ checked: h }), [h]), H = { id: l, ref: p, role: "switch", type: Qi(e, c), tabIndex: 0, "aria-checked": h, "aria-labelledby": u == null ? void 0 : u.labelledby, "aria-describedby": u == null ? void 0 : u.describedby, onClick: P, onKeyUp: k, onKeyPress: $ };
  return y.createElement(y.Fragment, null, a != null && h && y.createElement(fo, { features: Kn.Hidden, ...Wa({ as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: h, name: a, value: i }) }), Gt({ ourProps: H, theirProps: s, slot: I, defaultTag: Rk, name: "Switch" }));
}), yd = Object.assign($k, { Group: kk, Label: Jm, Description: Ff });
const Dk = y.forwardRef(
  ({ isMenuOpen: e, trackingId: n, ...o }, t) => /* @__PURE__ */ g.jsx(
    Tk,
    {
      ...o,
      ref: t,
      isMenuOpen: e,
      iconName: "more-vertical",
      trackingId: `${n}-menu-toggle-button`
    }
  )
), Tk = Y(Fn).withConfig({
  shouldForwardProp: (e) => !["isMenuOpen"].includes(e)
})(
  ({ theme: e, isMenuOpen: n }) => `
  ${n ? `background-color: ${Hr(e.color.black, 0.1)};` : ""} 
`
), RM = ({
  ariaLabel: e = "Open menu",
  items: n,
  trackingId: o
}) => {
  const { floatingRefCallback: t, referenceRefCallback: r, floatingPlacementStyles: a } = Li({ minMenuWidth: "xxs" });
  return /* @__PURE__ */ g.jsx($s, { children: ({ open: i }) => /* @__PURE__ */ g.jsxs(jk, { children: [
    /* @__PURE__ */ g.jsx(
      $s.Button,
      {
        as: Dk,
        ref: r,
        isMenuOpen: i,
        trackingId: o,
        "aria-label": e
      }
    ),
    /* @__PURE__ */ g.jsx(
      $s.Items,
      {
        as: _k,
        ref: t,
        style: a,
        children: n.map((s) => /* @__PURE__ */ g.jsx($s.Item, { as: Or, children: ({ active: l }) => /* @__PURE__ */ Xd(
          Ik,
          {
            ...s,
            isActive: l,
            variant: "invisible",
            key: s.trackingId
          }
        ) }, s.trackingId))
      }
    )
  ] }) });
}, jk = Y.div`
  position: relative;
`, _k = Y.div(Zd), Ik = Y(Co).withConfig({
  shouldForwardProp: (e) => !["isActive"].includes(e)
})(
  ({ theme: e, isActive: n }) => `
    ${ep({ theme: e, isActive: n })}
    cursor: pointer;
  `
), ey = (e) => ({
  primary: {
    backgroundColor: e.color.primary,
    color: e.color.primary
  },
  success: {
    backgroundColor: e.color.success,
    color: e.color.green4
  },
  warning: {
    color: e.color.orange1,
    backgroundColor: Fr(e.color.warning)
  },
  danger: {
    backgroundColor: e.color.danger,
    color: e.color.danger
  }
}), Mk = {
  primary: "info",
  success: "check-circle",
  warning: "alert-circle",
  danger: "alert-triangle"
}, Og = ({
  variant: e,
  onClose: n,
  children: o,
  trackingId: t,
  className: r = ""
}) => {
  const a = !!(n && t);
  return /* @__PURE__ */ g.jsxs(
    Ak,
    {
      variant: e,
      shouldShowCloseButton: a,
      className: r,
      trackingId: t,
      children: [
        /* @__PURE__ */ g.jsx(Fk, { name: Mk[e] }),
        /* @__PURE__ */ g.jsx(Cf, { as: "div", children: o }),
        a && /* @__PURE__ */ g.jsx(
          Lk,
          {
            alertVariant: e,
            onClick: n,
            trackingId: `${t}-close-button`,
            iconName: "x"
          }
        )
      ]
    }
  );
}, Ak = pa(
  Y.div.withConfig({
    shouldForwardProp: (e) => !["shouldShowCloseButton", "variant"].includes(e)
  })(({ theme: e, variant: n, shouldShowCloseButton: o }) => {
    const { color: t, backgroundColor: r } = ey(e)[n];
    return `
    position: relative;
    background-color: ${Fr(r)};
    padding: ${e.spacing.m} ${o ? e.spacing.xxl : e.spacing.m} ${e.spacing.m} ${e.spacing.xxl};
    border-radius: ${e.borderRadius.s};
  
    // Style for "a" rather than the Anchor base to account for internal navigation links
    // that can't be accomplished with the Anchor atom
    ${pr}, ${Cl}, ${Na}, a, a:hover, a:active {
      color: ${t} !important;
    }

    ${Sl}, a, a:hover, a:active {
      text-decoration: underline !important;
    }
  `;
  })
), Fk = Y(Lr)`
  position: absolute;
  top: 18px;
  left: 20px;
`, Lk = Y(Fn).withConfig({
  shouldForwardProp: (e) => e !== "alertVariant"
})(({ theme: e, alertVariant: n }) => {
  const { color: o, backgroundColor: t } = ey(e)[n];
  return `
    position: absolute;

    /* Hardcoded positioning to align the ActionButton with the top line of text */
    top: 14px;
    right: ${e.spacing.m};

    color: ${o};

    &:hover {
      background-color: ${Hr(t, 0.2)};
    }
  `;
}), ty = ({
  trackingId: e,
  onClear: n,
  isDisabled: o,
  isLoading: t,
  className: r
}) => /* @__PURE__ */ g.jsx(
  Nk,
  {
    className: r,
    iconName: "x",
    trackingId: `${e}-clear-button`,
    onClick: n,
    label: "Clear",
    isDisabled: o,
    isLoading: t
  }
), Nk = Y(Fn)(
  ({ theme: e }) => `
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: ${e.spacing.m};
`
), ry = ({
  isDisabled: e = !1,
  isLoading: n = !1,
  onClear: o,
  shouldShowClear: t = !1,
  trackingId: r
}) => /* @__PURE__ */ g.jsxs(Bk, { isDisabled: e, children: [
  /* @__PURE__ */ g.jsx(Wk, { name: "search" }),
  (t || n) && /* @__PURE__ */ g.jsx(
    ty,
    {
      trackingId: r,
      onClear: o,
      isDisabled: e,
      isLoading: n
    }
  )
] }), Bk = Y.div.withConfig({
  shouldForwardProp: (e) => e !== "isDisabled"
})(({ isDisabled: e }) => e ? Rn : ""), Wk = Y(Lr)(
  ({ theme: e }) => `
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: ${e.spacing.m};
`
), zk = ({
  isDisabled: e,
  onTextChange: n,
  trackingId: o,
  value: t,
  ...r
}) => /* @__PURE__ */ g.jsx(
  Hk,
  {
    autoComplete: "off",
    inputSiblingElement: /* @__PURE__ */ g.jsx(
      ry,
      {
        trackingId: o,
        isDisabled: e,
        onClear: () => n(""),
        shouldShowClear: !!t
      }
    ),
    isDisabled: e,
    onTextChange: n,
    trackingId: o,
    value: t,
    ...r
  }
), ny = (e) => {
  const n = cf(e).default.size, o = co(e);
  return `
    padding-left: calc(${e.spacing.m} + ${o} + ${e.spacing.s});
    padding-right: calc(${e.spacing.s} + ${n} + ${e.spacing.m});
`;
}, Hk = Y(kf)(
  ({ theme: e }) => `
    ${Rf} {
      ${ny(e)}
    }
`
), Yk = ({
  getOptionLabel: e,
  handleForceToggle: n,
  isDisabled: o,
  isLoading: t,
  onClear: r,
  onTextChange: a,
  referenceRefCallback: i,
  shouldShowClear: s,
  trackingId: l,
  validationState: u = "none",
  ...c
}) => /* @__PURE__ */ g.jsxs(Gk, { children: [
  /* @__PURE__ */ g.jsx(
    ja.Input,
    {
      as: Vk,
      displayValue: (p) => p ? e(p) : "",
      onChange: (p) => a(p.currentTarget.value),
      onFocus: n,
      ref: i,
      trackingId: l,
      validationState: u,
      autoComplete: "off",
      ...c
    }
  ),
  /* @__PURE__ */ g.jsx(
    ry,
    {
      trackingId: l,
      onClear: r,
      shouldShowClear: s,
      isDisabled: o,
      isLoading: t
    }
  )
] }), Gk = Y.div`
  position: relative;
  width: 100%;
`, Vk = Jr(
  Y.input.withConfig({
    shouldForwardProp: (e) => e !== "validationState"
  })(
    ({ theme: e, validationState: n }) => `
  ${Yi(e, n)}
  ${ny(e)}

  width: 100%;
`
  )
), oy = Y(Lr).attrs({
  name: "check"
})(
  ({ theme: e }) => `
  color: ${e.color.success};
`
), Zi = ({
  title: e,
  subtitleElement: n,
  avatarProps: o
}) => /* @__PURE__ */ g.jsxs(qk, { direction: "column", padding: "m", alignItems: "center", children: [
  o && /* @__PURE__ */ g.jsx(Uk, { ...o }),
  /* @__PURE__ */ g.jsx(xf, { as: "div", children: e }),
  n && /* @__PURE__ */ g.jsx(vo, { children: n })
] }), Uk = Y(Of)(
  ({ theme: e }) => `
  margin-bottom: ${e.spacing.s};

  ${Ho(e, "mobile")} {
    display: none;
  }
`
), qk = Y(Be)`
  ${pr} {
    text-align: center;
  }
`, Kk = {
  variant: "secondary",
  iconName: "search"
}, Qk = ({
  shouldIncludeAvatar: e = !0
} = {}) => ({
  title: "No results found",
  subtitleElement: "Please check your search terms and try again.",
  ...e ? { avatarProps: Kk } : {}
}), Kf = (e) => /* @__PURE__ */ g.jsx(Zi, { ...Qk(e) }), Pg = (e) => Array.isArray(e), Xk = ({
  options: e,
  floatingRefCallback: n,
  floatingPlacementStyles: o,
  emptyStateProps: t,
  getOptionKey: r,
  getOptionLabel: a,
  getOptionImgSrc: i
}) => {
  const s = It(
    (u) => /* @__PURE__ */ g.jsx("ul", { children: u.map((c) => /* @__PURE__ */ g.jsx(ja.Option, { value: c, as: Or, children: ({ active: p, selected: h }) => /* @__PURE__ */ g.jsxs(Zk, { isActive: p, children: [
      /* @__PURE__ */ g.jsxs(Be, { alignItems: "center", gap: "m", children: [
        i && /* @__PURE__ */ g.jsx(eR, { src: i(c) }),
        a(c)
      ] }),
      h && /* @__PURE__ */ g.jsx(oy, {})
    ] }) }, r(c))) }),
    [r, a, i]
  ), l = at(() => {
    if (Pg(e) ? e.length === 0 : !Object.values(e).some((c) => c.length > 0))
      return /* @__PURE__ */ g.jsx(Kf, { ...t });
    if (Pg(e))
      return s(e);
    {
      const c = Object.entries(e);
      return c.map(([p, h], O) => /* @__PURE__ */ g.jsxs(Or, { children: [
        /* @__PURE__ */ g.jsx(tR, { colorVariant: "secondary", children: p }),
        s(h),
        O !== c.length - 1 && /* @__PURE__ */ g.jsx(Be, { padding: "s m", children: /* @__PURE__ */ g.jsx(Bn, {}) })
      ] }, p));
    }
  }, [e, s, t]);
  return /* @__PURE__ */ g.jsx(
    ja.Options,
    {
      as: Jk,
      ref: n,
      style: o,
      children: l
    }
  );
}, Jk = Y.div(
  ({ theme: e }) => `
  margin: ${e.spacing.none};
  padding: ${e.spacing.s} ${e.spacing.none};
  background-color: ${e.color.white};
  border-radius: ${e.borderRadius.s};
  border: ${Pn(e)};
  box-shadow: ${e.shadow};
  outline: none;
  z-index: ${e.zIndex.popover};
  max-height: ${e.measure.m};
  overflow-x: hidden;
  overflow-y: auto;

  ul {
    padding: ${e.spacing.none};
    margin: ${e.spacing.none};
  }
`
), Zk = Y.li.withConfig({
  shouldForwardProp: (e) => e !== "isActive"
})(
  ({ theme: e, isActive: n }) => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style-type: none;
  padding: 12px ${e.spacing.m};
  cursor: default;

  background-color: ${n ? e.color.gray1 : e.color.white};
  outline: ${n ? `1px solid ${e.color.activeListItemOutline}` : "none"};
  
  &:active {
    background-color: ${e.color.gray2};
  }
`
), eR = Y.img`
  max-height: 20px;
  width: auto;
`, tR = Y(zi)(
  ({ theme: e }) => `
  padding: ${e.spacing.m};
`
), $M = ({
  emptyStateProps: e = {},
  errorMessage: n,
  getOptionImgSrc: o,
  getOptionKey: t,
  getOptionLabel: r,
  helpIconProps: a,
  isDisabled: i = !1,
  isLabelHidden: s = !1,
  isLoading: l = !1,
  label: u,
  onChange: c,
  onTextChange: p,
  options: h,
  placeholder: O,
  trackingId: C,
  validationState: P = "none",
  value: k
}) => {
  const $ = St(null), [I, H] = ur(), {
    floatingPlacementStyles: x,
    floatingRefCallback: _,
    floatingElement: F,
    referenceElement: G,
    referenceRefCallback: Q
  } = Li();
  Nt(() => {
    const ge = () => H(document.activeElement);
    return document.addEventListener("focusin", ge), () => document.removeEventListener("focusin", ge);
  }, []);
  const V = It(() => {
    var be;
    I && (F == null ? void 0 : F.contains(I)) || (be = $.current) == null || be.click();
  }, [F, I]), ie = (ge) => {
    c(ge), p(r(ge));
  }, ce = () => {
    c(void 0), p(""), G && (G.value = "", G.focus());
  }, me = !!(k || G != null && G.value), ve = Ba(), U = P === "error", ee = U && n, oe = {
    isLabelHidden: s,
    label: u,
    helpIconProps: a,
    trackingId: C
  };
  return /* @__PURE__ */ g.jsxs(ja, { value: k, onChange: ie, disabled: i, children: [
    /* @__PURE__ */ g.jsx(ja.Button, { as: rR, ref: $ }),
    /* @__PURE__ */ g.jsxs(fa, { LabelElement: ja.Label, ...oe, children: [
      /* @__PURE__ */ g.jsx(
        Yk,
        {
          "aria-describedby": ee ? ve : void 0,
          "aria-invalid": U,
          getOptionLabel: r,
          handleForceToggle: V,
          isDisabled: i,
          isLoading: l,
          onClear: ce,
          onTextChange: p,
          placeholder: O,
          referenceRefCallback: Q,
          shouldShowClear: me,
          trackingId: C,
          validationState: P
        }
      ),
      /* @__PURE__ */ g.jsx(
        Xk,
        {
          options: h,
          floatingPlacementStyles: x,
          floatingRefCallback: _,
          emptyStateProps: e,
          getOptionKey: t,
          getOptionLabel: r,
          getOptionImgSrc: o
        }
      ),
      ee && /* @__PURE__ */ g.jsx(
        un,
        {
          colorVariant: "danger",
          id: ve,
          trackingId: `${C}-error`,
          children: n
        }
      )
    ] })
  ] });
}, rR = Y.button`
  display: none;
`;
function Oo(e) {
  return Array.isArray ? Array.isArray(e) : sy(e) === "[object Array]";
}
const nR = 1 / 0;
function oR(e) {
  if (typeof e == "string")
    return e;
  let n = e + "";
  return n == "0" && 1 / e == -nR ? "-0" : n;
}
function aR(e) {
  return e == null ? "" : oR(e);
}
function ao(e) {
  return typeof e == "string";
}
function ay(e) {
  return typeof e == "number";
}
function iR(e) {
  return e === !0 || e === !1 || sR(e) && sy(e) == "[object Boolean]";
}
function iy(e) {
  return typeof e == "object";
}
function sR(e) {
  return iy(e) && e !== null;
}
function xn(e) {
  return e != null;
}
function Fu(e) {
  return !e.trim().length;
}
function sy(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
const lR = "Incorrect 'index' type", uR = (e) => `Invalid value for key ${e}`, cR = (e) => `Pattern length exceeds max of ${e}.`, dR = (e) => `Missing ${e} property in key`, pR = (e) => `Property 'weight' in key '${e}' must be a positive integer`, Eg = Object.prototype.hasOwnProperty;
class fR {
  constructor(n) {
    this._keys = [], this._keyMap = {};
    let o = 0;
    n.forEach((t) => {
      let r = ly(t);
      o += r.weight, this._keys.push(r), this._keyMap[r.id] = r, o += r.weight;
    }), this._keys.forEach((t) => {
      t.weight /= o;
    });
  }
  get(n) {
    return this._keyMap[n];
  }
  keys() {
    return this._keys;
  }
  toJSON() {
    return JSON.stringify(this._keys);
  }
}
function ly(e) {
  let n = null, o = null, t = null, r = 1, a = null;
  if (ao(e) || Oo(e))
    t = e, n = kg(e), o = bd(e);
  else {
    if (!Eg.call(e, "name"))
      throw new Error(dR("name"));
    const i = e.name;
    if (t = i, Eg.call(e, "weight") && (r = e.weight, r <= 0))
      throw new Error(pR(i));
    n = kg(i), o = bd(i), a = e.getFn;
  }
  return { path: n, id: o, weight: r, src: t, getFn: a };
}
function kg(e) {
  return Oo(e) ? e : e.split(".");
}
function bd(e) {
  return Oo(e) ? e.join(".") : e;
}
function vR(e, n) {
  let o = [], t = !1;
  const r = (a, i, s) => {
    if (xn(a))
      if (!i[s])
        o.push(a);
      else {
        let l = i[s];
        const u = a[l];
        if (!xn(u))
          return;
        if (s === i.length - 1 && (ao(u) || ay(u) || iR(u)))
          o.push(aR(u));
        else if (Oo(u)) {
          t = !0;
          for (let c = 0, p = u.length; c < p; c += 1)
            r(u[c], i, s + 1);
        } else
          i.length && r(u, i, s + 1);
      }
  };
  return r(e, ao(n) ? n.split(".") : n, 0), t ? o : o[0];
}
const gR = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: !1,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: !1,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
}, hR = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: !1,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: !1,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: !0,
  // Default sort function: sort by ascending score, ascending index
  sortFn: (e, n) => e.score === n.score ? e.idx < n.idx ? -1 : 1 : e.score < n.score ? -1 : 1
}, mR = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
}, yR = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: !1,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: vR,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: !1,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: !1,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};
var $t = {
  ...hR,
  ...gR,
  ...mR,
  ...yR
};
const bR = /[^ ]+/g;
function wR(e = 1, n = 3) {
  const o = /* @__PURE__ */ new Map(), t = Math.pow(10, n);
  return {
    get(r) {
      const a = r.match(bR).length;
      if (o.has(a))
        return o.get(a);
      const i = 1 / Math.pow(a, 0.5 * e), s = parseFloat(Math.round(i * t) / t);
      return o.set(a, s), s;
    },
    clear() {
      o.clear();
    }
  };
}
class Qf {
  constructor({
    getFn: n = $t.getFn,
    fieldNormWeight: o = $t.fieldNormWeight
  } = {}) {
    this.norm = wR(o, 3), this.getFn = n, this.isCreated = !1, this.setIndexRecords();
  }
  setSources(n = []) {
    this.docs = n;
  }
  setIndexRecords(n = []) {
    this.records = n;
  }
  setKeys(n = []) {
    this.keys = n, this._keysMap = {}, n.forEach((o, t) => {
      this._keysMap[o.id] = t;
    });
  }
  create() {
    this.isCreated || !this.docs.length || (this.isCreated = !0, ao(this.docs[0]) ? this.docs.forEach((n, o) => {
      this._addString(n, o);
    }) : this.docs.forEach((n, o) => {
      this._addObject(n, o);
    }), this.norm.clear());
  }
  // Adds a doc to the end of the index
  add(n) {
    const o = this.size();
    ao(n) ? this._addString(n, o) : this._addObject(n, o);
  }
  // Removes the doc at the specified index of the index
  removeAt(n) {
    this.records.splice(n, 1);
    for (let o = n, t = this.size(); o < t; o += 1)
      this.records[o].i -= 1;
  }
  getValueForItemAtKeyId(n, o) {
    return n[this._keysMap[o]];
  }
  size() {
    return this.records.length;
  }
  _addString(n, o) {
    if (!xn(n) || Fu(n))
      return;
    let t = {
      v: n,
      i: o,
      n: this.norm.get(n)
    };
    this.records.push(t);
  }
  _addObject(n, o) {
    let t = { i: o, $: {} };
    this.keys.forEach((r, a) => {
      let i = r.getFn ? r.getFn(n) : this.getFn(n, r.path);
      if (xn(i)) {
        if (Oo(i)) {
          let s = [];
          const l = [{ nestedArrIndex: -1, value: i }];
          for (; l.length; ) {
            const { nestedArrIndex: u, value: c } = l.pop();
            if (xn(c))
              if (ao(c) && !Fu(c)) {
                let p = {
                  v: c,
                  i: u,
                  n: this.norm.get(c)
                };
                s.push(p);
              } else
                Oo(c) && c.forEach((p, h) => {
                  l.push({
                    nestedArrIndex: h,
                    value: p
                  });
                });
          }
          t.$[a] = s;
        } else if (ao(i) && !Fu(i)) {
          let s = {
            v: i,
            n: this.norm.get(i)
          };
          t.$[a] = s;
        }
      }
    }), this.records.push(t);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    };
  }
}
function uy(e, n, { getFn: o = $t.getFn, fieldNormWeight: t = $t.fieldNormWeight } = {}) {
  const r = new Qf({ getFn: o, fieldNormWeight: t });
  return r.setKeys(e.map(ly)), r.setSources(n), r.create(), r;
}
function xR(e, { getFn: n = $t.getFn, fieldNormWeight: o = $t.fieldNormWeight } = {}) {
  const { keys: t, records: r } = e, a = new Qf({ getFn: n, fieldNormWeight: o });
  return a.setKeys(t), a.setIndexRecords(r), a;
}
function Ds(e, {
  errors: n = 0,
  currentLocation: o = 0,
  expectedLocation: t = 0,
  distance: r = $t.distance,
  ignoreLocation: a = $t.ignoreLocation
} = {}) {
  const i = n / e.length;
  if (a)
    return i;
  const s = Math.abs(t - o);
  return r ? i + s / r : s ? 1 : i;
}
function CR(e = [], n = $t.minMatchCharLength) {
  let o = [], t = -1, r = -1, a = 0;
  for (let i = e.length; a < i; a += 1) {
    let s = e[a];
    s && t === -1 ? t = a : !s && t !== -1 && (r = a - 1, r - t + 1 >= n && o.push([t, r]), t = -1);
  }
  return e[a - 1] && a - t >= n && o.push([t, a - 1]), o;
}
const na = 32;
function SR(e, n, o, {
  location: t = $t.location,
  distance: r = $t.distance,
  threshold: a = $t.threshold,
  findAllMatches: i = $t.findAllMatches,
  minMatchCharLength: s = $t.minMatchCharLength,
  includeMatches: l = $t.includeMatches,
  ignoreLocation: u = $t.ignoreLocation
} = {}) {
  if (n.length > na)
    throw new Error(cR(na));
  const c = n.length, p = e.length, h = Math.max(0, Math.min(t, p));
  let O = a, C = h;
  const P = s > 1 || l, k = P ? Array(p) : [];
  let $;
  for (; ($ = e.indexOf(n, C)) > -1; ) {
    let G = Ds(n, {
      currentLocation: $,
      expectedLocation: h,
      distance: r,
      ignoreLocation: u
    });
    if (O = Math.min(G, O), C = $ + c, P) {
      let Q = 0;
      for (; Q < c; )
        k[$ + Q] = 1, Q += 1;
    }
  }
  C = -1;
  let I = [], H = 1, x = c + p;
  const _ = 1 << c - 1;
  for (let G = 0; G < c; G += 1) {
    let Q = 0, V = x;
    for (; Q < V; )
      Ds(n, {
        errors: G,
        currentLocation: h + V,
        expectedLocation: h,
        distance: r,
        ignoreLocation: u
      }) <= O ? Q = V : x = V, V = Math.floor((x - Q) / 2 + Q);
    x = V;
    let ie = Math.max(1, h - V + 1), ce = i ? p : Math.min(h + V, p) + c, me = Array(ce + 2);
    me[ce + 1] = (1 << G) - 1;
    for (let U = ce; U >= ie; U -= 1) {
      let ee = U - 1, oe = o[e.charAt(ee)];
      if (P && (k[ee] = +!!oe), me[U] = (me[U + 1] << 1 | 1) & oe, G && (me[U] |= (I[U + 1] | I[U]) << 1 | 1 | I[U + 1]), me[U] & _ && (H = Ds(n, {
        errors: G,
        currentLocation: ee,
        expectedLocation: h,
        distance: r,
        ignoreLocation: u
      }), H <= O)) {
        if (O = H, C = ee, C <= h)
          break;
        ie = Math.max(1, 2 * h - C);
      }
    }
    if (Ds(n, {
      errors: G + 1,
      currentLocation: h,
      expectedLocation: h,
      distance: r,
      ignoreLocation: u
    }) > O)
      break;
    I = me;
  }
  const F = {
    isMatch: C >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(1e-3, H)
  };
  if (P) {
    const G = CR(k, s);
    G.length ? l && (F.indices = G) : F.isMatch = !1;
  }
  return F;
}
function OR(e) {
  let n = {};
  for (let o = 0, t = e.length; o < t; o += 1) {
    const r = e.charAt(o);
    n[r] = (n[r] || 0) | 1 << t - o - 1;
  }
  return n;
}
class cy {
  constructor(n, {
    location: o = $t.location,
    threshold: t = $t.threshold,
    distance: r = $t.distance,
    includeMatches: a = $t.includeMatches,
    findAllMatches: i = $t.findAllMatches,
    minMatchCharLength: s = $t.minMatchCharLength,
    isCaseSensitive: l = $t.isCaseSensitive,
    ignoreLocation: u = $t.ignoreLocation
  } = {}) {
    if (this.options = {
      location: o,
      threshold: t,
      distance: r,
      includeMatches: a,
      findAllMatches: i,
      minMatchCharLength: s,
      isCaseSensitive: l,
      ignoreLocation: u
    }, this.pattern = l ? n : n.toLowerCase(), this.chunks = [], !this.pattern.length)
      return;
    const c = (h, O) => {
      this.chunks.push({
        pattern: h,
        alphabet: OR(h),
        startIndex: O
      });
    }, p = this.pattern.length;
    if (p > na) {
      let h = 0;
      const O = p % na, C = p - O;
      for (; h < C; )
        c(this.pattern.substr(h, na), h), h += na;
      if (O) {
        const P = p - na;
        c(this.pattern.substr(P), P);
      }
    } else
      c(this.pattern, 0);
  }
  searchIn(n) {
    const { isCaseSensitive: o, includeMatches: t } = this.options;
    if (o || (n = n.toLowerCase()), this.pattern === n) {
      let C = {
        isMatch: !0,
        score: 0
      };
      return t && (C.indices = [[0, n.length - 1]]), C;
    }
    const {
      location: r,
      distance: a,
      threshold: i,
      findAllMatches: s,
      minMatchCharLength: l,
      ignoreLocation: u
    } = this.options;
    let c = [], p = 0, h = !1;
    this.chunks.forEach(({ pattern: C, alphabet: P, startIndex: k }) => {
      const { isMatch: $, score: I, indices: H } = SR(n, C, P, {
        location: r + k,
        distance: a,
        threshold: i,
        findAllMatches: s,
        minMatchCharLength: l,
        includeMatches: t,
        ignoreLocation: u
      });
      $ && (h = !0), p += I, $ && H && (c = [...c, ...H]);
    });
    let O = {
      isMatch: h,
      score: h ? p / this.chunks.length : 1
    };
    return h && t && (O.indices = c), O;
  }
}
class qo {
  constructor(n) {
    this.pattern = n;
  }
  static isMultiMatch(n) {
    return Rg(n, this.multiRegex);
  }
  static isSingleMatch(n) {
    return Rg(n, this.singleRegex);
  }
  search() {
  }
}
function Rg(e, n) {
  const o = e.match(n);
  return o ? o[1] : null;
}
class PR extends qo {
  constructor(n) {
    super(n);
  }
  static get type() {
    return "exact";
  }
  static get multiRegex() {
    return /^="(.*)"$/;
  }
  static get singleRegex() {
    return /^=(.*)$/;
  }
  search(n) {
    const o = n === this.pattern;
    return {
      isMatch: o,
      score: o ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
}
class ER extends qo {
  constructor(n) {
    super(n);
  }
  static get type() {
    return "inverse-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"$/;
  }
  static get singleRegex() {
    return /^!(.*)$/;
  }
  search(n) {
    const t = n.indexOf(this.pattern) === -1;
    return {
      isMatch: t,
      score: t ? 0 : 1,
      indices: [0, n.length - 1]
    };
  }
}
class kR extends qo {
  constructor(n) {
    super(n);
  }
  static get type() {
    return "prefix-exact";
  }
  static get multiRegex() {
    return /^\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^\^(.*)$/;
  }
  search(n) {
    const o = n.startsWith(this.pattern);
    return {
      isMatch: o,
      score: o ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
}
class RR extends qo {
  constructor(n) {
    super(n);
  }
  static get type() {
    return "inverse-prefix-exact";
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^!\^(.*)$/;
  }
  search(n) {
    const o = !n.startsWith(this.pattern);
    return {
      isMatch: o,
      score: o ? 0 : 1,
      indices: [0, n.length - 1]
    };
  }
}
class $R extends qo {
  constructor(n) {
    super(n);
  }
  static get type() {
    return "suffix-exact";
  }
  static get multiRegex() {
    return /^"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^(.*)\$$/;
  }
  search(n) {
    const o = n.endsWith(this.pattern);
    return {
      isMatch: o,
      score: o ? 0 : 1,
      indices: [n.length - this.pattern.length, n.length - 1]
    };
  }
}
class DR extends qo {
  constructor(n) {
    super(n);
  }
  static get type() {
    return "inverse-suffix-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^!(.*)\$$/;
  }
  search(n) {
    const o = !n.endsWith(this.pattern);
    return {
      isMatch: o,
      score: o ? 0 : 1,
      indices: [0, n.length - 1]
    };
  }
}
class dy extends qo {
  constructor(n, {
    location: o = $t.location,
    threshold: t = $t.threshold,
    distance: r = $t.distance,
    includeMatches: a = $t.includeMatches,
    findAllMatches: i = $t.findAllMatches,
    minMatchCharLength: s = $t.minMatchCharLength,
    isCaseSensitive: l = $t.isCaseSensitive,
    ignoreLocation: u = $t.ignoreLocation
  } = {}) {
    super(n), this._bitapSearch = new cy(n, {
      location: o,
      threshold: t,
      distance: r,
      includeMatches: a,
      findAllMatches: i,
      minMatchCharLength: s,
      isCaseSensitive: l,
      ignoreLocation: u
    });
  }
  static get type() {
    return "fuzzy";
  }
  static get multiRegex() {
    return /^"(.*)"$/;
  }
  static get singleRegex() {
    return /^(.*)$/;
  }
  search(n) {
    return this._bitapSearch.searchIn(n);
  }
}
class py extends qo {
  constructor(n) {
    super(n);
  }
  static get type() {
    return "include";
  }
  static get multiRegex() {
    return /^'"(.*)"$/;
  }
  static get singleRegex() {
    return /^'(.*)$/;
  }
  search(n) {
    let o = 0, t;
    const r = [], a = this.pattern.length;
    for (; (t = n.indexOf(this.pattern, o)) > -1; )
      o = t + a, r.push([t, o - 1]);
    const i = !!r.length;
    return {
      isMatch: i,
      score: i ? 0 : 1,
      indices: r
    };
  }
}
const wd = [
  PR,
  py,
  kR,
  RR,
  DR,
  $R,
  ER,
  dy
], $g = wd.length, TR = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/, jR = "|";
function _R(e, n = {}) {
  return e.split(jR).map((o) => {
    let t = o.trim().split(TR).filter((a) => a && !!a.trim()), r = [];
    for (let a = 0, i = t.length; a < i; a += 1) {
      const s = t[a];
      let l = !1, u = -1;
      for (; !l && ++u < $g; ) {
        const c = wd[u];
        let p = c.isMultiMatch(s);
        p && (r.push(new c(p, n)), l = !0);
      }
      if (!l)
        for (u = -1; ++u < $g; ) {
          const c = wd[u];
          let p = c.isSingleMatch(s);
          if (p) {
            r.push(new c(p, n));
            break;
          }
        }
    }
    return r;
  });
}
const IR = /* @__PURE__ */ new Set([dy.type, py.type]);
class MR {
  constructor(n, {
    isCaseSensitive: o = $t.isCaseSensitive,
    includeMatches: t = $t.includeMatches,
    minMatchCharLength: r = $t.minMatchCharLength,
    ignoreLocation: a = $t.ignoreLocation,
    findAllMatches: i = $t.findAllMatches,
    location: s = $t.location,
    threshold: l = $t.threshold,
    distance: u = $t.distance
  } = {}) {
    this.query = null, this.options = {
      isCaseSensitive: o,
      includeMatches: t,
      minMatchCharLength: r,
      findAllMatches: i,
      ignoreLocation: a,
      location: s,
      threshold: l,
      distance: u
    }, this.pattern = o ? n : n.toLowerCase(), this.query = _R(this.pattern, this.options);
  }
  static condition(n, o) {
    return o.useExtendedSearch;
  }
  searchIn(n) {
    const o = this.query;
    if (!o)
      return {
        isMatch: !1,
        score: 1
      };
    const { includeMatches: t, isCaseSensitive: r } = this.options;
    n = r ? n : n.toLowerCase();
    let a = 0, i = [], s = 0;
    for (let l = 0, u = o.length; l < u; l += 1) {
      const c = o[l];
      i.length = 0, a = 0;
      for (let p = 0, h = c.length; p < h; p += 1) {
        const O = c[p], { isMatch: C, indices: P, score: k } = O.search(n);
        if (C) {
          if (a += 1, s += k, t) {
            const $ = O.constructor.type;
            IR.has($) ? i = [...i, ...P] : i.push(P);
          }
        } else {
          s = 0, a = 0, i.length = 0;
          break;
        }
      }
      if (a) {
        let p = {
          isMatch: !0,
          score: s / a
        };
        return t && (p.indices = i), p;
      }
    }
    return {
      isMatch: !1,
      score: 1
    };
  }
}
const xd = [];
function AR(...e) {
  xd.push(...e);
}
function Cd(e, n) {
  for (let o = 0, t = xd.length; o < t; o += 1) {
    let r = xd[o];
    if (r.condition(e, n))
      return new r(e, n);
  }
  return new cy(e, n);
}
const el = {
  AND: "$and",
  OR: "$or"
}, Sd = {
  PATH: "$path",
  PATTERN: "$val"
}, Od = (e) => !!(e[el.AND] || e[el.OR]), FR = (e) => !!e[Sd.PATH], LR = (e) => !Oo(e) && iy(e) && !Od(e), Dg = (e) => ({
  [el.AND]: Object.keys(e).map((n) => ({
    [n]: e[n]
  }))
});
function fy(e, n, { auto: o = !0 } = {}) {
  const t = (r) => {
    let a = Object.keys(r);
    const i = FR(r);
    if (!i && a.length > 1 && !Od(r))
      return t(Dg(r));
    if (LR(r)) {
      const l = i ? r[Sd.PATH] : a[0], u = i ? r[Sd.PATTERN] : r[l];
      if (!ao(u))
        throw new Error(uR(l));
      const c = {
        keyId: bd(l),
        pattern: u
      };
      return o && (c.searcher = Cd(u, n)), c;
    }
    let s = {
      children: [],
      operator: a[0]
    };
    return a.forEach((l) => {
      const u = r[l];
      Oo(u) && u.forEach((c) => {
        s.children.push(t(c));
      });
    }), s;
  };
  return Od(e) || (e = Dg(e)), t(e);
}
function NR(e, { ignoreFieldNorm: n = $t.ignoreFieldNorm }) {
  e.forEach((o) => {
    let t = 1;
    o.matches.forEach(({ key: r, norm: a, score: i }) => {
      const s = r ? r.weight : null;
      t *= Math.pow(
        i === 0 && s ? Number.EPSILON : i,
        (s || 1) * (n ? 1 : a)
      );
    }), o.score = t;
  });
}
function BR(e, n) {
  const o = e.matches;
  n.matches = [], xn(o) && o.forEach((t) => {
    if (!xn(t.indices) || !t.indices.length)
      return;
    const { indices: r, value: a } = t;
    let i = {
      indices: r,
      value: a
    };
    t.key && (i.key = t.key.src), t.idx > -1 && (i.refIndex = t.idx), n.matches.push(i);
  });
}
function WR(e, n) {
  n.score = e.score;
}
function zR(e, n, {
  includeMatches: o = $t.includeMatches,
  includeScore: t = $t.includeScore
} = {}) {
  const r = [];
  return o && r.push(BR), t && r.push(WR), e.map((a) => {
    const { idx: i } = a, s = {
      item: n[i],
      refIndex: i
    };
    return r.length && r.forEach((l) => {
      l(a, s);
    }), s;
  });
}
class Ka {
  constructor(n, o = {}, t) {
    this.options = { ...$t, ...o }, this.options.useExtendedSearch, this._keyStore = new fR(this.options.keys), this.setCollection(n, t);
  }
  setCollection(n, o) {
    if (this._docs = n, o && !(o instanceof Qf))
      throw new Error(lR);
    this._myIndex = o || uy(this.options.keys, this._docs, {
      getFn: this.options.getFn,
      fieldNormWeight: this.options.fieldNormWeight
    });
  }
  add(n) {
    xn(n) && (this._docs.push(n), this._myIndex.add(n));
  }
  remove(n = () => !1) {
    const o = [];
    for (let t = 0, r = this._docs.length; t < r; t += 1) {
      const a = this._docs[t];
      n(a, t) && (this.removeAt(t), t -= 1, r -= 1, o.push(a));
    }
    return o;
  }
  removeAt(n) {
    this._docs.splice(n, 1), this._myIndex.removeAt(n);
  }
  getIndex() {
    return this._myIndex;
  }
  search(n, { limit: o = -1 } = {}) {
    const {
      includeMatches: t,
      includeScore: r,
      shouldSort: a,
      sortFn: i,
      ignoreFieldNorm: s
    } = this.options;
    let l = ao(n) ? ao(this._docs[0]) ? this._searchStringList(n) : this._searchObjectList(n) : this._searchLogical(n);
    return NR(l, { ignoreFieldNorm: s }), a && l.sort(i), ay(o) && o > -1 && (l = l.slice(0, o)), zR(l, this._docs, {
      includeMatches: t,
      includeScore: r
    });
  }
  _searchStringList(n) {
    const o = Cd(n, this.options), { records: t } = this._myIndex, r = [];
    return t.forEach(({ v: a, i, n: s }) => {
      if (!xn(a))
        return;
      const { isMatch: l, score: u, indices: c } = o.searchIn(a);
      l && r.push({
        item: a,
        idx: i,
        matches: [{ score: u, value: a, norm: s, indices: c }]
      });
    }), r;
  }
  _searchLogical(n) {
    const o = fy(n, this.options), t = (s, l, u) => {
      if (!s.children) {
        const { keyId: p, searcher: h } = s, O = this._findMatches({
          key: this._keyStore.get(p),
          value: this._myIndex.getValueForItemAtKeyId(l, p),
          searcher: h
        });
        return O && O.length ? [
          {
            idx: u,
            item: l,
            matches: O
          }
        ] : [];
      }
      const c = [];
      for (let p = 0, h = s.children.length; p < h; p += 1) {
        const O = s.children[p], C = t(O, l, u);
        if (C.length)
          c.push(...C);
        else if (s.operator === el.AND)
          return [];
      }
      return c;
    }, r = this._myIndex.records, a = {}, i = [];
    return r.forEach(({ $: s, i: l }) => {
      if (xn(s)) {
        let u = t(o, s, l);
        u.length && (a[l] || (a[l] = { idx: l, item: s, matches: [] }, i.push(a[l])), u.forEach(({ matches: c }) => {
          a[l].matches.push(...c);
        }));
      }
    }), i;
  }
  _searchObjectList(n) {
    const o = Cd(n, this.options), { keys: t, records: r } = this._myIndex, a = [];
    return r.forEach(({ $: i, i: s }) => {
      if (!xn(i))
        return;
      let l = [];
      t.forEach((u, c) => {
        l.push(
          ...this._findMatches({
            key: u,
            value: i[c],
            searcher: o
          })
        );
      }), l.length && a.push({
        idx: s,
        item: i,
        matches: l
      });
    }), a;
  }
  _findMatches({ key: n, value: o, searcher: t }) {
    if (!xn(o))
      return [];
    let r = [];
    if (Oo(o))
      o.forEach(({ v: a, i, n: s }) => {
        if (!xn(a))
          return;
        const { isMatch: l, score: u, indices: c } = t.searchIn(a);
        l && r.push({
          score: u,
          key: n,
          value: a,
          idx: i,
          norm: s,
          indices: c
        });
      });
    else {
      const { v: a, n: i } = o, { isMatch: s, score: l, indices: u } = t.searchIn(a);
      s && r.push({ score: l, key: n, value: a, norm: i, indices: u });
    }
    return r;
  }
}
Ka.version = "6.6.2";
Ka.createIndex = uy;
Ka.parseIndex = xR;
Ka.config = $t;
Ka.parseQuery = fy;
AR(MR);
const HR = (e, n, o) => {
  if (!o)
    return e;
  const t = e.map((s) => ({
    label: n(s),
    option: s
  })), r = ["label"];
  return new Ka(t, {
    ...g0,
    keys: r
  }).search(o).map(({ item: s }) => s.option);
};
function YR(e, n) {
  return Object.fromEntries(
    Object.entries(e).filter(
      ([o, t]) => n(t, o)
    )
  );
}
function GR(e, n) {
  return Object.fromEntries(
    Object.entries(e).map(([o, t]) => [
      o,
      n(t, o)
    ])
  );
}
const DM = (e, n, o, t = HR) => {
  const r = GR(
    e,
    (a, i) => t(a, n, o, i)
  );
  return YR(
    r,
    (a) => a.length > 0
  );
}, VR = (e) => ({
  primary: {
    backgroundColor: e.color.primary,
    color: e.color.primary
  },
  warning: {
    backgroundColor: Fr(e.color.warning),
    color: e.color.orange1
  }
}), TM = ({
  children: e,
  className: n = "",
  trackingId: o,
  variant: t = "primary"
}) => /* @__PURE__ */ g.jsx(
  UR,
  {
    variant: t,
    className: n,
    trackingId: o,
    children: /* @__PURE__ */ g.jsx(Cf, { as: "div", children: e })
  }
), UR = pa(
  Y.div(({ theme: e, variant: n }) => {
    const { color: o, backgroundColor: t } = VR(e)[n];
    return `
    position: relative;
    background-color: ${Fr(t)};
    padding: ${e.spacing.m} ${e.spacing.l};
  
    // Style for "a" rather than the Anchor base to account for internal navigation links
    // that can't be accomplished with the Anchor atom
    ${pr}, a, a:hover, a:active {
      color: ${o} !important;
    }

    a, a:hover, a:active {
      text-decoration: underline;
    }
  `;
  })
), jM = ({
  blocks: e,
  title: n,
  handleAddBlock: o,
  handleRemoveBlock: t,
  actionLabel: r
}) => /* @__PURE__ */ g.jsxs(Be, { gap: "m", direction: "column", children: [
  /* @__PURE__ */ g.jsxs(
    Be,
    {
      justifyContent: "space-between",
      alignItems: "center",
      padding: "xs none",
      children: [
        /* @__PURE__ */ g.jsx(zi, { children: n }),
        /* @__PURE__ */ g.jsx(
          La,
          {
            variant: "anchor-primary",
            trackingId: `add-additional-${r}-btn`,
            onClick: o,
            label: `Additional ${r}`,
            iconName: "plus-circle",
            size: "small"
          }
        )
      ]
    }
  ),
  e.map(({ content: a, key: i }, s) => {
    const l = s !== 0;
    return /* @__PURE__ */ g.jsxs(qR, { children: [
      a,
      l && /* @__PURE__ */ g.jsx(
        KR,
        {
          trackingId: `remove-${r}-btn`,
          iconName: "x-circle",
          onClick: () => t(s)
        }
      )
    ] }, i);
  })
] }), qR = Y(Be)(
  ({ theme: e }) => `
  border: ${Pn(e)};
  background-color:  ${e.color.gray0};
  border-radius: ${e.borderRadius.s};
  padding: ${e.spacing.m};
  position: relative;
`
), KR = Y(Fn)`
  position: absolute;
  right: 0;
`, QR = (e, n, o) => `
  pointer-events: none;
  user-select: none;
  position: relative;
  height: 100%;
  overflow: hidden;
  filter: blur(${n === "light" ? "5px" : "20px"});

  ${o ? `
    :before {
      content: '';
      position: absolute;
      top: 0;
      height: 100%;
      width: 100%;
      background-color: ${Hr(e.color.black, 0.25)};
    }
  ` : ""}
`, _M = Y.div.withConfig({
  shouldForwardProp: (e) => !["blurAmount", "shouldBlur", "shouldDarken"].includes(e)
})(
  ({ theme: e, blurAmount: n = "light", shouldBlur: o = !0, shouldDarken: t = !0 }) => o ? QR(e, n, t) : ""
), IM = ({
  badgeProps: e = void 0,
  centerElement: n,
  children: o,
  className: t = "",
  helpIconProps: r,
  subtitle: a = void 0,
  title: i,
  trackingId: s,
  utilityElement: l,
  titleHeading: u = "h2"
}) => /* @__PURE__ */ g.jsxs(Pf, { className: t, trackingId: s, children: [
  /* @__PURE__ */ g.jsxs(XR, { children: [
    /* @__PURE__ */ g.jsxs(
      Be,
      {
        gap: a ? "none" : "s",
        alignItems: a ? "flex-start" : "center",
        direction: a ? "column" : "row",
        children: [
          /* @__PURE__ */ g.jsxs(Be, { alignItems: "center", gap: "s", children: [
            /* @__PURE__ */ g.jsx(xf, { as: u, children: i }),
            r && /* @__PURE__ */ g.jsx(Hi, { ...r })
          ] }),
          a && /* @__PURE__ */ g.jsx(un, { colorVariant: "secondary", children: a }),
          e && /* @__PURE__ */ g.jsx(Rl, { ...e })
        ]
      }
    ),
    n && /* @__PURE__ */ g.jsx(vy, { children: n }),
    l && /* @__PURE__ */ g.jsx(gy, { children: l })
  ] }),
  /* @__PURE__ */ g.jsx(Bn, {}),
  o
] }), XR = Y.div(
  ({ theme: e, children: n }) => `
  display: grid;
  // Render an equally sized item for each child. This will be between 1-3
  // depending on whether the center and utility element props are defined.
  grid-template-columns: repeat(${fv.toArray(n).length}, 1fr);
  gap: ${e.spacing.m};
  min-height: ${e.sizing.xxl};
  padding: ${e.spacing.m} ${e.spacing.l};
  align-items: center;

  ${Ho(e, "mobile")} {
    grid-template-columns: auto;
    grid-template-rows: repeat(${fv.toArray(n).length}, 1fr);

    ${vy}, ${gy} {
      justify-self: stretch;
    }
  }
`
), vy = Y.div`
  justify-self: center;
`, gy = Y.div`
  justify-self: end;
`, hy = (e) => `
  &:hover:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${e.sizing.s};
    height: ${e.sizing.s};
    background-color: ${Fr(e.color.primary)};
    border-radius: ${e.borderRadius.round};
  }
`, Ei = ({
  isChecked: e,
  isDisabled: n = !1,
  isIndeterminate: o = !1,
  label: t,
  onChange: r,
  trackingId: a,
  shouldTruncateLabel: i = !1
}) => {
  const s = Ga(r), l = e || o;
  return /* @__PURE__ */ g.jsxs(yd.Group, { as: JR, children: [
    /* @__PURE__ */ g.jsx(
      yd,
      {
        as: ZR,
        checked: e,
        isCheckedOrIndeterminate: l,
        onChange: s,
        disabled: n,
        trackingId: a,
        "aria-label": "Checkbox",
        children: l && /* @__PURE__ */ g.jsx(Lr, { name: o ? "minus" : "check" })
      }
    ),
    t && /* @__PURE__ */ g.jsx(
      Tg,
      {
        as: Tg,
        trackingId: `${a}-label`,
        shouldTruncateLabel: i,
        children: t
      }
    )
  ] });
}, Tg = Jr(
  Y(yd.Label).withConfig({
    shouldForwardProp: (e) => e !== "shouldTruncateLabel"
  })(
    ({ theme: e, shouldTruncateLabel: n }) => `
  ${n ? Ah : ""}
  ${Nn(e).body}
`
  )
), JR = Y.div(
  ({ theme: e }) => `
  display: flex;
  gap: ${e.spacing.m};
  min-width: 0;
`
), ZR = Jr(
  Y.button.withConfig({
    shouldForwardProp: (e) => e !== "isCheckedOrIndeterminate"
  })(
    ({ theme: e, isCheckedOrIndeterminate: n }) => `
  ${Yo}

  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: ${e.borderRadius.xs};

  // Give the checkbox a top margin to align it vertically with the top line of label text
  margin-top: 3px;

  ${hy(e)}

  ${n ? `
        background-color: ${e.color.primary};
        color: ${e.color.white};

        &:active {
          background-color: ${e.color.blue3};
        }
      ` : `
        border: ${e.borderWidth.m} solid ${e.color.border};

        &:active {
          border-color: ${e.color.borderHover};
        }
      `}

  &[disabled] {
    ${Rn}
  }

  &:focus-visible {
    ${cn(e)}
  }
  
`
  )
), e$ = ({
  className: e = "",
  label: n,
  trackingId: o,
  isDisabled: t = !1,
  removeButtonProps: r
}) => {
  const a = {
    isDisabled: t,
    iconName: "x",
    trackingId: `${o}-remove-button`,
    ...r
  };
  return /* @__PURE__ */ g.jsxs(
    t$,
    {
      isDisabled: t,
      className: e,
      alignItems: "center",
      children: [
        /* @__PURE__ */ g.jsx(r$, { shouldTruncate: !0, children: n }),
        /* @__PURE__ */ g.jsx(n$, { ...a })
      ]
    }
  );
}, t$ = Y(Be)(
  ({ theme: e, isDisabled: n }) => `
    ${n ? Rn : ""}
    background-color: ${Fr(e.color.secondary)};
    border-radius: ${e.borderRadius.round};
    width: fit-content;
    height: ${e.sizing.xs};
  `
), r$ = Y(Sf)(
  ({ theme: e }) => `
    padding: ${e.spacing.xxs} ${e.spacing.xs} ${e.spacing.xxs} ${e.spacing.s};
    color: ${e.color.secondary};
  `
), n$ = Y(Fn)(
  ({ theme: e }) => `
    color: ${e.color.secondary};
  `
);
function Ln(e) {
  "@babel/helpers - typeof";
  return Ln = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ln(e);
}
function Ft(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var n = Number(e);
  return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
}
function We(e, n) {
  if (n.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + n.length + " present");
}
function Xe(e) {
  We(1, arguments);
  var n = Object.prototype.toString.call(e);
  return e instanceof Date || Ln(e) === "object" && n === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || n === "[object Number]" ? new Date(e) : ((typeof e == "string" || n === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Qa(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Ft(n);
  return isNaN(t) ? /* @__PURE__ */ new Date(NaN) : (t && o.setDate(o.getDate() + t), o);
}
function Qn(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Ft(n);
  if (isNaN(t))
    return /* @__PURE__ */ new Date(NaN);
  if (!t)
    return o;
  var r = o.getDate(), a = new Date(o.getTime());
  a.setMonth(o.getMonth() + t + 1, 0);
  var i = a.getDate();
  return r >= i ? a : (o.setFullYear(a.getFullYear(), a.getMonth(), r), o);
}
function Xf(e, n) {
  We(2, arguments);
  var o = Xe(e).getTime(), t = Ft(n);
  return new Date(o + t);
}
var o$ = 36e5;
function a$(e, n) {
  We(2, arguments);
  var o = Ft(n);
  return Xf(e, o * o$);
}
var i$ = {};
function ga() {
  return i$;
}
function my(e, n) {
  var o, t, r, a, i, s, l, u;
  We(1, arguments);
  var c = ga(), p = Ft((o = (t = (r = (a = n == null ? void 0 : n.weekStartsOn) !== null && a !== void 0 ? a : n == null || (i = n.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && r !== void 0 ? r : c.weekStartsOn) !== null && t !== void 0 ? t : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && o !== void 0 ? o : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = Xe(e), O = h.getDay(), C = (O < p ? 7 : 0) + O - p;
  return h.setDate(h.getDate() - C), h.setHours(0, 0, 0, 0), h;
}
function tl(e) {
  return We(1, arguments), my(e, {
    weekStartsOn: 1
  });
}
function s$(e) {
  We(1, arguments);
  var n = Xe(e), o = n.getFullYear(), t = /* @__PURE__ */ new Date(0);
  t.setFullYear(o + 1, 0, 4), t.setHours(0, 0, 0, 0);
  var r = tl(t), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(o, 0, 4), a.setHours(0, 0, 0, 0);
  var i = tl(a);
  return n.getTime() >= r.getTime() ? o + 1 : n.getTime() >= i.getTime() ? o : o - 1;
}
function l$(e) {
  We(1, arguments);
  var n = s$(e), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  var t = tl(o);
  return t;
}
function rl(e) {
  var n = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return n.setUTCFullYear(e.getFullYear()), e.getTime() - n.getTime();
}
function Un(e) {
  We(1, arguments);
  var n = Xe(e);
  return n.setHours(0, 0, 0, 0), n;
}
var u$ = 864e5;
function nl(e, n) {
  We(2, arguments);
  var o = Un(e), t = Un(n), r = o.getTime() - rl(o), a = t.getTime() - rl(t);
  return Math.round((r - a) / u$);
}
var c$ = 6e4;
function Pd(e, n) {
  We(2, arguments);
  var o = Ft(n);
  return Xf(e, o * c$);
}
function yy(e, n) {
  We(2, arguments);
  var o = Ft(n), t = o * 3;
  return Qn(e, t);
}
function Jf(e, n) {
  We(2, arguments);
  var o = Ft(n), t = o * 7;
  return Qa(e, t);
}
function za(e, n) {
  We(2, arguments);
  var o = Ft(n);
  return Qn(e, o * 12);
}
function jg(e) {
  We(1, arguments);
  var n;
  if (e && typeof e.forEach == "function")
    n = e;
  else if (Ln(e) === "object" && e !== null)
    n = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var o;
  return n.forEach(function(t) {
    var r = Xe(t);
    (o === void 0 || o < r || isNaN(Number(r))) && (o = r);
  }), o || /* @__PURE__ */ new Date(NaN);
}
function _g(e) {
  We(1, arguments);
  var n;
  if (e && typeof e.forEach == "function")
    n = e;
  else if (Ln(e) === "object" && e !== null)
    n = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var o;
  return n.forEach(function(t) {
    var r = Xe(t);
    (o === void 0 || o > r || isNaN(r.getDate())) && (o = r);
  }), o || /* @__PURE__ */ new Date(NaN);
}
var Zf = 6e4, ev = 36e5, d$ = 1e3;
function by(e, n) {
  We(2, arguments);
  var o = Un(e), t = Un(n);
  return o.getTime() === t.getTime();
}
function tv(e) {
  return We(1, arguments), e instanceof Date || Ln(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function wy(e) {
  if (We(1, arguments), !tv(e) && typeof e != "number")
    return !1;
  var n = Xe(e);
  return !isNaN(Number(n));
}
function ol(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Xe(n), r = o.getFullYear() - t.getFullYear(), a = o.getMonth() - t.getMonth();
  return r * 12 + a;
}
function Da(e) {
  We(1, arguments);
  var n = Xe(e), o = Math.floor(n.getMonth() / 3) + 1;
  return o;
}
function al(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Xe(n);
  return o.getFullYear() - t.getFullYear();
}
function il(e) {
  We(1, arguments);
  var n = Xe(e);
  return n.setHours(23, 59, 59, 999), n;
}
function p$(e) {
  We(1, arguments);
  var n = Xe(e), o = n.getMonth();
  return n.setFullYear(n.getFullYear(), o + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Ed(e) {
  We(1, arguments);
  var n = Xe(e), o = n.getMonth(), t = o - o % 3;
  return n.setMonth(t, 1), n.setHours(0, 0, 0, 0), n;
}
function xy(e) {
  We(1, arguments);
  var n = Xe(e);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function kd(e) {
  We(1, arguments);
  var n = Xe(e), o = n.getFullYear();
  return n.setFullYear(o + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function ki(e) {
  We(1, arguments);
  var n = Xe(e), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(n.getFullYear(), 0, 1), o.setHours(0, 0, 0, 0), o;
}
function Cy(e, n) {
  We(2, arguments);
  var o = Ft(n);
  return Xf(e, -o);
}
var f$ = 864e5;
function v$(e) {
  We(1, arguments);
  var n = Xe(e), o = n.getTime();
  n.setUTCMonth(0, 1), n.setUTCHours(0, 0, 0, 0);
  var t = n.getTime(), r = o - t;
  return Math.floor(r / f$) + 1;
}
function Ha(e) {
  We(1, arguments);
  var n = 1, o = Xe(e), t = o.getUTCDay(), r = (t < n ? 7 : 0) + t - n;
  return o.setUTCDate(o.getUTCDate() - r), o.setUTCHours(0, 0, 0, 0), o;
}
function Sy(e) {
  We(1, arguments);
  var n = Xe(e), o = n.getUTCFullYear(), t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(o + 1, 0, 4), t.setUTCHours(0, 0, 0, 0);
  var r = Ha(t), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(o, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var i = Ha(a);
  return n.getTime() >= r.getTime() ? o + 1 : n.getTime() >= i.getTime() ? o : o - 1;
}
function g$(e) {
  We(1, arguments);
  var n = Sy(e), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(n, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var t = Ha(o);
  return t;
}
var h$ = 6048e5;
function Oy(e) {
  We(1, arguments);
  var n = Xe(e), o = Ha(n).getTime() - g$(n).getTime();
  return Math.round(o / h$) + 1;
}
function ca(e, n) {
  var o, t, r, a, i, s, l, u;
  We(1, arguments);
  var c = ga(), p = Ft((o = (t = (r = (a = n == null ? void 0 : n.weekStartsOn) !== null && a !== void 0 ? a : n == null || (i = n.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && r !== void 0 ? r : c.weekStartsOn) !== null && t !== void 0 ? t : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && o !== void 0 ? o : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = Xe(e), O = h.getUTCDay(), C = (O < p ? 7 : 0) + O - p;
  return h.setUTCDate(h.getUTCDate() - C), h.setUTCHours(0, 0, 0, 0), h;
}
function rv(e, n) {
  var o, t, r, a, i, s, l, u;
  We(1, arguments);
  var c = Xe(e), p = c.getUTCFullYear(), h = ga(), O = Ft((o = (t = (r = (a = n == null ? void 0 : n.firstWeekContainsDate) !== null && a !== void 0 ? a : n == null || (i = n.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && r !== void 0 ? r : h.firstWeekContainsDate) !== null && t !== void 0 ? t : (l = h.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(O >= 1 && O <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var C = /* @__PURE__ */ new Date(0);
  C.setUTCFullYear(p + 1, 0, O), C.setUTCHours(0, 0, 0, 0);
  var P = ca(C, n), k = /* @__PURE__ */ new Date(0);
  k.setUTCFullYear(p, 0, O), k.setUTCHours(0, 0, 0, 0);
  var $ = ca(k, n);
  return c.getTime() >= P.getTime() ? p + 1 : c.getTime() >= $.getTime() ? p : p - 1;
}
function m$(e, n) {
  var o, t, r, a, i, s, l, u;
  We(1, arguments);
  var c = ga(), p = Ft((o = (t = (r = (a = n == null ? void 0 : n.firstWeekContainsDate) !== null && a !== void 0 ? a : n == null || (i = n.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && r !== void 0 ? r : c.firstWeekContainsDate) !== null && t !== void 0 ? t : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && o !== void 0 ? o : 1), h = rv(e, n), O = /* @__PURE__ */ new Date(0);
  O.setUTCFullYear(h, 0, p), O.setUTCHours(0, 0, 0, 0);
  var C = ca(O, n);
  return C;
}
var y$ = 6048e5;
function Py(e, n) {
  We(1, arguments);
  var o = Xe(e), t = ca(o, n).getTime() - m$(o, n).getTime();
  return Math.round(t / y$) + 1;
}
function lr(e, n) {
  for (var o = e < 0 ? "-" : "", t = Math.abs(e).toString(); t.length < n; )
    t = "0" + t;
  return o + t;
}
var b$ = {
  // Year
  y: function(n, o) {
    var t = n.getUTCFullYear(), r = t > 0 ? t : 1 - t;
    return lr(o === "yy" ? r % 100 : r, o.length);
  },
  // Month
  M: function(n, o) {
    var t = n.getUTCMonth();
    return o === "M" ? String(t + 1) : lr(t + 1, 2);
  },
  // Day of the month
  d: function(n, o) {
    return lr(n.getUTCDate(), o.length);
  },
  // AM or PM
  a: function(n, o) {
    var t = n.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (o) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(n, o) {
    return lr(n.getUTCHours() % 12 || 12, o.length);
  },
  // Hour [0-23]
  H: function(n, o) {
    return lr(n.getUTCHours(), o.length);
  },
  // Minute
  m: function(n, o) {
    return lr(n.getUTCMinutes(), o.length);
  },
  // Second
  s: function(n, o) {
    return lr(n.getUTCSeconds(), o.length);
  },
  // Fraction of second
  S: function(n, o) {
    var t = o.length, r = n.getUTCMilliseconds(), a = Math.floor(r * Math.pow(10, t - 3));
    return lr(a, o.length);
  }
};
const jo = b$;
var ka = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, w$ = {
  // Era
  G: function(n, o, t) {
    var r = n.getUTCFullYear() > 0 ? 1 : 0;
    switch (o) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, {
          width: "abbreviated"
        });
      case "GGGGG":
        return t.era(r, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return t.era(r, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(n, o, t) {
    if (o === "yo") {
      var r = n.getUTCFullYear(), a = r > 0 ? r : 1 - r;
      return t.ordinalNumber(a, {
        unit: "year"
      });
    }
    return jo.y(n, o);
  },
  // Local week-numbering year
  Y: function(n, o, t, r) {
    var a = rv(n, r), i = a > 0 ? a : 1 - a;
    if (o === "YY") {
      var s = i % 100;
      return lr(s, 2);
    }
    return o === "Yo" ? t.ordinalNumber(i, {
      unit: "year"
    }) : lr(i, o.length);
  },
  // ISO week-numbering year
  R: function(n, o) {
    var t = Sy(n);
    return lr(t, o.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, o) {
    var t = n.getUTCFullYear();
    return lr(t, o.length);
  },
  // Quarter
  Q: function(n, o, t) {
    var r = Math.ceil((n.getUTCMonth() + 1) / 3);
    switch (o) {
      case "Q":
        return String(r);
      case "QQ":
        return lr(r, 2);
      case "Qo":
        return t.ordinalNumber(r, {
          unit: "quarter"
        });
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, o, t) {
    var r = Math.ceil((n.getUTCMonth() + 1) / 3);
    switch (o) {
      case "q":
        return String(r);
      case "qq":
        return lr(r, 2);
      case "qo":
        return t.ordinalNumber(r, {
          unit: "quarter"
        });
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, o, t) {
    var r = n.getUTCMonth();
    switch (o) {
      case "M":
      case "MM":
        return jo.M(n, o);
      case "Mo":
        return t.ordinalNumber(r + 1, {
          unit: "month"
        });
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(n, o, t) {
    var r = n.getUTCMonth();
    switch (o) {
      case "L":
        return String(r + 1);
      case "LL":
        return lr(r + 1, 2);
      case "Lo":
        return t.ordinalNumber(r + 1, {
          unit: "month"
        });
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(n, o, t, r) {
    var a = Py(n, r);
    return o === "wo" ? t.ordinalNumber(a, {
      unit: "week"
    }) : lr(a, o.length);
  },
  // ISO week of year
  I: function(n, o, t) {
    var r = Oy(n);
    return o === "Io" ? t.ordinalNumber(r, {
      unit: "week"
    }) : lr(r, o.length);
  },
  // Day of the month
  d: function(n, o, t) {
    return o === "do" ? t.ordinalNumber(n.getUTCDate(), {
      unit: "date"
    }) : jo.d(n, o);
  },
  // Day of year
  D: function(n, o, t) {
    var r = v$(n);
    return o === "Do" ? t.ordinalNumber(r, {
      unit: "dayOfYear"
    }) : lr(r, o.length);
  },
  // Day of week
  E: function(n, o, t) {
    var r = n.getUTCDay();
    switch (o) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, o, t, r) {
    var a = n.getUTCDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (o) {
      case "e":
        return String(i);
      case "ee":
        return lr(i, 2);
      case "eo":
        return t.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, o, t, r) {
    var a = n.getUTCDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (o) {
      case "c":
        return String(i);
      case "cc":
        return lr(i, o.length);
      case "co":
        return t.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return t.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, o, t) {
    var r = n.getUTCDay(), a = r === 0 ? 7 : r;
    switch (o) {
      case "i":
        return String(a);
      case "ii":
        return lr(a, o.length);
      case "io":
        return t.ordinalNumber(a, {
          unit: "day"
        });
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, o, t) {
    var r = n.getUTCHours(), a = r / 12 >= 1 ? "pm" : "am";
    switch (o) {
      case "a":
      case "aa":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, o, t) {
    var r = n.getUTCHours(), a;
    switch (r === 12 ? a = ka.noon : r === 0 ? a = ka.midnight : a = r / 12 >= 1 ? "pm" : "am", o) {
      case "b":
      case "bb":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, o, t) {
    var r = n.getUTCHours(), a;
    switch (r >= 17 ? a = ka.evening : r >= 12 ? a = ka.afternoon : r >= 4 ? a = ka.morning : a = ka.night, o) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, o, t) {
    if (o === "ho") {
      var r = n.getUTCHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, {
        unit: "hour"
      });
    }
    return jo.h(n, o);
  },
  // Hour [0-23]
  H: function(n, o, t) {
    return o === "Ho" ? t.ordinalNumber(n.getUTCHours(), {
      unit: "hour"
    }) : jo.H(n, o);
  },
  // Hour [0-11]
  K: function(n, o, t) {
    var r = n.getUTCHours() % 12;
    return o === "Ko" ? t.ordinalNumber(r, {
      unit: "hour"
    }) : lr(r, o.length);
  },
  // Hour [1-24]
  k: function(n, o, t) {
    var r = n.getUTCHours();
    return r === 0 && (r = 24), o === "ko" ? t.ordinalNumber(r, {
      unit: "hour"
    }) : lr(r, o.length);
  },
  // Minute
  m: function(n, o, t) {
    return o === "mo" ? t.ordinalNumber(n.getUTCMinutes(), {
      unit: "minute"
    }) : jo.m(n, o);
  },
  // Second
  s: function(n, o, t) {
    return o === "so" ? t.ordinalNumber(n.getUTCSeconds(), {
      unit: "second"
    }) : jo.s(n, o);
  },
  // Fraction of second
  S: function(n, o) {
    return jo.S(n, o);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, o, t, r) {
    var a = r._originalDate || n, i = a.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (o) {
      case "X":
        return Mg(i);
      case "XXXX":
      case "XX":
        return ta(i);
      case "XXXXX":
      case "XXX":
      default:
        return ta(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, o, t, r) {
    var a = r._originalDate || n, i = a.getTimezoneOffset();
    switch (o) {
      case "x":
        return Mg(i);
      case "xxxx":
      case "xx":
        return ta(i);
      case "xxxxx":
      case "xxx":
      default:
        return ta(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, o, t, r) {
    var a = r._originalDate || n, i = a.getTimezoneOffset();
    switch (o) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ig(i, ":");
      case "OOOO":
      default:
        return "GMT" + ta(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, o, t, r) {
    var a = r._originalDate || n, i = a.getTimezoneOffset();
    switch (o) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ig(i, ":");
      case "zzzz":
      default:
        return "GMT" + ta(i, ":");
    }
  },
  // Seconds timestamp
  t: function(n, o, t, r) {
    var a = r._originalDate || n, i = Math.floor(a.getTime() / 1e3);
    return lr(i, o.length);
  },
  // Milliseconds timestamp
  T: function(n, o, t, r) {
    var a = r._originalDate || n, i = a.getTime();
    return lr(i, o.length);
  }
};
function Ig(e, n) {
  var o = e > 0 ? "-" : "+", t = Math.abs(e), r = Math.floor(t / 60), a = t % 60;
  if (a === 0)
    return o + String(r);
  var i = n || "";
  return o + String(r) + i + lr(a, 2);
}
function Mg(e, n) {
  if (e % 60 === 0) {
    var o = e > 0 ? "-" : "+";
    return o + lr(Math.abs(e) / 60, 2);
  }
  return ta(e, n);
}
function ta(e, n) {
  var o = n || "", t = e > 0 ? "-" : "+", r = Math.abs(e), a = lr(Math.floor(r / 60), 2), i = lr(r % 60, 2);
  return t + a + o + i;
}
const x$ = w$;
var Ag = function(n, o) {
  switch (n) {
    case "P":
      return o.date({
        width: "short"
      });
    case "PP":
      return o.date({
        width: "medium"
      });
    case "PPP":
      return o.date({
        width: "long"
      });
    case "PPPP":
    default:
      return o.date({
        width: "full"
      });
  }
}, Ey = function(n, o) {
  switch (n) {
    case "p":
      return o.time({
        width: "short"
      });
    case "pp":
      return o.time({
        width: "medium"
      });
    case "ppp":
      return o.time({
        width: "long"
      });
    case "pppp":
    default:
      return o.time({
        width: "full"
      });
  }
}, C$ = function(n, o) {
  var t = n.match(/(P+)(p+)?/) || [], r = t[1], a = t[2];
  if (!a)
    return Ag(n, o);
  var i;
  switch (r) {
    case "P":
      i = o.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = o.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = o.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = o.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", Ag(r, o)).replace("{{time}}", Ey(a, o));
}, S$ = {
  p: Ey,
  P: C$
};
const Rd = S$;
var O$ = ["D", "DD"], P$ = ["YY", "YYYY"];
function ky(e) {
  return O$.indexOf(e) !== -1;
}
function Ry(e) {
  return P$.indexOf(e) !== -1;
}
function sl(e, n, o) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(n, "`) for formatting years to the input `").concat(o, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(n, "`) for formatting years to the input `").concat(o, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(n, "`) for formatting days of the month to the input `").concat(o, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(n, "`) for formatting days of the month to the input `").concat(o, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var E$ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, k$ = function(n, o, t) {
  var r, a = E$[n];
  return typeof a == "string" ? r = a : o === 1 ? r = a.one : r = a.other.replace("{{count}}", o.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
const R$ = k$;
function Lu(e) {
  return function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = n.width ? String(n.width) : e.defaultWidth, t = e.formats[o] || e.formats[e.defaultWidth];
    return t;
  };
}
var $$ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, D$ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, T$ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, j$ = {
  date: Lu({
    formats: $$,
    defaultWidth: "full"
  }),
  time: Lu({
    formats: D$,
    defaultWidth: "full"
  }),
  dateTime: Lu({
    formats: T$,
    defaultWidth: "full"
  })
};
const _$ = j$;
var I$ = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, M$ = function(n, o, t, r) {
  return I$[n];
};
const A$ = M$;
function hi(e) {
  return function(n, o) {
    var t = o != null && o.context ? String(o.context) : "standalone", r;
    if (t === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, i = o != null && o.width ? String(o.width) : a;
      r = e.formattingValues[i] || e.formattingValues[a];
    } else {
      var s = e.defaultWidth, l = o != null && o.width ? String(o.width) : e.defaultWidth;
      r = e.values[l] || e.values[s];
    }
    var u = e.argumentCallback ? e.argumentCallback(n) : n;
    return r[u];
  };
}
var F$ = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, L$ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, N$ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, B$ = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, W$ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, z$ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, H$ = function(n, o) {
  var t = Number(n), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Y$ = {
  ordinalNumber: H$,
  era: hi({
    values: F$,
    defaultWidth: "wide"
  }),
  quarter: hi({
    values: L$,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: hi({
    values: N$,
    defaultWidth: "wide"
  }),
  day: hi({
    values: B$,
    defaultWidth: "wide"
  }),
  dayPeriod: hi({
    values: W$,
    defaultWidth: "wide",
    formattingValues: z$,
    defaultFormattingWidth: "wide"
  })
};
const G$ = Y$;
function mi(e) {
  return function(n) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = o.width, r = t && e.matchPatterns[t] || e.matchPatterns[e.defaultMatchWidth], a = n.match(r);
    if (!a)
      return null;
    var i = a[0], s = t && e.parsePatterns[t] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? U$(s, function(p) {
      return p.test(i);
    }) : V$(s, function(p) {
      return p.test(i);
    }), u;
    u = e.valueCallback ? e.valueCallback(l) : l, u = o.valueCallback ? o.valueCallback(u) : u;
    var c = n.slice(i.length);
    return {
      value: u,
      rest: c
    };
  };
}
function V$(e, n) {
  for (var o in e)
    if (e.hasOwnProperty(o) && n(e[o]))
      return o;
}
function U$(e, n) {
  for (var o = 0; o < e.length; o++)
    if (n(e[o]))
      return o;
}
function q$(e) {
  return function(n) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.match(e.matchPattern);
    if (!t)
      return null;
    var r = t[0], a = n.match(e.parsePattern);
    if (!a)
      return null;
    var i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = o.valueCallback ? o.valueCallback(i) : i;
    var s = n.slice(r.length);
    return {
      value: i,
      rest: s
    };
  };
}
var K$ = /^(\d+)(th|st|nd|rd)?/i, Q$ = /\d+/i, X$ = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, J$ = {
  any: [/^b/i, /^(a|c)/i]
}, Z$ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, eD = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, tD = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, rD = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, nD = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, oD = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, aD = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, iD = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, sD = {
  ordinalNumber: q$({
    matchPattern: K$,
    parsePattern: Q$,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: mi({
    matchPatterns: X$,
    defaultMatchWidth: "wide",
    parsePatterns: J$,
    defaultParseWidth: "any"
  }),
  quarter: mi({
    matchPatterns: Z$,
    defaultMatchWidth: "wide",
    parsePatterns: eD,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: mi({
    matchPatterns: tD,
    defaultMatchWidth: "wide",
    parsePatterns: rD,
    defaultParseWidth: "any"
  }),
  day: mi({
    matchPatterns: nD,
    defaultMatchWidth: "wide",
    parsePatterns: oD,
    defaultParseWidth: "any"
  }),
  dayPeriod: mi({
    matchPatterns: aD,
    defaultMatchWidth: "any",
    parsePatterns: iD,
    defaultParseWidth: "any"
  })
};
const lD = sD;
var uD = {
  code: "en-US",
  formatDistance: R$,
  formatLong: _$,
  formatRelative: A$,
  localize: G$,
  match: lD,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const $y = uD;
var cD = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, dD = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, pD = /^'([^]*?)'?$/, fD = /''/g, vD = /[a-zA-Z]/;
function Fg(e, n, o) {
  var t, r, a, i, s, l, u, c, p, h, O, C, P, k, $, I, H, x;
  We(2, arguments);
  var _ = String(n), F = ga(), G = (t = (r = o == null ? void 0 : o.locale) !== null && r !== void 0 ? r : F.locale) !== null && t !== void 0 ? t : $y, Q = Ft((a = (i = (s = (l = o == null ? void 0 : o.firstWeekContainsDate) !== null && l !== void 0 ? l : o == null || (u = o.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && s !== void 0 ? s : F.firstWeekContainsDate) !== null && i !== void 0 ? i : (p = F.locale) === null || p === void 0 || (h = p.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(Q >= 1 && Q <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var V = Ft((O = (C = (P = (k = o == null ? void 0 : o.weekStartsOn) !== null && k !== void 0 ? k : o == null || ($ = o.locale) === null || $ === void 0 || (I = $.options) === null || I === void 0 ? void 0 : I.weekStartsOn) !== null && P !== void 0 ? P : F.weekStartsOn) !== null && C !== void 0 ? C : (H = F.locale) === null || H === void 0 || (x = H.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && O !== void 0 ? O : 0);
  if (!(V >= 0 && V <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!G.localize)
    throw new RangeError("locale must contain localize property");
  if (!G.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var ie = Xe(e);
  if (!wy(ie))
    throw new RangeError("Invalid time value");
  var ce = rl(ie), me = Cy(ie, ce), ve = {
    firstWeekContainsDate: Q,
    weekStartsOn: V,
    locale: G,
    _originalDate: ie
  }, U = _.match(dD).map(function(ee) {
    var oe = ee[0];
    if (oe === "p" || oe === "P") {
      var ge = Rd[oe];
      return ge(ee, G.formatLong);
    }
    return ee;
  }).join("").match(cD).map(function(ee) {
    if (ee === "''")
      return "'";
    var oe = ee[0];
    if (oe === "'")
      return gD(ee);
    var ge = x$[oe];
    if (ge)
      return !(o != null && o.useAdditionalWeekYearTokens) && Ry(ee) && sl(ee, n, String(e)), !(o != null && o.useAdditionalDayOfYearTokens) && ky(ee) && sl(ee, n, String(e)), ge(me, ee, G.localize, ve);
    if (oe.match(vD))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + oe + "`");
    return ee;
  }).join("");
  return U;
}
function gD(e) {
  var n = e.match(pD);
  return n ? n[1].replace(fD, "'") : e;
}
function hD(e, n) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var o in n)
    Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  return e;
}
function Lg(e) {
  We(1, arguments);
  var n = Xe(e), o = n.getDate();
  return o;
}
function mD(e) {
  We(1, arguments);
  var n = Xe(e), o = n.getDay();
  return o;
}
function yD(e) {
  We(1, arguments);
  var n = Xe(e), o = n.getFullYear(), t = n.getMonth(), r = /* @__PURE__ */ new Date(0);
  return r.setFullYear(o, t + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
function Sn(e) {
  We(1, arguments);
  var n = Xe(e), o = n.getHours();
  return o;
}
var bD = 6048e5;
function wD(e) {
  We(1, arguments);
  var n = Xe(e), o = tl(n).getTime() - l$(n).getTime();
  return Math.round(o / bD) + 1;
}
function On(e) {
  We(1, arguments);
  var n = Xe(e), o = n.getMinutes();
  return o;
}
function en(e) {
  We(1, arguments);
  var n = Xe(e), o = n.getMonth();
  return o;
}
function Nu(e) {
  We(1, arguments);
  var n = Xe(e), o = n.getSeconds();
  return o;
}
function $d(e) {
  We(1, arguments);
  var n = Xe(e), o = n.getTime();
  return o;
}
function Wt(e) {
  return We(1, arguments), Xe(e).getFullYear();
}
function zo(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Xe(n);
  return o.getTime() > t.getTime();
}
function yo(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Xe(n);
  return o.getTime() < t.getTime();
}
function xD(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Xe(n);
  return o.getTime() === t.getTime();
}
function Ng(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var o = 0, t = new Array(n); o < n; o++)
    t[o] = e[o];
  return t;
}
function CD(e, n) {
  if (e) {
    if (typeof e == "string")
      return Ng(e, n);
    var o = Object.prototype.toString.call(e).slice(8, -1);
    if (o === "Object" && e.constructor && (o = e.constructor.name), o === "Map" || o === "Set")
      return Array.from(e);
    if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o))
      return Ng(e, n);
  }
}
function Bg(e, n) {
  var o = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!o) {
    if (Array.isArray(e) || (o = CD(e)) || n && e && typeof e.length == "number") {
      o && (e = o);
      var t = 0, r = function() {
      };
      return {
        s: r,
        n: function() {
          return t >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[t++]
          };
        },
        e: function(u) {
          throw u;
        },
        f: r
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, i = !1, s;
  return {
    s: function() {
      o = o.call(e);
    },
    n: function() {
      var u = o.next();
      return a = u.done, u;
    },
    e: function(u) {
      i = !0, s = u;
    },
    f: function() {
      try {
        !a && o.return != null && o.return();
      } finally {
        if (i)
          throw s;
      }
    }
  };
}
function Ke(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Dd(e, n) {
  return Dd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, r) {
    return t.__proto__ = r, t;
  }, Dd(e, n);
}
function Zt(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), n && Dd(e, n);
}
function ll(e) {
  return ll = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, ll(e);
}
function SD() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function OD(e, n) {
  if (n && (Ln(n) === "object" || typeof n == "function"))
    return n;
  if (n !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ke(e);
}
function er(e) {
  var n = SD();
  return function() {
    var t = ll(e), r;
    if (n) {
      var a = ll(this).constructor;
      r = Reflect.construct(t, arguments, a);
    } else
      r = t.apply(this, arguments);
    return OD(this, r);
  };
}
function Vt(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function PD(e, n) {
  if (Ln(e) !== "object" || e === null)
    return e;
  var o = e[Symbol.toPrimitive];
  if (o !== void 0) {
    var t = o.call(e, n || "default");
    if (Ln(t) !== "object")
      return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function Dy(e) {
  var n = PD(e, "string");
  return Ln(n) === "symbol" ? n : String(n);
}
function Wg(e, n) {
  for (var o = 0; o < n.length; o++) {
    var t = n[o];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, Dy(t.key), t);
  }
}
function Ut(e, n, o) {
  return n && Wg(e.prototype, n), o && Wg(e, o), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Ue(e, n, o) {
  return n = Dy(n), n in e ? Object.defineProperty(e, n, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = o, e;
}
var ED = 10, Ty = /* @__PURE__ */ function() {
  function e() {
    Vt(this, e), Ue(this, "priority", void 0), Ue(this, "subPriority", 0);
  }
  return Ut(e, [{
    key: "validate",
    value: function(o, t) {
      return !0;
    }
  }]), e;
}(), kD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o(t, r, a, i, s) {
    var l;
    return Vt(this, o), l = n.call(this), l.value = t, l.validateValue = r, l.setValue = a, l.priority = i, s && (l.subPriority = s), l;
  }
  return Ut(o, [{
    key: "validate",
    value: function(r, a) {
      return this.validateValue(r, this.value, a);
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return this.setValue(r, a, this.value, i);
    }
  }]), o;
}(Ty), RD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", ED), Ue(Ke(t), "subPriority", -1), t;
  }
  return Ut(o, [{
    key: "set",
    value: function(r, a) {
      if (a.timestampIsSet)
        return r;
      var i = /* @__PURE__ */ new Date(0);
      return i.setFullYear(r.getUTCFullYear(), r.getUTCMonth(), r.getUTCDate()), i.setHours(r.getUTCHours(), r.getUTCMinutes(), r.getUTCSeconds(), r.getUTCMilliseconds()), i;
    }
  }]), o;
}(Ty), or = /* @__PURE__ */ function() {
  function e() {
    Vt(this, e), Ue(this, "incompatibleTokens", void 0), Ue(this, "priority", void 0), Ue(this, "subPriority", void 0);
  }
  return Ut(e, [{
    key: "run",
    value: function(o, t, r, a) {
      var i = this.parse(o, t, r, a);
      return i ? {
        setter: new kD(i.value, this.validate, this.set, this.priority, this.subPriority),
        rest: i.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(o, t, r) {
      return !0;
    }
  }]), e;
}(), $D = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 140), Ue(Ke(t), "incompatibleTokens", ["R", "u", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "G":
        case "GG":
        case "GGG":
          return i.era(r, {
            width: "abbreviated"
          }) || i.era(r, {
            width: "narrow"
          });
        case "GGGGG":
          return i.era(r, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return i.era(r, {
            width: "wide"
          }) || i.era(r, {
            width: "abbreviated"
          }) || i.era(r, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return a.era = i, r.setUTCFullYear(i, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(or), $r = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, no = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Dr(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function Cr(e, n) {
  var o = n.match(e);
  return o ? {
    value: parseInt(o[0], 10),
    rest: n.slice(o[0].length)
  } : null;
}
function oo(e, n) {
  var o = n.match(e);
  if (!o)
    return null;
  if (o[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  var t = o[1] === "+" ? 1 : -1, r = o[2] ? parseInt(o[2], 10) : 0, a = o[3] ? parseInt(o[3], 10) : 0, i = o[5] ? parseInt(o[5], 10) : 0;
  return {
    value: t * (r * ev + a * Zf + i * d$),
    rest: n.slice(o[0].length)
  };
}
function jy(e) {
  return Cr($r.anyDigitsSigned, e);
}
function kr(e, n) {
  switch (e) {
    case 1:
      return Cr($r.singleDigit, n);
    case 2:
      return Cr($r.twoDigits, n);
    case 3:
      return Cr($r.threeDigits, n);
    case 4:
      return Cr($r.fourDigits, n);
    default:
      return Cr(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function ul(e, n) {
  switch (e) {
    case 1:
      return Cr($r.singleDigitSigned, n);
    case 2:
      return Cr($r.twoDigitsSigned, n);
    case 3:
      return Cr($r.threeDigitsSigned, n);
    case 4:
      return Cr($r.fourDigitsSigned, n);
    default:
      return Cr(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function nv(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function _y(e, n) {
  var o = n > 0, t = o ? n : 1 - n, r;
  if (t <= 50)
    r = e || 100;
  else {
    var a = t + 50, i = Math.floor(a / 100) * 100, s = e >= a % 100;
    r = e + i - (s ? 100 : 0);
  }
  return o ? r : 1 - r;
}
function Iy(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var DD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 130), Ue(Ke(t), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      var s = function(u) {
        return {
          year: u,
          isTwoDigitYear: a === "yy"
        };
      };
      switch (a) {
        case "y":
          return Dr(kr(4, r), s);
        case "yo":
          return Dr(i.ordinalNumber(r, {
            unit: "year"
          }), s);
        default:
          return Dr(kr(a.length, r), s);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      var s = r.getUTCFullYear();
      if (i.isTwoDigitYear) {
        var l = _y(i.year, s);
        return r.setUTCFullYear(l, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
      }
      var u = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
      return r.setUTCFullYear(u, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(or), TD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 130), Ue(Ke(t), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      var s = function(u) {
        return {
          year: u,
          isTwoDigitYear: a === "YY"
        };
      };
      switch (a) {
        case "Y":
          return Dr(kr(4, r), s);
        case "Yo":
          return Dr(i.ordinalNumber(r, {
            unit: "year"
          }), s);
        default:
          return Dr(kr(a.length, r), s);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(r, a, i, s) {
      var l = rv(r, s);
      if (i.isTwoDigitYear) {
        var u = _y(i.year, l);
        return r.setUTCFullYear(u, 0, s.firstWeekContainsDate), r.setUTCHours(0, 0, 0, 0), ca(r, s);
      }
      var c = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
      return r.setUTCFullYear(c, 0, s.firstWeekContainsDate), r.setUTCHours(0, 0, 0, 0), ca(r, s);
    }
  }]), o;
}(or), jD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 130), Ue(Ke(t), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a) {
      return ul(a === "R" ? 4 : a.length, r);
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(i, 0, 4), s.setUTCHours(0, 0, 0, 0), Ha(s);
    }
  }]), o;
}(or), _D = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 130), Ue(Ke(t), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a) {
      return ul(a === "u" ? 4 : a.length, r);
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCFullYear(i, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(or), ID = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 120), Ue(Ke(t), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "Q":
        case "QQ":
          return kr(a.length, r);
        case "Qo":
          return i.ordinalNumber(r, {
            unit: "quarter"
          });
        case "QQQ":
          return i.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return i.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return i.quarter(r, {
            width: "wide",
            context: "formatting"
          }) || i.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCMonth((i - 1) * 3, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(or), MD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 120), Ue(Ke(t), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "q":
        case "qq":
          return kr(a.length, r);
        case "qo":
          return i.ordinalNumber(r, {
            unit: "quarter"
          });
        case "qqq":
          return i.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return i.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return i.quarter(r, {
            width: "wide",
            context: "standalone"
          }) || i.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCMonth((i - 1) * 3, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(or), AD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), Ue(Ke(t), "priority", 110), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      var s = function(u) {
        return u - 1;
      };
      switch (a) {
        case "M":
          return Dr(Cr($r.month, r), s);
        case "MM":
          return Dr(kr(2, r), s);
        case "Mo":
          return Dr(i.ordinalNumber(r, {
            unit: "month"
          }), s);
        case "MMM":
          return i.month(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(r, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return i.month(r, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return i.month(r, {
            width: "wide",
            context: "formatting"
          }) || i.month(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCMonth(i, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(or), FD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 110), Ue(Ke(t), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      var s = function(u) {
        return u - 1;
      };
      switch (a) {
        case "L":
          return Dr(Cr($r.month, r), s);
        case "LL":
          return Dr(kr(2, r), s);
        case "Lo":
          return Dr(i.ordinalNumber(r, {
            unit: "month"
          }), s);
        case "LLL":
          return i.month(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(r, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return i.month(r, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return i.month(r, {
            width: "wide",
            context: "standalone"
          }) || i.month(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCMonth(i, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(or);
function LD(e, n, o) {
  We(2, arguments);
  var t = Xe(e), r = Ft(n), a = Py(t, o) - r;
  return t.setUTCDate(t.getUTCDate() - a * 7), t;
}
var ND = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 100), Ue(Ke(t), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "w":
          return Cr($r.week, r);
        case "wo":
          return i.ordinalNumber(r, {
            unit: "week"
          });
        default:
          return kr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(r, a, i, s) {
      return ca(LD(r, i, s), s);
    }
  }]), o;
}(or);
function BD(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Ft(n), r = Oy(o) - t;
  return o.setUTCDate(o.getUTCDate() - r * 7), o;
}
var WD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 100), Ue(Ke(t), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "I":
          return Cr($r.week, r);
        case "Io":
          return i.ordinalNumber(r, {
            unit: "week"
          });
        default:
          return kr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return Ha(BD(r, i));
    }
  }]), o;
}(or), zD = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], HD = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], YD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 90), Ue(Ke(t), "subPriority", 1), Ue(Ke(t), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "d":
          return Cr($r.date, r);
        case "do":
          return i.ordinalNumber(r, {
            unit: "date"
          });
        default:
          return kr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      var i = r.getUTCFullYear(), s = Iy(i), l = r.getUTCMonth();
      return s ? a >= 1 && a <= HD[l] : a >= 1 && a <= zD[l];
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCDate(i), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(or), GD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 90), Ue(Ke(t), "subpriority", 1), Ue(Ke(t), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "D":
        case "DD":
          return Cr($r.dayOfYear, r);
        case "Do":
          return i.ordinalNumber(r, {
            unit: "date"
          });
        default:
          return kr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      var i = r.getUTCFullYear(), s = Iy(i);
      return s ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCMonth(0, i), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(or);
function ov(e, n, o) {
  var t, r, a, i, s, l, u, c;
  We(2, arguments);
  var p = ga(), h = Ft((t = (r = (a = (i = o == null ? void 0 : o.weekStartsOn) !== null && i !== void 0 ? i : o == null || (s = o.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && a !== void 0 ? a : p.weekStartsOn) !== null && r !== void 0 ? r : (u = p.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && t !== void 0 ? t : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var O = Xe(e), C = Ft(n), P = O.getUTCDay(), k = C % 7, $ = (k + 7) % 7, I = ($ < h ? 7 : 0) + C - P;
  return O.setUTCDate(O.getUTCDate() + I), O;
}
var VD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 90), Ue(Ke(t), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "E":
        case "EE":
        case "EEE":
          return i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return i.day(r, {
            width: "wide",
            context: "formatting"
          }) || i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(r, a, i, s) {
      return r = ov(r, i, s), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(or), UD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 90), Ue(Ke(t), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i, s) {
      var l = function(c) {
        var p = Math.floor((c - 1) / 7) * 7;
        return (c + s.weekStartsOn + 6) % 7 + p;
      };
      switch (a) {
        case "e":
        case "ee":
          return Dr(kr(a.length, r), l);
        case "eo":
          return Dr(i.ordinalNumber(r, {
            unit: "day"
          }), l);
        case "eee":
          return i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return i.day(r, {
            width: "wide",
            context: "formatting"
          }) || i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(r, a, i, s) {
      return r = ov(r, i, s), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(or), qD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 90), Ue(Ke(t), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i, s) {
      var l = function(c) {
        var p = Math.floor((c - 1) / 7) * 7;
        return (c + s.weekStartsOn + 6) % 7 + p;
      };
      switch (a) {
        case "c":
        case "cc":
          return Dr(kr(a.length, r), l);
        case "co":
          return Dr(i.ordinalNumber(r, {
            unit: "day"
          }), l);
        case "ccc":
          return i.day(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(r, {
            width: "short",
            context: "standalone"
          }) || i.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return i.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return i.day(r, {
            width: "short",
            context: "standalone"
          }) || i.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return i.day(r, {
            width: "wide",
            context: "standalone"
          }) || i.day(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(r, {
            width: "short",
            context: "standalone"
          }) || i.day(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(r, a, i, s) {
      return r = ov(r, i, s), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(or);
function KD(e, n) {
  We(2, arguments);
  var o = Ft(n);
  o % 7 === 0 && (o = o - 7);
  var t = 1, r = Xe(e), a = r.getUTCDay(), i = o % 7, s = (i + 7) % 7, l = (s < t ? 7 : 0) + o - a;
  return r.setUTCDate(r.getUTCDate() + l), r;
}
var QD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 90), Ue(Ke(t), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      var s = function(u) {
        return u === 0 ? 7 : u;
      };
      switch (a) {
        case "i":
        case "ii":
          return kr(a.length, r);
        case "io":
          return i.ordinalNumber(r, {
            unit: "day"
          });
        case "iii":
          return Dr(i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiii":
          return Dr(i.day(r, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiiii":
          return Dr(i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiii":
        default:
          return Dr(i.day(r, {
            width: "wide",
            context: "formatting"
          }) || i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 7;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r = KD(r, i), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(or), XD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 80), Ue(Ke(t), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "a":
        case "aa":
        case "aaa":
          return i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return i.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCHours(nv(i), 0, 0, 0), r;
    }
  }]), o;
}(or), JD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 80), Ue(Ke(t), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "b":
        case "bb":
        case "bbb":
          return i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return i.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCHours(nv(i), 0, 0, 0), r;
    }
  }]), o;
}(or), ZD = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 80), Ue(Ke(t), "incompatibleTokens", ["a", "b", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "B":
        case "BB":
        case "BBB":
          return i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return i.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCHours(nv(i), 0, 0, 0), r;
    }
  }]), o;
}(or), eT = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 70), Ue(Ke(t), "incompatibleTokens", ["H", "K", "k", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "h":
          return Cr($r.hour12h, r);
        case "ho":
          return i.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return kr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 12;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      var s = r.getUTCHours() >= 12;
      return s && i < 12 ? r.setUTCHours(i + 12, 0, 0, 0) : !s && i === 12 ? r.setUTCHours(0, 0, 0, 0) : r.setUTCHours(i, 0, 0, 0), r;
    }
  }]), o;
}(or), tT = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 70), Ue(Ke(t), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "H":
          return Cr($r.hour23h, r);
        case "Ho":
          return i.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return kr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 23;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCHours(i, 0, 0, 0), r;
    }
  }]), o;
}(or), rT = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 70), Ue(Ke(t), "incompatibleTokens", ["h", "H", "k", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "K":
          return Cr($r.hour11h, r);
        case "Ko":
          return i.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return kr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      var s = r.getUTCHours() >= 12;
      return s && i < 12 ? r.setUTCHours(i + 12, 0, 0, 0) : r.setUTCHours(i, 0, 0, 0), r;
    }
  }]), o;
}(or), nT = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 70), Ue(Ke(t), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "k":
          return Cr($r.hour24h, r);
        case "ko":
          return i.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return kr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 24;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      var s = i <= 24 ? i % 24 : i;
      return r.setUTCHours(s, 0, 0, 0), r;
    }
  }]), o;
}(or), oT = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 60), Ue(Ke(t), "incompatibleTokens", ["t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "m":
          return Cr($r.minute, r);
        case "mo":
          return i.ordinalNumber(r, {
            unit: "minute"
          });
        default:
          return kr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCMinutes(i, 0, 0), r;
    }
  }]), o;
}(or), aT = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 50), Ue(Ke(t), "incompatibleTokens", ["t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "s":
          return Cr($r.second, r);
        case "so":
          return i.ordinalNumber(r, {
            unit: "second"
          });
        default:
          return kr(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCSeconds(i, 0), r;
    }
  }]), o;
}(or), iT = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 30), Ue(Ke(t), "incompatibleTokens", ["t", "T"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a) {
      var i = function(l) {
        return Math.floor(l * Math.pow(10, -a.length + 3));
      };
      return Dr(kr(a.length, r), i);
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCMilliseconds(i), r;
    }
  }]), o;
}(or), sT = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 10), Ue(Ke(t), "incompatibleTokens", ["t", "T", "x"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a) {
      switch (a) {
        case "X":
          return oo(no.basicOptionalMinutes, r);
        case "XX":
          return oo(no.basic, r);
        case "XXXX":
          return oo(no.basicOptionalSeconds, r);
        case "XXXXX":
          return oo(no.extendedOptionalSeconds, r);
        case "XXX":
        default:
          return oo(no.extended, r);
      }
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return a.timestampIsSet ? r : new Date(r.getTime() - i);
    }
  }]), o;
}(or), lT = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 10), Ue(Ke(t), "incompatibleTokens", ["t", "T", "X"]), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r, a) {
      switch (a) {
        case "x":
          return oo(no.basicOptionalMinutes, r);
        case "xx":
          return oo(no.basic, r);
        case "xxxx":
          return oo(no.basicOptionalSeconds, r);
        case "xxxxx":
          return oo(no.extendedOptionalSeconds, r);
        case "xxx":
        default:
          return oo(no.extended, r);
      }
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return a.timestampIsSet ? r : new Date(r.getTime() - i);
    }
  }]), o;
}(or), uT = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 40), Ue(Ke(t), "incompatibleTokens", "*"), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r) {
      return jy(r);
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return [new Date(i * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), o;
}(or), cT = /* @__PURE__ */ function(e) {
  Zt(o, e);
  var n = er(o);
  function o() {
    var t;
    Vt(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return t = n.call.apply(n, [this].concat(a)), Ue(Ke(t), "priority", 20), Ue(Ke(t), "incompatibleTokens", "*"), t;
  }
  return Ut(o, [{
    key: "parse",
    value: function(r) {
      return jy(r);
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return [new Date(i), {
        timestampIsSet: !0
      }];
    }
  }]), o;
}(or), dT = {
  G: new $D(),
  y: new DD(),
  Y: new TD(),
  R: new jD(),
  u: new _D(),
  Q: new ID(),
  q: new MD(),
  M: new AD(),
  L: new FD(),
  w: new ND(),
  I: new WD(),
  d: new YD(),
  D: new GD(),
  E: new VD(),
  e: new UD(),
  c: new qD(),
  i: new QD(),
  a: new XD(),
  b: new JD(),
  B: new ZD(),
  h: new eT(),
  H: new tT(),
  K: new rT(),
  k: new nT(),
  m: new oT(),
  s: new aT(),
  S: new iT(),
  X: new sT(),
  x: new lT(),
  t: new uT(),
  T: new cT()
}, pT = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, fT = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, vT = /^'([^]*?)'?$/, gT = /''/g, hT = /\S/, mT = /[a-zA-Z]/;
function Bu(e, n, o, t) {
  var r, a, i, s, l, u, c, p, h, O, C, P, k, $, I, H, x, _;
  We(3, arguments);
  var F = String(e), G = String(n), Q = ga(), V = (r = (a = t == null ? void 0 : t.locale) !== null && a !== void 0 ? a : Q.locale) !== null && r !== void 0 ? r : $y;
  if (!V.match)
    throw new RangeError("locale must contain match property");
  var ie = Ft((i = (s = (l = (u = t == null ? void 0 : t.firstWeekContainsDate) !== null && u !== void 0 ? u : t == null || (c = t.locale) === null || c === void 0 || (p = c.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && l !== void 0 ? l : Q.firstWeekContainsDate) !== null && s !== void 0 ? s : (h = Q.locale) === null || h === void 0 || (O = h.options) === null || O === void 0 ? void 0 : O.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(ie >= 1 && ie <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var ce = Ft((C = (P = (k = ($ = t == null ? void 0 : t.weekStartsOn) !== null && $ !== void 0 ? $ : t == null || (I = t.locale) === null || I === void 0 || (H = I.options) === null || H === void 0 ? void 0 : H.weekStartsOn) !== null && k !== void 0 ? k : Q.weekStartsOn) !== null && P !== void 0 ? P : (x = Q.locale) === null || x === void 0 || (_ = x.options) === null || _ === void 0 ? void 0 : _.weekStartsOn) !== null && C !== void 0 ? C : 0);
  if (!(ce >= 0 && ce <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (G === "")
    return F === "" ? Xe(o) : /* @__PURE__ */ new Date(NaN);
  var me = {
    firstWeekContainsDate: ie,
    weekStartsOn: ce,
    locale: V
  }, ve = [new RD()], U = G.match(fT).map(function(_e) {
    var De = _e[0];
    if (De in Rd) {
      var fe = Rd[De];
      return fe(_e, V.formatLong);
    }
    return _e;
  }).join("").match(pT), ee = [], oe = Bg(U), ge;
  try {
    var be = function() {
      var De = ge.value;
      !(t != null && t.useAdditionalWeekYearTokens) && Ry(De) && sl(De, G, e), !(t != null && t.useAdditionalDayOfYearTokens) && ky(De) && sl(De, G, e);
      var fe = De[0], ke = dT[fe];
      if (ke) {
        var re = ke.incompatibleTokens;
        if (Array.isArray(re)) {
          var tt = ee.find(function(Dt) {
            return re.includes(Dt.token) || Dt.token === fe;
          });
          if (tt)
            throw new RangeError("The format string mustn't contain `".concat(tt.fullToken, "` and `").concat(De, "` at the same time"));
        } else if (ke.incompatibleTokens === "*" && ee.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(De, "` and any other token at the same time"));
        ee.push({
          token: fe,
          fullToken: De
        });
        var et = ke.run(F, De, V.match, me);
        if (!et)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        ve.push(et.setter), F = et.rest;
      } else {
        if (fe.match(mT))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + fe + "`");
        if (De === "''" ? De = "'" : fe === "'" && (De = yT(De)), F.indexOf(De) === 0)
          F = F.slice(De.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (oe.s(); !(ge = oe.n()).done; ) {
      var he = be();
      if (Ln(he) === "object")
        return he.v;
    }
  } catch (_e) {
    oe.e(_e);
  } finally {
    oe.f();
  }
  if (F.length > 0 && hT.test(F))
    return /* @__PURE__ */ new Date(NaN);
  var K = ve.map(function(_e) {
    return _e.priority;
  }).sort(function(_e, De) {
    return De - _e;
  }).filter(function(_e, De, fe) {
    return fe.indexOf(_e) === De;
  }).map(function(_e) {
    return ve.filter(function(De) {
      return De.priority === _e;
    }).sort(function(De, fe) {
      return fe.subPriority - De.subPriority;
    });
  }).map(function(_e) {
    return _e[0];
  }), le = Xe(o);
  if (isNaN(le.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var Pe = Cy(le, rl(le)), lt = {}, Ge = Bg(K), ut;
  try {
    for (Ge.s(); !(ut = Ge.n()).done; ) {
      var ze = ut.value;
      if (!ze.validate(Pe, me))
        return /* @__PURE__ */ new Date(NaN);
      var Ze = ze.set(Pe, lt, me);
      Array.isArray(Ze) ? (Pe = Ze[0], hD(lt, Ze[1])) : Pe = Ze;
    }
  } catch (_e) {
    Ge.e(_e);
  } finally {
    Ge.f();
  }
  return Pe;
}
function yT(e) {
  return e.match(vT)[1].replace(gT, "'");
}
function bT(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Xe(n);
  return o.getFullYear() === t.getFullYear() && o.getMonth() === t.getMonth();
}
function wT(e, n) {
  We(2, arguments);
  var o = Ed(e), t = Ed(n);
  return o.getTime() === t.getTime();
}
function xT(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Xe(n);
  return o.getFullYear() === t.getFullYear();
}
function Ii(e, n) {
  We(2, arguments);
  var o = Xe(e).getTime(), t = Xe(n.start).getTime(), r = Xe(n.end).getTime();
  if (!(t <= r))
    throw new RangeError("Invalid interval");
  return o >= t && o <= r;
}
function ra(e, n) {
  We(2, arguments);
  var o = Ft(n);
  return Qa(e, -o);
}
function CT(e, n) {
  var o;
  We(1, arguments);
  var t = Ft((o = n == null ? void 0 : n.additionalDigits) !== null && o !== void 0 ? o : 2);
  if (t !== 2 && t !== 1 && t !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var r = ET(e), a;
  if (r.date) {
    var i = kT(r.date, t);
    a = RT(i.restDateString, i.year);
  }
  if (!a || isNaN(a.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var s = a.getTime(), l = 0, u;
  if (r.time && (l = $T(r.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (r.timezone) {
    if (u = DT(r.timezone), isNaN(u))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var c = new Date(s + l), p = /* @__PURE__ */ new Date(0);
    return p.setFullYear(c.getUTCFullYear(), c.getUTCMonth(), c.getUTCDate()), p.setHours(c.getUTCHours(), c.getUTCMinutes(), c.getUTCSeconds(), c.getUTCMilliseconds()), p;
  }
  return new Date(s + l + u);
}
var Ts = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, ST = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, OT = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, PT = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function ET(e) {
  var n = {}, o = e.split(Ts.dateTimeDelimiter), t;
  if (o.length > 2)
    return n;
  if (/:/.test(o[0]) ? t = o[0] : (n.date = o[0], t = o[1], Ts.timeZoneDelimiter.test(n.date) && (n.date = e.split(Ts.timeZoneDelimiter)[0], t = e.substr(n.date.length, e.length))), t) {
    var r = Ts.timezone.exec(t);
    r ? (n.time = t.replace(r[1], ""), n.timezone = r[1]) : n.time = t;
  }
  return n;
}
function kT(e, n) {
  var o = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + n) + "})|(\\d{2}|[+-]\\d{" + (2 + n) + "})$)"), t = e.match(o);
  if (!t)
    return {
      year: NaN,
      restDateString: ""
    };
  var r = t[1] ? parseInt(t[1]) : null, a = t[2] ? parseInt(t[2]) : null;
  return {
    year: a === null ? r : a * 100,
    restDateString: e.slice((t[1] || t[2]).length)
  };
}
function RT(e, n) {
  if (n === null)
    return /* @__PURE__ */ new Date(NaN);
  var o = e.match(ST);
  if (!o)
    return /* @__PURE__ */ new Date(NaN);
  var t = !!o[4], r = yi(o[1]), a = yi(o[2]) - 1, i = yi(o[3]), s = yi(o[4]), l = yi(o[5]) - 1;
  if (t)
    return MT(n, s, l) ? TT(n, s, l) : /* @__PURE__ */ new Date(NaN);
  var u = /* @__PURE__ */ new Date(0);
  return !_T(n, a, i) || !IT(n, r) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(n, a, Math.max(r, i)), u);
}
function yi(e) {
  return e ? parseInt(e) : 1;
}
function $T(e) {
  var n = e.match(OT);
  if (!n)
    return NaN;
  var o = Wu(n[1]), t = Wu(n[2]), r = Wu(n[3]);
  return AT(o, t, r) ? o * ev + t * Zf + r * 1e3 : NaN;
}
function Wu(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function DT(e) {
  if (e === "Z")
    return 0;
  var n = e.match(PT);
  if (!n)
    return 0;
  var o = n[1] === "+" ? -1 : 1, t = parseInt(n[2]), r = n[3] && parseInt(n[3]) || 0;
  return FT(t, r) ? o * (t * ev + r * Zf) : NaN;
}
function TT(e, n, o) {
  var t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(e, 0, 4);
  var r = t.getUTCDay() || 7, a = (n - 1) * 7 + o + 1 - r;
  return t.setUTCDate(t.getUTCDate() + a), t;
}
var jT = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function My(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function _T(e, n, o) {
  return n >= 0 && n <= 11 && o >= 1 && o <= (jT[n] || (My(e) ? 29 : 28));
}
function IT(e, n) {
  return n >= 1 && n <= (My(e) ? 366 : 365);
}
function MT(e, n, o) {
  return n >= 1 && n <= 53 && o >= 0 && o <= 6;
}
function AT(e, n, o) {
  return e === 24 ? n === 0 && o === 0 : o >= 0 && o < 60 && n >= 0 && n < 60 && e >= 0 && e < 25;
}
function FT(e, n) {
  return n >= 0 && n <= 59;
}
function wn(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Ft(n), r = o.getFullYear(), a = o.getDate(), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(r, t, 15), i.setHours(0, 0, 0, 0);
  var s = yD(i);
  return o.setMonth(t, Math.min(a, s)), o;
}
function LT(e, n) {
  if (We(2, arguments), Ln(n) !== "object" || n === null)
    throw new RangeError("values parameter must be an object");
  var o = Xe(e);
  return isNaN(o.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.year != null && o.setFullYear(n.year), n.month != null && (o = wn(o, n.month)), n.date != null && o.setDate(Ft(n.date)), n.hours != null && o.setHours(Ft(n.hours)), n.minutes != null && o.setMinutes(Ft(n.minutes)), n.seconds != null && o.setSeconds(Ft(n.seconds)), n.milliseconds != null && o.setMilliseconds(Ft(n.milliseconds)), o);
}
function Ri(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Ft(n);
  return o.setHours(t), o;
}
function $i(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Ft(n);
  return o.setMinutes(t), o;
}
function $a(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Ft(n), r = Math.floor(o.getMonth() / 3) + 1, a = t - r;
  return wn(o, o.getMonth() + a * 3);
}
function NT(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Ft(n);
  return o.setSeconds(t), o;
}
function cl(e, n) {
  We(2, arguments);
  var o = Xe(e), t = Ft(n);
  return isNaN(o.getTime()) ? /* @__PURE__ */ new Date(NaN) : (o.setFullYear(t), o);
}
function Ya(e, n) {
  We(2, arguments);
  var o = Ft(n);
  return Qn(e, -o);
}
function BT(e, n) {
  We(2, arguments);
  var o = Ft(n);
  return yy(e, -o);
}
function WT(e, n) {
  We(2, arguments);
  var o = Ft(n);
  return Jf(e, -o);
}
function bo(e, n) {
  We(2, arguments);
  var o = Ft(n);
  return za(e, -o);
}
const zT = ({
  now: e,
  trackingId: n
}) => {
  const o = `${e.getFullYear() - 1}`, t = `${e.getFullYear() - 2}`;
  return [
    {
      label: "Today",
      startDate: e,
      endDate: e,
      trackingId: `${n}-today`
    },
    {
      label: "Yesterday",
      startDate: ra(e, 1),
      endDate: ra(e, 1),
      trackingId: `${n}-yesterday`
    },
    {
      label: "Last 7 Days",
      startDate: ra(e, 7),
      endDate: ra(e, 1),
      trackingId: `${n}-last-7-days`
    },
    {
      label: "Last 30 Days",
      startDate: ra(e, 30),
      endDate: ra(e, 1),
      trackingId: `${n}-last-30-days`
    },
    {
      label: "This Year",
      startDate: ki(e),
      endDate: e,
      trackingId: `${n}-this-year`
    },
    {
      label: o,
      startDate: ki(bo(e, 1)),
      endDate: kd(bo(e, 1)),
      trackingId: `${n}-previous-year`
    },
    {
      label: t,
      startDate: ki(bo(e, 2)),
      endDate: kd(bo(e, 2)),
      trackingId: `${n}-penultimate-year`
    }
  ];
};
var Ay = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var n = {}.hasOwnProperty;
    function o() {
      for (var t = [], r = 0; r < arguments.length; r++) {
        var a = arguments[r];
        if (a) {
          var i = typeof a;
          if (i === "string" || i === "number")
            t.push(a);
          else if (Array.isArray(a)) {
            if (a.length) {
              var s = o.apply(null, a);
              s && t.push(s);
            }
          } else if (i === "object") {
            if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]")) {
              t.push(a.toString());
              continue;
            }
            for (var l in a)
              n.call(a, l) && a[l] && t.push(l);
          }
        }
      }
      return t.join(" ");
    }
    e.exports ? (o.default = o, e.exports = o) : window.classNames = o;
  })();
})(Ay);
var HT = Ay.exports;
const gn = /* @__PURE__ */ xl(HT);
function YT(e, n) {
  e.prototype = Object.create(n.prototype), e.prototype.constructor = e, Td(e, n);
}
function Td(e, n) {
  return Td = Object.setPrototypeOf || function(t, r) {
    return t.__proto__ = r, t;
  }, Td(e, n);
}
function GT(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
function zg(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function VT(e, n, o) {
  return e === n ? !0 : e.correspondingElement ? e.correspondingElement.classList.contains(o) : e.classList.contains(o);
}
function UT(e, n, o) {
  if (e === n)
    return !0;
  for (; e.parentNode || e.host; ) {
    if (e.parentNode && VT(e, n, o))
      return !0;
    e = e.parentNode || e.host;
  }
  return e;
}
function qT(e) {
  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
}
var KT = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var n = !1, o = Object.defineProperty({}, "passive", {
      get: function() {
        n = !0;
      }
    }), t = function() {
    };
    return window.addEventListener("testPassiveEventSupport", t, o), window.removeEventListener("testPassiveEventSupport", t, o), n;
  }
};
function QT(e) {
  return e === void 0 && (e = 0), function() {
    return ++e;
  };
}
var XT = QT(), jd, js = {}, zu = {}, JT = ["touchstart", "touchmove"], ZT = "ignore-react-onclickoutside";
function Hg(e, n) {
  var o = {}, t = JT.indexOf(n) !== -1;
  return t && jd && (o.passive = !e.props.preventDefault), o;
}
function Bl(e, n) {
  var o, t, r = e.displayName || e.name || "Component";
  return t = o = /* @__PURE__ */ function(a) {
    YT(i, a);
    function i(l) {
      var u;
      return u = a.call(this, l) || this, u.__outsideClickHandler = function(c) {
        if (typeof u.__clickOutsideHandlerProp == "function") {
          u.__clickOutsideHandlerProp(c);
          return;
        }
        var p = u.getInstance();
        if (typeof p.props.handleClickOutside == "function") {
          p.props.handleClickOutside(c);
          return;
        }
        if (typeof p.handleClickOutside == "function") {
          p.handleClickOutside(c);
          return;
        }
        throw new Error("WrappedComponent: " + r + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, u.__getComponentNode = function() {
        var c = u.getInstance();
        return n && typeof n.setClickOutsideRef == "function" ? n.setClickOutsideRef()(c) : typeof c.setClickOutsideRef == "function" ? c.setClickOutsideRef() : Lb(c);
      }, u.enableOnClickOutside = function() {
        if (!(typeof document > "u" || zu[u._uid])) {
          typeof jd > "u" && (jd = KT()), zu[u._uid] = !0;
          var c = u.props.eventTypes;
          c.forEach || (c = [c]), js[u._uid] = function(p) {
            if (u.componentNode !== null && (u.props.preventDefault && p.preventDefault(), u.props.stopPropagation && p.stopPropagation(), !(u.props.excludeScrollbar && qT(p)))) {
              var h = p.composed && p.composedPath && p.composedPath().shift() || p.target;
              UT(h, u.componentNode, u.props.outsideClickIgnoreClass) === document && u.__outsideClickHandler(p);
            }
          }, c.forEach(function(p) {
            document.addEventListener(p, js[u._uid], Hg(zg(u), p));
          });
        }
      }, u.disableOnClickOutside = function() {
        delete zu[u._uid];
        var c = js[u._uid];
        if (c && typeof document < "u") {
          var p = u.props.eventTypes;
          p.forEach || (p = [p]), p.forEach(function(h) {
            return document.removeEventListener(h, c, Hg(zg(u), h));
          }), delete js[u._uid];
        }
      }, u.getRef = function(c) {
        return u.instanceRef = c;
      }, u._uid = XT(), u;
    }
    var s = i.prototype;
    return s.getInstance = function() {
      if (e.prototype && !e.prototype.isReactComponent)
        return this;
      var u = this.instanceRef;
      return u.getInstance ? u.getInstance() : u;
    }, s.componentDidMount = function() {
      if (!(typeof document > "u" || !document.createElement)) {
        var u = this.getInstance();
        if (n && typeof n.handleClickOutside == "function" && (this.__clickOutsideHandlerProp = n.handleClickOutside(u), typeof this.__clickOutsideHandlerProp != "function"))
          throw new Error("WrappedComponent: " + r + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside();
      }
    }, s.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, s.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, s.render = function() {
      var u = this.props;
      u.excludeScrollbar;
      var c = GT(u, ["excludeScrollbar"]);
      return e.prototype && e.prototype.isReactComponent ? c.ref = this.getRef : c.wrappedRef = this.getRef, c.disableOnClickOutside = this.disableOnClickOutside, c.enableOnClickOutside = this.enableOnClickOutside, Xd(e, c);
    }, i;
  }(_b), o.displayName = "OnClickOutside(" + r + ")", o.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: n && n.excludeScrollbar || !1,
    outsideClickIgnoreClass: ZT,
    preventDefault: !1,
    stopPropagation: !1
  }, o.getClass = function() {
    return e.getClass ? e.getClass() : e;
  }, t;
}
var Fy = Ht.createContext(), Ly = Ht.createContext();
function ej(e) {
  var n = e.children, o = Ht.useState(null), t = o[0], r = o[1], a = Ht.useRef(!1);
  Ht.useEffect(function() {
    return function() {
      a.current = !0;
    };
  }, []);
  var i = Ht.useCallback(function(s) {
    a.current || r(s);
  }, []);
  return /* @__PURE__ */ Ht.createElement(Fy.Provider, {
    value: t
  }, /* @__PURE__ */ Ht.createElement(Ly.Provider, {
    value: i
  }, n));
}
var Ny = function(n) {
  return Array.isArray(n) ? n[0] : n;
}, By = function(n) {
  if (typeof n == "function") {
    for (var o = arguments.length, t = new Array(o > 1 ? o - 1 : 0), r = 1; r < o; r++)
      t[r - 1] = arguments[r];
    return n.apply(void 0, t);
  }
}, _d = function(n, o) {
  if (typeof n == "function")
    return By(n, o);
  n != null && (n.current = o);
}, Yg = function(n) {
  return n.reduce(function(o, t) {
    var r = t[0], a = t[1];
    return o[r] = a, o;
  }, {});
}, Gg = typeof window < "u" && window.document && window.document.createElement ? Ht.useLayoutEffect : Ht.useEffect, tj = typeof Element < "u", rj = typeof Map == "function", nj = typeof Set == "function", oj = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Ns(e, n) {
  if (e === n)
    return !0;
  if (e && n && typeof e == "object" && typeof n == "object") {
    if (e.constructor !== n.constructor)
      return !1;
    var o, t, r;
    if (Array.isArray(e)) {
      if (o = e.length, o != n.length)
        return !1;
      for (t = o; t-- !== 0; )
        if (!Ns(e[t], n[t]))
          return !1;
      return !0;
    }
    var a;
    if (rj && e instanceof Map && n instanceof Map) {
      if (e.size !== n.size)
        return !1;
      for (a = e.entries(); !(t = a.next()).done; )
        if (!n.has(t.value[0]))
          return !1;
      for (a = e.entries(); !(t = a.next()).done; )
        if (!Ns(t.value[1], n.get(t.value[0])))
          return !1;
      return !0;
    }
    if (nj && e instanceof Set && n instanceof Set) {
      if (e.size !== n.size)
        return !1;
      for (a = e.entries(); !(t = a.next()).done; )
        if (!n.has(t.value[0]))
          return !1;
      return !0;
    }
    if (oj && ArrayBuffer.isView(e) && ArrayBuffer.isView(n)) {
      if (o = e.length, o != n.length)
        return !1;
      for (t = o; t-- !== 0; )
        if (e[t] !== n[t])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === n.source && e.flags === n.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof n.valueOf == "function")
      return e.valueOf() === n.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof n.toString == "function")
      return e.toString() === n.toString();
    if (r = Object.keys(e), o = r.length, o !== Object.keys(n).length)
      return !1;
    for (t = o; t-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, r[t]))
        return !1;
    if (tj && e instanceof Element)
      return !1;
    for (t = o; t-- !== 0; )
      if (!((r[t] === "_owner" || r[t] === "__v" || r[t] === "__o") && e.$$typeof) && !Ns(e[r[t]], n[r[t]]))
        return !1;
    return !0;
  }
  return e !== e && n !== n;
}
var aj = function(n, o) {
  try {
    return Ns(n, o);
  } catch (t) {
    if ((t.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw t;
  }
};
const ij = /* @__PURE__ */ xl(aj);
var sj = [], lj = function(n, o, t) {
  t === void 0 && (t = {});
  var r = Ht.useRef(null), a = {
    onFirstUpdate: t.onFirstUpdate,
    placement: t.placement || "bottom",
    strategy: t.strategy || "absolute",
    modifiers: t.modifiers || sj
  }, i = Ht.useState({
    styles: {
      popper: {
        position: a.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), s = i[0], l = i[1], u = Ht.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(O) {
        var C = O.state, P = Object.keys(C.elements);
        Mb.flushSync(function() {
          l({
            styles: Yg(P.map(function(k) {
              return [k, C.styles[k] || {}];
            })),
            attributes: Yg(P.map(function(k) {
              return [k, C.attributes[k]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), c = Ht.useMemo(function() {
    var h = {
      onFirstUpdate: a.onFirstUpdate,
      placement: a.placement,
      strategy: a.strategy,
      modifiers: [].concat(a.modifiers, [u, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return ij(r.current, h) ? r.current || h : (r.current = h, h);
  }, [a.onFirstUpdate, a.placement, a.strategy, a.modifiers, u]), p = Ht.useRef();
  return Gg(function() {
    p.current && p.current.setOptions(c);
  }, [c]), Gg(function() {
    if (!(n == null || o == null)) {
      var h = t.createPopper || dm, O = h(n, o, c);
      return p.current = O, function() {
        O.destroy(), p.current = null;
      };
    }
  }, [n, o, t.createPopper]), {
    state: p.current ? p.current.state : null,
    styles: s.styles,
    attributes: s.attributes,
    update: p.current ? p.current.update : null,
    forceUpdate: p.current ? p.current.forceUpdate : null
  };
}, uj = function() {
}, cj = function() {
  return Promise.resolve(null);
}, dj = [];
function pj(e) {
  var n = e.placement, o = n === void 0 ? "bottom" : n, t = e.strategy, r = t === void 0 ? "absolute" : t, a = e.modifiers, i = a === void 0 ? dj : a, s = e.referenceElement, l = e.onFirstUpdate, u = e.innerRef, c = e.children, p = Ht.useContext(Fy), h = Ht.useState(null), O = h[0], C = h[1], P = Ht.useState(null), k = P[0], $ = P[1];
  Ht.useEffect(function() {
    _d(u, O);
  }, [u, O]);
  var I = Ht.useMemo(function() {
    return {
      placement: o,
      strategy: r,
      onFirstUpdate: l,
      modifiers: [].concat(i, [{
        name: "arrow",
        enabled: k != null,
        options: {
          element: k
        }
      }])
    };
  }, [o, r, l, i, k]), H = lj(s || p, O, I), x = H.state, _ = H.styles, F = H.forceUpdate, G = H.update, Q = Ht.useMemo(function() {
    return {
      ref: C,
      style: _.popper,
      placement: x ? x.placement : o,
      hasPopperEscaped: x && x.modifiersData.hide ? x.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: x && x.modifiersData.hide ? x.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: _.arrow,
        ref: $
      },
      forceUpdate: F || uj,
      update: G || cj
    };
  }, [C, $, o, x, _, G, F]);
  return Ny(c)(Q);
}
var fj = process.env.NODE_ENV !== "production", Wy = function() {
};
if (fj) {
  var vj = function(n, o) {
    var t = arguments.length;
    o = new Array(t > 1 ? t - 1 : 0);
    for (var r = 1; r < t; r++)
      o[r - 1] = arguments[r];
    var a = 0, i = "Warning: " + n.replace(/%s/g, function() {
      return o[a++];
    });
    typeof console < "u" && console.error(i);
    try {
      throw new Error(i);
    } catch {
    }
  };
  Wy = function(e, n, o) {
    var t = arguments.length;
    o = new Array(t > 2 ? t - 2 : 0);
    for (var r = 2; r < t; r++)
      o[r - 2] = arguments[r];
    if (n === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || vj.apply(null, [n].concat(o));
  };
}
var gj = Wy;
const hj = /* @__PURE__ */ xl(gj);
function mj(e) {
  var n = e.children, o = e.innerRef, t = Ht.useContext(Ly), r = Ht.useCallback(function(a) {
    _d(o, a), By(t, a);
  }, [o, t]);
  return Ht.useEffect(function() {
    return function() {
      return _d(o, null);
    };
  }, []), Ht.useEffect(function() {
    hj(!!t, "`Reference` should not be used outside of a `Manager` component.");
  }, [t]), Ny(n)({
    ref: r
  });
}
function Vg(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), o.push.apply(o, t);
  }
  return o;
}
function Ug(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Vg(Object(o), !0).forEach(function(t) {
      A(e, t, o[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : Vg(Object(o)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
    });
  }
  return e;
}
function zy(e) {
  return (zy = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  })(e);
}
function Gr(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function qg(e, n) {
  for (var o = 0; o < n.length; o++) {
    var t = n[o];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, Yy(t.key), t);
  }
}
function Vr(e, n, o) {
  return n && qg(e.prototype, n), o && qg(e, o), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function A(e, n, o) {
  return (n = Yy(n)) in e ? Object.defineProperty(e, n, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = o, e;
}
function Wl() {
  return (Wl = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (e[t] = o[t]);
    }
    return e;
  }).apply(this, arguments);
}
function Ur(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), n && Hy(e, n);
}
function Id(e) {
  return (Id = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  })(e);
}
function Hy(e, n) {
  return (Hy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, t) {
    return o.__proto__ = t, o;
  })(e, n);
}
function z(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function yj(e, n) {
  if (n && (typeof n == "object" || typeof n == "function"))
    return n;
  if (n !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return z(e);
}
function qr(e) {
  var n = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }();
  return function() {
    var o, t = Id(e);
    if (n) {
      var r = Id(this).constructor;
      o = Reflect.construct(t, arguments, r);
    } else
      o = t.apply(this, arguments);
    return yj(this, o);
  };
}
function Md(e) {
  return function(n) {
    if (Array.isArray(n))
      return Hu(n);
  }(e) || function(n) {
    if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null)
      return Array.from(n);
  }(e) || function(n, o) {
    if (n) {
      if (typeof n == "string")
        return Hu(n, o);
      var t = Object.prototype.toString.call(n).slice(8, -1);
      if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
        return Array.from(n);
      if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
        return Hu(n, o);
    }
  }(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Hu(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var o = 0, t = new Array(n); o < n; o++)
    t[o] = e[o];
  return t;
}
function Yy(e) {
  var n = function(o, t) {
    if (typeof o != "object" || o === null)
      return o;
    var r = o[Symbol.toPrimitive];
    if (r !== void 0) {
      var a = r.call(o, t || "default");
      if (typeof a != "object")
        return a;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(o);
  }(e, "string");
  return typeof n == "symbol" ? n : String(n);
}
function Kg(e, n) {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}
function Qg(e, n) {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}
var bj = { p: Qg, P: function(e, n) {
  var o, t = e.match(/(P+)(p+)?/) || [], r = t[1], a = t[2];
  if (!a)
    return Kg(e, n);
  switch (r) {
    case "P":
      o = n.dateTime({ width: "short" });
      break;
    case "PP":
      o = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = n.dateTime({ width: "full" });
  }
  return o.replace("{{date}}", Kg(r, n)).replace("{{time}}", Qg(a, n));
} }, wj = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function Sr(e) {
  var n = e ? typeof e == "string" || e instanceof String ? CT(e) : Xe(e) : /* @__PURE__ */ new Date();
  return Io(n) ? n : null;
}
function xj(e, n, o, t, r) {
  var a = null, i = Bo(o) || Bo(sa()), s = !0;
  return Array.isArray(n) ? (n.forEach(function(l) {
    var u = Bu(e, l, /* @__PURE__ */ new Date(), { locale: i });
    t && (s = Io(u, r) && e === Tr(u, l, o)), Io(u, r) && s && (a = u);
  }), a) : (a = Bu(e, n, /* @__PURE__ */ new Date(), { locale: i }), t ? s = Io(a) && e === Tr(a, n, o) : Io(a) || (n = n.match(wj).map(function(l) {
    var u = l[0];
    return u === "p" || u === "P" ? i ? (0, bj[u])(l, i.formatLong) : u : l;
  }).join(""), e.length > 0 && (a = Bu(e, n.slice(0, e.length), /* @__PURE__ */ new Date())), Io(a) || (a = new Date(e))), Io(a) && s ? a : null);
}
function Io(e, n) {
  return n = n || /* @__PURE__ */ new Date("1/1/1000"), wy(e) && !yo(e, n);
}
function Tr(e, n, o) {
  if (o === "en")
    return Fg(e, n, { awareOfUnicodeTokens: !0 });
  var t = Bo(o);
  return o && !t && console.warn('A locale object was not found for the provided string ["'.concat(o, '"].')), !t && sa() && Bo(sa()) && (t = Bo(sa())), Fg(e, n, { locale: t || null, awareOfUnicodeTokens: !0 });
}
function eo(e, n) {
  var o = n.dateFormat, t = n.locale;
  return e && Tr(e, Array.isArray(o) ? o[0] : o, t) || "";
}
function Xg(e, n) {
  var o = n.hour, t = o === void 0 ? 0 : o, r = n.minute, a = r === void 0 ? 0 : r, i = n.second;
  return Ri($i(NT(e, i === void 0 ? 0 : i), a), t);
}
function Cj(e, n) {
  var o = n && Bo(n) || sa() && Bo(sa());
  return wD(e, o ? { locale: o } : null);
}
function Sj(e, n) {
  return Tr(e, "ddd", n);
}
function Oj(e) {
  return Un(e);
}
function av(e, n, o) {
  var t = Bo(n || sa());
  return my(e, { locale: t, weekStartsOn: o });
}
function No(e) {
  return xy(e);
}
function wi(e) {
  return ki(e);
}
function Jg(e) {
  return Ed(e);
}
function Zg() {
  return Un(Sr());
}
function dl(e, n) {
  return e && n ? xT(e, n) : !e && !n;
}
function Mo(e, n) {
  return e && n ? bT(e, n) : !e && !n;
}
function pl(e, n) {
  return e && n ? wT(e, n) : !e && !n;
}
function ln(e, n) {
  return e && n ? by(e, n) : !e && !n;
}
function Ao(e, n) {
  return e && n ? xD(e, n) : !e && !n;
}
function Bs(e, n, o) {
  var t, r = Un(n), a = il(o);
  try {
    t = Ii(e, { start: r, end: a });
  } catch {
    t = !1;
  }
  return t;
}
function sa() {
  return (typeof window < "u" ? window : globalThis).__localeId__;
}
function Bo(e) {
  if (typeof e == "string") {
    var n = typeof window < "u" ? window : globalThis;
    return n.__localeData__ ? n.__localeData__[e] : null;
  }
  return e;
}
function iv(e, n) {
  return Tr(wn(Sr(), e), "LLLL", n);
}
function Gy(e, n) {
  return Tr(wn(Sr(), e), "LLL", n);
}
function Pj(e, n) {
  return Tr($a(Sr(), e), "QQQ", n);
}
function zl(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.minDate, t = n.maxDate, r = n.excludeDates, a = n.excludeDateIntervals, i = n.includeDates, s = n.includeDateIntervals, l = n.filterDate;
  return Hl(e, { minDate: o, maxDate: t }) || r && r.some(function(u) {
    return ln(e, u);
  }) || a && a.some(function(u) {
    var c = u.start, p = u.end;
    return Ii(e, { start: c, end: p });
  }) || i && !i.some(function(u) {
    return ln(e, u);
  }) || s && !s.some(function(u) {
    var c = u.start, p = u.end;
    return Ii(e, { start: c, end: p });
  }) || l && !l(Sr(e)) || !1;
}
function sv(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.excludeDates, t = n.excludeDateIntervals;
  return t && t.length > 0 ? t.some(function(r) {
    var a = r.start, i = r.end;
    return Ii(e, { start: a, end: i });
  }) : o && o.some(function(r) {
    return ln(e, r);
  }) || !1;
}
function Vy(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.minDate, t = n.maxDate, r = n.excludeDates, a = n.includeDates, i = n.filterDate;
  return Hl(e, { minDate: xy(o), maxDate: p$(t) }) || r && r.some(function(s) {
    return Mo(e, s);
  }) || a && !a.some(function(s) {
    return Mo(e, s);
  }) || i && !i(Sr(e)) || !1;
}
function Yu(e, n, o, t) {
  var r = Wt(e), a = en(e), i = Wt(n), s = en(n), l = Wt(t);
  return r === i && r === l ? a <= o && o <= s : r < i ? l === r && a <= o || l === i && s >= o || l < i && l > r : void 0;
}
function Ej(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.minDate, t = n.maxDate, r = n.excludeDates, a = n.includeDates, i = n.filterDate;
  return Hl(e, { minDate: o, maxDate: t }) || r && r.some(function(s) {
    return pl(e, s);
  }) || a && !a.some(function(s) {
    return pl(e, s);
  }) || i && !i(Sr(e)) || !1;
}
function Uy(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.minDate, t = n.maxDate, r = n.excludeDates, a = n.includeDates, i = n.filterDate, s = new Date(e, 0, 1);
  return Hl(s, { minDate: ki(o), maxDate: kd(t) }) || r && r.some(function(l) {
    return dl(s, l);
  }) || a && !a.some(function(l) {
    return dl(s, l);
  }) || i && !i(Sr(s)) || !1;
}
function Gu(e, n, o, t) {
  var r = Wt(e), a = Da(e), i = Wt(n), s = Da(n), l = Wt(t);
  return r === i && r === l ? a <= o && o <= s : r < i ? l === r && a <= o || l === i && s >= o || l < i && l > r : void 0;
}
function Hl(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.minDate, t = n.maxDate;
  return o && nl(e, o) < 0 || t && nl(e, t) > 0;
}
function eh(e, n) {
  return n.some(function(o) {
    return Sn(o) === Sn(e) && On(o) === On(e);
  });
}
function th(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.excludeTimes, t = n.includeTimes, r = n.filterTime;
  return o && eh(e, o) || t && !eh(e, t) || r && !r(e) || !1;
}
function rh(e, n) {
  var o = n.minTime, t = n.maxTime;
  if (!o || !t)
    throw new Error("Both minTime and maxTime props required");
  var r, a = Sr(), i = Ri($i(a, On(e)), Sn(e)), s = Ri($i(a, On(o)), Sn(o)), l = Ri($i(a, On(t)), Sn(t));
  try {
    r = !Ii(i, { start: s, end: l });
  } catch {
    r = !1;
  }
  return r;
}
function nh(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.minDate, t = n.includeDates, r = Ya(e, 1);
  return o && ol(o, r) > 0 || t && t.every(function(a) {
    return ol(a, r) > 0;
  }) || !1;
}
function oh(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.maxDate, t = n.includeDates, r = Qn(e, 1);
  return o && ol(r, o) > 0 || t && t.every(function(a) {
    return ol(r, a) > 0;
  }) || !1;
}
function ah(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.minDate, t = n.includeDates, r = bo(e, 1);
  return o && al(o, r) > 0 || t && t.every(function(a) {
    return al(a, r) > 0;
  }) || !1;
}
function ih(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.maxDate, t = n.includeDates, r = za(e, 1);
  return o && al(r, o) > 0 || t && t.every(function(a) {
    return al(r, a) > 0;
  }) || !1;
}
function qy(e) {
  var n = e.minDate, o = e.includeDates;
  if (o && n) {
    var t = o.filter(function(r) {
      return nl(r, n) >= 0;
    });
    return _g(t);
  }
  return o ? _g(o) : n;
}
function Ky(e) {
  var n = e.maxDate, o = e.includeDates;
  if (o && n) {
    var t = o.filter(function(r) {
      return nl(r, n) <= 0;
    });
    return jg(t);
  }
  return o ? jg(o) : n;
}
function sh() {
  for (var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", o = /* @__PURE__ */ new Map(), t = 0, r = e.length; t < r; t++) {
    var a = e[t];
    if (tv(a)) {
      var i = Tr(a, "MM.dd.yyyy"), s = o.get(i) || [];
      s.includes(n) || (s.push(n), o.set(i, s));
    } else if (zy(a) === "object") {
      var l = Object.keys(a), u = l[0], c = a[l[0]];
      if (typeof u == "string" && c.constructor === Array)
        for (var p = 0, h = c.length; p < h; p++) {
          var O = Tr(c[p], "MM.dd.yyyy"), C = o.get(O) || [];
          C.includes(u) || (C.push(u), o.set(O, C));
        }
    }
  }
  return o;
}
function kj(e, n, o, t, r) {
  for (var a = r.length, i = [], s = 0; s < a; s++) {
    var l = Pd(a$(e, Sn(r[s])), On(r[s])), u = Pd(e, (o + 1) * t);
    zo(l, n) && yo(l, u) && i.push(r[s]);
  }
  return i;
}
function lh(e) {
  return e < 10 ? "0".concat(e) : "".concat(e);
}
function Ta(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12, o = Math.ceil(Wt(e) / n) * n, t = o - (n - 1);
  return { startPeriod: t, endPeriod: o };
}
function Rj(e, n, o, t) {
  for (var r = [], a = 0; a < 2 * n + 1; a++) {
    var i = e + n - a, s = !0;
    o && (s = Wt(o) <= i), t && s && (s = Wt(t) >= i), s && r.push(i);
  }
  return r;
}
var $j = Bl(function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o(t) {
    var r;
    Gr(this, o), A(z(r = n.call(this, t)), "renderOptions", function() {
      var l = r.props.year, u = r.state.yearsList.map(function(h) {
        return y.createElement("div", { className: l === h ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: h, onClick: r.onChange.bind(z(r), h), "aria-selected": l === h ? "true" : void 0 }, l === h ? y.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", h);
      }), c = r.props.minDate ? Wt(r.props.minDate) : null, p = r.props.maxDate ? Wt(r.props.maxDate) : null;
      return p && r.state.yearsList.find(function(h) {
        return h === p;
      }) || u.unshift(y.createElement("div", { className: "react-datepicker__year-option", key: "upcoming", onClick: r.incrementYears }, y.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" }))), c && r.state.yearsList.find(function(h) {
        return h === c;
      }) || u.push(y.createElement("div", { className: "react-datepicker__year-option", key: "previous", onClick: r.decrementYears }, y.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" }))), u;
    }), A(z(r), "onChange", function(l) {
      r.props.onChange(l);
    }), A(z(r), "handleClickOutside", function() {
      r.props.onCancel();
    }), A(z(r), "shiftYears", function(l) {
      var u = r.state.yearsList.map(function(c) {
        return c + l;
      });
      r.setState({ yearsList: u });
    }), A(z(r), "incrementYears", function() {
      return r.shiftYears(1);
    }), A(z(r), "decrementYears", function() {
      return r.shiftYears(-1);
    });
    var a = t.yearDropdownItemNumber, i = t.scrollableYearDropdown, s = a || (i ? 10 : 5);
    return r.state = { yearsList: Rj(r.props.year, s, r.props.minDate, r.props.maxDate) }, r.dropdownRef = io(), r;
  }
  return Vr(o, [{ key: "componentDidMount", value: function() {
    var t = this.dropdownRef.current;
    if (t) {
      var r = t.children ? Array.from(t.children) : null, a = r ? r.find(function(i) {
        return i.ariaSelected;
      }) : null;
      t.scrollTop = a ? a.offsetTop + (a.clientHeight - t.clientHeight) / 2 : (t.scrollHeight - t.clientHeight) / 2;
    }
  } }, { key: "render", value: function() {
    var t = gn({ "react-datepicker__year-dropdown": !0, "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown });
    return y.createElement("div", { className: t, ref: this.dropdownRef }, this.renderOptions());
  } }]), o;
}()), Dj = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o() {
    var t;
    Gr(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return A(z(t = n.call.apply(n, [this].concat(a))), "state", { dropdownVisible: !1 }), A(z(t), "renderSelectOptions", function() {
      for (var s = t.props.minDate ? Wt(t.props.minDate) : 1900, l = t.props.maxDate ? Wt(t.props.maxDate) : 2100, u = [], c = s; c <= l; c++)
        u.push(y.createElement("option", { key: c, value: c }, c));
      return u;
    }), A(z(t), "onSelectChange", function(s) {
      t.onChange(s.target.value);
    }), A(z(t), "renderSelectMode", function() {
      return y.createElement("select", { value: t.props.year, className: "react-datepicker__year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
    }), A(z(t), "renderReadView", function(s) {
      return y.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(l) {
        return t.toggleDropdown(l);
      } }, y.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), y.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, t.props.year));
    }), A(z(t), "renderDropdown", function() {
      return y.createElement($j, { key: "dropdown", year: t.props.year, onChange: t.onChange, onCancel: t.toggleDropdown, minDate: t.props.minDate, maxDate: t.props.maxDate, scrollableYearDropdown: t.props.scrollableYearDropdown, yearDropdownItemNumber: t.props.yearDropdownItemNumber });
    }), A(z(t), "renderScrollMode", function() {
      var s = t.state.dropdownVisible, l = [t.renderReadView(!s)];
      return s && l.unshift(t.renderDropdown()), l;
    }), A(z(t), "onChange", function(s) {
      t.toggleDropdown(), s !== t.props.year && t.props.onChange(s);
    }), A(z(t), "toggleDropdown", function(s) {
      t.setState({ dropdownVisible: !t.state.dropdownVisible }, function() {
        t.props.adjustDateOnChange && t.handleYearChange(t.props.date, s);
      });
    }), A(z(t), "handleYearChange", function(s, l) {
      t.onSelect(s, l), t.setOpen();
    }), A(z(t), "onSelect", function(s, l) {
      t.props.onSelect && t.props.onSelect(s, l);
    }), A(z(t), "setOpen", function() {
      t.props.setOpen && t.props.setOpen(!0);
    }), t;
  }
  return Vr(o, [{ key: "render", value: function() {
    var t;
    switch (this.props.dropdownMode) {
      case "scroll":
        t = this.renderScrollMode();
        break;
      case "select":
        t = this.renderSelectMode();
    }
    return y.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, t);
  } }]), o;
}(), Tj = Bl(function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o() {
    var t;
    Gr(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return A(z(t = n.call.apply(n, [this].concat(a))), "isSelectedMonth", function(s) {
      return t.props.month === s;
    }), A(z(t), "renderOptions", function() {
      return t.props.monthNames.map(function(s, l) {
        return y.createElement("div", { className: t.isSelectedMonth(l) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: s, onClick: t.onChange.bind(z(t), l), "aria-selected": t.isSelectedMonth(l) ? "true" : void 0 }, t.isSelectedMonth(l) ? y.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", s);
      });
    }), A(z(t), "onChange", function(s) {
      return t.props.onChange(s);
    }), A(z(t), "handleClickOutside", function() {
      return t.props.onCancel();
    }), t;
  }
  return Vr(o, [{ key: "render", value: function() {
    return y.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
  } }]), o;
}()), jj = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o() {
    var t;
    Gr(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return A(z(t = n.call.apply(n, [this].concat(a))), "state", { dropdownVisible: !1 }), A(z(t), "renderSelectOptions", function(s) {
      return s.map(function(l, u) {
        return y.createElement("option", { key: u, value: u }, l);
      });
    }), A(z(t), "renderSelectMode", function(s) {
      return y.createElement("select", { value: t.props.month, className: "react-datepicker__month-select", onChange: function(l) {
        return t.onChange(l.target.value);
      } }, t.renderSelectOptions(s));
    }), A(z(t), "renderReadView", function(s, l) {
      return y.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: t.toggleDropdown }, y.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), y.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, l[t.props.month]));
    }), A(z(t), "renderDropdown", function(s) {
      return y.createElement(Tj, { key: "dropdown", month: t.props.month, monthNames: s, onChange: t.onChange, onCancel: t.toggleDropdown });
    }), A(z(t), "renderScrollMode", function(s) {
      var l = t.state.dropdownVisible, u = [t.renderReadView(!l, s)];
      return l && u.unshift(t.renderDropdown(s)), u;
    }), A(z(t), "onChange", function(s) {
      t.toggleDropdown(), s !== t.props.month && t.props.onChange(s);
    }), A(z(t), "toggleDropdown", function() {
      return t.setState({ dropdownVisible: !t.state.dropdownVisible });
    }), t;
  }
  return Vr(o, [{ key: "render", value: function() {
    var t, r = this, a = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(i) {
      return Gy(i, r.props.locale);
    } : function(i) {
      return iv(i, r.props.locale);
    });
    switch (this.props.dropdownMode) {
      case "scroll":
        t = this.renderScrollMode(a);
        break;
      case "select":
        t = this.renderSelectMode(a);
    }
    return y.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, t);
  } }]), o;
}();
function _j(e, n) {
  for (var o = [], t = No(e), r = No(n); !zo(t, r); )
    o.push(Sr(t)), t = Qn(t, 1);
  return o;
}
var _s, Ij = Bl(function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o(t) {
    var r;
    return Gr(this, o), A(z(r = n.call(this, t)), "renderOptions", function() {
      return r.state.monthYearsList.map(function(a) {
        var i = $d(a), s = dl(r.props.date, a) && Mo(r.props.date, a);
        return y.createElement("div", { className: s ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: i, onClick: r.onChange.bind(z(r), i), "aria-selected": s ? "true" : void 0 }, s ? y.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", Tr(a, r.props.dateFormat, r.props.locale));
      });
    }), A(z(r), "onChange", function(a) {
      return r.props.onChange(a);
    }), A(z(r), "handleClickOutside", function() {
      r.props.onCancel();
    }), r.state = { monthYearsList: _j(r.props.minDate, r.props.maxDate) }, r;
  }
  return Vr(o, [{ key: "render", value: function() {
    var t = gn({ "react-datepicker__month-year-dropdown": !0, "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown });
    return y.createElement("div", { className: t }, this.renderOptions());
  } }]), o;
}()), Mj = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o() {
    var t;
    Gr(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return A(z(t = n.call.apply(n, [this].concat(a))), "state", { dropdownVisible: !1 }), A(z(t), "renderSelectOptions", function() {
      for (var s = No(t.props.minDate), l = No(t.props.maxDate), u = []; !zo(s, l); ) {
        var c = $d(s);
        u.push(y.createElement("option", { key: c, value: c }, Tr(s, t.props.dateFormat, t.props.locale))), s = Qn(s, 1);
      }
      return u;
    }), A(z(t), "onSelectChange", function(s) {
      t.onChange(s.target.value);
    }), A(z(t), "renderSelectMode", function() {
      return y.createElement("select", { value: $d(No(t.props.date)), className: "react-datepicker__month-year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
    }), A(z(t), "renderReadView", function(s) {
      var l = Tr(t.props.date, t.props.dateFormat, t.props.locale);
      return y.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: function(u) {
        return t.toggleDropdown(u);
      } }, y.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), y.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, l));
    }), A(z(t), "renderDropdown", function() {
      return y.createElement(Ij, { key: "dropdown", date: t.props.date, dateFormat: t.props.dateFormat, onChange: t.onChange, onCancel: t.toggleDropdown, minDate: t.props.minDate, maxDate: t.props.maxDate, scrollableMonthYearDropdown: t.props.scrollableMonthYearDropdown, locale: t.props.locale });
    }), A(z(t), "renderScrollMode", function() {
      var s = t.state.dropdownVisible, l = [t.renderReadView(!s)];
      return s && l.unshift(t.renderDropdown()), l;
    }), A(z(t), "onChange", function(s) {
      t.toggleDropdown();
      var l = Sr(parseInt(s));
      dl(t.props.date, l) && Mo(t.props.date, l) || t.props.onChange(l);
    }), A(z(t), "toggleDropdown", function() {
      return t.setState({ dropdownVisible: !t.state.dropdownVisible });
    }), t;
  }
  return Vr(o, [{ key: "render", value: function() {
    var t;
    switch (this.props.dropdownMode) {
      case "scroll":
        t = this.renderScrollMode();
        break;
      case "select":
        t = this.renderSelectMode();
    }
    return y.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, t);
  } }]), o;
}(), Aj = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o() {
    var t;
    Gr(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return A(z(t = n.call.apply(n, [this].concat(a))), "dayEl", y.createRef()), A(z(t), "handleClick", function(s) {
      !t.isDisabled() && t.props.onClick && t.props.onClick(s);
    }), A(z(t), "handleMouseEnter", function(s) {
      !t.isDisabled() && t.props.onMouseEnter && t.props.onMouseEnter(s);
    }), A(z(t), "handleOnKeyDown", function(s) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), t.props.handleOnKeyDown(s);
    }), A(z(t), "isSameDay", function(s) {
      return ln(t.props.day, s);
    }), A(z(t), "isKeyboardSelected", function() {
      return !t.props.disabledKeyboardNavigation && !t.isSameDay(t.props.selected) && t.isSameDay(t.props.preSelection);
    }), A(z(t), "isDisabled", function() {
      return zl(t.props.day, t.props);
    }), A(z(t), "isExcluded", function() {
      return sv(t.props.day, t.props);
    }), A(z(t), "getHighLightedClass", function(s) {
      var l = t.props, u = l.day, c = l.highlightDates;
      if (!c)
        return !1;
      var p = Tr(u, "MM.dd.yyyy");
      return c.get(p);
    }), A(z(t), "isInRange", function() {
      var s = t.props, l = s.day, u = s.startDate, c = s.endDate;
      return !(!u || !c) && Bs(l, u, c);
    }), A(z(t), "isInSelectingRange", function() {
      var s, l = t.props, u = l.day, c = l.selectsStart, p = l.selectsEnd, h = l.selectsRange, O = l.selectsDisabledDaysInRange, C = l.startDate, P = l.endDate, k = (s = t.props.selectingDate) !== null && s !== void 0 ? s : t.props.preSelection;
      return !(!(c || p || h) || !k || !O && t.isDisabled()) && (c && P && (yo(k, P) || Ao(k, P)) ? Bs(u, k, P) : (p && C && (zo(k, C) || Ao(k, C)) || !(!h || !C || P || !zo(k, C) && !Ao(k, C))) && Bs(u, C, k));
    }), A(z(t), "isSelectingRangeStart", function() {
      var s;
      if (!t.isInSelectingRange())
        return !1;
      var l = t.props, u = l.day, c = l.startDate, p = l.selectsStart, h = (s = t.props.selectingDate) !== null && s !== void 0 ? s : t.props.preSelection;
      return ln(u, p ? h : c);
    }), A(z(t), "isSelectingRangeEnd", function() {
      var s;
      if (!t.isInSelectingRange())
        return !1;
      var l = t.props, u = l.day, c = l.endDate, p = l.selectsEnd, h = l.selectsRange, O = (s = t.props.selectingDate) !== null && s !== void 0 ? s : t.props.preSelection;
      return ln(u, p || h ? O : c);
    }), A(z(t), "isRangeStart", function() {
      var s = t.props, l = s.day, u = s.startDate, c = s.endDate;
      return !(!u || !c) && ln(u, l);
    }), A(z(t), "isRangeEnd", function() {
      var s = t.props, l = s.day, u = s.startDate, c = s.endDate;
      return !(!u || !c) && ln(c, l);
    }), A(z(t), "isWeekend", function() {
      var s = mD(t.props.day);
      return s === 0 || s === 6;
    }), A(z(t), "isAfterMonth", function() {
      return t.props.month !== void 0 && (t.props.month + 1) % 12 === en(t.props.day);
    }), A(z(t), "isBeforeMonth", function() {
      return t.props.month !== void 0 && (en(t.props.day) + 1) % 12 === t.props.month;
    }), A(z(t), "isCurrentDay", function() {
      return t.isSameDay(Sr());
    }), A(z(t), "isSelected", function() {
      return t.isSameDay(t.props.selected);
    }), A(z(t), "getClassNames", function(s) {
      var l = t.props.dayClassName ? t.props.dayClassName(s) : void 0;
      return gn("react-datepicker__day", l, "react-datepicker__day--" + Sj(t.props.day), { "react-datepicker__day--disabled": t.isDisabled(), "react-datepicker__day--excluded": t.isExcluded(), "react-datepicker__day--selected": t.isSelected(), "react-datepicker__day--keyboard-selected": t.isKeyboardSelected(), "react-datepicker__day--range-start": t.isRangeStart(), "react-datepicker__day--range-end": t.isRangeEnd(), "react-datepicker__day--in-range": t.isInRange(), "react-datepicker__day--in-selecting-range": t.isInSelectingRange(), "react-datepicker__day--selecting-range-start": t.isSelectingRangeStart(), "react-datepicker__day--selecting-range-end": t.isSelectingRangeEnd(), "react-datepicker__day--today": t.isCurrentDay(), "react-datepicker__day--weekend": t.isWeekend(), "react-datepicker__day--outside-month": t.isAfterMonth() || t.isBeforeMonth() }, t.getHighLightedClass("react-datepicker__day--highlighted"));
    }), A(z(t), "getAriaLabel", function() {
      var s = t.props, l = s.day, u = s.ariaLabelPrefixWhenEnabled, c = u === void 0 ? "Choose" : u, p = s.ariaLabelPrefixWhenDisabled, h = p === void 0 ? "Not available" : p, O = t.isDisabled() || t.isExcluded() ? h : c;
      return "".concat(O, " ").concat(Tr(l, "PPPP", t.props.locale));
    }), A(z(t), "getTabIndex", function(s, l) {
      var u = s || t.props.selected, c = l || t.props.preSelection;
      return t.isKeyboardSelected() || t.isSameDay(u) && ln(c, u) ? 0 : -1;
    }), A(z(t), "handleFocusDay", function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = !1;
      t.getTabIndex() === 0 && !s.isInputFocused && t.isSameDay(t.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (l = !0), t.props.inline && !t.props.shouldFocusDayInline && (l = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (l = !0), t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() && (l = !1), t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() && (l = !1)), l && t.dayEl.current.focus({ preventScroll: !0 });
    }), A(z(t), "renderDayContents", function() {
      return t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() || t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() ? null : t.props.renderDayContents ? t.props.renderDayContents(Lg(t.props.day), t.props.day) : Lg(t.props.day);
    }), A(z(t), "render", function() {
      return y.createElement("div", { ref: t.dayEl, className: t.getClassNames(t.props.day), onKeyDown: t.handleOnKeyDown, onClick: t.handleClick, onMouseEnter: t.handleMouseEnter, tabIndex: t.getTabIndex(), "aria-label": t.getAriaLabel(), role: "option", "aria-disabled": t.isDisabled(), "aria-current": t.isCurrentDay() ? "date" : void 0, "aria-selected": t.isSelected() }, t.renderDayContents());
    }), t;
  }
  return Vr(o, [{ key: "componentDidMount", value: function() {
    this.handleFocusDay();
  } }, { key: "componentDidUpdate", value: function(t) {
    this.handleFocusDay(t);
  } }]), o;
}(), Fj = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o() {
    var t;
    Gr(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return A(z(t = n.call.apply(n, [this].concat(a))), "handleClick", function(s) {
      t.props.onClick && t.props.onClick(s);
    }), t;
  }
  return Vr(o, [{ key: "render", value: function() {
    var t = this.props, r = t.weekNumber, a = t.ariaLabelPrefix, i = a === void 0 ? "week " : a, s = { "react-datepicker__week-number": !0, "react-datepicker__week-number--clickable": !!t.onClick };
    return y.createElement("div", { className: gn(s), "aria-label": "".concat(i, " ").concat(this.props.weekNumber), onClick: this.handleClick }, r);
  } }]), o;
}(), Lj = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o() {
    var t;
    Gr(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return A(z(t = n.call.apply(n, [this].concat(a))), "handleDayClick", function(s, l) {
      t.props.onDayClick && t.props.onDayClick(s, l);
    }), A(z(t), "handleDayMouseEnter", function(s) {
      t.props.onDayMouseEnter && t.props.onDayMouseEnter(s);
    }), A(z(t), "handleWeekClick", function(s, l, u) {
      typeof t.props.onWeekSelect == "function" && t.props.onWeekSelect(s, l, u), t.props.shouldCloseOnSelect && t.props.setOpen(!1);
    }), A(z(t), "formatWeekNumber", function(s) {
      return t.props.formatWeekNumber ? t.props.formatWeekNumber(s) : Cj(s);
    }), A(z(t), "renderDays", function() {
      var s = av(t.props.day, t.props.locale, t.props.calendarStartDay), l = [], u = t.formatWeekNumber(s);
      if (t.props.showWeekNumber) {
        var c = t.props.onWeekSelect ? t.handleWeekClick.bind(z(t), s, u) : void 0;
        l.push(y.createElement(Fj, { key: "W", weekNumber: u, onClick: c, ariaLabelPrefix: t.props.ariaLabelPrefix }));
      }
      return l.concat([0, 1, 2, 3, 4, 5, 6].map(function(p) {
        var h = Qa(s, p);
        return y.createElement(Aj, { ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix, key: h.valueOf(), day: h, month: t.props.month, onClick: t.handleDayClick.bind(z(t), h), onMouseEnter: t.handleDayMouseEnter.bind(z(t), h), minDate: t.props.minDate, maxDate: t.props.maxDate, excludeDates: t.props.excludeDates, excludeDateIntervals: t.props.excludeDateIntervals, includeDates: t.props.includeDates, includeDateIntervals: t.props.includeDateIntervals, highlightDates: t.props.highlightDates, selectingDate: t.props.selectingDate, filterDate: t.props.filterDate, preSelection: t.props.preSelection, selected: t.props.selected, selectsStart: t.props.selectsStart, selectsEnd: t.props.selectsEnd, selectsRange: t.props.selectsRange, selectsDisabledDaysInRange: t.props.selectsDisabledDaysInRange, startDate: t.props.startDate, endDate: t.props.endDate, dayClassName: t.props.dayClassName, renderDayContents: t.props.renderDayContents, disabledKeyboardNavigation: t.props.disabledKeyboardNavigation, handleOnKeyDown: t.props.handleOnKeyDown, isInputFocused: t.props.isInputFocused, containerRef: t.props.containerRef, inline: t.props.inline, shouldFocusDayInline: t.props.shouldFocusDayInline, monthShowsDuplicateDaysEnd: t.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: t.props.monthShowsDuplicateDaysStart, locale: t.props.locale });
      }));
    }), t;
  }
  return Vr(o, [{ key: "render", value: function() {
    return y.createElement("div", { className: "react-datepicker__week" }, this.renderDays());
  } }], [{ key: "defaultProps", get: function() {
    return { shouldCloseOnSelect: !0 };
  } }]), o;
}(), Qy = "two_columns", Xy = "three_columns", Jy = "four_columns", Vu = (A(_s = {}, Qy, { grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]], verticalNavigationOffset: 2 }), A(_s, Xy, { grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]], verticalNavigationOffset: 3 }), A(_s, Jy, { grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]], verticalNavigationOffset: 4 }), _s);
function uh(e, n) {
  return e ? Jy : n ? Qy : Xy;
}
var Nj = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o() {
    var t;
    Gr(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return A(z(t = n.call.apply(n, [this].concat(a))), "MONTH_REFS", Md(Array(12)).map(function() {
      return y.createRef();
    })), A(z(t), "QUARTER_REFS", Md(Array(4)).map(function() {
      return y.createRef();
    })), A(z(t), "isDisabled", function(s) {
      return zl(s, t.props);
    }), A(z(t), "isExcluded", function(s) {
      return sv(s, t.props);
    }), A(z(t), "handleDayClick", function(s, l) {
      t.props.onDayClick && t.props.onDayClick(s, l, t.props.orderInDisplay);
    }), A(z(t), "handleDayMouseEnter", function(s) {
      t.props.onDayMouseEnter && t.props.onDayMouseEnter(s);
    }), A(z(t), "handleMouseLeave", function() {
      t.props.onMouseLeave && t.props.onMouseLeave();
    }), A(z(t), "isRangeStartMonth", function(s) {
      var l = t.props, u = l.day, c = l.startDate, p = l.endDate;
      return !(!c || !p) && Mo(wn(u, s), c);
    }), A(z(t), "isRangeStartQuarter", function(s) {
      var l = t.props, u = l.day, c = l.startDate, p = l.endDate;
      return !(!c || !p) && pl($a(u, s), c);
    }), A(z(t), "isRangeEndMonth", function(s) {
      var l = t.props, u = l.day, c = l.startDate, p = l.endDate;
      return !(!c || !p) && Mo(wn(u, s), p);
    }), A(z(t), "isRangeEndQuarter", function(s) {
      var l = t.props, u = l.day, c = l.startDate, p = l.endDate;
      return !(!c || !p) && pl($a(u, s), p);
    }), A(z(t), "isInSelectingRangeMonth", function(s) {
      var l, u = t.props, c = u.day, p = u.selectsStart, h = u.selectsEnd, O = u.selectsRange, C = u.startDate, P = u.endDate, k = (l = t.props.selectingDate) !== null && l !== void 0 ? l : t.props.preSelection;
      return !(!(p || h || O) || !k) && (p && P ? Yu(k, P, s, c) : (h && C || !(!O || !C || P)) && Yu(C, k, s, c));
    }), A(z(t), "isInSelectingRangeQuarter", function(s) {
      var l, u = t.props, c = u.day, p = u.selectsStart, h = u.selectsEnd, O = u.selectsRange, C = u.startDate, P = u.endDate, k = (l = t.props.selectingDate) !== null && l !== void 0 ? l : t.props.preSelection;
      return !(!(p || h || O) || !k) && (p && P ? Gu(k, P, s, c) : (h && C || !(!O || !C || P)) && Gu(C, k, s, c));
    }), A(z(t), "isWeekInMonth", function(s) {
      var l = t.props.day, u = Qa(s, 6);
      return Mo(s, l) || Mo(u, l);
    }), A(z(t), "isCurrentMonth", function(s, l) {
      return Wt(s) === Wt(Sr()) && l === en(Sr());
    }), A(z(t), "isCurrentQuarter", function(s, l) {
      return Wt(s) === Wt(Sr()) && l === Da(Sr());
    }), A(z(t), "isSelectedMonth", function(s, l, u) {
      return en(s) === l && Wt(s) === Wt(u);
    }), A(z(t), "isSelectedQuarter", function(s, l, u) {
      return Da(s) === l && Wt(s) === Wt(u);
    }), A(z(t), "renderWeeks", function() {
      for (var s = [], l = t.props.fixedHeight, u = 0, c = !1, p = av(No(t.props.day), t.props.locale, t.props.calendarStartDay); s.push(y.createElement(Lj, { ariaLabelPrefix: t.props.weekAriaLabelPrefix, chooseDayAriaLabelPrefix: t.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: t.props.disabledDayAriaLabelPrefix, key: u, day: p, month: en(t.props.day), onDayClick: t.handleDayClick, onDayMouseEnter: t.handleDayMouseEnter, onWeekSelect: t.props.onWeekSelect, formatWeekNumber: t.props.formatWeekNumber, locale: t.props.locale, minDate: t.props.minDate, maxDate: t.props.maxDate, excludeDates: t.props.excludeDates, excludeDateIntervals: t.props.excludeDateIntervals, includeDates: t.props.includeDates, includeDateIntervals: t.props.includeDateIntervals, inline: t.props.inline, shouldFocusDayInline: t.props.shouldFocusDayInline, highlightDates: t.props.highlightDates, selectingDate: t.props.selectingDate, filterDate: t.props.filterDate, preSelection: t.props.preSelection, selected: t.props.selected, selectsStart: t.props.selectsStart, selectsEnd: t.props.selectsEnd, selectsRange: t.props.selectsRange, selectsDisabledDaysInRange: t.props.selectsDisabledDaysInRange, showWeekNumber: t.props.showWeekNumbers, startDate: t.props.startDate, endDate: t.props.endDate, dayClassName: t.props.dayClassName, setOpen: t.props.setOpen, shouldCloseOnSelect: t.props.shouldCloseOnSelect, disabledKeyboardNavigation: t.props.disabledKeyboardNavigation, renderDayContents: t.props.renderDayContents, handleOnKeyDown: t.props.handleOnKeyDown, isInputFocused: t.props.isInputFocused, containerRef: t.props.containerRef, calendarStartDay: t.props.calendarStartDay, monthShowsDuplicateDaysEnd: t.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: t.props.monthShowsDuplicateDaysStart })), !c; ) {
        u++, p = Jf(p, 1);
        var h = l && u >= 6, O = !l && !t.isWeekInMonth(p);
        if (h || O) {
          if (!t.props.peekNextMonth)
            break;
          c = !0;
        }
      }
      return s;
    }), A(z(t), "onMonthClick", function(s, l) {
      t.handleDayClick(No(wn(t.props.day, l)), s);
    }), A(z(t), "onMonthMouseEnter", function(s) {
      t.handleDayMouseEnter(No(wn(t.props.day, s)));
    }), A(z(t), "handleMonthNavigation", function(s, l) {
      t.isDisabled(l) || t.isExcluded(l) || (t.props.setPreSelection(l), t.MONTH_REFS[s].current && t.MONTH_REFS[s].current.focus());
    }), A(z(t), "onMonthKeyDown", function(s, l) {
      var u = t.props, c = u.selected, p = u.preSelection, h = u.disabledKeyboardNavigation, O = u.showTwoColumnMonthYearPicker, C = u.showFourColumnMonthYearPicker, P = u.setPreSelection, k = s.key;
      if (k !== "Tab" && s.preventDefault(), !h) {
        var $ = uh(C, O), I = Vu[$].verticalNavigationOffset, H = Vu[$].grid;
        switch (k) {
          case "Enter":
            t.onMonthClick(s, l), P(c);
            break;
          case "ArrowRight":
            t.handleMonthNavigation(l === 11 ? 0 : l + 1, Qn(p, 1));
            break;
          case "ArrowLeft":
            t.handleMonthNavigation(l === 0 ? 11 : l - 1, Ya(p, 1));
            break;
          case "ArrowUp":
            t.handleMonthNavigation(H[0].includes(l) ? l + 12 - I : l - I, Ya(p, I));
            break;
          case "ArrowDown":
            t.handleMonthNavigation(H[H.length - 1].includes(l) ? l - 12 + I : l + I, Qn(p, I));
        }
      }
    }), A(z(t), "onQuarterClick", function(s, l) {
      t.handleDayClick(Jg($a(t.props.day, l)), s);
    }), A(z(t), "onQuarterMouseEnter", function(s) {
      t.handleDayMouseEnter(Jg($a(t.props.day, s)));
    }), A(z(t), "handleQuarterNavigation", function(s, l) {
      t.isDisabled(l) || t.isExcluded(l) || (t.props.setPreSelection(l), t.QUARTER_REFS[s - 1].current && t.QUARTER_REFS[s - 1].current.focus());
    }), A(z(t), "onQuarterKeyDown", function(s, l) {
      var u = s.key;
      if (!t.props.disabledKeyboardNavigation)
        switch (u) {
          case "Enter":
            t.onQuarterClick(s, l), t.props.setPreSelection(t.props.selected);
            break;
          case "ArrowRight":
            t.handleQuarterNavigation(l === 4 ? 1 : l + 1, yy(t.props.preSelection, 1));
            break;
          case "ArrowLeft":
            t.handleQuarterNavigation(l === 1 ? 4 : l - 1, BT(t.props.preSelection, 1));
        }
    }), A(z(t), "getMonthClassNames", function(s) {
      var l = t.props, u = l.day, c = l.startDate, p = l.endDate, h = l.selected, O = l.minDate, C = l.maxDate, P = l.preSelection, k = l.monthClassName, $ = l.excludeDates, I = l.includeDates, H = k ? k(wn(u, s)) : void 0, x = wn(u, s);
      return gn("react-datepicker__month-text", "react-datepicker__month-".concat(s), H, { "react-datepicker__month-text--disabled": (O || C || $ || I) && Vy(x, t.props), "react-datepicker__month-text--selected": t.isSelectedMonth(u, s, h), "react-datepicker__month-text--keyboard-selected": !t.props.disabledKeyboardNavigation && en(P) === s, "react-datepicker__month-text--in-selecting-range": t.isInSelectingRangeMonth(s), "react-datepicker__month-text--in-range": Yu(c, p, s, u), "react-datepicker__month-text--range-start": t.isRangeStartMonth(s), "react-datepicker__month-text--range-end": t.isRangeEndMonth(s), "react-datepicker__month-text--today": t.isCurrentMonth(u, s) });
    }), A(z(t), "getTabIndex", function(s) {
      var l = en(t.props.preSelection);
      return t.props.disabledKeyboardNavigation || s !== l ? "-1" : "0";
    }), A(z(t), "getQuarterTabIndex", function(s) {
      var l = Da(t.props.preSelection);
      return t.props.disabledKeyboardNavigation || s !== l ? "-1" : "0";
    }), A(z(t), "getAriaLabel", function(s) {
      var l = t.props, u = l.chooseDayAriaLabelPrefix, c = u === void 0 ? "Choose" : u, p = l.disabledDayAriaLabelPrefix, h = p === void 0 ? "Not available" : p, O = l.day, C = wn(O, s), P = t.isDisabled(C) || t.isExcluded(C) ? h : c;
      return "".concat(P, " ").concat(Tr(C, "MMMM yyyy"));
    }), A(z(t), "getQuarterClassNames", function(s) {
      var l = t.props, u = l.day, c = l.startDate, p = l.endDate, h = l.selected, O = l.minDate, C = l.maxDate, P = l.preSelection;
      return gn("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(s), { "react-datepicker__quarter-text--disabled": (O || C) && Ej($a(u, s), t.props), "react-datepicker__quarter-text--selected": t.isSelectedQuarter(u, s, h), "react-datepicker__quarter-text--keyboard-selected": Da(P) === s, "react-datepicker__quarter-text--in-selecting-range": t.isInSelectingRangeQuarter(s), "react-datepicker__quarter-text--in-range": Gu(c, p, s, u), "react-datepicker__quarter-text--range-start": t.isRangeStartQuarter(s), "react-datepicker__quarter-text--range-end": t.isRangeEndQuarter(s) });
    }), A(z(t), "renderMonths", function() {
      var s = t.props, l = s.showFullMonthYearPicker, u = s.showTwoColumnMonthYearPicker, c = s.showFourColumnMonthYearPicker, p = s.locale, h = s.day, O = s.selected;
      return Vu[uh(c, u)].grid.map(function(C, P) {
        return y.createElement("div", { className: "react-datepicker__month-wrapper", key: P }, C.map(function(k, $) {
          return y.createElement("div", { ref: t.MONTH_REFS[k], key: $, onClick: function(I) {
            t.onMonthClick(I, k);
          }, onKeyDown: function(I) {
            t.onMonthKeyDown(I, k);
          }, onMouseEnter: function() {
            return t.onMonthMouseEnter(k);
          }, tabIndex: t.getTabIndex(k), className: t.getMonthClassNames(k), role: "option", "aria-label": t.getAriaLabel(k), "aria-current": t.isCurrentMonth(h, k) ? "date" : void 0, "aria-selected": t.isSelectedMonth(h, k, O) }, l ? iv(k, p) : Gy(k, p));
        }));
      });
    }), A(z(t), "renderQuarters", function() {
      var s = t.props, l = s.day, u = s.selected;
      return y.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [1, 2, 3, 4].map(function(c, p) {
        return y.createElement("div", { key: p, ref: t.QUARTER_REFS[p], role: "option", onClick: function(h) {
          t.onQuarterClick(h, c);
        }, onKeyDown: function(h) {
          t.onQuarterKeyDown(h, c);
        }, onMouseEnter: function() {
          return t.onQuarterMouseEnter(c);
        }, className: t.getQuarterClassNames(c), "aria-selected": t.isSelectedQuarter(l, c, u), tabIndex: t.getQuarterTabIndex(c), "aria-current": t.isCurrentQuarter(l, c) ? "date" : void 0 }, Pj(c, t.props.locale));
      }));
    }), A(z(t), "getClassNames", function() {
      var s = t.props;
      s.day;
      var l = s.selectingDate, u = s.selectsStart, c = s.selectsEnd, p = s.showMonthYearPicker, h = s.showQuarterYearPicker;
      return gn("react-datepicker__month", { "react-datepicker__month--selecting-range": l && (u || c) }, { "react-datepicker__monthPicker": p }, { "react-datepicker__quarterPicker": h });
    }), t;
  }
  return Vr(o, [{ key: "render", value: function() {
    var t = this.props, r = t.showMonthYearPicker, a = t.showQuarterYearPicker, i = t.day, s = t.ariaLabelPrefix, l = s === void 0 ? "month " : s;
    return y.createElement("div", { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, "aria-label": "".concat(l, " ").concat(Tr(i, "yyyy-MM")), role: "listbox" }, r ? this.renderMonths() : a ? this.renderQuarters() : this.renderWeeks());
  } }]), o;
}(), Zy = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o() {
    var t;
    Gr(this, o);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return A(z(t = n.call.apply(n, [this].concat(a))), "state", { height: null }), A(z(t), "handleClick", function(s) {
      (t.props.minTime || t.props.maxTime) && rh(s, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && th(s, t.props) || t.props.onChange(s);
    }), A(z(t), "isSelectedTime", function(s, l, u) {
      return t.props.selected && l === Sn(s) && u === On(s);
    }), A(z(t), "liClasses", function(s, l, u) {
      var c = ["react-datepicker__time-list-item", t.props.timeClassName ? t.props.timeClassName(s, l, u) : void 0];
      return t.isSelectedTime(s, l, u) && c.push("react-datepicker__time-list-item--selected"), ((t.props.minTime || t.props.maxTime) && rh(s, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && th(s, t.props)) && c.push("react-datepicker__time-list-item--disabled"), t.props.injectTimes && (60 * Sn(s) + On(s)) % t.props.intervals != 0 && c.push("react-datepicker__time-list-item--injected"), c.join(" ");
    }), A(z(t), "handleOnKeyDown", function(s, l) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), s.key === "Enter" && t.handleClick(l), t.props.handleOnKeyDown(s);
    }), A(z(t), "renderTimes", function() {
      for (var s = [], l = t.props.format ? t.props.format : "p", u = t.props.intervals, c = Oj(Sr(t.props.selected)), p = 1440 / u, h = t.props.injectTimes && t.props.injectTimes.sort(function(x, _) {
        return x - _;
      }), O = t.props.selected || t.props.openToDate || Sr(), C = Sn(O), P = On(O), k = Ri($i(c, P), C), $ = 0; $ < p; $++) {
        var I = Pd(c, $ * u);
        if (s.push(I), h) {
          var H = kj(c, I, $, u, h);
          s = s.concat(H);
        }
      }
      return s.map(function(x, _) {
        return y.createElement("li", { key: _, onClick: t.handleClick.bind(z(t), x), className: t.liClasses(x, C, P), ref: function(F) {
          (yo(x, k) || Ao(x, k)) && (t.centerLi = F);
        }, onKeyDown: function(F) {
          t.handleOnKeyDown(F, x);
        }, tabIndex: "0", "aria-selected": t.isSelectedTime(x, C, P) ? "true" : void 0 }, Tr(x, l, t.props.locale));
      });
    }), t;
  }
  return Vr(o, [{ key: "componentDidMount", value: function() {
    this.list.scrollTop = this.centerLi && o.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
  } }, { key: "render", value: function() {
    var t = this, r = this.state.height;
    return y.createElement("div", { className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "") }, y.createElement("div", { className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(a) {
      t.header = a;
    } }, y.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)), y.createElement("div", { className: "react-datepicker__time" }, y.createElement("div", { className: "react-datepicker__time-box" }, y.createElement("ul", { className: "react-datepicker__time-list", ref: function(a) {
      t.list = a;
    }, style: r ? { height: r } : {}, tabIndex: "0" }, this.renderTimes()))));
  } }], [{ key: "defaultProps", get: function() {
    return { intervals: 30, onTimeChange: function() {
    }, todayButton: null, timeCaption: "Time" };
  } }]), o;
}();
A(Zy, "calcCenterPosition", function(e, n) {
  return n.offsetTop - (e / 2 - n.clientHeight / 2);
});
var Bj = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o(t) {
    var r;
    return Gr(this, o), A(z(r = n.call(this, t)), "YEAR_REFS", Md(Array(r.props.yearItemNumber)).map(function() {
      return y.createRef();
    })), A(z(r), "isDisabled", function(a) {
      return zl(a, r.props);
    }), A(z(r), "isExcluded", function(a) {
      return sv(a, r.props);
    }), A(z(r), "updateFocusOnPaginate", function(a) {
      var i = function() {
        this.YEAR_REFS[a].current.focus();
      }.bind(z(r));
      window.requestAnimationFrame(i);
    }), A(z(r), "handleYearClick", function(a, i) {
      r.props.onDayClick && r.props.onDayClick(a, i);
    }), A(z(r), "handleYearNavigation", function(a, i) {
      var s = r.props, l = s.date, u = s.yearItemNumber, c = Ta(l, u).startPeriod;
      r.isDisabled(i) || r.isExcluded(i) || (r.props.setPreSelection(i), a - c == -1 ? r.updateFocusOnPaginate(u - 1) : a - c === u ? r.updateFocusOnPaginate(0) : r.YEAR_REFS[a - c].current.focus());
    }), A(z(r), "isSameDay", function(a, i) {
      return ln(a, i);
    }), A(z(r), "isCurrentYear", function(a) {
      return a === Wt(Sr());
    }), A(z(r), "isKeyboardSelected", function(a) {
      var i = wi(cl(r.props.date, a));
      return !r.props.disabledKeyboardNavigation && !r.props.inline && !ln(i, wi(r.props.selected)) && ln(i, wi(r.props.preSelection));
    }), A(z(r), "onYearClick", function(a, i) {
      var s = r.props.date;
      r.handleYearClick(wi(cl(s, i)), a);
    }), A(z(r), "onYearKeyDown", function(a, i) {
      var s = a.key;
      if (!r.props.disabledKeyboardNavigation)
        switch (s) {
          case "Enter":
            r.onYearClick(a, i), r.props.setPreSelection(r.props.selected);
            break;
          case "ArrowRight":
            r.handleYearNavigation(i + 1, za(r.props.preSelection, 1));
            break;
          case "ArrowLeft":
            r.handleYearNavigation(i - 1, bo(r.props.preSelection, 1));
        }
    }), A(z(r), "getYearClassNames", function(a) {
      var i = r.props, s = i.minDate, l = i.maxDate, u = i.selected, c = i.excludeDates, p = i.includeDates, h = i.filterDate;
      return gn("react-datepicker__year-text", { "react-datepicker__year-text--selected": a === Wt(u), "react-datepicker__year-text--disabled": (s || l || c || p || h) && Uy(a, r.props), "react-datepicker__year-text--keyboard-selected": r.isKeyboardSelected(a), "react-datepicker__year-text--today": r.isCurrentYear(a) });
    }), A(z(r), "getYearTabIndex", function(a) {
      return r.props.disabledKeyboardNavigation ? "-1" : a === Wt(r.props.preSelection) ? "0" : "-1";
    }), r;
  }
  return Vr(o, [{ key: "render", value: function() {
    for (var t = this, r = [], a = this.props, i = Ta(a.date, a.yearItemNumber), s = i.startPeriod, l = i.endPeriod, u = function(p) {
      r.push(y.createElement("div", { ref: t.YEAR_REFS[p - s], onClick: function(h) {
        t.onYearClick(h, p);
      }, onKeyDown: function(h) {
        t.onYearKeyDown(h, p);
      }, tabIndex: t.getYearTabIndex(p), className: t.getYearClassNames(p), key: p, "aria-current": t.isCurrentYear(p) ? "date" : void 0 }, p));
    }, c = s; c <= l; c++)
      u(c);
    return y.createElement("div", { className: "react-datepicker__year" }, y.createElement("div", { className: "react-datepicker__year-wrapper" }, r));
  } }]), o;
}(), Wj = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o(t) {
    var r;
    return Gr(this, o), A(z(r = n.call(this, t)), "onTimeChange", function(a) {
      r.setState({ time: a });
      var i = /* @__PURE__ */ new Date();
      i.setHours(a.split(":")[0]), i.setMinutes(a.split(":")[1]), r.props.onChange(i);
    }), A(z(r), "renderTimeInput", function() {
      var a = r.state.time, i = r.props, s = i.date, l = i.timeString, u = i.customTimeInput;
      return u ? y.cloneElement(u, { date: s, value: a, onChange: r.onTimeChange }) : y.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: !0, value: a, onChange: function(c) {
        r.onTimeChange(c.target.value || l);
      } });
    }), r.state = { time: r.props.timeString }, r;
  }
  return Vr(o, [{ key: "render", value: function() {
    return y.createElement("div", { className: "react-datepicker__input-time-container" }, y.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), y.createElement("div", { className: "react-datepicker-time__input-container" }, y.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
  } }], [{ key: "getDerivedStateFromProps", value: function(t, r) {
    return t.timeString !== r.time ? { time: t.timeString } : null;
  } }]), o;
}();
function zj(e) {
  var n = e.className, o = e.children, t = e.showPopperArrow, r = e.arrowProps, a = r === void 0 ? {} : r;
  return y.createElement("div", { className: n }, t && y.createElement("div", Wl({ className: "react-datepicker__triangle" }, a)), o);
}
var Hj = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], Yj = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o(t) {
    var r;
    return Gr(this, o), A(z(r = n.call(this, t)), "handleClickOutside", function(a) {
      r.props.onClickOutside(a);
    }), A(z(r), "setClickOutsideRef", function() {
      return r.containerRef.current;
    }), A(z(r), "handleDropdownFocus", function(a) {
      (function() {
        var i = ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).className || "").split(/\s+/);
        return Hj.some(function(s) {
          return i.indexOf(s) >= 0;
        });
      })(a.target) && r.props.onDropdownFocus();
    }), A(z(r), "getDateInView", function() {
      var a = r.props, i = a.preSelection, s = a.selected, l = a.openToDate, u = qy(r.props), c = Ky(r.props), p = Sr(), h = l || s || i;
      return h || (u && yo(p, u) ? u : c && zo(p, c) ? c : p);
    }), A(z(r), "increaseMonth", function() {
      r.setState(function(a) {
        var i = a.date;
        return { date: Qn(i, 1) };
      }, function() {
        return r.handleMonthChange(r.state.date);
      });
    }), A(z(r), "decreaseMonth", function() {
      r.setState(function(a) {
        var i = a.date;
        return { date: Ya(i, 1) };
      }, function() {
        return r.handleMonthChange(r.state.date);
      });
    }), A(z(r), "handleDayClick", function(a, i, s) {
      r.props.onSelect(a, i, s), r.props.setPreSelection && r.props.setPreSelection(a);
    }), A(z(r), "handleDayMouseEnter", function(a) {
      r.setState({ selectingDate: a }), r.props.onDayMouseEnter && r.props.onDayMouseEnter(a);
    }), A(z(r), "handleMonthMouseLeave", function() {
      r.setState({ selectingDate: null }), r.props.onMonthMouseLeave && r.props.onMonthMouseLeave();
    }), A(z(r), "handleYearChange", function(a) {
      r.props.onYearChange && (r.props.onYearChange(a), r.setState({ isRenderAriaLiveMessage: !0 })), r.props.adjustDateOnChange && (r.props.onSelect && r.props.onSelect(a), r.props.setOpen && r.props.setOpen(!0)), r.props.setPreSelection && r.props.setPreSelection(a);
    }), A(z(r), "handleMonthChange", function(a) {
      r.props.onMonthChange && (r.props.onMonthChange(a), r.setState({ isRenderAriaLiveMessage: !0 })), r.props.adjustDateOnChange && (r.props.onSelect && r.props.onSelect(a), r.props.setOpen && r.props.setOpen(!0)), r.props.setPreSelection && r.props.setPreSelection(a);
    }), A(z(r), "handleMonthYearChange", function(a) {
      r.handleYearChange(a), r.handleMonthChange(a);
    }), A(z(r), "changeYear", function(a) {
      r.setState(function(i) {
        var s = i.date;
        return { date: cl(s, a) };
      }, function() {
        return r.handleYearChange(r.state.date);
      });
    }), A(z(r), "changeMonth", function(a) {
      r.setState(function(i) {
        var s = i.date;
        return { date: wn(s, a) };
      }, function() {
        return r.handleMonthChange(r.state.date);
      });
    }), A(z(r), "changeMonthYear", function(a) {
      r.setState(function(i) {
        var s = i.date;
        return { date: cl(wn(s, en(a)), Wt(a)) };
      }, function() {
        return r.handleMonthYearChange(r.state.date);
      });
    }), A(z(r), "header", function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : r.state.date, i = av(a, r.props.locale, r.props.calendarStartDay), s = [];
      return r.props.showWeekNumbers && s.push(y.createElement("div", { key: "W", className: "react-datepicker__day-name" }, r.props.weekLabel || "#")), s.concat([0, 1, 2, 3, 4, 5, 6].map(function(l) {
        var u = Qa(i, l), c = r.formatWeekday(u, r.props.locale), p = r.props.weekDayClassName ? r.props.weekDayClassName(u) : void 0;
        return y.createElement("div", { key: l, className: gn("react-datepicker__day-name", p) }, c);
      }));
    }), A(z(r), "formatWeekday", function(a, i) {
      return r.props.formatWeekDay ? function(s, l, u) {
        return l(Tr(s, "EEEE", u));
      }(a, r.props.formatWeekDay, i) : r.props.useWeekdaysShort ? function(s, l) {
        return Tr(s, "EEE", l);
      }(a, i) : function(s, l) {
        return Tr(s, "EEEEEE", l);
      }(a, i);
    }), A(z(r), "decreaseYear", function() {
      r.setState(function(a) {
        var i = a.date;
        return { date: bo(i, r.props.showYearPicker ? r.props.yearItemNumber : 1) };
      }, function() {
        return r.handleYearChange(r.state.date);
      });
    }), A(z(r), "renderPreviousButton", function() {
      if (!r.props.renderCustomHeader) {
        var a;
        switch (!0) {
          case r.props.showMonthYearPicker:
            a = ah(r.state.date, r.props);
            break;
          case r.props.showYearPicker:
            a = function($) {
              var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, H = I.minDate, x = I.yearItemNumber, _ = x === void 0 ? 12 : x, F = Ta(wi(bo($, _)), _).endPeriod, G = H && Wt(H);
              return G && G > F || !1;
            }(r.state.date, r.props);
            break;
          default:
            a = nh(r.state.date, r.props);
        }
        if ((r.props.forceShowMonthNavigation || r.props.showDisabledMonthNavigation || !a) && !r.props.showTimeSelectOnly) {
          var i = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], s = r.decreaseMonth;
          (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker) && (s = r.decreaseYear), a && r.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--previous--disabled"), s = null);
          var l = r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker, u = r.props, c = u.previousMonthButtonLabel, p = u.previousYearButtonLabel, h = r.props, O = h.previousMonthAriaLabel, C = O === void 0 ? typeof c == "string" ? c : "Previous Month" : O, P = h.previousYearAriaLabel, k = P === void 0 ? typeof p == "string" ? p : "Previous Year" : P;
          return y.createElement("button", { type: "button", className: i.join(" "), onClick: s, onKeyDown: r.props.handleOnKeyDown, "aria-label": l ? k : C }, y.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" ") }, l ? r.props.previousYearButtonLabel : r.props.previousMonthButtonLabel));
        }
      }
    }), A(z(r), "increaseYear", function() {
      r.setState(function(a) {
        var i = a.date;
        return { date: za(i, r.props.showYearPicker ? r.props.yearItemNumber : 1) };
      }, function() {
        return r.handleYearChange(r.state.date);
      });
    }), A(z(r), "renderNextButton", function() {
      if (!r.props.renderCustomHeader) {
        var a;
        switch (!0) {
          case r.props.showMonthYearPicker:
            a = ih(r.state.date, r.props);
            break;
          case r.props.showYearPicker:
            a = function($) {
              var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, H = I.maxDate, x = I.yearItemNumber, _ = x === void 0 ? 12 : x, F = Ta(za($, _), _).startPeriod, G = H && Wt(H);
              return G && G < F || !1;
            }(r.state.date, r.props);
            break;
          default:
            a = oh(r.state.date, r.props);
        }
        if ((r.props.forceShowMonthNavigation || r.props.showDisabledMonthNavigation || !a) && !r.props.showTimeSelectOnly) {
          var i = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
          r.props.showTimeSelect && i.push("react-datepicker__navigation--next--with-time"), r.props.todayButton && i.push("react-datepicker__navigation--next--with-today-button");
          var s = r.increaseMonth;
          (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker) && (s = r.increaseYear), a && r.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--next--disabled"), s = null);
          var l = r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker, u = r.props, c = u.nextMonthButtonLabel, p = u.nextYearButtonLabel, h = r.props, O = h.nextMonthAriaLabel, C = O === void 0 ? typeof c == "string" ? c : "Next Month" : O, P = h.nextYearAriaLabel, k = P === void 0 ? typeof p == "string" ? p : "Next Year" : P;
          return y.createElement("button", { type: "button", className: i.join(" "), onClick: s, onKeyDown: r.props.handleOnKeyDown, "aria-label": l ? k : C }, y.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" ") }, l ? r.props.nextYearButtonLabel : r.props.nextMonthButtonLabel));
        }
      }
    }), A(z(r), "renderCurrentMonth", function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : r.state.date, i = ["react-datepicker__current-month"];
      return r.props.showYearDropdown && i.push("react-datepicker__current-month--hasYearDropdown"), r.props.showMonthDropdown && i.push("react-datepicker__current-month--hasMonthDropdown"), r.props.showMonthYearDropdown && i.push("react-datepicker__current-month--hasMonthYearDropdown"), y.createElement("div", { className: i.join(" ") }, Tr(a, r.props.dateFormat, r.props.locale));
    }), A(z(r), "renderYearDropdown", function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (r.props.showYearDropdown && !a)
        return y.createElement(Dj, { adjustDateOnChange: r.props.adjustDateOnChange, date: r.state.date, onSelect: r.props.onSelect, setOpen: r.props.setOpen, dropdownMode: r.props.dropdownMode, onChange: r.changeYear, minDate: r.props.minDate, maxDate: r.props.maxDate, year: Wt(r.state.date), scrollableYearDropdown: r.props.scrollableYearDropdown, yearDropdownItemNumber: r.props.yearDropdownItemNumber });
    }), A(z(r), "renderMonthDropdown", function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (r.props.showMonthDropdown && !a)
        return y.createElement(jj, { dropdownMode: r.props.dropdownMode, locale: r.props.locale, onChange: r.changeMonth, month: en(r.state.date), useShortMonthInDropdown: r.props.useShortMonthInDropdown });
    }), A(z(r), "renderMonthYearDropdown", function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (r.props.showMonthYearDropdown && !a)
        return y.createElement(Mj, { dropdownMode: r.props.dropdownMode, locale: r.props.locale, dateFormat: r.props.dateFormat, onChange: r.changeMonthYear, minDate: r.props.minDate, maxDate: r.props.maxDate, date: r.state.date, scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown });
    }), A(z(r), "handleTodayButtonClick", function(a) {
      r.props.onSelect(Zg(), a), r.props.setPreSelection && r.props.setPreSelection(Zg());
    }), A(z(r), "renderTodayButton", function() {
      if (r.props.todayButton && !r.props.showTimeSelectOnly)
        return y.createElement("div", { className: "react-datepicker__today-button", onClick: function(a) {
          return r.handleTodayButtonClick(a);
        } }, r.props.todayButton);
    }), A(z(r), "renderDefaultHeader", function(a) {
      var i = a.monthDate, s = a.i;
      return y.createElement("div", { className: "react-datepicker__header ".concat(r.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") }, r.renderCurrentMonth(i), y.createElement("div", { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(r.props.dropdownMode), onFocus: r.handleDropdownFocus }, r.renderMonthDropdown(s !== 0), r.renderMonthYearDropdown(s !== 0), r.renderYearDropdown(s !== 0)), y.createElement("div", { className: "react-datepicker__day-names" }, r.header(i)));
    }), A(z(r), "renderCustomHeader", function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = a.monthDate, s = a.i;
      if (r.props.showTimeSelect && !r.state.monthContainer || r.props.showTimeSelectOnly)
        return null;
      var l = nh(r.state.date, r.props), u = oh(r.state.date, r.props), c = ah(r.state.date, r.props), p = ih(r.state.date, r.props), h = !r.props.showMonthYearPicker && !r.props.showQuarterYearPicker && !r.props.showYearPicker;
      return y.createElement("div", { className: "react-datepicker__header react-datepicker__header--custom", onFocus: r.props.onDropdownFocus }, r.props.renderCustomHeader(Ug(Ug({}, r.state), {}, { customHeaderCount: s, monthDate: i, changeMonth: r.changeMonth, changeYear: r.changeYear, decreaseMonth: r.decreaseMonth, increaseMonth: r.increaseMonth, decreaseYear: r.decreaseYear, increaseYear: r.increaseYear, prevMonthButtonDisabled: l, nextMonthButtonDisabled: u, prevYearButtonDisabled: c, nextYearButtonDisabled: p })), h && y.createElement("div", { className: "react-datepicker__day-names" }, r.header(i)));
    }), A(z(r), "renderYearHeader", function() {
      var a = r.state.date, i = r.props, s = i.showYearPicker, l = Ta(a, i.yearItemNumber), u = l.startPeriod, c = l.endPeriod;
      return y.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, s ? "".concat(u, " - ").concat(c) : Wt(a));
    }), A(z(r), "renderHeader", function(a) {
      switch (!0) {
        case r.props.renderCustomHeader !== void 0:
          return r.renderCustomHeader(a);
        case (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker):
          return r.renderYearHeader(a);
        default:
          return r.renderDefaultHeader(a);
      }
    }), A(z(r), "renderMonths", function() {
      if (!r.props.showTimeSelectOnly && !r.props.showYearPicker) {
        for (var a = [], i = r.props.showPreviousMonths ? r.props.monthsShown - 1 : 0, s = Ya(r.state.date, i), l = 0; l < r.props.monthsShown; ++l) {
          var u = l - r.props.monthSelectedIn, c = Qn(s, u), p = "month-".concat(l), h = l < r.props.monthsShown - 1, O = l > 0;
          a.push(y.createElement("div", { key: p, ref: function(C) {
            r.monthContainer = C;
          }, className: "react-datepicker__month-container" }, r.renderHeader({ monthDate: c, i: l }), y.createElement(Nj, { chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: r.props.weekAriaLabelPrefix, ariaLabelPrefix: r.props.monthAriaLabelPrefix, onChange: r.changeMonthYear, day: c, dayClassName: r.props.dayClassName, calendarStartDay: r.props.calendarStartDay, monthClassName: r.props.monthClassName, onDayClick: r.handleDayClick, handleOnKeyDown: r.props.handleOnDayKeyDown, onDayMouseEnter: r.handleDayMouseEnter, onMouseLeave: r.handleMonthMouseLeave, onWeekSelect: r.props.onWeekSelect, orderInDisplay: l, formatWeekNumber: r.props.formatWeekNumber, locale: r.props.locale, minDate: r.props.minDate, maxDate: r.props.maxDate, excludeDates: r.props.excludeDates, excludeDateIntervals: r.props.excludeDateIntervals, highlightDates: r.props.highlightDates, selectingDate: r.state.selectingDate, includeDates: r.props.includeDates, includeDateIntervals: r.props.includeDateIntervals, inline: r.props.inline, shouldFocusDayInline: r.props.shouldFocusDayInline, fixedHeight: r.props.fixedHeight, filterDate: r.props.filterDate, preSelection: r.props.preSelection, setPreSelection: r.props.setPreSelection, selected: r.props.selected, selectsStart: r.props.selectsStart, selectsEnd: r.props.selectsEnd, selectsRange: r.props.selectsRange, selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange, showWeekNumbers: r.props.showWeekNumbers, startDate: r.props.startDate, endDate: r.props.endDate, peekNextMonth: r.props.peekNextMonth, setOpen: r.props.setOpen, shouldCloseOnSelect: r.props.shouldCloseOnSelect, renderDayContents: r.props.renderDayContents, disabledKeyboardNavigation: r.props.disabledKeyboardNavigation, showMonthYearPicker: r.props.showMonthYearPicker, showFullMonthYearPicker: r.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: r.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: r.props.showFourColumnMonthYearPicker, showYearPicker: r.props.showYearPicker, showQuarterYearPicker: r.props.showQuarterYearPicker, isInputFocused: r.props.isInputFocused, containerRef: r.containerRef, monthShowsDuplicateDaysEnd: h, monthShowsDuplicateDaysStart: O })));
        }
        return a;
      }
    }), A(z(r), "renderYears", function() {
      if (!r.props.showTimeSelectOnly)
        return r.props.showYearPicker ? y.createElement("div", { className: "react-datepicker__year--container" }, r.renderHeader(), y.createElement(Bj, Wl({ onDayClick: r.handleDayClick, date: r.state.date }, r.props))) : void 0;
    }), A(z(r), "renderTimeSection", function() {
      if (r.props.showTimeSelect && (r.state.monthContainer || r.props.showTimeSelectOnly))
        return y.createElement(Zy, { selected: r.props.selected, openToDate: r.props.openToDate, onChange: r.props.onTimeChange, timeClassName: r.props.timeClassName, format: r.props.timeFormat, includeTimes: r.props.includeTimes, intervals: r.props.timeIntervals, minTime: r.props.minTime, maxTime: r.props.maxTime, excludeTimes: r.props.excludeTimes, filterTime: r.props.filterTime, timeCaption: r.props.timeCaption, todayButton: r.props.todayButton, showMonthDropdown: r.props.showMonthDropdown, showMonthYearDropdown: r.props.showMonthYearDropdown, showYearDropdown: r.props.showYearDropdown, withPortal: r.props.withPortal, monthRef: r.state.monthContainer, injectTimes: r.props.injectTimes, locale: r.props.locale, handleOnKeyDown: r.props.handleOnKeyDown, showTimeSelectOnly: r.props.showTimeSelectOnly });
    }), A(z(r), "renderInputTimeSection", function() {
      var a = new Date(r.props.selected), i = Io(a) && r.props.selected ? "".concat(lh(a.getHours()), ":").concat(lh(a.getMinutes())) : "";
      if (r.props.showTimeInput)
        return y.createElement(Wj, { date: a, timeString: i, timeInputLabel: r.props.timeInputLabel, onChange: r.props.onTimeChange, customTimeInput: r.props.customTimeInput });
    }), A(z(r), "renderAriaLiveRegion", function() {
      var a, i = Ta(r.state.date, r.props.yearItemNumber), s = i.startPeriod, l = i.endPeriod;
      return a = r.props.showYearPicker ? "".concat(s, " - ").concat(l) : r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? Wt(r.state.date) : "".concat(iv(en(r.state.date), r.props.locale), " ").concat(Wt(r.state.date)), y.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, r.state.isRenderAriaLiveMessage && a);
    }), A(z(r), "renderChildren", function() {
      if (r.props.children)
        return y.createElement("div", { className: "react-datepicker__children-container" }, r.props.children);
    }), r.containerRef = y.createRef(), r.state = { date: r.getDateInView(), selectingDate: null, monthContainer: null, isRenderAriaLiveMessage: !1 }, r;
  }
  return Vr(o, [{ key: "componentDidMount", value: function() {
    var t = this;
    this.props.showTimeSelect && (this.assignMonthContainer = void t.setState({ monthContainer: t.monthContainer }));
  } }, { key: "componentDidUpdate", value: function(t) {
    !this.props.preSelection || ln(this.props.preSelection, t.preSelection) && this.props.monthSelectedIn === t.monthSelectedIn ? this.props.openToDate && !ln(this.props.openToDate, t.openToDate) && this.setState({ date: this.props.openToDate }) : this.setState({ date: this.props.preSelection });
  } }, { key: "render", value: function() {
    var t = this.props.container || zj;
    return y.createElement("div", { ref: this.containerRef }, y.createElement(t, { className: gn("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }), showPopperArrow: this.props.showPopperArrow, arrowProps: this.props.arrowProps }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
  } }], [{ key: "defaultProps", get: function() {
    return { onDropdownFocus: function() {
    }, monthsShown: 1, monthSelectedIn: 0, forceShowMonthNavigation: !1, timeCaption: "Time", previousYearButtonLabel: "Previous Year", nextYearButtonLabel: "Next Year", previousMonthButtonLabel: "Previous Month", nextMonthButtonLabel: "Next Month", customTimeInput: null, yearItemNumber: 12 };
  } }]), o;
}(), eb = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o(t) {
    var r;
    return Gr(this, o), (r = n.call(this, t)).el = document.createElement("div"), r;
  }
  return Vr(o, [{ key: "componentDidMount", value: function() {
    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
  } }, { key: "componentWillUnmount", value: function() {
    this.portalRoot.removeChild(this.el);
  } }, { key: "render", value: function() {
    return Ab.createPortal(this.props.children, this.el);
  } }]), o;
}(), Gj = function(e) {
  return !e.disabled && e.tabIndex !== -1;
}, tb = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o(t) {
    var r;
    return Gr(this, o), A(z(r = n.call(this, t)), "getTabChildren", function() {
      return Array.prototype.slice.call(r.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(Gj);
    }), A(z(r), "handleFocusStart", function(a) {
      var i = r.getTabChildren();
      i && i.length > 1 && i[i.length - 1].focus();
    }), A(z(r), "handleFocusEnd", function(a) {
      var i = r.getTabChildren();
      i && i.length > 1 && i[0].focus();
    }), r.tabLoopRef = y.createRef(), r;
  }
  return Vr(o, [{ key: "render", value: function() {
    return this.props.enableTabLoop ? y.createElement("div", { className: "react-datepicker__tab-loop", ref: this.tabLoopRef }, y.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: "0", onFocus: this.handleFocusStart }), this.props.children, y.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: "0", onFocus: this.handleFocusEnd })) : this.props.children;
  } }], [{ key: "defaultProps", get: function() {
    return { enableTabLoop: !0 };
  } }]), o;
}(), Vj = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o() {
    return Gr(this, o), n.apply(this, arguments);
  }
  return Vr(o, [{ key: "render", value: function() {
    var t, r = this.props, a = r.className, i = r.wrapperClassName, s = r.hidePopper, l = r.popperComponent, u = r.popperModifiers, c = r.popperPlacement, p = r.popperProps, h = r.targetComponent, O = r.enableTabLoop, C = r.popperOnKeyDown, P = r.portalId, k = r.portalHost;
    if (!s) {
      var $ = gn("react-datepicker-popper", a);
      t = y.createElement(pj, Wl({ modifiers: u, placement: c }, p), function(H) {
        var x = H.ref, _ = H.style, F = H.placement, G = H.arrowProps;
        return y.createElement(tb, { enableTabLoop: O }, y.createElement("div", { ref: x, style: _, className: $, "data-placement": F, onKeyDown: C }, y.cloneElement(l, { arrowProps: G })));
      });
    }
    this.props.popperContainer && (t = y.createElement(this.props.popperContainer, {}, t)), P && !s && (t = y.createElement(eb, { portalId: P, portalHost: k }, t));
    var I = gn("react-datepicker-wrapper", i);
    return y.createElement(ej, { className: "react-datepicker-manager" }, y.createElement(mj, null, function(H) {
      var x = H.ref;
      return y.createElement("div", { ref: x, className: I }, h);
    }), t);
  } }], [{ key: "defaultProps", get: function() {
    return { hidePopper: !0, popperModifiers: [], popperProps: {}, popperPlacement: "bottom-start" };
  } }]), o;
}(), Uj = Bl(Yj), qj = function(e) {
  Ur(o, y.Component);
  var n = qr(o);
  function o(t) {
    var r;
    return Gr(this, o), A(z(r = n.call(this, t)), "getPreSelection", function() {
      return r.props.openToDate ? r.props.openToDate : r.props.selectsEnd && r.props.startDate ? r.props.startDate : r.props.selectsStart && r.props.endDate ? r.props.endDate : Sr();
    }), A(z(r), "calcInitialState", function() {
      var a, i = r.getPreSelection(), s = qy(r.props), l = Ky(r.props), u = s && yo(i, Un(s)) ? s : l && zo(i, il(l)) ? l : i;
      return { open: r.props.startOpen || !1, preventFocus: !1, preSelection: (a = r.props.selectsRange ? r.props.startDate : r.props.selected) !== null && a !== void 0 ? a : u, highlightDates: sh(r.props.highlightDates), focused: !1, shouldFocusDayInline: !1, isRenderAriaLiveMessage: !1 };
    }), A(z(r), "clearPreventFocusTimeout", function() {
      r.preventFocusTimeout && clearTimeout(r.preventFocusTimeout);
    }), A(z(r), "setFocus", function() {
      r.input && r.input.focus && r.input.focus({ preventScroll: !0 });
    }), A(z(r), "setBlur", function() {
      r.input && r.input.blur && r.input.blur(), r.cancelFocusInput();
    }), A(z(r), "setOpen", function(a) {
      var i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      r.setState({ open: a, preSelection: a && r.state.open ? r.state.preSelection : r.calcInitialState().preSelection, lastPreSelectChange: Uu }, function() {
        a || r.setState(function(s) {
          return { focused: !!i && s.focused };
        }, function() {
          !i && r.setBlur(), r.setState({ inputValue: null });
        });
      });
    }), A(z(r), "inputOk", function() {
      return tv(r.state.preSelection);
    }), A(z(r), "isCalendarOpen", function() {
      return r.props.open === void 0 ? r.state.open && !r.props.disabled && !r.props.readOnly : r.props.open;
    }), A(z(r), "handleFocus", function(a) {
      r.state.preventFocus || (r.props.onFocus(a), r.props.preventOpenOnFocus || r.props.readOnly || r.setOpen(!0)), r.setState({ focused: !0 });
    }), A(z(r), "cancelFocusInput", function() {
      clearTimeout(r.inputFocusTimeout), r.inputFocusTimeout = null;
    }), A(z(r), "deferFocusInput", function() {
      r.cancelFocusInput(), r.inputFocusTimeout = setTimeout(function() {
        return r.setFocus();
      }, 1);
    }), A(z(r), "handleDropdownFocus", function() {
      r.cancelFocusInput();
    }), A(z(r), "handleBlur", function(a) {
      (!r.state.open || r.props.withPortal || r.props.showTimeInput) && r.props.onBlur(a), r.setState({ focused: !1 });
    }), A(z(r), "handleCalendarClickOutside", function(a) {
      r.props.inline || r.setOpen(!1), r.props.onClickOutside(a), r.props.withPortal && a.preventDefault();
    }), A(z(r), "handleChange", function() {
      for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
        i[s] = arguments[s];
      var l = i[0];
      if (!r.props.onChangeRaw || (r.props.onChangeRaw.apply(z(r), i), typeof l.isDefaultPrevented == "function" && !l.isDefaultPrevented())) {
        r.setState({ inputValue: l.target.value, lastPreSelectChange: Kj });
        var u = xj(l.target.value, r.props.dateFormat, r.props.locale, r.props.strictParsing, r.props.minDate);
        r.props.showTimeSelectOnly && r.props.selected && !ln(u, r.props.selected) && (u = LT(r.props.selected, u == null ? { hours: Sn(r.props.selected), minutes: On(r.props.selected), seconds: Nu(r.props.selected) } : { hours: Sn(u), minutes: On(u), seconds: Nu(u) })), !u && l.target.value || r.setSelected(u, l, !0);
      }
    }), A(z(r), "handleSelect", function(a, i, s) {
      if (r.setState({ preventFocus: !0 }, function() {
        return r.preventFocusTimeout = setTimeout(function() {
          return r.setState({ preventFocus: !1 });
        }, 50), r.preventFocusTimeout;
      }), r.props.onChangeRaw && r.props.onChangeRaw(i), r.setSelected(a, i, !1, s), r.setState({ isRenderAriaLiveMessage: !0 }), !r.props.shouldCloseOnSelect || r.props.showTimeSelect)
        r.setPreSelection(a);
      else if (!r.props.inline) {
        r.props.selectsRange || r.setOpen(!1);
        var l = r.props, u = l.startDate, c = l.endDate;
        !u || c || yo(a, u) || r.setOpen(!1);
      }
    }), A(z(r), "setSelected", function(a, i, s, l) {
      var u = a;
      if (r.props.showYearPicker) {
        if (u !== null && Uy(Wt(u), r.props))
          return;
      } else if (r.props.showMonthYearPicker) {
        if (u !== null && Vy(u, r.props))
          return;
      } else if (u !== null && zl(u, r.props))
        return;
      var c = r.props, p = c.onChange, h = c.selectsRange, O = c.startDate, C = c.endDate;
      if (!Ao(r.props.selected, u) || r.props.allowSameDay || h)
        if (u !== null && (!r.props.selected || s && (r.props.showTimeSelect || r.props.showTimeSelectOnly || r.props.showTimeInput) || (u = Xg(u, { hour: Sn(r.props.selected), minute: On(r.props.selected), second: Nu(r.props.selected) })), r.props.inline || r.setState({ preSelection: u }), r.props.focusSelectedMonth || r.setState({ monthSelectedIn: l })), h) {
          var P = O && !C, k = O && C;
          !O && !C ? p([u, null], i) : P && (yo(u, O) ? p([u, null], i) : p([O, u], i)), k && p([u, null], i);
        } else
          p(u, i);
      s || (r.props.onSelect(u, i), r.setState({ inputValue: null }));
    }), A(z(r), "setPreSelection", function(a) {
      var i = r.props.minDate !== void 0, s = r.props.maxDate !== void 0, l = !0;
      if (a) {
        var u = Un(a);
        if (i && s)
          l = Bs(a, r.props.minDate, r.props.maxDate);
        else if (i) {
          var c = Un(r.props.minDate);
          l = zo(a, c) || Ao(u, c);
        } else if (s) {
          var p = il(r.props.maxDate);
          l = yo(a, p) || Ao(u, p);
        }
      }
      l && r.setState({ preSelection: a });
    }), A(z(r), "handleTimeChange", function(a) {
      var i = Xg(r.props.selected ? r.props.selected : r.getPreSelection(), { hour: Sn(a), minute: On(a) });
      r.setState({ preSelection: i }), r.props.onChange(i), r.props.shouldCloseOnSelect && r.setOpen(!1), r.props.showTimeInput && r.setOpen(!0), (r.props.showTimeSelectOnly || r.props.showTimeSelect) && r.setState({ isRenderAriaLiveMessage: !0 }), r.setState({ inputValue: null });
    }), A(z(r), "onInputClick", function() {
      r.props.disabled || r.props.readOnly || r.setOpen(!0), r.props.onInputClick();
    }), A(z(r), "onInputKeyDown", function(a) {
      r.props.onKeyDown(a);
      var i = a.key;
      if (r.state.open || r.props.inline || r.props.preventOpenOnFocus) {
        if (r.state.open) {
          if (i === "ArrowDown" || i === "ArrowUp") {
            a.preventDefault();
            var s = r.calendar.componentNode && r.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
            return void (s && s.focus({ preventScroll: !0 }));
          }
          var l = Sr(r.state.preSelection);
          i === "Enter" ? (a.preventDefault(), r.inputOk() && r.state.lastPreSelectChange === Uu ? (r.handleSelect(l, a), !r.props.shouldCloseOnSelect && r.setPreSelection(l)) : r.setOpen(!1)) : i === "Escape" ? (a.preventDefault(), r.setOpen(!1)) : i === "Tab" && a.shiftKey && r.setOpen(!1), r.inputOk() || r.props.onInputError({ code: 1, msg: "Date input not valid." });
        }
      } else
        i !== "ArrowDown" && i !== "ArrowUp" && i !== "Enter" || r.onInputClick();
    }), A(z(r), "onPortalKeyDown", function(a) {
      a.key === "Escape" && (a.preventDefault(), r.setState({ preventFocus: !0 }, function() {
        r.setOpen(!1), setTimeout(function() {
          r.setFocus(), r.setState({ preventFocus: !1 });
        });
      }));
    }), A(z(r), "onDayKeyDown", function(a) {
      r.props.onKeyDown(a);
      var i = a.key, s = Sr(r.state.preSelection);
      if (i === "Enter")
        a.preventDefault(), r.handleSelect(s, a), !r.props.shouldCloseOnSelect && r.setPreSelection(s);
      else if (i === "Escape")
        a.preventDefault(), r.setOpen(!1), r.inputOk() || r.props.onInputError({ code: 1, msg: "Date input not valid." });
      else if (!r.props.disabledKeyboardNavigation) {
        var l;
        switch (i) {
          case "ArrowLeft":
            l = ra(s, 1);
            break;
          case "ArrowRight":
            l = Qa(s, 1);
            break;
          case "ArrowUp":
            l = WT(s, 1);
            break;
          case "ArrowDown":
            l = Jf(s, 1);
            break;
          case "PageUp":
            l = Ya(s, 1);
            break;
          case "PageDown":
            l = Qn(s, 1);
            break;
          case "Home":
            l = bo(s, 1);
            break;
          case "End":
            l = za(s, 1);
        }
        if (!l)
          return void (r.props.onInputError && r.props.onInputError({ code: 1, msg: "Date input not valid." }));
        if (a.preventDefault(), r.setState({ lastPreSelectChange: Uu }), r.props.adjustDateOnChange && r.setSelected(l), r.setPreSelection(l), r.props.inline) {
          var u = en(s), c = en(l), p = Wt(s), h = Wt(l);
          u !== c || p !== h ? r.setState({ shouldFocusDayInline: !0 }) : r.setState({ shouldFocusDayInline: !1 });
        }
      }
    }), A(z(r), "onPopperKeyDown", function(a) {
      a.key === "Escape" && (a.preventDefault(), r.setState({ preventFocus: !0 }, function() {
        r.setOpen(!1), setTimeout(function() {
          r.setFocus(), r.setState({ preventFocus: !1 });
        });
      }));
    }), A(z(r), "onClearClick", function(a) {
      a && a.preventDefault && a.preventDefault(), r.props.selectsRange ? r.props.onChange([null, null], a) : r.props.onChange(null, a), r.setState({ inputValue: null });
    }), A(z(r), "clear", function() {
      r.onClearClick();
    }), A(z(r), "onScroll", function(a) {
      typeof r.props.closeOnScroll == "boolean" && r.props.closeOnScroll ? a.target !== document && a.target !== document.documentElement && a.target !== document.body || r.setOpen(!1) : typeof r.props.closeOnScroll == "function" && r.props.closeOnScroll(a) && r.setOpen(!1);
    }), A(z(r), "renderCalendar", function() {
      return r.props.inline || r.isCalendarOpen() ? y.createElement(Uj, { ref: function(a) {
        r.calendar = a;
      }, locale: r.props.locale, calendarStartDay: r.props.calendarStartDay, chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: r.props.weekAriaLabelPrefix, monthAriaLabelPrefix: r.props.monthAriaLabelPrefix, adjustDateOnChange: r.props.adjustDateOnChange, setOpen: r.setOpen, shouldCloseOnSelect: r.props.shouldCloseOnSelect, dateFormat: r.props.dateFormatCalendar, useWeekdaysShort: r.props.useWeekdaysShort, formatWeekDay: r.props.formatWeekDay, dropdownMode: r.props.dropdownMode, selected: r.props.selected, preSelection: r.state.preSelection, onSelect: r.handleSelect, onWeekSelect: r.props.onWeekSelect, openToDate: r.props.openToDate, minDate: r.props.minDate, maxDate: r.props.maxDate, selectsStart: r.props.selectsStart, selectsEnd: r.props.selectsEnd, selectsRange: r.props.selectsRange, startDate: r.props.startDate, endDate: r.props.endDate, excludeDates: r.props.excludeDates, excludeDateIntervals: r.props.excludeDateIntervals, filterDate: r.props.filterDate, onClickOutside: r.handleCalendarClickOutside, formatWeekNumber: r.props.formatWeekNumber, highlightDates: r.state.highlightDates, includeDates: r.props.includeDates, includeDateIntervals: r.props.includeDateIntervals, includeTimes: r.props.includeTimes, injectTimes: r.props.injectTimes, inline: r.props.inline, shouldFocusDayInline: r.state.shouldFocusDayInline, peekNextMonth: r.props.peekNextMonth, showMonthDropdown: r.props.showMonthDropdown, showPreviousMonths: r.props.showPreviousMonths, useShortMonthInDropdown: r.props.useShortMonthInDropdown, showMonthYearDropdown: r.props.showMonthYearDropdown, showWeekNumbers: r.props.showWeekNumbers, showYearDropdown: r.props.showYearDropdown, withPortal: r.props.withPortal, forceShowMonthNavigation: r.props.forceShowMonthNavigation, showDisabledMonthNavigation: r.props.showDisabledMonthNavigation, scrollableYearDropdown: r.props.scrollableYearDropdown, scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown, todayButton: r.props.todayButton, weekLabel: r.props.weekLabel, outsideClickIgnoreClass: "react-datepicker-ignore-onclickoutside", fixedHeight: r.props.fixedHeight, monthsShown: r.props.monthsShown, monthSelectedIn: r.state.monthSelectedIn, onDropdownFocus: r.handleDropdownFocus, onMonthChange: r.props.onMonthChange, onYearChange: r.props.onYearChange, dayClassName: r.props.dayClassName, weekDayClassName: r.props.weekDayClassName, monthClassName: r.props.monthClassName, timeClassName: r.props.timeClassName, showTimeSelect: r.props.showTimeSelect, showTimeSelectOnly: r.props.showTimeSelectOnly, onTimeChange: r.handleTimeChange, timeFormat: r.props.timeFormat, timeIntervals: r.props.timeIntervals, minTime: r.props.minTime, maxTime: r.props.maxTime, excludeTimes: r.props.excludeTimes, filterTime: r.props.filterTime, timeCaption: r.props.timeCaption, className: r.props.calendarClassName, container: r.props.calendarContainer, yearItemNumber: r.props.yearItemNumber, yearDropdownItemNumber: r.props.yearDropdownItemNumber, previousMonthAriaLabel: r.props.previousMonthAriaLabel, previousMonthButtonLabel: r.props.previousMonthButtonLabel, nextMonthAriaLabel: r.props.nextMonthAriaLabel, nextMonthButtonLabel: r.props.nextMonthButtonLabel, previousYearAriaLabel: r.props.previousYearAriaLabel, previousYearButtonLabel: r.props.previousYearButtonLabel, nextYearAriaLabel: r.props.nextYearAriaLabel, nextYearButtonLabel: r.props.nextYearButtonLabel, timeInputLabel: r.props.timeInputLabel, disabledKeyboardNavigation: r.props.disabledKeyboardNavigation, renderCustomHeader: r.props.renderCustomHeader, popperProps: r.props.popperProps, renderDayContents: r.props.renderDayContents, onDayMouseEnter: r.props.onDayMouseEnter, onMonthMouseLeave: r.props.onMonthMouseLeave, selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange, showTimeInput: r.props.showTimeInput, showMonthYearPicker: r.props.showMonthYearPicker, showFullMonthYearPicker: r.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: r.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: r.props.showFourColumnMonthYearPicker, showYearPicker: r.props.showYearPicker, showQuarterYearPicker: r.props.showQuarterYearPicker, showPopperArrow: r.props.showPopperArrow, excludeScrollbar: r.props.excludeScrollbar, handleOnKeyDown: r.props.onKeyDown, handleOnDayKeyDown: r.onDayKeyDown, isInputFocused: r.state.focused, customTimeInput: r.props.customTimeInput, setPreSelection: r.setPreSelection }, r.props.children) : null;
    }), A(z(r), "renderAriaLiveRegion", function() {
      var a, i = r.props, s = i.dateFormat, l = i.locale, u = r.props.showTimeInput || r.props.showTimeSelect ? "PPPPp" : "PPPP";
      return a = r.props.selectsRange ? "Selected start date: ".concat(eo(r.props.startDate, { dateFormat: u, locale: l }), ". ").concat(r.props.endDate ? "End date: " + eo(r.props.endDate, { dateFormat: u, locale: l }) : "") : r.props.showTimeSelectOnly ? "Selected time: ".concat(eo(r.props.selected, { dateFormat: s, locale: l })) : r.props.showYearPicker ? "Selected year: ".concat(eo(r.props.selected, { dateFormat: "yyyy", locale: l })) : r.props.showMonthYearPicker ? "Selected month: ".concat(eo(r.props.selected, { dateFormat: "MMMM yyyy", locale: l })) : r.props.showQuarterYearPicker ? "Selected quarter: ".concat(eo(r.props.selected, { dateFormat: "yyyy, QQQ", locale: l })) : "Selected date: ".concat(eo(r.props.selected, { dateFormat: u, locale: l })), y.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, r.state.isRenderAriaLiveMessage && a);
    }), A(z(r), "renderDateInput", function() {
      var a, i = gn(r.props.className, A({}, "react-datepicker-ignore-onclickoutside", r.state.open)), s = r.props.customInput || y.createElement("input", { type: "text" }), l = r.props.customInputRef || "ref", u = typeof r.props.value == "string" ? r.props.value : typeof r.state.inputValue == "string" ? r.state.inputValue : r.props.selectsRange ? function(c, p, h) {
        if (!c)
          return "";
        var O = eo(c, h), C = p ? eo(p, h) : "";
        return "".concat(O, " - ").concat(C);
      }(r.props.startDate, r.props.endDate, r.props) : eo(r.props.selected, r.props);
      return y.cloneElement(s, (A(a = {}, l, function(c) {
        r.input = c;
      }), A(a, "value", u), A(a, "onBlur", r.handleBlur), A(a, "onChange", r.handleChange), A(a, "onClick", r.onInputClick), A(a, "onFocus", r.handleFocus), A(a, "onKeyDown", r.onInputKeyDown), A(a, "id", r.props.id), A(a, "name", r.props.name), A(a, "form", r.props.form), A(a, "autoFocus", r.props.autoFocus), A(a, "placeholder", r.props.placeholderText), A(a, "disabled", r.props.disabled), A(a, "autoComplete", r.props.autoComplete), A(a, "className", gn(s.props.className, i)), A(a, "title", r.props.title), A(a, "readOnly", r.props.readOnly), A(a, "required", r.props.required), A(a, "tabIndex", r.props.tabIndex), A(a, "aria-describedby", r.props.ariaDescribedBy), A(a, "aria-invalid", r.props.ariaInvalid), A(a, "aria-labelledby", r.props.ariaLabelledBy), A(a, "aria-required", r.props.ariaRequired), a));
    }), A(z(r), "renderClearButton", function() {
      var a = r.props, i = a.isClearable, s = a.selected, l = a.startDate, u = a.endDate, c = a.clearButtonTitle, p = a.clearButtonClassName, h = p === void 0 ? "" : p, O = a.ariaLabelClose, C = O === void 0 ? "Close" : O;
      return !i || s == null && l == null && u == null ? null : y.createElement("button", { type: "button", className: "react-datepicker__close-icon ".concat(h).trim(), "aria-label": C, onClick: r.onClearClick, title: c, tabIndex: -1 });
    }), r.state = r.calcInitialState(), r;
  }
  return Vr(o, [{ key: "componentDidMount", value: function() {
    window.addEventListener("scroll", this.onScroll, !0);
  } }, { key: "componentDidUpdate", value: function(t, r) {
    var a, i;
    t.inline && (a = t.selected, i = this.props.selected, a && i ? en(a) !== en(i) || Wt(a) !== Wt(i) : a !== i) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && t.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), t.highlightDates !== this.props.highlightDates && this.setState({ highlightDates: sh(this.props.highlightDates) }), r.focused || Ao(t.selected, this.props.selected) || this.setState({ inputValue: null }), r.open !== this.state.open && (r.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), r.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
  } }, { key: "componentWillUnmount", value: function() {
    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
  } }, { key: "renderInputContainer", value: function() {
    var t = this.props.showIcon;
    return y.createElement("div", { className: "react-datepicker__input-container ".concat(t ? "react-datepicker__view-calendar-icon" : "") }, t && y.createElement("svg", { className: "react-datepicker__calendar-icon", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512" }, y.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" })), this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
  } }, { key: "render", value: function() {
    var t = this.renderCalendar();
    if (this.props.inline)
      return t;
    if (this.props.withPortal) {
      var r = this.state.open ? y.createElement(tb, { enableTabLoop: this.props.enableTabLoop }, y.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, t)) : null;
      return this.state.open && this.props.portalId && (r = y.createElement(eb, { portalId: this.props.portalId, portalHost: this.props.portalHost }, r)), y.createElement("div", null, this.renderInputContainer(), r);
    }
    return y.createElement(Vj, { className: this.props.popperClassName, wrapperClassName: this.props.wrapperClassName, hidePopper: !this.isCalendarOpen(), portalId: this.props.portalId, portalHost: this.props.portalHost, popperModifiers: this.props.popperModifiers, targetComponent: this.renderInputContainer(), popperContainer: this.props.popperContainer, popperComponent: t, popperPlacement: this.props.popperPlacement, popperProps: this.props.popperProps, popperOnKeyDown: this.onPopperKeyDown, enableTabLoop: this.props.enableTabLoop });
  } }], [{ key: "defaultProps", get: function() {
    return { allowSameDay: !1, dateFormat: "MM/dd/yyyy", dateFormatCalendar: "LLLL yyyy", onChange: function() {
    }, disabled: !1, disabledKeyboardNavigation: !1, dropdownMode: "scroll", onFocus: function() {
    }, onBlur: function() {
    }, onKeyDown: function() {
    }, onInputClick: function() {
    }, onSelect: function() {
    }, onClickOutside: function() {
    }, onMonthChange: function() {
    }, onCalendarOpen: function() {
    }, onCalendarClose: function() {
    }, preventOpenOnFocus: !1, onYearChange: function() {
    }, onInputError: function() {
    }, monthsShown: 1, readOnly: !1, withPortal: !1, selectsDisabledDaysInRange: !1, shouldCloseOnSelect: !0, showTimeSelect: !1, showTimeInput: !1, showPreviousMonths: !1, showMonthYearPicker: !1, showFullMonthYearPicker: !1, showTwoColumnMonthYearPicker: !1, showFourColumnMonthYearPicker: !1, showYearPicker: !1, showQuarterYearPicker: !1, strictParsing: !1, timeIntervals: 30, timeCaption: "Time", previousMonthAriaLabel: "Previous Month", previousMonthButtonLabel: "Previous Month", nextMonthAriaLabel: "Next Month", nextMonthButtonLabel: "Next Month", previousYearAriaLabel: "Previous Year", previousYearButtonLabel: "Previous Year", nextYearAriaLabel: "Next Year", nextYearButtonLabel: "Next Year", timeInputLabel: "Time", enableTabLoop: !0, yearItemNumber: 12, renderDayContents: function(t) {
      return t;
    }, focusSelectedMonth: !1, showPopperArrow: !0, excludeScrollbar: !0, customTimeInput: null, calendarStartDay: void 0 };
  } }]), o;
}(), Kj = "input", Uu = "navigate";
const rb = (e) => {
  const [n, o] = ur(
    void 0
  ), [t] = A0(
    (r) => {
      const a = r[0];
      o(
        a.target.getAttribute(e) || void 0
      );
    },
    {
      attributeFilter: [e]
    }
  );
  return { attributeValue: n, attributeRef: t };
}, ch = "--/--/----", MM = ({
  startDate: e,
  endDate: n,
  onChange: o,
  placeholder: t,
  trackingId: r,
  minDate: a,
  maxDate: i,
  label: s,
  helpIconProps: l,
  isLabelHidden: u = !1,
  isDisabled: c = !1,
  aliases: p,
  shouldAlignMenuToTargetWidth: h = !1
}) => {
  const [[O, C], P] = ur([
    e,
    n
  ]);
  Nt(() => {
    P([e, n]);
  }, [e, n]);
  const { floatingRefCallback: k, referenceRefCallback: $, floatingPlacementStyles: I } = Li({
    shouldAlignMenuToTargetWidth: h,
    // Every time the menu is toggled, reset internal dates so that
    // the input label is accurate if "Clear" or "Apply" weren't pressed.
    onMenuToggle: () => P([e, n])
  }), H = `${(O == null ? void 0 : O.toLocaleDateString()) ?? ch} - ${(C == null ? void 0 : C.toLocaleDateString()) ?? ch}`, x = at(() => /* @__PURE__ */ new Date(), []), _ = (U) => {
    const ee = U.replaceAll(/\s/g, "-");
    return `${r}-${ee.toLocaleLowerCase()}`;
  }, F = at(
    () => zT({ now: x, trackingId: r }),
    [x, r]
  ), G = It(
    ([U, ee]) => {
      P([
        U ? Un(U) : void 0,
        ee ? by(ee, x) ? x : il(ee) : void 0
      ]);
    },
    [x]
  ), { attributeRef: Q, attributeValue: V } = rb("id"), ie = qs(Q, k), ce = {
    isLabelHidden: u,
    label: s,
    helpIconProps: l,
    trackingId: r
  }, me = (p ?? F).map((U) => /* @__PURE__ */ g.jsx(
    Xj,
    {
      label: U.label,
      variant: "anchor-primary",
      onClick: () => {
        P([U.startDate, U.endDate]);
      },
      trackingId: U.trackingId ?? _(U.label)
    },
    U.label
  )), ve = me.length > 0;
  return /* @__PURE__ */ g.jsx(fa, { ...ce, htmlFor: V, children: /* @__PURE__ */ g.jsxs(gi, { as: Or, children: [
    /* @__PURE__ */ g.jsxs(
      gi.Button,
      {
        as: Zj,
        ref: $,
        disabled: c,
        trackingId: `${r}-toggle-button`,
        children: [
          /* @__PURE__ */ g.jsx(vo, { children: O || C ? H : t }),
          /* @__PURE__ */ g.jsx(Lr, { name: "calendar" })
        ]
      }
    ),
    /* @__PURE__ */ g.jsxs(
      gi.Panel,
      {
        as: e2,
        ref: ie,
        style: I,
        children: [
          /* @__PURE__ */ g.jsxs(
            Be,
            {
              alignItems: "center",
              justifyContent: "space-around",
              padding: ve ? void 0 : "l",
              children: [
                ve && /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
                  /* @__PURE__ */ g.jsx(
                    Be,
                    {
                      direction: "column",
                      alignItems: "center",
                      gap: "l",
                      padding: "none l",
                      children: me
                    }
                  ),
                  /* @__PURE__ */ g.jsx(Qj, { direction: "vertical" })
                ] }),
                /* @__PURE__ */ g.jsx(Jj, { children: /* @__PURE__ */ g.jsx(
                  qj,
                  {
                    onChange: G,
                    selectsRange: !0,
                    startDate: O,
                    endDate: C,
                    showMonthDropdown: !0,
                    showYearDropdown: !0,
                    dropdownMode: "select",
                    useShortMonthInDropdown: !0,
                    inline: !0,
                    fixedHeight: !0,
                    minDate: a,
                    maxDate: i
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ g.jsx(Bn, {}),
          /* @__PURE__ */ g.jsxs(Be, { justifyContent: "flex-end", gap: "s", padding: "m l", children: [
            /* @__PURE__ */ g.jsx(
              gi.Button,
              {
                as: La,
                trackingId: `${r}-secondary-button`,
                variant: "button-secondary",
                label: "Clear",
                onClick: () => o([void 0, void 0]),
                isDisabled: !(e || n || O || C)
              }
            ),
            /* @__PURE__ */ g.jsx(
              gi.Button,
              {
                as: La,
                trackingId: `${r}-primary-button`,
                label: "Apply",
                onClick: () => o([O, C]),
                isDisabled: e === O && n === C
              }
            )
          ] })
        ]
      }
    )
  ] }) });
}, Qj = Y(Bn)(
  ({ theme: e }) => `
  height: ${e.measure.l};
`
), Xj = Y(La)(
  ({ theme: e }) => `
  width: ${e.measure.xxs};
  text-align: center;
`
), Jj = Y.div(
  ({ theme: e }) => `
  .react-datepicker {
    font-family: "Roboto", sans-serif;
    font-size: ${e.fontSize.s};
    border: none; 
  }

  .react-datepicker__month-container {
    float: none;
  }

  .react-datepicker__header {
    background-color: ${e.color.white};
    padding: ${e.spacing.m} ${e.spacing.m} ${e.spacing.s};
    border-bottom: ${Pn(e)};
  }
  
  .react-datepicker__header__dropdown react-datepicker__header__dropdown--select {
    padding: ${e.spacing.m} ${e.spacing.none} ${e.spacing.none};
  }

  .react-datepicker__day-names {
    padding: ${e.spacing.m} ${e.spacing.none} ${e.spacing.s};
  }

  .react-datepicker__navigation--previous {
    left: ${e.spacing.xs};
    top: ${e.spacing.m};
  }

  .react-datepicker__navigation--next {
    right: ${e.spacing.xs};
    top: ${e.spacing.m};
  }

  .react-datepicker__navigation *::before {
    border-color: ${e.color.black};
  }

  .react-datepicker__day--keyboard-selected{
    background-color: inherit;
    color: inherit;
    border-radius: ${e.borderRadius.round};
  } 
  
  .react-datepicker__day--selected, 
  .react-datepicker__day--in-selecting-range, 
  .react-datepicker__day--in-range {
    background-color: ${e.color.primary};
    border-radius: ${e.borderRadius.round};
    color: ${e.color.white};
  }

  .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,
  .react-datepicker__month-text--in-range, 
  .react-datepicker__quarter-text--in-range,
  .react-datepicker__year-text--in-range),
  .react-datepicker__day--selected:hover,
  .react-datepicker__day--in-selecting-range:hover,
  .react-datepicker__day--in-range:hover,
  {
    background-color: ${e.color.blue0};
    border-radius: ${e.borderRadius.round};
  }

  .react-datepicker__day:hover {
    background-color: ${e.color.blue0};
    border-radius: ${e.borderRadius.round};
    color: ${e.color.white};
  }

  .react-datepicker__day--today {
    font-weight: ${e.fontWeight.regular};
  }

  .react-datepicker__month {
    margin: ${e.spacing.none};
    padding: ${e.spacing.m};
  }
  
  [class$="-dropdown-container--select"] {
    margin: ${e.spacing.s} ${e.spacing.xxs} ${e.spacing.xxs};
    border: ${Pn(e)};
    border-radius: ${e.borderRadius.s};
  }

  select {
    border: ${e.color.transparent};
  }

  select:focus-visible {
    outline: none;
    ${cn(e)}
  }

`
), Zj = Jr(
  Y.button(
    ({ theme: e }) => `
  ${Yi(e, "none")}
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${e.spacing.l};
  min-width: ${e.measure.xxs};
  padding: ${e.spacing.m};
`
  )
), e2 = Y.div(
  ({ theme: e }) => `
  background-color: ${e.color.white};
  box-shadow: ${e.shadow};
  z-index: ${e.zIndex.popover};
  max-height: ${e.measure.xxl};
  overflow-x: hidden;
  overflow-y: auto;
  border: ${Pn(e)};
  border-radius: ${e.borderRadius.s};
`
), t2 = ({
  primaryButtonProps: e,
  secondaryButtonProps: n
}) => /* @__PURE__ */ g.jsx(r2, { children: /* @__PURE__ */ g.jsxs(
  Be,
  {
    growItems: !0,
    alignItems: "center",
    gap: "s",
    justifyContent: "flex-end",
    padding: "m l",
    children: [
      /* @__PURE__ */ g.jsx(Co, { variant: "button-secondary", ...n }),
      e && /* @__PURE__ */ g.jsx(Co, { ...e })
    ]
  }
) }), r2 = Y.div(
  ({ theme: e }) => `
  box-shadow: ${e.shadow};
`
), n2 = ({
  title: e,
  onClose: n,
  closeButtonTrackingId: o
}) => /* @__PURE__ */ g.jsxs(a2, { children: [
  /* @__PURE__ */ g.jsx(
    Fn,
    {
      iconName: "x",
      size: "large",
      label: "Back",
      onClick: n,
      trackingId: o
    }
  ),
  /* @__PURE__ */ g.jsx(Lo.Title, { as: o2, children: e })
] }), o2 = Y.h2(
  ({ theme: e }) => `
  ${Nn(e).h4};
`
), a2 = Y.div(
  ({ theme: e }) => `
  box-shadow: ${e.shadow};
  padding: ${e.spacing.m};
  display: grid;
  grid-template-columns: ${cf(e).default.size} 1fr 40px;
  place-items: center;
`
), AM = ({
  isOpen: e,
  onClose: n,
  closeButtonTrackingId: o,
  title: t,
  primaryButtonProps: r,
  secondaryButtonProps: a,
  children: i
}) => /* @__PURE__ */ g.jsxs(Lo, { open: e, onClose: n, children: [
  /* @__PURE__ */ g.jsx(Lo.Overlay, { as: $m }),
  /* @__PURE__ */ g.jsxs(i2, { children: [
    /* @__PURE__ */ g.jsx(
      n2,
      {
        title: t,
        onClose: n,
        closeButtonTrackingId: o
      }
    ),
    /* @__PURE__ */ g.jsx(Lo.Description, { as: s2, children: i }),
    /* @__PURE__ */ g.jsx(
      t2,
      {
        primaryButtonProps: r,
        secondaryButtonProps: a
      }
    )
  ] })
] }), i2 = Y.div(
  ({ theme: e }) => `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: ${e.zIndex.modal};
  width: ${e.measure.xl};
  box-shadow: ${e.shadow};
  background-color: ${e.color.white};
  display: grid;
  grid-template-rows: min-content 1fr min-content;

  ${Ho(e, "mobile")} {
    width: 100%;
  }
`
), s2 = Y.div(
  ({ theme: e }) => `
  overflow-y: auto;
  padding: ${e.spacing.m} ${e.spacing.m} ${e.spacing.l} ${e.spacing.m};
`
), l2 = (e) => Array.isArray(e), nb = ({
  errorMessage: e,
  getIsOptionDisabled: n,
  getOptionKey: o,
  getOptionLabel: t,
  helpIconProps: r,
  isDisabled: a = !1,
  isLabelHidden: i = !1,
  isLoading: s = !1,
  label: l,
  minWidth: u = "xxs",
  onChange: c,
  options: p,
  placeholder: h,
  shouldAlignMenuToTargetWidth: O = !1,
  size: C = "default",
  targetButtonProps: P,
  trackingId: k,
  validationState: $ = "none",
  value: I,
  maxMenuWidth: H,
  getOptionDescription: x,
  targetButtonRef: _
}) => {
  const { floatingRefCallback: F, referenceRefCallback: G, floatingPlacementStyles: Q } = Li({ shouldAlignMenuToTargetWidth: O, maxMenuWidth: H }), V = It(
    (ge) => /* @__PURE__ */ g.jsx("ul", { children: ge.map((be) => {
      const he = o(be);
      return /* @__PURE__ */ g.jsx(
        Tn.Option,
        {
          value: be,
          disabled: n == null ? void 0 : n(be),
          as: Or,
          children: ({ active: K, selected: le, disabled: Pe }) => /* @__PURE__ */ g.jsxs(
            p2,
            {
              isActive: K,
              isDisabled: Pe,
              trackingId: `${k}-${he}`,
              children: [
                /* @__PURE__ */ g.jsxs(Be, { direction: "column", gap: "xs", children: [
                  t(be),
                  x && /* @__PURE__ */ g.jsx(un, { colorVariant: "secondary", children: x(be) })
                ] }),
                le ? /* @__PURE__ */ g.jsx(oy, { name: "check" }) : /* @__PURE__ */ g.jsx(f2, {})
              ]
            }
          )
        },
        he
      );
    }) }),
    [
      o,
      n,
      k,
      t,
      x
    ]
  ), ie = at(() => {
    if (l2(p))
      return V(p);
    {
      const ge = Object.entries(p);
      return ge.map(([be, he], K) => /* @__PURE__ */ g.jsxs(Or, { children: [
        /* @__PURE__ */ g.jsx(v2, { colorVariant: "secondary", children: be }),
        V(he),
        K !== ge.length - 1 && /* @__PURE__ */ g.jsx(Be, { padding: "s m", children: /* @__PURE__ */ g.jsx(Bn, {}) })
      ] }, be));
    }
  }, [p, V]), ce = Ba(), me = $ === "error", ve = me && e, U = {
    as: c2,
    disabled: a || s,
    isShowingPlaceholder: !I,
    minWidth: u,
    trackingId: k,
    validationState: $,
    size: C,
    children: /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
      /* @__PURE__ */ g.jsx(vo, { shouldTruncate: !0, children: I ? t(I) : h ?? /* @__PURE__ */ g.jsx(u2, {}) }),
      s ? /* @__PURE__ */ g.jsx(kl, {}) : /* @__PURE__ */ g.jsx(Lr, { name: "chevron-down" })
    ] })
  }, ee = {
    isLabelHidden: i,
    label: l,
    helpIconProps: r,
    trackingId: k
  }, oe = qs(
    G,
    _
  );
  return /* @__PURE__ */ g.jsx(
    Tn,
    {
      value: I,
      onChange: c,
      disabled: a || s,
      children: ({ open: ge }) => /* @__PURE__ */ g.jsxs(fa, { LabelElement: Tn.Label, ...ee, children: [
        /* @__PURE__ */ g.jsx(
          Tn.Button,
          {
            "aria-describedby": ve ? ce : void 0,
            "aria-invalid": me,
            isDropdownOpen: ge,
            ref: oe,
            ...P ?? U
          }
        ),
        /* @__PURE__ */ g.jsx(
          Tn.Options,
          {
            as: d2,
            ref: F,
            style: Q,
            children: ie
          }
        ),
        ve && /* @__PURE__ */ g.jsx(
          un,
          {
            colorVariant: "danger",
            id: ce,
            trackingId: `${k}-error`,
            children: e
          }
        )
      ] })
    }
  );
}, u2 = Y.div`
  visibility: hidden;
`, c2 = Jr(
  Y.button.withConfig({
    shouldForwardProp: (e) => ![
      "validationState",
      "isShowingPlaceholder",
      "isDropdownOpen",
      "size",
      "minWidth"
    ].includes(e)
  })(
    ({
      theme: e,
      validationState: n,
      isShowingPlaceholder: o,
      isDropdownOpen: t,
      size: r,
      minWidth: a
    }) => `

      ${Yi(e, n)}

      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: ${e.spacing.m};
      min-width: ${e.measure[a]};
      padding: ${e.spacing.m};
      height: ${r === "default" ? e.sizing.m : e.sizing.s};

      // Show the button in its enabled state when the menu is open to reduce distraction.
      ${t ? Ef(e) : ""}

      color: ${o ? e.color.textSecondary : e.color.textPrimary};
    `
  )
), d2 = Y.div(Zd), p2 = Jr(
  Y.li.withConfig({
    shouldForwardProp: (e) => !["isActive", "isDisabled"].includes(e)
  })(ep)
), f2 = Y.div(
  ({ theme: e }) => `
  width: ${co(e)};
  height: ${co(e)};
  flex-shrink: 0;
`
), v2 = Y(zi)(
  ({ theme: e }) => `
  padding: ${e.spacing.m};
`
), g2 = ({
  entity: e = "data",
  shouldIncludeAvatar: n = !0,
  iconName: o
}) => {
  const t = {
    iconName: o ?? "file",
    variant: "secondary"
  }, r = {
    title: "No results",
    subtitleElement: `No ${e} on file.`,
    ...n ? { avatarProps: t } : {}
  };
  return /* @__PURE__ */ g.jsx(Zi, { ...r });
}, FM = (e) => /* @__PURE__ */ g.jsx(Be, { justifyContent: "center", padding: "contentPadding", children: /* @__PURE__ */ g.jsx(g2, { ...e }) }), h2 = {
  variant: "danger",
  iconName: "alert-triangle"
}, m2 = ({
  entity: e = "data",
  shouldIncludeAvatar: n = !0
} = {}) => ({
  title: `Could not load ${e}`,
  subtitleElement: "Refresh the page to try again or come back later.",
  ...n ? { avatarProps: h2 } : {}
}), y2 = (e) => /* @__PURE__ */ g.jsx(Zi, { ...m2(e) }), LM = (e) => /* @__PURE__ */ g.jsx(Be, { justifyContent: "center", padding: "contentPadding", children: /* @__PURE__ */ g.jsx(y2, { ...e }) }), NM = (e) => /* @__PURE__ */ g.jsx(Be, { justifyContent: "center", padding: "contentPadding", children: /* @__PURE__ */ g.jsx(Kf, { ...e }) }), BM = (e) => /* @__PURE__ */ g.jsx(Be, { justifyContent: "center", padding: "contentPadding", children: /* @__PURE__ */ g.jsx(Zi, { ...e }) }), ob = (e) => /* @__PURE__ */ g.jsx(b2, { children: /* @__PURE__ */ g.jsx(w2, { ...e }) }), b2 = Y.div`
  /* position: fixed doesn't work with z-index strategy */
  position: absolute;
  top: 0;
  left: 0;
  /* use flex (not grid) because it allows padding below the modal to show when scrolled to bottom */
  display: flex;
  overflow-y: auto;
  padding: ${({ theme: e }) => e.spacing.l};
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`, w2 = Y(Pf)(
  ({ theme: e }) => `
  z-index: ${e.zIndex.modal};
  /* Ensure modal fills parent width */
  flex: 1;
  max-width: ${e.measure.xxl};
  min-height: 200px;
  max-height: 100vh;
`
), ab = Y.div(
  ({ theme: e }) => `
  padding: ${e.spacing.l};  
`
), ib = ({
  primaryButtonProps: e,
  secondaryButtonProps: n,
  tertiaryButtonProps: o
}) => /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
  /* @__PURE__ */ g.jsx(Bn, {}),
  /* @__PURE__ */ g.jsxs(
    Be,
    {
      alignItems: "center",
      justifyContent: o ? "space-between" : "flex-end",
      padding: "m l",
      children: [
        o && /* @__PURE__ */ g.jsx(Co, { variant: "button-secondary", ...o }),
        /* @__PURE__ */ g.jsxs(Be, { gap: "s", children: [
          n && /* @__PURE__ */ g.jsx(Co, { variant: "button-secondary", ...n }),
          /* @__PURE__ */ g.jsx(Co, { ...e })
        ] })
      ]
    }
  )
] }), sb = ({
  title: e,
  onClose: n,
  closeButtonTrackingId: o
}) => {
  const t = n && o;
  return /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
    /* @__PURE__ */ g.jsxs(
      Be,
      {
        alignItems: "center",
        justifyContent: "space-between",
        padding: "l l m l",
        children: [
          t ? /* @__PURE__ */ g.jsx(Lo.Title, { as: dh, children: e }) : /* @__PURE__ */ g.jsx(dh, { children: e }),
          t && /* @__PURE__ */ g.jsx(
            Fn,
            {
              iconName: "x",
              onClick: n,
              trackingId: o
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ g.jsx(Bn, {})
  ] });
}, dh = Y.h2(
  ({ theme: e }) => `
  ${Nn(e).h4};
`
), WM = ({
  children: e,
  closeButtonTrackingId: n,
  isOpen: o,
  onClose: t,
  title: r,
  ...a
}) => {
  const i = a.primaryButtonProps ? /* @__PURE__ */ g.jsx(ib, { ...a }) : void 0;
  return /* @__PURE__ */ g.jsxs(Lo, { open: o, onClose: t, children: [
    /* @__PURE__ */ g.jsx(Lo.Overlay, { as: $m }),
    /* @__PURE__ */ g.jsxs(ob, { children: [
      /* @__PURE__ */ g.jsx(
        sb,
        {
          title: r,
          onClose: t,
          closeButtonTrackingId: n
        }
      ),
      /* @__PURE__ */ g.jsx(Lo.Description, { as: ab, children: e }),
      i
    ] })
  ] });
}, zM = ({
  title: e,
  primaryButtonProps: n,
  secondaryButtonProps: o,
  children: t
}) => /* @__PURE__ */ g.jsxs(ob, { children: [
  e && /* @__PURE__ */ g.jsx(sb, { title: e }),
  /* @__PURE__ */ g.jsx(ab, { children: t }),
  n && /* @__PURE__ */ g.jsx(
    ib,
    {
      primaryButtonProps: n,
      secondaryButtonProps: o
    }
  )
] }), x2 = Y(Be).attrs({
  gap: "s",
  wrap: "wrap"
})``, C2 = ({
  getOptionKey: e,
  getOptionLabel: n,
  isDisabled: o,
  onChange: t,
  trackingId: r,
  values: a
}) => {
  const i = It(
    (s) => {
      const l = a.filter((u) => u !== s);
      t(l);
    },
    [t, a]
  );
  return /* @__PURE__ */ g.jsx(x2, { children: a.map((s) => {
    const l = e(s);
    return /* @__PURE__ */ g.jsx(
      e$,
      {
        label: n(s),
        isDisabled: o,
        removeButtonProps: {
          onClick: () => i(s)
        },
        trackingId: `${r}-chip-${l}`
      },
      l
    );
  }) });
}, jn = (e) => e === void 0, Ad = (e) => e.length > 0 && !!e[0].data, HM = (e) => !Ad(e), YM = ({
  getButtonLabel: e = (H) => `${H.length} selected`,
  getOptionKey: n,
  getOptionLabel: o,
  getOptionUtilityElement: t,
  helpIconProps: r,
  isDisabled: a = !1,
  isLabelHidden: i = !1,
  isLoading: s = !1,
  label: l,
  onChange: u,
  options: c,
  placeholder: p,
  searchBarProps: h,
  shouldAlignMenuToTargetWidth: O = !1,
  shouldShowChips: C = !1,
  targetButtonRef: P,
  trackingId: k,
  validationState: $ = "none",
  values: I
}) => {
  const { floatingRefCallback: H, referenceRefCallback: x, floatingPlacementStyles: _ } = Li({ shouldAlignMenuToTargetWidth: O }), F = It(
    (fe, ke) => n(fe) === n(ke),
    [n]
  ), G = It(
    (fe, ke) => n(fe) === ke,
    [n]
  ), Q = It(
    (fe, ke) => fe.length > 0 && fe.every(
      (re) => ke.some((tt) => F(tt, re))
    ),
    [F]
  ), { attributeValue: V, attributeRef: ie } = rb(
    "aria-activedescendant"
  ), ce = St(null), me = qs(ie, H), ve = Ba(), U = It(
    (fe, ke) => {
      let re = [];
      if (fe) {
        const tt = c.find(
          (et) => G(et, ke)
        );
        re = tt ? [...I, tt] : I;
      } else
        I && (re = I.filter((tt) => !G(tt, ke)));
      u(re);
    },
    [I, u, c, G]
  ), ee = It(
    (fe, ke) => {
      let re = [];
      const tt = c.find(({ data: Kt }) => G(Kt, ke));
      if (jn(tt))
        return;
      const { data: et, children: Dt } = tt;
      fe ? et && Dt.length === 0 ? re = [...I, et] : Dt.length > 0 && (re = [.../* @__PURE__ */ new Set([...I, ...Dt])]) : Dt.length === 0 && et ? re = I.filter((Kt) => !F(Kt, et)) ?? [] : re = I.filter(
        (Kt) => !Dt.some((fr) => F(fr, Kt))
      ), u(re);
    },
    [I, u, c, G, F]
  ), oe = It(
    (fe, ke) => {
      let re = [];
      const et = c.flatMap(
        ({ children: Dt }) => Dt
      ).find(
        (Dt) => G(Dt, ke)
      );
      fe ? re = et ? [...I, et] : I : re = I.filter((Dt) => !G(Dt, ke)), u(re);
    },
    [I, u, c, G]
  ), ge = It(
    (fe) => fe.map((ke) => {
      const re = n(ke);
      return /* @__PURE__ */ g.jsx(Tn.Option, { value: ke, as: Or, children: ({ active: tt, selected: et, disabled: Dt }) => /* @__PURE__ */ g.jsxs(
        qu,
        {
          isActive: tt,
          isDisabled: Dt,
          isIndented: !1,
          children: [
            /* @__PURE__ */ g.jsx(
              Ei,
              {
                isChecked: !!et,
                onChange: (Kt) => {
                  U(Kt, re);
                },
                label: o(ke),
                trackingId: `select-${n(ke)}-checkbox`,
                shouldTruncateLabel: !0
              }
            ),
            t == null ? void 0 : t(ke)
          ]
        }
      ) }, re);
    }),
    [
      U,
      n,
      o,
      t
    ]
  ), be = It(
    (fe) => {
      const ke = c.find(({ data: et }) => G(et, fe));
      if (jn(ke))
        return !1;
      const { data: re, children: tt } = ke;
      return tt.length === 0 && I.some((et) => F(et, re)) ? !0 : !!Q(tt, I);
    },
    [
      I,
      c,
      G,
      F,
      Q
    ]
  ), he = It(
    (fe) => {
      const ke = c.find(({ data: et }) => G(et, fe));
      if (jn(ke))
        return !1;
      const { children: re } = ke, tt = re.map(
        (et) => I.some((Dt) => F(Dt, et))
      );
      return !tt.every((et) => et === tt[0]);
    },
    [I, c, G, F]
  ), K = It(
    (fe) => fe.map(({ data: ke, children: re }) => {
      const tt = n(ke), et = /* @__PURE__ */ g.jsx(Tn.Option, { value: ke, as: Or, children: ({ active: Kt, disabled: fr }) => /* @__PURE__ */ g.jsxs(
        qu,
        {
          isActive: Kt,
          isDisabled: fr,
          isIndented: !1,
          children: [
            /* @__PURE__ */ g.jsx(
              Ei,
              {
                isChecked: be(tt),
                isIndeterminate: he(tt),
                onChange: (Ir) => {
                  ee(Ir, tt);
                },
                label: o(ke),
                trackingId: `select-${n(ke)}-checkbox`,
                shouldTruncateLabel: !0
              }
            ),
            t == null ? void 0 : t(ke)
          ]
        }
      ) }, tt), Dt = re.map((Kt) => {
        const fr = n(Kt);
        return /* @__PURE__ */ g.jsx(Tn.Option, { value: Kt, as: Or, children: ({ active: Ir, selected: jr, disabled: Pr }) => /* @__PURE__ */ g.jsxs(
          qu,
          {
            isActive: Ir,
            isDisabled: Pr,
            isIndented: !0,
            children: [
              /* @__PURE__ */ g.jsx(
                Ei,
                {
                  isChecked: !!jr,
                  onChange: (Nr) => {
                    oe(Nr, fr);
                  },
                  label: o(Kt),
                  trackingId: `select-${n(Kt)}-checkbox`,
                  shouldTruncateLabel: !0
                }
              ),
              t == null ? void 0 : t(Kt)
            ]
          }
        ) }, fr);
      });
      return [et, ...Dt];
    }),
    [
      n,
      be,
      he,
      o,
      t,
      ee,
      oe
    ]
  ), le = at(() => Ad(c) ? K(c) : ge(c), [c, K, ge]), Pe = It(
    (fe, { data: ke, children: re }) => {
      let tt = [];
      return Q(re, fe) ? tt = fe.filter(
        (et) => !re.some((Dt) => F(Dt, et))
      ) : tt = [.../* @__PURE__ */ new Set([...fe, ...re])], tt.filter((et) => !F(et, ke));
    },
    [Q, F]
  ), lt = It(
    (fe) => {
      let ke = [...fe];
      const re = fe.length > I.length ? fe.find(
        (tt) => !I.some(
          (et) => F(et, tt)
        )
      ) : I.find(
        (tt) => !fe.some(
          (et) => F(et, tt)
        )
      );
      if (!jn(re)) {
        if (Ad(c) && c.flatMap(({ data: et }) => et).some(
          (et) => F(et, re)
        )) {
          const et = c.find(({ data: Dt }) => F(Dt, re));
          if (jn(et))
            return;
          et.children.length > 0 && (ke = Pe(ke, et));
        }
        u(ke);
      }
    },
    [
      c,
      u,
      I,
      F,
      Pe
    ]
  ), Ge = {
    isLabelHidden: i,
    label: l,
    helpIconProps: r,
    trackingId: k
  }, ut = {
    getOptionKey: n,
    getOptionLabel: o,
    isDisabled: a,
    onChange: u,
    trackingId: k,
    values: I
  }, ze = c.length === 0 && !(h != null && h.value), Ze = (() => I.length > 0 && e ? e(I) : p ? /* @__PURE__ */ g.jsx(vo, { colorVariant: "secondary", children: p }) : /* @__PURE__ */ g.jsx(O2, {}))(), _e = qs(
    x,
    P
  ), De = /* @__PURE__ */ g.jsx(
    Tn,
    {
      value: I,
      onChange: lt,
      multiple: !0,
      disabled: a || s || ze,
      by: F,
      children: ({ open: fe }) => /* @__PURE__ */ g.jsxs(fa, { LabelElement: Tn.Label, ...Ge, children: [
        /* @__PURE__ */ g.jsxs(
          Tn.Button,
          {
            as: P2,
            isMultiselectOpen: fe,
            isShowingPlaceholder: !I,
            ref: _e,
            trackingId: k,
            validationState: $,
            disabled: s,
            children: [
              Ze,
              s ? /* @__PURE__ */ g.jsx(kl, {}) : /* @__PURE__ */ g.jsx(Lr, { name: "chevron-down" })
            ]
          }
        ),
        /* @__PURE__ */ g.jsx(
          Tn.Options,
          {
            as: E2,
            style: _,
            ref: me,
            onFocus: () => {
              var ke;
              return (ke = ce.current) == null ? void 0 : ke.focus();
            },
            children: /* @__PURE__ */ g.jsxs(Be, { direction: "column", children: [
              h && /* @__PURE__ */ g.jsx(
                S2,
                {
                  trackingId: `search-input-${k}`,
                  inputRef: ce,
                  "aria-activedescendant": V,
                  "aria-controls": ve,
                  onClick: (ke) => ke.stopPropagation(),
                  onKeyDown: (ke) => ke.key === " " && ke.stopPropagation(),
                  isLabelHidden: !0,
                  label: "Search",
                  ...h
                }
              ),
              le.length === 0 && h ? /* @__PURE__ */ g.jsx(Kf, { shouldIncludeAvatar: !1 }) : /* @__PURE__ */ g.jsx("ul", { id: ve, children: le })
            ] })
          }
        ),
        C && I.length > 0 && /* @__PURE__ */ g.jsx(C2, { ...ut })
      ] })
    }
  );
  return ze ? /* @__PURE__ */ g.jsx(El, { content: "No options available", target: De }) : De;
}, S2 = Y(zk)(
  ({ theme: e }) => `
    position: sticky;
    z-index: ${e.zIndex.stickyElement};
    top: -${e.spacing.s};
    padding: ${e.spacing.s} ${e.spacing.m} ${e.spacing.m} ${e.spacing.m};
    background-color: ${e.color.white};
  `
), O2 = Y.div`
  visibility: hidden;
`, P2 = Jr(
  Y.button.withConfig({
    shouldForwardProp: (e) => ![
      "validationState",
      "isShowingPlaceholder",
      "isMultiselectOpen"
    ].includes(e)
  })(
    ({ theme: e, validationState: n, isShowingPlaceholder: o, isMultiselectOpen: t }) => `
  ${Yi(e, n)}

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${e.spacing.m};
  min-width: ${e.measure.xxs};
  padding: ${e.spacing.m};

  // Show the button in its enabled state when the menu is open to reduce distraction.
  ${t ? Ef(e) : ""}

  color: ${o ? e.color.textSecondary : e.color.textPrimary};
`
  )
), E2 = Y.div(
  ({ theme: e }) => Zd({ theme: e })
), qu = Y.li.withConfig({
  shouldForwardProp: (e) => !["isActive", "isDisabled", "isIndented"].includes(e)
})(ep), lv = (e) => (
  // Child = 12px top/bottom padding + 21px line height of body-small text
  // Parent = 12px top/bottom padding + 24px line height of body text
  e ? "calc(12px + 21px + 12px)" : "calc(12px + 24px + 12px)"
), uv = Y(Co).withConfig({
  shouldForwardProp: (e) => !["isActive", "isChildActive", "isChild"].includes(e)
}).attrs({
  variant: "invisible"
})(
  ({ theme: e, isActive: n = !1, isChildActive: o = !1, isChild: t = !1 }) => `

  height: ${lv(t)};
  font-size: ${t ? e.fontSize.s : e.fontSize.m};
  border-radius: ${e.borderRadius.s};
  color: ${e.color.textSecondary};
  padding: ${e.spacing.m};
  display: flex;
  align-items: center;
  gap: ${e.spacing.m};
  width: 100%;
  text-align: left;

  &:focus-visible {
    ${cn(e)};
  }

  &:hover {
    background-color: ${Hr(e.color.black, 0.05)};
  }

  &:active {
    background-color: ${Hr(e.color.black, 0.1)};
  }

  ${n || o ? `
      color: ${e.color.primary};
      background-color: ${n ? Hr(e.color.primary, 0.1) : e.color.transparent};
      font-weight: ${e.fontWeight.bold};

      &:hover {
        color: ${e.color.blue3};
        background-color: ${Hr(e.color.primary, 0.2)};
      }

      &:active {
        color: ${e.color.blue4};
        background-color: ${Hr(e.color.primary, 0.25)};
      }
  ` : ""}
`
), lb = () => {
  const [e, n] = ur(!1), [o, t] = ur(!1);
  return {
    handlers: {
      onMouseDown: () => n(!0),
      onMouseUp: () => n(!1),
      onMouseEnter: () => t(!0),
      onMouseLeave: () => t(!1)
    },
    states: {
      isClickablePressed: e,
      isClickableHovered: o
    }
  };
}, ub = pa(
  Y.div.withConfig({
    shouldForwardProp: (e) => !["isClickablePressed", "isClickableHovered", "isActive"].includes(
      e
    )
  })(
    ({ theme: e, isClickablePressed: n, isClickableHovered: o, isActive: t }) => `
  position: absolute;
  background-color: ${(() => t ? n ? e.color.blue4 : o ? e.color.blue3 : e.color.primary : e.color.gray2)()};
`
  )
), k2 = ({
  badgeLabel: e,
  id: n,
  isActive: o,
  renderWrapper: t,
  trackingId: r,
  ...a
}) => {
  const { states: i, handlers: s } = lb(), l = /* @__PURE__ */ g.jsx(
    uv,
    {
      isActive: o,
      "aria-current": o ? "page" : void 0,
      trackingId: r,
      utilityElement: e ? /* @__PURE__ */ g.jsx(Rl, { label: e, variant: "success" }) : void 0,
      ...s,
      ...a
    }
  );
  return /* @__PURE__ */ g.jsxs(R2, { children: [
    o && /* @__PURE__ */ g.jsx(
      $2,
      {
        isActive: !0,
        ...i,
        trackingId: `${r}-active-indicator`
      }
    ),
    t ? t(l) : l
  ] });
}, R2 = Y.li`
  position: relative;
  padding-left: 12px;
  list-style-type: none;
`, $2 = Y(ub)(
  ({ theme: e }) => `
  left: 0;
  top: 0;
  width: 4px;
  height: ${lv(!1)};
  border-top-right-radius: ${e.borderRadius.m};
  border-bottom-right-radius: ${e.borderRadius.m};
`
), D2 = ({
  badgeLabel: e,
  id: n,
  isActive: o,
  renderWrapper: t,
  trackingId: r,
  ...a
}) => {
  const { states: i, handlers: s } = lb(), l = /* @__PURE__ */ g.jsx(
    uv,
    {
      isActive: o,
      "aria-current": o ? "page" : void 0,
      trackingId: r,
      utilityElement: e ? /* @__PURE__ */ g.jsx(Rl, { label: e, variant: "success" }) : void 0,
      isChild: !0,
      ...s,
      ...a
    }
  );
  return /* @__PURE__ */ g.jsxs(T2, { children: [
    /* @__PURE__ */ g.jsx(j2, { isActive: o, ...i }),
    t ? t(l) : l
  ] });
}, T2 = Y.li(
  ({ theme: e }) => `
    position: relative;
    // 24px on left of border, 2px border, 12px on right of border.
    padding-left: calc(${e.spacing.l} + 2px + 12px);
    list-style-type: none;
`
), j2 = Y(ub)(
  ({ theme: e }) => `
  left: ${e.spacing.l};
  top: 0;
  width: 2px;
  height: ${lv(!0)};
`
), _2 = ({
  trackingId: e,
  children: n,
  ...o
}) => {
  const [t, r] = ur(
    // If a child is initialized as selected, start with the parent item open.
    n.some(({ isActive: s }) => s)
  ), a = () => r(!t), i = n.some(({ isActive: s }) => s);
  return /* @__PURE__ */ g.jsxs(I2, { children: [
    /* @__PURE__ */ g.jsx(
      uv,
      {
        trackingId: e,
        onClick: a,
        isChildActive: i,
        utilityElement: /* @__PURE__ */ g.jsx(Lr, { name: t ? "chevron-up" : "chevron-down" }),
        shouldSeparateUtilityElement: !0,
        ...o
      }
    ),
    t && /* @__PURE__ */ g.jsx(M2, { children: n.map((s) => /* @__PURE__ */ g.jsx(D2, { ...s }, s.trackingId)) })
  ] });
}, I2 = Y.li`
  position: relative;
  padding-left: 12px;
  list-style-type: none;
`, M2 = Y.ul`
  padding: 0;
`, A2 = (e) => !!e.children, F2 = ({ items: e }) => /* @__PURE__ */ g.jsx(L2, { children: e.map(
  (n) => A2(n) ? /* @__PURE__ */ g.jsx(_2, { ...n }, n.trackingId) : /* @__PURE__ */ g.jsx(k2, { ...n }, n.trackingId)
) }), L2 = Y.ul`
  padding: 0;
  width: 100%;
`, Ws = (e) => e.toLocaleString("en-US"), N2 = ({
  totalCount: e,
  pageSize: n,
  currentPage: o
}) => {
  const t = e > 0 ? (o - 1) * n + 1 : 0, r = Math.min(o * n, e);
  return /* @__PURE__ */ g.jsxs(un, { children: [
    "Showing ",
    Ws(t),
    "-",
    Ws(r),
    " of ",
    Ws(e)
  ] });
}, B2 = (e, n, o, t) => {
  const r = Array.from({ length: n }, () => 0);
  let a, i = 0;
  return o <= t ? a = r.map((s, l) => l < t || l === t && e === t + 1 ? l + 1 : l === t ? 0 : e) : o > e - t ? a = r.map((s, l) => l === 0 ? l + 1 : l === 1 && e > t + 1 ? 0 : e > t + 2 ? e - t - 1 + l : l + 1) : a = r.map((s, l) => l === 0 ? l + 1 : l === 1 || l === t ? (i -= 1, i) : l + 1 === n ? e : o + l - Math.floor(n / 2)), a;
}, Is = 5, W2 = ({
  totalPages: e,
  currentPage: n,
  setCurrentPage: o,
  trackingId: t,
  isDisabled: r
}) => {
  const a = Math.min(
    e,
    e > Is + 1 ? Is + 2 : Is + 1
  ), i = B2(
    e,
    a,
    n,
    Is
  );
  return /* @__PURE__ */ g.jsxs(Be, { alignItems: "center", gap: "s", children: [
    /* @__PURE__ */ g.jsx(
      Fn,
      {
        trackingId: `${t}-button-left`,
        iconName: "chevron-left",
        isDisabled: n <= 1 || i.length === 0 || r,
        onClick: () => o(n - 1)
      }
    ),
    i.map(
      (s, l) => s <= 0 ? /* @__PURE__ */ g.jsx(un, { children: "..." }, `ellipse-${s.toString()}`) : /* @__PURE__ */ g.jsx(
        z2,
        {
          trackingId: `${t}-button-${s}`,
          label: Ws(s),
          onClick: () => o(s),
          isActive: s === n,
          variant: "invisible",
          isDisabled: r
        },
        `${t}-button-${s}-${l}`
      )
    ),
    /* @__PURE__ */ g.jsx(
      Fn,
      {
        trackingId: `${t}-button-right`,
        iconName: "chevron-right",
        isDisabled: n >= e || i.length === 0 || r,
        onClick: () => o(n + 1)
      }
    )
  ] });
}, z2 = Y(La).withConfig({
  shouldForwardProp: (e) => e !== "isActive"
})(({ theme: e, isActive: n, isDisabled: o }) => {
  const { height: t, horizontalPadding: r, fontSize: a, verticalPadding: i } = Xh(e).small;
  return `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: ${e.borderRadius.s};
    min-height: ${t};
    padding: ${i} ${r};
    font-size: ${a};

    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    
    ${n ? `
          &&, &:active, &:hover {
              color: ${e.color.primary};
              background-color: ${Fr(
    e.color.primary
  )};
          }
        ` : `
        color: ${e.color.black};
        background-color: ${e.color.white};
        border: ${e.borderWidth.s} solid ${e.color.border};

        &:hover {
          background-color: ${e.color.gray1};
          border: ${e.borderWidth.s} solid ${e.color.borderHover};
        }

        &:active {
          background-color: ${e.color.gray3};
          border: ${e.borderWidth.s} solid ${e.color.borderHover};
        }
        `}
    ${o ? `${Rn}` : ""}
`;
}), H2 = [25, 50, 100], Y2 = ({
  pageSize: e,
  setPageSize: n,
  trackingId: o,
  isDisabled: t
}) => /* @__PURE__ */ g.jsxs(Be, { alignItems: "center", gap: "s", children: [
  /* @__PURE__ */ g.jsx(un, { children: "Items per page:" }),
  /* @__PURE__ */ g.jsx(
    nb,
    {
      trackingId: `${o}-per-page-dropdown`,
      options: H2,
      value: e,
      onChange: n,
      getOptionKey: (r) => r.toString(),
      getOptionLabel: (r) => r.toString(),
      minWidth: "xxxs",
      size: "small",
      isDisabled: t
    }
  )
] }), GM = ({
  totalCount: e,
  currentPage: n,
  setCurrentPage: o,
  pageSize: t,
  setPageSize: r,
  trackingId: a,
  isDisabled: i = !1
}) => {
  const s = at(
    () => Math.ceil(e / t),
    [e, t]
  ), l = Uh("mobile"), u = /* @__PURE__ */ g.jsx(
    W2,
    {
      totalPages: s,
      currentPage: n,
      setCurrentPage: o,
      trackingId: a,
      isDisabled: i
    }
  ), c = /* @__PURE__ */ g.jsx(
    N2,
    {
      totalCount: e,
      pageSize: t,
      currentPage: n
    }
  ), p = /* @__PURE__ */ g.jsxs(Be, { direction: "column", alignItems: "center", gap: "l", children: [
    u,
    c
  ] }), h = /* @__PURE__ */ g.jsxs(Be, { alignItems: "center", justifyContent: "center", gap: "l", children: [
    c,
    u
  ] });
  return /* @__PURE__ */ g.jsxs(
    G2,
    {
      padding: "m l",
      justifyContent: r ? "space-between" : "flex-end",
      gap: "l",
      children: [
        r && /* @__PURE__ */ g.jsx(
          Y2,
          {
            pageSize: t,
            setPageSize: r,
            trackingId: a,
            isDisabled: i
          }
        ),
        l ? p : h
      ]
    }
  );
}, G2 = Y(Be)(
  ({ theme: e }) => `
  align-items: center;
  ${Ho(e, "mobile")} {
      flex-direction: column;
      justify-content: center;
      padding: ${e.spacing.m} ${e.spacing.none};
    }
`
), V2 = ({
  isActive: e,
  trackingId: n,
  label: o,
  ...t
}) => /* @__PURE__ */ g.jsx(
  U2,
  {
    isActive: e,
    label: o,
    trackingId: `${n}-item-${o}`,
    variant: "invisible",
    ...t
  }
), U2 = Y(Co).withConfig({
  shouldForwardProp: (e) => e !== "isActive"
})(
  ({ theme: e, isActive: n }) => `
  white-space: nowrap;
  padding: ${e.spacing.m} ${e.spacing.l};
  font-size: ${e.fontSize.m};
  color: ${e.color.textSecondary};

  &[disabled] {
    ${Rn}
  }

  &:focus-visible {
    ${cn(e)};
  }

  ${n ? `
      font-weight: ${e.fontWeight.bold};
      box-shadow: inset 0 -${e.borderRadius.s} 0 ${e.color.primary};

      &:hover {
        background-color: ${e.color.gray0};
      }

      &:active {
        box-shadow: inset 0 -${e.borderRadius.s} 0 ${e.color.blue4};
        background-color: ${e.color.gray1};
      }
    ` : `
      &:hover {
        background-color: ${e.color.gray0};
        box-shadow: inset 0 -${e.borderRadius.s} 0 ${e.color.gray5};
      }

      &:active {
        background-color: ${e.color.gray1};
        box-shadow: inset 0 -${e.borderRadius.s} 0 ${e.color.gray6};
      }
    `}
`
), VM = ({ items: e }) => /* @__PURE__ */ g.jsx(q2, { children: e.map((n) => /* @__PURE__ */ g.jsx(V2, { ...n }, n.trackingId)) }), q2 = Y(Be)`
  overflow: auto;
`, K2 = ({ tooltipProps: e, trackingId: n }) => /* @__PURE__ */ g.jsx(
  El,
  {
    interactiveBorder: 4,
    target: /* @__PURE__ */ g.jsx(Q2, { name: "alert-circle", trackingId: n }),
    touch: !0,
    ...e
  }
), Q2 = Y(Lr)(
  ({ theme: e }) => `
    ${Yo}
    cursor: default;
    
    // Border radius is needed so the focus ring below aligns properly to the edge
    // of the Icon itself rather than the Icon's square viewbox.
    border-radius: ${e.borderRadius.round};
    
    // Safari required height to be set to auto while Chrome defaults to
    // height: auto when in a flexbox element.
    height: auto;
    
    color: ${e.color.danger};
    
    &:hover {
        color: ${e.color.red4};
    }
    
    &:focus-visible {
        ${cn(e)}
    }
`
), X2 = (e) => {
  const n = typeof e == "string" ? e.replace("%", "") : e;
  return (typeof n == "number" || typeof n == "string" && n.trim() !== "") && !Number.isNaN(Number(n));
}, cb = ({
  helpIconProps: e,
  isLoading: n = !1,
  title: o,
  value: t,
  badgeProps: r,
  errorIconProps: a,
  hasError: i = !1
}) => {
  const s = i || jn(t) ? "-" : t;
  return /* @__PURE__ */ g.jsxs(Be, { direction: "column", padding: "m l", gap: "xs", children: [
    /* @__PURE__ */ g.jsxs(J2, { children: [
      /* @__PURE__ */ g.jsx(
        zi,
        {
          colorVariant: "secondary",
          shouldTruncate: !0,
          title: o,
          children: o
        }
      ),
      e && /* @__PURE__ */ g.jsx(Hi, { ...e })
    ] }),
    /* @__PURE__ */ g.jsxs(Be, { alignItems: "center", children: [
      n && /* @__PURE__ */ g.jsx(kl, {}),
      /* @__PURE__ */ g.jsxs(Z2, { isVisible: !n, alignItems: "center", gap: "s", children: [
        /* @__PURE__ */ g.jsx(
          e_,
          {
            shouldTruncate: !0,
            hasError: i,
            title: s,
            forwardedAs: "div",
            children: n ? "$" : s
          }
        ),
        i && a && /* @__PURE__ */ g.jsx(K2, { ...a }),
        r && !i && /* @__PURE__ */ g.jsx(
          Rl,
          {
            ...r,
            variant: X2(r.label) ? Number.parseFloat(r.label) < 0 ? "danger" : "success" : r.variant
          }
        )
      ] })
    ] })
  ] });
}, J2 = Y(Be).attrs({
  gap: "s",
  alignItems: "center"
})(
  ({ theme: e }) => `
  height: ${e.sizing.xxs};
`
), Z2 = Y(Be)(
  ({ isVisible: e }) => `
  visibility: ${e ? "visible" : "hidden"};
`
), e_ = Y(IO).withConfig({
  shouldForwardProp: (e) => e !== "hasError"
})(
  ({ theme: e, hasError: n }) => `
  color: ${n ? e.color.danger : e.color.black} !important;
`
), UM = ({ summaries: e }) => /* @__PURE__ */ g.jsx(t_, { itemsCount: e.length, children: e.map(({ trackingId: n, title: o, value: t, helpIconProps: r }) => /* @__PURE__ */ g.jsx(
  r_,
  {
    itemsCount: e.length,
    direction: "column",
    children: /* @__PURE__ */ g.jsx(Be, { justifyContent: "space-between", children: /* @__PURE__ */ g.jsx(
      cb,
      {
        title: o,
        value: t,
        helpIconProps: r
      }
    ) })
  },
  n
)) }), t_ = Y(Be)(
  ({ theme: e, itemsCount: n }) => `
  display: grid;
  grid-template-columns: ${n > 5 ? "repeat(3, 1fr)" : `repeat(${n}, 1fr)`};

  ${Ho(e, "mobile")} {
    grid-template-columns: repeat(1, 1fr);
  }
`
), r_ = Y(Be)(
  ({ theme: e, itemsCount: n }) => `
  border-right: ${Pn(e)};
  border-bottom: ${Pn(e)};

  ${Ho(e, "mobile")} {
    &:nth-child(n) {
      border-right: none;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  ${v0(e, "mobile")} {
    ${n > 5 ? `
      &:nth-child(3n+3) {
        border-right: none;
      }

      &:nth-last-child(-n+3) {
        border-bottom: none;
      }
    ` : `
      &:last-child {
        border-right: none;
      }

      &:nth-last-child(n) {
        border-bottom: none;
      }
    `}
  }
`
), n_ = (e) => ({
  unselected: {
    enabled: e.color.border,
    active: e.color.borderHover
  },
  selected: {
    enabled: e.color.primary,
    active: e.color.blue3
  },
  error: {
    enabled: e.color.danger,
    active: e.color.red3
  }
}), o_ = ({
  value: e,
  label: n,
  description: o,
  isDisabled: t = !1,
  trackingId: r,
  groupErrorMessage: a
}) => /* @__PURE__ */ g.jsx(Be, { direction: "column", children: /* @__PURE__ */ g.jsx(
  _a.Option,
  {
    as: a_,
    value: e,
    disabled: t,
    isDisabled: t,
    trackingId: r,
    children: ({ checked: i }) => /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
      /* @__PURE__ */ g.jsxs(Be, { gap: "m", padding: o ? "none none s none" : "none", children: [
        /* @__PURE__ */ g.jsx(
          db,
          {
            state: a ? "error" : i ? "selected" : "unselected",
            children: i && /* @__PURE__ */ g.jsx(Ld, {})
          }
        ),
        /* @__PURE__ */ g.jsx(_a.Label, { as: vo, trackingId: `${r}-label`, children: n })
      ] }),
      // This uses RadioGroup.Description, which renders a hidden error
      // message in a span, adds an ID to the span, then adds an
      // aria-describedby attribute with the span's ID to the
      // option. This is for screen readers.
      //
      // It may seem strange that we're handling this at the option
      // level rather than the group level, since it's a group-level
      // error. However, the `described-by` attribute at the group
      // level is not as well-supported by screen readers.
      // https://russmaxdesign.github.io/accessible-error-fieldset/
      //
      // It may also seem like we could just directly set the
      // aria-describedby prop on the Option element and reference the
      // ID of the error alert being displayed at the group level.
      // However, Headless UI only allows us to configure
      // aria-describedby on the Option element by rendering a
      // RadioGroup.Description element as a descendent, which we've
      // done here.
      a && /* @__PURE__ */ g.jsx(s_, { children: a }),
      o && // We can't pass OptionDescription as the `as` prop value
      // because the ID attribute RadioGroup.Description tries
      // to apply won't make it through to the underlying DOM element.
      // I suspect it has something to do with styled-components.
      /* @__PURE__ */ g.jsx(_a.Description, { as: "div", children: /* @__PURE__ */ g.jsx(i_, { children: o }) })
    ] })
  }
) }), Fd = "20px", db = Y.span.withConfig({
  shouldForwardProp: (e) => e !== "state"
})(({ theme: e, state: n }) => {
  const { enabled: o, active: t } = n_(e)[n];
  return `
    ${Yo}
  
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: ${Fd};
    height: ${Fd};
    border-radius: ${e.borderRadius.round};
    background-color: ${e.color.white};
  
    // Give the radio a top margin to align it vertically with the top line of label text
    margin-top: 2px;
  
    ${hy(e)}

    border: ${e.borderWidth.m} solid ${o};
    
    ${Ld} {
      background-color: ${o};
    }

    &:active {
      border-color: ${t};

      ${Ld} {
        background-color: ${t};
      }
    }
  `;
}), Ld = Y.div(
  ({ theme: e }) => `
  width: 10px;
  height: 10px;
  border-radius: ${e.borderRadius.round};
  background-color: ${e.color.primary};
`
), a_ = Jr(
  Y.div.withConfig({
    shouldForwardProp: (e) => e !== "isDisabled"
  })(
    ({ theme: e, isDisabled: n }) => `
  ${Yo}

  ${n ? Rn : ""}

  &:focus-visible {
    ${db} {
      ${cn(e)}
    }
  }
  
`
  )
), i_ = Y.div(
  ({ theme: e }) => `
  ${Nn(e).body};
  // This calc ensures that the description sits underneath the option label
  padding-left: calc(${Fd} + ${e.spacing.m});
`
), s_ = Y(_a.Description)`
  display: none;
`, qM = ({
  errorMessage: e,
  helpIconProps: n,
  isDisabled: o = !1,
  isLabelHidden: t = !1,
  label: r,
  onChange: a,
  options: i,
  shouldShowDividers: s = !1,
  trackingId: l,
  value: u
}) => {
  const c = Ga(a), p = {
    isLabelHidden: t,
    label: r,
    helpIconProps: n,
    trackingId: l
  };
  return /* @__PURE__ */ g.jsx(
    _a,
    {
      value: u,
      onChange: c,
      disabled: o,
      children: /* @__PURE__ */ g.jsxs(
        fa,
        {
          ...p,
          LabelElement: _a.Label,
          children: [
            /* @__PURE__ */ g.jsx(Be, { direction: "column", gap: "m", children: i.map(
              ({ isDisabled: h, value: O, ...C }, P) => /* @__PURE__ */ g.jsxs(Or, { children: [
                /* @__PURE__ */ g.jsx(
                  o_,
                  {
                    value: O,
                    isDisabled: o || h,
                    groupErrorMessage: e,
                    ...C
                  }
                ),
                P < i.length - 1 && s && /* @__PURE__ */ g.jsx(Bn, {})
              ] }, String(O))
            ) }),
            e && /* @__PURE__ */ g.jsx(un, { colorVariant: "danger", children: e })
          ]
        }
      )
    }
  );
}, l_ = ({ row: e, rowIndex: n, rowCount: o }) => {
  const { avatarProps: t, content: r, description: a, title: i, key: s } = e, l = n === o - 1;
  return /* @__PURE__ */ g.jsxs(y.Fragment, { children: [
    t && /* @__PURE__ */ g.jsx(
      u_,
      {
        rowIndex: n,
        isTopRow: !0,
        isBottomRow: !a,
        isFirstColumn: !0,
        isLastColumn: !1,
        children: /* @__PURE__ */ g.jsx(Of, { size: "default", ...t })
      }
    ),
    /* @__PURE__ */ g.jsx(
      c_,
      {
        rowIndex: n,
        isTopRow: !0,
        isBottomRow: !a,
        isFirstColumn: !t,
        isLastColumn: !1,
        children: /* @__PURE__ */ g.jsx(vo, { children: i })
      }
    ),
    /* @__PURE__ */ g.jsx(
      d_,
      {
        rowIndex: n,
        isTopRow: !0,
        isBottomRow: !a,
        isFirstColumn: !1,
        isLastColumn: !0,
        children: r
      }
    ),
    a && /* @__PURE__ */ g.jsx(
      p_,
      {
        rowIndex: n,
        isTopRow: !1,
        isBottomRow: !0,
        isFirstColumn: !t,
        isLastColumn: !1,
        children: /* @__PURE__ */ g.jsx(un, { colorVariant: "secondary", children: a })
      }
    ),
    !l && /* @__PURE__ */ g.jsx(f_, { rowIndex: n, children: /* @__PURE__ */ g.jsx(Bn, {}) })
  ] }, s);
}, ph = (e) => e.spacing.m, fh = (e) => e.spacing.l, Yl = Y.div.withConfig({
  shouldForwardProp: (e) => ![
    "rowIndex",
    "isTopRow",
    "isBottomRow",
    "isFirstColumn",
    "isLastColumn"
  ].includes(e)
})``, Gl = (e, {
  isTopRow: n,
  isBottomRow: o,
  isFirstColumn: t,
  isLastColumn: r
}) => `
  padding-top: ${n ? ph(e) : e.spacing.none};
  padding-bottom: ${o ? ph(e) : e.spacing.none};
  padding-left: ${t ? fh(e) : e.spacing.none};
  padding-right: ${r ? fh(e) : e.spacing.none};
`, u_ = Y(Yl)(
  ({ theme: e, rowIndex: n, isTopRow: o, isBottomRow: t, isFirstColumn: r, isLastColumn: a }) => `
  grid-area: avatar${n};
  
  ${Gl(e, {
    isTopRow: o,
    isBottomRow: t,
    isFirstColumn: r,
    isLastColumn: a
  })}
`
), c_ = Y(Yl)(
  ({ theme: e, rowIndex: n, isTopRow: o, isBottomRow: t, isFirstColumn: r, isLastColumn: a }) => `
  grid-area: title${n};

  ${Gl(e, {
    isTopRow: o,
    isBottomRow: t,
    isFirstColumn: r,
    isLastColumn: a
  })}
`
), d_ = Y(Yl)(
  ({ theme: e, rowIndex: n, isTopRow: o, isBottomRow: t, isFirstColumn: r, isLastColumn: a }) => `
  ${Nn(e)["body-small"]}
  
  color: ${Jd(e).secondary};
  grid-area: content${n};
  justify-self: end;

  ${Gl(e, {
    isTopRow: o,
    isBottomRow: t,
    isFirstColumn: r,
    isLastColumn: a
  })}
  
  &&, ${pr} {
    text-align: right;
  }
`
), p_ = Y(Yl)(
  ({ theme: e, rowIndex: n, isTopRow: o, isBottomRow: t, isFirstColumn: r, isLastColumn: a }) => `
  grid-area: description${n};

  ${Gl(e, {
    isTopRow: o,
    isBottomRow: t,
    isFirstColumn: r,
    isLastColumn: a
  })}

  padding-top: ${e.spacing.s};
`
), f_ = Y.div.withConfig({
  shouldForwardProp: (e) => e !== "rowIndex"
})(
  ({ rowIndex: e }) => `
  grid-area: divider${e};
`
), vh = (e, n) => e.map((o) => `"${o.map(
  (r) => r === "." ? "." : `${r}${n}`
).join(" ")}"`).join(`
`), v_ = (e, n, o) => {
  const t = !!e.avatarProps, r = !!e.description, a = (() => t ? r ? [
    ["avatar", "title", "content"],
    [".", "description", "."]
  ] : [["avatar", "title", "content"]] : r ? [
    ["title", "content"],
    ["description", "."]
  ] : [["title", "content"]])();
  return vh(o ? a : [
    ...a,
    t ? ["divider", "divider", "divider"] : ["divider", "divider"]
  ], n);
}, KM = ({ rows: e, className: n = "" }) => {
  const o = e.some(
    (r) => !!r.avatarProps
  ), t = e.map((r, a) => v_(r, a, a === e.length - 1)).join(`
`);
  return /* @__PURE__ */ g.jsx(
    g_,
    {
      hasAvatarColumn: o,
      className: n,
      templateAreas: t,
      children: e.map((r, a) => /* @__PURE__ */ g.jsx(l_, { row: r, rowIndex: a, rowCount: e.length }, r.key))
    }
  );
}, g_ = Y.div.withConfig({
  shouldForwardProp: (e) => !["templateAreas", "hasAvatarColumn"].includes(e)
})(
  ({ theme: e, templateAreas: n, hasAvatarColumn: o }) => `
  display: grid;
  align-items: center;
  grid-template-areas: ${n};
  grid-template-columns: ${o ? "auto " : ""} minmax(30%, 1fr) auto;
  grid-column-gap: ${e.spacing.m};
`
), QM = ({
  inputProps: e,
  dropdownProps: n,
  trackingId: o,
  isDisabled: t = !1,
  size: r = "default",
  ...a
}) => {
  const i = Ba();
  return /* @__PURE__ */ g.jsx(
    fa,
    {
      ...a,
      htmlFor: i,
      trackingId: o,
      children: /* @__PURE__ */ g.jsxs(Be, { children: [
        /* @__PURE__ */ g.jsx(
          nb,
          {
            ...n,
            isDisabled: t,
            trackingId: `${o}-dropdown`,
            targetButtonProps: {
              as: h_,
              size: r,
              trackingId: `${o}-dropdown-button`,
              children: /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
                /* @__PURE__ */ g.jsxs(Be, { alignItems: "center", gap: "s", children: [
                  /* @__PURE__ */ g.jsx(Lr, { name: "search" }),
                  n.getOptionLabel(n.value)
                ] }),
                /* @__PURE__ */ g.jsx(Lr, { name: "chevron-down" })
              ] })
            }
          }
        ),
        /* @__PURE__ */ g.jsx(
          m_,
          {
            ...e,
            id: i,
            isDisabled: t,
            trackingId: `${o}-search-bar`,
            size: r,
            inputSiblingElement: e.value ? /* @__PURE__ */ g.jsx(
              y_,
              {
                isDisabled: t,
                trackingId: o,
                onClear: () => e.onTextChange("")
              }
            ) : void 0
          }
        )
      ] })
    }
  );
}, zs = {
  staticElement: 1,
  hoveredElement: 2,
  focusedElement: 3,
  clearButton: 4
}, pb = `
  z-index: ${zs.staticElement};

  // When we have an interaction state, show the dropdown over the input.
  &:hover, &:active {
    z-index: ${zs.hoveredElement};
  }

  &:focus-visible {
    z-index: ${zs.focusedElement};
  }
`, h_ = Jr(
  Y.button.withConfig({
    shouldForwardProp: (e) => !["size", "isDropdownOpen"].includes(e)
  })(
    ({ theme: e, size: n }) => `
  ${Ol(e, { variant: "button-tertiary", size: n })}

  display: flex;
  justify-content: space-between;
  padding: ${n === "default" ? e.spacing.s : e.spacing.xs} ${e.spacing.m};
  font-size: ${e.fontSize.m};
  align-items: center;
  border-radius: ${e.borderRadius.s} ${e.borderRadius.none} ${e.borderRadius.none} ${e.borderRadius.s};

  // Align the right border over the border of the input to avoid visual duplication.
  margin-right: -1px;

  ${pb}
`
  )
), m_ = Y(kf)(
  ({ theme: e }) => `
    flex: 1;

    ${Rf} {
      position: relative;
      border-radius: ${e.borderRadius.none} ${e.borderRadius.s} ${e.borderRadius.s} ${e.borderRadius.none};

      ${pb}
    }
  `
), y_ = Y(ty)`
  z-index: ${zs.clearButton};
`, XM = ({
  label: e,
  content: n,
  helpIconProps: o,
  className: t = ""
}) => /* @__PURE__ */ g.jsxs(Be, { gap: "xs", direction: "column", className: t, children: [
  /* @__PURE__ */ g.jsxs(Be, { gap: "xs", children: [
    /* @__PURE__ */ g.jsx(un, { colorVariant: "secondary", children: e }),
    o && /* @__PURE__ */ g.jsx(Hi, { ...o })
  ] }),
  /* @__PURE__ */ g.jsx(vo, { children: n })
] }), JM = ({
  className: e = "",
  helpIconProps: n,
  isLoading: o = !1,
  title: t,
  value: r,
  badgeProps: a,
  errorIconProps: i,
  hasError: s = !1,
  trackingId: l
}) => /* @__PURE__ */ g.jsx(
  b_,
  {
    trackingId: l,
    headElement: /* @__PURE__ */ g.jsx(HO, { background: "primary" }),
    className: e,
    children: /* @__PURE__ */ g.jsx(
      cb,
      {
        helpIconProps: n,
        isLoading: o,
        title: t,
        value: r,
        badgeProps: a,
        errorIconProps: i,
        hasError: s
      }
    )
  }
), b_ = Y(Pf)`
  flex: 1 0;
`, ZM = ({ currentStep: e = -1, steps: n }) => {
  const o = ({ title: t, content: r, key: a, isDisabled: i = !1, titleHeading: s = "div" }, l) => {
    const [u, c] = (() => e <= l ? [
      e === l ? "primary" : "secondary",
      { label: (l + 1).toString() }
    ] : ["success", { iconName: "check" }])(), p = l === n.length - 1;
    return /* @__PURE__ */ g.jsxs(
      w_,
      {
        "aria-current": e === l ? "step" : void 0,
        children: [
          /* @__PURE__ */ g.jsx(gh, { children: /* @__PURE__ */ g.jsx(Of, { size: "small", variant: u, ...c }) }),
          /* @__PURE__ */ g.jsx(x_, { isDisabled: i, forwardedAs: s, children: t }),
          /* @__PURE__ */ g.jsx(gh, { children: !p && /* @__PURE__ */ g.jsx(Bn, { direction: "vertical" }) }),
          /* @__PURE__ */ g.jsx(C_, { growItems: !0, isLastStep: p, children: r })
        ]
      },
      a
    );
  };
  return /* @__PURE__ */ g.jsx(Be, { direction: "column", gap: "s", children: n.map((t, r) => o(t, r)) });
}, w_ = Y.div(
  ({ theme: e }) => `
  display: grid;
  grid-template-columns: auto 1fr; 
  grid-template-rows: auto auto;
  gap: ${e.spacing.s} ${e.spacing.m};
`
), gh = Y.div`
  display: grid;
  justify-items: center;
`, x_ = Y(xf).withConfig({
  shouldForwardProp: (e) => e !== "isDisabled"
})(
  ({ theme: e, isDisabled: n }) => `
  display: grid;
  align-items: center;
  color: ${n ? e.color.disabled : e.color.black};
`
), C_ = Y(Be)(
  ({ theme: e, isLastStep: n }) => `
  padding-bottom: ${n ? e.spacing.none : e.spacing.l};
`
);
var Nd = { exports: {} }, Ms = { exports: {} }, hh;
function S_() {
  return hh || (hh = 1, function(e, n) {
    (function(o, t) {
      t(n, y);
    })(Vh, function(o, t) {
      function r(d, b, S, E, L, T, B) {
        try {
          var X = d[T](B), te = X.value;
        } catch (ne) {
          return void S(ne);
        }
        X.done ? b(te) : Promise.resolve(te).then(E, L);
      }
      function a(d) {
        return function() {
          var b = this, S = arguments;
          return new Promise(function(E, L) {
            var T = d.apply(b, S);
            function B(te) {
              r(T, E, L, B, X, "next", te);
            }
            function X(te) {
              r(T, E, L, B, X, "throw", te);
            }
            B(void 0);
          });
        };
      }
      function i() {
        return (i = Object.assign || function(d) {
          for (var b = 1; b < arguments.length; b++) {
            var S = arguments[b];
            for (var E in S)
              Object.prototype.hasOwnProperty.call(S, E) && (d[E] = S[E]);
          }
          return d;
        }).apply(this, arguments);
      }
      function s(d, b) {
        if (d == null)
          return {};
        var S, E, L = {}, T = Object.keys(d);
        for (E = 0; E < T.length; E++)
          S = T[E], b.indexOf(S) >= 0 || (L[S] = d[S]);
        return L;
      }
      function l(d) {
        var b = function(S, E) {
          if (typeof S != "object" || S === null)
            return S;
          var L = S[Symbol.toPrimitive];
          if (L !== void 0) {
            var T = L.call(S, E || "default");
            if (typeof T != "object")
              return T;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (E === "string" ? String : Number)(S);
        }(d, "string");
        return typeof b == "symbol" ? b : String(b);
      }
      t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
      var u = { init: "init" }, c = function(d) {
        var b = d.value;
        return b === void 0 ? "" : b;
      }, p = function() {
        return t.createElement(t.Fragment, null, " ");
      }, h = { Cell: c, width: 150, minWidth: 0, maxWidth: Number.MAX_SAFE_INTEGER };
      function O() {
        for (var d = arguments.length, b = new Array(d), S = 0; S < d; S++)
          b[S] = arguments[S];
        return b.reduce(function(E, L) {
          var T = L.style, B = L.className;
          return E = i({}, E, {}, s(L, ["style", "className"])), T && (E.style = E.style ? i({}, E.style || {}, {}, T || {}) : T), B && (E.className = E.className ? E.className + " " + B : B), E.className === "" && delete E.className, E;
        }, {});
      }
      var C = function(d, b) {
        return b === void 0 && (b = {}), function(S) {
          return S === void 0 && (S = {}), [].concat(d, [S]).reduce(function(E, L) {
            return function T(B, X, te) {
              return typeof X == "function" ? T({}, X(B, te)) : Array.isArray(X) ? O.apply(void 0, [B].concat(X)) : O(B, X);
            }(E, L, i({}, b, { userProps: S }));
          }, {});
        };
      }, P = function(d, b, S, E) {
        return S === void 0 && (S = {}), d.reduce(function(L, T) {
          return T(L, S);
        }, b);
      }, k = function(d, b, S) {
        return S === void 0 && (S = {}), d.forEach(function(E) {
          E(b, S);
        });
      };
      function $(d, b, S, E) {
        d.findIndex(function(L) {
          return L.pluginName === S;
        }), b.forEach(function(L) {
          d.findIndex(function(T) {
            return T.pluginName === L;
          });
        });
      }
      function I(d, b) {
        return typeof d == "function" ? d(b) : d;
      }
      function H(d) {
        var b = t.useRef();
        return b.current = d, t.useCallback(function() {
          return b.current;
        }, []);
      }
      var x = typeof document < "u" ? t.useLayoutEffect : t.useEffect;
      function _(d, b) {
        var S = t.useRef(!1);
        x(function() {
          S.current && d(), S.current = !0;
        }, b);
      }
      function F(d, b, S) {
        return S === void 0 && (S = {}), function(E, L) {
          L === void 0 && (L = {});
          var T = typeof E == "string" ? b[E] : E;
          if (T === void 0)
            throw console.info(b), new Error("Renderer Error ☝️");
          return G(T, i({}, d, { column: b }, S, {}, L));
        };
      }
      function G(d, b) {
        return function(E) {
          return typeof E == "function" && (L = Object.getPrototypeOf(E)).prototype && L.prototype.isReactComponent;
          var L;
        }(S = d) || typeof S == "function" || function(E) {
          return typeof E == "object" && typeof E.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(E.$$typeof.description);
        }(S) ? t.createElement(d, b) : d;
        var S;
      }
      function Q(d, b, S) {
        return S === void 0 && (S = 0), d.map(function(E) {
          return ie(E = i({}, E, { parent: b, depth: S })), E.columns && (E.columns = Q(E.columns, E, S + 1)), E;
        });
      }
      function V(d) {
        return oe(d, "columns");
      }
      function ie(d) {
        var b = d.id, S = d.accessor, E = d.Header;
        if (typeof S == "string") {
          b = b || S;
          var L = S.split(".");
          S = function(T) {
            return function(B, X, te) {
              if (!X)
                return B;
              var ne, Se = typeof X == "function" ? X : JSON.stringify(X), we = ve.get(Se) || function() {
                var xe = function(se) {
                  return function ye(Te, Ae) {
                    if (Ae === void 0 && (Ae = []), Array.isArray(Te))
                      for (var rt = 0; rt < Te.length; rt += 1)
                        ye(Te[rt], Ae);
                    else
                      Ae.push(Te);
                    return Ae;
                  }(se).map(function(ye) {
                    return String(ye).replace(".", "_");
                  }).join(".").replace(Pe, ".").replace(lt, "").split(".");
                }(X);
                return ve.set(Se, xe), xe;
              }();
              try {
                ne = we.reduce(function(xe, se) {
                  return xe[se];
                }, B);
              } catch {
              }
              return ne !== void 0 ? ne : te;
            }(T, L);
          };
        }
        if (!b && typeof E == "string" && E && (b = E), !b && d.columns)
          throw console.error(d), new Error('A column ID (or unique "Header" value) is required!');
        if (!b)
          throw console.error(d), new Error("A column ID (or string accessor) is required!");
        return Object.assign(d, { id: b, accessor: S }), d;
      }
      function ce(d, b) {
        if (!b)
          throw new Error();
        return Object.assign(d, i({ Header: p, Footer: p }, h, {}, b, {}, d)), Object.assign(d, { originalWidth: d.width }), d;
      }
      function me(d, b, S) {
        S === void 0 && (S = function() {
          return {};
        });
        for (var E = [], L = d, T = 0, B = function() {
          return T++;
        }, X = function() {
          var te = { headers: [] }, ne = [], Se = L.some(function(we) {
            return we.parent;
          });
          L.forEach(function(we) {
            var xe, se = [].concat(ne).reverse()[0];
            Se && (we.parent ? xe = i({}, we.parent, { originalId: we.parent.id, id: we.parent.id + "_" + B(), headers: [we] }, S(we)) : xe = ce(i({ originalId: we.id + "_placeholder", id: we.id + "_placeholder_" + B(), placeholderOf: we, headers: [we] }, S(we)), b), se && se.originalId === xe.originalId ? se.headers.push(we) : ne.push(xe)), te.headers.push(we);
          }), E.push(te), L = ne;
        }; L.length; )
          X();
        return E.reverse();
      }
      var ve = /* @__PURE__ */ new Map();
      function U() {
        for (var d = arguments.length, b = new Array(d), S = 0; S < d; S++)
          b[S] = arguments[S];
        for (var E = 0; E < b.length; E += 1)
          if (b[E] !== void 0)
            return b[E];
      }
      function ee(d) {
        if (typeof d == "function")
          return d;
      }
      function oe(d, b) {
        var S = [];
        return function E(L) {
          L.forEach(function(T) {
            T[b] ? E(T[b]) : S.push(T);
          });
        }(d), S;
      }
      function ge(d, b) {
        var S = b.manualExpandedKey, E = b.expanded, L = b.expandSubRows, T = L === void 0 || L, B = [];
        return d.forEach(function(X) {
          return function te(ne, Se) {
            Se === void 0 && (Se = !0), ne.isExpanded = ne.original && ne.original[S] || E[ne.id], ne.canExpand = ne.subRows && !!ne.subRows.length, Se && B.push(ne), ne.subRows && ne.subRows.length && ne.isExpanded && ne.subRows.forEach(function(we) {
              return te(we, T);
            });
          }(X);
        }), B;
      }
      function be(d, b, S) {
        return ee(d) || b[d] || S[d] || S.text;
      }
      function he(d, b, S) {
        return d ? d(b, S) : b === void 0;
      }
      function K() {
        throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
      }
      var le = null, Pe = /\[/g, lt = /\]/g, Ge = function(d) {
        return i({ role: "table" }, d);
      }, ut = function(d) {
        return i({ role: "rowgroup" }, d);
      }, ze = function(d, b) {
        var S = b.column;
        return i({ key: "header_" + S.id, colSpan: S.totalVisibleHeaderCount, role: "columnheader" }, d);
      }, Ze = function(d, b) {
        var S = b.column;
        return i({ key: "footer_" + S.id, colSpan: S.totalVisibleHeaderCount }, d);
      }, _e = function(d, b) {
        return i({ key: "headerGroup_" + b.index, role: "row" }, d);
      }, De = function(d, b) {
        return i({ key: "footerGroup_" + b.index }, d);
      }, fe = function(d, b) {
        return i({ key: "row_" + b.row.id, role: "row" }, d);
      }, ke = function(d, b) {
        var S = b.cell;
        return i({ key: "cell_" + S.row.id + "_" + S.column.id, role: "cell" }, d);
      };
      function re() {
        return { useOptions: [], stateReducers: [], useControlledState: [], columns: [], columnsDeps: [], allColumns: [], allColumnsDeps: [], accessValue: [], materializedColumns: [], materializedColumnsDeps: [], useInstanceAfterData: [], visibleColumns: [], visibleColumnsDeps: [], headerGroups: [], headerGroupsDeps: [], useInstanceBeforeDimensions: [], useInstance: [], prepareRow: [], getTableProps: [Ge], getTableBodyProps: [ut], getHeaderGroupProps: [_e], getFooterGroupProps: [De], getHeaderProps: [ze], getFooterProps: [Ze], getRowProps: [fe], getCellProps: [ke], useFinalInstance: [] };
      }
      u.resetHiddenColumns = "resetHiddenColumns", u.toggleHideColumn = "toggleHideColumn", u.setHiddenColumns = "setHiddenColumns", u.toggleHideAllColumns = "toggleHideAllColumns";
      var tt = function(d) {
        d.getToggleHiddenProps = [et], d.getToggleHideAllColumnsProps = [Dt], d.stateReducers.push(Kt), d.useInstanceBeforeDimensions.push(fr), d.headerGroupsDeps.push(function(b, S) {
          var E = S.instance;
          return [].concat(b, [E.state.hiddenColumns]);
        }), d.useInstance.push(Ir);
      };
      tt.pluginName = "useColumnVisibility";
      var et = function(d, b) {
        var S = b.column;
        return [d, { onChange: function(E) {
          S.toggleHidden(!E.target.checked);
        }, style: { cursor: "pointer" }, checked: S.isVisible, title: "Toggle Column Visible" }];
      }, Dt = function(d, b) {
        var S = b.instance;
        return [d, { onChange: function(E) {
          S.toggleHideAllColumns(!E.target.checked);
        }, style: { cursor: "pointer" }, checked: !S.allColumnsHidden && !S.state.hiddenColumns.length, title: "Toggle All Columns Hidden", indeterminate: !S.allColumnsHidden && S.state.hiddenColumns.length }];
      };
      function Kt(d, b, S, E) {
        if (b.type === u.init)
          return i({ hiddenColumns: [] }, d);
        if (b.type === u.resetHiddenColumns)
          return i({}, d, { hiddenColumns: E.initialState.hiddenColumns || [] });
        if (b.type === u.toggleHideColumn) {
          var L = (b.value !== void 0 ? b.value : !d.hiddenColumns.includes(b.columnId)) ? [].concat(d.hiddenColumns, [b.columnId]) : d.hiddenColumns.filter(function(T) {
            return T !== b.columnId;
          });
          return i({}, d, { hiddenColumns: L });
        }
        return b.type === u.setHiddenColumns ? i({}, d, { hiddenColumns: I(b.value, d.hiddenColumns) }) : b.type === u.toggleHideAllColumns ? i({}, d, { hiddenColumns: (b.value !== void 0 ? b.value : !d.hiddenColumns.length) ? E.allColumns.map(function(T) {
          return T.id;
        }) : [] }) : void 0;
      }
      function fr(d) {
        var b = d.headers, S = d.state.hiddenColumns;
        t.useRef(!1).current;
        var E = 0;
        b.forEach(function(L) {
          return E += function T(B, X) {
            B.isVisible = X && !S.includes(B.id);
            var te = 0;
            return B.headers && B.headers.length ? B.headers.forEach(function(ne) {
              return te += T(ne, B.isVisible);
            }) : te = B.isVisible ? 1 : 0, B.totalVisibleHeaderCount = te, te;
          }(L, !0);
        });
      }
      function Ir(d) {
        var b = d.columns, S = d.flatHeaders, E = d.dispatch, L = d.allColumns, T = d.getHooks, B = d.state.hiddenColumns, X = d.autoResetHiddenColumns, te = X === void 0 || X, ne = H(d), Se = L.length === B.length, we = t.useCallback(function(Ae, rt) {
          return E({ type: u.toggleHideColumn, columnId: Ae, value: rt });
        }, [E]), xe = t.useCallback(function(Ae) {
          return E({ type: u.setHiddenColumns, value: Ae });
        }, [E]), se = t.useCallback(function(Ae) {
          return E({ type: u.toggleHideAllColumns, value: Ae });
        }, [E]), ye = C(T().getToggleHideAllColumnsProps, { instance: ne() });
        S.forEach(function(Ae) {
          Ae.toggleHidden = function(rt) {
            E({ type: u.toggleHideColumn, columnId: Ae.id, value: rt });
          }, Ae.getToggleHiddenProps = C(T().getToggleHiddenProps, { instance: ne(), column: Ae });
        });
        var Te = H(te);
        _(function() {
          Te() && E({ type: u.resetHiddenColumns });
        }, [E, b]), Object.assign(d, { allColumnsHidden: Se, toggleHideColumn: we, setHiddenColumns: xe, toggleHideAllColumns: se, getToggleHideAllColumnsProps: ye });
      }
      var jr = {}, Pr = {}, Nr = function(d, b, S) {
        return d;
      }, nn = function(d, b) {
        return d.subRows || [];
      }, on = function(d, b, S) {
        return "" + (S ? [S.id, b].join(".") : b);
      }, Re = function(d) {
        return d;
      };
      function it(d) {
        var b = d.initialState, S = b === void 0 ? jr : b, E = d.defaultColumn, L = E === void 0 ? Pr : E, T = d.getSubRows, B = T === void 0 ? nn : T, X = d.getRowId, te = X === void 0 ? on : X, ne = d.stateReducer, Se = ne === void 0 ? Nr : ne, we = d.useControlledState, xe = we === void 0 ? Re : we;
        return i({}, s(d, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]), { initialState: S, defaultColumn: L, getSubRows: B, getRowId: te, stateReducer: Se, useControlledState: xe });
      }
      function Qt(d, b) {
        b === void 0 && (b = 0);
        var S = 0, E = 0, L = 0, T = 0;
        return d.forEach(function(B) {
          var X = B.headers;
          if (B.totalLeft = b, X && X.length) {
            var te = Qt(X, b), ne = te[0], Se = te[1], we = te[2], xe = te[3];
            B.totalMinWidth = ne, B.totalWidth = Se, B.totalMaxWidth = we, B.totalFlexWidth = xe;
          } else
            B.totalMinWidth = B.minWidth, B.totalWidth = Math.min(Math.max(B.minWidth, B.width), B.maxWidth), B.totalMaxWidth = B.maxWidth, B.totalFlexWidth = B.canResize ? B.totalWidth : 0;
          B.isVisible && (b += B.totalWidth, S += B.totalMinWidth, E += B.totalWidth, L += B.totalMaxWidth, T += B.totalFlexWidth);
        }), [S, E, L, T];
      }
      function tr(d) {
        var b = d.data, S = d.rows, E = d.flatRows, L = d.rowsById, T = d.column, B = d.getRowId, X = d.getSubRows, te = d.accessValueHooks, ne = d.getInstance;
        b.forEach(function(Se, we) {
          return function xe(se, ye, Te, Ae, rt) {
            Te === void 0 && (Te = 0);
            var Ot = se, nt = B(se, ye, Ae), Oe = L[nt];
            if (Oe)
              Oe.subRows && Oe.originalSubRows.forEach(function(qe, mt) {
                return xe(qe, mt, Te + 1, Oe);
              });
            else if ((Oe = { id: nt, original: Ot, index: ye, depth: Te, cells: [{}] }).cells.map = K, Oe.cells.filter = K, Oe.cells.forEach = K, Oe.cells[0].getCellProps = K, Oe.values = {}, rt.push(Oe), E.push(Oe), L[nt] = Oe, Oe.originalSubRows = X(se, ye), Oe.originalSubRows) {
              var xt = [];
              Oe.originalSubRows.forEach(function(qe, mt) {
                return xe(qe, mt, Te + 1, Oe, xt);
              }), Oe.subRows = xt;
            }
            T.accessor && (Oe.values[T.id] = T.accessor(se, ye, Oe, rt, b)), Oe.values[T.id] = P(te, Oe.values[T.id], { row: Oe, column: T, instance: ne() });
          }(Se, we, 0, void 0, S);
        });
      }
      u.resetExpanded = "resetExpanded", u.toggleRowExpanded = "toggleRowExpanded", u.toggleAllRowsExpanded = "toggleAllRowsExpanded";
      var mr = function(d) {
        d.getToggleAllRowsExpandedProps = [dn], d.getToggleRowExpandedProps = [an], d.stateReducers.push(hn), d.useInstance.push(Wn), d.prepareRow.push(zn);
      };
      mr.pluginName = "useExpanded";
      var dn = function(d, b) {
        var S = b.instance;
        return [d, { onClick: function(E) {
          S.toggleAllRowsExpanded();
        }, style: { cursor: "pointer" }, title: "Toggle All Rows Expanded" }];
      }, an = function(d, b) {
        var S = b.row;
        return [d, { onClick: function() {
          S.toggleRowExpanded();
        }, style: { cursor: "pointer" }, title: "Toggle Row Expanded" }];
      };
      function hn(d, b, S, E) {
        if (b.type === u.init)
          return i({ expanded: {} }, d);
        if (b.type === u.resetExpanded)
          return i({}, d, { expanded: E.initialState.expanded || {} });
        if (b.type === u.toggleAllRowsExpanded) {
          var L = b.value, T = E.rowsById, B = Object.keys(T).length === Object.keys(d.expanded).length;
          if (L !== void 0 ? L : !B) {
            var X = {};
            return Object.keys(T).forEach(function(ye) {
              X[ye] = !0;
            }), i({}, d, { expanded: X });
          }
          return i({}, d, { expanded: {} });
        }
        if (b.type === u.toggleRowExpanded) {
          var te, ne = b.id, Se = b.value, we = d.expanded[ne], xe = Se !== void 0 ? Se : !we;
          if (!we && xe)
            return i({}, d, { expanded: i({}, d.expanded, (te = {}, te[ne] = !0, te)) });
          if (we && !xe) {
            var se = d.expanded;
            return se[ne], i({}, d, { expanded: s(se, [ne].map(l)) });
          }
          return d;
        }
      }
      function Wn(d) {
        var b = d.data, S = d.rows, E = d.rowsById, L = d.manualExpandedKey, T = L === void 0 ? "expanded" : L, B = d.paginateExpandedRows, X = B === void 0 || B, te = d.expandSubRows, ne = te === void 0 || te, Se = d.autoResetExpanded, we = Se === void 0 || Se, xe = d.getHooks, se = d.plugins, ye = d.state.expanded, Te = d.dispatch;
        $(se, ["useSortBy", "useGroupBy", "usePivotColumns", "useGlobalFilter"], "useExpanded");
        var Ae = H(we), rt = !!(Object.keys(E).length && Object.keys(ye).length);
        rt && Object.keys(E).some(function(_t) {
          return !ye[_t];
        }) && (rt = !1), _(function() {
          Ae() && Te({ type: u.resetExpanded });
        }, [Te, b]);
        var Ot = t.useCallback(function(_t, pt) {
          Te({ type: u.toggleRowExpanded, id: _t, value: pt });
        }, [Te]), nt = t.useCallback(function(_t) {
          return Te({ type: u.toggleAllRowsExpanded, value: _t });
        }, [Te]), Oe = t.useMemo(function() {
          return X ? ge(S, { manualExpandedKey: T, expanded: ye, expandSubRows: ne }) : S;
        }, [X, S, T, ye, ne]), xt = t.useMemo(function() {
          return function(_t) {
            var pt = 0;
            return Object.keys(_t).forEach(function(gt) {
              var zt = gt.split(".");
              pt = Math.max(pt, zt.length);
            }), pt;
          }(ye);
        }, [ye]), qe = H(d), mt = C(xe().getToggleAllRowsExpandedProps, { instance: qe() });
        Object.assign(d, { preExpandedRows: S, expandedRows: Oe, rows: Oe, expandedDepth: xt, isAllRowsExpanded: rt, toggleRowExpanded: Ot, toggleAllRowsExpanded: nt, getToggleAllRowsExpandedProps: mt });
      }
      function zn(d, b) {
        var S = b.instance.getHooks, E = b.instance;
        d.toggleRowExpanded = function(L) {
          return E.toggleRowExpanded(d.id, L);
        }, d.getToggleRowExpandedProps = C(S().getToggleRowExpandedProps, { instance: E, row: d });
      }
      var Z = function(d, b, S) {
        return d = d.filter(function(E) {
          return b.some(function(L) {
            var T = E.values[L];
            return String(T).toLowerCase().includes(String(S).toLowerCase());
          });
        });
      };
      Z.autoRemove = function(d) {
        return !d;
      };
      var Ve = function(d, b, S) {
        return d.filter(function(E) {
          return b.some(function(L) {
            var T = E.values[L];
            return T === void 0 || String(T).toLowerCase() === String(S).toLowerCase();
          });
        });
      };
      Ve.autoRemove = function(d) {
        return !d;
      };
      var ct = function(d, b, S) {
        return d.filter(function(E) {
          return b.some(function(L) {
            var T = E.values[L];
            return T === void 0 || String(T) === String(S);
          });
        });
      };
      ct.autoRemove = function(d) {
        return !d;
      };
      var Mt = function(d, b, S) {
        return d.filter(function(E) {
          return b.some(function(L) {
            return E.values[L].includes(S);
          });
        });
      };
      Mt.autoRemove = function(d) {
        return !d || !d.length;
      };
      var Et = function(d, b, S) {
        return d.filter(function(E) {
          return b.some(function(L) {
            var T = E.values[L];
            return T && T.length && S.every(function(B) {
              return T.includes(B);
            });
          });
        });
      };
      Et.autoRemove = function(d) {
        return !d || !d.length;
      };
      var vr = function(d, b, S) {
        return d.filter(function(E) {
          return b.some(function(L) {
            var T = E.values[L];
            return T && T.length && S.some(function(B) {
              return T.includes(B);
            });
          });
        });
      };
      vr.autoRemove = function(d) {
        return !d || !d.length;
      };
      var Rr = function(d, b, S) {
        return d.filter(function(E) {
          return b.some(function(L) {
            var T = E.values[L];
            return S.includes(T);
          });
        });
      };
      Rr.autoRemove = function(d) {
        return !d || !d.length;
      };
      var Br = function(d, b, S) {
        return d.filter(function(E) {
          return b.some(function(L) {
            return E.values[L] === S;
          });
        });
      };
      Br.autoRemove = function(d) {
        return d === void 0;
      };
      var Hn = function(d, b, S) {
        return d.filter(function(E) {
          return b.some(function(L) {
            return E.values[L] == S;
          });
        });
      };
      Hn.autoRemove = function(d) {
        return d == null;
      };
      var Zr = function(d, b, S) {
        var E = S || [], L = E[0], T = E[1];
        if ((L = typeof L == "number" ? L : -1 / 0) > (T = typeof T == "number" ? T : 1 / 0)) {
          var B = L;
          L = T, T = B;
        }
        return d.filter(function(X) {
          return b.some(function(te) {
            var ne = X.values[te];
            return ne >= L && ne <= T;
          });
        });
      };
      Zr.autoRemove = function(d) {
        return !d || typeof d[0] != "number" && typeof d[1] != "number";
      };
      var pn = Object.freeze({ __proto__: null, text: Z, exactText: Ve, exactTextCase: ct, includes: Mt, includesAll: Et, includesSome: vr, includesValue: Rr, exact: Br, equals: Hn, between: Zr });
      u.resetFilters = "resetFilters", u.setFilter = "setFilter", u.setAllFilters = "setAllFilters";
      var Yn = function(d) {
        d.stateReducers.push(mn), d.useInstance.push(Eo);
      };
      function mn(d, b, S, E) {
        if (b.type === u.init)
          return i({ filters: [] }, d);
        if (b.type === u.resetFilters)
          return i({}, d, { filters: E.initialState.filters || [] });
        if (b.type === u.setFilter) {
          var L = b.columnId, T = b.filterValue, B = E.allColumns, X = E.filterTypes, te = B.find(function(Te) {
            return Te.id === L;
          });
          if (!te)
            throw new Error("React-Table: Could not find a column with id: " + L);
          var ne = be(te.filter, X || {}, pn), Se = d.filters.find(function(Te) {
            return Te.id === L;
          }), we = I(T, Se && Se.value);
          return he(ne.autoRemove, we, te) ? i({}, d, { filters: d.filters.filter(function(Te) {
            return Te.id !== L;
          }) }) : i({}, d, Se ? { filters: d.filters.map(function(Te) {
            return Te.id === L ? { id: L, value: we } : Te;
          }) } : { filters: [].concat(d.filters, [{ id: L, value: we }]) });
        }
        if (b.type === u.setAllFilters) {
          var xe = b.filters, se = E.allColumns, ye = E.filterTypes;
          return i({}, d, { filters: I(xe, d.filters).filter(function(Te) {
            var Ae = se.find(function(rt) {
              return rt.id === Te.id;
            });
            return !he(be(Ae.filter, ye || {}, pn).autoRemove, Te.value, Ae);
          }) });
        }
      }
      function Eo(d) {
        var b = d.data, S = d.rows, E = d.flatRows, L = d.rowsById, T = d.allColumns, B = d.filterTypes, X = d.manualFilters, te = d.defaultCanFilter, ne = te !== void 0 && te, Se = d.disableFilters, we = d.state.filters, xe = d.dispatch, se = d.autoResetFilters, ye = se === void 0 || se, Te = t.useCallback(function(qe, mt) {
          xe({ type: u.setFilter, columnId: qe, filterValue: mt });
        }, [xe]), Ae = t.useCallback(function(qe) {
          xe({ type: u.setAllFilters, filters: qe });
        }, [xe]);
        T.forEach(function(qe) {
          var mt = qe.id, _t = qe.accessor, pt = qe.defaultCanFilter, gt = qe.disableFilters;
          qe.canFilter = _t ? U(gt !== !0 && void 0, Se !== !0 && void 0, !0) : U(pt, ne, !1), qe.setFilter = function(wt) {
            return Te(qe.id, wt);
          };
          var zt = we.find(function(wt) {
            return wt.id === mt;
          });
          qe.filterValue = zt && zt.value;
        });
        var rt = t.useMemo(function() {
          if (X || !we.length)
            return [S, E, L];
          var qe = [], mt = {};
          return [function _t(pt, gt) {
            gt === void 0 && (gt = 0);
            var zt = pt;
            return (zt = we.reduce(function(wt, Lt) {
              var f = Lt.id, v = Lt.value, w = T.find(function(D) {
                return D.id === f;
              });
              if (!w)
                return wt;
              gt === 0 && (w.preFilteredRows = wt);
              var m = be(w.filter, B || {}, pn);
              return m ? (w.filteredRows = m(wt, [f], v), w.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + w.id + "."), wt);
            }, pt)).forEach(function(wt) {
              qe.push(wt), mt[wt.id] = wt, wt.subRows && (wt.subRows = wt.subRows && wt.subRows.length > 0 ? _t(wt.subRows, gt + 1) : wt.subRows);
            }), zt;
          }(S), qe, mt];
        }, [X, we, S, E, L, T, B]), Ot = rt[0], nt = rt[1], Oe = rt[2];
        t.useMemo(function() {
          T.filter(function(qe) {
            return !we.find(function(mt) {
              return mt.id === qe.id;
            });
          }).forEach(function(qe) {
            qe.preFilteredRows = Ot, qe.filteredRows = Ot;
          });
        }, [Ot, we, T]);
        var xt = H(ye);
        _(function() {
          xt() && xe({ type: u.resetFilters });
        }, [xe, X ? null : b]), Object.assign(d, { preFilteredRows: S, preFilteredFlatRows: E, preFilteredRowsById: L, filteredRows: Ot, filteredFlatRows: nt, filteredRowsById: Oe, rows: Ot, flatRows: nt, rowsById: Oe, setFilter: Te, setAllFilters: Ae });
      }
      Yn.pluginName = "useFilters", u.resetGlobalFilter = "resetGlobalFilter", u.setGlobalFilter = "setGlobalFilter";
      var $n = function(d) {
        d.stateReducers.push(Dn), d.useInstance.push(ha);
      };
      function Dn(d, b, S, E) {
        if (b.type === u.resetGlobalFilter)
          return i({}, d, { globalFilter: E.initialState.globalFilter || void 0 });
        if (b.type === u.setGlobalFilter) {
          var L = b.filterValue, T = E.userFilterTypes, B = be(E.globalFilter, T || {}, pn), X = I(L, d.globalFilter);
          return he(B.autoRemove, X) ? (d.globalFilter, s(d, ["globalFilter"])) : i({}, d, { globalFilter: X });
        }
      }
      function ha(d) {
        var b = d.data, S = d.rows, E = d.flatRows, L = d.rowsById, T = d.allColumns, B = d.filterTypes, X = d.globalFilter, te = d.manualGlobalFilter, ne = d.state.globalFilter, Se = d.dispatch, we = d.autoResetGlobalFilter, xe = we === void 0 || we, se = d.disableGlobalFilter, ye = t.useCallback(function(Oe) {
          Se({ type: u.setGlobalFilter, filterValue: Oe });
        }, [Se]), Te = t.useMemo(function() {
          if (te || ne === void 0)
            return [S, E, L];
          var Oe = [], xt = {}, qe = be(X, B || {}, pn);
          if (!qe)
            return console.warn("Could not find a valid 'globalFilter' option."), S;
          T.forEach(function(_t) {
            var pt = _t.disableGlobalFilter;
            _t.canFilter = U(pt !== !0 && void 0, se !== !0 && void 0, !0);
          });
          var mt = T.filter(function(_t) {
            return _t.canFilter === !0;
          });
          return [function _t(pt) {
            return (pt = qe(pt, mt.map(function(gt) {
              return gt.id;
            }), ne)).forEach(function(gt) {
              Oe.push(gt), xt[gt.id] = gt, gt.subRows = gt.subRows && gt.subRows.length ? _t(gt.subRows) : gt.subRows;
            }), pt;
          }(S), Oe, xt];
        }, [te, ne, X, B, T, S, E, L, se]), Ae = Te[0], rt = Te[1], Ot = Te[2], nt = H(xe);
        _(function() {
          nt() && Se({ type: u.resetGlobalFilter });
        }, [Se, te ? null : b]), Object.assign(d, { preGlobalFilteredRows: S, preGlobalFilteredFlatRows: E, preGlobalFilteredRowsById: L, globalFilteredRows: Ae, globalFilteredFlatRows: rt, globalFilteredRowsById: Ot, rows: Ae, flatRows: rt, rowsById: Ot, setGlobalFilter: ye, disableGlobalFilter: se });
      }
      function Ko(d, b) {
        return b.reduce(function(S, E) {
          return S + (typeof E == "number" ? E : 0);
        }, 0);
      }
      $n.pluginName = "useGlobalFilter";
      var ko = Object.freeze({ __proto__: null, sum: Ko, min: function(d) {
        var b = d[0] || 0;
        return d.forEach(function(S) {
          typeof S == "number" && (b = Math.min(b, S));
        }), b;
      }, max: function(d) {
        var b = d[0] || 0;
        return d.forEach(function(S) {
          typeof S == "number" && (b = Math.max(b, S));
        }), b;
      }, minMax: function(d) {
        var b = d[0] || 0, S = d[0] || 0;
        return d.forEach(function(E) {
          typeof E == "number" && (b = Math.min(b, E), S = Math.max(S, E));
        }), b + ".." + S;
      }, average: function(d) {
        return Ko(0, d) / d.length;
      }, median: function(d) {
        if (!d.length)
          return null;
        var b = Math.floor(d.length / 2), S = [].concat(d).sort(function(E, L) {
          return E - L;
        });
        return d.length % 2 != 0 ? S[b] : (S[b - 1] + S[b]) / 2;
      }, unique: function(d) {
        return Array.from(new Set(d).values());
      }, uniqueCount: function(d) {
        return new Set(d).size;
      }, count: function(d) {
        return d.length;
      } }), ma = [], ya = {};
      u.resetGroupBy = "resetGroupBy", u.setGroupBy = "setGroupBy", u.toggleGroupBy = "toggleGroupBy";
      var Qo = function(d) {
        d.getGroupByToggleProps = [ba], d.stateReducers.push(N), d.visibleColumnsDeps.push(function(b, S) {
          var E = S.instance;
          return [].concat(b, [E.state.groupBy]);
        }), d.visibleColumns.push(pe), d.useInstance.push(bt), d.prepareRow.push(Bt);
      };
      Qo.pluginName = "useGroupBy";
      var ba = function(d, b) {
        var S = b.header;
        return [d, { onClick: S.canGroupBy ? function(E) {
          E.persist(), S.toggleGroupBy();
        } : void 0, style: { cursor: S.canGroupBy ? "pointer" : void 0 }, title: "Toggle GroupBy" }];
      };
      function N(d, b, S, E) {
        if (b.type === u.init)
          return i({ groupBy: [] }, d);
        if (b.type === u.resetGroupBy)
          return i({}, d, { groupBy: E.initialState.groupBy || [] });
        if (b.type === u.setGroupBy)
          return i({}, d, { groupBy: b.value });
        if (b.type === u.toggleGroupBy) {
          var L = b.columnId, T = b.value, B = T !== void 0 ? T : !d.groupBy.includes(L);
          return i({}, d, B ? { groupBy: [].concat(d.groupBy, [L]) } : { groupBy: d.groupBy.filter(function(X) {
            return X !== L;
          }) });
        }
      }
      function pe(d, b) {
        var S = b.instance.state.groupBy, E = S.map(function(T) {
          return d.find(function(B) {
            return B.id === T;
          });
        }).filter(Boolean), L = d.filter(function(T) {
          return !S.includes(T.id);
        });
        return (d = [].concat(E, L)).forEach(function(T) {
          T.isGrouped = S.includes(T.id), T.groupedIndex = S.indexOf(T.id);
        }), d;
      }
      var Ie = {};
      function bt(d) {
        var b = d.data, S = d.rows, E = d.flatRows, L = d.rowsById, T = d.allColumns, B = d.flatHeaders, X = d.groupByFn, te = X === void 0 ? rr : X, ne = d.manualGroupBy, Se = d.aggregations, we = Se === void 0 ? Ie : Se, xe = d.plugins, se = d.state.groupBy, ye = d.dispatch, Te = d.autoResetGroupBy, Ae = Te === void 0 || Te, rt = d.disableGroupBy, Ot = d.defaultCanGroupBy, nt = d.getHooks;
        $(xe, ["useColumnOrder", "useFilters"], "useGroupBy");
        var Oe = H(d);
        T.forEach(function(w) {
          var m = w.accessor, D = w.defaultGroupBy, M = w.disableGroupBy;
          w.canGroupBy = m ? U(w.canGroupBy, M !== !0 && void 0, rt !== !0 && void 0, !0) : U(w.canGroupBy, D, Ot, !1), w.canGroupBy && (w.toggleGroupBy = function() {
            return d.toggleGroupBy(w.id);
          }), w.Aggregated = w.Aggregated || w.Cell;
        });
        var xt = t.useCallback(function(w, m) {
          ye({ type: u.toggleGroupBy, columnId: w, value: m });
        }, [ye]), qe = t.useCallback(function(w) {
          ye({ type: u.setGroupBy, value: w });
        }, [ye]);
        B.forEach(function(w) {
          w.getGroupByToggleProps = C(nt().getGroupByToggleProps, { instance: Oe(), header: w });
        });
        var mt = t.useMemo(function() {
          if (ne || !se.length)
            return [S, E, L, ma, ya, E, L];
          var w = se.filter(function(ae) {
            return T.find(function(Ee) {
              return Ee.id === ae;
            });
          }), m = [], D = {}, M = [], R = {}, W = [], q = {}, J = function ae(Ee, de, Ce) {
            if (de === void 0 && (de = 0), de === w.length)
              return Ee.map(function(He) {
                return i({}, He, { depth: de });
              });
            var $e = w[de], ue = te(Ee, $e);
            return Object.entries(ue).map(function(He, st) {
              var vt = He[0], Me = He[1], Ct = $e + ":" + vt, Tt = ae(Me, de + 1, Ct = Ce ? Ce + ">" + Ct : Ct), Fe = de ? oe(Me, "leafRows") : Me, je = function(ot, Pt, kt) {
                var ar = {};
                return T.forEach(function(Qe) {
                  if (w.includes(Qe.id))
                    ar[Qe.id] = Pt[0] ? Pt[0].values[Qe.id] : null;
                  else {
                    var Mr = typeof Qe.aggregate == "function" ? Qe.aggregate : we[Qe.aggregate] || ko[Qe.aggregate];
                    if (Mr) {
                      var Rt = Pt.map(function(yt) {
                        return yt.values[Qe.id];
                      }), ht = ot.map(function(yt) {
                        var cr = yt.values[Qe.id];
                        if (!kt && Qe.aggregateValue) {
                          var Wr = typeof Qe.aggregateValue == "function" ? Qe.aggregateValue : we[Qe.aggregateValue] || ko[Qe.aggregateValue];
                          if (!Wr)
                            throw console.info({ column: Qe }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                          cr = Wr(cr, yt, Qe);
                        }
                        return cr;
                      });
                      ar[Qe.id] = Mr(ht, Rt);
                    } else {
                      if (Qe.aggregate)
                        throw console.info({ column: Qe }), new Error("React Table: Invalid column.aggregate option for column listed above");
                      ar[Qe.id] = null;
                    }
                  }
                }), ar;
              }(Fe, Me, de), Le = { id: Ct, isGrouped: !0, groupByID: $e, groupByVal: vt, values: je, subRows: Tt, leafRows: Fe, depth: de, index: st };
              return Tt.forEach(function(ot) {
                m.push(ot), D[ot.id] = ot, ot.isGrouped ? (M.push(ot), R[ot.id] = ot) : (W.push(ot), q[ot.id] = ot);
              }), Le;
            });
          }(S);
          return J.forEach(function(ae) {
            m.push(ae), D[ae.id] = ae, ae.isGrouped ? (M.push(ae), R[ae.id] = ae) : (W.push(ae), q[ae.id] = ae);
          }), [J, m, D, M, R, W, q];
        }, [ne, se, S, E, L, T, we, te]), _t = mt[0], pt = mt[1], gt = mt[2], zt = mt[3], wt = mt[4], Lt = mt[5], f = mt[6], v = H(Ae);
        _(function() {
          v() && ye({ type: u.resetGroupBy });
        }, [ye, ne ? null : b]), Object.assign(d, { preGroupedRows: S, preGroupedFlatRow: E, preGroupedRowsById: L, groupedRows: _t, groupedFlatRows: pt, groupedRowsById: gt, onlyGroupedFlatRows: zt, onlyGroupedRowsById: wt, nonGroupedFlatRows: Lt, nonGroupedRowsById: f, rows: _t, flatRows: pt, rowsById: gt, toggleGroupBy: xt, setGroupBy: qe });
      }
      function Bt(d) {
        d.allCells.forEach(function(b) {
          var S;
          b.isGrouped = b.column.isGrouped && b.column.id === d.groupByID, b.isPlaceholder = !b.isGrouped && b.column.isGrouped, b.isAggregated = !b.isGrouped && !b.isPlaceholder && ((S = d.subRows) == null ? void 0 : S.length);
        });
      }
      function rr(d, b) {
        return d.reduce(function(S, E, L) {
          var T = "" + E.values[b];
          return S[T] = Array.isArray(S[T]) ? S[T] : [], S[T].push(E), S;
        }, {});
      }
      var At = /([0-9]+)/gm;
      function jt(d, b) {
        return d === b ? 0 : d > b ? 1 : -1;
      }
      function wr(d, b, S) {
        return [d.values[S], b.values[S]];
      }
      function gr(d) {
        return typeof d == "number" ? isNaN(d) || d === 1 / 0 || d === -1 / 0 ? "" : String(d) : typeof d == "string" ? d : "";
      }
      var yr = Object.freeze({ __proto__: null, alphanumeric: function(d, b, S) {
        var E = wr(d, b, S), L = E[0], T = E[1];
        for (L = gr(L), T = gr(T), L = L.split(At).filter(Boolean), T = T.split(At).filter(Boolean); L.length && T.length; ) {
          var B = L.shift(), X = T.shift(), te = parseInt(B, 10), ne = parseInt(X, 10), Se = [te, ne].sort();
          if (isNaN(Se[0])) {
            if (B > X)
              return 1;
            if (X > B)
              return -1;
          } else {
            if (isNaN(Se[1]))
              return isNaN(te) ? -1 : 1;
            if (te > ne)
              return 1;
            if (ne > te)
              return -1;
          }
        }
        return L.length - T.length;
      }, datetime: function(d, b, S) {
        var E = wr(d, b, S), L = E[0], T = E[1];
        return jt(L = L.getTime(), T = T.getTime());
      }, basic: function(d, b, S) {
        var E = wr(d, b, S);
        return jt(E[0], E[1]);
      }, string: function(d, b, S) {
        var E = wr(d, b, S), L = E[0], T = E[1];
        for (L = L.split("").filter(Boolean), T = T.split("").filter(Boolean); L.length && T.length; ) {
          var B = L.shift(), X = T.shift(), te = B.toLowerCase(), ne = X.toLowerCase();
          if (te > ne)
            return 1;
          if (ne > te)
            return -1;
          if (B > X)
            return 1;
          if (X > B)
            return -1;
        }
        return L.length - T.length;
      }, number: function(d, b, S) {
        var E = wr(d, b, S), L = E[0], T = E[1], B = /[^0-9.]/gi;
        return jt(L = Number(String(L).replace(B, "")), T = Number(String(T).replace(B, "")));
      } });
      u.resetSortBy = "resetSortBy", u.setSortBy = "setSortBy", u.toggleSortBy = "toggleSortBy", u.clearSortBy = "clearSortBy", h.sortType = "alphanumeric", h.sortDescFirst = !1;
      var Kr = function(d) {
        d.getSortByToggleProps = [Xn], d.stateReducers.push(wa), d.useInstance.push(yn);
      };
      Kr.pluginName = "useSortBy";
      var Xn = function(d, b) {
        var S = b.instance, E = b.column, L = S.isMultiSortEvent, T = L === void 0 ? function(B) {
          return B.shiftKey;
        } : L;
        return [d, { onClick: E.canSort ? function(B) {
          B.persist(), E.toggleSortBy(void 0, !S.disableMultiSort && T(B));
        } : void 0, style: { cursor: E.canSort ? "pointer" : void 0 }, title: E.canSort ? "Toggle SortBy" : void 0 }];
      };
      function wa(d, b, S, E) {
        if (b.type === u.init)
          return i({ sortBy: [] }, d);
        if (b.type === u.resetSortBy)
          return i({}, d, { sortBy: E.initialState.sortBy || [] });
        if (b.type === u.clearSortBy)
          return i({}, d, { sortBy: d.sortBy.filter(function(Oe) {
            return Oe.id !== b.columnId;
          }) });
        if (b.type === u.setSortBy)
          return i({}, d, { sortBy: b.sortBy });
        if (b.type === u.toggleSortBy) {
          var L, T = b.columnId, B = b.desc, X = b.multi, te = E.allColumns, ne = E.disableMultiSort, Se = E.disableSortRemove, we = E.disableMultiRemove, xe = E.maxMultiSortColCount, se = xe === void 0 ? Number.MAX_SAFE_INTEGER : xe, ye = d.sortBy, Te = te.find(function(Oe) {
            return Oe.id === T;
          }).sortDescFirst, Ae = ye.find(function(Oe) {
            return Oe.id === T;
          }), rt = ye.findIndex(function(Oe) {
            return Oe.id === T;
          }), Ot = B != null, nt = [];
          return (L = !ne && X ? Ae ? "toggle" : "add" : rt !== ye.length - 1 || ye.length !== 1 ? "replace" : Ae ? "toggle" : "replace") != "toggle" || Se || Ot || X && we || !(Ae && Ae.desc && !Te || !Ae.desc && Te) || (L = "remove"), L === "replace" ? nt = [{ id: T, desc: Ot ? B : Te }] : L === "add" ? (nt = [].concat(ye, [{ id: T, desc: Ot ? B : Te }])).splice(0, nt.length - se) : L === "toggle" ? nt = ye.map(function(Oe) {
            return Oe.id === T ? i({}, Oe, { desc: Ot ? B : !Ae.desc }) : Oe;
          }) : L === "remove" && (nt = ye.filter(function(Oe) {
            return Oe.id !== T;
          })), i({}, d, { sortBy: nt });
        }
      }
      function yn(d) {
        var b = d.data, S = d.rows, E = d.flatRows, L = d.allColumns, T = d.orderByFn, B = T === void 0 ? ts : T, X = d.sortTypes, te = d.manualSortBy, ne = d.defaultCanSort, Se = d.disableSortBy, we = d.flatHeaders, xe = d.state.sortBy, se = d.dispatch, ye = d.plugins, Te = d.getHooks, Ae = d.autoResetSortBy, rt = Ae === void 0 || Ae;
        $(ye, ["useFilters", "useGlobalFilter", "useGroupBy", "usePivotColumns"], "useSortBy");
        var Ot = t.useCallback(function(pt) {
          se({ type: u.setSortBy, sortBy: pt });
        }, [se]), nt = t.useCallback(function(pt, gt, zt) {
          se({ type: u.toggleSortBy, columnId: pt, desc: gt, multi: zt });
        }, [se]), Oe = H(d);
        we.forEach(function(pt) {
          var gt = pt.accessor, zt = pt.canSort, wt = pt.disableSortBy, Lt = pt.id, f = gt ? U(wt !== !0 && void 0, Se !== !0 && void 0, !0) : U(ne, zt, !1);
          pt.canSort = f, pt.canSort && (pt.toggleSortBy = function(w, m) {
            return nt(pt.id, w, m);
          }, pt.clearSortBy = function() {
            se({ type: u.clearSortBy, columnId: pt.id });
          }), pt.getSortByToggleProps = C(Te().getSortByToggleProps, { instance: Oe(), column: pt });
          var v = xe.find(function(w) {
            return w.id === Lt;
          });
          pt.isSorted = !!v, pt.sortedIndex = xe.findIndex(function(w) {
            return w.id === Lt;
          }), pt.isSortedDesc = pt.isSorted ? v.desc : void 0;
        });
        var xt = t.useMemo(function() {
          if (te || !xe.length)
            return [S, E];
          var pt = [], gt = xe.filter(function(zt) {
            return L.find(function(wt) {
              return wt.id === zt.id;
            });
          });
          return [function zt(wt) {
            var Lt = B(wt, gt.map(function(f) {
              var v = L.find(function(D) {
                return D.id === f.id;
              });
              if (!v)
                throw new Error("React-Table: Could not find a column with id: " + f.id + " while sorting");
              var w = v.sortType, m = ee(w) || (X || {})[w] || yr[w];
              if (!m)
                throw new Error("React-Table: Could not find a valid sortType of '" + w + "' for column '" + f.id + "'.");
              return function(D, M) {
                return m(D, M, f.id, f.desc);
              };
            }), gt.map(function(f) {
              var v = L.find(function(w) {
                return w.id === f.id;
              });
              return v && v.sortInverted ? f.desc : !f.desc;
            }));
            return Lt.forEach(function(f) {
              pt.push(f), f.subRows && f.subRows.length !== 0 && (f.subRows = zt(f.subRows));
            }), Lt;
          }(S), pt];
        }, [te, xe, S, E, L, B, X]), qe = xt[0], mt = xt[1], _t = H(rt);
        _(function() {
          _t() && se({ type: u.resetSortBy });
        }, [te ? null : b]), Object.assign(d, { preSortedRows: S, preSortedFlatRows: E, sortedRows: qe, sortedFlatRows: mt, rows: qe, flatRows: mt, setSortBy: Ot, toggleSortBy: nt });
      }
      function ts(d, b, S) {
        return [].concat(d).sort(function(E, L) {
          for (var T = 0; T < b.length; T += 1) {
            var B = b[T], X = S[T] === !1 || S[T] === "desc", te = B(E, L);
            if (te !== 0)
              return X ? -te : te;
          }
          return S[0] ? E.index - L.index : L.index - E.index;
        });
      }
      u.resetPage = "resetPage", u.gotoPage = "gotoPage", u.setPageSize = "setPageSize";
      var Za = function(d) {
        d.stateReducers.push(Vl), d.useInstance.push(Ul);
      };
      function Vl(d, b, S, E) {
        if (b.type === u.init)
          return i({ pageSize: 10, pageIndex: 0 }, d);
        if (b.type === u.resetPage)
          return i({}, d, { pageIndex: E.initialState.pageIndex || 0 });
        if (b.type === u.gotoPage) {
          var L = E.pageCount, T = E.page, B = I(b.pageIndex, d.pageIndex), X = !1;
          return B > d.pageIndex ? X = L === -1 ? T.length >= d.pageSize : B < L : B < d.pageIndex && (X = B > -1), X ? i({}, d, { pageIndex: B }) : d;
        }
        if (b.type === u.setPageSize) {
          var te = b.pageSize, ne = d.pageSize * d.pageIndex;
          return i({}, d, { pageIndex: Math.floor(ne / te), pageSize: te });
        }
      }
      function Ul(d) {
        var b = d.rows, S = d.autoResetPage, E = S === void 0 || S, L = d.manualExpandedKey, T = L === void 0 ? "expanded" : L, B = d.plugins, X = d.pageCount, te = d.paginateExpandedRows, ne = te === void 0 || te, Se = d.expandSubRows, we = Se === void 0 || Se, xe = d.state, se = xe.pageSize, ye = xe.pageIndex, Te = xe.expanded, Ae = xe.globalFilter, rt = xe.filters, Ot = xe.groupBy, nt = xe.sortBy, Oe = d.dispatch, xt = d.data, qe = d.manualPagination;
        $(B, ["useGlobalFilter", "useFilters", "useGroupBy", "useSortBy", "useExpanded"], "usePagination");
        var mt = H(E);
        _(function() {
          mt() && Oe({ type: u.resetPage });
        }, [Oe, qe ? null : xt, Ae, rt, Ot, nt]);
        var _t = qe ? X : Math.ceil(b.length / se), pt = t.useMemo(function() {
          return _t > 0 ? [].concat(new Array(_t)).fill(null).map(function(m, D) {
            return D;
          }) : [];
        }, [_t]), gt = t.useMemo(function() {
          var m;
          if (qe)
            m = b;
          else {
            var D = se * ye, M = D + se;
            m = b.slice(D, M);
          }
          return ne ? m : ge(m, { manualExpandedKey: T, expanded: Te, expandSubRows: we });
        }, [we, Te, T, qe, ye, se, ne, b]), zt = ye > 0, wt = _t === -1 ? gt.length >= se : ye < _t - 1, Lt = t.useCallback(function(m) {
          Oe({ type: u.gotoPage, pageIndex: m });
        }, [Oe]), f = t.useCallback(function() {
          return Lt(function(m) {
            return m - 1;
          });
        }, [Lt]), v = t.useCallback(function() {
          return Lt(function(m) {
            return m + 1;
          });
        }, [Lt]), w = t.useCallback(function(m) {
          Oe({ type: u.setPageSize, pageSize: m });
        }, [Oe]);
        Object.assign(d, { pageOptions: pt, pageCount: _t, page: gt, canPreviousPage: zt, canNextPage: wt, gotoPage: Lt, previousPage: f, nextPage: v, setPageSize: w });
      }
      Za.pluginName = "usePagination", u.resetPivot = "resetPivot", u.togglePivot = "togglePivot";
      var ei = function(d) {
        d.getPivotToggleProps = [ql], d.stateReducers.push(Kl), d.useInstanceAfterData.push(Ql), d.allColumns.push(Xl), d.accessValue.push(Jl), d.materializedColumns.push(ns), d.materializedColumnsDeps.push(os), d.visibleColumns.push(Zl), d.visibleColumnsDeps.push(eu), d.useInstance.push(tu), d.prepareRow.push(ru);
      };
      ei.pluginName = "usePivotColumns";
      var rs = [], ql = function(d, b) {
        var S = b.header;
        return [d, { onClick: S.canPivot ? function(E) {
          E.persist(), S.togglePivot();
        } : void 0, style: { cursor: S.canPivot ? "pointer" : void 0 }, title: "Toggle Pivot" }];
      };
      function Kl(d, b, S, E) {
        if (b.type === u.init)
          return i({ pivotColumns: rs }, d);
        if (b.type === u.resetPivot)
          return i({}, d, { pivotColumns: E.initialState.pivotColumns || rs });
        if (b.type === u.togglePivot) {
          var L = b.columnId, T = b.value, B = T !== void 0 ? T : !d.pivotColumns.includes(L);
          return i({}, d, B ? { pivotColumns: [].concat(d.pivotColumns, [L]) } : { pivotColumns: d.pivotColumns.filter(function(X) {
            return X !== L;
          }) });
        }
      }
      function Ql(d) {
        d.allColumns.forEach(function(b) {
          b.isPivotSource = d.state.pivotColumns.includes(b.id);
        });
      }
      function Xl(d, b) {
        var S = b.instance;
        return d.forEach(function(E) {
          E.isPivotSource = S.state.pivotColumns.includes(E.id), E.uniqueValues = /* @__PURE__ */ new Set();
        }), d;
      }
      function Jl(d, b) {
        var S = b.column;
        return S.uniqueValues && d !== void 0 && S.uniqueValues.add(d), d;
      }
      function ns(d, b) {
        var S = b.instance, E = S.allColumns, L = S.state;
        if (!L.pivotColumns.length || !L.groupBy || !L.groupBy.length)
          return d;
        var T = L.pivotColumns.map(function(te) {
          return E.find(function(ne) {
            return ne.id === te;
          });
        }).filter(Boolean), B = E.filter(function(te) {
          return !te.isPivotSource && !L.groupBy.includes(te.id) && !L.pivotColumns.includes(te.id);
        }), X = V(function te(ne, Se, we) {
          ne === void 0 && (ne = 0), we === void 0 && (we = []);
          var xe = T[ne];
          return xe ? Array.from(xe.uniqueValues).sort().map(function(se) {
            var ye = i({}, xe, { Header: xe.PivotHeader || typeof xe.header == "string" ? xe.Header + ": " + se : se, isPivotGroup: !0, parent: Se, depth: ne, id: Se ? Se.id + "." + xe.id + "." + se : xe.id + "." + se, pivotValue: se });
            return ye.columns = te(ne + 1, ye, [].concat(we, [function(Te) {
              return Te.values[xe.id] === se;
            }])), ye;
          }) : B.map(function(se) {
            return i({}, se, { canPivot: !1, isPivoted: !0, parent: Se, depth: ne, id: "" + (Se ? Se.id + "." + se.id : se.id), accessor: function(ye, Te, Ae) {
              if (we.every(function(rt) {
                return rt(Ae);
              }))
                return Ae.values[se.id];
            } });
          });
        }());
        return [].concat(d, X);
      }
      function os(d, b) {
        var S = b.instance.state, E = S.pivotColumns, L = S.groupBy;
        return [].concat(d, [E, L]);
      }
      function Zl(d, b) {
        var S = b.instance.state;
        return d = d.filter(function(E) {
          return !E.isPivotSource;
        }), S.pivotColumns.length && S.groupBy && S.groupBy.length && (d = d.filter(function(E) {
          return E.isGrouped || E.isPivoted;
        })), d;
      }
      function eu(d, b) {
        var S = b.instance;
        return [].concat(d, [S.state.pivotColumns, S.state.groupBy]);
      }
      function tu(d) {
        var b = d.columns, S = d.allColumns, E = d.flatHeaders, L = d.getHooks, T = d.plugins, B = d.dispatch, X = d.autoResetPivot, te = X === void 0 || X, ne = d.manaulPivot, Se = d.disablePivot, we = d.defaultCanPivot;
        $(T, ["useGroupBy"], "usePivotColumns");
        var xe = H(d);
        S.forEach(function(ye) {
          var Te = ye.accessor, Ae = ye.defaultPivot, rt = ye.disablePivot;
          ye.canPivot = Te ? U(ye.canPivot, rt !== !0 && void 0, Se !== !0 && void 0, !0) : U(ye.canPivot, Ae, we, !1), ye.canPivot && (ye.togglePivot = function() {
            return d.togglePivot(ye.id);
          }), ye.Aggregated = ye.Aggregated || ye.Cell;
        }), E.forEach(function(ye) {
          ye.getPivotToggleProps = C(L().getPivotToggleProps, { instance: xe(), header: ye });
        });
        var se = H(te);
        _(function() {
          se() && B({ type: u.resetPivot });
        }, [B, ne ? null : b]), Object.assign(d, { togglePivot: function(ye, Te) {
          B({ type: u.togglePivot, columnId: ye, value: Te });
        } });
      }
      function ru(d) {
        d.allCells.forEach(function(b) {
          b.isPivoted = b.column.isPivoted;
        });
      }
      u.resetSelectedRows = "resetSelectedRows", u.toggleAllRowsSelected = "toggleAllRowsSelected", u.toggleRowSelected = "toggleRowSelected", u.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
      var as = function(d) {
        d.getToggleRowSelectedProps = [ti], d.getToggleAllRowsSelectedProps = [Xo], d.getToggleAllPageRowsSelectedProps = [is], d.stateReducers.push(nu), d.useInstance.push(ss), d.prepareRow.push(ou);
      };
      as.pluginName = "useRowSelect";
      var ti = function(d, b) {
        var S = b.instance, E = b.row, L = S.manualRowSelectedKey, T = L === void 0 ? "isSelected" : L;
        return [d, { onChange: function(B) {
          E.toggleRowSelected(B.target.checked);
        }, style: { cursor: "pointer" }, checked: !(!E.original || !E.original[T]) || E.isSelected, title: "Toggle Row Selected", indeterminate: E.isSomeSelected }];
      }, Xo = function(d, b) {
        var S = b.instance;
        return [d, { onChange: function(E) {
          S.toggleAllRowsSelected(E.target.checked);
        }, style: { cursor: "pointer" }, checked: S.isAllRowsSelected, title: "Toggle All Rows Selected", indeterminate: !!(!S.isAllRowsSelected && Object.keys(S.state.selectedRowIds).length) }];
      }, is = function(d, b) {
        var S = b.instance;
        return [d, { onChange: function(E) {
          S.toggleAllPageRowsSelected(E.target.checked);
        }, style: { cursor: "pointer" }, checked: S.isAllPageRowsSelected, title: "Toggle All Current Page Rows Selected", indeterminate: !!(!S.isAllPageRowsSelected && S.page.some(function(E) {
          var L = E.id;
          return S.state.selectedRowIds[L];
        })) }];
      };
      function nu(d, b, S, E) {
        if (b.type === u.init)
          return i({ selectedRowIds: {} }, d);
        if (b.type === u.resetSelectedRows)
          return i({}, d, { selectedRowIds: E.initialState.selectedRowIds || {} });
        if (b.type === u.toggleAllRowsSelected) {
          var L = b.value, T = E.isAllRowsSelected, B = E.rowsById, X = E.nonGroupedRowsById, te = X === void 0 ? B : X, ne = L !== void 0 ? L : !T, Se = Object.assign({}, d.selectedRowIds);
          return ne ? Object.keys(te).forEach(function(Lt) {
            Se[Lt] = !0;
          }) : Object.keys(te).forEach(function(Lt) {
            delete Se[Lt];
          }), i({}, d, { selectedRowIds: Se });
        }
        if (b.type === u.toggleRowSelected) {
          var we = b.id, xe = b.value, se = E.rowsById, ye = E.selectSubRows, Te = ye === void 0 || ye, Ae = E.getSubRows, rt = d.selectedRowIds[we], Ot = xe !== void 0 ? xe : !rt;
          if (rt === Ot)
            return d;
          var nt = i({}, d.selectedRowIds);
          return function Lt(f) {
            var v = se[f];
            if (v && (v.isGrouped || (Ot ? nt[f] = !0 : delete nt[f]), Te && Ae(v)))
              return Ae(v).forEach(function(w) {
                return Lt(w.id);
              });
          }(we), i({}, d, { selectedRowIds: nt });
        }
        if (b.type === u.toggleAllPageRowsSelected) {
          var Oe = b.value, xt = E.page, qe = E.rowsById, mt = E.selectSubRows, _t = mt === void 0 || mt, pt = E.isAllPageRowsSelected, gt = E.getSubRows, zt = Oe !== void 0 ? Oe : !pt, wt = i({}, d.selectedRowIds);
          return xt.forEach(function(Lt) {
            return function f(v) {
              var w = qe[v];
              if (w.isGrouped || (zt ? wt[v] = !0 : delete wt[v]), _t && gt(w))
                return gt(w).forEach(function(m) {
                  return f(m.id);
                });
            }(Lt.id);
          }), i({}, d, { selectedRowIds: wt });
        }
        return d;
      }
      function ss(d) {
        var b = d.data, S = d.rows, E = d.getHooks, L = d.plugins, T = d.rowsById, B = d.nonGroupedRowsById, X = B === void 0 ? T : B, te = d.autoResetSelectedRows, ne = te === void 0 || te, Se = d.state.selectedRowIds, we = d.selectSubRows, xe = we === void 0 || we, se = d.dispatch, ye = d.page, Te = d.getSubRows;
        $(L, ["useFilters", "useGroupBy", "useSortBy", "useExpanded", "usePagination"], "useRowSelect");
        var Ae = t.useMemo(function() {
          var gt = [];
          return S.forEach(function(zt) {
            var wt = xe ? function Lt(f, v, w) {
              if (v[f.id])
                return !0;
              var m = w(f);
              if (m && m.length) {
                var D = !0, M = !1;
                return m.forEach(function(R) {
                  M && !D || (Lt(R, v, w) ? M = !0 : D = !1);
                }), !!D || !!M && null;
              }
              return !1;
            }(zt, Se, Te) : !!Se[zt.id];
            zt.isSelected = !!wt, zt.isSomeSelected = wt === null, wt && gt.push(zt);
          }), gt;
        }, [S, xe, Se, Te]), rt = !!(Object.keys(X).length && Object.keys(Se).length), Ot = rt;
        rt && Object.keys(X).some(function(gt) {
          return !Se[gt];
        }) && (rt = !1), rt || ye && ye.length && ye.some(function(gt) {
          var zt = gt.id;
          return !Se[zt];
        }) && (Ot = !1);
        var nt = H(ne);
        _(function() {
          nt() && se({ type: u.resetSelectedRows });
        }, [se, b]);
        var Oe = t.useCallback(function(gt) {
          return se({ type: u.toggleAllRowsSelected, value: gt });
        }, [se]), xt = t.useCallback(function(gt) {
          return se({ type: u.toggleAllPageRowsSelected, value: gt });
        }, [se]), qe = t.useCallback(function(gt, zt) {
          return se({ type: u.toggleRowSelected, id: gt, value: zt });
        }, [se]), mt = H(d), _t = C(E().getToggleAllRowsSelectedProps, { instance: mt() }), pt = C(E().getToggleAllPageRowsSelectedProps, { instance: mt() });
        Object.assign(d, { selectedFlatRows: Ae, isAllRowsSelected: rt, isAllPageRowsSelected: Ot, toggleRowSelected: qe, toggleAllRowsSelected: Oe, getToggleAllRowsSelectedProps: _t, getToggleAllPageRowsSelectedProps: pt, toggleAllPageRowsSelected: xt });
      }
      function ou(d, b) {
        var S = b.instance;
        d.toggleRowSelected = function(E) {
          return S.toggleRowSelected(d.id, E);
        }, d.getToggleRowSelectedProps = C(S.getHooks().getToggleRowSelectedProps, { instance: S, row: d });
      }
      var ls = function(d) {
        return {};
      }, us = function(d) {
        return {};
      };
      u.setRowState = "setRowState", u.setCellState = "setCellState", u.resetRowState = "resetRowState";
      var ri = function(d) {
        d.stateReducers.push(au), d.useInstance.push(cs), d.prepareRow.push(iu);
      };
      function au(d, b, S, E) {
        var L = E.initialRowStateAccessor, T = L === void 0 ? ls : L, B = E.initialCellStateAccessor, X = B === void 0 ? us : B, te = E.rowsById;
        if (b.type === u.init)
          return i({ rowState: {} }, d);
        if (b.type === u.resetRowState)
          return i({}, d, { rowState: E.initialState.rowState || {} });
        if (b.type === u.setRowState) {
          var ne, Se = b.rowId, we = b.value, xe = d.rowState[Se] !== void 0 ? d.rowState[Se] : T(te[Se]);
          return i({}, d, { rowState: i({}, d.rowState, (ne = {}, ne[Se] = I(we, xe), ne)) });
        }
        if (b.type === u.setCellState) {
          var se, ye, Te, Ae, rt, Ot = b.rowId, nt = b.columnId, Oe = b.value, xt = d.rowState[Ot] !== void 0 ? d.rowState[Ot] : T(te[Ot]), qe = (xt == null || (se = xt.cellState) == null ? void 0 : se[nt]) !== void 0 ? xt.cellState[nt] : X((ye = te[Ot]) == null || (Te = ye.cells) == null ? void 0 : Te.find(function(mt) {
            return mt.column.id === nt;
          }));
          return i({}, d, { rowState: i({}, d.rowState, (rt = {}, rt[Ot] = i({}, xt, { cellState: i({}, xt.cellState || {}, (Ae = {}, Ae[nt] = I(Oe, qe), Ae)) }), rt)) });
        }
      }
      function cs(d) {
        var b = d.autoResetRowState, S = b === void 0 || b, E = d.data, L = d.dispatch, T = t.useCallback(function(te, ne) {
          return L({ type: u.setRowState, rowId: te, value: ne });
        }, [L]), B = t.useCallback(function(te, ne, Se) {
          return L({ type: u.setCellState, rowId: te, columnId: ne, value: Se });
        }, [L]), X = H(S);
        _(function() {
          X() && L({ type: u.resetRowState });
        }, [E]), Object.assign(d, { setRowState: T, setCellState: B });
      }
      function iu(d, b) {
        var S = b.instance, E = S.initialRowStateAccessor, L = E === void 0 ? ls : E, T = S.initialCellStateAccessor, B = T === void 0 ? us : T, X = S.state.rowState;
        d && (d.state = X[d.id] !== void 0 ? X[d.id] : L(d), d.setState = function(te) {
          return S.setRowState(d.id, te);
        }, d.cells.forEach(function(te) {
          d.state.cellState || (d.state.cellState = {}), te.state = d.state.cellState[te.column.id] !== void 0 ? d.state.cellState[te.column.id] : B(te), te.setState = function(ne) {
            return S.setCellState(d.id, te.column.id, ne);
          };
        }));
      }
      ri.pluginName = "useRowState", u.resetColumnOrder = "resetColumnOrder", u.setColumnOrder = "setColumnOrder";
      var ds = function(d) {
        d.stateReducers.push(ps), d.visibleColumnsDeps.push(function(b, S) {
          var E = S.instance;
          return [].concat(b, [E.state.columnOrder]);
        }), d.visibleColumns.push(fs), d.useInstance.push(su);
      };
      function ps(d, b, S, E) {
        return b.type === u.init ? i({ columnOrder: [] }, d) : b.type === u.resetColumnOrder ? i({}, d, { columnOrder: E.initialState.columnOrder || [] }) : b.type === u.setColumnOrder ? i({}, d, { columnOrder: I(b.columnOrder, d.columnOrder) }) : void 0;
      }
      function fs(d, b) {
        var S = b.instance.state.columnOrder;
        if (!S || !S.length)
          return d;
        for (var E = [].concat(S), L = [].concat(d), T = [], B = function() {
          var X = E.shift(), te = L.findIndex(function(ne) {
            return ne.id === X;
          });
          te > -1 && T.push(L.splice(te, 1)[0]);
        }; L.length && E.length; )
          B();
        return [].concat(T, L);
      }
      function su(d) {
        var b = d.dispatch;
        d.setColumnOrder = t.useCallback(function(S) {
          return b({ type: u.setColumnOrder, columnOrder: S });
        }, [b]);
      }
      ds.pluginName = "useColumnOrder", h.canResize = !0, u.columnStartResizing = "columnStartResizing", u.columnResizing = "columnResizing", u.columnDoneResizing = "columnDoneResizing", u.resetResize = "resetResize";
      var vs = function(d) {
        d.getResizerProps = [lu], d.getHeaderProps.push({ style: { position: "relative" } }), d.stateReducers.push(uu), d.useInstance.push(du), d.useInstanceBeforeDimensions.push(cu);
      }, lu = function(d, b) {
        var S = b.instance, E = b.header, L = S.dispatch, T = function(B, X) {
          var te = !1;
          if (B.type === "touchstart") {
            if (B.touches && B.touches.length > 1)
              return;
            te = !0;
          }
          var ne, Se, we = function(nt) {
            var Oe = [];
            return function xt(qe) {
              qe.columns && qe.columns.length && qe.columns.map(xt), Oe.push(qe);
            }(nt), Oe;
          }(X).map(function(nt) {
            return [nt.id, nt.totalWidth];
          }), xe = te ? Math.round(B.touches[0].clientX) : B.clientX, se = function() {
            window.cancelAnimationFrame(ne), ne = null, L({ type: u.columnDoneResizing });
          }, ye = function() {
            window.cancelAnimationFrame(ne), ne = null, L({ type: u.columnResizing, clientX: Se });
          }, Te = function(nt) {
            Se = nt, ne || (ne = window.requestAnimationFrame(ye));
          }, Ae = { mouse: { moveEvent: "mousemove", moveHandler: function(nt) {
            return Te(nt.clientX);
          }, upEvent: "mouseup", upHandler: function(nt) {
            document.removeEventListener("mousemove", Ae.mouse.moveHandler), document.removeEventListener("mouseup", Ae.mouse.upHandler), se();
          } }, touch: { moveEvent: "touchmove", moveHandler: function(nt) {
            return nt.cancelable && (nt.preventDefault(), nt.stopPropagation()), Te(nt.touches[0].clientX), !1;
          }, upEvent: "touchend", upHandler: function(nt) {
            document.removeEventListener(Ae.touch.moveEvent, Ae.touch.moveHandler), document.removeEventListener(Ae.touch.upEvent, Ae.touch.moveHandler), se();
          } } }, rt = te ? Ae.touch : Ae.mouse, Ot = !!function() {
            if (typeof le == "boolean")
              return le;
            var nt = !1;
            try {
              var Oe = { get passive() {
                return nt = !0, !1;
              } };
              window.addEventListener("test", null, Oe), window.removeEventListener("test", null, Oe);
            } catch {
              nt = !1;
            }
            return le = nt;
          }() && { passive: !1 };
          document.addEventListener(rt.moveEvent, rt.moveHandler, Ot), document.addEventListener(rt.upEvent, rt.upHandler, Ot), L({ type: u.columnStartResizing, columnId: X.id, columnWidth: X.totalWidth, headerIdWidths: we, clientX: xe });
        };
        return [d, { onMouseDown: function(B) {
          return B.persist() || T(B, E);
        }, onTouchStart: function(B) {
          return B.persist() || T(B, E);
        }, style: { cursor: "col-resize" }, draggable: !1, role: "separator" }];
      };
      function uu(d, b) {
        if (b.type === u.init)
          return i({ columnResizing: { columnWidths: {} } }, d);
        if (b.type === u.resetResize)
          return i({}, d, { columnResizing: { columnWidths: {} } });
        if (b.type === u.columnStartResizing) {
          var S = b.clientX, E = b.columnId, L = b.columnWidth, T = b.headerIdWidths;
          return i({}, d, { columnResizing: i({}, d.columnResizing, { startX: S, headerIdWidths: T, columnWidth: L, isResizingColumn: E }) });
        }
        if (b.type === u.columnResizing) {
          var B = b.clientX, X = d.columnResizing, te = X.startX, ne = X.columnWidth, Se = X.headerIdWidths, we = (B - te) / ne, xe = {};
          return (Se === void 0 ? [] : Se).forEach(function(se) {
            var ye = se[0], Te = se[1];
            xe[ye] = Math.max(Te + Te * we, 0);
          }), i({}, d, { columnResizing: i({}, d.columnResizing, { columnWidths: i({}, d.columnResizing.columnWidths, {}, xe) }) });
        }
        return b.type === u.columnDoneResizing ? i({}, d, { columnResizing: i({}, d.columnResizing, { startX: null, isResizingColumn: null }) }) : void 0;
      }
      vs.pluginName = "useResizeColumns";
      var cu = function(d) {
        var b = d.flatHeaders, S = d.disableResizing, E = d.getHooks, L = d.state.columnResizing, T = H(d);
        b.forEach(function(B) {
          var X = U(B.disableResizing !== !0 && void 0, S !== !0 && void 0, !0);
          B.canResize = X, B.width = L.columnWidths[B.id] || B.originalWidth || B.width, B.isResizing = L.isResizingColumn === B.id, X && (B.getResizerProps = C(E().getResizerProps, { instance: T(), header: B }));
        });
      };
      function du(d) {
        var b = d.plugins, S = d.dispatch, E = d.autoResetResize, L = E === void 0 || E, T = d.columns;
        $(b, ["useAbsoluteLayout"], "useResizeColumns");
        var B = H(L);
        _(function() {
          B() && S({ type: u.resetResize });
        }, [T]);
        var X = t.useCallback(function() {
          return S({ type: u.resetResize });
        }, [S]);
        Object.assign(d, { resetResizing: X });
      }
      var ni = { position: "absolute", top: 0 }, gs = function(d) {
        d.getTableBodyProps.push(xa), d.getRowProps.push(xa), d.getHeaderGroupProps.push(xa), d.getFooterGroupProps.push(xa), d.getHeaderProps.push(function(b, S) {
          var E = S.column;
          return [b, { style: i({}, ni, { left: E.totalLeft + "px", width: E.totalWidth + "px" }) }];
        }), d.getCellProps.push(function(b, S) {
          var E = S.cell;
          return [b, { style: i({}, ni, { left: E.column.totalLeft + "px", width: E.column.totalWidth + "px" }) }];
        }), d.getFooterProps.push(function(b, S) {
          var E = S.column;
          return [b, { style: i({}, ni, { left: E.totalLeft + "px", width: E.totalWidth + "px" }) }];
        });
      };
      gs.pluginName = "useAbsoluteLayout";
      var xa = function(d, b) {
        return [d, { style: { position: "relative", width: b.instance.totalColumnsWidth + "px" } }];
      }, oi = { display: "inline-block", boxSizing: "border-box" }, ai = function(d, b) {
        return [d, { style: { display: "flex", width: b.instance.totalColumnsWidth + "px" } }];
      }, hs = function(d) {
        d.getRowProps.push(ai), d.getHeaderGroupProps.push(ai), d.getFooterGroupProps.push(ai), d.getHeaderProps.push(function(b, S) {
          var E = S.column;
          return [b, { style: i({}, oi, { width: E.totalWidth + "px" }) }];
        }), d.getCellProps.push(function(b, S) {
          var E = S.cell;
          return [b, { style: i({}, oi, { width: E.column.totalWidth + "px" }) }];
        }), d.getFooterProps.push(function(b, S) {
          var E = S.column;
          return [b, { style: i({}, oi, { width: E.totalWidth + "px" }) }];
        });
      };
      function ii(d) {
        d.getTableProps.push(pu), d.getRowProps.push(si), d.getHeaderGroupProps.push(si), d.getFooterGroupProps.push(si), d.getHeaderProps.push(fu), d.getCellProps.push(vu), d.getFooterProps.push(gu);
      }
      hs.pluginName = "useBlockLayout", ii.pluginName = "useFlexLayout";
      var pu = function(d, b) {
        return [d, { style: { minWidth: b.instance.totalColumnsMinWidth + "px" } }];
      }, si = function(d, b) {
        return [d, { style: { display: "flex", flex: "1 0 auto", minWidth: b.instance.totalColumnsMinWidth + "px" } }];
      }, fu = function(d, b) {
        var S = b.column;
        return [d, { style: { boxSizing: "border-box", flex: S.totalFlexWidth ? S.totalFlexWidth + " 0 auto" : void 0, minWidth: S.totalMinWidth + "px", width: S.totalWidth + "px" } }];
      }, vu = function(d, b) {
        var S = b.cell;
        return [d, { style: { boxSizing: "border-box", flex: S.column.totalFlexWidth + " 0 auto", minWidth: S.column.totalMinWidth + "px", width: S.column.totalWidth + "px" } }];
      }, gu = function(d, b) {
        var S = b.column;
        return [d, { style: { boxSizing: "border-box", flex: S.totalFlexWidth ? S.totalFlexWidth + " 0 auto" : void 0, minWidth: S.totalMinWidth + "px", width: S.totalWidth + "px" } }];
      };
      function ms(d) {
        d.stateReducers.push(xs), d.getTableProps.push(ys), d.getHeaderProps.push(bs), d.getRowProps.push(ws);
      }
      u.columnStartResizing = "columnStartResizing", u.columnResizing = "columnResizing", u.columnDoneResizing = "columnDoneResizing", u.resetResize = "resetResize", ms.pluginName = "useGridLayout";
      var ys = function(d, b) {
        var S = b.instance;
        return [d, { style: { display: "grid", gridTemplateColumns: S.visibleColumns.map(function(E) {
          var L;
          return S.state.gridLayout.columnWidths[E.id] ? S.state.gridLayout.columnWidths[E.id] + "px" : (L = S.state.columnResizing) != null && L.isResizingColumn ? S.state.gridLayout.startWidths[E.id] + "px" : typeof E.width == "number" ? E.width + "px" : E.width;
        }).join(" ") } }];
      }, bs = function(d, b) {
        var S = b.column;
        return [d, { id: "header-cell-" + S.id, style: { position: "sticky", gridColumn: "span " + S.totalVisibleHeaderCount } }];
      }, ws = function(d, b) {
        var S = b.row;
        return S.isExpanded ? [d, { style: { gridColumn: "1 / " + (S.cells.length + 1) } }] : [d, {}];
      };
      function xs(d, b, S, E) {
        if (b.type === u.init)
          return i({ gridLayout: { columnWidths: {} } }, d);
        if (b.type === u.resetResize)
          return i({}, d, { gridLayout: { columnWidths: {} } });
        if (b.type === u.columnStartResizing) {
          var L = b.columnId, T = b.headerIdWidths, B = li(L);
          if (B !== void 0) {
            var X = E.visibleColumns.reduce(function(Oe, xt) {
              var qe;
              return i({}, Oe, ((qe = {})[xt.id] = li(xt.id), qe));
            }, {}), te = E.visibleColumns.reduce(function(Oe, xt) {
              var qe;
              return i({}, Oe, ((qe = {})[xt.id] = xt.minWidth, qe));
            }, {}), ne = E.visibleColumns.reduce(function(Oe, xt) {
              var qe;
              return i({}, Oe, ((qe = {})[xt.id] = xt.maxWidth, qe));
            }, {}), Se = T.map(function(Oe) {
              var xt = Oe[0];
              return [xt, li(xt)];
            });
            return i({}, d, { gridLayout: i({}, d.gridLayout, { startWidths: X, minWidths: te, maxWidths: ne, headerIdGridWidths: Se, columnWidth: B }) });
          }
          return d;
        }
        if (b.type === u.columnResizing) {
          var we = b.clientX, xe = d.columnResizing.startX, se = d.gridLayout, ye = se.columnWidth, Te = se.minWidths, Ae = se.maxWidths, rt = se.headerIdGridWidths, Ot = (we - xe) / ye, nt = {};
          return (rt === void 0 ? [] : rt).forEach(function(Oe) {
            var xt = Oe[0], qe = Oe[1];
            nt[xt] = Math.min(Math.max(Te[xt], qe + qe * Ot), Ae[xt]);
          }), i({}, d, { gridLayout: i({}, d.gridLayout, { columnWidths: i({}, d.gridLayout.columnWidths, {}, nt) }) });
        }
        return b.type === u.columnDoneResizing ? i({}, d, { gridLayout: i({}, d.gridLayout, { startWidths: {}, minWidths: {}, maxWidths: {} }) }) : void 0;
      }
      function li(d) {
        var b, S = (b = document.getElementById("header-cell-" + d)) == null ? void 0 : b.offsetWidth;
        if (S !== void 0)
          return S;
      }
      o._UNSTABLE_usePivotColumns = ei, o.actions = u, o.defaultColumn = h, o.defaultGroupByFn = rr, o.defaultOrderByFn = ts, o.defaultRenderer = c, o.emptyRenderer = p, o.ensurePluginOrder = $, o.flexRender = G, o.functionalUpdate = I, o.loopHooks = k, o.makePropGetter = C, o.makeRenderer = F, o.reduceHooks = P, o.safeUseLayoutEffect = x, o.useAbsoluteLayout = gs, o.useAsyncDebounce = function(d, b) {
        b === void 0 && (b = 0);
        var S = t.useRef({}), E = H(d), L = H(b);
        return t.useCallback(function() {
          var T = a(regeneratorRuntime.mark(function B() {
            var X, te, ne, Se = arguments;
            return regeneratorRuntime.wrap(function(we) {
              for (; ; )
                switch (we.prev = we.next) {
                  case 0:
                    for (X = Se.length, te = new Array(X), ne = 0; ne < X; ne++)
                      te[ne] = Se[ne];
                    return S.current.promise || (S.current.promise = new Promise(function(xe, se) {
                      S.current.resolve = xe, S.current.reject = se;
                    })), S.current.timeout && clearTimeout(S.current.timeout), S.current.timeout = setTimeout(a(regeneratorRuntime.mark(function xe() {
                      return regeneratorRuntime.wrap(function(se) {
                        for (; ; )
                          switch (se.prev = se.next) {
                            case 0:
                              return delete S.current.timeout, se.prev = 1, se.t0 = S.current, se.next = 5, E().apply(void 0, te);
                            case 5:
                              se.t1 = se.sent, se.t0.resolve.call(se.t0, se.t1), se.next = 12;
                              break;
                            case 9:
                              se.prev = 9, se.t2 = se.catch(1), S.current.reject(se.t2);
                            case 12:
                              return se.prev = 12, delete S.current.promise, se.finish(12);
                            case 15:
                            case "end":
                              return se.stop();
                          }
                      }, xe, null, [[1, 9, 12, 15]]);
                    })), L()), we.abrupt("return", S.current.promise);
                  case 5:
                  case "end":
                    return we.stop();
                }
            }, B);
          }));
          return function() {
            return T.apply(this, arguments);
          };
        }(), [E, L]);
      }, o.useBlockLayout = hs, o.useColumnOrder = ds, o.useExpanded = mr, o.useFilters = Yn, o.useFlexLayout = ii, o.useGetLatest = H, o.useGlobalFilter = $n, o.useGridLayout = ms, o.useGroupBy = Qo, o.useMountedLayoutEffect = _, o.usePagination = Za, o.useResizeColumns = vs, o.useRowSelect = as, o.useRowState = ri, o.useSortBy = Kr, o.useTable = function(d) {
        for (var b = arguments.length, S = new Array(b > 1 ? b - 1 : 0), E = 1; E < b; E++)
          S[E - 1] = arguments[E];
        d = it(d), S = [tt].concat(S);
        var L = t.useRef({}), T = H(L.current);
        Object.assign(T(), i({}, d, { plugins: S, hooks: re() })), S.filter(Boolean).forEach(function(R) {
          R(T().hooks);
        });
        var B = H(T().hooks);
        T().getHooks = B, delete T().hooks, Object.assign(T(), P(B().useOptions, it(d)));
        var X = T(), te = X.data, ne = X.columns, Se = X.initialState, we = X.defaultColumn, xe = X.getSubRows, se = X.getRowId, ye = X.stateReducer, Te = X.useControlledState, Ae = H(ye), rt = t.useCallback(function(R, W) {
          if (!W.type)
            throw console.info({ action: W }), new Error("Unknown Action 👆");
          return [].concat(B().stateReducers, Array.isArray(Ae()) ? Ae() : [Ae()]).reduce(function(q, J) {
            return J(q, W, R, T()) || q;
          }, R);
        }, [B, Ae, T]), Ot = t.useReducer(rt, void 0, function() {
          return rt(Se, { type: u.init });
        }), nt = Ot[0], Oe = Ot[1], xt = P([].concat(B().useControlledState, [Te]), nt, { instance: T() });
        Object.assign(T(), { state: xt, dispatch: Oe });
        var qe = t.useMemo(function() {
          return Q(P(B().columns, ne, { instance: T() }));
        }, [B, T, ne].concat(P(B().columnsDeps, [], { instance: T() })));
        T().columns = qe;
        var mt = t.useMemo(function() {
          return P(B().allColumns, V(qe), { instance: T() }).map(ie);
        }, [qe, B, T].concat(P(B().allColumnsDeps, [], { instance: T() })));
        T().allColumns = mt;
        var _t = t.useMemo(function() {
          for (var R = [], W = [], q = {}, J = [].concat(mt); J.length; ) {
            var ae = J.shift();
            tr({ data: te, rows: R, flatRows: W, rowsById: q, column: ae, getRowId: se, getSubRows: xe, accessValueHooks: B().accessValue, getInstance: T });
          }
          return [R, W, q];
        }, [mt, te, se, xe, B, T]), pt = _t[0], gt = _t[1], zt = _t[2];
        Object.assign(T(), { rows: pt, initialRows: [].concat(pt), flatRows: gt, rowsById: zt }), k(B().useInstanceAfterData, T());
        var wt = t.useMemo(function() {
          return P(B().visibleColumns, mt, { instance: T() }).map(function(R) {
            return ce(R, we);
          });
        }, [B, mt, T, we].concat(P(B().visibleColumnsDeps, [], { instance: T() })));
        mt = t.useMemo(function() {
          var R = [].concat(wt);
          return mt.forEach(function(W) {
            R.find(function(q) {
              return q.id === W.id;
            }) || R.push(W);
          }), R;
        }, [mt, wt]), T().allColumns = mt;
        var Lt = t.useMemo(function() {
          return P(B().headerGroups, me(wt, we), T());
        }, [B, wt, we, T].concat(P(B().headerGroupsDeps, [], { instance: T() })));
        T().headerGroups = Lt;
        var f = t.useMemo(function() {
          return Lt.length ? Lt[0].headers : [];
        }, [Lt]);
        T().headers = f, T().flatHeaders = Lt.reduce(function(R, W) {
          return [].concat(R, W.headers);
        }, []), k(B().useInstanceBeforeDimensions, T());
        var v = wt.filter(function(R) {
          return R.isVisible;
        }).map(function(R) {
          return R.id;
        }).sort().join("_");
        wt = t.useMemo(function() {
          return wt.filter(function(R) {
            return R.isVisible;
          });
        }, [wt, v]), T().visibleColumns = wt;
        var w = Qt(f), m = w[0], D = w[1], M = w[2];
        return T().totalColumnsMinWidth = m, T().totalColumnsWidth = D, T().totalColumnsMaxWidth = M, k(B().useInstance, T()), [].concat(T().flatHeaders, T().allColumns).forEach(function(R) {
          R.render = F(T(), R), R.getHeaderProps = C(B().getHeaderProps, { instance: T(), column: R }), R.getFooterProps = C(B().getFooterProps, { instance: T(), column: R });
        }), T().headerGroups = t.useMemo(function() {
          return Lt.filter(function(R, W) {
            return R.headers = R.headers.filter(function(q) {
              return q.headers ? function J(ae) {
                return ae.filter(function(Ee) {
                  return Ee.headers ? J(Ee.headers) : Ee.isVisible;
                }).length;
              }(q.headers) : q.isVisible;
            }), !!R.headers.length && (R.getHeaderGroupProps = C(B().getHeaderGroupProps, { instance: T(), headerGroup: R, index: W }), R.getFooterGroupProps = C(B().getFooterGroupProps, { instance: T(), headerGroup: R, index: W }), !0);
          });
        }, [Lt, T, B]), T().footerGroups = [].concat(T().headerGroups).reverse(), T().prepareRow = t.useCallback(function(R) {
          R.getRowProps = C(B().getRowProps, { instance: T(), row: R }), R.allCells = mt.map(function(W) {
            var q = R.values[W.id], J = { column: W, row: R, value: q };
            return J.getCellProps = C(B().getCellProps, { instance: T(), cell: J }), J.render = F(T(), W, { row: R, cell: J, value: q }), J;
          }), R.cells = wt.map(function(W) {
            return R.allCells.find(function(q) {
              return q.column.id === W.id;
            });
          }), k(B().prepareRow, R, { instance: T() });
        }, [B, T, mt, wt]), T().getTableProps = C(B().getTableProps, { instance: T() }), T().getTableBodyProps = C(B().getTableBodyProps, { instance: T() }), k(B().useFinalInstance, T()), T();
      }, Object.defineProperty(o, "__esModule", { value: !0 });
    });
  }(Ms, Ms.exports)), Ms.exports;
}
var As = { exports: {} }, mh;
function O_() {
  return mh || (mh = 1, function(e, n) {
    (function(o, t) {
      t(n, y);
    })(Vh, function(o, t) {
      t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
      function r(f, v, w, m, D, M, R) {
        try {
          var W = f[M](R), q = W.value;
        } catch (J) {
          w(J);
          return;
        }
        W.done ? v(q) : Promise.resolve(q).then(m, D);
      }
      function a(f) {
        return function() {
          var v = this, w = arguments;
          return new Promise(function(m, D) {
            var M = f.apply(v, w);
            function R(q) {
              r(M, m, D, R, W, "next", q);
            }
            function W(q) {
              r(M, m, D, R, W, "throw", q);
            }
            R(void 0);
          });
        };
      }
      function i() {
        return i = Object.assign || function(f) {
          for (var v = 1; v < arguments.length; v++) {
            var w = arguments[v];
            for (var m in w)
              Object.prototype.hasOwnProperty.call(w, m) && (f[m] = w[m]);
          }
          return f;
        }, i.apply(this, arguments);
      }
      function s(f, v) {
        if (f == null)
          return {};
        var w = {}, m = Object.keys(f), D, M;
        for (M = 0; M < m.length; M++)
          D = m[M], !(v.indexOf(D) >= 0) && (w[D] = f[D]);
        return w;
      }
      function l(f, v) {
        if (typeof f != "object" || f === null)
          return f;
        var w = f[Symbol.toPrimitive];
        if (w !== void 0) {
          var m = w.call(f, v || "default");
          if (typeof m != "object")
            return m;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (v === "string" ? String : Number)(f);
      }
      function u(f) {
        var v = l(f, "string");
        return typeof v == "symbol" ? v : String(v);
      }
      var c = "Renderer Error ☝️", p = {
        init: "init"
      }, h = function(v) {
        var w = v.value, m = w === void 0 ? "" : w;
        return m;
      }, O = function() {
        return t.createElement(t.Fragment, null, " ");
      }, C = {
        Cell: h,
        width: 150,
        minWidth: 0,
        maxWidth: Number.MAX_SAFE_INTEGER
      };
      function P() {
        for (var f = arguments.length, v = new Array(f), w = 0; w < f; w++)
          v[w] = arguments[w];
        return v.reduce(function(m, D) {
          var M = D.style, R = D.className, W = s(D, ["style", "className"]);
          return m = i({}, m, {}, W), M && (m.style = m.style ? i({}, m.style || {}, {}, M || {}) : M), R && (m.className = m.className ? m.className + " " + R : R), m.className === "" && delete m.className, m;
        }, {});
      }
      function k(f, v, w) {
        return typeof v == "function" ? k({}, v(f, w)) : Array.isArray(v) ? P.apply(void 0, [f].concat(v)) : P(f, v);
      }
      var $ = function(v, w) {
        return w === void 0 && (w = {}), function(m) {
          return m === void 0 && (m = {}), [].concat(v, [m]).reduce(function(D, M) {
            return k(D, M, i({}, w, {
              userProps: m
            }));
          }, {});
        };
      }, I = function(v, w, m, D) {
        return m === void 0 && (m = {}), v.reduce(function(M, R) {
          var W = R(M, m);
          if (!D && typeof W > "u")
            throw console.info(R), new Error("React Table: A reducer hook ☝️ just returned undefined! This is not allowed.");
          return W;
        }, w);
      }, H = function(v, w, m) {
        return m === void 0 && (m = {}), v.forEach(function(D) {
          var M = D(w, m);
          if (typeof M < "u")
            throw console.info(D, M), new Error("React Table: A loop-type hook ☝️ just returned a value! This is not allowed.");
        });
      };
      function x(f, v, w, m) {
        if (m)
          throw new Error('Defining plugins in the "after" section of ensurePluginOrder is no longer supported (see plugin ' + w + ")");
        var D = f.findIndex(function(M) {
          return M.pluginName === w;
        });
        if (D === -1)
          throw new Error('The plugin "' + w + `" was not found in the plugin list!
This usually means you need to need to name your plugin hook by setting the 'pluginName' property of the hook function, eg:

  ` + w + ".pluginName = '" + w + `'
`);
        v.forEach(function(M) {
          var R = f.findIndex(function(W) {
            return W.pluginName === M;
          });
          if (R > -1 && R > D)
            throw new Error("React Table: The " + w + " plugin hook must be placed after the " + M + " plugin hook!");
        });
      }
      function _(f, v) {
        return typeof f == "function" ? f(v) : f;
      }
      function F(f) {
        var v = t.useRef();
        return v.current = f, t.useCallback(function() {
          return v.current;
        }, []);
      }
      var G = typeof document < "u" ? t.useLayoutEffect : t.useEffect;
      function Q(f, v) {
        var w = t.useRef(!1);
        G(function() {
          w.current && f(), w.current = !0;
        }, v);
      }
      function V(f, v) {
        v === void 0 && (v = 0);
        var w = t.useRef({}), m = F(f), D = F(v);
        return t.useCallback(
          /* @__PURE__ */ function() {
            var M = a(
              /* @__PURE__ */ regeneratorRuntime.mark(function R() {
                var W, q, J, ae = arguments;
                return regeneratorRuntime.wrap(function(de) {
                  for (; ; )
                    switch (de.prev = de.next) {
                      case 0:
                        for (W = ae.length, q = new Array(W), J = 0; J < W; J++)
                          q[J] = ae[J];
                        return w.current.promise || (w.current.promise = new Promise(function(Ce, $e) {
                          w.current.resolve = Ce, w.current.reject = $e;
                        })), w.current.timeout && clearTimeout(w.current.timeout), w.current.timeout = setTimeout(
                          /* @__PURE__ */ a(
                            /* @__PURE__ */ regeneratorRuntime.mark(function Ce() {
                              return regeneratorRuntime.wrap(function(ue) {
                                for (; ; )
                                  switch (ue.prev = ue.next) {
                                    case 0:
                                      return delete w.current.timeout, ue.prev = 1, ue.t0 = w.current, ue.next = 5, m().apply(void 0, q);
                                    case 5:
                                      ue.t1 = ue.sent, ue.t0.resolve.call(ue.t0, ue.t1), ue.next = 12;
                                      break;
                                    case 9:
                                      ue.prev = 9, ue.t2 = ue.catch(1), w.current.reject(ue.t2);
                                    case 12:
                                      return ue.prev = 12, delete w.current.promise, ue.finish(12);
                                    case 15:
                                    case "end":
                                      return ue.stop();
                                  }
                              }, Ce, null, [[1, 9, 12, 15]]);
                            })
                          ),
                          D()
                        ), de.abrupt("return", w.current.promise);
                      case 5:
                      case "end":
                        return de.stop();
                    }
                }, R);
              })
            );
            return function() {
              return M.apply(this, arguments);
            };
          }(),
          [m, D]
        );
      }
      function ie(f, v, w) {
        return w === void 0 && (w = {}), function(m, D) {
          D === void 0 && (D = {});
          var M = typeof m == "string" ? v[m] : m;
          if (typeof M > "u")
            throw console.info(v), new Error(c);
          return ce(M, i({}, f, {
            column: v
          }, w, {}, D));
        };
      }
      function ce(f, v) {
        return me(f) ? t.createElement(f, v) : f;
      }
      function me(f) {
        return ve(f) || typeof f == "function" || U(f);
      }
      function ve(f) {
        return typeof f == "function" && function() {
          var v = Object.getPrototypeOf(f);
          return v.prototype && v.prototype.isReactComponent;
        }();
      }
      function U(f) {
        return typeof f == "object" && typeof f.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(f.$$typeof.description);
      }
      function ee(f, v, w) {
        return w === void 0 && (w = 0), f.map(function(m) {
          return m = i({}, m, {
            parent: v,
            depth: w
          }), ge(m), m.columns && (m.columns = ee(m.columns, m, w + 1)), m;
        });
      }
      function oe(f) {
        return Ge(f, "columns");
      }
      function ge(f) {
        var v = f.id, w = f.accessor, m = f.Header;
        if (typeof w == "string") {
          v = v || w;
          var D = w.split(".");
          w = function(R) {
            return le(R, D);
          };
        }
        if (!v && typeof m == "string" && m && (v = m), !v && f.columns)
          throw console.error(f), new Error('A column ID (or unique "Header" value) is required!');
        if (!v)
          throw console.error(f), new Error("A column ID (or string accessor) is required!");
        return Object.assign(f, {
          id: v,
          accessor: w
        }), f;
      }
      function be(f, v) {
        if (!v)
          throw new Error();
        return Object.assign(f, i({
          // Make sure there is a fallback header, just in case
          Header: O,
          Footer: O
        }, C, {}, v, {}, f)), Object.assign(f, {
          originalWidth: f.width
        }), f;
      }
      function he(f, v, w) {
        w === void 0 && (w = function() {
          return {};
        });
        for (var m = [], D = f, M = 0, R = function() {
          return M++;
        }, W = function() {
          var J = {
            headers: []
          }, ae = [], Ee = D.some(function(de) {
            return de.parent;
          });
          D.forEach(function(de) {
            var Ce = [].concat(ae).reverse()[0], $e;
            if (Ee) {
              if (de.parent)
                $e = i({}, de.parent, {
                  originalId: de.parent.id,
                  id: de.parent.id + "_" + R(),
                  headers: [de]
                }, w(de));
              else {
                var ue = de.id + "_placeholder";
                $e = be(i({
                  originalId: ue,
                  id: de.id + "_placeholder_" + R(),
                  placeholderOf: de,
                  headers: [de]
                }, w(de)), v);
              }
              Ce && Ce.originalId === $e.originalId ? Ce.headers.push(de) : ae.push($e);
            }
            J.headers.push(de);
          }), m.push(J), D = ae;
        }; D.length; )
          W();
        return m.reverse();
      }
      var K = /* @__PURE__ */ new Map();
      function le(f, v, w) {
        if (!v)
          return f;
        var m = typeof v == "function" ? v : JSON.stringify(v), D = K.get(m) || function() {
          var R = tt(v);
          return K.set(m, R), R;
        }(), M;
        try {
          M = D.reduce(function(R, W) {
            return R[W];
          }, f);
        } catch {
        }
        return typeof M < "u" ? M : w;
      }
      function Pe() {
        for (var f = arguments.length, v = new Array(f), w = 0; w < f; w++)
          v[w] = arguments[w];
        for (var m = 0; m < v.length; m += 1)
          if (typeof v[m] < "u")
            return v[m];
      }
      function lt(f) {
        if (typeof f == "function")
          return f;
      }
      function Ge(f, v) {
        var w = [], m = function D(M) {
          M.forEach(function(R) {
            R[v] ? D(R[v]) : w.push(R);
          });
        };
        return m(f), w;
      }
      function ut(f, v) {
        var w = v.manualExpandedKey, m = v.expanded, D = v.expandSubRows, M = D === void 0 ? !0 : D, R = [], W = function q(J, ae) {
          ae === void 0 && (ae = !0), J.isExpanded = J.original && J.original[w] || m[J.id], J.canExpand = J.subRows && !!J.subRows.length, ae && R.push(J), J.subRows && J.subRows.length && J.isExpanded && J.subRows.forEach(function(Ee) {
            return q(Ee, M);
          });
        };
        return f.forEach(function(q) {
          return W(q);
        }), R;
      }
      function ze(f, v, w) {
        return lt(f) || v[f] || w[f] || w.text;
      }
      function Ze(f, v, w) {
        return f ? f(v, w) : typeof v > "u";
      }
      function _e() {
        throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
      }
      var De = null;
      function fe() {
        if (typeof De == "boolean")
          return De;
        var f = !1;
        try {
          var v = {
            get passive() {
              return f = !0, !1;
            }
          };
          window.addEventListener("test", null, v), window.removeEventListener("test", null, v);
        } catch {
          f = !1;
        }
        return De = f, De;
      }
      var ke = /\[/g, re = /\]/g;
      function tt(f) {
        return et(f).map(function(v) {
          return String(v).replace(".", "_");
        }).join(".").replace(ke, ".").replace(re, "").split(".");
      }
      function et(f, v) {
        if (v === void 0 && (v = []), !Array.isArray(f))
          v.push(f);
        else
          for (var w = 0; w < f.length; w += 1)
            et(f[w], v);
        return v;
      }
      var Dt = function(v) {
        return i({
          role: "table"
        }, v);
      }, Kt = function(v) {
        return i({
          role: "rowgroup"
        }, v);
      }, fr = function(v, w) {
        var m = w.column;
        return i({
          key: "header_" + m.id,
          colSpan: m.totalVisibleHeaderCount,
          role: "columnheader"
        }, v);
      }, Ir = function(v, w) {
        var m = w.column;
        return i({
          key: "footer_" + m.id,
          colSpan: m.totalVisibleHeaderCount
        }, v);
      }, jr = function(v, w) {
        var m = w.index;
        return i({
          key: "headerGroup_" + m,
          role: "row"
        }, v);
      }, Pr = function(v, w) {
        var m = w.index;
        return i({
          key: "footerGroup_" + m
        }, v);
      }, Nr = function(v, w) {
        var m = w.row;
        return i({
          key: "row_" + m.id,
          role: "row"
        }, v);
      }, nn = function(v, w) {
        var m = w.cell;
        return i({
          key: "cell_" + m.row.id + "_" + m.column.id,
          role: "cell"
        }, v);
      };
      function on() {
        return {
          useOptions: [],
          stateReducers: [],
          useControlledState: [],
          columns: [],
          columnsDeps: [],
          allColumns: [],
          allColumnsDeps: [],
          accessValue: [],
          materializedColumns: [],
          materializedColumnsDeps: [],
          useInstanceAfterData: [],
          visibleColumns: [],
          visibleColumnsDeps: [],
          headerGroups: [],
          headerGroupsDeps: [],
          useInstanceBeforeDimensions: [],
          useInstance: [],
          prepareRow: [],
          getTableProps: [Dt],
          getTableBodyProps: [Kt],
          getHeaderGroupProps: [jr],
          getFooterGroupProps: [Pr],
          getHeaderProps: [fr],
          getFooterProps: [Ir],
          getRowProps: [Nr],
          getCellProps: [nn],
          useFinalInstance: []
        };
      }
      p.resetHiddenColumns = "resetHiddenColumns", p.toggleHideColumn = "toggleHideColumn", p.setHiddenColumns = "setHiddenColumns", p.toggleHideAllColumns = "toggleHideAllColumns";
      var Re = function(v) {
        v.getToggleHiddenProps = [it], v.getToggleHideAllColumnsProps = [Qt], v.stateReducers.push(tr), v.useInstanceBeforeDimensions.push(mr), v.headerGroupsDeps.push(function(w, m) {
          var D = m.instance;
          return [].concat(w, [D.state.hiddenColumns]);
        }), v.useInstance.push(dn);
      };
      Re.pluginName = "useColumnVisibility";
      var it = function(v, w) {
        var m = w.column;
        return [v, {
          onChange: function(M) {
            m.toggleHidden(!M.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: m.isVisible,
          title: "Toggle Column Visible"
        }];
      }, Qt = function(v, w) {
        var m = w.instance;
        return [v, {
          onChange: function(M) {
            m.toggleHideAllColumns(!M.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: !m.allColumnsHidden && !m.state.hiddenColumns.length,
          title: "Toggle All Columns Hidden",
          indeterminate: !m.allColumnsHidden && m.state.hiddenColumns.length
        }];
      };
      function tr(f, v, w, m) {
        if (v.type === p.init)
          return i({
            hiddenColumns: []
          }, f);
        if (v.type === p.resetHiddenColumns)
          return i({}, f, {
            hiddenColumns: m.initialState.hiddenColumns || []
          });
        if (v.type === p.toggleHideColumn) {
          var D = typeof v.value < "u" ? v.value : !f.hiddenColumns.includes(v.columnId), M = D ? [].concat(f.hiddenColumns, [v.columnId]) : f.hiddenColumns.filter(function(W) {
            return W !== v.columnId;
          });
          return i({}, f, {
            hiddenColumns: M
          });
        }
        if (v.type === p.setHiddenColumns)
          return i({}, f, {
            hiddenColumns: _(v.value, f.hiddenColumns)
          });
        if (v.type === p.toggleHideAllColumns) {
          var R = typeof v.value < "u" ? v.value : !f.hiddenColumns.length;
          return i({}, f, {
            hiddenColumns: R ? m.allColumns.map(function(W) {
              return W.id;
            }) : []
          });
        }
      }
      function mr(f) {
        var v = f.headers, w = f.state.hiddenColumns, m = t.useRef(!1);
        m.current;
        var D = function R(W, q) {
          W.isVisible = q && !w.includes(W.id);
          var J = 0;
          return W.headers && W.headers.length ? W.headers.forEach(function(ae) {
            return J += R(ae, W.isVisible);
          }) : J = W.isVisible ? 1 : 0, W.totalVisibleHeaderCount = J, J;
        }, M = 0;
        v.forEach(function(R) {
          return M += D(R, !0);
        });
      }
      function dn(f) {
        var v = f.columns, w = f.flatHeaders, m = f.dispatch, D = f.allColumns, M = f.getHooks, R = f.state.hiddenColumns, W = f.autoResetHiddenColumns, q = W === void 0 ? !0 : W, J = F(f), ae = D.length === R.length, Ee = t.useCallback(function(He, st) {
          return m({
            type: p.toggleHideColumn,
            columnId: He,
            value: st
          });
        }, [m]), de = t.useCallback(function(He) {
          return m({
            type: p.setHiddenColumns,
            value: He
          });
        }, [m]), Ce = t.useCallback(function(He) {
          return m({
            type: p.toggleHideAllColumns,
            value: He
          });
        }, [m]), $e = $(M().getToggleHideAllColumnsProps, {
          instance: J()
        });
        w.forEach(function(He) {
          He.toggleHidden = function(st) {
            m({
              type: p.toggleHideColumn,
              columnId: He.id,
              value: st
            });
          }, He.getToggleHiddenProps = $(M().getToggleHiddenProps, {
            instance: J(),
            column: He
          });
        });
        var ue = F(q);
        Q(function() {
          ue() && m({
            type: p.resetHiddenColumns
          });
        }, [m, v]), Object.assign(f, {
          allColumnsHidden: ae,
          toggleHideColumn: Ee,
          setHiddenColumns: de,
          toggleHideAllColumns: Ce,
          getToggleHideAllColumnsProps: $e
        });
      }
      var an = {}, hn = {}, Wn = function(v, w, m) {
        return v;
      }, zn = function(v, w) {
        return v.subRows || [];
      }, Z = function(v, w, m) {
        return "" + (m ? [m.id, w].join(".") : w);
      }, Ve = function(v) {
        return v;
      };
      function ct(f) {
        var v = f.initialState, w = v === void 0 ? an : v, m = f.defaultColumn, D = m === void 0 ? hn : m, M = f.getSubRows, R = M === void 0 ? zn : M, W = f.getRowId, q = W === void 0 ? Z : W, J = f.stateReducer, ae = J === void 0 ? Wn : J, Ee = f.useControlledState, de = Ee === void 0 ? Ve : Ee, Ce = s(f, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]);
        return i({}, Ce, {
          initialState: w,
          defaultColumn: D,
          getSubRows: R,
          getRowId: q,
          stateReducer: ae,
          useControlledState: de
        });
      }
      var Mt = function(v) {
        for (var w = arguments.length, m = new Array(w > 1 ? w - 1 : 0), D = 1; D < w; D++)
          m[D - 1] = arguments[D];
        v = ct(v), m = [Re].concat(m);
        var M = t.useRef({}), R = F(M.current);
        Object.assign(R(), i({}, v, {
          plugins: m,
          hooks: on()
        })), m.filter(Boolean).forEach(function(ft) {
          ft(R().hooks);
        });
        var W = F(R().hooks);
        R().getHooks = W, delete R().hooks, Object.assign(R(), I(W().useOptions, ct(v)));
        var q = R(), J = q.data, ae = q.columns, Ee = q.initialState, de = q.defaultColumn, Ce = q.getSubRows, $e = q.getRowId, ue = q.stateReducer, He = q.useControlledState, st = F(ue), vt = t.useCallback(function(ft, hr) {
          if (!hr.type)
            throw console.info({
              action: hr
            }), new Error("Unknown Action 👆");
          return [].concat(W().stateReducers, Array.isArray(st()) ? st() : [st()]).reduce(function(_r, sn) {
            return sn(_r, hr, ft, R()) || _r;
          }, ft);
        }, [W, st, R]), Me = t.useReducer(vt, void 0, function() {
          return vt(Ee, {
            type: p.init
          });
        }), Ct = Me[0], Tt = Me[1], Fe = I([].concat(W().useControlledState, [He]), Ct, {
          instance: R()
        });
        Object.assign(R(), {
          state: Fe,
          dispatch: Tt
        });
        var je = t.useMemo(function() {
          return ee(I(W().columns, ae, {
            instance: R()
          }));
        }, [W, R, ae].concat(I(W().columnsDeps, [], {
          instance: R()
        })));
        R().columns = je;
        var Le = t.useMemo(function() {
          return I(W().allColumns, oe(je), {
            instance: R()
          }).map(ge);
        }, [je, W, R].concat(I(W().allColumnsDeps, [], {
          instance: R()
        })));
        R().allColumns = Le;
        var ot = t.useMemo(function() {
          for (var ft = [], hr = [], _r = {}, sn = [].concat(Le); sn.length; ) {
            var Ar = sn.shift();
            vr({
              data: J,
              rows: ft,
              flatRows: hr,
              rowsById: _r,
              column: Ar,
              getRowId: $e,
              getSubRows: Ce,
              accessValueHooks: W().accessValue,
              getInstance: R
            });
          }
          return [ft, hr, _r];
        }, [Le, J, $e, Ce, W, R]), Pt = ot[0], kt = ot[1], ar = ot[2];
        Object.assign(R(), {
          rows: Pt,
          initialRows: [].concat(Pt),
          flatRows: kt,
          rowsById: ar
          // materializedColumns,
        }), H(W().useInstanceAfterData, R());
        var Qe = t.useMemo(function() {
          return I(W().visibleColumns, Le, {
            instance: R()
          }).map(function(ft) {
            return be(ft, de);
          });
        }, [W, Le, R, de].concat(I(W().visibleColumnsDeps, [], {
          instance: R()
        })));
        Le = t.useMemo(function() {
          var ft = [].concat(Qe);
          return Le.forEach(function(hr) {
            ft.find(function(_r) {
              return _r.id === hr.id;
            }) || ft.push(hr);
          }), ft;
        }, [Le, Qe]), R().allColumns = Le;
        {
          var Mr = Le.filter(function(ft, hr) {
            return Le.findIndex(function(_r) {
              return _r.id === ft.id;
            }) !== hr;
          });
          if (Mr.length)
            throw console.info(Le), new Error('Duplicate columns were found with ids: "' + Mr.map(function(ft) {
              return ft.id;
            }).join(", ") + '" in the columns array above');
        }
        var Rt = t.useMemo(function() {
          return I(W().headerGroups, he(Qe, de), R());
        }, [W, Qe, de, R].concat(I(W().headerGroupsDeps, [], {
          instance: R()
        })));
        R().headerGroups = Rt;
        var ht = t.useMemo(function() {
          return Rt.length ? Rt[0].headers : [];
        }, [Rt]);
        R().headers = ht, R().flatHeaders = Rt.reduce(function(ft, hr) {
          return [].concat(ft, hr.headers);
        }, []), H(W().useInstanceBeforeDimensions, R());
        var yt = Qe.filter(function(ft) {
          return ft.isVisible;
        }).map(function(ft) {
          return ft.id;
        }).sort().join("_");
        Qe = t.useMemo(
          function() {
            return Qe.filter(function(ft) {
              return ft.isVisible;
            });
          },
          // eslint-disable-next-line react-hooks/exhaustive-deps
          [Qe, yt]
        ), R().visibleColumns = Qe;
        var cr = Et(ht), Wr = cr[0], Jo = cr[1], ui = cr[2];
        return R().totalColumnsMinWidth = Wr, R().totalColumnsWidth = Jo, R().totalColumnsMaxWidth = ui, H(W().useInstance, R()), [].concat(R().flatHeaders, R().allColumns).forEach(function(ft) {
          ft.render = ie(R(), ft), ft.getHeaderProps = $(W().getHeaderProps, {
            instance: R(),
            column: ft
          }), ft.getFooterProps = $(W().getFooterProps, {
            instance: R(),
            column: ft
          });
        }), R().headerGroups = t.useMemo(function() {
          return Rt.filter(function(ft, hr) {
            return ft.headers = ft.headers.filter(function(_r) {
              var sn = function Ar(Ro) {
                return Ro.filter(function(Qr) {
                  return Qr.headers ? Ar(Qr.headers) : Qr.isVisible;
                }).length;
              };
              return _r.headers ? sn(_r.headers) : _r.isVisible;
            }), ft.headers.length ? (ft.getHeaderGroupProps = $(W().getHeaderGroupProps, {
              instance: R(),
              headerGroup: ft,
              index: hr
            }), ft.getFooterGroupProps = $(W().getFooterGroupProps, {
              instance: R(),
              headerGroup: ft,
              index: hr
            }), !0) : !1;
          });
        }, [Rt, R, W]), R().footerGroups = [].concat(R().headerGroups).reverse(), R().prepareRow = t.useCallback(function(ft) {
          ft.getRowProps = $(W().getRowProps, {
            instance: R(),
            row: ft
          }), ft.allCells = Le.map(function(hr) {
            var _r = ft.values[hr.id], sn = {
              column: hr,
              row: ft,
              value: _r
            };
            return sn.getCellProps = $(W().getCellProps, {
              instance: R(),
              cell: sn
            }), sn.render = ie(R(), hr, {
              row: ft,
              cell: sn,
              value: _r
            }), sn;
          }), ft.cells = Qe.map(function(hr) {
            return ft.allCells.find(function(_r) {
              return _r.column.id === hr.id;
            });
          }), H(W().prepareRow, ft, {
            instance: R()
          });
        }, [W, R, Le, Qe]), R().getTableProps = $(W().getTableProps, {
          instance: R()
        }), R().getTableBodyProps = $(W().getTableBodyProps, {
          instance: R()
        }), H(W().useFinalInstance, R()), R();
      };
      function Et(f, v) {
        v === void 0 && (v = 0);
        var w = 0, m = 0, D = 0, M = 0;
        return f.forEach(function(R) {
          var W = R.headers;
          if (R.totalLeft = v, W && W.length) {
            var q = Et(W, v), J = q[0], ae = q[1], Ee = q[2], de = q[3];
            R.totalMinWidth = J, R.totalWidth = ae, R.totalMaxWidth = Ee, R.totalFlexWidth = de;
          } else
            R.totalMinWidth = R.minWidth, R.totalWidth = Math.min(Math.max(R.minWidth, R.width), R.maxWidth), R.totalMaxWidth = R.maxWidth, R.totalFlexWidth = R.canResize ? R.totalWidth : 0;
          R.isVisible && (v += R.totalWidth, w += R.totalMinWidth, m += R.totalWidth, D += R.totalMaxWidth, M += R.totalFlexWidth);
        }), [w, m, D, M];
      }
      function vr(f) {
        var v = f.data, w = f.rows, m = f.flatRows, D = f.rowsById, M = f.column, R = f.getRowId, W = f.getSubRows, q = f.accessValueHooks, J = f.getInstance, ae = function Ee(de, Ce, $e, ue, He) {
          $e === void 0 && ($e = 0);
          var st = de, vt = R(de, Ce, ue), Me = D[vt];
          if (Me)
            Me.subRows && Me.originalSubRows.forEach(function(Tt, Fe) {
              return Ee(Tt, Fe, $e + 1, Me);
            });
          else if (Me = {
            id: vt,
            original: st,
            index: Ce,
            depth: $e,
            cells: [{}]
            // This is a dummy cell
          }, Me.cells.map = _e, Me.cells.filter = _e, Me.cells.forEach = _e, Me.cells[0].getCellProps = _e, Me.values = {}, He.push(Me), m.push(Me), D[vt] = Me, Me.originalSubRows = W(de, Ce), Me.originalSubRows) {
            var Ct = [];
            Me.originalSubRows.forEach(function(Tt, Fe) {
              return Ee(Tt, Fe, $e + 1, Me, Ct);
            }), Me.subRows = Ct;
          }
          M.accessor && (Me.values[M.id] = M.accessor(de, Ce, Me, He, v)), Me.values[M.id] = I(q, Me.values[M.id], {
            row: Me,
            column: M,
            instance: J()
          }, !0);
        };
        v.forEach(function(Ee, de) {
          return ae(Ee, de, 0, void 0, w);
        });
      }
      p.resetExpanded = "resetExpanded", p.toggleRowExpanded = "toggleRowExpanded", p.toggleAllRowsExpanded = "toggleAllRowsExpanded";
      var Rr = function(v) {
        v.getToggleAllRowsExpandedProps = [Br], v.getToggleRowExpandedProps = [Hn], v.stateReducers.push(Zr), v.useInstance.push(pn), v.prepareRow.push(Yn);
      };
      Rr.pluginName = "useExpanded";
      var Br = function(v, w) {
        var m = w.instance;
        return [v, {
          onClick: function(M) {
            m.toggleAllRowsExpanded();
          },
          style: {
            cursor: "pointer"
          },
          title: "Toggle All Rows Expanded"
        }];
      }, Hn = function(v, w) {
        var m = w.row;
        return [v, {
          onClick: function() {
            m.toggleRowExpanded();
          },
          style: {
            cursor: "pointer"
          },
          title: "Toggle Row Expanded"
        }];
      };
      function Zr(f, v, w, m) {
        if (v.type === p.init)
          return i({
            expanded: {}
          }, f);
        if (v.type === p.resetExpanded)
          return i({}, f, {
            expanded: m.initialState.expanded || {}
          });
        if (v.type === p.toggleAllRowsExpanded) {
          var D = v.value, M = m.rowsById, R = Object.keys(M).length === Object.keys(f.expanded).length, W = typeof D < "u" ? D : !R;
          if (W) {
            var q = {};
            return Object.keys(M).forEach(function(He) {
              q[He] = !0;
            }), i({}, f, {
              expanded: q
            });
          }
          return i({}, f, {
            expanded: {}
          });
        }
        if (v.type === p.toggleRowExpanded) {
          var J = v.id, ae = v.value, Ee = f.expanded[J], de = typeof ae < "u" ? ae : !Ee;
          if (!Ee && de) {
            var Ce;
            return i({}, f, {
              expanded: i({}, f.expanded, (Ce = {}, Ce[J] = !0, Ce))
            });
          } else if (Ee && !de) {
            var $e = f.expanded;
            $e[J];
            var ue = s($e, [J].map(u));
            return i({}, f, {
              expanded: ue
            });
          } else
            return f;
        }
      }
      function pn(f) {
        var v = f.data, w = f.rows, m = f.rowsById, D = f.manualExpandedKey, M = D === void 0 ? "expanded" : D, R = f.paginateExpandedRows, W = R === void 0 ? !0 : R, q = f.expandSubRows, J = q === void 0 ? !0 : q, ae = f.autoResetExpanded, Ee = ae === void 0 ? !0 : ae, de = f.getHooks, Ce = f.plugins, $e = f.state.expanded, ue = f.dispatch;
        x(Ce, ["useSortBy", "useGroupBy", "usePivotColumns", "useGlobalFilter"], "useExpanded");
        var He = F(Ee), st = !!(Object.keys(m).length && Object.keys($e).length);
        st && Object.keys(m).some(function(Le) {
          return !$e[Le];
        }) && (st = !1), Q(function() {
          He() && ue({
            type: p.resetExpanded
          });
        }, [ue, v]);
        var vt = t.useCallback(function(Le, ot) {
          ue({
            type: p.toggleRowExpanded,
            id: Le,
            value: ot
          });
        }, [ue]), Me = t.useCallback(function(Le) {
          return ue({
            type: p.toggleAllRowsExpanded,
            value: Le
          });
        }, [ue]), Ct = t.useMemo(function() {
          return W ? ut(w, {
            manualExpandedKey: M,
            expanded: $e,
            expandSubRows: J
          }) : w;
        }, [W, w, M, $e, J]), Tt = t.useMemo(function() {
          return mn($e);
        }, [$e]), Fe = F(f), je = $(de().getToggleAllRowsExpandedProps, {
          instance: Fe()
        });
        Object.assign(f, {
          preExpandedRows: w,
          expandedRows: Ct,
          rows: Ct,
          expandedDepth: Tt,
          isAllRowsExpanded: st,
          toggleRowExpanded: vt,
          toggleAllRowsExpanded: Me,
          getToggleAllRowsExpandedProps: je
        });
      }
      function Yn(f, v) {
        var w = v.instance.getHooks, m = v.instance;
        f.toggleRowExpanded = function(D) {
          return m.toggleRowExpanded(f.id, D);
        }, f.getToggleRowExpandedProps = $(w().getToggleRowExpandedProps, {
          instance: m,
          row: f
        });
      }
      function mn(f) {
        var v = 0;
        return Object.keys(f).forEach(function(w) {
          var m = w.split(".");
          v = Math.max(v, m.length);
        }), v;
      }
      var Eo = function(v, w, m) {
        return v = v.filter(function(D) {
          return w.some(function(M) {
            var R = D.values[M];
            return String(R).toLowerCase().includes(String(m).toLowerCase());
          });
        }), v;
      };
      Eo.autoRemove = function(f) {
        return !f;
      };
      var $n = function(v, w, m) {
        return v.filter(function(D) {
          return w.some(function(M) {
            var R = D.values[M];
            return R !== void 0 ? String(R).toLowerCase() === String(m).toLowerCase() : !0;
          });
        });
      };
      $n.autoRemove = function(f) {
        return !f;
      };
      var Dn = function(v, w, m) {
        return v.filter(function(D) {
          return w.some(function(M) {
            var R = D.values[M];
            return R !== void 0 ? String(R) === String(m) : !0;
          });
        });
      };
      Dn.autoRemove = function(f) {
        return !f;
      };
      var ha = function(v, w, m) {
        return v.filter(function(D) {
          return w.some(function(M) {
            var R = D.values[M];
            return R.includes(m);
          });
        });
      };
      ha.autoRemove = function(f) {
        return !f || !f.length;
      };
      var Ko = function(v, w, m) {
        return v.filter(function(D) {
          return w.some(function(M) {
            var R = D.values[M];
            return R && R.length && m.every(function(W) {
              return R.includes(W);
            });
          });
        });
      };
      Ko.autoRemove = function(f) {
        return !f || !f.length;
      };
      var ko = function(v, w, m) {
        return v.filter(function(D) {
          return w.some(function(M) {
            var R = D.values[M];
            return R && R.length && m.some(function(W) {
              return R.includes(W);
            });
          });
        });
      };
      ko.autoRemove = function(f) {
        return !f || !f.length;
      };
      var ma = function(v, w, m) {
        return v.filter(function(D) {
          return w.some(function(M) {
            var R = D.values[M];
            return m.includes(R);
          });
        });
      };
      ma.autoRemove = function(f) {
        return !f || !f.length;
      };
      var ya = function(v, w, m) {
        return v.filter(function(D) {
          return w.some(function(M) {
            var R = D.values[M];
            return R === m;
          });
        });
      };
      ya.autoRemove = function(f) {
        return typeof f > "u";
      };
      var Qo = function(v, w, m) {
        return v.filter(function(D) {
          return w.some(function(M) {
            var R = D.values[M];
            return R == m;
          });
        });
      };
      Qo.autoRemove = function(f) {
        return f == null;
      };
      var ba = function(v, w, m) {
        var D = m || [], M = D[0], R = D[1];
        if (M = typeof M == "number" ? M : -1 / 0, R = typeof R == "number" ? R : 1 / 0, M > R) {
          var W = M;
          M = R, R = W;
        }
        return v.filter(function(q) {
          return w.some(function(J) {
            var ae = q.values[J];
            return ae >= M && ae <= R;
          });
        });
      };
      ba.autoRemove = function(f) {
        return !f || typeof f[0] != "number" && typeof f[1] != "number";
      };
      var N = /* @__PURE__ */ Object.freeze({
        __proto__: null,
        text: Eo,
        exactText: $n,
        exactTextCase: Dn,
        includes: ha,
        includesAll: Ko,
        includesSome: ko,
        includesValue: ma,
        exact: ya,
        equals: Qo,
        between: ba
      });
      p.resetFilters = "resetFilters", p.setFilter = "setFilter", p.setAllFilters = "setAllFilters";
      var pe = function(v) {
        v.stateReducers.push(Ie), v.useInstance.push(bt);
      };
      pe.pluginName = "useFilters";
      function Ie(f, v, w, m) {
        if (v.type === p.init)
          return i({
            filters: []
          }, f);
        if (v.type === p.resetFilters)
          return i({}, f, {
            filters: m.initialState.filters || []
          });
        if (v.type === p.setFilter) {
          var D = v.columnId, M = v.filterValue, R = m.allColumns, W = m.filterTypes, q = R.find(function(ue) {
            return ue.id === D;
          });
          if (!q)
            throw new Error("React-Table: Could not find a column with id: " + D);
          var J = ze(q.filter, W || {}, N), ae = f.filters.find(function(ue) {
            return ue.id === D;
          }), Ee = _(M, ae && ae.value);
          return Ze(J.autoRemove, Ee, q) ? i({}, f, {
            filters: f.filters.filter(function(ue) {
              return ue.id !== D;
            })
          }) : ae ? i({}, f, {
            filters: f.filters.map(function(ue) {
              return ue.id === D ? {
                id: D,
                value: Ee
              } : ue;
            })
          }) : i({}, f, {
            filters: [].concat(f.filters, [{
              id: D,
              value: Ee
            }])
          });
        }
        if (v.type === p.setAllFilters) {
          var de = v.filters, Ce = m.allColumns, $e = m.filterTypes;
          return i({}, f, {
            // Filter out undefined values
            filters: _(de, f.filters).filter(function(ue) {
              var He = Ce.find(function(vt) {
                return vt.id === ue.id;
              }), st = ze(He.filter, $e || {}, N);
              return !Ze(st.autoRemove, ue.value, He);
            })
          });
        }
      }
      function bt(f) {
        var v = f.data, w = f.rows, m = f.flatRows, D = f.rowsById, M = f.allColumns, R = f.filterTypes, W = f.manualFilters, q = f.defaultCanFilter, J = q === void 0 ? !1 : q, ae = f.disableFilters, Ee = f.state.filters, de = f.dispatch, Ce = f.autoResetFilters, $e = Ce === void 0 ? !0 : Ce, ue = t.useCallback(function(Fe, je) {
          de({
            type: p.setFilter,
            columnId: Fe,
            filterValue: je
          });
        }, [de]), He = t.useCallback(function(Fe) {
          de({
            type: p.setAllFilters,
            filters: Fe
          });
        }, [de]);
        M.forEach(function(Fe) {
          var je = Fe.id, Le = Fe.accessor, ot = Fe.defaultCanFilter, Pt = Fe.disableFilters;
          Fe.canFilter = Le ? Pe(Pt === !0 ? !1 : void 0, ae === !0 ? !1 : void 0, !0) : Pe(ot, J, !1), Fe.setFilter = function(ar) {
            return ue(Fe.id, ar);
          };
          var kt = Ee.find(function(ar) {
            return ar.id === je;
          });
          Fe.filterValue = kt && kt.value;
        });
        var st = t.useMemo(function() {
          if (W || !Ee.length)
            return [w, m, D];
          var Fe = [], je = {}, Le = function ot(Pt, kt) {
            kt === void 0 && (kt = 0);
            var ar = Pt;
            return ar = Ee.reduce(function(Qe, Mr) {
              var Rt = Mr.id, ht = Mr.value, yt = M.find(function(Wr) {
                return Wr.id === Rt;
              });
              if (!yt)
                return Qe;
              kt === 0 && (yt.preFilteredRows = Qe);
              var cr = ze(yt.filter, R || {}, N);
              return cr ? (yt.filteredRows = cr(Qe, [Rt], ht), yt.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + yt.id + "."), Qe);
            }, Pt), ar.forEach(function(Qe) {
              Fe.push(Qe), je[Qe.id] = Qe, Qe.subRows && (Qe.subRows = Qe.subRows && Qe.subRows.length > 0 ? ot(Qe.subRows, kt + 1) : Qe.subRows);
            }), ar;
          };
          return [Le(w), Fe, je];
        }, [W, Ee, w, m, D, M, R]), vt = st[0], Me = st[1], Ct = st[2];
        t.useMemo(function() {
          var Fe = M.filter(function(je) {
            return !Ee.find(function(Le) {
              return Le.id === je.id;
            });
          });
          Fe.forEach(function(je) {
            je.preFilteredRows = vt, je.filteredRows = vt;
          });
        }, [vt, Ee, M]);
        var Tt = F($e);
        Q(function() {
          Tt() && de({
            type: p.resetFilters
          });
        }, [de, W ? null : v]), Object.assign(f, {
          preFilteredRows: w,
          preFilteredFlatRows: m,
          preFilteredRowsById: D,
          filteredRows: vt,
          filteredFlatRows: Me,
          filteredRowsById: Ct,
          rows: vt,
          flatRows: Me,
          rowsById: Ct,
          setFilter: ue,
          setAllFilters: He
        });
      }
      p.resetGlobalFilter = "resetGlobalFilter", p.setGlobalFilter = "setGlobalFilter";
      var Bt = function(v) {
        v.stateReducers.push(rr), v.useInstance.push(At);
      };
      Bt.pluginName = "useGlobalFilter";
      function rr(f, v, w, m) {
        if (v.type === p.resetGlobalFilter)
          return i({}, f, {
            globalFilter: m.initialState.globalFilter || void 0
          });
        if (v.type === p.setGlobalFilter) {
          var D = v.filterValue, M = m.userFilterTypes, R = ze(m.globalFilter, M || {}, N), W = _(D, f.globalFilter);
          if (Ze(R.autoRemove, W)) {
            f.globalFilter;
            var q = s(f, ["globalFilter"]);
            return q;
          }
          return i({}, f, {
            globalFilter: W
          });
        }
      }
      function At(f) {
        var v = f.data, w = f.rows, m = f.flatRows, D = f.rowsById, M = f.allColumns, R = f.filterTypes, W = f.globalFilter, q = f.manualGlobalFilter, J = f.state.globalFilter, ae = f.dispatch, Ee = f.autoResetGlobalFilter, de = Ee === void 0 ? !0 : Ee, Ce = f.disableGlobalFilter, $e = t.useCallback(function(Ct) {
          ae({
            type: p.setGlobalFilter,
            filterValue: Ct
          });
        }, [ae]), ue = t.useMemo(function() {
          if (q || typeof J > "u")
            return [w, m, D];
          var Ct = [], Tt = {}, Fe = ze(W, R || {}, N);
          if (!Fe)
            return console.warn("Could not find a valid 'globalFilter' option."), w;
          M.forEach(function(ot) {
            var Pt = ot.disableGlobalFilter;
            ot.canFilter = Pe(Pt === !0 ? !1 : void 0, Ce === !0 ? !1 : void 0, !0);
          });
          var je = M.filter(function(ot) {
            return ot.canFilter === !0;
          }), Le = function ot(Pt) {
            return Pt = Fe(Pt, je.map(function(kt) {
              return kt.id;
            }), J), Pt.forEach(function(kt) {
              Ct.push(kt), Tt[kt.id] = kt, kt.subRows = kt.subRows && kt.subRows.length ? ot(kt.subRows) : kt.subRows;
            }), Pt;
          };
          return [Le(w), Ct, Tt];
        }, [q, J, W, R, M, w, m, D, Ce]), He = ue[0], st = ue[1], vt = ue[2], Me = F(de);
        Q(function() {
          Me() && ae({
            type: p.resetGlobalFilter
          });
        }, [ae, q ? null : v]), Object.assign(f, {
          preGlobalFilteredRows: w,
          preGlobalFilteredFlatRows: m,
          preGlobalFilteredRowsById: D,
          globalFilteredRows: He,
          globalFilteredFlatRows: st,
          globalFilteredRowsById: vt,
          rows: He,
          flatRows: st,
          rowsById: vt,
          setGlobalFilter: $e,
          disableGlobalFilter: Ce
        });
      }
      function jt(f, v) {
        return v.reduce(function(w, m) {
          return w + (typeof m == "number" ? m : 0);
        }, 0);
      }
      function wr(f) {
        var v = f[0] || 0;
        return f.forEach(function(w) {
          typeof w == "number" && (v = Math.min(v, w));
        }), v;
      }
      function gr(f) {
        var v = f[0] || 0;
        return f.forEach(function(w) {
          typeof w == "number" && (v = Math.max(v, w));
        }), v;
      }
      function yr(f) {
        var v = f[0] || 0, w = f[0] || 0;
        return f.forEach(function(m) {
          typeof m == "number" && (v = Math.min(v, m), w = Math.max(w, m));
        }), v + ".." + w;
      }
      function Kr(f) {
        return jt(null, f) / f.length;
      }
      function Xn(f) {
        if (!f.length)
          return null;
        var v = Math.floor(f.length / 2), w = [].concat(f).sort(function(m, D) {
          return m - D;
        });
        return f.length % 2 !== 0 ? w[v] : (w[v - 1] + w[v]) / 2;
      }
      function wa(f) {
        return Array.from(new Set(f).values());
      }
      function yn(f) {
        return new Set(f).size;
      }
      function ts(f) {
        return f.length;
      }
      var Za = /* @__PURE__ */ Object.freeze({
        __proto__: null,
        sum: jt,
        min: wr,
        max: gr,
        minMax: yr,
        average: Kr,
        median: Xn,
        unique: wa,
        uniqueCount: yn,
        count: ts
      }), Vl = [], Ul = {};
      p.resetGroupBy = "resetGroupBy", p.setGroupBy = "setGroupBy", p.toggleGroupBy = "toggleGroupBy";
      var ei = function(v) {
        v.getGroupByToggleProps = [rs], v.stateReducers.push(ql), v.visibleColumnsDeps.push(function(w, m) {
          var D = m.instance;
          return [].concat(w, [D.state.groupBy]);
        }), v.visibleColumns.push(Kl), v.useInstance.push(Xl), v.prepareRow.push(Jl);
      };
      ei.pluginName = "useGroupBy";
      var rs = function(v, w) {
        var m = w.header;
        return [v, {
          onClick: m.canGroupBy ? function(D) {
            D.persist(), m.toggleGroupBy();
          } : void 0,
          style: {
            cursor: m.canGroupBy ? "pointer" : void 0
          },
          title: "Toggle GroupBy"
        }];
      };
      function ql(f, v, w, m) {
        if (v.type === p.init)
          return i({
            groupBy: []
          }, f);
        if (v.type === p.resetGroupBy)
          return i({}, f, {
            groupBy: m.initialState.groupBy || []
          });
        if (v.type === p.setGroupBy) {
          var D = v.value;
          return i({}, f, {
            groupBy: D
          });
        }
        if (v.type === p.toggleGroupBy) {
          var M = v.columnId, R = v.value, W = typeof R < "u" ? R : !f.groupBy.includes(M);
          return W ? i({}, f, {
            groupBy: [].concat(f.groupBy, [M])
          }) : i({}, f, {
            groupBy: f.groupBy.filter(function(q) {
              return q !== M;
            })
          });
        }
      }
      function Kl(f, v) {
        var w = v.instance.state.groupBy, m = w.map(function(M) {
          return f.find(function(R) {
            return R.id === M;
          });
        }).filter(Boolean), D = f.filter(function(M) {
          return !w.includes(M.id);
        });
        return f = [].concat(m, D), f.forEach(function(M) {
          M.isGrouped = w.includes(M.id), M.groupedIndex = w.indexOf(M.id);
        }), f;
      }
      var Ql = {};
      function Xl(f) {
        var v = f.data, w = f.rows, m = f.flatRows, D = f.rowsById, M = f.allColumns, R = f.flatHeaders, W = f.groupByFn, q = W === void 0 ? ns : W, J = f.manualGroupBy, ae = f.aggregations, Ee = ae === void 0 ? Ql : ae, de = f.plugins, Ce = f.state.groupBy, $e = f.dispatch, ue = f.autoResetGroupBy, He = ue === void 0 ? !0 : ue, st = f.disableGroupBy, vt = f.defaultCanGroupBy, Me = f.getHooks;
        x(de, ["useColumnOrder", "useFilters"], "useGroupBy");
        var Ct = F(f);
        M.forEach(function(ht) {
          var yt = ht.accessor, cr = ht.defaultGroupBy, Wr = ht.disableGroupBy;
          ht.canGroupBy = yt ? Pe(ht.canGroupBy, Wr === !0 ? !1 : void 0, st === !0 ? !1 : void 0, !0) : Pe(ht.canGroupBy, cr, vt, !1), ht.canGroupBy && (ht.toggleGroupBy = function() {
            return f.toggleGroupBy(ht.id);
          }), ht.Aggregated = ht.Aggregated || ht.Cell;
        });
        var Tt = t.useCallback(function(ht, yt) {
          $e({
            type: p.toggleGroupBy,
            columnId: ht,
            value: yt
          });
        }, [$e]), Fe = t.useCallback(function(ht) {
          $e({
            type: p.setGroupBy,
            value: ht
          });
        }, [$e]);
        R.forEach(function(ht) {
          ht.getGroupByToggleProps = $(Me().getGroupByToggleProps, {
            instance: Ct(),
            header: ht
          });
        });
        var je = t.useMemo(function() {
          if (J || !Ce.length)
            return [w, m, D, Vl, Ul, m, D];
          var ht = Ce.filter(function(Ar) {
            return M.find(function(Ro) {
              return Ro.id === Ar;
            });
          }), yt = function(Ro, Qr, Cs) {
            var $o = {};
            return M.forEach(function(Er) {
              if (ht.includes(Er.id)) {
                $o[Er.id] = Qr[0] ? Qr[0].values[Er.id] : null;
                return;
              }
              var Ss = typeof Er.aggregate == "function" ? Er.aggregate : Ee[Er.aggregate] || Za[Er.aggregate];
              if (Ss) {
                var Ca = Qr.map(function(Zo) {
                  return Zo.values[Er.id];
                }), hu = Ro.map(function(Zo) {
                  var Do = Zo.values[Er.id];
                  if (!Cs && Er.aggregateValue) {
                    var To = typeof Er.aggregateValue == "function" ? Er.aggregateValue : Ee[Er.aggregateValue] || Za[Er.aggregateValue];
                    if (!To)
                      throw console.info({
                        column: Er
                      }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                    Do = To(Do, Zo, Er);
                  }
                  return Do;
                });
                $o[Er.id] = Ss(hu, Ca);
              } else {
                if (Er.aggregate)
                  throw console.info({
                    column: Er
                  }), new Error("React Table: Invalid column.aggregate option for column listed above");
                $o[Er.id] = null;
              }
            }), $o;
          }, cr = [], Wr = {}, Jo = [], ui = {}, ft = [], hr = {}, _r = function Ar(Ro, Qr, Cs) {
            if (Qr === void 0 && (Qr = 0), Qr === ht.length)
              return Ro.map(function(Ca) {
                return i({}, Ca, {
                  depth: Qr
                });
              });
            var $o = ht[Qr], Er = q(Ro, $o), Ss = Object.entries(Er).map(function(Ca, hu) {
              var Zo = Ca[0], Do = Ca[1], To = $o + ":" + Zo;
              To = Cs ? Cs + ">" + To : To;
              var dv = Ar(Do, Qr + 1, To), pv = Qr ? Ge(Do, "leafRows") : Do, Rb = yt(pv, Do, Qr), $b = {
                id: To,
                isGrouped: !0,
                groupByID: $o,
                groupByVal: Zo,
                values: Rb,
                subRows: dv,
                leafRows: pv,
                depth: Qr,
                index: hu
              };
              return dv.forEach(function(Jn) {
                cr.push(Jn), Wr[Jn.id] = Jn, Jn.isGrouped ? (Jo.push(Jn), ui[Jn.id] = Jn) : (ft.push(Jn), hr[Jn.id] = Jn);
              }), $b;
            });
            return Ss;
          }, sn = _r(w);
          return sn.forEach(function(Ar) {
            cr.push(Ar), Wr[Ar.id] = Ar, Ar.isGrouped ? (Jo.push(Ar), ui[Ar.id] = Ar) : (ft.push(Ar), hr[Ar.id] = Ar);
          }), [sn, cr, Wr, Jo, ui, ft, hr];
        }, [J, Ce, w, m, D, M, Ee, q]), Le = je[0], ot = je[1], Pt = je[2], kt = je[3], ar = je[4], Qe = je[5], Mr = je[6], Rt = F(He);
        Q(function() {
          Rt() && $e({
            type: p.resetGroupBy
          });
        }, [$e, J ? null : v]), Object.assign(f, {
          preGroupedRows: w,
          preGroupedFlatRow: m,
          preGroupedRowsById: D,
          groupedRows: Le,
          groupedFlatRows: ot,
          groupedRowsById: Pt,
          onlyGroupedFlatRows: kt,
          onlyGroupedRowsById: ar,
          nonGroupedFlatRows: Qe,
          nonGroupedRowsById: Mr,
          rows: Le,
          flatRows: ot,
          rowsById: Pt,
          toggleGroupBy: Tt,
          setGroupBy: Fe
        });
      }
      function Jl(f) {
        f.allCells.forEach(function(v) {
          var w;
          v.isGrouped = v.column.isGrouped && v.column.id === f.groupByID, v.isPlaceholder = !v.isGrouped && v.column.isGrouped, v.isAggregated = !v.isGrouped && !v.isPlaceholder && ((w = f.subRows) == null ? void 0 : w.length);
        });
      }
      function ns(f, v) {
        return f.reduce(function(w, m, D) {
          var M = "" + m.values[v];
          return w[M] = Array.isArray(w[M]) ? w[M] : [], w[M].push(m), w;
        }, {});
      }
      var os = /([0-9]+)/gm, Zl = function(v, w, m) {
        var D = Xo(v, w, m), M = D[0], R = D[1];
        for (M = is(M), R = is(R), M = M.split(os).filter(Boolean), R = R.split(os).filter(Boolean); M.length && R.length; ) {
          var W = M.shift(), q = R.shift(), J = parseInt(W, 10), ae = parseInt(q, 10), Ee = [J, ae].sort();
          if (isNaN(Ee[0])) {
            if (W > q)
              return 1;
            if (q > W)
              return -1;
            continue;
          }
          if (isNaN(Ee[1]))
            return isNaN(J) ? -1 : 1;
          if (J > ae)
            return 1;
          if (ae > J)
            return -1;
        }
        return M.length - R.length;
      };
      function eu(f, v, w) {
        var m = Xo(f, v, w), D = m[0], M = m[1];
        return D = D.getTime(), M = M.getTime(), ti(D, M);
      }
      function tu(f, v, w) {
        var m = Xo(f, v, w), D = m[0], M = m[1];
        return ti(D, M);
      }
      function ru(f, v, w) {
        var m = Xo(f, v, w), D = m[0], M = m[1];
        for (D = D.split("").filter(Boolean), M = M.split("").filter(Boolean); D.length && M.length; ) {
          var R = D.shift(), W = M.shift(), q = R.toLowerCase(), J = W.toLowerCase();
          if (q > J)
            return 1;
          if (J > q)
            return -1;
          if (R > W)
            return 1;
          if (W > R)
            return -1;
        }
        return D.length - M.length;
      }
      function as(f, v, w) {
        var m = Xo(f, v, w), D = m[0], M = m[1], R = /[^0-9.]/gi;
        return D = Number(String(D).replace(R, "")), M = Number(String(M).replace(R, "")), ti(D, M);
      }
      function ti(f, v) {
        return f === v ? 0 : f > v ? 1 : -1;
      }
      function Xo(f, v, w) {
        return [f.values[w], v.values[w]];
      }
      function is(f) {
        return typeof f == "number" ? isNaN(f) || f === 1 / 0 || f === -1 / 0 ? "" : String(f) : typeof f == "string" ? f : "";
      }
      var nu = /* @__PURE__ */ Object.freeze({
        __proto__: null,
        alphanumeric: Zl,
        datetime: eu,
        basic: tu,
        string: ru,
        number: as
      });
      p.resetSortBy = "resetSortBy", p.setSortBy = "setSortBy", p.toggleSortBy = "toggleSortBy", p.clearSortBy = "clearSortBy", C.sortType = "alphanumeric", C.sortDescFirst = !1;
      var ss = function(v) {
        v.getSortByToggleProps = [ou], v.stateReducers.push(ls), v.useInstance.push(us);
      };
      ss.pluginName = "useSortBy";
      var ou = function(v, w) {
        var m = w.instance, D = w.column, M = m.isMultiSortEvent, R = M === void 0 ? function(W) {
          return W.shiftKey;
        } : M;
        return [v, {
          onClick: D.canSort ? function(W) {
            W.persist(), D.toggleSortBy(void 0, !m.disableMultiSort && R(W));
          } : void 0,
          style: {
            cursor: D.canSort ? "pointer" : void 0
          },
          title: D.canSort ? "Toggle SortBy" : void 0
        }];
      };
      function ls(f, v, w, m) {
        if (v.type === p.init)
          return i({
            sortBy: []
          }, f);
        if (v.type === p.resetSortBy)
          return i({}, f, {
            sortBy: m.initialState.sortBy || []
          });
        if (v.type === p.clearSortBy) {
          var D = f.sortBy, M = D.filter(function(Le) {
            return Le.id !== v.columnId;
          });
          return i({}, f, {
            sortBy: M
          });
        }
        if (v.type === p.setSortBy) {
          var R = v.sortBy;
          return i({}, f, {
            sortBy: R
          });
        }
        if (v.type === p.toggleSortBy) {
          var W = v.columnId, q = v.desc, J = v.multi, ae = m.allColumns, Ee = m.disableMultiSort, de = m.disableSortRemove, Ce = m.disableMultiRemove, $e = m.maxMultiSortColCount, ue = $e === void 0 ? Number.MAX_SAFE_INTEGER : $e, He = f.sortBy, st = ae.find(function(Le) {
            return Le.id === W;
          }), vt = st.sortDescFirst, Me = He.find(function(Le) {
            return Le.id === W;
          }), Ct = He.findIndex(function(Le) {
            return Le.id === W;
          }), Tt = typeof q < "u" && q !== null, Fe = [], je;
          return !Ee && J ? Me ? je = "toggle" : je = "add" : Ct !== He.length - 1 || He.length !== 1 ? je = "replace" : Me ? je = "toggle" : je = "replace", je === "toggle" && // Must be toggling
          !de && // If disableSortRemove, disable in general
          !Tt && // Must not be setting desc
          (!J || !Ce) && // If multi, don't allow if disableMultiRemove
          (Me && // Finally, detect if it should indeed be removed
          Me.desc && !vt || !Me.desc && vt) && (je = "remove"), je === "replace" ? Fe = [{
            id: W,
            desc: Tt ? q : vt
          }] : je === "add" ? (Fe = [].concat(He, [{
            id: W,
            desc: Tt ? q : vt
          }]), Fe.splice(0, Fe.length - ue)) : je === "toggle" ? Fe = He.map(function(Le) {
            return Le.id === W ? i({}, Le, {
              desc: Tt ? q : !Me.desc
            }) : Le;
          }) : je === "remove" && (Fe = He.filter(function(Le) {
            return Le.id !== W;
          })), i({}, f, {
            sortBy: Fe
          });
        }
      }
      function us(f) {
        var v = f.data, w = f.rows, m = f.flatRows, D = f.allColumns, M = f.orderByFn, R = M === void 0 ? ri : M, W = f.sortTypes, q = f.manualSortBy, J = f.defaultCanSort, ae = f.disableSortBy, Ee = f.flatHeaders, de = f.state.sortBy, Ce = f.dispatch, $e = f.plugins, ue = f.getHooks, He = f.autoResetSortBy, st = He === void 0 ? !0 : He;
        x($e, ["useFilters", "useGlobalFilter", "useGroupBy", "usePivotColumns"], "useSortBy");
        var vt = t.useCallback(function(ot) {
          Ce({
            type: p.setSortBy,
            sortBy: ot
          });
        }, [Ce]), Me = t.useCallback(function(ot, Pt, kt) {
          Ce({
            type: p.toggleSortBy,
            columnId: ot,
            desc: Pt,
            multi: kt
          });
        }, [Ce]), Ct = F(f);
        Ee.forEach(function(ot) {
          var Pt = ot.accessor, kt = ot.canSort, ar = ot.disableSortBy, Qe = ot.id, Mr = Pt ? Pe(ar === !0 ? !1 : void 0, ae === !0 ? !1 : void 0, !0) : Pe(J, kt, !1);
          ot.canSort = Mr, ot.canSort && (ot.toggleSortBy = function(ht, yt) {
            return Me(ot.id, ht, yt);
          }, ot.clearSortBy = function() {
            Ce({
              type: p.clearSortBy,
              columnId: ot.id
            });
          }), ot.getSortByToggleProps = $(ue().getSortByToggleProps, {
            instance: Ct(),
            column: ot
          });
          var Rt = de.find(function(ht) {
            return ht.id === Qe;
          });
          ot.isSorted = !!Rt, ot.sortedIndex = de.findIndex(function(ht) {
            return ht.id === Qe;
          }), ot.isSortedDesc = ot.isSorted ? Rt.desc : void 0;
        });
        var Tt = t.useMemo(function() {
          if (q || !de.length)
            return [w, m];
          var ot = [], Pt = de.filter(function(ar) {
            return D.find(function(Qe) {
              return Qe.id === ar.id;
            });
          }), kt = function ar(Qe) {
            var Mr = R(
              Qe,
              Pt.map(function(Rt) {
                var ht = D.find(function(Wr) {
                  return Wr.id === Rt.id;
                });
                if (!ht)
                  throw new Error("React-Table: Could not find a column with id: " + Rt.id + " while sorting");
                var yt = ht.sortType, cr = lt(yt) || (W || {})[yt] || nu[yt];
                if (!cr)
                  throw new Error("React-Table: Could not find a valid sortType of '" + yt + "' for column '" + Rt.id + "'.");
                return function(Wr, Jo) {
                  return cr(Wr, Jo, Rt.id, Rt.desc);
                };
              }),
              // Map the directions
              Pt.map(function(Rt) {
                var ht = D.find(function(yt) {
                  return yt.id === Rt.id;
                });
                return ht && ht.sortInverted ? Rt.desc : !Rt.desc;
              })
            );
            return Mr.forEach(function(Rt) {
              ot.push(Rt), !(!Rt.subRows || Rt.subRows.length === 0) && (Rt.subRows = ar(Rt.subRows));
            }), Mr;
          };
          return [kt(w), ot];
        }, [q, de, w, m, D, R, W]), Fe = Tt[0], je = Tt[1], Le = F(st);
        Q(function() {
          Le() && Ce({
            type: p.resetSortBy
          });
        }, [q ? null : v]), Object.assign(f, {
          preSortedRows: w,
          preSortedFlatRows: m,
          sortedRows: Fe,
          sortedFlatRows: je,
          rows: Fe,
          flatRows: je,
          setSortBy: vt,
          toggleSortBy: Me
        });
      }
      function ri(f, v, w) {
        return [].concat(f).sort(function(m, D) {
          for (var M = 0; M < v.length; M += 1) {
            var R = v[M], W = w[M] === !1 || w[M] === "desc", q = R(m, D);
            if (q !== 0)
              return W ? -q : q;
          }
          return w[0] ? m.index - D.index : D.index - m.index;
        });
      }
      var au = "usePagination";
      p.resetPage = "resetPage", p.gotoPage = "gotoPage", p.setPageSize = "setPageSize";
      var cs = function(v) {
        v.stateReducers.push(iu), v.useInstance.push(ds);
      };
      cs.pluginName = au;
      function iu(f, v, w, m) {
        if (v.type === p.init)
          return i({
            pageSize: 10,
            pageIndex: 0
          }, f);
        if (v.type === p.resetPage)
          return i({}, f, {
            pageIndex: m.initialState.pageIndex || 0
          });
        if (v.type === p.gotoPage) {
          var D = m.pageCount, M = m.page, R = _(v.pageIndex, f.pageIndex), W = !1;
          return R > f.pageIndex ? W = D === -1 ? M.length >= f.pageSize : R < D : R < f.pageIndex && (W = R > -1), W ? i({}, f, {
            pageIndex: R
          }) : f;
        }
        if (v.type === p.setPageSize) {
          var q = v.pageSize, J = f.pageSize * f.pageIndex, ae = Math.floor(J / q);
          return i({}, f, {
            pageIndex: ae,
            pageSize: q
          });
        }
      }
      function ds(f) {
        var v = f.rows, w = f.autoResetPage, m = w === void 0 ? !0 : w, D = f.manualExpandedKey, M = D === void 0 ? "expanded" : D, R = f.plugins, W = f.pageCount, q = f.paginateExpandedRows, J = q === void 0 ? !0 : q, ae = f.expandSubRows, Ee = ae === void 0 ? !0 : ae, de = f.state, Ce = de.pageSize, $e = de.pageIndex, ue = de.expanded, He = de.globalFilter, st = de.filters, vt = de.groupBy, Me = de.sortBy, Ct = f.dispatch, Tt = f.data, Fe = f.manualPagination;
        x(R, ["useGlobalFilter", "useFilters", "useGroupBy", "useSortBy", "useExpanded"], "usePagination");
        var je = F(m);
        Q(function() {
          je() && Ct({
            type: p.resetPage
          });
        }, [Ct, Fe ? null : Tt, He, st, vt, Me]);
        var Le = Fe ? W : Math.ceil(v.length / Ce), ot = t.useMemo(function() {
          return Le > 0 ? [].concat(new Array(Le)).fill(null).map(function(yt, cr) {
            return cr;
          }) : [];
        }, [Le]), Pt = t.useMemo(function() {
          var yt;
          if (Fe)
            yt = v;
          else {
            var cr = Ce * $e, Wr = cr + Ce;
            yt = v.slice(cr, Wr);
          }
          return J ? yt : ut(yt, {
            manualExpandedKey: M,
            expanded: ue,
            expandSubRows: Ee
          });
        }, [Ee, ue, M, Fe, $e, Ce, J, v]), kt = $e > 0, ar = Le === -1 ? Pt.length >= Ce : $e < Le - 1, Qe = t.useCallback(function(yt) {
          Ct({
            type: p.gotoPage,
            pageIndex: yt
          });
        }, [Ct]), Mr = t.useCallback(function() {
          return Qe(function(yt) {
            return yt - 1;
          });
        }, [Qe]), Rt = t.useCallback(function() {
          return Qe(function(yt) {
            return yt + 1;
          });
        }, [Qe]), ht = t.useCallback(function(yt) {
          Ct({
            type: p.setPageSize,
            pageSize: yt
          });
        }, [Ct]);
        Object.assign(f, {
          pageOptions: ot,
          pageCount: Le,
          page: Pt,
          canPreviousPage: kt,
          canNextPage: ar,
          gotoPage: Qe,
          previousPage: Mr,
          nextPage: Rt,
          setPageSize: ht
        });
      }
      p.resetPivot = "resetPivot", p.togglePivot = "togglePivot";
      var ps = function(v) {
        v.getPivotToggleProps = [su], v.stateReducers.push(vs), v.useInstanceAfterData.push(lu), v.allColumns.push(uu), v.accessValue.push(cu), v.materializedColumns.push(du), v.materializedColumnsDeps.push(ni), v.visibleColumns.push(gs), v.visibleColumnsDeps.push(xa), v.useInstance.push(oi), v.prepareRow.push(ai);
      };
      ps.pluginName = "usePivotColumns";
      var fs = [], su = function(v, w) {
        var m = w.header;
        return [v, {
          onClick: m.canPivot ? function(D) {
            D.persist(), m.togglePivot();
          } : void 0,
          style: {
            cursor: m.canPivot ? "pointer" : void 0
          },
          title: "Toggle Pivot"
        }];
      };
      function vs(f, v, w, m) {
        if (v.type === p.init)
          return i({
            pivotColumns: fs
          }, f);
        if (v.type === p.resetPivot)
          return i({}, f, {
            pivotColumns: m.initialState.pivotColumns || fs
          });
        if (v.type === p.togglePivot) {
          var D = v.columnId, M = v.value, R = typeof M < "u" ? M : !f.pivotColumns.includes(D);
          return R ? i({}, f, {
            pivotColumns: [].concat(f.pivotColumns, [D])
          }) : i({}, f, {
            pivotColumns: f.pivotColumns.filter(function(W) {
              return W !== D;
            })
          });
        }
      }
      function lu(f) {
        f.allColumns.forEach(function(v) {
          v.isPivotSource = f.state.pivotColumns.includes(v.id);
        });
      }
      function uu(f, v) {
        var w = v.instance;
        return f.forEach(function(m) {
          m.isPivotSource = w.state.pivotColumns.includes(m.id), m.uniqueValues = /* @__PURE__ */ new Set();
        }), f;
      }
      function cu(f, v) {
        var w = v.column;
        return w.uniqueValues && typeof f < "u" && w.uniqueValues.add(f), f;
      }
      function du(f, v) {
        var w = v.instance, m = w.allColumns, D = w.state;
        if (!D.pivotColumns.length || !D.groupBy || !D.groupBy.length)
          return f;
        var M = D.pivotColumns.map(function(J) {
          return m.find(function(ae) {
            return ae.id === J;
          });
        }).filter(Boolean), R = m.filter(function(J) {
          return !J.isPivotSource && !D.groupBy.includes(J.id) && !D.pivotColumns.includes(J.id);
        }), W = function J(ae, Ee, de) {
          ae === void 0 && (ae = 0), de === void 0 && (de = []);
          var Ce = M[ae];
          if (!Ce)
            return R.map(function(ue) {
              return i({}, ue, {
                canPivot: !1,
                isPivoted: !0,
                parent: Ee,
                depth: ae,
                id: "" + (Ee ? Ee.id + "." + ue.id : ue.id),
                accessor: function(st, vt, Me) {
                  if (de.every(function(Ct) {
                    return Ct(Me);
                  }))
                    return Me.values[ue.id];
                }
              });
            });
          var $e = Array.from(Ce.uniqueValues).sort();
          return $e.map(function(ue) {
            var He = i({}, Ce, {
              Header: Ce.PivotHeader || typeof Ce.header == "string" ? Ce.Header + ": " + ue : ue,
              isPivotGroup: !0,
              parent: Ee,
              depth: ae,
              id: Ee ? Ee.id + "." + Ce.id + "." + ue : Ce.id + "." + ue,
              pivotValue: ue
            });
            return He.columns = J(ae + 1, He, [].concat(de, [function(st) {
              return st.values[Ce.id] === ue;
            }])), He;
          });
        }, q = oe(W());
        return [].concat(f, q);
      }
      function ni(f, v) {
        var w = v.instance.state, m = w.pivotColumns, D = w.groupBy;
        return [].concat(f, [m, D]);
      }
      function gs(f, v) {
        var w = v.instance.state;
        return f = f.filter(function(m) {
          return !m.isPivotSource;
        }), w.pivotColumns.length && w.groupBy && w.groupBy.length && (f = f.filter(function(m) {
          return m.isGrouped || m.isPivoted;
        })), f;
      }
      function xa(f, v) {
        var w = v.instance;
        return [].concat(f, [w.state.pivotColumns, w.state.groupBy]);
      }
      function oi(f) {
        var v = f.columns, w = f.allColumns, m = f.flatHeaders, D = f.getHooks, M = f.plugins, R = f.dispatch, W = f.autoResetPivot, q = W === void 0 ? !0 : W, J = f.manaulPivot, ae = f.disablePivot, Ee = f.defaultCanPivot;
        x(M, ["useGroupBy"], "usePivotColumns");
        var de = F(f);
        w.forEach(function(ue) {
          var He = ue.accessor, st = ue.defaultPivot, vt = ue.disablePivot;
          ue.canPivot = He ? Pe(ue.canPivot, vt === !0 ? !1 : void 0, ae === !0 ? !1 : void 0, !0) : Pe(ue.canPivot, st, Ee, !1), ue.canPivot && (ue.togglePivot = function() {
            return f.togglePivot(ue.id);
          }), ue.Aggregated = ue.Aggregated || ue.Cell;
        });
        var Ce = function(He, st) {
          R({
            type: p.togglePivot,
            columnId: He,
            value: st
          });
        };
        m.forEach(function(ue) {
          ue.getPivotToggleProps = $(D().getPivotToggleProps, {
            instance: de(),
            header: ue
          });
        });
        var $e = F(q);
        Q(function() {
          $e() && R({
            type: p.resetPivot
          });
        }, [R, J ? null : v]), Object.assign(f, {
          togglePivot: Ce
        });
      }
      function ai(f) {
        f.allCells.forEach(function(v) {
          v.isPivoted = v.column.isPivoted;
        });
      }
      var hs = "useRowSelect";
      p.resetSelectedRows = "resetSelectedRows", p.toggleAllRowsSelected = "toggleAllRowsSelected", p.toggleRowSelected = "toggleRowSelected", p.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
      var ii = function(v) {
        v.getToggleRowSelectedProps = [pu], v.getToggleAllRowsSelectedProps = [si], v.getToggleAllPageRowsSelectedProps = [fu], v.stateReducers.push(vu), v.useInstance.push(gu), v.prepareRow.push(ms);
      };
      ii.pluginName = hs;
      var pu = function(v, w) {
        var m = w.instance, D = w.row, M = m.manualRowSelectedKey, R = M === void 0 ? "isSelected" : M, W = !1;
        return D.original && D.original[R] ? W = !0 : W = D.isSelected, [v, {
          onChange: function(J) {
            D.toggleRowSelected(J.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: W,
          title: "Toggle Row Selected",
          indeterminate: D.isSomeSelected
        }];
      }, si = function(v, w) {
        var m = w.instance;
        return [v, {
          onChange: function(M) {
            m.toggleAllRowsSelected(M.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: m.isAllRowsSelected,
          title: "Toggle All Rows Selected",
          indeterminate: !!(!m.isAllRowsSelected && Object.keys(m.state.selectedRowIds).length)
        }];
      }, fu = function(v, w) {
        var m = w.instance;
        return [v, {
          onChange: function(M) {
            m.toggleAllPageRowsSelected(M.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: m.isAllPageRowsSelected,
          title: "Toggle All Current Page Rows Selected",
          indeterminate: !!(!m.isAllPageRowsSelected && m.page.some(function(D) {
            var M = D.id;
            return m.state.selectedRowIds[M];
          }))
        }];
      };
      function vu(f, v, w, m) {
        if (v.type === p.init)
          return i({
            selectedRowIds: {}
          }, f);
        if (v.type === p.resetSelectedRows)
          return i({}, f, {
            selectedRowIds: m.initialState.selectedRowIds || {}
          });
        if (v.type === p.toggleAllRowsSelected) {
          var D = v.value, M = m.isAllRowsSelected, R = m.rowsById, W = m.nonGroupedRowsById, q = W === void 0 ? R : W, J = typeof D < "u" ? D : !M, ae = Object.assign({}, f.selectedRowIds);
          return J ? Object.keys(q).forEach(function(Rt) {
            ae[Rt] = !0;
          }) : Object.keys(q).forEach(function(Rt) {
            delete ae[Rt];
          }), i({}, f, {
            selectedRowIds: ae
          });
        }
        if (v.type === p.toggleRowSelected) {
          var Ee = v.id, de = v.value, Ce = m.rowsById, $e = m.selectSubRows, ue = $e === void 0 ? !0 : $e, He = m.getSubRows, st = f.selectedRowIds[Ee], vt = typeof de < "u" ? de : !st;
          if (st === vt)
            return f;
          var Me = i({}, f.selectedRowIds), Ct = function Rt(ht) {
            var yt = Ce[ht];
            if (yt && (yt.isGrouped || (vt ? Me[ht] = !0 : delete Me[ht]), ue && He(yt)))
              return He(yt).forEach(function(cr) {
                return Rt(cr.id);
              });
          };
          return Ct(Ee), i({}, f, {
            selectedRowIds: Me
          });
        }
        if (v.type === p.toggleAllPageRowsSelected) {
          var Tt = v.value, Fe = m.page, je = m.rowsById, Le = m.selectSubRows, ot = Le === void 0 ? !0 : Le, Pt = m.isAllPageRowsSelected, kt = m.getSubRows, ar = typeof Tt < "u" ? Tt : !Pt, Qe = i({}, f.selectedRowIds), Mr = function Rt(ht) {
            var yt = je[ht];
            if (yt.isGrouped || (ar ? Qe[ht] = !0 : delete Qe[ht]), ot && kt(yt))
              return kt(yt).forEach(function(cr) {
                return Rt(cr.id);
              });
          };
          return Fe.forEach(function(Rt) {
            return Mr(Rt.id);
          }), i({}, f, {
            selectedRowIds: Qe
          });
        }
        return f;
      }
      function gu(f) {
        var v = f.data, w = f.rows, m = f.getHooks, D = f.plugins, M = f.rowsById, R = f.nonGroupedRowsById, W = R === void 0 ? M : R, q = f.autoResetSelectedRows, J = q === void 0 ? !0 : q, ae = f.state.selectedRowIds, Ee = f.selectSubRows, de = Ee === void 0 ? !0 : Ee, Ce = f.dispatch, $e = f.page, ue = f.getSubRows;
        x(D, ["useFilters", "useGroupBy", "useSortBy", "useExpanded", "usePagination"], "useRowSelect");
        var He = t.useMemo(function() {
          var Pt = [];
          return w.forEach(function(kt) {
            var ar = de ? ys(kt, ae, ue) : !!ae[kt.id];
            kt.isSelected = !!ar, kt.isSomeSelected = ar === null, ar && Pt.push(kt);
          }), Pt;
        }, [w, de, ae, ue]), st = !!(Object.keys(W).length && Object.keys(ae).length), vt = st;
        st && Object.keys(W).some(function(Pt) {
          return !ae[Pt];
        }) && (st = !1), st || $e && $e.length && $e.some(function(Pt) {
          var kt = Pt.id;
          return !ae[kt];
        }) && (vt = !1);
        var Me = F(J);
        Q(function() {
          Me() && Ce({
            type: p.resetSelectedRows
          });
        }, [Ce, v]);
        var Ct = t.useCallback(function(Pt) {
          return Ce({
            type: p.toggleAllRowsSelected,
            value: Pt
          });
        }, [Ce]), Tt = t.useCallback(function(Pt) {
          return Ce({
            type: p.toggleAllPageRowsSelected,
            value: Pt
          });
        }, [Ce]), Fe = t.useCallback(function(Pt, kt) {
          return Ce({
            type: p.toggleRowSelected,
            id: Pt,
            value: kt
          });
        }, [Ce]), je = F(f), Le = $(m().getToggleAllRowsSelectedProps, {
          instance: je()
        }), ot = $(m().getToggleAllPageRowsSelectedProps, {
          instance: je()
        });
        Object.assign(f, {
          selectedFlatRows: He,
          isAllRowsSelected: st,
          isAllPageRowsSelected: vt,
          toggleRowSelected: Fe,
          toggleAllRowsSelected: Ct,
          getToggleAllRowsSelectedProps: Le,
          getToggleAllPageRowsSelectedProps: ot,
          toggleAllPageRowsSelected: Tt
        });
      }
      function ms(f, v) {
        var w = v.instance;
        f.toggleRowSelected = function(m) {
          return w.toggleRowSelected(f.id, m);
        }, f.getToggleRowSelectedProps = $(w.getHooks().getToggleRowSelectedProps, {
          instance: w,
          row: f
        });
      }
      function ys(f, v, w) {
        if (v[f.id])
          return !0;
        var m = w(f);
        if (m && m.length) {
          var D = !0, M = !1;
          return m.forEach(function(R) {
            M && !D || (ys(R, v, w) ? M = !0 : D = !1);
          }), D ? !0 : M ? null : !1;
        }
        return !1;
      }
      var bs = function(v) {
        return {};
      }, ws = function(v) {
        return {};
      };
      p.setRowState = "setRowState", p.setCellState = "setCellState", p.resetRowState = "resetRowState";
      var xs = function(v) {
        v.stateReducers.push(li), v.useInstance.push(d), v.prepareRow.push(b);
      };
      xs.pluginName = "useRowState";
      function li(f, v, w, m) {
        var D = m.initialRowStateAccessor, M = D === void 0 ? bs : D, R = m.initialCellStateAccessor, W = R === void 0 ? ws : R, q = m.rowsById;
        if (v.type === p.init)
          return i({
            rowState: {}
          }, f);
        if (v.type === p.resetRowState)
          return i({}, f, {
            rowState: m.initialState.rowState || {}
          });
        if (v.type === p.setRowState) {
          var J, ae = v.rowId, Ee = v.value, de = typeof f.rowState[ae] < "u" ? f.rowState[ae] : M(q[ae]);
          return i({}, f, {
            rowState: i({}, f.rowState, (J = {}, J[ae] = _(Ee, de), J))
          });
        }
        if (v.type === p.setCellState) {
          var Ce, $e, ue, He, st, vt = v.rowId, Me = v.columnId, Ct = v.value, Tt = typeof f.rowState[vt] < "u" ? f.rowState[vt] : M(q[vt]), Fe = typeof (Tt == null || (Ce = Tt.cellState) == null ? void 0 : Ce[Me]) < "u" ? Tt.cellState[Me] : W(($e = q[vt]) == null || (ue = $e.cells) == null ? void 0 : ue.find(function(je) {
            return je.column.id === Me;
          }));
          return i({}, f, {
            rowState: i({}, f.rowState, (st = {}, st[vt] = i({}, Tt, {
              cellState: i({}, Tt.cellState || {}, (He = {}, He[Me] = _(Ct, Fe), He))
            }), st))
          });
        }
      }
      function d(f) {
        var v = f.autoResetRowState, w = v === void 0 ? !0 : v, m = f.data, D = f.dispatch, M = t.useCallback(function(q, J) {
          return D({
            type: p.setRowState,
            rowId: q,
            value: J
          });
        }, [D]), R = t.useCallback(function(q, J, ae) {
          return D({
            type: p.setCellState,
            rowId: q,
            columnId: J,
            value: ae
          });
        }, [D]), W = F(w);
        Q(function() {
          W() && D({
            type: p.resetRowState
          });
        }, [m]), Object.assign(f, {
          setRowState: M,
          setCellState: R
        });
      }
      function b(f, v) {
        var w = v.instance, m = w.initialRowStateAccessor, D = m === void 0 ? bs : m, M = w.initialCellStateAccessor, R = M === void 0 ? ws : M, W = w.state.rowState;
        f && (f.state = typeof W[f.id] < "u" ? W[f.id] : D(f), f.setState = function(q) {
          return w.setRowState(f.id, q);
        }, f.cells.forEach(function(q) {
          f.state.cellState || (f.state.cellState = {}), q.state = typeof f.state.cellState[q.column.id] < "u" ? f.state.cellState[q.column.id] : R(q), q.setState = function(J) {
            return w.setCellState(f.id, q.column.id, J);
          };
        }));
      }
      p.resetColumnOrder = "resetColumnOrder", p.setColumnOrder = "setColumnOrder";
      var S = function(v) {
        v.stateReducers.push(E), v.visibleColumnsDeps.push(function(w, m) {
          var D = m.instance;
          return [].concat(w, [D.state.columnOrder]);
        }), v.visibleColumns.push(L), v.useInstance.push(T);
      };
      S.pluginName = "useColumnOrder";
      function E(f, v, w, m) {
        if (v.type === p.init)
          return i({
            columnOrder: []
          }, f);
        if (v.type === p.resetColumnOrder)
          return i({}, f, {
            columnOrder: m.initialState.columnOrder || []
          });
        if (v.type === p.setColumnOrder)
          return i({}, f, {
            columnOrder: _(v.columnOrder, f.columnOrder)
          });
      }
      function L(f, v) {
        var w = v.instance.state.columnOrder;
        if (!w || !w.length)
          return f;
        for (var m = [].concat(w), D = [].concat(f), M = [], R = function() {
          var q = m.shift(), J = D.findIndex(function(ae) {
            return ae.id === q;
          });
          J > -1 && M.push(D.splice(J, 1)[0]);
        }; D.length && m.length; )
          R();
        return [].concat(M, D);
      }
      function T(f) {
        var v = f.dispatch;
        f.setColumnOrder = t.useCallback(function(w) {
          return v({
            type: p.setColumnOrder,
            columnOrder: w
          });
        }, [v]);
      }
      C.canResize = !0, p.columnStartResizing = "columnStartResizing", p.columnResizing = "columnResizing", p.columnDoneResizing = "columnDoneResizing", p.resetResize = "resetResize";
      var B = function(v) {
        v.getResizerProps = [X], v.getHeaderProps.push({
          style: {
            position: "relative"
          }
        }), v.stateReducers.push(te), v.useInstance.push(Se), v.useInstanceBeforeDimensions.push(ne);
      }, X = function(v, w) {
        var m = w.instance, D = w.header, M = m.dispatch, R = function(q, J) {
          var ae = !1;
          if (q.type === "touchstart") {
            if (q.touches && q.touches.length > 1)
              return;
            ae = !0;
          }
          var Ee = we(J), de = Ee.map(function(Fe) {
            return [Fe.id, Fe.totalWidth];
          }), Ce = ae ? Math.round(q.touches[0].clientX) : q.clientX, $e, ue, He = function() {
            window.cancelAnimationFrame($e), $e = null, M({
              type: p.columnDoneResizing
            });
          }, st = function() {
            window.cancelAnimationFrame($e), $e = null, M({
              type: p.columnResizing,
              clientX: ue
            });
          }, vt = function(je) {
            ue = je, $e || ($e = window.requestAnimationFrame(st));
          }, Me = {
            mouse: {
              moveEvent: "mousemove",
              moveHandler: function(je) {
                return vt(je.clientX);
              },
              upEvent: "mouseup",
              upHandler: function(je) {
                document.removeEventListener("mousemove", Me.mouse.moveHandler), document.removeEventListener("mouseup", Me.mouse.upHandler), He();
              }
            },
            touch: {
              moveEvent: "touchmove",
              moveHandler: function(je) {
                return je.cancelable && (je.preventDefault(), je.stopPropagation()), vt(je.touches[0].clientX), !1;
              },
              upEvent: "touchend",
              upHandler: function(je) {
                document.removeEventListener(Me.touch.moveEvent, Me.touch.moveHandler), document.removeEventListener(Me.touch.upEvent, Me.touch.moveHandler), He();
              }
            }
          }, Ct = ae ? Me.touch : Me.mouse, Tt = fe() ? {
            passive: !1
          } : !1;
          document.addEventListener(Ct.moveEvent, Ct.moveHandler, Tt), document.addEventListener(Ct.upEvent, Ct.upHandler, Tt), M({
            type: p.columnStartResizing,
            columnId: J.id,
            columnWidth: J.totalWidth,
            headerIdWidths: de,
            clientX: Ce
          });
        };
        return [v, {
          onMouseDown: function(q) {
            return q.persist() || R(q, D);
          },
          onTouchStart: function(q) {
            return q.persist() || R(q, D);
          },
          style: {
            cursor: "col-resize"
          },
          draggable: !1,
          role: "separator"
        }];
      };
      B.pluginName = "useResizeColumns";
      function te(f, v) {
        if (v.type === p.init)
          return i({
            columnResizing: {
              columnWidths: {}
            }
          }, f);
        if (v.type === p.resetResize)
          return i({}, f, {
            columnResizing: {
              columnWidths: {}
            }
          });
        if (v.type === p.columnStartResizing) {
          var w = v.clientX, m = v.columnId, D = v.columnWidth, M = v.headerIdWidths;
          return i({}, f, {
            columnResizing: i({}, f.columnResizing, {
              startX: w,
              headerIdWidths: M,
              columnWidth: D,
              isResizingColumn: m
            })
          });
        }
        if (v.type === p.columnResizing) {
          var R = v.clientX, W = f.columnResizing, q = W.startX, J = W.columnWidth, ae = W.headerIdWidths, Ee = ae === void 0 ? [] : ae, de = R - q, Ce = de / J, $e = {};
          return Ee.forEach(function(ue) {
            var He = ue[0], st = ue[1];
            $e[He] = Math.max(st + st * Ce, 0);
          }), i({}, f, {
            columnResizing: i({}, f.columnResizing, {
              columnWidths: i({}, f.columnResizing.columnWidths, {}, $e)
            })
          });
        }
        if (v.type === p.columnDoneResizing)
          return i({}, f, {
            columnResizing: i({}, f.columnResizing, {
              startX: null,
              isResizingColumn: null
            })
          });
      }
      var ne = function(v) {
        var w = v.flatHeaders, m = v.disableResizing, D = v.getHooks, M = v.state.columnResizing, R = F(v);
        w.forEach(function(W) {
          var q = Pe(W.disableResizing === !0 ? !1 : void 0, m === !0 ? !1 : void 0, !0);
          W.canResize = q, W.width = M.columnWidths[W.id] || W.originalWidth || W.width, W.isResizing = M.isResizingColumn === W.id, q && (W.getResizerProps = $(D().getResizerProps, {
            instance: R(),
            header: W
          }));
        });
      };
      function Se(f) {
        var v = f.plugins, w = f.dispatch, m = f.autoResetResize, D = m === void 0 ? !0 : m, M = f.columns;
        x(v, ["useAbsoluteLayout"], "useResizeColumns");
        var R = F(D);
        Q(function() {
          R() && w({
            type: p.resetResize
          });
        }, [M]);
        var W = t.useCallback(function() {
          return w({
            type: p.resetResize
          });
        }, [w]);
        Object.assign(f, {
          resetResizing: W
        });
      }
      function we(f) {
        var v = [], w = function m(D) {
          D.columns && D.columns.length && D.columns.map(m), v.push(D);
        };
        return w(f), v;
      }
      var xe = {
        position: "absolute",
        top: 0
      }, se = function(v) {
        v.getTableBodyProps.push(ye), v.getRowProps.push(ye), v.getHeaderGroupProps.push(ye), v.getFooterGroupProps.push(ye), v.getHeaderProps.push(function(w, m) {
          var D = m.column;
          return [w, {
            style: i({}, xe, {
              left: D.totalLeft + "px",
              width: D.totalWidth + "px"
            })
          }];
        }), v.getCellProps.push(function(w, m) {
          var D = m.cell;
          return [w, {
            style: i({}, xe, {
              left: D.column.totalLeft + "px",
              width: D.column.totalWidth + "px"
            })
          }];
        }), v.getFooterProps.push(function(w, m) {
          var D = m.column;
          return [w, {
            style: i({}, xe, {
              left: D.totalLeft + "px",
              width: D.totalWidth + "px"
            })
          }];
        });
      };
      se.pluginName = "useAbsoluteLayout";
      var ye = function(v, w) {
        var m = w.instance;
        return [v, {
          style: {
            position: "relative",
            width: m.totalColumnsWidth + "px"
          }
        }];
      }, Te = {
        display: "inline-block",
        boxSizing: "border-box"
      }, Ae = function(v, w) {
        var m = w.instance;
        return [v, {
          style: {
            display: "flex",
            width: m.totalColumnsWidth + "px"
          }
        }];
      }, rt = function(v) {
        v.getRowProps.push(Ae), v.getHeaderGroupProps.push(Ae), v.getFooterGroupProps.push(Ae), v.getHeaderProps.push(function(w, m) {
          var D = m.column;
          return [w, {
            style: i({}, Te, {
              width: D.totalWidth + "px"
            })
          }];
        }), v.getCellProps.push(function(w, m) {
          var D = m.cell;
          return [w, {
            style: i({}, Te, {
              width: D.column.totalWidth + "px"
            })
          }];
        }), v.getFooterProps.push(function(w, m) {
          var D = m.column;
          return [w, {
            style: i({}, Te, {
              width: D.totalWidth + "px"
            })
          }];
        });
      };
      rt.pluginName = "useBlockLayout";
      function Ot(f) {
        f.getTableProps.push(nt), f.getRowProps.push(Oe), f.getHeaderGroupProps.push(Oe), f.getFooterGroupProps.push(Oe), f.getHeaderProps.push(xt), f.getCellProps.push(qe), f.getFooterProps.push(mt);
      }
      Ot.pluginName = "useFlexLayout";
      var nt = function(v, w) {
        var m = w.instance;
        return [v, {
          style: {
            minWidth: m.totalColumnsMinWidth + "px"
          }
        }];
      }, Oe = function(v, w) {
        var m = w.instance;
        return [v, {
          style: {
            display: "flex",
            flex: "1 0 auto",
            minWidth: m.totalColumnsMinWidth + "px"
          }
        }];
      }, xt = function(v, w) {
        var m = w.column;
        return [v, {
          style: {
            boxSizing: "border-box",
            flex: m.totalFlexWidth ? m.totalFlexWidth + " 0 auto" : void 0,
            minWidth: m.totalMinWidth + "px",
            width: m.totalWidth + "px"
          }
        }];
      }, qe = function(v, w) {
        var m = w.cell;
        return [v, {
          style: {
            boxSizing: "border-box",
            flex: m.column.totalFlexWidth + " 0 auto",
            minWidth: m.column.totalMinWidth + "px",
            width: m.column.totalWidth + "px"
          }
        }];
      }, mt = function(v, w) {
        var m = w.column;
        return [v, {
          style: {
            boxSizing: "border-box",
            flex: m.totalFlexWidth ? m.totalFlexWidth + " 0 auto" : void 0,
            minWidth: m.totalMinWidth + "px",
            width: m.totalWidth + "px"
          }
        }];
      };
      p.columnStartResizing = "columnStartResizing", p.columnResizing = "columnResizing", p.columnDoneResizing = "columnDoneResizing", p.resetResize = "resetResize";
      function _t(f) {
        f.stateReducers.push(wt), f.getTableProps.push(pt), f.getHeaderProps.push(gt), f.getRowProps.push(zt);
      }
      _t.pluginName = "useGridLayout";
      var pt = function(v, w) {
        var m = w.instance, D = m.visibleColumns.map(function(M) {
          var R;
          return m.state.gridLayout.columnWidths[M.id] ? m.state.gridLayout.columnWidths[M.id] + "px" : (R = m.state.columnResizing) != null && R.isResizingColumn ? m.state.gridLayout.startWidths[M.id] + "px" : typeof M.width == "number" ? M.width + "px" : M.width;
        });
        return [v, {
          style: {
            display: "grid",
            gridTemplateColumns: D.join(" ")
          }
        }];
      }, gt = function(v, w) {
        var m = w.column;
        return [v, {
          id: "header-cell-" + m.id,
          style: {
            position: "sticky",
            //enables a scroll wrapper to be placed around the table and have sticky headers
            gridColumn: "span " + m.totalVisibleHeaderCount
          }
        }];
      }, zt = function(v, w) {
        var m = w.row;
        return m.isExpanded ? [v, {
          style: {
            gridColumn: "1 / " + (m.cells.length + 1)
          }
        }] : [v, {}];
      };
      function wt(f, v, w, m) {
        if (v.type === p.init)
          return i({
            gridLayout: {
              columnWidths: {}
            }
          }, f);
        if (v.type === p.resetResize)
          return i({}, f, {
            gridLayout: {
              columnWidths: {}
            }
          });
        if (v.type === p.columnStartResizing) {
          var D = v.columnId, M = v.headerIdWidths, R = Lt(D);
          if (R !== void 0) {
            var W = m.visibleColumns.reduce(function(Fe, je) {
              var Le;
              return i({}, Fe, (Le = {}, Le[je.id] = Lt(je.id), Le));
            }, {}), q = m.visibleColumns.reduce(function(Fe, je) {
              var Le;
              return i({}, Fe, (Le = {}, Le[je.id] = je.minWidth, Le));
            }, {}), J = m.visibleColumns.reduce(function(Fe, je) {
              var Le;
              return i({}, Fe, (Le = {}, Le[je.id] = je.maxWidth, Le));
            }, {}), ae = M.map(function(Fe) {
              var je = Fe[0];
              return [je, Lt(je)];
            });
            return i({}, f, {
              gridLayout: i({}, f.gridLayout, {
                startWidths: W,
                minWidths: q,
                maxWidths: J,
                headerIdGridWidths: ae,
                columnWidth: R
              })
            });
          } else
            return f;
        }
        if (v.type === p.columnResizing) {
          var Ee = v.clientX, de = f.columnResizing.startX, Ce = f.gridLayout, $e = Ce.columnWidth, ue = Ce.minWidths, He = Ce.maxWidths, st = Ce.headerIdGridWidths, vt = st === void 0 ? [] : st, Me = Ee - de, Ct = Me / $e, Tt = {};
          return vt.forEach(function(Fe) {
            var je = Fe[0], Le = Fe[1];
            Tt[je] = Math.min(Math.max(ue[je], Le + Le * Ct), He[je]);
          }), i({}, f, {
            gridLayout: i({}, f.gridLayout, {
              columnWidths: i({}, f.gridLayout.columnWidths, {}, Tt)
            })
          });
        }
        if (v.type === p.columnDoneResizing)
          return i({}, f, {
            gridLayout: i({}, f.gridLayout, {
              startWidths: {},
              minWidths: {},
              maxWidths: {}
            })
          });
      }
      function Lt(f) {
        var v, w = (v = document.getElementById("header-cell-" + f)) == null ? void 0 : v.offsetWidth;
        if (w !== void 0)
          return w;
      }
      o._UNSTABLE_usePivotColumns = ps, o.actions = p, o.defaultColumn = C, o.defaultGroupByFn = ns, o.defaultOrderByFn = ri, o.defaultRenderer = h, o.emptyRenderer = O, o.ensurePluginOrder = x, o.flexRender = ce, o.functionalUpdate = _, o.loopHooks = H, o.makePropGetter = $, o.makeRenderer = ie, o.reduceHooks = I, o.safeUseLayoutEffect = G, o.useAbsoluteLayout = se, o.useAsyncDebounce = V, o.useBlockLayout = rt, o.useColumnOrder = S, o.useExpanded = Rr, o.useFilters = pe, o.useFlexLayout = Ot, o.useGetLatest = F, o.useGlobalFilter = Bt, o.useGridLayout = _t, o.useGroupBy = ei, o.useMountedLayoutEffect = Q, o.usePagination = cs, o.useResizeColumns = B, o.useRowSelect = ii, o.useRowState = xs, o.useSortBy = ss, o.useTable = Mt, Object.defineProperty(o, "__esModule", { value: !0 });
    });
  }(As, As.exports)), As.exports;
}
process.env.NODE_ENV === "production" ? Nd.exports = S_() : Nd.exports = O_();
var Ku = Nd.exports;
const yh = ({
  children: e,
  columnCount: n
}) => /* @__PURE__ */ g.jsx("tr", { children: /* @__PURE__ */ g.jsx("td", { colSpan: n, children: e }) }), Bd = (e) => e.sizing.xxxl, P_ = Y(wf)(
  ({ theme: e }) => `
  color: ${e.color.textSecondary};
  width: ${Bd(e)};
  height: ${Bd(e)};
`
), E_ = ({
  columnCount: e,
  emptyStateProps: n,
  getRowOnClick: o,
  getTableBodyProps: t,
  isLoading: r = !1,
  prepareRow: a,
  rows: i
}) => {
  const s = (() => r && i.length === 0 ? /* @__PURE__ */ g.jsx(yh, { columnCount: e, children: /* @__PURE__ */ g.jsx(D_, {}) }) : n && i.length === 0 ? /* @__PURE__ */ g.jsx(yh, { columnCount: e, children: /* @__PURE__ */ g.jsx(Zi, { ...n }) }) : i.map((l) => (a(l), /* @__PURE__ */ g.jsx(
    R_,
    {
      ...l.getRowProps(),
      isClickable: !!o && !r,
      onClick: () => r || o == null ? void 0 : o(l.original),
      children: l.cells.map((u) => /* @__PURE__ */ g.jsx($_, { ...u.getCellProps(), children: u.render("Cell") }))
    }
  ))))();
  return /* @__PURE__ */ g.jsx(k_, { ...t(), children: s });
}, k_ = Y.tbody(
  ({ theme: e }) => `
  position: relative;
  background-color: ${e.color.white};
`
), R_ = Y.tr.withConfig({
  shouldForwardProp: (e) => e !== "isClickable"
})(
  ({ theme: e, isClickable: n }) => `
  &:not(:last-of-type) {
    border-bottom: ${Pn(e)};
  }

  ${n ? `
    &:hover {
      background-color: ${e.color.gray0};
    }

    &:active {
      background-color: ${e.color.gray1};
    }

    &:focus-visible {
      ${cn(e)};
    }

    cursor: pointer;
  ` : ""}
`
), $_ = Y.td`
  border-spacing: 0px;
  padding: 0px;
`, D_ = Y.div(
  ({ theme: e }) => `
  height: calc(${e.spacing.xxl} + ${Bd(e)} + ${e.spacing.xxl});
  width: 100%;
`
), T_ = ({
  helpIconProps: e,
  textAlign: n = "left",
  label: o,
  isSorted: t = !1,
  isSortedDesc: r = !1,
  isTableSortable: a = !1,
  isLoading: i = !1,
  onClick: s,
  isFirstColumn: l,
  isLastColumn: u
}) => {
  const c = e && /* @__PURE__ */ g.jsx(Hi, { isDisabled: i, ...e }), p = (() => {
    if (a)
      return t ? /* @__PURE__ */ g.jsx(
        Lr,
        {
          "aria-label": r ? `${o} column is sorted in descending order` : `${o} column is sorted in ascending order`,
          name: r ? "chevron-down" : "chevron-up"
        }
      ) : /* @__PURE__ */ g.jsx(__, {});
  })();
  return /* @__PURE__ */ g.jsxs(
    j_,
    {
      isFirstColumn: l,
      isLastColumn: u,
      textAlign: n,
      "aria-live": "polite",
      tabIndex: a ? 0 : -1,
      role: a ? "button" : void 0,
      onClick: s,
      onKeyDown: (h) => {
        a && (h.key === "Enter" || h.key === " ") && (s == null || s(h));
      },
      children: [
        n === "right" && /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
          p,
          c
        ] }),
        o,
        n === "left" && /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
          c,
          p
        ] })
      ]
    }
  );
}, j_ = Y.div.withConfig({
  shouldForwardProp: (e) => !["textAlign", "isFirstColumn", "isLastColumn"].includes(e)
})(
  ({ theme: e, textAlign: n, isFirstColumn: o, isLastColumn: t, onClick: r }) => `
  ${r ? Yo : ""}
  padding: ${e.spacing.m} ${t ? e.spacing.l : e.spacing.m} ${e.spacing.m} ${o ? e.spacing.l : e.spacing.m};
  border-radius: ${e.borderRadius.s};
  display: flex;
  align-items: center;
  gap: ${e.spacing.xs};
  justify-content: ${n === "right" ? "flex-end" : "flex-start"};
  text-align: ${n};

 /**
 * The ':focus-visible' pseudo-class is used to recreate the 
 * focus state manually for accessibility purposes.
 * 
 * Because HTML tables have certain limitations with regards to styling 
 * focus states, we need to use a 'box-shadow' with 'inset' 
 * to achieve the desired effect. The 'box-shadow' is applied on 
 * the element when it receives focus via keyboard navigation, and is removed when focus is lost.
 */
  &:focus-visible {
      box-shadow: inset 0 0 0 ${e.borderWidth.s} ${e.color.white}, inset 0 0 0 ${e.borderWidth.l} ${e.color.focusOutline};
  }
`
), __ = Y.div(
  ({ theme: e }) => `
  width: ${co(e)};
  height: ${co(e)};
  visibility: hidden;
`
), I_ = (e, n) => jn(e) ? -1 : jn(n) ? 1 : e - n, M_ = (e) => ({
  compact: {
    rowPadding: "12px"
  },
  default: {
    rowPadding: e.spacing.m
  }
}), A_ = "–", F_ = ({
  columns: e,
  shouldShowAutomaticPlaceholders: n = !1,
  density: o = "default",
  isLoading: t = !1
}) => at(
  () => e.map(
    ({
      helpIconProps: r,
      isContentFullWidth: a,
      key: i,
      label: s,
      maxWidth: l,
      minWidth: u,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      renderCell: c = (k) => k,
      shouldDisableSorting: p,
      shouldTruncate: h = !1,
      sortMethod: O,
      textAlign: C
    }, P) => ({
      accessor: i,
      Header: (k) => /* @__PURE__ */ g.jsx(
        T_,
        {
          ...k,
          isLoading: t,
          helpIconProps: r,
          label: s,
          textAlign: C,
          isFirstColumn: P === 0,
          isLastColumn: P === e.length - 1
        }
      ),
      Cell: ({ row: { original: k }, value: $ }) => /* @__PURE__ */ g.jsx(
        L_,
        {
          textAlign: C,
          maxWidth: l,
          density: o,
          minWidth: u,
          isContentFullWidth: a,
          isFirstColumn: P === 0,
          isLastColumn: P === e.length - 1,
          children: /* @__PURE__ */ g.jsx(un, { as: "span", shouldTruncate: h, children: n ? (
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            c($, k) || A_
          ) : (
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            c($, k)
          ) })
        }
      ),
      disableSortBy: p || t,
      sortType: (k, $, I, H) => {
        const x = k.values[I], _ = $.values[I];
        return O ? O(x, _, H) : I_(x, _);
      }
    })
  ),
  [e, o, t, n]
), L_ = Y.div.withConfig({
  shouldForwardProp: (e) => ![
    "textAlign",
    "maxWidth",
    "density",
    "minWidth",
    "isContentFullWidth",
    "isFirstColumn",
    "isLastColumn"
  ].includes(e)
})(
  ({
    theme: e,
    textAlign: n = "left",
    maxWidth: o,
    density: t,
    minWidth: r,
    isContentFullWidth: a,
    isFirstColumn: i,
    isLastColumn: s
  }) => {
    const { rowPadding: l } = M_(e)[t];
    return `
      display: grid;
      padding: ${l} ${s ? e.spacing.l : e.spacing.m} ${l} ${i ? e.spacing.l : e.spacing.m};
      text-align: ${n};
      justify-content: ${n === "left" ? "start" : "end"};
      box-sizing: content-box;
      ${o ? `max-width: ${o}px;` : ""}
      ${r ? `min-width: ${r}px;` : ""}
      ${a ? "white-space: nowrap;" : ""}
  `;
  }
), N_ = "cosmic-clickable-icon-column", B_ = (e, n = "Open Item") => [
  ...e,
  {
    id: N_,
    Cell: () => /* @__PURE__ */ g.jsx(Be, { justifyContent: "flex-end", padding: "m l", children: /* @__PURE__ */ g.jsx(W_, { name: "chevron-right" }) }),
    Header: /* @__PURE__ */ g.jsx(Im, { children: n })
  }
], W_ = Y(Lr)(
  ({ theme: e }) => `
  min-width: ${co(e)};
`
), z_ = "cosmic-selection-column", H_ = (e, n, o) => [
  {
    id: z_,
    Header: ({
      getToggleAllRowsSelectedProps: t,
      toggleAllRowsSelected: r
    }) => {
      const { checked: a, indeterminate: i } = t();
      return /* @__PURE__ */ g.jsx(Be, { padding: "m m m l", children: /* @__PURE__ */ g.jsx(
        Ei,
        {
          isChecked: !!a,
          isIndeterminate: !!i,
          onChange: r,
          trackingId: "select-all-checkbox",
          "aria-label": "Select All",
          isDisabled: o
        }
      ) });
    },
    Cell: ({ row: t }) => /* @__PURE__ */ g.jsx(Be, { padding: "m l", children: /* @__PURE__ */ g.jsx(
      Ei,
      {
        isChecked: t.isSelected,
        onChange: t.toggleRowSelected,
        trackingId: `${n(t.original)}-select-checkbox`,
        isDisabled: o
      }
    ) })
  },
  ...e
], Y_ = "cosmic-utility-element-column", G_ = (e, n, o = "Utility") => [
  ...e,
  {
    id: Y_,
    Cell: ({ row: t }) => {
      const r = n(t.original);
      return r ? /* @__PURE__ */ g.jsx(Be, { justifyContent: "flex-end", padding: "m l", children: r }) : (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        /* @__PURE__ */ g.jsx(g.Fragment, {})
      );
    },
    Header: /* @__PURE__ */ g.jsx(Im, { children: o })
  }
], eA = ({
  clickableIndicatorColumnHeader: e,
  columns: n,
  density: o = "default",
  emptyStateProps: t,
  getRowKey: r,
  getRowOnClick: a,
  getRowUtilityElement: i,
  initialSortColumnKey: s,
  isInitialSortDescending: l,
  isLoading: u = !1,
  isSortable: c,
  onRowSelect: p,
  rows: h,
  shouldShowAutomaticPlaceholders: O,
  utilityColumnHeader: C,
  onSortChange: P,
  isManualSortable: k = !1,
  ...$
}) => {
  const I = F_({
    columns: n,
    shouldShowAutomaticPlaceholders: O,
    density: o,
    isLoading: u
  }), H = Ku.useTable(
    {
      columns: I,
      data: h,
      getRowId: r,
      manualSortBy: k,
      // Tables are opted into sorting by default in react-table, but we want to opt out by default
      disableSortBy: !c && !k,
      // Disallow sorting by multiple columns at once
      disableMultiSort: !0,
      // Ensures that sort order is maintained across data updates
      autoResetSortBy: !1,
      // Removes the ability for a 3rd click on a sortable column to remove sort order
      disableSortRemove: !0,
      // If we have an initial sort column key, feed it into the intial state for react-table
      // to ensure the table is initialized with the desired sort order/direction applied.
      ...s ? {
        initialState: {
          sortBy: [
            { id: s, desc: !!l }
          ]
        }
      } : {}
    },
    Ku.useSortBy,
    Ku.useRowSelect,
    // Each property on the object passed to this helper holds an array of utilities
    // that calculates internal state for the react-table instance. To add additional
    // columns, we can push our own helpers onto the `visibleColumns` utility array.
    ({ visibleColumns: oe }) => {
      i && oe.push(
        (ge) => G_(
          ge,
          i,
          C
        )
      ), a && oe.push(
        (ge) => B_(
          ge,
          e
        )
      ), p && oe.push(
        (ge) => H_(ge, r, u)
      );
    }
  ), {
    getTableProps: x,
    getTableBodyProps: _,
    headerGroups: F,
    rows: G,
    prepareRow: Q,
    selectedFlatRows: V,
    setHiddenColumns: ie,
    state: { sortBy: ce }
  } = H;
  Nt(() => {
    const oe = ce[0];
    P == null || P(oe.id, oe.desc);
  }, [P, ce]), Nt(() => {
    const oe = V.map(({ original: ge }) => ge);
    p == null || p(oe);
  }, [p, V]);
  const me = Uh("mobile"), ve = at(() => me ? n.filter(({ shouldHideOnMobile: oe }) => oe).map(({ key: oe }) => oe) : [], [n, me]);
  Nt(() => {
    ie(ve);
  }, [ve, ie]);
  const U = {
    emptyStateProps: t,
    getRowOnClick: a,
    isLoading: u,
    columnCount: n.length,
    rows: G,
    prepareRow: Q,
    getTableBodyProps: _
  }, ee = u && h.length === 0;
  return /* @__PURE__ */ g.jsxs(V_, { children: [
    /* @__PURE__ */ g.jsxs(U_, { isLoading: u, ...x(), ...$, children: [
      /* @__PURE__ */ g.jsx("thead", { children: F.map((oe) => /* @__PURE__ */ g.jsx(q_, { ...oe.getHeaderGroupProps(), children: oe.headers.map((ge) => {
        const { onClick: be, ...he } = ge.getSortByToggleProps();
        return /* @__PURE__ */ g.jsx(
          "th",
          {
            ...ge.getHeaderProps(he),
            "aria-sort": ge.isSortedDesc ? "descending" : "ascending",
            children: ge.render("Header", {
              isSorted: ge.isSorted,
              isSortedDesc: ge.isSortedDesc,
              isTableSortable: c || k,
              onClick: be
            })
          }
        );
      }) })) }),
      /* @__PURE__ */ g.jsx(E_, { ...U })
    ] }),
    ee && /* @__PURE__ */ g.jsx(K_, {})
  ] });
}, V_ = Y.div`
  width: 100%;
  overflow-x: auto;
  position: relative;
`, U_ = Y.table.withConfig({
  shouldForwardProp: (e) => e !== "isLoading"
})(
  ({ isLoading: e }) => `
  ${e ? "opacity: 40%; pointer-events: none;" : ""}
  width: 100%;
  border-collapse: collapse;
`
), q_ = Y.tr(
  ({ theme: e }) => `
  ${Nn(e)["h6-uppercase"]}
  color: ${Jd(e).secondary};
  line-height: 1;
  background-color: ${e.color.gray0};
  border-bottom: ${Pn(e)};
  padding: ${e.spacing.m} ${e.spacing.l};
  white-space: nowrap;
`
), K_ = Y(P_)(
  ({ theme: e }) => `
  position: absolute;
  // 48px header height (can't be hardcoded due to table limitations) + 48px spacing 
  top: calc(${e.sizing.l} + ${e.spacing.xxl});
  left: 50%;
  transform: translateX(-50%);
`
), tA = (e, n) => jn(e) ? -1 : jn(n) ? 1 : e.localeCompare(n), rA = (e, n) => jn(e) ? -1 : jn(n) ? 1 : e.getTime() - n.getTime(), Q_ = (e) => ({
  primary: {
    backgroundColor: e.color.black,
    color: e.color.white
  },
  danger: {
    backgroundColor: e.color.danger,
    color: e.color.white
  }
}), nA = ({
  children: e,
  className: n = "",
  onClose: o,
  trackingId: t,
  variant: r = "primary"
}) => /* @__PURE__ */ g.jsxs(
  X_,
  {
    variant: r,
    className: n,
    trackingId: t,
    children: [
      /* @__PURE__ */ g.jsx(Cf, { as: "div", children: e }),
      /* @__PURE__ */ g.jsx(
        J_,
        {
          variant: "white",
          onClick: o,
          trackingId: `${t}-close-button`,
          iconName: "x"
        }
      )
    ]
  }
), X_ = Jr(
  Y.div.withConfig({
    shouldForwardProp: (e) => e !== "variant"
  })(({ theme: e, variant: n }) => {
    const { color: o, backgroundColor: t } = Q_(e)[n];
    return `
    position: relative;
    z-index: ${e.zIndex.toast};

    background-color: ${t};
    padding: ${e.spacing.m} ${e.spacing.xxl} ${e.spacing.m} ${e.spacing.m};
    border-radius: ${e.borderRadius.s};
  
    // Style for "a" rather than the Anchor base to account for internal navigation links
    // that can't be accomplished with the Anchor atom
    ${pr}, ${Na}, a, a:hover, a:active {
      color: ${o} !important;
    }

    ${Na}, a, a:hover, a:active {
      font-weight: ${e.fontWeight.bold};
      text-decoration: underline;
    }
  `;
  })
), J_ = Y(Fn)(({ theme: e }) => `
    position: absolute;

    /* Hardcoded positioning to align the ActionButton with the top line of text */
    top: 14px;
    right: ${e.spacing.m};
  `), oA = Y.div(
  ({ theme: e }) => `
    display: flex;
    gap: ${e.spacing.l};
    
    ${Ho(e, "mobile")} {
      flex-direction: column;
    }
`
), Z_ = ({
  title: e,
  items: n
}) => /* @__PURE__ */ g.jsxs(Be, { direction: "column", padding: "none m none none", children: [
  e && /* @__PURE__ */ g.jsx(eI, { forwardedAs: "div", colorVariant: "secondary", children: e }),
  /* @__PURE__ */ g.jsx(F2, { items: n })
] }), eI = Y(zi)(
  ({ theme: e }) => `
  padding: ${e.spacing.xs} ${e.spacing.l} 12px;
`
), tI = "290px", aA = ({ sections: e, logoElement: n }) => /* @__PURE__ */ g.jsx(
  nI,
  {
    direction: "column",
    padding: `${n ? "xxl" : "xl"} none m none`,
    children: /* @__PURE__ */ g.jsxs(Be, { direction: "column", gap: "l", children: [
      n && /* @__PURE__ */ g.jsx(rI, { children: n }),
      e.map((o, t) => {
        const r = o.items[0].trackingId;
        return /* @__PURE__ */ g.jsxs(Or, { children: [
          t !== 0 && /* @__PURE__ */ g.jsx(Be, { padding: "none m", children: /* @__PURE__ */ g.jsx(Bn, {}) }),
          /* @__PURE__ */ g.jsx(Z_, { ...o })
        ] }, r);
      })
    ] })
  }
), rI = Y.div(
  ({ theme: e }) => `
  height: ${e.sizing.xs};
  align-self: center;
`
), nI = Y(Be)(
  ({ theme: e }) => `
  width: ${tI};
  background-color: ${e.color.white};
  border-right: ${Pn(e)};
`
);
function Xa(e, n, o, t) {
  function r(a) {
    return a instanceof o ? a : new o(function(i) {
      i(a);
    });
  }
  return new (o || (o = Promise))(function(a, i) {
    function s(c) {
      try {
        u(t.next(c));
      } catch (p) {
        i(p);
      }
    }
    function l(c) {
      try {
        u(t.throw(c));
      } catch (p) {
        i(p);
      }
    }
    function u(c) {
      c.done ? a(c.value) : r(c.value).then(s, l);
    }
    u((t = t.apply(e, n || [])).next());
  });
}
function Ja(e, n) {
  var o = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, t, r, a, i;
  return i = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function s(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (t)
      throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, u[0] && (o = 0)), o; )
      try {
        if (t = 1, r && (a = u[0] & 2 ? r.return : u[0] ? r.throw || ((a = r.return) && a.call(r), 0) : r.next) && !(a = a.call(r, u[1])).done)
          return a;
        switch (r = 0, a && (u = [u[0] & 2, a.value]), u[0]) {
          case 0:
          case 1:
            a = u;
            break;
          case 4:
            return o.label++, { value: u[1], done: !1 };
          case 5:
            o.label++, r = u[1], u = [0];
            continue;
          case 7:
            u = o.ops.pop(), o.trys.pop();
            continue;
          default:
            if (a = o.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              o = 0;
              continue;
            }
            if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
              o.label = u[1];
              break;
            }
            if (u[0] === 6 && o.label < a[1]) {
              o.label = a[1], a = u;
              break;
            }
            if (a && o.label < a[2]) {
              o.label = a[2], o.ops.push(u);
              break;
            }
            a[2] && o.ops.pop(), o.trys.pop();
            continue;
        }
        u = n.call(e, o);
      } catch (c) {
        u = [6, c], r = 0;
      } finally {
        t = a = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function bh(e, n) {
  var o = typeof Symbol == "function" && e[Symbol.iterator];
  if (!o)
    return e;
  var t = o.call(e), r, a = [], i;
  try {
    for (; (n === void 0 || n-- > 0) && !(r = t.next()).done; )
      a.push(r.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      r && !r.done && (o = t.return) && o.call(t);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return a;
}
function wh(e, n, o) {
  if (o || arguments.length === 2)
    for (var t = 0, r = n.length, a; t < r; t++)
      (a || !(t in n)) && (a || (a = Array.prototype.slice.call(n, 0, t)), a[t] = n[t]);
  return e.concat(a || Array.prototype.slice.call(n));
}
var oI = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function es(e, n) {
  var o = aI(e);
  if (typeof o.path != "string") {
    var t = e.webkitRelativePath;
    Object.defineProperty(o, "path", {
      value: typeof n == "string" ? n : typeof t == "string" && t.length > 0 ? t : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return o;
}
function aI(e) {
  var n = e.name, o = n && n.lastIndexOf(".") !== -1;
  if (o && !e.type) {
    var t = n.split(".").pop().toLowerCase(), r = oI.get(t);
    r && Object.defineProperty(e, "type", {
      value: r,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var iI = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function sI(e) {
  return Xa(this, void 0, void 0, function() {
    return Ja(this, function(n) {
      return fl(e) && lI(e.dataTransfer) ? [2, pI(e.dataTransfer, e.type)] : uI(e) ? [2, cI(e)] : Array.isArray(e) && e.every(function(o) {
        return "getFile" in o && typeof o.getFile == "function";
      }) ? [2, dI(e)] : [2, []];
    });
  });
}
function lI(e) {
  return fl(e);
}
function uI(e) {
  return fl(e) && fl(e.target);
}
function fl(e) {
  return typeof e == "object" && e !== null;
}
function cI(e) {
  return Wd(e.target.files).map(function(n) {
    return es(n);
  });
}
function dI(e) {
  return Xa(this, void 0, void 0, function() {
    var n;
    return Ja(this, function(o) {
      switch (o.label) {
        case 0:
          return [4, Promise.all(e.map(function(t) {
            return t.getFile();
          }))];
        case 1:
          return n = o.sent(), [2, n.map(function(t) {
            return es(t);
          })];
      }
    });
  });
}
function pI(e, n) {
  return Xa(this, void 0, void 0, function() {
    var o, t;
    return Ja(this, function(r) {
      switch (r.label) {
        case 0:
          return e.items ? (o = Wd(e.items).filter(function(a) {
            return a.kind === "file";
          }), n !== "drop" ? [2, o] : [4, Promise.all(o.map(fI))]) : [3, 2];
        case 1:
          return t = r.sent(), [2, xh(fb(t))];
        case 2:
          return [2, xh(Wd(e.files).map(function(a) {
            return es(a);
          }))];
      }
    });
  });
}
function xh(e) {
  return e.filter(function(n) {
    return iI.indexOf(n.name) === -1;
  });
}
function Wd(e) {
  if (e === null)
    return [];
  for (var n = [], o = 0; o < e.length; o++) {
    var t = e[o];
    n.push(t);
  }
  return n;
}
function fI(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return Ch(e);
  var n = e.webkitGetAsEntry();
  return n && n.isDirectory ? vb(n) : Ch(e);
}
function fb(e) {
  return e.reduce(function(n, o) {
    return wh(wh([], bh(n), !1), bh(Array.isArray(o) ? fb(o) : [o]), !1);
  }, []);
}
function Ch(e) {
  var n = e.getAsFile();
  if (!n)
    return Promise.reject("".concat(e, " is not a File"));
  var o = es(n);
  return Promise.resolve(o);
}
function vI(e) {
  return Xa(this, void 0, void 0, function() {
    return Ja(this, function(n) {
      return [2, e.isDirectory ? vb(e) : gI(e)];
    });
  });
}
function vb(e) {
  var n = e.createReader();
  return new Promise(function(o, t) {
    var r = [];
    function a() {
      var i = this;
      n.readEntries(function(s) {
        return Xa(i, void 0, void 0, function() {
          var l, u, c;
          return Ja(this, function(p) {
            switch (p.label) {
              case 0:
                if (s.length)
                  return [3, 5];
                p.label = 1;
              case 1:
                return p.trys.push([1, 3, , 4]), [4, Promise.all(r)];
              case 2:
                return l = p.sent(), o(l), [3, 4];
              case 3:
                return u = p.sent(), t(u), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                c = Promise.all(s.map(vI)), r.push(c), a(), p.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(s) {
        t(s);
      });
    }
    a();
  });
}
function gI(e) {
  return Xa(this, void 0, void 0, function() {
    return Ja(this, function(n) {
      return [2, new Promise(function(o, t) {
        e.file(function(r) {
          var a = es(r, e.fullPath);
          o(a);
        }, function(r) {
          t(r);
        });
      })];
    });
  });
}
var hI = function(e, n) {
  if (e && n) {
    var o = Array.isArray(n) ? n : n.split(","), t = e.name || "", r = (e.type || "").toLowerCase(), a = r.replace(/\/.*$/, "");
    return o.some(function(i) {
      var s = i.trim().toLowerCase();
      return s.charAt(0) === "." ? t.toLowerCase().endsWith(s) : s.endsWith("/*") ? a === s.replace(/\/.*$/, "") : r === s;
    });
  }
  return !0;
};
function Sh(e) {
  return bI(e) || yI(e) || hb(e) || mI();
}
function mI() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yI(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function bI(e) {
  if (Array.isArray(e))
    return zd(e);
}
function Oh(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), o.push.apply(o, t);
  }
  return o;
}
function Ph(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Oh(Object(o), !0).forEach(function(t) {
      gb(e, t, o[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : Oh(Object(o)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
    });
  }
  return e;
}
function gb(e, n, o) {
  return n in e ? Object.defineProperty(e, n, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = o, e;
}
function Mi(e, n) {
  return CI(e) || xI(e, n) || hb(e, n) || wI();
}
function wI() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hb(e, n) {
  if (e) {
    if (typeof e == "string")
      return zd(e, n);
    var o = Object.prototype.toString.call(e).slice(8, -1);
    if (o === "Object" && e.constructor && (o = e.constructor.name), o === "Map" || o === "Set")
      return Array.from(e);
    if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o))
      return zd(e, n);
  }
}
function zd(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var o = 0, t = new Array(n); o < n; o++)
    t[o] = e[o];
  return t;
}
function xI(e, n) {
  var o = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (o != null) {
    var t = [], r = !0, a = !1, i, s;
    try {
      for (o = o.call(e); !(r = (i = o.next()).done) && (t.push(i.value), !(n && t.length === n)); r = !0)
        ;
    } catch (l) {
      a = !0, s = l;
    } finally {
      try {
        !r && o.return != null && o.return();
      } finally {
        if (a)
          throw s;
      }
    }
    return t;
  }
}
function CI(e) {
  if (Array.isArray(e))
    return e;
}
var mb = "file-invalid-type", yb = "file-too-large", bb = "file-too-small", wb = "too-many-files", Eh = {
  FileInvalidType: mb,
  FileTooLarge: yb,
  FileTooSmall: bb,
  TooManyFiles: wb
}, SI = function(n) {
  n = Array.isArray(n) && n.length === 1 ? n[0] : n;
  var o = Array.isArray(n) ? "one of ".concat(n.join(", ")) : n;
  return {
    code: mb,
    message: "File type must be ".concat(o)
  };
}, kh = function(n) {
  return {
    code: yb,
    message: "File is larger than ".concat(n, " ").concat(n === 1 ? "byte" : "bytes")
  };
}, Rh = function(n) {
  return {
    code: bb,
    message: "File is smaller than ".concat(n, " ").concat(n === 1 ? "byte" : "bytes")
  };
}, OI = {
  code: wb,
  message: "Too many files"
};
function xb(e, n) {
  var o = e.type === "application/x-moz-file" || hI(e, n);
  return [o, o ? null : SI(n)];
}
function Cb(e, n, o) {
  if (oa(e.size))
    if (oa(n) && oa(o)) {
      if (e.size > o)
        return [!1, kh(o)];
      if (e.size < n)
        return [!1, Rh(n)];
    } else {
      if (oa(n) && e.size < n)
        return [!1, Rh(n)];
      if (oa(o) && e.size > o)
        return [!1, kh(o)];
    }
  return [!0, null];
}
function oa(e) {
  return e != null;
}
function PI(e) {
  var n = e.files, o = e.accept, t = e.minSize, r = e.maxSize, a = e.multiple, i = e.maxFiles, s = e.validator;
  return !a && n.length > 1 || a && i >= 1 && n.length > i ? !1 : n.every(function(l) {
    var u = xb(l, o), c = Mi(u, 1), p = c[0], h = Cb(l, t, r), O = Mi(h, 1), C = O[0], P = s ? s(l) : null;
    return p && C && !P;
  });
}
function vl(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function Fs(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(n) {
    return n === "Files" || n === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function $h(e) {
  e.preventDefault();
}
function EI(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function kI(e) {
  return e.indexOf("Edge/") !== -1;
}
function RI() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return EI(e) || kI(e);
}
function to() {
  for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++)
    n[o] = arguments[o];
  return function(t) {
    for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      a[i - 1] = arguments[i];
    return n.some(function(s) {
      return !vl(t) && s && s.apply(void 0, [t].concat(a)), vl(t);
    });
  };
}
function $I() {
  return "showOpenFilePicker" in window;
}
function DI(e) {
  if (oa(e)) {
    var n = Object.entries(e).filter(function(o) {
      var t = Mi(o, 2), r = t[0], a = t[1], i = !0;
      return Sb(r) || (console.warn('Skipped "'.concat(r, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), i = !1), (!Array.isArray(a) || !a.every(Ob)) && (console.warn('Skipped "'.concat(r, '" because an invalid file extension was provided.')), i = !1), i;
    }).reduce(function(o, t) {
      var r = Mi(t, 2), a = r[0], i = r[1];
      return Ph(Ph({}, o), {}, gb({}, a, i));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: n
    }];
  }
  return e;
}
function TI(e) {
  if (oa(e))
    return Object.entries(e).reduce(function(n, o) {
      var t = Mi(o, 2), r = t[0], a = t[1];
      return [].concat(Sh(n), [r], Sh(a));
    }, []).filter(function(n) {
      return Sb(n) || Ob(n);
    }).join(",");
}
function jI(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function _I(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function Sb(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function Ob(e) {
  return /^.*\.[\w]+$/.test(e);
}
var II = ["children"], MI = ["open"], AI = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], FI = ["refKey", "onChange", "onClick"];
function LI(e) {
  return WI(e) || BI(e) || Pb(e) || NI();
}
function NI() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function BI(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function WI(e) {
  if (Array.isArray(e))
    return Hd(e);
}
function Qu(e, n) {
  return YI(e) || HI(e, n) || Pb(e, n) || zI();
}
function zI() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Pb(e, n) {
  if (e) {
    if (typeof e == "string")
      return Hd(e, n);
    var o = Object.prototype.toString.call(e).slice(8, -1);
    if (o === "Object" && e.constructor && (o = e.constructor.name), o === "Map" || o === "Set")
      return Array.from(e);
    if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o))
      return Hd(e, n);
  }
}
function Hd(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var o = 0, t = new Array(n); o < n; o++)
    t[o] = e[o];
  return t;
}
function HI(e, n) {
  var o = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (o != null) {
    var t = [], r = !0, a = !1, i, s;
    try {
      for (o = o.call(e); !(r = (i = o.next()).done) && (t.push(i.value), !(n && t.length === n)); r = !0)
        ;
    } catch (l) {
      a = !0, s = l;
    } finally {
      try {
        !r && o.return != null && o.return();
      } finally {
        if (a)
          throw s;
      }
    }
    return t;
  }
}
function YI(e) {
  if (Array.isArray(e))
    return e;
}
function Dh(e, n) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), o.push.apply(o, t);
  }
  return o;
}
function xr(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Dh(Object(o), !0).forEach(function(t) {
      Yd(e, t, o[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : Dh(Object(o)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
    });
  }
  return e;
}
function Yd(e, n, o) {
  return n in e ? Object.defineProperty(e, n, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = o, e;
}
function gl(e, n) {
  if (e == null)
    return {};
  var o = GI(e, n), t, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function GI(e, n) {
  if (e == null)
    return {};
  var o = {}, t = Object.keys(e), r, a;
  for (a = 0; a < t.length; a++)
    r = t[a], !(n.indexOf(r) >= 0) && (o[r] = e[r]);
  return o;
}
var cv = /* @__PURE__ */ Ye(function(e, n) {
  var o = e.children, t = gl(e, II), r = kb(t), a = r.open, i = gl(r, MI);
  return Ib(n, function() {
    return {
      open: a
    };
  }, [a]), /* @__PURE__ */ y.createElement(Or, null, o(xr(xr({}, i), {}, {
    open: a
  })));
});
cv.displayName = "Dropzone";
var Eb = {
  disabled: !1,
  getFilesFromEvent: sI,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
cv.defaultProps = Eb;
cv.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: j.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: j.objectOf(j.arrayOf(j.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: j.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: j.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: j.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: j.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: j.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: j.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: j.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: j.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: j.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: j.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: j.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: j.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: j.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: j.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: j.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: j.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: j.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: j.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: j.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: j.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: j.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: j.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: j.func
};
var Gd = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function kb() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = xr(xr({}, Eb), e), o = n.accept, t = n.disabled, r = n.getFilesFromEvent, a = n.maxSize, i = n.minSize, s = n.multiple, l = n.maxFiles, u = n.onDragEnter, c = n.onDragLeave, p = n.onDragOver, h = n.onDrop, O = n.onDropAccepted, C = n.onDropRejected, P = n.onFileDialogCancel, k = n.onFileDialogOpen, $ = n.useFsAccessApi, I = n.autoFocus, H = n.preventDropOnDocument, x = n.noClick, _ = n.noKeyboard, F = n.noDrag, G = n.noDragEventsBubbling, Q = n.onError, V = n.validator, ie = at(function() {
    return TI(o);
  }, [o]), ce = at(function() {
    return DI(o);
  }, [o]), me = at(function() {
    return typeof k == "function" ? k : Th;
  }, [k]), ve = at(function() {
    return typeof P == "function" ? P : Th;
  }, [P]), U = St(null), ee = St(null), oe = da(VI, Gd), ge = Qu(oe, 2), be = ge[0], he = ge[1], K = be.isFocused, le = be.isFileDialogActive, Pe = St(typeof window < "u" && window.isSecureContext && $ && $I()), lt = function() {
    !Pe.current && le && setTimeout(function() {
      if (ee.current) {
        var it = ee.current.files;
        it.length || (he({
          type: "closeDialog"
        }), ve());
      }
    }, 300);
  };
  Nt(function() {
    return window.addEventListener("focus", lt, !1), function() {
      window.removeEventListener("focus", lt, !1);
    };
  }, [ee, le, ve, Pe]);
  var Ge = St([]), ut = function(it) {
    U.current && U.current.contains(it.target) || (it.preventDefault(), Ge.current = []);
  };
  Nt(function() {
    return H && (document.addEventListener("dragover", $h, !1), document.addEventListener("drop", ut, !1)), function() {
      H && (document.removeEventListener("dragover", $h), document.removeEventListener("drop", ut));
    };
  }, [U, H]), Nt(function() {
    return !t && I && U.current && U.current.focus(), function() {
    };
  }, [U, I, t]);
  var ze = It(function(Re) {
    Q ? Q(Re) : console.error(Re);
  }, [Q]), Ze = It(function(Re) {
    Re.preventDefault(), Re.persist(), Pr(Re), Ge.current = [].concat(LI(Ge.current), [Re.target]), Fs(Re) && Promise.resolve(r(Re)).then(function(it) {
      if (!(vl(Re) && !G)) {
        var Qt = it.length, tr = Qt > 0 && PI({
          files: it,
          accept: ie,
          minSize: i,
          maxSize: a,
          multiple: s,
          maxFiles: l,
          validator: V
        }), mr = Qt > 0 && !tr;
        he({
          isDragAccept: tr,
          isDragReject: mr,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), u && u(Re);
      }
    }).catch(function(it) {
      return ze(it);
    });
  }, [r, u, ze, G, ie, i, a, s, l, V]), _e = It(function(Re) {
    Re.preventDefault(), Re.persist(), Pr(Re);
    var it = Fs(Re);
    if (it && Re.dataTransfer)
      try {
        Re.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return it && p && p(Re), !1;
  }, [p, G]), De = It(function(Re) {
    Re.preventDefault(), Re.persist(), Pr(Re);
    var it = Ge.current.filter(function(tr) {
      return U.current && U.current.contains(tr);
    }), Qt = it.indexOf(Re.target);
    Qt !== -1 && it.splice(Qt, 1), Ge.current = it, !(it.length > 0) && (he({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), Fs(Re) && c && c(Re));
  }, [U, c, G]), fe = It(function(Re, it) {
    var Qt = [], tr = [];
    Re.forEach(function(mr) {
      var dn = xb(mr, ie), an = Qu(dn, 2), hn = an[0], Wn = an[1], zn = Cb(mr, i, a), Z = Qu(zn, 2), Ve = Z[0], ct = Z[1], Mt = V ? V(mr) : null;
      if (hn && Ve && !Mt)
        Qt.push(mr);
      else {
        var Et = [Wn, ct];
        Mt && (Et = Et.concat(Mt)), tr.push({
          file: mr,
          errors: Et.filter(function(vr) {
            return vr;
          })
        });
      }
    }), (!s && Qt.length > 1 || s && l >= 1 && Qt.length > l) && (Qt.forEach(function(mr) {
      tr.push({
        file: mr,
        errors: [OI]
      });
    }), Qt.splice(0)), he({
      acceptedFiles: Qt,
      fileRejections: tr,
      type: "setFiles"
    }), h && h(Qt, tr, it), tr.length > 0 && C && C(tr, it), Qt.length > 0 && O && O(Qt, it);
  }, [he, s, ie, i, a, l, h, O, C, V]), ke = It(function(Re) {
    Re.preventDefault(), Re.persist(), Pr(Re), Ge.current = [], Fs(Re) && Promise.resolve(r(Re)).then(function(it) {
      vl(Re) && !G || fe(it, Re);
    }).catch(function(it) {
      return ze(it);
    }), he({
      type: "reset"
    });
  }, [r, fe, ze, G]), re = It(function() {
    if (Pe.current) {
      he({
        type: "openDialog"
      }), me();
      var Re = {
        multiple: s,
        types: ce
      };
      window.showOpenFilePicker(Re).then(function(it) {
        return r(it);
      }).then(function(it) {
        fe(it, null), he({
          type: "closeDialog"
        });
      }).catch(function(it) {
        jI(it) ? (ve(it), he({
          type: "closeDialog"
        })) : _I(it) ? (Pe.current = !1, ee.current ? (ee.current.value = null, ee.current.click()) : ze(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : ze(it);
      });
      return;
    }
    ee.current && (he({
      type: "openDialog"
    }), me(), ee.current.value = null, ee.current.click());
  }, [he, me, ve, $, fe, ze, ce, s]), tt = It(function(Re) {
    !U.current || !U.current.isEqualNode(Re.target) || (Re.key === " " || Re.key === "Enter" || Re.keyCode === 32 || Re.keyCode === 13) && (Re.preventDefault(), re());
  }, [U, re]), et = It(function() {
    he({
      type: "focus"
    });
  }, []), Dt = It(function() {
    he({
      type: "blur"
    });
  }, []), Kt = It(function() {
    x || (RI() ? setTimeout(re, 0) : re());
  }, [x, re]), fr = function(it) {
    return t ? null : it;
  }, Ir = function(it) {
    return _ ? null : fr(it);
  }, jr = function(it) {
    return F ? null : fr(it);
  }, Pr = function(it) {
    G && it.stopPropagation();
  }, Nr = at(function() {
    return function() {
      var Re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, it = Re.refKey, Qt = it === void 0 ? "ref" : it, tr = Re.role, mr = Re.onKeyDown, dn = Re.onFocus, an = Re.onBlur, hn = Re.onClick, Wn = Re.onDragEnter, zn = Re.onDragOver, Z = Re.onDragLeave, Ve = Re.onDrop, ct = gl(Re, AI);
      return xr(xr(Yd({
        onKeyDown: Ir(to(mr, tt)),
        onFocus: Ir(to(dn, et)),
        onBlur: Ir(to(an, Dt)),
        onClick: fr(to(hn, Kt)),
        onDragEnter: jr(to(Wn, Ze)),
        onDragOver: jr(to(zn, _e)),
        onDragLeave: jr(to(Z, De)),
        onDrop: jr(to(Ve, ke)),
        role: typeof tr == "string" && tr !== "" ? tr : "presentation"
      }, Qt, U), !t && !_ ? {
        tabIndex: 0
      } : {}), ct);
    };
  }, [U, tt, et, Dt, Kt, Ze, _e, De, ke, _, F, t]), nn = It(function(Re) {
    Re.stopPropagation();
  }, []), on = at(function() {
    return function() {
      var Re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, it = Re.refKey, Qt = it === void 0 ? "ref" : it, tr = Re.onChange, mr = Re.onClick, dn = gl(Re, FI), an = Yd({
        accept: ie,
        multiple: s,
        type: "file",
        style: {
          display: "none"
        },
        onChange: fr(to(tr, ke)),
        onClick: fr(to(mr, nn)),
        tabIndex: -1
      }, Qt, ee);
      return xr(xr({}, an), dn);
    };
  }, [ee, o, s, ke, t]);
  return xr(xr({}, be), {}, {
    isFocused: K && !t,
    getRootProps: Nr,
    getInputProps: on,
    rootRef: U,
    inputRef: ee,
    open: fr(re)
  });
}
function VI(e, n) {
  switch (n.type) {
    case "focus":
      return xr(xr({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return xr(xr({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return xr(xr({}, Gd), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return xr(xr({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return xr(xr({}, e), {}, {
        isDragActive: n.isDragActive,
        isDragAccept: n.isDragAccept,
        isDragReject: n.isDragReject
      });
    case "setFiles":
      return xr(xr({}, e), {}, {
        acceptedFiles: n.acceptedFiles,
        fileRejections: n.fileRejections
      });
    case "reset":
      return xr({}, Gd);
    default:
      return e;
  }
}
function Th() {
}
const UI = ({ filename: e, onRemove: n, isDisabled: o }) => /* @__PURE__ */ g.jsxs(
  qI,
  {
    justifyContent: "space-between",
    alignItems: "center",
    isDisabled: o,
    children: [
      /* @__PURE__ */ g.jsxs(Be, { gap: "m", alignItems: "center", children: [
        /* @__PURE__ */ g.jsx(KI, { name: "check-circle" }),
        /* @__PURE__ */ g.jsx(vo, { children: e })
      ] }),
      /* @__PURE__ */ g.jsx(
        Fn,
        {
          iconName: "x",
          onClick: n,
          trackingId: `uploader-remove-button-${e}`,
          isDisabled: o
        }
      )
    ]
  }
), qI = Y(Be)(
  ({ theme: e, isDisabled: n }) => `
  background-color: ${e.color.white};
  border: ${Pn(e)};
  border-radius: ${e.borderRadius.s};
  padding: ${e.spacing.m};

  ${n ? Rn : ""}
`
), KI = Y(Lr)(
  ({ theme: e }) => `
  color: ${e.color.success};
`
), jh = (e) => e === 1 ? "You can only upload 1 file." : `You can only upload up to ${e} files.`, iA = ({
  errorMessage: e,
  files: n,
  isDisabled: o = !1,
  maxFiles: t = 1,
  onChange: r,
  shouldShowSelectedFiles: a = !1,
  supportedFileTypes: i,
  trackingId: s,
  validationState: l = "none"
}) => {
  const u = o || n.length >= t, [c, p] = ur(), h = i.map(($) => jv[$]).join(", "), { getRootProps: O, getInputProps: C, isDragActive: P } = kb({
    onDrop: ($) => {
      const I = [...n, ...$];
      I.length > t ? p(jh(t)) : (p(void 0), r(I));
    },
    onDropRejected: ($) => {
      if ($.some(
        ({ errors: x }) => x.some(({ code: _ }) => _ === Eh.TooManyFiles)
      )) {
        p(jh(t));
        return;
      }
      $.some(
        ({ errors: x }) => x.some(({ code: _ }) => _ === Eh.FileInvalidType)
      ) && p(
        `Files uploaded must be one of the following types: ${h}`
      );
    },
    accept: Object.fromEntries(
      i.map(($) => [
        $,
        [jv[$]]
      ])
    ),
    disabled: u,
    maxFiles: t,
    multiple: t > 1
  }), k = It(
    ($) => {
      r(n.filter((I) => I !== $));
    },
    [r, n]
  );
  return /* @__PURE__ */ g.jsxs(Be, { direction: "column", gap: "m", children: [
    c ? /* @__PURE__ */ g.jsx(Og, { variant: "danger", children: c }) : e && l === "error" ? /* @__PURE__ */ g.jsx(Og, { variant: "danger", children: e }) : void 0,
    /* @__PURE__ */ g.jsxs(
      JI,
      {
        ...O(),
        isDisabled: u,
        isDragActive: P,
        trackingId: s,
        validationState: c ? "error" : l,
        role: "button",
        children: [
          /* @__PURE__ */ g.jsx("input", { ...C() }),
          /* @__PURE__ */ g.jsx(XI, { name: "upload-cloud", isDisabled: u }),
          /* @__PURE__ */ g.jsxs(Be, { direction: "column", gap: "s", alignItems: "center", children: [
            /* @__PURE__ */ g.jsxs(vo, { children: [
              "Drag and drop to upload, or",
              " ",
              /* @__PURE__ */ g.jsx(QI, { isDisabled: u, children: "browse files" }),
              "."
            ] }),
            /* @__PURE__ */ g.jsxs(un, { colorVariant: "secondary", children: [
              "Supported file types: ",
              h
            ] })
          ] })
        ]
      }
    ),
    a && n.map(($, I) => /* @__PURE__ */ g.jsx(
      UI,
      {
        onRemove: () => k($),
        filename: $.name,
        isDisabled: o
      },
      `${$.name}-${I}`
    ))
  ] });
}, QI = Y.span.withConfig({
  shouldForwardProp: (e) => e !== "isDisabled"
})(
  ({ theme: e, isDisabled: n }) => `
   ${Ol(e, { variant: "anchor-primary-inline" })}

   // The underline in the anchor-primary-inline style is currently added directly to the underlying clickable contents container due to a Chrome issue. So, we have to add the underline ourselves to this usage.
   text-decoration: underline;
   transition: none;

  ${n ? `color: ${e.color.disabled};` : ""}
`
), XI = Y(Lr).withConfig({
  shouldForwardProp: (e) => e !== "isDisabled"
})(
  ({ theme: e, isDisabled: n }) => `
  width: ${e.sizing.l};
  height: ${e.sizing.l};
  color: ${n ? e.color.disabled : e.color.primary};
`
), JI = Jr(
  Y.div.withConfig({
    shouldForwardProp: (e) => !["isDragActive", "isFocused", "isDisabled", "validationState"].includes(
      e
    )
  })(
    ({ theme: e, isDragActive: n, isDisabled: o, validationState: t }) => `
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: ${e.spacing.m};
  padding: ${e.spacing.l};
  align-items: center;
  border-radius: ${e.borderRadius.s};
  text-align: center;
  border: ${e.borderWidth.m} dashed ${t === "error" ? e.color.danger : e.color.primary};


  &:hover {
    background-color: ${e.color.gray0};
  }

  ${n ? `background-color: ${Fr(e.color.primary)};` : ""}

  &:focus-visible {
    outline: none;
    ${cn(e)}
  }


  ${o ? `
        pointer-events: none;
        border-color: ${e.color.disabled};
        background-color: ${e.color.gray0};

        ${pr}, ${Na}, ${em} {
          color: ${e.color.disabled};
        }
      ` : ""}
`
  )
), ZI = (e, n, o, t) => e.map((r, a) => /* @__PURE__ */ g.jsxs(Or, { children: [
  o(r),
  a !== e.length - 1 && t
] }, n(r, a))), eM = ({
  title: e,
  onBack: n,
  backButtonTrackingId: o,
  backButtonLabel: t = "Back",
  utilityElement: r,
  subtitles: a
}) => /* @__PURE__ */ g.jsxs(Be, { direction: "column", children: [
  /* @__PURE__ */ g.jsxs(rM, { padding: "l none", justifyContent: "space-between", children: [
    /* @__PURE__ */ g.jsxs(Be, { gap: "m", alignItems: "center", children: [
      n && o && /* @__PURE__ */ g.jsx(
        Fn,
        {
          onClick: n,
          trackingId: o,
          iconName: "arrow-left",
          size: "large",
          label: t
        }
      ),
      /* @__PURE__ */ g.jsxs(Be, { direction: "column", children: [
        /* @__PURE__ */ g.jsx(_O, { children: e }),
        /* @__PURE__ */ g.jsx(Be, { direction: "row", children: a && ZI(
          a,
          (i, s) => `${i}-${s}`,
          (i) => /* @__PURE__ */ g.jsx(un, { colorVariant: "secondary", children: i }),
          /* @__PURE__ */ g.jsx(tM, { colorVariant: "secondary", children: "|" })
        ) })
      ] })
    ] }),
    r
  ] }),
  /* @__PURE__ */ g.jsx(Bn, {})
] }), tM = Y(un)(
  ({ theme: e }) => `
    padding: ${e.spacing.none} ${e.spacing.m};
`
), rM = Y(Be)(
  ({ theme: e }) => `
  // Min height of top/bottom padding + the expected height for utility slot.
  // We set min-height here so the header doesn't shrink if there is
  // no utility element or back button present.
  min-height: calc(${e.spacing.l} + ${e.spacing.l} + ${e.sizing.m});
`
), sA = ({
  backButtonLabel: e,
  backButtonTrackingId: n,
  children: o,
  onBack: t,
  title: r,
  trackingId: a,
  subtitles: i,
  utilityElement: s,
  shouldHaveMaxWidth: l = !1
}) => {
  const u = {
    backButtonLabel: e,
    backButtonTrackingId: n,
    onBack: t,
    title: r,
    utilityElement: s && /* @__PURE__ */ g.jsx(Vd, { children: s }),
    subtitles: i
  };
  return /* @__PURE__ */ g.jsxs(
    nM,
    {
      trackingId: a,
      direction: "column",
      gap: "l",
      shouldHaveMaxWidth: l,
      children: [
        /* @__PURE__ */ g.jsx(eM, { ...u }),
        s && /* @__PURE__ */ g.jsx(Ud, { children: s }),
        o
      ]
    }
  );
}, Vd = Y.div``, Ud = Y.div``, nM = Y(Be).withConfig({
  shouldForwardProp: (e) => e !== "shouldHaveMaxWidth"
})(
  ({ theme: e, shouldHaveMaxWidth: n }) => `
  ${n ? `max-width: ${e.pageMaxWidth};` : ""}
  margin: 0 auto;
  width: 100%;
  padding: ${e.spacing.none} ${e.spacing.xxl} ${e.spacing.xxl};

  ${Vd} {
    display: block;
  }

  ${Ud} {
    display: none;
  }

  ${Ho(e, "mobile")} {
    padding: ${e.spacing.m};

    ${Vd} {
      display: none;
    }

    ${Ud} {
      display: block;
    }
  }
`
), lA = Y(Be).attrs({
  alignItems: "center",
  gap: "m"
})``;
export {
  Fn as ActionButton,
  kM as ActionButtonGroup,
  RM as ActionMenu,
  Og as Alert,
  TC as Anchor,
  $M as Autocomplete,
  Of as Avatar,
  SM as AvatarLoadingShimmer,
  $m as Backdrop,
  Rl as Badge,
  TM as Banner,
  jM as BlockGroup,
  _M as BlurContainer,
  vo as Body,
  bM as BodyDanger,
  wM as BodyDangerSmall,
  fM as BodyExtraSmall,
  vM as BodySecondary,
  hM as BodySecondaryExtraSmall,
  gM as BodySecondarySmall,
  un as BodySmall,
  mM as BodySuccess,
  yM as BodySuccessSmall,
  Pf as Box,
  HO as BoxAccent,
  La as Button,
  A_ as COSMIC_TABLE_PLACEHOLDER,
  IM as Card,
  Ei as Checkbox,
  e$ as Chip,
  x2 as ChipGroup,
  Co as Clickable,
  Qh as ClickableContent,
  BM as ContentEmptyState,
  FM as ContentEntityEmptyState,
  LM as ContentErrorEmptyState,
  NM as ContentSearchEmptyState,
  PM as ContentSpinner,
  MM as DateRangePicker,
  Bn as Divider,
  AM as Drawer,
  nb as Dropdown,
  Zi as EmptyState,
  g2 as EntityEmptyState,
  y2 as ErrorEmptyState,
  Be as Flex,
  CM as FormattedNumberInput,
  lM as GlobalStyles,
  _O as H1,
  IO as H2,
  cM as H3,
  xf as H4,
  Cf as H5,
  Sf as H6,
  dM as H6Secondary,
  zi as H6Uppercase,
  pM as H6UppercaseSecondary,
  Hi as HelpIcon,
  Lr as Icon,
  kl as InlineSpinner,
  lP as LoadingShimmer,
  q0 as MimeType,
  WM as Modal,
  ob as ModalContainer,
  ab as ModalContents,
  ib as ModalFooter,
  sb as ModalHeader,
  YM as Multiselect,
  tI as NAVIGATION_SIDEBAR_WIDTH,
  F2 as Navigation,
  aA as NavigationSidebar,
  H2 as PAGINATION_PAGE_SIZE_OPTIONS,
  GM as PaginationFooter,
  sA as PrimaryTemplate,
  lA as PrimaryTemplateCtaWrapper,
  OM as ProgressBar,
  qM as RadioGroup,
  KM as RowGroup,
  QM as ScopedSearchBar,
  zk as SearchBar,
  Kf as SearchEmptyState,
  XM as Snippet,
  wf as Spinner,
  JM as StatCard,
  oA as StatCardPanel,
  zM as StaticModal,
  ZM as Stepper,
  zO as StyledBoxBase,
  Cl as StyledIconBase,
  UM as SummaryGrid,
  eA as Table,
  VM as Tabs,
  pr as Text,
  kf as TextInput,
  nA as Toast,
  El as Tooltip,
  xM as TrimmedBoxContent,
  iA as Uploader,
  EM as ValueText,
  HR as filterAutocompleteOptions,
  DM as filterAutocompleteOptionsObject,
  g0 as fuseTextFilterOptions,
  Yi as getBaseTextInputCss,
  uM as getBreakpointPx,
  Ol as getClickableCss,
  zT as getDateRangePickerDefaultAliases,
  m2 as getErrorEmptyStateProps,
  ep as getListOptionCss,
  Zd as getListOptionsWrapperCss,
  Cv as getMeasurePx,
  v0 as getMediaQueryForAboveBreakpoint,
  Ho as getMediaQueryForBelowBreakpoint,
  Ef as getNoValidationTextInputCss,
  Hr as getRgbaForHex,
  Qk as getSearchEmptyStateProps,
  cn as getSharedAtomFocusCss,
  Pn as getSharedBorderStyle,
  Fr as getStandardLightThemeHex,
  Jd as getTextColorStyles,
  Nn as getTextCss,
  Dm as getTrimmedBoxContentTopStyles,
  sM as highContrastTheme,
  Yo as invisibleClickableStyles,
  HM as isMultiselectOptionsArrayFlat,
  Ad as isMultiselectOptionsArrayNested,
  tA as optionalAlphabeticalSort,
  rA as optionalDateSort,
  I_ as optionalNumericalSort,
  xv as theme,
  Li as useFloatingMenu,
  Uh as useIsWindowSizeBelowBreakpoint,
  pa as withOptionalTracking,
  Jr as withTracking
};
